export const manoaBuildings = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "id": 1,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81664076578875,
                            21.291936203638219
                        ],
                        [
                            -157.81668100027605,
                            21.291980047977773
                        ],
                        [
                            -157.81683763640223,
                            21.291853798858291
                        ],
                        [
                            -157.81679740189881,
                            21.291809954554989
                        ],
                        [
                            -157.81664076578875,
                            21.291936203638219
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 1,
                "NUMBER": "1108Q",
                "PROPER_NAME": "MAKAI CAMPUS 12 - ARMY ROTC 3",
                "DISPLAY_NAME": "MAKAI CAMPUS 12 - ARMY ROTC 3 - 1108Q",
                "ADDRESS": "1311 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ARMY AND AIR FORCE ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1108Q_01.jpg",
                "HEIGHT (ft)": 15.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.669313950946901,
                "SHAPE_Area": 137.20429556224497
            }
        },
        {
            "type": "Feature",
            "id": 2,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81654035612851,
                            21.292017345873049
                        ],
                        [
                            -157.81657952305869,
                            21.292060165512794
                        ],
                        [
                            -157.81662522910543,
                            21.292023404436272
                        ],
                        [
                            -157.81658592739404,
                            21.291980563081346
                        ],
                        [
                            -157.81654035612851,
                            21.292017345873049
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2,
                "NUMBER": "1108C",
                "PROPER_NAME": "ARMY ROTC 1",
                "DISPLAY_NAME": "ARMY ROTC 1 - 1108C",
                "ADDRESS": "1311 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ARMY AND AIR FORCE ROTC",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1108C_01.jpg",
                "HEIGHT (ft)": 15.6,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 24.98548317525897,
                "SHAPE_Area": 39.01710777063159
            }
        },
        {
            "type": "Feature",
            "id": 3,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.816718080431,
                            21.292037308075205
                        ],
                        [
                            -157.81675834427489,
                            21.292081103821001
                        ],
                        [
                            -157.81692375779986,
                            21.29194753290637
                        ],
                        [
                            -157.81688349394636,
                            21.291903736295545
                        ],
                        [
                            -157.816718080431,
                            21.292037308075205
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3,
                "NUMBER": "1108O",
                "PROPER_NAME": "MAKAI CAMPUS 10 - ARMY ROTC 2",
                "DISPLAY_NAME": "MAKAI CAMPUS 10 - ARMY ROTC 2 - 1108O",
                "ADDRESS": "1311 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ARMY AND AIR FORCE ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1108O_01.jpg",
                "HEIGHT (ft)": 16,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 58.103051114146226,
                "SHAPE_Area": 144.9606934737935
            }
        },
        {
            "type": "Feature",
            "id": 4,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81678900044429,
                            21.292122994530057
                        ],
                        [
                            -157.81682935550054,
                            21.292166720436811
                        ],
                        [
                            -157.81692729210289,
                            21.292087330390739
                        ],
                        [
                            -157.8169399420006,
                            21.292101037912374
                        ],
                        [
                            -157.8169982612782,
                            21.292053764986971
                        ],
                        [
                            -157.81694525725618,
                            21.291996333412538
                        ],
                        [
                            -157.81678900044429,
                            21.292122994530057
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 4,
                "NUMBER": "1108P",
                "PROPER_NAME": "MAKAI CAMPUS 11 - AIR FORCE ROTC 3",
                "DISPLAY_NAME": "MAKAI CAMPUS 11 - AIR FORCE ROTC 3 - 1108P",
                "ADDRESS": "1460 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ARMY AND AIR FORCE ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1108P_01.jpg",
                "HEIGHT (ft)": 16.199999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 59.677929337082887,
                "SHAPE_Area": 153.21082235129202
            }
        },
        {
            "type": "Feature",
            "id": 5,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81697885026659,
                            21.292131989606393
                        ],
                        [
                            -157.81711424933476,
                            21.292278836934109
                        ],
                        [
                            -157.81716092274112,
                            21.292241038188024
                        ],
                        [
                            -157.81702552269334,
                            21.292094190889895
                        ],
                        [
                            -157.81697885026659,
                            21.292131989606393
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 5,
                "NUMBER": "1108A",
                "PROPER_NAME": "AIR FORCE ROTC 1",
                "DISPLAY_NAME": "AIR FORCE ROTC 1 - 1108A",
                "ADDRESS": "1460 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ARMY AND AIR FORCE ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1108A_01.jpg",
                "HEIGHT (ft)": 15.6,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.766874629809493,
                "SHAPE_Area": 137.48594677512568
            }
        },
        {
            "type": "Feature",
            "id": 6,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81642036111299,
                            21.292262140509852
                        ],
                        [
                            -157.8164661943633,
                            21.292312339870477
                        ],
                        [
                            -157.81660754393488,
                            21.292198986921516
                        ],
                        [
                            -157.81650469585762,
                            21.292086419571813
                        ],
                        [
                            -157.81652110417329,
                            21.292073261408909
                        ],
                        [
                            -157.81648386428196,
                            21.292032473479615
                        ],
                        [
                            -157.81646228986625,
                            21.292049774403274
                        ],
                        [
                            -157.81643810000497,
                            21.292023279519537
                        ],
                        [
                            -157.81638751196007,
                            21.292063848338049
                        ],
                        [
                            -157.81641170182539,
                            21.29209034232548
                        ],
                        [
                            -157.81632614719854,
                            21.292158951335228
                        ],
                        [
                            -157.81637198037814,
                            21.29220915162249
                        ],
                        [
                            -157.81635859020264,
                            21.292219890029557
                        ],
                        [
                            -157.81640696900806,
                            21.292272878907085
                        ],
                        [
                            -157.81642036111299,
                            21.292262140509852
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 6,
                "NUMBER": "1007",
                "PROPER_NAME": "ARMY ROTC BUILDING",
                "DISPLAY_NAME": "ARMY ROTC BUILDING (ARMY) - 1007",
                "ADDRESS": "1311 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ARMY AND AIR FORCE ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1007_01.jpg",
                "HEIGHT (ft)": 20.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 99.14654589677842,
                "SHAPE_Area": 485.31509933161618
            }
        },
        {
            "type": "Feature",
            "id": 7,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81688049988557,
                            21.292211651404667
                        ],
                        [
                            -157.817015915415,
                            21.292358485374056
                        ],
                        [
                            -157.81706258408801,
                            21.292320682107356
                        ],
                        [
                            -157.81692716854286,
                            21.29217384817434
                        ],
                        [
                            -157.81688049988557,
                            21.292211651404667
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 7,
                "NUMBER": "1108B",
                "PROPER_NAME": "AIR FORCE ROTC 2",
                "DISPLAY_NAME": "AIR FORCE ROTC 2 (AF2) - 1108B",
                "ADDRESS": "1460 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ARMY AND AIR FORCE ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1108B_01.jpg",
                "HEIGHT (ft)": 15.700000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.7667790567899,
                "SHAPE_Area": 137.48551292792541
            }
        },
        {
            "type": "Feature",
            "id": 8,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81713729267346,
                            21.292303836688351
                        ],
                        [
                            -157.81727255866443,
                            21.292450488734037
                        ],
                        [
                            -157.81731681731677,
                            21.292414632434795
                        ],
                        [
                            -157.81718155227483,
                            21.292267980430331
                        ],
                        [
                            -157.81713729267346,
                            21.292303836688351
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 8,
                "NUMBER": "1174D",
                "PROPER_NAME": "LOWER CAMPUS 4 - ROTC",
                "DISPLAY_NAME": "LOWER CAMPUS 4 - ROTC (LC4) - 1174D",
                "ADDRESS": "1420 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "NAVY ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1174D_01.jpg",
                "HEIGHT (ft)": 15.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.055814792630912,
                "SHAPE_Area": 130.24021274274546
            }
        },
        {
            "type": "Feature",
            "id": 9,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81704344790222,
                            21.292379857051941
                        ],
                        [
                            -157.81717870804223,
                            21.292526513646717
                        ],
                        [
                            -157.81722297446524,
                            21.2924906556221
                        ],
                        [
                            -157.81708770946207,
                            21.292344002641254
                        ],
                        [
                            -157.81704344790222,
                            21.292379857051941
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 9,
                "NUMBER": "1174C",
                "PROPER_NAME": "LOWER CAMPUS 3 - NROTC",
                "DISPLAY_NAME": "LOWER CAMPUS 3 - NROTC - 1174C",
                "ADDRESS": "1420 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "NAVY ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1174C_01.jpg",
                "HEIGHT (ft)": 15.6,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.056621614347065,
                "SHAPE_Area": 130.24844451505405
            }
        },
        {
            "type": "Feature",
            "id": 10,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81731545863002,
                            21.292497000402449
                        ],
                        [
                            -157.8174507239936,
                            21.292643654117992
                        ],
                        [
                            -157.81749498266552,
                            21.292607797773378
                        ],
                        [
                            -157.81735971824372,
                            21.292461145002378
                        ],
                        [
                            -157.81731545863002,
                            21.292497000402449
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 10,
                "NUMBER": "1174B",
                "PROPER_NAME": "LOWER CAMPUS 2 - NROTC",
                "DISPLAY_NAME": "LOWER CAMPUS 2 - NROTC - 1174B",
                "ADDRESS": "1420 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "NAVY ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1174B_01.jpg",
                "HEIGHT (ft)": 15.700000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.055842393660626,
                "SHAPE_Area": 130.23978896654216
            }
        },
        {
            "type": "Feature",
            "id": 11,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8172216157233,
                            21.292573023585781
                        ],
                        [
                            -157.81735688202647,
                            21.292719676477795
                        ],
                        [
                            -157.81740114074358,
                            21.292683820160295
                        ],
                        [
                            -157.81726587538222,
                            21.292537168212839
                        ],
                        [
                            -157.8172216157233,
                            21.292573023585781
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 11,
                "NUMBER": "1174A",
                "PROPER_NAME": "LOWER CAMPUS 1 - PAYROLL",
                "DISPLAY_NAME": "LOWER CAMPUS 1 - PAYROLL - 1174A",
                "ADDRESS": "1420 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "NAVY ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1174A_01.jpg",
                "HEIGHT (ft)": 15.700000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.055823991787278,
                "SHAPE_Area": 130.23973311356019
            }
        },
        {
            "type": "Feature",
            "id": 12,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81694583559272,
                            21.292747214313227
                        ],
                        [
                            -157.81708130066514,
                            21.292893705302628
                        ],
                        [
                            -157.81712560390065,
                            21.292857721094364
                        ],
                        [
                            -157.81699013784961,
                            21.292711230132713
                        ],
                        [
                            -157.81694583559272,
                            21.292747214313227
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 12,
                "NUMBER": "1108T",
                "PROPER_NAME": "MAKAI CAMPUS 15 - INTERNAL AUDIT",
                "DISPLAY_NAME": "MAKAI CAMPUS 15 - INTERNAL AUDIT - 1108T",
                "ADDRESS": "1395 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ARMY AND AIR FORCE ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1108T_01.jpg",
                "HEIGHT (ft)": 16.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.081325280838556,
                "SHAPE_Area": 130.51274297337582
            }
        },
        {
            "type": "Feature",
            "id": 13,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81675382531287,
                            21.29290316675813
                        ],
                        [
                            -157.81679374258226,
                            21.292946334014864
                        ],
                        [
                            -157.81695005278362,
                            21.292819377905435
                        ],
                        [
                            -157.81691013549894,
                            21.292776210684593
                        ],
                        [
                            -157.81675382531287,
                            21.29290316675813
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 13,
                "NUMBER": "1108R",
                "PROPER_NAME": "MAKAI CAMPUS 13",
                "DISPLAY_NAME": "MAKAI CAMPUS 13 - 1108R",
                "ADDRESS": "1395 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ARMY AND AIR FORCE ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1108R_01.jpg",
                "HEIGHT (ft)": 16.399999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.563736826561964,
                "SHAPE_Area": 135.68804172719359
            }
        },
        {
            "type": "Feature",
            "id": 14,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81669645282562,
                            21.292985409263494
                        ],
                        [
                            -157.81683318756268,
                            21.293133560771295
                        ],
                        [
                            -157.81687756572032,
                            21.293097505793302
                        ],
                        [
                            -157.81674066303071,
                            21.292949501296015
                        ],
                        [
                            -157.81669645282562,
                            21.292985409263494
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 14,
                "NUMBER": "1108S",
                "PROPER_NAME": "MAKAI CAMPUS 14",
                "DISPLAY_NAME": "MAKAI CAMPUS 14 - 1108S",
                "ADDRESS": "1395 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ARMY AND AIR FORCE ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1108S_01.jpg",
                "HEIGHT (ft)": 16.199999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.528960293820148,
                "SHAPE_Area": 131.86034941428301
            }
        },
        {
            "type": "Feature",
            "id": 15,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81821324386519,
                            21.29313270193402
                        ],
                        [
                            -157.81834470969142,
                            21.29321171941255
                        ],
                        [
                            -157.81834523832697,
                            21.293210946207118
                        ],
                        [
                            -157.81833380500851,
                            21.293204074251268
                        ],
                        [
                            -157.81836033402112,
                            21.293165308062033
                        ],
                        [
                            -157.81836191894868,
                            21.293162990245488
                        ],
                        [
                            -157.8183744402395,
                            21.293144694131655
                        ],
                        [
                            -157.81837602612325,
                            21.29314237722506
                        ],
                        [
                            -157.81845716288521,
                            21.293023809337701
                        ],
                        [
                            -157.81846859716021,
                            21.293030681291722
                        ],
                        [
                            -157.81846925842771,
                            21.293029715691087
                        ],
                        [
                            -157.81845782415277,
                            21.293022843737116
                        ],
                        [
                            -157.8183502524623,
                            21.292958188165603
                        ],
                        [
                            -157.81833854959606,
                            21.292951153514821
                        ],
                        [
                            -157.81831760644081,
                            21.29293856770213
                        ],
                        [
                            -157.81833033351475,
                            21.292919970399119
                        ],
                        [
                            -157.81832930319067,
                            21.292919351570497
                        ],
                        [
                            -157.81831657708776,
                            21.292937947976853
                        ],
                        [
                            -157.81830137457283,
                            21.292928811859717
                        ],
                        [
                            -157.81821951402404,
                            21.292879607625562
                        ],
                        [
                            -157.81821827744761,
                            21.29287886448709
                        ],
                        [
                            -157.81820906021235,
                            21.292873324322795
                        ],
                        [
                            -157.81820839894397,
                            21.292874289922377
                        ],
                        [
                            -157.81821761715034,
                            21.292879829190134
                        ],
                        [
                            -157.81809438480119,
                            21.293059806623809
                        ],
                        [
                            -157.81808522798872,
                            21.293054303915866
                        ],
                        [
                            -157.81808456865363,
                            21.293055268625068
                        ],
                        [
                            -157.81818667593129,
                            21.29311664101845
                        ],
                        [
                            -157.81818663107265,
                            21.293116705747675
                        ],
                        [
                            -157.81819223740501,
                            21.293120075008325
                        ],
                        [
                            -157.81817946640814,
                            21.293138736131485
                        ],
                        [
                            -157.81818049673305,
                            21.293139354961053
                        ],
                        [
                            -157.81819326676595,
                            21.293120693831046
                        ],
                        [
                            -157.81821324386519,
                            21.29313270193402
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 15,
                "NUMBER": "1171F",
                "PROPER_NAME": "VARSITY BUILDING F - CENTER FOR DISABILITY SERVICES",
                "DISPLAY_NAME": "VARSITY BUILDING F - CENTER FOR DISABILITY SERVICES - 1171F",
                "ADDRESS": "1410 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "VARSITY BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "Speech Pathology/ Audiology",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1171F_01.jpg",
                "HEIGHT (ft)": 15.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 126.88695536569713,
                "SHAPE_Area": 707.83275582980343
            }
        },
        {
            "type": "Feature",
            "id": 16,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81839953962788,
                            21.293280101654123
                        ],
                        [
                            -157.81852191204965,
                            21.293351496495436
                        ],
                        [
                            -157.81855304012174,
                            21.293304633841803
                        ],
                        [
                            -157.81843066771407,
                            21.293233239927179
                        ],
                        [
                            -157.81839953962788,
                            21.293280101654123
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 16,
                "NUMBER": "1171G",
                "PROPER_NAME": "VARSITY BUILDING G - FINANCIAL MANAGEMENT OFFICE",
                "DISPLAY_NAME": "VARSITY BUILDING G - FINANCIAL MANAGEMENT OFFICE - 1171G",
                "ADDRESS": "LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "VARSITY BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1171G_01.jpg",
                "HEIGHT (ft)": 15.200000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 42.1297840556132,
                "SHAPE_Area": 91.379315653757885
            }
        },
        {
            "type": "Feature",
            "id": 17,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81844163588713,
                            21.293168170668878
                        ],
                        [
                            -157.81844266816285,
                            21.293168786800393
                        ],
                        [
                            -157.81844821137051,
                            21.293160636468759
                        ],
                        [
                            -157.8188041851914,
                            21.293373306037925
                        ],
                        [
                            -157.81879866051008,
                            21.293381431216609
                        ],
                        [
                            -157.81879989905036,
                            21.293382170751279
                        ],
                        [
                            -157.81889309945981,
                            21.293245127127612
                        ],
                        [
                            -157.81889186092735,
                            21.293244386690308
                        ],
                        [
                            -157.8188863362559,
                            21.293252511872446
                        ],
                        [
                            -157.81853004762601,
                            21.293039691211884
                        ],
                        [
                            -157.81853557327176,
                            21.293031566048551
                        ],
                        [
                            -157.81853448919216,
                            21.293030918838703
                        ],
                        [
                            -157.81849486060145,
                            21.293089189475573
                        ],
                        [
                            -157.8184826437344,
                            21.293107872580663
                        ],
                        [
                            -157.81844163588713,
                            21.293168170668878
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 17,
                "NUMBER": "1171E",
                "PROPER_NAME": "VARSITY BUILDING E - PROCUREMENT",
                "DISPLAY_NAME": "VARSITY BUILDING E - PROCUREMENT - 1171E",
                "ADDRESS": "1400 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "VARSITY BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1171E_01.jpg",
                "HEIGHT (ft)": 18.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 128.44203831133419,
                "SHAPE_Area": 699.74367293996238
            }
        },
        {
            "type": "Feature",
            "id": 18,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81875675818341,
                            21.293512547170295
                        ],
                        [
                            -157.81908297197847,
                            21.293707782383969
                        ],
                        [
                            -157.81911545885504,
                            21.293660107974301
                        ],
                        [
                            -157.81878924512284,
                            21.293464871922076
                        ],
                        [
                            -157.81875675818341,
                            21.293512547170295
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 18,
                "NUMBER": "1171H",
                "PROPER_NAME": "VARSITY BUILDING H - FINANCIAL MANAGEMENT OFFICE",
                "DISPLAY_NAME": "VARSITY BUILDING H - FINANCIAL MANAGEMENT OFFICE - 1171H",
                "ADDRESS": "LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "VARSITY BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1171H_01.jpg",
                "HEIGHT (ft)": 15.9,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 92.833013138578366,
                "SHAPE_Area": 251.44198582006072
            }
        },
        {
            "type": "Feature",
            "id": 19,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81736348813638,
                            21.293681526160682
                        ],
                        [
                            -157.81740961413522,
                            21.293728962966959
                        ],
                        [
                            -157.81749638342043,
                            21.293654857606757
                        ],
                        [
                            -157.817450258371,
                            21.29360742173375
                        ],
                        [
                            -157.81736348813638,
                            21.293681526160682
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 19,
                "NUMBER": "1116A",
                "PROPER_NAME": "CHING FIELD - RESTROOM FACILITIES",
                "DISPLAY_NAME": "CHING FIELD - RESTROOM FACILITIES - 1116A",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CLARENCE TC CHING ATHLETICS COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1116A_01.jpg",
                "HEIGHT (ft)": 19.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 38.566475703777307,
                "SHAPE_Area": 86.523180259309299
            }
        },
        {
            "type": "Feature",
            "id": 21,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81913415198198,
                            21.293732476991909
                        ],
                        [
                            -157.81918499956501,
                            21.293762707944971
                        ],
                        [
                            -157.81929580223257,
                            21.293599017383258
                        ],
                        [
                            -157.81924495371578,
                            21.293568786457886
                        ],
                        [
                            -157.81913415198198,
                            21.293732476991909
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 21,
                "NUMBER": "1171B",
                "PROPER_NAME": "VARSITY BUILDING B - FINANCIAL MANAGEMENT OFFICE",
                "DISPLAY_NAME": "VARSITY BUILDING B - FINANCIAL MANAGEMENT OFFICE - 1171B",
                "ADDRESS": "1406 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "VARSITY BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1171B_01.jpg",
                "HEIGHT (ft)": 15.200000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.411394903954971,
                "SHAPE_Area": 134.05383271196652
            }
        },
        {
            "type": "Feature",
            "id": 25,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8153466168983,
                            21.294546057142746
                        ],
                        [
                            -157.81539504865569,
                            21.294596570492903
                        ],
                        [
                            -157.81546497393819,
                            21.294537686366809
                        ],
                        [
                            -157.81541654121742,
                            21.294487172126082
                        ],
                        [
                            -157.8153466168983,
                            21.294546057142746
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 25,
                "NUMBER": "1116B",
                "PROPER_NAME": "RAINBOW WĀHINE SOFTBALL STADUIM - RESTROOM FACILITIES",
                "DISPLAY_NAME": "RAINBOW WĀHINE SOFTBALL STADUIM - RESTROOM FACILITIES - 1116B",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "SOFTBALL AND TENNIS COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1116B_01.jpg",
                "HEIGHT (ft)": 19.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 34.540170830366087,
                "SHAPE_Area": 73.315112277317851
            }
        },
        {
            "type": "Feature",
            "id": 27,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81523524332039,
                            21.294777111193959
                        ],
                        [
                            -157.81530316908902,
                            21.294718882480254
                        ],
                        [
                            -157.81515033390278,
                            21.29456228987593
                        ],
                        [
                            -157.8150824081597,
                            21.294620517626214
                        ],
                        [
                            -157.81523524332039,
                            21.294777111193959
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 27,
                "NUMBER": "1116C",
                "PROPER_NAME": "PRACTICE FIELD - EQUIPMENT STORAGE",
                "DISPLAY_NAME": "PRACTICE FIELD - EQUIPMENT STORAGE - 1116C",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PRACTICE FIELD - EQUIPMENT STORAGE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1116C_01.jpg",
                "HEIGHT (ft)": 16.699999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 66.084515715633415,
                "SHAPE_Area": 224.35263604168784
            }
        },
        {
            "type": "Feature",
            "id": 28,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82028129375939,
                            21.294891667316392
                        ],
                        [
                            -157.82032536223227,
                            21.295078246462417
                        ],
                        [
                            -157.82039610625017,
                            21.29506357161371
                        ],
                        [
                            -157.82035203866872,
                            21.294876990682031
                        ],
                        [
                            -157.82028129375939,
                            21.294891667316392
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 28,
                "NUMBER": "1092I",
                "PROPER_NAME": "LUNALILO BUILDING 2",
                "DISPLAY_NAME": "LUNALILO BUILDING 2 - 1092I",
                "ADDRESS": "2411 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MUSIC COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1092I_01.jpg",
                "HEIGHT (ft)": 16,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 57.341290922999448,
                "SHAPE_Area": 159.0099812097634
            }
        },
        {
            "type": "Feature",
            "id": 29,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82016617953647,
                            21.29497078620787
                        ],
                        [
                            -157.82021042134079,
                            21.295160149941417
                        ],
                        [
                            -157.8202690061394,
                            21.295148127195827
                        ],
                        [
                            -157.82022476425479,
                            21.294958764377444
                        ],
                        [
                            -157.82016617953647,
                            21.29497078620787
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 29,
                "NUMBER": "1092F",
                "PROPER_NAME": "LUNALILO BUILDING 1",
                "DISPLAY_NAME": "LUNALILO BUILDING 1 - 1092F",
                "ADDRESS": "2411 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MUSIC COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1092F_01.jpg",
                "HEIGHT (ft)": 16.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.36056255621282,
                "SHAPE_Area": 133.50920157739125
            }
        },
        {
            "type": "Feature",
            "id": 30,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81545948691075,
                            21.29524955001148
                        ],
                        [
                            -157.81554757658037,
                            21.295257276899221
                        ],
                        [
                            -157.8155648789016,
                            21.295082301745001
                        ],
                        [
                            -157.81547639138591,
                            21.295074915358736
                        ],
                        [
                            -157.81545948691075,
                            21.29524955001148
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 30,
                "NUMBER": "1116D",
                "PROPER_NAME": "RAINBOW WĀHINE SOFTBALL STADIUM - BATTING CAGE",
                "DISPLAY_NAME": "RAINBOW WĀHINE SOFTBALL STADIUM - BATTING CAGE - 1116D",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "SOFTBALL AND TENNIS COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1116D_01.jpg",
                "HEIGHT (ft)": 23.400000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 57.258059913580091,
                "SHAPE_Area": 178.720120265567
            }
        },
        {
            "type": "Feature",
            "id": 31,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81230196142405,
                            21.295484989045551
                        ],
                        [
                            -157.81230477811545,
                            21.295486546490149
                        ],
                        [
                            -157.81230565912102,
                            21.29548703240668
                        ],
                        [
                            -157.81230870141437,
                            21.295488705270238
                        ],
                        [
                            -157.81231046443304,
                            21.295489671690053
                        ],
                        [
                            -157.81231258646224,
                            21.29549082583798
                        ],
                        [
                            -157.81231460861605,
                            21.295491933208265
                        ],
                        [
                            -157.81232066001826,
                            21.295495210043246
                        ],
                        [
                            -157.8123244570119,
                            21.295497252297888
                        ],
                        [
                            -157.8123273201814,
                            21.295498783871793
                        ],
                        [
                            -157.8123400951489,
                            21.295505541932695
                        ],
                        [
                            -157.81234030345868,
                            21.295505650002511
                        ],
                        [
                            -157.81234229058006,
                            21.295506678530412
                        ],
                        [
                            -157.81235283486836,
                            21.295512128099919
                        ],
                        [
                            -157.81236034757336,
                            21.29551601148173
                        ],
                        [
                            -157.81237226213804,
                            21.295521999201696
                        ],
                        [
                            -157.81240015924192,
                            21.295535643897594
                        ],
                        [
                            -157.81242504958652,
                            21.295454758379627
                        ],
                        [
                            -157.81234011574702,
                            21.295367515910538
                        ],
                        [
                            -157.81231986757533,
                            21.295384835553403
                        ],
                        [
                            -157.81231788180057,
                            21.295382799755547
                        ],
                        [
                            -157.8123168922796,
                            21.295381782783753
                        ],
                        [
                            -157.81231435313617,
                            21.295383953779449
                        ],
                        [
                            -157.81226239497346,
                            21.295330579857698
                        ],
                        [
                            -157.81222564920736,
                            21.295361998807476
                        ],
                        [
                            -157.81220717246282,
                            21.295377796981686
                        ],
                        [
                            -157.81211939548979,
                            21.295287631753148
                        ],
                        [
                            -157.81215328181446,
                            21.295258657093136
                        ],
                        [
                            -157.81199918309565,
                            21.295100365296975
                        ],
                        [
                            -157.81197824348544,
                            21.295078856858492
                        ],
                        [
                            -157.81205924869417,
                            21.295009573100899
                        ],
                        [
                            -157.81207877852768,
                            21.294992874466974
                        ],
                        [
                            -157.81211204943304,
                            21.294964423951374
                        ],
                        [
                            -157.81213880941795,
                            21.294941540238359
                        ],
                        [
                            -157.81213930369444,
                            21.294942048721307
                        ],
                        [
                            -157.81214907003778,
                            21.294933700764737
                        ],
                        [
                            -157.8121672170081,
                            21.294952340184178
                        ],
                        [
                            -157.8122516906989,
                            21.295039104301221
                        ],
                        [
                            -157.81222854911405,
                            21.29505890229272
                        ],
                        [
                            -157.81222674181183,
                            21.295060448789297
                        ],
                        [
                            -157.81230956346815,
                            21.295145522724297
                        ],
                        [
                            -157.81229365112833,
                            21.295159129314303
                        ],
                        [
                            -157.81229497049236,
                            21.295160484674586
                        ],
                        [
                            -157.8123076907394,
                            21.29517321014184
                        ],
                        [
                            -157.81230901010369,
                            21.29517456550202
                        ],
                        [
                            -157.8123251049048,
                            21.29516080481508
                        ],
                        [
                            -157.81233995254195,
                            21.295176056714084
                        ],
                        [
                            -157.81236020645036,
                            21.295158738914413
                        ],
                        [
                            -157.81234403752052,
                            21.295142131643644
                        ],
                        [
                            -157.81241130721463,
                            21.295084613200252
                        ],
                        [
                            -157.81242747614644,
                            21.295101220464726
                        ],
                        [
                            -157.81244772810669,
                            21.295083902639814
                        ],
                        [
                            -157.81243288046664,
                            21.295068650750068
                        ],
                        [
                            -157.81244897331703,
                            21.295054890036429
                        ],
                        [
                            -157.81244765395238,
                            21.295053534677319
                        ],
                        [
                            -157.81243511520651,
                            21.295040654214617
                        ],
                        [
                            -157.81243379584217,
                            21.295039298855407
                        ],
                        [
                            -157.81241625483722,
                            21.295054296930932
                        ],
                        [
                            -157.81235223983086,
                            21.294988541934394
                        ],
                        [
                            -157.812340361737,
                            21.294976340055211
                        ],
                        [
                            -157.81235772124279,
                            21.294961496089758
                        ],
                        [
                            -157.81235640091595,
                            21.294960140723191
                        ],
                        [
                            -157.81235612748421,
                            21.294959859646511
                        ],
                        [
                            -157.81235193037378,
                            21.294955548868849
                        ],
                        [
                            -157.81232835392493,
                            21.294931330669481
                        ],
                        [
                            -157.81231876330469,
                            21.294939524493817
                        ],
                        [
                            -157.8122384218027,
                            21.294856993944329
                        ],
                        [
                            -157.81221085093674,
                            21.294792684927994
                        ],
                        [
                            -157.81219986839812,
                            21.294802075851674
                        ],
                        [
                            -157.81213060996322,
                            21.294861294812371
                        ],
                        [
                            -157.81206568533949,
                            21.294916801586112
                        ],
                        [
                            -157.81202254706309,
                            21.29487248670064
                        ],
                        [
                            -157.81198981681302,
                            21.294900473059243
                        ],
                        [
                            -157.8119894047571,
                            21.294900049171432
                        ],
                        [
                            -157.81196878977107,
                            21.294917676047412
                        ],
                        [
                            -157.81196920183427,
                            21.294918099031957
                        ],
                        [
                            -157.81193647156408,
                            21.294946085379088
                        ],
                        [
                            -157.81195074069359,
                            21.294960746927266
                        ],
                        [
                            -157.81190517104156,
                            21.294999711872443
                        ],
                        [
                            -157.81188627306986,
                            21.295015869298357
                        ],
                        [
                            -157.81182189571584,
                            21.295070908264496
                        ],
                        [
                            -157.81185188714497,
                            21.295106046816947
                        ],
                        [
                            -157.81191199901116,
                            21.29517119175916
                        ],
                        [
                            -157.81198987367284,
                            21.295245213189233
                        ],
                        [
                            -157.8119920108166,
                            21.295247244638805
                        ],
                        [
                            -157.81199366414276,
                            21.295248665595786
                        ],
                        [
                            -157.81207913801302,
                            21.295322051337664
                        ],
                        [
                            -157.81216716547675,
                            21.295393997892933
                        ],
                        [
                            -157.81217973457387,
                            21.295403101518318
                        ],
                        [
                            -157.81220259951223,
                            21.295420981054722
                        ],
                        [
                            -157.81224662297097,
                            21.295453050378558
                        ],
                        [
                            -157.81224982623115,
                            21.295454964680623
                        ],
                        [
                            -157.81225368291632,
                            21.295457255790101
                        ],
                        [
                            -157.81225754837106,
                            21.295459535217343
                        ],
                        [
                            -157.81226199115363,
                            21.295462184591209
                        ],
                        [
                            -157.81226204487794,
                            21.295462216588955
                        ],
                        [
                            -157.81226440029045,
                            21.29546359732835
                        ],
                        [
                            -157.81226904215038,
                            21.295466304117006
                        ],
                        [
                            -157.81226996996583,
                            21.295466842760636
                        ],
                        [
                            -157.81227450837079,
                            21.295469468417455
                        ],
                        [
                            -157.81227671625035,
                            21.295470735191916
                        ],
                        [
                            -157.8122768572685,
                            21.295470820202233
                        ],
                        [
                            -157.81227746753581,
                            21.295471169603395
                        ],
                        [
                            -157.81228087412146,
                            21.295473092566802
                        ],
                        [
                            -157.81228939227421,
                            21.295477929798775
                        ],
                        [
                            -157.81229264033939,
                            21.295479786599302
                        ],
                        [
                            -157.8122927650729,
                            21.295479858847244
                        ],
                        [
                            -157.81229303760821,
                            21.295480011636435
                        ],
                        [
                            -157.81229363545376,
                            21.295480347399039
                        ],
                        [
                            -157.8122985219637,
                            21.295483078498023
                        ],
                        [
                            -157.81230196142405,
                            21.295484989045551
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 31,
                "NUMBER": "1131",
                "PROPER_NAME": "KAMAKAKŪOKALANI CENTER FOR HAWAIIAN STUDIES",
                "DISPLAY_NAME": "KAMAKAKŪOKALANI CENTER FOR HAWAIIAN STUDIES (KAMA) - 1131",
                "ADDRESS": "2645 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CENTER FOR HAWAIIAN STUDIES AND CULTURAL RESOURCES",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1131_01.jpg",
                "HEIGHT (ft)": 47.899999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 360.7985504831787,
                "SHAPE_Area": 1615.581732360032
            }
        },
        {
            "type": "Feature",
            "id": 32,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81854899320263,
                            21.29540480270806
                        ],
                        [
                            -157.81868797898915,
                            21.295548728112593
                        ],
                        [
                            -157.8187314161836,
                            21.295511887339003
                        ],
                        [
                            -157.81859252065647,
                            21.295367884007966
                        ],
                        [
                            -157.81854899320263,
                            21.29540480270806
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 32,
                "NUMBER": "1108G",
                "PROPER_NAME": "KLUM ANNEX 2 - ATHLETIC LETTERWINNERS CLUB",
                "DISPLAY_NAME": "KLUM ANNEX 2 - ATHLETIC LETTERWINNERS CLUB - 1108G",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PHYSICAL EDUCATION/ATHLETIC COMPLEX (HPER)",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1108G_01.jpg",
                "HEIGHT (ft)": 14.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.14403117875456,
                "SHAPE_Area": 130.73342316372438
            }
        },
        {
            "type": "Feature",
            "id": 33,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81871327673022,
                            21.295593883693691
                        ],
                        [
                            -157.81876130738212,
                            21.295643393258676
                        ],
                        [
                            -157.81885366818042,
                            21.295564698401307
                        ],
                        [
                            -157.81880563849148,
                            21.29551518796541
                        ],
                        [
                            -157.81871327673022,
                            21.295593883693691
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 33,
                "NUMBER": "1152E",
                "PROPER_NAME": "VARSITY ANNEX 1 - NA KOA FOOTBALL BOOSTERS ORGANIZATION",
                "DISPLAY_NAME": "VARSITY ANNEX 1 - NA KOA FOOTBALL BOOSTERS ORGANIZATION - 1152E",
                "ADDRESS": "1333 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PHYSICAL EDUCATION/ATHLETIC COMPLEX (HPER)",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1152E_01.jpg",
                "HEIGHT (ft)": 16.899999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 40.713785902211185,
                "SHAPE_Area": 95.920340589927946
            }
        },
        {
            "type": "Feature",
            "id": 34,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81148541132129,
                            21.295469449565676
                        ],
                        [
                            -157.8115195452618,
                            21.29550549642498
                        ],
                        [
                            -157.81152722437545,
                            21.295499109482133
                        ],
                        [
                            -157.81165859301765,
                            21.295637841838904
                        ],
                        [
                            -157.81165091293792,
                            21.295644228780748
                        ],
                        [
                            -157.81168498770515,
                            21.29568021195394
                        ],
                        [
                            -157.81176068221174,
                            21.295617257956955
                        ],
                        [
                            -157.81156110675931,
                            21.295406495662675
                        ],
                        [
                            -157.81148541132129,
                            21.295469449565676
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 34,
                "NUMBER": "1154B",
                "PROPER_NAME": "WA`AHILA FACULTY HOUSING BUILDING B",
                "DISPLAY_NAME": "WA`AHILA FACULTY HOUSING BUILDING B - 1154B",
                "ADDRESS": "2640 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WAAHILA FACULTY HOUSING BUILDING B",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1154B_01.jpg",
                "HEIGHT (ft)": 28,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 85.514592058960986,
                "SHAPE_Area": 305.62824498254304
            }
        },
        {
            "type": "Feature",
            "id": 35,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81157460511309,
                            21.295992458781686
                        ],
                        [
                            -157.81164994444586,
                            21.295931024548032
                        ],
                        [
                            -157.81163103629441,
                            21.295910657838444
                        ],
                        [
                            -157.81164211536677,
                            21.295901624478109
                        ],
                        [
                            -157.81160752162717,
                            21.295864362949022
                        ],
                        [
                            -157.81160807471099,
                            21.295863911545972
                        ],
                        [
                            -157.81160711139171,
                            21.295862873073784
                        ],
                        [
                            -157.81160655733672,
                            21.295863325373361
                        ],
                        [
                            -157.81156703325374,
                            21.295820754135189
                        ],
                        [
                            -157.81156758634478,
                            21.295820301828929
                        ],
                        [
                            -157.81156662302607,
                            21.295819263356531
                        ],
                        [
                            -157.81156606897838,
                            21.295819714752646
                        ],
                        [
                            -157.81152654395464,
                            21.295777143499027
                        ],
                        [
                            -157.8115270980023,
                            21.295776692103036
                        ],
                        [
                            -157.81152613468413,
                            21.295775653630429
                        ],
                        [
                            -157.8115255806365,
                            21.295776105026416
                        ],
                        [
                            -157.81148605563595,
                            21.295733533764178
                        ],
                        [
                            -157.81148661065467,
                            21.295733081471791
                        ],
                        [
                            -157.81148564636592,
                            21.295732043895502
                        ],
                        [
                            -157.81148509231835,
                            21.29573249529134
                        ],
                        [
                            -157.81144556734094,
                            21.295689924020465
                        ],
                        [
                            -157.81144612235238,
                            21.295689472631544
                        ],
                        [
                            -157.81144515807145,
                            21.295688434151707
                        ],
                        [
                            -157.81144460402393,
                            21.295688885547438
                        ],
                        [
                            -157.81141001037597,
                            21.295651624884812
                        ],
                        [
                            -157.81139893033864,
                            21.295660659126863
                        ],
                        [
                            -157.81138002225592,
                            21.295640292391646
                        ],
                        [
                            -157.81130468200811,
                            21.295701726501392
                        ],
                        [
                            -157.81157460511309,
                            21.295992458781686
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 35,
                "NUMBER": "1154C",
                "PROPER_NAME": "WA`AHILA FACULTY HOUSING BUILDING C",
                "DISPLAY_NAME": "WA`AHILA FACULTY HOUSING BUILDING C - 1154C",
                "ADDRESS": "2640 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WAAHILA FACULTY HOUSING BUILDING C",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1154C_01.jpg",
                "HEIGHT (ft)": 28,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 109.85002171069164,
                "SHAPE_Area": 497.92149670687945
            }
        },
        {
            "type": "Feature",
            "id": 36,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81235342228101,
                            21.296047329961759
                        ],
                        [
                            -157.81239333407183,
                            21.29596152760676
                        ],
                        [
                            -157.81236692543521,
                            21.295950738183407
                        ],
                        [
                            -157.81237279512402,
                            21.29593812040471
                        ],
                        [
                            -157.81232447826036,
                            21.295918380986972
                        ],
                        [
                            -157.81232477251859,
                            21.295917749787396
                        ],
                        [
                            -157.81232342546818,
                            21.295917200055193
                        ],
                        [
                            -157.81232313217382,
                            21.295917831261573
                        ],
                        [
                            -157.81226793021335,
                            21.295895278872266
                        ],
                        [
                            -157.81226822350786,
                            21.295894647665992
                        ],
                        [
                            -157.81226687742904,
                            21.295894097036822
                        ],
                        [
                            -157.81226658317064,
                            21.29589472823627
                        ],
                        [
                            -157.8122113802643,
                            21.295872175822378
                        ],
                        [
                            -157.8122116745229,
                            21.295871544623012
                        ],
                        [
                            -157.81221032747337,
                            21.295870994889942
                        ],
                        [
                            -157.81221003514256,
                            21.295871626102912
                        ],
                        [
                            -157.81215483225429,
                            21.295849073671192
                        ],
                        [
                            -157.81215512651306,
                            21.295848442471929
                        ],
                        [
                            -157.81215377947123,
                            21.295847891835088
                        ],
                        [
                            -157.81215348617636,
                            21.295848523041148
                        ],
                        [
                            -157.81209828427004,
                            21.295825970598429
                        ],
                        [
                            -157.81209857660122,
                            21.295825339385669
                        ],
                        [
                            -157.81209723148032,
                            21.295824789665332
                        ],
                        [
                            -157.81209693722138,
                            21.295825420864485
                        ],
                        [
                            -157.81204862140601,
                            21.295805680474171
                        ],
                        [
                            -157.81204275168875,
                            21.295818299144045
                        ],
                        [
                            -157.81201634310568,
                            21.295807509667899
                        ],
                        [
                            -157.81197643114709,
                            21.295893311926736
                        ],
                        [
                            -157.81235342228101,
                            21.296047329961759
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 36,
                "NUMBER": "1154A",
                "PROPER_NAME": "WA`AHILA FACULTY HOUSING BUILDING A",
                "DISPLAY_NAME": "WA`AHILA FACULTY HOUSING BUILDING A - 1154A",
                "ADDRESS": "2640 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WAAHILA FACULTY HOUSING BUILDING A",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1154A_01.jpg",
                "HEIGHT (ft)": 28,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 109.86161555082906,
                "SHAPE_Area": 498.02116501825179
            }
        },
        {
            "type": "Feature",
            "id": 37,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8120477810381,
                            21.296235681546239
                        ],
                        [
                            -157.81208439725859,
                            21.296148563264744
                        ],
                        [
                            -157.81205758334278,
                            21.296138664384269
                        ],
                        [
                            -157.81206296781906,
                            21.29612585348157
                        ],
                        [
                            -157.81204893278218,
                            21.296120671953087
                        ],
                        [
                            -157.81204156300993,
                            21.296117952227661
                        ],
                        [
                            -157.81202722042582,
                            21.296112656506434
                        ],
                        [
                            -157.81202593926716,
                            21.296112184024995
                        ],
                        [
                            -157.8120139110186,
                            21.296107743886445
                        ],
                        [
                            -157.81201418028965,
                            21.29610710347723
                        ],
                        [
                            -157.81201281263387,
                            21.296106598766542
                        ],
                        [
                            -157.81201254336281,
                            21.296107239175761
                        ],
                        [
                            -157.81199067050346,
                            21.296099164774738
                        ],
                        [
                            -157.81198547091765,
                            21.296097245410358
                        ],
                        [
                            -157.81196548471434,
                            21.296089867285364
                        ],
                        [
                            -157.81195649452403,
                            21.29608654891539
                        ],
                        [
                            -157.81195676379531,
                            21.296085908506274
                        ],
                        [
                            -157.81195539710382,
                            21.296085403801964
                        ],
                        [
                            -157.81195512783253,
                            21.296086044211059
                        ],
                        [
                            -157.81192095090287,
                            21.296073427434635
                        ],
                        [
                            -157.81189907804679,
                            21.296065353925478
                        ],
                        [
                            -157.81189934828217,
                            21.296064713523268
                        ],
                        [
                            -157.81189866398,
                            21.296064460260741
                        ],
                        [
                            -157.81189798062721,
                            21.296064208811686
                        ],
                        [
                            -157.81189771135575,
                            21.296064849220699
                        ],
                        [
                            -157.81189401014063,
                            21.296063482464117
                        ],
                        [
                            -157.81189309901089,
                            21.296063146295353
                        ],
                        [
                            -157.81187583947352,
                            21.296056774812083
                        ],
                        [
                            -157.81184166159417,
                            21.296044158013338
                        ],
                        [
                            -157.8118419318225,
                            21.296043518514562
                        ],
                        [
                            -157.81184056513186,
                            21.296043013809335
                        ],
                        [
                            -157.81184029489629,
                            21.296043654211445
                        ],
                        [
                            -157.81181234210405,
                            21.296033335307953
                        ],
                        [
                            -157.8118113502392,
                            21.296032969660352
                        ],
                        [
                            -157.81180611894391,
                            21.296031038322692
                        ],
                        [
                            -157.81178424707221,
                            21.296022963902608
                        ],
                        [
                            -157.8117845153802,
                            21.296022323486984
                        ],
                        [
                            -157.81178314868998,
                            21.296021818781309
                        ],
                        [
                            -157.81178287845418,
                            21.29602245918332
                        ],
                        [
                            -157.81173382172602,
                            21.296004349509531
                        ],
                        [
                            -157.81173211762157,
                            21.296008405440507
                        ],
                        [
                            -157.81172843818339,
                            21.296017161310875
                        ],
                        [
                            -157.81170162334666,
                            21.296007263272291
                        ],
                        [
                            -157.81166500694442,
                            21.296094381463025
                        ],
                        [
                            -157.8120477810381,
                            21.296235681546239
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 37,
                "NUMBER": "1154D",
                "PROPER_NAME": "WA`AHILA FACULTY HOUSING BUILDING D",
                "DISPLAY_NAME": "WA`AHILA FACULTY HOUSING BUILDING D - 1154D",
                "ADDRESS": "2640 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WAAHILA FACULTY HOUSING BUILDING D",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1154D_01.jpg",
                "HEIGHT (ft)": 28.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 109.8988622121272,
                "SHAPE_Area": 498.36724465590117
            }
        },
        {
            "type": "Feature",
            "id": 38,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81210934003246,
                            21.296618985066228
                        ],
                        [
                            -157.81213634064241,
                            21.296623416140307
                        ],
                        [
                            -157.81214537397548,
                            21.296575066358379
                        ],
                        [
                            -157.81212030067491,
                            21.296570952427444
                        ],
                        [
                            -157.81212462593612,
                            21.296547804694768
                        ],
                        [
                            -157.81212534891486,
                            21.296547923624424
                        ],
                        [
                            -157.81212976280193,
                            21.296524303141009
                        ],
                        [
                            -157.81210910055901,
                            21.29652091324029
                        ],
                        [
                            -157.81210897462634,
                            21.296521589893448
                        ],
                        [
                            -157.8119966709464,
                            21.296503163074885
                        ],
                        [
                            -157.81199850928704,
                            21.29649331917037
                        ],
                        [
                            -157.81199981473659,
                            21.296486331634888
                        ],
                        [
                            -157.81192389406991,
                            21.296473873704521
                        ],
                        [
                            -157.81192074931482,
                            21.296490704232607
                        ],
                        [
                            -157.81185202187262,
                            21.296479427186426
                        ],
                        [
                            -157.81185516759905,
                            21.296462596666775
                        ],
                        [
                            -157.81177924599623,
                            21.296450138665442
                        ],
                        [
                            -157.81177610122546,
                            21.296466969190128
                        ],
                        [
                            -157.81166379764721,
                            21.296448541249809
                        ],
                        [
                            -157.81166392456026,
                            21.296447862797201
                        ],
                        [
                            -157.81164326234165,
                            21.29644447284025
                        ],
                        [
                            -157.81163885030838,
                            21.296468093321231
                        ],
                        [
                            -157.8116395723296,
                            21.296468211342795
                        ],
                        [
                            -157.81163524795269,
                            21.29649135996992
                        ],
                        [
                            -157.81161017564835,
                            21.296487245971061
                        ],
                        [
                            -157.8116036886216,
                            21.296521965293326
                        ],
                        [
                            -157.81160114311979,
                            21.296535594820277
                        ],
                        [
                            -157.81162402530597,
                            21.296539350069065
                        ],
                        [
                            -157.81162549148982,
                            21.29653958988224
                        ],
                        [
                            -157.81162814369509,
                            21.296540025974522
                        ],
                        [
                            -157.81164005314074,
                            21.296541980078882
                        ],
                        [
                            -157.81163986477128,
                            21.29654298873799
                        ],
                        [
                            -157.81164179304179,
                            21.296543304988194
                        ],
                        [
                            -157.81164198237511,
                            21.296542296335886
                        ],
                        [
                            -157.81167104022742,
                            21.296547064518936
                        ],
                        [
                            -157.81167085185817,
                            21.296548073178084
                        ],
                        [
                            -157.81167278012884,
                            21.29654838942794
                        ],
                        [
                            -157.81167296946194,
                            21.296547380775593
                        ],
                        [
                            -157.81169353734185,
                            21.296550756512541
                        ],
                        [
                            -157.81169334897277,
                            21.296551765171721
                        ],
                        [
                            -157.81169527724353,
                            21.296552081421307
                        ],
                        [
                            -157.81169546561259,
                            21.296551072762139
                        ],
                        [
                            -157.81171091776068,
                            21.29655360836184
                        ],
                        [
                            -157.81171100236688,
                            21.296553156361195
                        ],
                        [
                            -157.81172456956958,
                            21.296555382339871
                        ],
                        [
                            -157.81172429659455,
                            21.296556842999745
                        ],
                        [
                            -157.81172622582935,
                            21.296557159255801
                        ],
                        [
                            -157.81172649784045,
                            21.296555698589106
                        ],
                        [
                            -157.81174712637653,
                            21.296559083781723
                        ],
                        [
                            -157.8117468534017,
                            21.296560544441665
                        ],
                        [
                            -157.81174878167272,
                            21.296560860690661
                        ],
                        [
                            -157.81174905560417,
                            21.296559400940858
                        ],
                        [
                            -157.81177794885417,
                            21.296564140841941
                        ],
                        [
                            -157.81177767587238,
                            21.296565602405277
                        ],
                        [
                            -157.81177960510743,
                            21.296565918660718
                        ],
                        [
                            -157.81177987808195,
                            21.296564458000727
                        ],
                        [
                            -157.8117919868138,
                            21.296566444216644
                        ],
                        [
                            -157.81179337212455,
                            21.296566671713368
                        ],
                        [
                            -157.81180036510816,
                            21.29656781960314
                        ],
                        [
                            -157.81180009309776,
                            21.296569280269992
                        ],
                        [
                            -157.81180202136176,
                            21.296569597421726
                        ],
                        [
                            -157.81180229434332,
                            21.29656813585834
                        ],
                        [
                            -157.81183160924348,
                            21.296572946481248
                        ],
                        [
                            -157.81183133529828,
                            21.29657440803787
                        ],
                        [
                            -157.81183326453359,
                            21.296574724292721
                        ],
                        [
                            -157.81183353655098,
                            21.296573262722465
                        ],
                        [
                            -157.81184568186205,
                            21.296575255516533
                        ],
                        [
                            -157.81184196793203,
                            21.296595137286843
                        ],
                        [
                            -157.81188825508011,
                            21.296602733615757
                        ],
                        [
                            -157.81189196900422,
                            21.296582851844175
                        ],
                        [
                            -157.81190411432436,
                            21.296584843730738
                        ],
                        [
                            -157.81190384230763,
                            21.29658630530114
                        ],
                        [
                            -157.81190577057941,
                            21.296586621548354
                        ],
                        [
                            -157.81190604259609,
                            21.296585159977965
                        ],
                        [
                            -157.81193188315174,
                            21.296589400410841
                        ],
                        [
                            -157.81193535750396,
                            21.296589970583089
                        ],
                        [
                            -157.81193508452364,
                            21.296591432146748
                        ],
                        [
                            -157.81193701375946,
                            21.296591748400427
                        ],
                        [
                            -157.8119372867325,
                            21.296590287740102
                        ],
                        [
                            -157.81195777376686,
                            21.29659364932369
                        ],
                        [
                            -157.81195750176516,
                            21.296595109087509
                        ],
                        [
                            -157.81195943002996,
                            21.29659542623747
                        ],
                        [
                            -157.81195970300277,
                            21.296593965577095
                        ],
                        [
                            -157.81198859722483,
                            21.296598706352761
                        ],
                        [
                            -157.81198832328835,
                            21.296600167006389
                        ],
                        [
                            -157.81199025251718,
                            21.296600484162806
                        ],
                        [
                            -157.81199052549698,
                            21.296599022599032
                        ],
                        [
                            -157.81201115403954,
                            21.296602408663169
                        ],
                        [
                            -157.81201088107446,
                            21.296603868420313
                        ],
                        [
                            -157.81201280934675,
                            21.296604184666322
                        ],
                        [
                            -157.81201308231184,
                            21.296602724909192
                        ],
                        [
                            -157.81202079347321,
                            21.296603989879412
                        ],
                        [
                            -157.81202234340222,
                            21.29660424473451
                        ],
                        [
                            -157.81202664952488,
                            21.296604950863923
                        ],
                        [
                            -157.81202656491962,
                            21.296605402864763
                        ],
                        [
                            -157.81204201708789,
                            21.296607937531252
                        ],
                        [
                            -157.8120418287138,
                            21.296608947094263
                        ],
                        [
                            -157.81204375794292,
                            21.296609264250076
                        ],
                        [
                            -157.81204394631698,
                            21.296608254687065
                        ],
                        [
                            -157.81206451325951,
                            21.296611629469297
                        ],
                        [
                            -157.81206432585677,
                            21.296612638135805
                        ],
                        [
                            -157.81206625412204,
                            21.296612955284562
                        ],
                        [
                            -157.81206644248869,
                            21.296611946624854
                        ],
                        [
                            -157.81209550230724,
                            21.29661671384611
                        ],
                        [
                            -157.81209531296963,
                            21.296617723402395
                        ],
                        [
                            -157.81209724124233,
                            21.296618039647466
                        ],
                        [
                            -157.81209742960877,
                            21.296617030987719
                        ],
                        [
                            -157.81210934003246,
                            21.296618985066228
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 38,
                "NUMBER": "1154E",
                "PROPER_NAME": "WA`AHILA FACULTY HOUSING BUILDING E",
                "DISPLAY_NAME": "WA`AHILA FACULTY HOUSING BUILDING E - 1154E",
                "ADDRESS": "2640 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WAAHILA FACULTY HOUSING BUILDING E",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1154E_01.jpg",
                "HEIGHT (ft)": 36,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 151.34988320903369,
                "SHAPE_Area": 611.5299807375867
            }
        },
        {
            "type": "Feature",
            "id": 39,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82263095040202,
                            21.296707517904458
                        ],
                        [
                            -157.82268941754748,
                            21.296709478017021
                        ],
                        [
                            -157.82269017031081,
                            21.29668976133534
                        ],
                        [
                            -157.822725887226,
                            21.296690957926284
                        ],
                        [
                            -157.82272609684711,
                            21.296685455929385
                        ],
                        [
                            -157.82279459425357,
                            21.296687751761628
                        ],
                        [
                            -157.82279662379713,
                            21.296634563403025
                        ],
                        [
                            -157.82280591970456,
                            21.29663487595106
                        ],
                        [
                            -157.82280657113856,
                            21.296617834406078
                        ],
                        [
                            -157.82279287108361,
                            21.296617375419743
                        ],
                        [
                            -157.82279741740049,
                            21.296498234471606
                        ],
                        [
                            -157.8225892357523,
                            21.296491256723154
                        ],
                        [
                            -157.82258200723246,
                            21.296680626643404
                        ],
                        [
                            -157.8226319127977,
                            21.296682299226774
                        ],
                        [
                            -157.82263095040202,
                            21.296707517904458
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 39,
                "NUMBER": "1067",
                "PROPER_NAME": "DOLE STREET OFFICES",
                "DISPLAY_NAME": "DOLE STREET OFFICES - 1067",
                "ADDRESS": "2327 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "DOLE STREET OFFICES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1067_01.jpg",
                "HEIGHT (ft)": 29.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 93.605250841477186,
                "SHAPE_Area": 477.90413867726329
            }
        },
        {
            "type": "Feature",
            "id": 40,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81915999126883,
                            21.297249399973801
                        ],
                        [
                            -157.81916008605441,
                            21.297305832760177
                        ],
                        [
                            -157.81936693275438,
                            21.297305529515423
                        ],
                        [
                            -157.81936683886815,
                            21.297249094925572
                        ],
                        [
                            -157.81915999126883,
                            21.297249399973801
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 40,
                "NUMBER": "1103C",
                "PROPER_NAME": "BACHMAN ANNEX 11",
                "DISPLAY_NAME": "BACHMAN ANNEX 11 - 1103C",
                "ADDRESS": "2444 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BACHMAN HALL AND ANNEXES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1103C_01.jpg",
                "HEIGHT (ft)": 15.4,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.411171276344639,
                "SHAPE_Area": 134.05263568312424
            }
        },
        {
            "type": "Feature",
            "id": 41,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81459627923221,
                            21.29730106722937
                        ],
                        [
                            -157.81459657290998,
                            21.297310484426596
                        ],
                        [
                            -157.81483175532057,
                            21.29730403008222
                        ],
                        [
                            -157.81483552360254,
                            21.297300285868577
                        ],
                        [
                            -157.81481753893155,
                            21.296724754955516
                        ],
                        [
                            -157.81481354366676,
                            21.296721223475398
                        ],
                        [
                            -157.81464142402629,
                            21.296725947525516
                        ],
                        [
                            -157.81463287784081,
                            21.296452431209996
                        ],
                        [
                            -157.81462759032294,
                            21.296452575552212
                        ],
                        [
                            -157.81462611122748,
                            21.296405260025107
                        ],
                        [
                            -157.81460035335252,
                            21.296405967549777
                        ],
                        [
                            -157.81460012828586,
                            21.296398812923236
                        ],
                        [
                            -157.81459906576458,
                            21.296398842478855
                        ],
                        [
                            -157.81459901355515,
                            21.296397178970299
                        ],
                        [
                            -157.8143646068234,
                            21.296403612312517
                        ],
                        [
                            -157.81436161980898,
                            21.29640657968439
                        ],
                        [
                            -157.81437963959181,
                            21.296983283442565
                        ],
                        [
                            -157.81438295143198,
                            21.296986210267558
                        ],
                        [
                            -157.81455542908216,
                            21.296981476368529
                        ],
                        [
                            -157.81456397609566,
                            21.297254989059361
                        ],
                        [
                            -157.81456935235829,
                            21.297254840828426
                        ],
                        [
                            -157.81457081817999,
                            21.297301765089784
                        ],
                        [
                            -157.81459627923221,
                            21.29730106722937
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 41,
                "NUMBER": "1155",
                "PROPER_NAME": "JOHN A. BURNS HALL",
                "DISPLAY_NAME": "JOHN A. BURNS HALL - 1155",
                "ADDRESS": "1601 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "JOHN A. BURNS HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1155_01.jpg",
                "HEIGHT (ft)": 50.399999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": "https://www.hawaii.edu/sustainability/pv_system/john-a-burns-hall/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2019/05/4330_4Feb2012-1.jpg",
                "PORTABLE?": null,
                "SHAPE_Length": 293.73770439794356,
                "SHAPE_Area": 3327.6883855720716
            }
        },
        {
            "type": "Feature",
            "id": 42,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81916018507911,
                            21.297365234118516
                        ],
                        [
                            -157.81916027888414,
                            21.297421668704054
                        ],
                        [
                            -157.81936712672464,
                            21.297421363666675
                        ],
                        [
                            -157.81936703186949,
                            21.297364929974144
                        ],
                        [
                            -157.81916018507911,
                            21.297365234118516
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 42,
                "NUMBER": "1103D",
                "PROPER_NAME": "BACHMAN ANNEX 12",
                "DISPLAY_NAME": "BACHMAN ANNEX 12 - 1103D",
                "ADDRESS": "2444 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BACHMAN HALL AND ANNEXES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1103D_01.jpg",
                "HEIGHT (ft)": 14.200000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.41127217918465,
                "SHAPE_Area": 134.05371141133355
            }
        },
        {
            "type": "Feature",
            "id": 43,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81745380156042,
                            21.297440049151742
                        ],
                        [
                            -157.81750255254971,
                            21.297441826269242
                        ],
                        [
                            -157.81750254988526,
                            21.297442882314026
                        ],
                        [
                            -157.81750507671779,
                            21.29744296872531
                        ],
                        [
                            -157.81750536554256,
                            21.297435061570635
                        ],
                        [
                            -157.81765252997175,
                            21.297439485911223
                        ],
                        [
                            -157.81765706442206,
                            21.29732621000548
                        ],
                        [
                            -157.81746598136783,
                            21.297319786853247
                        ],
                        [
                            -157.8174638772027,
                            21.297362540382728
                        ],
                        [
                            -157.81746466642355,
                            21.2973625739331
                        ],
                        [
                            -157.81746366476523,
                            21.297389215108549
                        ],
                        [
                            -157.81745405308396,
                            21.29738908975715
                        ],
                        [
                            -157.81745397582048,
                            21.297391397377023
                        ],
                        [
                            -157.81745543388894,
                            21.297391449177841
                        ],
                        [
                            -157.81745380156042,
                            21.297440049151742
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 43,
                "NUMBER": "1046C",
                "PROPER_NAME": "KRAUSS HALL PRI BUILDING 2",
                "DISPLAY_NAME": "KRAUSS HALL PRI BUILDING 2 - 1046C",
                "ADDRESS": "2500 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KRAUSS HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1046C_01.jpg",
                "HEIGHT (ft)": 18.699999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 68.532478147028414,
                "SHAPE_Area": 257.48869697676446
            }
        },
        {
            "type": "Feature",
            "id": 44,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81914838095727,
                            21.297480873867745
                        ],
                        [
                            -157.81914847572665,
                            21.297537307555753
                        ],
                        [
                            -157.81936731756642,
                            21.297536985497583
                        ],
                        [
                            -157.81936722272062,
                            21.297480550902485
                        ],
                        [
                            -157.81914838095727,
                            21.297480873867745
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 44,
                "NUMBER": "1103E",
                "PROPER_NAME": "BACHMAN ANNEX 13",
                "DISPLAY_NAME": "BACHMAN ANNEX 13 - 1103E",
                "ADDRESS": "2444 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BACHMAN HALL AND ANNEXES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1103E_01.jpg",
                "HEIGHT (ft)": 14.700000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 57.899875703741714,
                "SHAPE_Area": 141.8270038009768
            }
        },
        {
            "type": "Feature",
            "id": 45,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82326895487319,
                            21.297566076314997
                        ],
                        [
                            -157.82344557542658,
                            21.297572130713736
                        ],
                        [
                            -157.82344945026239,
                            21.297472864187004
                        ],
                        [
                            -157.82339538729045,
                            21.297471010097791
                        ],
                        [
                            -157.82339656804456,
                            21.297440748398987
                        ],
                        [
                            -157.82336256462671,
                            21.297439582893887
                        ],
                        [
                            -157.82336611836337,
                            21.297348569320292
                        ],
                        [
                            -157.82327756247639,
                            21.29734553361488
                        ],
                        [
                            -157.82326895487319,
                            21.297566076314997
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 45,
                "NUMBER": "1080",
                "PROPER_NAME": "CASTLE MEMORIAL ANNEX",
                "DISPLAY_NAME": "CASTLE MEMORIAL ANNEX - 1080",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CASTLE MEMORIAL ANNEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1080_01.jpg",
                "HEIGHT (ft)": 16.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 85.529521033271109,
                "SHAPE_Area": 336.93846420943152
            }
        },
        {
            "type": "Feature",
            "id": 46,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81583190821539,
                            21.297628414746839
                        ],
                        [
                            -157.81583386554766,
                            21.29762835534406
                        ],
                        [
                            -157.81584830058611,
                            21.297627923004907
                        ],
                        [
                            -157.81583653046707,
                            21.297283071291911
                        ],
                        [
                            -157.8157190901951,
                            21.297286591162951
                        ],
                        [
                            -157.81572512432038,
                            21.29746337466721
                        ],
                        [
                            -157.81572653361837,
                            21.297504646022503
                        ],
                        [
                            -157.8157289201628,
                            21.29757457978733
                        ],
                        [
                            -157.81573772812942,
                            21.297574315641555
                        ],
                        [
                            -157.81573868294612,
                            21.297602288606718
                        ],
                        [
                            -157.81578688234333,
                            21.297600843562567
                        ],
                        [
                            -157.81578786837287,
                            21.297629734591698
                        ],
                        [
                            -157.81583190821539,
                            21.297628414746839
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 46,
                "NUMBER": "1162A",
                "PROPER_NAME": "PACIFIC OCEAN SCIENCE AND TECHNOLOGY (POST) MECHANICAL BUILDING",
                "DISPLAY_NAME": "PACIFIC OCEAN SCIENCE AND TECHNOLOGY (POST) MECHANICAL BUILDING - 1162A",
                "ADDRESS": "1680 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PACIFIC OCEAN SCIENCE AND TECHNOLOGY (POST)",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1162A_01.jpg",
                "HEIGHT (ft)": 17.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 100.76653536340147,
                "SHAPE_Area": 443.79812571744026
            }
        },
        {
            "type": "Feature",
            "id": 47,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82224688578103,
                            21.297547033958757
                        ],
                        [
                            -157.82225209465039,
                            21.297410738671601
                        ],
                        [
                            -157.82193113647105,
                            21.297399965250733
                        ],
                        [
                            -157.82192818308181,
                            21.297477226114061
                        ],
                        [
                            -157.82192451326924,
                            21.297477102859979
                        ],
                        [
                            -157.82192444370364,
                            21.297478937161337
                        ],
                        [
                            -157.82192811351624,
                            21.297479060415426
                        ],
                        [
                            -157.82192723196499,
                            21.297502101570661
                        ],
                        [
                            -157.82192356215904,
                            21.297501977413187
                        ],
                        [
                            -157.82192349259338,
                            21.297503811714542
                        ],
                        [
                            -157.82192716144269,
                            21.297503934961917
                        ],
                        [
                            -157.82192576052677,
                            21.29754061640454
                        ],
                        [
                            -157.82192209070544,
                            21.297540494053692
                        ],
                        [
                            -157.8219220201758,
                            21.297542328348271
                        ],
                        [
                            -157.82192568999716,
                            21.29754245069914
                        ],
                        [
                            -157.82192428811609,
                            21.297579132134814
                        ],
                        [
                            -157.82192061926494,
                            21.297579008887276
                        ],
                        [
                            -157.82192054873525,
                            21.297580843181844
                        ],
                        [
                            -157.82192421855038,
                            21.297580966436133
                        ],
                        [
                            -157.82192281569695,
                            21.297617648768185
                        ],
                        [
                            -157.82191914588094,
                            21.297617525513829
                        ],
                        [
                            -157.82191907631508,
                            21.297619359815155
                        ],
                        [
                            -157.82192274613115,
                            21.297619483069496
                        ],
                        [
                            -157.8219213442548,
                            21.297656163601406
                        ],
                        [
                            -157.82191767443783,
                            21.29765604034699
                        ],
                        [
                            -157.82191760487194,
                            21.297657874648284
                        ],
                        [
                            -157.82192127372505,
                            21.297657997895978
                        ],
                        [
                            -157.82191987183307,
                            21.297694680234354
                        ],
                        [
                            -157.82191619141923,
                            21.297694556002284
                        ],
                        [
                            -157.82191613245638,
                            21.297696390377791
                        ],
                        [
                            -157.82224076109466,
                            21.29770728710422
                        ],
                        [
                            -157.82224311882885,
                            21.297645845870726
                        ],
                        [
                            -157.8222548597426,
                            21.297646239702381
                        ],
                        [
                            -157.82225490541285,
                            21.297644863253119
                        ],
                        [
                            -157.82224316256418,
                            21.297644470311337
                        ],
                        [
                            -157.82224430135835,
                            21.297614665453075
                        ],
                        [
                            -157.82225604322633,
                            21.297615060194605
                        ],
                        [
                            -157.82225723538451,
                            21.297583880747407
                        ],
                        [
                            -157.82224549255506,
                            21.297583485999311
                        ],
                        [
                            -157.82224623970421,
                            21.297563998746284
                        ],
                        [
                            -157.82224629307859,
                            21.297562623254318
                        ],
                        [
                            -157.82224683625509,
                            21.297548410381051
                        ],
                        [
                            -157.82224688578103,
                            21.297547033958757
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 47,
                "NUMBER": "1187",
                "PROPER_NAME": "UNIVERSITY LAB SCHOOL - MULTIPURPOSE BUILDING",
                "DISPLAY_NAME": "UNIVERSITY LAB SCHOOL - MULTIPURPOSE BUILDING - 1187",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY LAB SCHOOL - MULTIPURPOSE BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1187_01.jpg",
                "HEIGHT (ft)": 28.400000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 142.5417953144289,
                "SHAPE_Area": 1099.3684372871746
            }
        },
        {
            "type": "Feature",
            "id": 49,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82341350625762,
                            21.297748794273691
                        ],
                        [
                            -157.82350912341028,
                            21.29775280796526
                        ],
                        [
                            -157.82351203209791,
                            21.297691961363331
                        ],
                        [
                            -157.82350163818222,
                            21.297691524638555
                        ],
                        [
                            -157.82350321570431,
                            21.297658523918042
                        ],
                        [
                            -157.82348162612163,
                            21.297657616857105
                        ],
                        [
                            -157.82347374829166,
                            21.297657286251944
                        ],
                        [
                            -157.82346274342774,
                            21.297656823572574
                        ],
                        [
                            -157.82346200908376,
                            21.297672178811929
                        ],
                        [
                            -157.82343743217584,
                            21.297671147875118
                        ],
                        [
                            -157.8234354115547,
                            21.297713430558865
                        ],
                        [
                            -157.82341523659315,
                            21.297712583968472
                        ],
                        [
                            -157.82341350625762,
                            21.297748794273691
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 49,
                "NUMBER": "1069",
                "PROPER_NAME": "CASTLE MEMORIAL CARETAKERS COTTAGE",
                "DISPLAY_NAME": "CASTLE MEMORIAL CARETAKERS COTTAGE - 1069",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CASTLE MEMORIAL CARETAKERS COTTAGE",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1069_01.jpg",
                "HEIGHT (ft)": 22.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 40.656888805123558,
                "SHAPE_Area": 81.587273505738366
            }
        },
        {
            "type": "Feature",
            "id": 50,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81609554559978,
                            21.297219373315901
                        ],
                        [
                            -157.81611353297987,
                            21.297730673238654
                        ],
                        [
                            -157.81654168471673,
                            21.297717444225519
                        ],
                        [
                            -157.81652369585203,
                            21.297206144278917
                        ],
                        [
                            -157.81609554559978,
                            21.297219373315901
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 50,
                "NUMBER": "1162",
                "PROPER_NAME": "PACIFIC OCEAN SCIENCE AND TECHNOLOGY",
                "DISPLAY_NAME": "PACIFIC OCEAN SCIENCE AND TECHNOLOGY (POST) - 1162",
                "ADDRESS": "1680 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PACIFIC OCEAN SCIENCE AND TECHNOLOGY (POST)",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1162_01.jpg",
                "HEIGHT (ft)": 120.3,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 202.14225453216778,
                "SHAPE_Area": 2516.6979587180163
            }
        },
        {
            "type": "Feature",
            "id": 51,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81752764090524,
                            21.297884161598471
                        ],
                        [
                            -157.8175863419888,
                            21.29788632027627
                        ],
                        [
                            -157.81759445988538,
                            21.297692390460359
                        ],
                        [
                            -157.81753575501551,
                            21.297690232665175
                        ],
                        [
                            -157.81752764090524,
                            21.297884161598471
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 51,
                "NUMBER": "1046T",
                "PROPER_NAME": "KRAUSS ANNEX 19 - ENVIRONMENTAL CENTER",
                "DISPLAY_NAME": "KRAUSS ANNEX 19 - ENVIRONMENTAL CENTER - 1046T",
                "ADDRESS": "2500 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KRAUSS HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1046T_01.jpg",
                "HEIGHT (ft)": 14,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.1570210468646,
                "SHAPE_Area": 130.9352964610168
            }
        },
        {
            "type": "Feature",
            "id": 52,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81908179118329,
                            21.297886739209456
                        ],
                        [
                            -157.81908760666659,
                            21.29796385822581
                        ],
                        [
                            -157.81931078973358,
                            21.297949075433973
                        ],
                        [
                            -157.81930740068941,
                            21.297904147710224
                        ],
                        [
                            -157.81930497316969,
                            21.297871956413047
                        ],
                        [
                            -157.81928739259121,
                            21.297873122215446
                        ],
                        [
                            -157.81908179118329,
                            21.297886739209456
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 52,
                "NUMBER": "1024C",
                "PROPER_NAME": "BACHMAN ANNEX 2 - COMMUNICATIONS",
                "DISPLAY_NAME": "BACHMAN ANNEX 2 - COMMUNICATIONS - 1024C",
                "ADDRESS": "1627 BACHMAN PLACE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ADMINISTRATIVE SERVICES BUILDING 2 COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1024C_01.jpg",
                "HEIGHT (ft)": 14.300000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 63.537916288764279,
                "SHAPE_Area": 198.63971104355835
            }
        },
        {
            "type": "Feature",
            "id": 53,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81502522850292,
                            21.297869981262181
                        ],
                        [
                            -157.81504326558616,
                            21.297873077700615
                        ],
                        [
                            -157.81504756174758,
                            21.297850743628981
                        ],
                        [
                            -157.81502956344076,
                            21.297847620362436
                        ],
                        [
                            -157.81502522850292,
                            21.297869981262181
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 53,
                "NUMBER": "1252A",
                "PROPER_NAME": "PARKING KIOSK - EAST WEST RD",
                "DISPLAY_NAME": "PARKING KIOSK - EAST WEST RD - 1252A",
                "ADDRESS": "2600 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PARKING KIOSK - EAST WEST RD",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1252A_01.jpg",
                "HEIGHT (ft)": 7.7000000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 8.8291917222117391,
                "SHAPE_Area": 4.778076889627755
            }
        },
        {
            "type": "Feature",
            "id": 54,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81773646317455,
                            21.298059253989372
                        ],
                        [
                            -157.81773838376637,
                            21.298114285769767
                        ],
                        [
                            -157.8179453666198,
                            21.298107937978063
                        ],
                        [
                            -157.81794344592186,
                            21.298052909809766
                        ],
                        [
                            -157.81773646317455,
                            21.298059253989372
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 54,
                "NUMBER": "1046U",
                "PROPER_NAME": "KRAUSS ANNEX 7 - CTAHR",
                "DISPLAY_NAME": "KRAUSS ANNEX 7 - CTAHR - 1046U",
                "ADDRESS": "2500 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KUYKENDALL HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1046U_01.jpg",
                "HEIGHT (ft)": 16.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.157756752530432,
                "SHAPE_Area": 130.94304065560368
            }
        },
        {
            "type": "Feature",
            "id": 55,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82194020184335,
                            21.298126847860779
                        ],
                        [
                            -157.82214692906504,
                            21.298133474839602
                        ],
                        [
                            -157.82214892928943,
                            21.298078678265316
                        ],
                        [
                            -157.82194220214407,
                            21.298072051292454
                        ],
                        [
                            -157.82194020184335,
                            21.298126847860779
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 55,
                "NUMBER": "1038D",
                "PROPER_NAME": "UNIVERSITY AVENUE BUILDING 4",
                "DISPLAY_NAME": "UNIVERSITY AVENUE BUILDING 4 - 1038D",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY HIGH SCHOOL 3 COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1038D_01.jpg",
                "HEIGHT (ft)": 17.199999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.055660248291034,
                "SHAPE_Area": 130.23929922974696
            }
        },
        {
            "type": "Feature",
            "id": 56,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82010739504483,
                            21.298164116909803
                        ],
                        [
                            -157.8203141135244,
                            21.298170977346917
                        ],
                        [
                            -157.82031624482383,
                            21.298114578220932
                        ],
                        [
                            -157.82010952545886,
                            21.298107717783267
                        ],
                        [
                            -157.82010739504483,
                            21.298164116909803
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 56,
                "NUMBER": "1133B",
                "PROPER_NAME": "SINCLAIR ANNEX 2",
                "DISPLAY_NAME": "SINCLAIR ANNEX 2 - 1133B",
                "ADDRESS": "1633 BACHMAN PLACE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "SINCLAIR LIBRARY AND ANNEXES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1133B_01.jpg",
                "HEIGHT (ft)": 14.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.411290791368344,
                "SHAPE_Area": 134.05418736796142
            }
        },
        {
            "type": "Feature",
            "id": 57,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82246139643254,
                            21.298193384040534
                        ],
                        [
                            -157.82258077659952,
                            21.298197416376276
                        ],
                        [
                            -157.82259481395693,
                            21.297832436838547
                        ],
                        [
                            -157.82247543408337,
                            21.297828404526225
                        ],
                        [
                            -157.82246139643254,
                            21.298193384040534
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 57,
                "NUMBER": "1040",
                "PROPER_NAME": "WIST HALL ANNEX 1",
                "DISPLAY_NAME": "WIST HALL ANNEX 1 - 1040",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WIST HALL ANNEX 1",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1040_01.jpg",
                "HEIGHT (ft)": 19,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 105.64188965937234,
                "SHAPE_Area": 501.01102420606463
            }
        },
        {
            "type": "Feature",
            "id": 58,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8200451116746,
                            21.298256625633336
                        ],
                        [
                            -157.82025183221148,
                            21.298263485262943
                        ],
                        [
                            -157.8202539625739,
                            21.298207086132763
                        ],
                        [
                            -157.82004724308666,
                            21.298200225612781
                        ],
                        [
                            -157.8200451116746,
                            21.298256625633336
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 58,
                "NUMBER": "1133A",
                "PROPER_NAME": "SINCLAIR ANNEX 1",
                "DISPLAY_NAME": "SINCLAIR ANNEX 1 - 1133A",
                "ADDRESS": "1633 BACHMAN PLACE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "SINCLAIR LIBRARY AND ANNEXES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1133A_01.jpg",
                "HEIGHT (ft)": 12.6,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.411587884634685,
                "SHAPE_Area": 134.05587563590944
            }
        },
        {
            "type": "Feature",
            "id": 59,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82150235971017,
                            21.298292194495666
                        ],
                        [
                            -157.82170907132885,
                            21.29829923024451
                        ],
                        [
                            -157.8217111950666,
                            21.298244439064632
                        ],
                        [
                            -157.8215044835386,
                            21.298237401515216
                        ],
                        [
                            -157.82150235971017,
                            21.298292194495666
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 59,
                "NUMBER": "1038C",
                "PROPER_NAME": "UNIVERSITY AVENUE BUILDING 3",
                "DISPLAY_NAME": "UNIVERSITY AVENUE BUILDING 3 - 1038C",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY HIGH SCHOOL 3 COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1038C_01.jpg",
                "HEIGHT (ft)": 14.9,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.05548929600829,
                "SHAPE_Area": 130.23809910356695
            }
        },
        {
            "type": "Feature",
            "id": 60,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82201491865339,
                            21.298336681245324
                        ],
                        [
                            -157.82207338999132,
                            21.298338556707215
                        ],
                        [
                            -157.82208046231995,
                            21.298144820592167
                        ],
                        [
                            -157.82202199202226,
                            21.298142945142981
                        ],
                        [
                            -157.82201491865339,
                            21.298336681245324
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 60,
                "NUMBER": "1038A",
                "PROPER_NAME": "UNIVERSITY AVENUE BUILDING 1",
                "DISPLAY_NAME": "UNIVERSITY AVENUE BUILDING 1 - 1038A",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY HIGH SCHOOL 3 COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1038A_01.jpg",
                "HEIGHT (ft)": 13.200000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.055773580281297,
                "SHAPE_Area": 130.2389151092066
            }
        },
        {
            "type": "Feature",
            "id": 61,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82173436593467,
                            21.298354383223145
                        ],
                        [
                            -157.82194107863015,
                            21.2983614186982
                        ],
                        [
                            -157.82194320228416,
                            21.298306627511842
                        ],
                        [
                            -157.82173648967935,
                            21.298299590236219
                        ],
                        [
                            -157.82173436593467,
                            21.298354383223145
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 61,
                "NUMBER": "1038B",
                "PROPER_NAME": "UNIVERSITY AVENUE BUILDING 2",
                "DISPLAY_NAME": "UNIVERSITY AVENUE BUILDING 2 - 1038B",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY HIGH SCHOOL 3 COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1038B_01.jpg",
                "HEIGHT (ft)": 14.9,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.055689212520463,
                "SHAPE_Area": 130.23870578253639
            }
        },
        {
            "type": "Feature",
            "id": 62,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81932082460537,
                            21.298359273548314
                        ],
                        [
                            -157.81932044844555,
                            21.298359299817882
                        ],
                        [
                            -157.81932073536555,
                            21.29836296327392
                        ],
                        [
                            -157.81938127004807,
                            21.298358861954419
                        ],
                        [
                            -157.81938003319024,
                            21.298342820799856
                        ],
                        [
                            -157.81942398236373,
                            21.29833984618033
                        ],
                        [
                            -157.81942428194131,
                            21.2983437355728
                        ],
                        [
                            -157.81943160728079,
                            21.298343240407362
                        ],
                        [
                            -157.81943130578242,
                            21.298339350098033
                        ],
                        [
                            -157.81944276398738,
                            21.298338574963626
                        ],
                        [
                            -157.81944002332429,
                            21.298301412822028
                        ],
                        [
                            -157.81947117419352,
                            21.298299354789677
                        ],
                        [
                            -157.8194576731224,
                            21.298124185637224
                        ],
                        [
                            -157.81941558451683,
                            21.298127035101
                        ],
                        [
                            -157.81941552075989,
                            21.298126207147678
                        ],
                        [
                            -157.8194081963951,
                            21.298126702319706
                        ],
                        [
                            -157.81940825918088,
                            21.298127531169591
                        ],
                        [
                            -157.81936879882588,
                            21.29813020211925
                        ],
                        [
                            -157.81936565963167,
                            21.298089473303584
                        ],
                        [
                            -157.81934124346483,
                            21.298091125965254
                        ],
                        [
                            -157.8193316634331,
                            21.29796683347622
                        ],
                        [
                            -157.81930653840283,
                            21.29796853175068
                        ],
                        [
                            -157.81930484270339,
                            21.297961662214252
                        ],
                        [
                            -157.81930197775173,
                            21.297962269068556
                        ],
                        [
                            -157.81929082876965,
                            21.297964522504596
                        ],
                        [
                            -157.81929065401189,
                            21.297964557414218
                        ],
                        [
                            -157.81929031030879,
                            21.297964623660658
                        ],
                        [
                            -157.81927929022316,
                            21.297966670220287
                        ],
                        [
                            -157.81926809100318,
                            21.297968575496853
                        ],
                        [
                            -157.81926789216914,
                            21.29796860752737
                        ],
                        [
                            -157.81925688550038,
                            21.297970301857202
                        ],
                        [
                            -157.81925646083536,
                            21.297970366632157
                        ],
                        [
                            -157.81925487035775,
                            21.297970598485904
                        ],
                        [
                            -157.8192459621427,
                            21.297971824223133
                        ],
                        [
                            -157.81924500004871,
                            21.297971951175093
                        ],
                        [
                            -157.81923351273704,
                            21.297973356659767
                        ],
                        [
                            -157.81923247263063,
                            21.297973474933809
                        ],
                        [
                            -157.81922352896575,
                            21.297974432114032
                        ],
                        [
                            -157.81922200275611,
                            21.29797458311317
                        ],
                        [
                            -157.81921062249151,
                            21.297975620763811
                        ],
                        [
                            -157.81921047296879,
                            21.297975634169021
                        ],
                        [
                            -157.81921019129553,
                            21.29797565839112
                        ],
                        [
                            -157.81919892533909,
                            21.29797650532409
                        ],
                        [
                            -157.81918764627326,
                            21.297977183230216
                        ],
                        [
                            -157.81918736467216,
                            21.297977198418884
                        ],
                        [
                            -157.81917622202695,
                            21.297977692989672
                        ],
                        [
                            -157.81917579291758,
                            21.297977710756932
                        ],
                        [
                            -157.81917425975428,
                            21.297977766850813
                        ],
                        [
                            -157.81916526191171,
                            21.297978024423251
                        ],
                        [
                            -157.81916421389494,
                            21.297978046881951
                        ],
                        [
                            -157.81915263052491,
                            21.297978203200884
                        ],
                        [
                            -157.81915165783806,
                            21.297978208120231
                        ],
                        [
                            -157.81914265638423,
                            21.297978193745479
                        ],
                        [
                            -157.81914104667044,
                            21.297978178837464
                        ],
                        [
                            -157.81914061582808,
                            21.29797817220091
                        ],
                        [
                            -157.81912946326659,
                            21.297977977411797
                        ],
                        [
                            -157.81912926087273,
                            21.297977972378124
                        ],
                        [
                            -157.81911788611859,
                            21.297977596254434
                        ],
                        [
                            -157.81910666787601,
                            21.297977055907648
                        ],
                        [
                            -157.81910631715428,
                            21.297977035378938
                        ],
                        [
                            -157.81910613890167,
                            21.297977025094291
                        ],
                        [
                            -157.8190947602078,
                            21.297976297522371
                        ],
                        [
                            -157.81909183145675,
                            21.2979760818397
                        ],
                        [
                            -157.81909120850949,
                            21.29798310765619
                        ],
                        [
                            -157.81906514861649,
                            21.297984902321204
                        ],
                        [
                            -157.81906547045631,
                            21.297989020428179
                        ],
                        [
                            -157.81907099821296,
                            21.297988615650866
                        ],
                        [
                            -157.81908799581413,
                            21.298204362566988
                        ],
                        [
                            -157.8190699279327,
                            21.29820558545287
                        ],
                        [
                            -157.81907856970119,
                            21.298317704494298
                        ],
                        [
                            -157.81918399099777,
                            21.298310568431162
                        ],
                        [
                            -157.81918550990949,
                            21.298330275718559
                        ],
                        [
                            -157.81918336872957,
                            21.298330420595619
                        ],
                        [
                            -157.81918516709908,
                            21.298353759668071
                        ],
                        [
                            -157.81919766021264,
                            21.298352914120052
                        ],
                        [
                            -157.81919762530742,
                            21.298352456759389
                        ],
                        [
                            -157.81931966296639,
                            21.298344195032538
                        ],
                        [
                            -157.81932082460537,
                            21.298359273548314
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 62,
                "NUMBER": "1124",
                "PROPER_NAME": "ADMINISTRATIVE SERVICES BUILDING 1",
                "DISPLAY_NAME": "ADMINISTRATIVE SERVICES BUILDING 1 - 1124",
                "ADDRESS": "2442 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ADMINISTRATIVE SERVICES BUILDING 1",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "Admin Services 1",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1124_01.jpg",
                "HEIGHT (ft)": 20.699999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 173.10837340886957,
                "SHAPE_Area": 1401.9857568174032
            }
        },
        {
            "type": "Feature",
            "id": 63,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82334751775718,
                            21.298459104482166
                        ],
                        [
                            -157.82353495460671,
                            21.298472741637383
                        ],
                        [
                            -157.82354125316232,
                            21.298396692066746
                        ],
                        [
                            -157.82335381736465,
                            21.298383055832954
                        ],
                        [
                            -157.82334751775718,
                            21.298459104482166
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 63,
                "NUMBER": "1064B",
                "PROPER_NAME": "KŌKO`OLUA 2",
                "DISPLAY_NAME": "KŌKO`OLUA 2 - 1064B",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY LAB SCHOOL PORTABLES WEST",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "UNIVERSITY LAB SCHOOL - PORTABLE 2 , LSP 2 , LSP2",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1064B_01.jpg",
                "HEIGHT (ft)": 15.200000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.893742138515165,
                "SHAPE_Area": 164.67929819821759
            }
        },
        {
            "type": "Feature",
            "id": 64,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82306796434341,
                            21.298480095883502
                        ],
                        [
                            -157.82325652072328,
                            21.298493929083619
                        ],
                        [
                            -157.82326286378532,
                            21.298417998184778
                        ],
                        [
                            -157.82307430749378,
                            21.298404165899434
                        ],
                        [
                            -157.82306796434341,
                            21.298480095883502
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 64,
                "NUMBER": "1064A",
                "PROPER_NAME": "KŪKAHI 1",
                "DISPLAY_NAME": "KŪKAHI 1 - 1064A",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY LAB SCHOOL PORTABLES WEST",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "UNIVERSITY LAB SCHOOL - PORTABLE 1 , LSP 1 , LSP1",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1064A_01.jpg",
                "HEIGHT (ft)": 15.1,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 56.103308817187482,
                "SHAPE_Area": 165.42165774613267
            }
        },
        {
            "type": "Feature",
            "id": 65,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82362015501306,
                            21.298506975905745
                        ],
                        [
                            -157.82380782512641,
                            21.298520748996069
                        ],
                        [
                            -157.82381422830773,
                            21.298444132811273
                        ],
                        [
                            -157.82362655829749,
                            21.298430358829105
                        ],
                        [
                            -157.82362015501306,
                            21.298506975905745
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 65,
                "NUMBER": "1064C",
                "PROPER_NAME": "WAIKOLU 3",
                "DISPLAY_NAME": "WAIKOLU 3 - 1064C",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY LAB SCHOOL PORTABLES WEST",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "UNIVERSITY LAB SCHOOL - PORTABLE 3 , LSP 3 , LSP3",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1064C_01.jpg",
                "HEIGHT (ft)": 15.300000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 56.071374590620486,
                "SHAPE_Area": 166.13280965809852
            }
        },
        {
            "type": "Feature",
            "id": 66,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81559601585735,
                            21.298185236865301
                        ],
                        [
                            -157.81560628063968,
                            21.298476672242881
                        ],
                        [
                            -157.81612667031797,
                            21.29846057387352
                        ],
                        [
                            -157.81611833489114,
                            21.298223955315926
                        ],
                        [
                            -157.81566106816629,
                            21.29823810031619
                        ],
                        [
                            -157.81565913793773,
                            21.29818328528912
                        ],
                        [
                            -157.81559601585735,
                            21.298185236865301
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 66,
                "NUMBER": "1160",
                "PROPER_NAME": "WATANABE HALL",
                "DISPLAY_NAME": "WATANABE HALL (WAT) - 1160",
                "ADDRESS": "2505 CORREA ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WATANABE HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1160_01.jpg",
                "HEIGHT (ft)": 64.099999999999994,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 172.58655380743846,
                "SHAPE_Area": 1455.3591175247388
            }
        },
        {
            "type": "Feature",
            "id": 67,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82333130395588,
                            21.298673154602554
                        ],
                        [
                            -157.82351512584788,
                            21.298686709601601
                        ],
                        [
                            -157.82352155906651,
                            21.298610094549005
                        ],
                        [
                            -157.82333773727569,
                            21.298596538657911
                        ],
                        [
                            -157.82333130395588,
                            21.298673154602554
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 67,
                "NUMBER": "1064D",
                "PROPER_NAME": "KĀUNA 4",
                "DISPLAY_NAME": "KĀUNA 4 - 1064D",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY LAB SCHOOL PORTABLES WEST",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "UNIVERSITY LAB SCHOOL - PORTABLE 4 , LSP 4 , LSP4",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1064D_01.jpg",
                "HEIGHT (ft)": 14.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.271817170613247,
                "SHAPE_Area": 162.7330825755825
            }
        },
        {
            "type": "Feature",
            "id": 68,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82189328911539,
                            21.298774851007675
                        ],
                        [
                            -157.82194859057915,
                            21.298776666387077
                        ],
                        [
                            -157.82201881633384,
                            21.298778967443557
                        ],
                        [
                            -157.82203224581409,
                            21.298779412862626
                        ],
                        [
                            -157.82203853603158,
                            21.298611131570009
                        ],
                        [
                            -157.82206324496838,
                            21.298611942310064
                        ],
                        [
                            -157.8220692607367,
                            21.298450997339764
                        ],
                        [
                            -157.82154230164534,
                            21.298433697747001
                        ],
                        [
                            -157.82154066464122,
                            21.29847748721544
                        ],
                        [
                            -157.82152109334956,
                            21.29847684427083
                        ],
                        [
                            -157.82152073316391,
                            21.298486473707516
                        ],
                        [
                            -157.82152195709264,
                            21.298486513896687
                        ],
                        [
                            -157.82151993416443,
                            21.298540621005031
                        ],
                        [
                            -157.82151871119916,
                            21.298540580822561
                        ],
                        [
                            -157.821518351013,
                            21.298550210259162
                        ],
                        [
                            -157.82153792232145,
                            21.298550852301197
                        ],
                        [
                            -157.82153628530571,
                            21.298594642672242
                        ],
                        [
                            -157.82189957852648,
                            21.298606569720743
                        ],
                        [
                            -157.82189328911539,
                            21.298774851007675
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 68,
                "NUMBER": "1039",
                "PROPER_NAME": "WIST HALL",
                "DISPLAY_NAME": "WIST HALL (WIST) - 1039",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "EVERLY AND WIST HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1039_01.jpg",
                "HEIGHT (ft)": 46.300000000000004,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 186.65111101357869,
                "SHAPE_Area": 1259.7545505215571
            }
        },
        {
            "type": "Feature",
            "id": 69,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81766665201971,
                            21.298724020297662
                        ],
                        [
                            -157.81766982462949,
                            21.298813898314584
                        ],
                        [
                            -157.81771679930162,
                            21.298812442321466
                        ],
                        [
                            -157.81771696119861,
                            21.298817028165224
                        ],
                        [
                            -157.81772381195071,
                            21.298816816116059
                        ],
                        [
                            -157.81772400507788,
                            21.298822318217116
                        ],
                        [
                            -157.81774235507774,
                            21.298821748805693
                        ],
                        [
                            -157.81774216002205,
                            21.298816246691096
                        ],
                        [
                            -157.8177991663967,
                            21.298814479916398
                        ],
                        [
                            -157.81779919859105,
                            21.298815396180458
                        ],
                        [
                            -157.81780360408359,
                            21.298815260903574
                        ],
                        [
                            -157.81782219898412,
                            21.298814685073211
                        ],
                        [
                            -157.81782660064988,
                            21.298814546155267
                        ],
                        [
                            -157.81782656749141,
                            21.298813629884435
                        ],
                        [
                            -157.81789067048285,
                            21.298811644621551
                        ],
                        [
                            -157.8178907026778,
                            21.298812560885619
                        ],
                        [
                            -157.81790880584751,
                            21.298811997852738
                        ],
                        [
                            -157.81790861174952,
                            21.298806495744799
                        ],
                        [
                            -157.81795558546378,
                            21.298805038774674
                        ],
                        [
                            -157.81795524795265,
                            21.298795410778467
                        ],
                        [
                            -157.81796111906948,
                            21.298795227974548
                        ],
                        [
                            -157.81796082839787,
                            21.298786975267642
                        ],
                        [
                            -157.8179549563319,
                            21.298787156258122
                        ],
                        [
                            -157.81795420241789,
                            21.298765831850737
                        ],
                        [
                            -157.81794759657657,
                            21.298766036595673
                        ],
                        [
                            -157.81794715962442,
                            21.298753655270183
                        ],
                        [
                            -157.81795376546521,
                            21.298753450525226
                        ],
                        [
                            -157.8179524126798,
                            21.298715160754981
                        ],
                        [
                            -157.81790543803751,
                            21.298716616815447
                        ],
                        [
                            -157.8179052770985,
                            21.298712030978315
                        ],
                        [
                            -157.81785732378026,
                            21.298713517190169
                        ],
                        [
                            -157.8178566927395,
                            21.298695633756754
                        ],
                        [
                            -157.81776078610665,
                            21.298698607042855
                        ],
                        [
                            -157.81776141809971,
                            21.29871649048286
                        ],
                        [
                            -157.81771346476629,
                            21.298717978460274
                        ],
                        [
                            -157.81771362667044,
                            21.298722563400727
                        ],
                        [
                            -157.81766665201971,
                            21.298724020297662
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 69,
                "NUMBER": "1037",
                "PROPER_NAME": "BUILDING 37 - iLab",
                "DISPLAY_NAME": "BUILDING 37 - iLab - 1037",
                "ADDRESS": "2532 CORREA ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BUILDING 37 - iLab",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1037_01.jpg",
                "HEIGHT (ft)": 26.199999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 89.43967646610551,
                "SHAPE_Area": 336.47063088363063
            }
        },
        {
            "type": "Feature",
            "id": 70,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82041866525145,
                            21.298849435988302
                        ],
                        [
                            -157.82055689469041,
                            21.298853805156931
                        ],
                        [
                            -157.82055738148122,
                            21.298840277576481
                        ],
                        [
                            -157.82062368161493,
                            21.298842372832539
                        ],
                        [
                            -157.82063258371062,
                            21.298594982833258
                        ],
                        [
                            -157.8206342962618,
                            21.298595037293744
                        ],
                        [
                            -157.82063449440722,
                            21.298589534320016
                        ],
                        [
                            -157.82082483460263,
                            21.298595550341382
                        ],
                        [
                            -157.8208247517363,
                            21.298597841664247
                        ],
                        [
                            -157.82083160194904,
                            21.298598058594962
                        ],
                        [
                            -157.82083643621593,
                            21.298463702183774
                        ],
                        [
                            -157.82086383705678,
                            21.298464568095245
                        ],
                        [
                            -157.82086682332877,
                            21.298381569171227
                        ],
                        [
                            -157.82083550877681,
                            21.298380580983466
                        ],
                        [
                            -157.82083608603256,
                            21.298364530862564
                        ],
                        [
                            -157.82064207622915,
                            21.298358400617943
                        ],
                        [
                            -157.82065057336473,
                            21.298122245047143
                        ],
                        [
                            -157.82044384170302,
                            21.298115711960786
                        ],
                        [
                            -157.82044214221534,
                            21.29816294288981
                        ],
                        [
                            -157.82042085823619,
                            21.298162269747326
                        ],
                        [
                            -157.82041405926839,
                            21.298351194354673
                        ],
                        [
                            -157.82004243192426,
                            21.298339449610314
                        ],
                        [
                            -157.82004185458993,
                            21.298355498821206
                        ],
                        [
                            -157.82001151825617,
                            21.298354539923707
                        ],
                        [
                            -157.82000853054203,
                            21.298437538803796
                        ],
                        [
                            -157.82003593137327,
                            21.29843840394631
                        ],
                        [
                            -157.8200310963818,
                            21.298572760301184
                        ],
                        [
                            -157.8200379465905,
                            21.298572977264104
                        ],
                        [
                            -157.82003802948341,
                            21.298570684135523
                        ],
                        [
                            -157.82036046204826,
                            21.298581438171038
                        ],
                        [
                            -157.82035997039097,
                            21.298595090384506
                        ],
                        [
                            -157.82036975709613,
                            21.298595400188187
                        ],
                        [
                            -157.82037024875251,
                            21.298581747974669
                        ],
                        [
                            -157.820426519194,
                            21.298583526376664
                        ],
                        [
                            -157.82042602754998,
                            21.298597177687263
                        ],
                        [
                            -157.8204303094131,
                            21.298597313395423
                        ],
                        [
                            -157.82042858417162,
                            21.298645232524841
                        ],
                        [
                            -157.8204269940166,
                            21.298645181630278
                        ],
                        [
                            -157.82042684539985,
                            21.298649309085942
                        ],
                        [
                            -157.82042843556209,
                            21.298649359077167
                        ],
                        [
                            -157.82042635690456,
                            21.298707137146291
                        ],
                        [
                            -157.82042476674167,
                            21.298707087155019
                        ],
                        [
                            -157.82042461813907,
                            21.298711212803966
                        ],
                        [
                            -157.8204262082948,
                            21.298711263698582
                        ],
                        [
                            -157.82042412963423,
                            21.29876904176718
                        ],
                        [
                            -157.8204215603192,
                            21.298768960521397
                        ],
                        [
                            -157.82041866525145,
                            21.298849435988302
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 70,
                "NUMBER": "1133",
                "PROPER_NAME": "FUTURE STUDENT SUCCESS CENTER",
                "DISPLAY_NAME": "FUTURE STUDENT SUCCESS CENTER (SL) - 1133",
                "ADDRESS": "2425 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "SINCLAIR LIBRARY AND ANNEXES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": "Sinclair Library",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1133_01.jpg",
                "HEIGHT (ft)": 65.200000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": "https://www.hawaii.edu/sustainability/pv_system/sinclair-library/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2019/08/Sinclair_Library_snapshot_11-12-19_14_42-scaled.jpeg",
                "PORTABLE?": null,
                "SHAPE_Length": 345.25727871187092,
                "SHAPE_Area": 3400.5023879955752
            }
        },
        {
            "type": "Feature",
            "id": 71,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81914492464182,
                            21.29902478971221
                        ],
                        [
                            -157.81937363302654,
                            21.298776958192644
                        ],
                        [
                            -157.81937370304956,
                            21.298776880992257
                        ],
                        [
                            -157.81937688862288,
                            21.298779461742733
                        ],
                        [
                            -157.81938221251991,
                            21.298773687577913
                        ],
                        [
                            -157.81938213781015,
                            21.298773627430013
                        ],
                        [
                            -157.8193790269394,
                            21.298771107730893
                        ],
                        [
                            -157.8193791650215,
                            21.298770957833309
                        ],
                        [
                            -157.8194176241239,
                            21.298729286805408
                        ],
                        [
                            -157.81914762453633,
                            21.298511053032406
                        ],
                        [
                            -157.81910784141274,
                            21.298478820955236
                        ],
                        [
                            -157.81910064252611,
                            21.29838566517958
                        ],
                        [
                            -157.81909936859898,
                            21.298369200073807
                        ],
                        [
                            -157.81897407910873,
                            21.298268561259501
                        ],
                        [
                            -157.81895688005611,
                            21.298046679805847
                        ],
                        [
                            -157.81883679165435,
                            21.298054837518265
                        ],
                        [
                            -157.81858809002907,
                            21.297853267271027
                        ],
                        [
                            -157.81849820021168,
                            21.297951375045486
                        ],
                        [
                            -157.81845341985365,
                            21.297915080425366
                        ],
                        [
                            -157.81841501125035,
                            21.297956700095561
                        ],
                        [
                            -157.81846238237057,
                            21.297995094326421
                        ],
                        [
                            -157.8183691622358,
                            21.298090501896581
                        ],
                        [
                            -157.81849388366439,
                            21.298191586138515
                        ],
                        [
                            -157.81843974143706,
                            21.298249554228708
                        ],
                        [
                            -157.81856853355268,
                            21.298353939080762
                        ],
                        [
                            -157.81880042869702,
                            21.298338187381258
                        ],
                        [
                            -157.81885816312271,
                            21.298384980795564
                        ],
                        [
                            -157.81885825718825,
                            21.298386117017916
                        ],
                        [
                            -157.81887466567073,
                            21.298598344707479
                        ],
                        [
                            -157.81885942718185,
                            21.298599063459282
                        ],
                        [
                            -157.8188218326934,
                            21.298641090939206
                        ],
                        [
                            -157.81882673324372,
                            21.298699391324263
                        ],
                        [
                            -157.8188315253316,
                            21.298771505598292
                        ],
                        [
                            -157.8188933341608,
                            21.298823186940069
                        ],
                        [
                            -157.81889448071405,
                            21.298821811895571
                        ],
                        [
                            -157.81914492464182,
                            21.29902478971221
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 71,
                "NUMBER": "1055",
                "PROPER_NAME": "CAMPUS CENTER",
                "DISPLAY_NAME": "CAMPUS CENTER (CC) - 1055",
                "ADDRESS": "2465 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CAMPUS CENTER AND WARRIOR RECREATION CENTER",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1055_01.jpg",
                "HEIGHT (ft)": 50.899999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 398.72201388343956,
                "SHAPE_Area": 4936.0270304791175
            }
        },
        {
            "type": "Feature",
            "id": 72,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81950723836036,
                            21.299033549607191
                        ],
                        [
                            -157.81959696828014,
                            21.299030667517727
                        ],
                        [
                            -157.81959698478548,
                            21.299031135589953
                        ],
                        [
                            -157.81959847162645,
                            21.299031087298257
                        ],
                        [
                            -157.81959848739154,
                            21.299031527360196
                        ],
                        [
                            -157.81960435952601,
                            21.299031339085971
                        ],
                        [
                            -157.81960434376091,
                            21.299030899024054
                        ],
                        [
                            -157.81960575345903,
                            21.29903085380478
                        ],
                        [
                            -157.81960573598971,
                            21.299030385725793
                        ],
                        [
                            -157.81962930074232,
                            21.299029625030748
                        ],
                        [
                            -157.81962932203854,
                            21.299030096750137
                        ],
                        [
                            -157.81963080791559,
                            21.299030048451399
                        ],
                        [
                            -157.81963082464469,
                            21.299030488520092
                        ],
                        [
                            -157.81963669678632,
                            21.299030299341418
                        ],
                        [
                            -157.81963668102114,
                            21.299029859279482
                        ],
                        [
                            -157.81963808975533,
                            21.299029814053188
                        ],
                        [
                            -157.81963807228593,
                            21.299029345974184
                        ],
                        [
                            -157.8197937803682,
                            21.299024341017287
                        ],
                        [
                            -157.81979379784531,
                            21.29902480819295
                        ],
                        [
                            -157.81979528371511,
                            21.299024760796087
                        ],
                        [
                            -157.8197953004447,
                            21.299025200864794
                        ],
                        [
                            -157.81980117354291,
                            21.299025012590437
                        ],
                        [
                            -157.81980115682055,
                            21.299024571618411
                        ],
                        [
                            -157.81980256555468,
                            21.299024526390721
                        ],
                        [
                            -157.81980252785678,
                            21.299024056363091
                        ],
                        [
                            -157.81982611380073,
                            21.299023297595784
                        ],
                        [
                            -157.81982613413365,
                            21.29902376930842
                        ],
                        [
                            -157.81982762001067,
                            21.299023721007934
                        ],
                        [
                            -157.81982763674034,
                            21.299024161076638
                        ],
                        [
                            -157.81983350984578,
                            21.29902397189781
                        ],
                        [
                            -157.81983349310886,
                            21.299023532732463
                        ],
                        [
                            -157.81983490281416,
                            21.299023486607922
                        ],
                        [
                            -157.81983488630084,
                            21.299023019439023
                        ],
                        [
                            -157.8199243645966,
                            21.299020139926789
                        ],
                        [
                            -157.81992357006555,
                            21.298998434001778
                        ],
                        [
                            -157.81992414281714,
                            21.298998415433157
                        ],
                        [
                            -157.81992409129802,
                            21.298997020236289
                        ],
                        [
                            -157.81992454063115,
                            21.298997005319237
                        ],
                        [
                            -157.81992429047742,
                            21.29899018386693
                        ],
                        [
                            -157.81992384115148,
                            21.298990197880663
                        ],
                        [
                            -157.81992379154576,
                            21.298988804503988
                        ],
                        [
                            -157.81992321879423,
                            21.298988823072609
                        ],
                        [
                            -157.81992228649355,
                            21.298963364398876
                        ],
                        [
                            -157.81992285923778,
                            21.298963346733604
                        ],
                        [
                            -157.81992280772585,
                            21.298961950633394
                        ],
                        [
                            -157.81992325705889,
                            21.298961935716321
                        ],
                        [
                            -157.81992300689797,
                            21.298955115167349
                        ],
                        [
                            -157.81992255853609,
                            21.298955129187824
                        ],
                        [
                            -157.81992250700975,
                            21.298953734894305
                        ],
                        [
                            -157.81992193522225,
                            21.298953753469664
                        ],
                        [
                            -157.81992122609347,
                            21.298934390636063
                        ],
                        [
                            -157.81992114221538,
                            21.29893209814507
                        ],
                        [
                            -157.81978880320344,
                            21.298936351974298
                        ],
                        [
                            -157.81978799283274,
                            21.29891421773085
                        ],
                        [
                            -157.81977455823116,
                            21.298902462545609
                        ],
                        [
                            -157.819768369206,
                            21.298733367599432
                        ],
                        [
                            -157.81976921966012,
                            21.298733339234744
                        ],
                        [
                            -157.81978094012806,
                            21.298721574360229
                        ],
                        [
                            -157.81977993122229,
                            21.298694002117347
                        ],
                        [
                            -157.81978168706644,
                            21.298693946676465
                        ],
                        [
                            -157.81978170456514,
                            21.298694411142122
                        ],
                        [
                            -157.81978319139554,
                            21.298694363751974
                        ],
                        [
                            -157.81978320716843,
                            21.298694802910578
                        ],
                        [
                            -157.81978908025349,
                            21.298694614636045
                        ],
                        [
                            -157.8197890635239,
                            21.298694174567348
                        ],
                        [
                            -157.81979047321883,
                            21.298694129346366
                        ],
                        [
                            -157.81979045572726,
                            21.298693663977367
                        ],
                        [
                            -157.81981396640359,
                            21.29869290829539
                        ],
                        [
                            -157.81981398293127,
                            21.298693373657631
                        ],
                        [
                            -157.81981546879774,
                            21.298693326260452
                        ],
                        [
                            -157.8198154855346,
                            21.298693765425813
                        ],
                        [
                            -157.81982135861966,
                            21.298693577150154
                        ],
                        [
                            -157.81982134285391,
                            21.298693137088193
                        ],
                        [
                            -157.81982275158489,
                            21.298693091860201
                        ],
                        [
                            -157.81982273505719,
                            21.298692626497964
                        ],
                        [
                            -157.8199122719445,
                            21.298689748298454
                        ],
                        [
                            -157.81991218710976,
                            21.298687454897308
                        ],
                        [
                            -157.81991147637842,
                            21.29866805139935
                        ],
                        [
                            -157.81991204816478,
                            21.298668032823969
                        ],
                        [
                            -157.81991199760964,
                            21.298666637633811
                        ],
                        [
                            -157.81991244694177,
                            21.298666622716727
                        ],
                        [
                            -157.81991219678835,
                            21.298659801264211
                        ],
                        [
                            -157.81991174842736,
                            21.298659815284697
                        ],
                        [
                            -157.81991169689385,
                            21.298658421894476
                        ],
                        [
                            -157.81991112510752,
                            21.298658440469854
                        ],
                        [
                            -157.8199101937719,
                            21.298632981802029
                        ],
                        [
                            -157.81991076458704,
                            21.298632964123229
                        ],
                        [
                            -157.8199107140463,
                            21.298631567126389
                        ],
                        [
                            -157.81991116240718,
                            21.298631553105899
                        ],
                        [
                            -157.81991091418163,
                            21.298624731666859
                        ],
                        [
                            -157.81991046484964,
                            21.298624746583947
                        ],
                        [
                            -157.81991041332336,
                            21.298623352290363
                        ],
                        [
                            -157.81990984058044,
                            21.298623369955646
                        ],
                        [
                            -157.81990904761062,
                            21.29860171011363
                        ],
                        [
                            -157.81984072947481,
                            21.298603906894034
                        ],
                        [
                            -157.81983964691071,
                            21.298574330413061
                        ],
                        [
                            -157.81981491458191,
                            21.298575125412164
                        ],
                        [
                            -157.81981512901456,
                            21.298580987213029
                        ],
                        [
                            -157.81958343673486,
                            21.298588435043914
                        ],
                        [
                            -157.81958429452237,
                            21.298611870503358
                        ],
                        [
                            -157.81949191225655,
                            21.298614840591402
                        ],
                        [
                            -157.8194950453169,
                            21.298700395615974
                        ],
                        [
                            -157.81949330970787,
                            21.29870045209919
                        ],
                        [
                            -157.81949336036007,
                            21.298701834642522
                        ],
                        [
                            -157.81949288981434,
                            21.298701850313055
                        ],
                        [
                            -157.81949309255299,
                            21.298707364226242
                        ],
                        [
                            -157.8194935621276,
                            21.298707349452275
                        ],
                        [
                            -157.81949361037866,
                            21.298708670548169
                        ],
                        [
                            -157.81949534598778,
                            21.298708614064974
                        ],
                        [
                            -157.81949614967152,
                            21.298730614559819
                        ],
                        [
                            -157.81949441309823,
                            21.298730671036264
                        ],
                        [
                            -157.81949446374321,
                            21.298732054482933
                        ],
                        [
                            -157.81949399416851,
                            21.298732069256882
                        ],
                        [
                            -157.81949419594326,
                            21.298737583163298
                        ],
                        [
                            -157.81949466648192,
                            21.298737568396088
                        ],
                        [
                            -157.81949471474019,
                            21.298738888588645
                        ],
                        [
                            -157.81949645130635,
                            21.298738833015538
                        ],
                        [
                            -157.81949860209829,
                            21.298797591093034
                        ],
                        [
                            -157.81947020085784,
                            21.298798503943267
                        ],
                        [
                            -157.81946775365589,
                            21.298798582536289
                        ],
                        [
                            -157.81946963387327,
                            21.29884993904091
                        ],
                        [
                            -157.81945937740758,
                            21.298850269103262
                        ],
                        [
                            -157.81946176097023,
                            21.298915365196123
                        ],
                        [
                            -157.81950286397944,
                            21.298914043677421
                        ],
                        [
                            -157.81950291468939,
                            21.298915418994003
                        ],
                        [
                            -157.81950120222646,
                            21.298915473832761
                        ],
                        [
                            -157.81950130267526,
                            21.298918225362495
                        ],
                        [
                            -157.81950301513822,
                            21.298918170523716
                        ],
                        [
                            -157.81950390627574,
                            21.298942497862978
                        ],
                        [
                            -157.81950219284857,
                            21.298942552694974
                        ],
                        [
                            -157.8195022942613,
                            21.298945304231459
                        ],
                        [
                            -157.81950400673179,
                            21.29894524848935
                        ],
                        [
                            -157.81950723836036,
                            21.299033549607191
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 72,
                "NUMBER": "1056",
                "PROPER_NAME": "HEMENWAY HALL",
                "DISPLAY_NAME": "HEMENWAY HALL (HEM) - 1056",
                "ADDRESS": "2445 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HEMENWAY HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1056_01.jpg",
                "HEIGHT (ft)": 40.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 226.69870491166736,
                "SHAPE_Area": 1733.216123683618
            }
        },
        {
            "type": "Feature",
            "id": 73,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81813846653719,
                            21.299519894164018
                        ],
                        [
                            -157.81813925538512,
                            21.299541675027459
                        ],
                        [
                            -157.81816347483854,
                            21.299540904684932
                        ],
                        [
                            -157.8181889188628,
                            21.299540095058802
                        ],
                        [
                            -157.81821289532684,
                            21.299539332940043
                        ],
                        [
                            -157.818212106468,
                            21.299517552076416
                        ],
                        [
                            -157.81826323845451,
                            21.299515925484265
                        ],
                        [
                            -157.81825331766345,
                            21.299241941496863
                        ],
                        [
                            -157.81820340841256,
                            21.299243528796566
                        ],
                        [
                            -157.8182026117498,
                            21.299221518416314
                        ],
                        [
                            -157.81812774740578,
                            21.299223898883138
                        ],
                        [
                            -157.81812854405734,
                            21.299245909263238
                        ],
                        [
                            -157.81807814594373,
                            21.29924751206368
                        ],
                        [
                            -157.81808806736598,
                            21.299521496956292
                        ],
                        [
                            -157.81813846653719,
                            21.299519894164018
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 73,
                "NUMBER": "1062",
                "PROPER_NAME": "MILLER HALL",
                "DISPLAY_NAME": "MILLER HALL - 1062",
                "ADDRESS": "2515 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MILLER HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1062_01.jpg",
                "HEIGHT (ft)": 41.899999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 106.75954473561188,
                "SHAPE_Area": 589.16949943890097
            }
        },
        {
            "type": "Feature",
            "id": 74,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81533852118861,
                            21.299190139613287
                        ],
                        [
                            -157.81533283812996,
                            21.299027347608138
                        ],
                        [
                            -157.81513908692472,
                            21.299033286615789
                        ],
                        [
                            -157.81514424038988,
                            21.299180946725286
                        ],
                        [
                            -157.8151118234598,
                            21.299181940776503
                        ],
                        [
                            -157.81511179126767,
                            21.299181026319417
                        ],
                        [
                            -157.81510396184228,
                            21.299181265699573
                        ],
                        [
                            -157.8151041539293,
                            21.299186765082077
                        ],
                        [
                            -157.8150473915243,
                            21.299188504649038
                        ],
                        [
                            -157.81504720039607,
                            21.299183006176694
                        ],
                        [
                            -157.81503937097065,
                            21.29918324555382
                        ],
                        [
                            -157.81503956305525,
                            21.299188744936284
                        ],
                        [
                            -157.81498329143218,
                            21.299190469869433
                        ],
                        [
                            -157.81498309838574,
                            21.299184970480223
                        ],
                        [
                            -157.81497429123692,
                            21.299185240912056
                        ],
                        [
                            -157.81497448332635,
                            21.299190739391143
                        ],
                        [
                            -157.81491869959342,
                            21.299192449670304
                        ],
                        [
                            -157.81491850847723,
                            21.2991869502947
                        ],
                        [
                            -157.81490970037171,
                            21.299187219813039
                        ],
                        [
                            -157.81490989077713,
                            21.299192687565
                        ],
                        [
                            -157.81490621719738,
                            21.299192789977262
                        ],
                        [
                            -157.814906061795,
                            21.29918824663946
                        ],
                        [
                            -157.8149055573391,
                            21.29918431605206
                        ],
                        [
                            -157.8149043306874,
                            21.299180527631496
                        ],
                        [
                            -157.81490242140475,
                            21.299176996386898
                        ],
                        [
                            -157.81489988550817,
                            21.299173829312679
                        ],
                        [
                            -157.81489680319939,
                            21.299171122732915
                        ],
                        [
                            -157.81489326539213,
                            21.299168959496246
                        ],
                        [
                            -157.81488938049554,
                            21.29916740450674
                        ],
                        [
                            -157.81488526669554,
                            21.299166505572899
                        ],
                        [
                            -157.81488104812826,
                            21.299166289767182
                        ],
                        [
                            -157.81487685392327,
                            21.299166762515888
                        ],
                        [
                            -157.81487281141256,
                            21.299167912971622
                        ],
                        [
                            -157.81486904430437,
                            21.299169701353026
                        ],
                        [
                            -157.81486566385558,
                            21.299172077853804
                        ],
                        [
                            -157.81486277671343,
                            21.299174966436858
                        ],
                        [
                            -157.81486046839143,
                            21.299178281882423
                        ],
                        [
                            -157.81485880911058,
                            21.299181922601957
                        ],
                        [
                            -157.81485784891478,
                            21.299185778734401
                        ],
                        [
                            -157.81485761864187,
                            21.299189731249477
                        ],
                        [
                            -157.81485777033862,
                            21.299194135439148
                        ],
                        [
                            -157.81485795190582,
                            21.299199262550914
                        ],
                        [
                            -157.81485428210192,
                            21.299199374925916
                        ],
                        [
                            -157.81485391760441,
                            21.299188930077538
                        ],
                        [
                            -157.81484511142665,
                            21.299189199606058
                        ],
                        [
                            -157.81484547591631,
                            21.29919964535776
                        ],
                        [
                            -157.81478969121684,
                            21.299201355587137
                        ],
                        [
                            -157.81478932673113,
                            21.299190909835495
                        ],
                        [
                            -157.81478050223154,
                            21.299191180134962
                        ],
                        [
                            -157.81478086671663,
                            21.299201625886607
                        ],
                        [
                            -157.81478891320364,
                            21.299432171588329
                        ],
                        [
                            -157.81478927693516,
                            21.299442591136103
                        ],
                        [
                            -157.81479810145703,
                            21.299442319933533
                        ],
                        [
                            -157.81479773771767,
                            21.299431901289104
                        ],
                        [
                            -157.81485354179009,
                            21.299430190293567
                        ],
                        [
                            -157.81485390552618,
                            21.299440609841419
                        ],
                        [
                            -157.81486269147652,
                            21.299440340170602
                        ],
                        [
                            -157.8148623277398,
                            21.299429920622746
                        ],
                        [
                            -157.81486599754939,
                            21.29942980824784
                        ],
                        [
                            -157.81486616296019,
                            21.299434545884765
                        ],
                        [
                            -157.81486649794419,
                            21.299441338120602
                        ],
                        [
                            -157.81486737501092,
                            21.299445204481177
                        ],
                        [
                            -157.81486895451059,
                            21.299448868912219
                        ],
                        [
                            -157.81487118720273,
                            21.299452220853397
                        ],
                        [
                            -157.81487400737328,
                            21.299455160469048
                        ],
                        [
                            -157.81487732705818,
                            21.299457597704098
                        ],
                        [
                            -157.81488104949491,
                            21.299459457799156
                        ],
                        [
                            -157.81488505752625,
                            21.299460684822392
                        ],
                        [
                            -157.81488923287907,
                            21.299461241805322
                        ],
                        [
                            -157.81489344746697,
                            21.299461113391661
                        ],
                        [
                            -157.81489757499395,
                            21.29946030140221
                        ],
                        [
                            -157.8149014889828,
                            21.299458830241232
                        ],
                        [
                            -157.81490507338569,
                            21.299456746067779
                        ],
                        [
                            -157.81490821588019,
                            21.299454111328171
                        ],
                        [
                            -157.81491082520537,
                            21.299451006684873
                        ],
                        [
                            -157.81491281964537,
                            21.299447524611587
                        ],
                        [
                            -157.81491413954609,
                            21.299443771288235
                        ],
                        [
                            -157.81491474640902,
                            21.299439859367457
                        ],
                        [
                            -157.81491461101396,
                            21.299433181460842
                        ],
                        [
                            -157.81491825937104,
                            21.299433099648979
                        ],
                        [
                            -157.81491847433168,
                            21.299438630810986
                        ],
                        [
                            -157.81492728245948,
                            21.299438360389576
                        ],
                        [
                            -157.81492709043718,
                            21.299432853780605
                        ],
                        [
                            -157.81498287329714,
                            21.299431143496147
                        ],
                        [
                            -157.81498306627822,
                            21.299436651015274
                        ],
                        [
                            -157.81499187344204,
                            21.299436380583664
                        ],
                        [
                            -157.81499168141733,
                            21.299430873974654
                        ],
                        [
                            -157.81504795312489,
                            21.299429149946363
                        ],
                        [
                            -157.8150481461229,
                            21.29943465565885
                        ],
                        [
                            -157.81505597459778,
                            21.29943441627514
                        ],
                        [
                            -157.81505578354182,
                            21.299428908769546
                        ],
                        [
                            -157.81511254411151,
                            21.299427169190523
                        ],
                        [
                            -157.81511273614078,
                            21.299432675799604
                        ],
                        [
                            -157.8151529642501,
                            21.299431442240405
                        ],
                        [
                            -157.81515808070915,
                            21.299578067702114
                        ],
                        [
                            -157.81535185287999,
                            21.299572127945357
                        ],
                        [
                            -157.81534613958476,
                            21.299408416986303
                        ],
                        [
                            -157.81534606139115,
                            21.299405664710555
                        ],
                        [
                            -157.81533863506183,
                            21.299192890333465
                        ],
                        [
                            -157.81533852118861,
                            21.299190139613287
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 74,
                "NUMBER": "1183",
                "PROPER_NAME": "KENNEDY THEATRE",
                "DISPLAY_NAME": "KENNEDY THEATRE (KT) - 1183",
                "ADDRESS": "1770 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KENNEDY THEATRE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1183_01.jpg",
                "HEIGHT (ft)": 82.900000000000006,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 260.90931193038352,
                "SHAPE_Area": 2246.99724340274
            }
        },
        {
            "type": "Feature",
            "id": 75,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81397013576844,
                            21.299052535459339
                        ],
                        [
                            -157.81399043697564,
                            21.299629420436979
                        ],
                        [
                            -157.81436516771828,
                            21.299617838871875
                        ],
                        [
                            -157.81434486505213,
                            21.299040952967225
                        ],
                        [
                            -157.81397013576844,
                            21.299052535459339
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 75,
                "NUMBER": "1181",
                "PROPER_NAME": "JEFFERSON HALL",
                "DISPLAY_NAME": "JEFFERSON HALL - 1181",
                "ADDRESS": "1777 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "JEFFERSON HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1181_01.jpg",
                "HEIGHT (ft)": 40.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 205.57977252845484,
                "SHAPE_Area": 2485.2034783419695
            }
        },
        {
            "type": "Feature",
            "id": 76,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81951617685587,
                            21.299650108777062
                        ],
                        [
                            -157.81954626942445,
                            21.299649153585939
                        ],
                        [
                            -157.81961893166715,
                            21.299646846485452
                        ],
                        [
                            -157.81961912577347,
                            21.299652234766256
                        ],
                        [
                            -157.81969399030265,
                            21.299649859064942
                        ],
                        [
                            -157.81968825498384,
                            21.299491199672001
                        ],
                        [
                            -157.81961167902949,
                            21.299493630220887
                        ],
                        [
                            -157.81961187409956,
                            21.299499018508538
                        ],
                        [
                            -157.81943816969761,
                            21.299504532115822
                        ],
                        [
                            -157.81943797559055,
                            21.299499144738387
                        ],
                        [
                            -157.81936139867005,
                            21.299501575166197
                        ],
                        [
                            -157.81936403307157,
                            21.299574483730506
                        ],
                        [
                            -157.81935461449788,
                            21.299574783527103
                        ],
                        [
                            -157.81935369475588,
                            21.299549333977634
                        ],
                        [
                            -157.81935467345318,
                            21.299549301997974
                        ],
                        [
                            -157.8193540853247,
                            21.299533023287609
                        ],
                        [
                            -157.81932362540115,
                            21.299533991225612
                        ],
                        [
                            -157.81932421353346,
                            21.299550269032586
                        ],
                        [
                            -157.81932519222354,
                            21.299550237956435
                        ],
                        [
                            -157.81932611196063,
                            21.299575687505829
                        ],
                        [
                            -157.81932513422709,
                            21.299575719492076
                        ],
                        [
                            -157.81932559752403,
                            21.299588558118032
                        ],
                        [
                            -157.81932657621437,
                            21.299588527041884
                        ],
                        [
                            -157.81932759152983,
                            21.299616613355887
                        ],
                        [
                            -157.8193405574888,
                            21.299616202036312
                        ],
                        [
                            -157.81933954313482,
                            21.299588115729033
                        ],
                        [
                            -157.81934113314333,
                            21.29958806545347
                        ],
                        [
                            -157.81934066888834,
                            21.29957522591739
                        ],
                        [
                            -157.81933907887995,
                            21.299575276192961
                        ],
                        [
                            -157.81933803526877,
                            21.299546387469345
                        ],
                        [
                            -157.81934060300298,
                            21.29954630611077
                        ],
                        [
                            -157.8193416475786,
                            21.299575194841154
                        ],
                        [
                            -157.81934128020649,
                            21.299575206718053
                        ],
                        [
                            -157.81934150769419,
                            21.299581483266095
                        ],
                        [
                            -157.81934157081628,
                            21.29958323538359
                        ],
                        [
                            -157.81934174446874,
                            21.299588045350788
                        ],
                        [
                            -157.81934211183366,
                            21.299588034377233
                        ],
                        [
                            -157.81936449732137,
                            21.299587324169952
                        ],
                        [
                            -157.81936713268763,
                            21.299660232740379
                        ],
                        [
                            -157.81944370969057,
                            21.299657802313799
                        ],
                        [
                            -157.81944351461948,
                            21.299652414929682
                        ],
                        [
                            -157.81951617685587,
                            21.299650108777062
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 76,
                "NUMBER": "1030",
                "PROPER_NAME": "DEAN HALL",
                "DISPLAY_NAME": "DEAN HALL (DEAN) - 1030",
                "ADDRESS": "2450 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "DEAN HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1030_01.jpg",
                "HEIGHT (ft)": 36.200000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 138.98476228851888,
                "SHAPE_Area": 597.60978203198931
            }
        },
        {
            "type": "Feature",
            "id": 77,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81596103548461,
                            21.299462698198433
                        ],
                        [
                            -157.81596825481606,
                            21.299656659832838
                        ],
                        [
                            -157.81600593034341,
                            21.299655428890404
                        ],
                        [
                            -157.81600126196915,
                            21.299530018170731
                        ],
                        [
                            -157.81603551347482,
                            21.299528898639046
                        ],
                        [
                            -157.8160356744082,
                            21.299531913480138
                        ],
                        [
                            -157.81615796332815,
                            21.299527917152083
                        ],
                        [
                            -157.81615007944956,
                            21.299316037518366
                        ],
                        [
                            -157.8161243807323,
                            21.299316877567509
                        ],
                        [
                            -157.81612345218474,
                            21.299292115439492
                        ],
                        [
                            -157.81612785871252,
                            21.299291972987273
                        ],
                        [
                            -157.81612775639894,
                            21.299289221445008
                        ],
                        [
                            -157.81612334987122,
                            21.299289363897213
                        ],
                        [
                            -157.81612140490725,
                            21.299237090007072
                        ],
                        [
                            -157.81612581142616,
                            21.299236948458184
                        ],
                        [
                            -157.81612570814141,
                            21.299234197812442
                        ],
                        [
                            -157.81612130162259,
                            21.299234339361348
                        ],
                        [
                            -157.81611935665904,
                            21.299182065470916
                        ],
                        [
                            -157.81612376317634,
                            21.299181923922003
                        ],
                        [
                            -157.81612366085551,
                            21.299179173283029
                        ],
                        [
                            -157.81611925433833,
                            21.299179314831942
                        ],
                        [
                            -157.81611730841129,
                            21.299127040934454
                        ],
                        [
                            -157.81612171492691,
                            21.299126899385502
                        ],
                        [
                            -157.81612161261339,
                            21.299124147843173
                        ],
                        [
                            -157.81611720609783,
                            21.299124289392132
                        ],
                        [
                            -157.81611526112786,
                            21.299072016404455
                        ],
                        [
                            -157.81611966669243,
                            21.299071873042024
                        ],
                        [
                            -157.81611956437888,
                            21.299069121499695
                        ],
                        [
                            -157.81611515785053,
                            21.29906926485533
                        ],
                        [
                            -157.81611321288102,
                            21.299016991867383
                        ],
                        [
                            -157.81611761842944,
                            21.299016850311599
                        ],
                        [
                            -157.81611751707987,
                            21.299014098776038
                        ],
                        [
                            -157.81611311056761,
                            21.299014240325025
                        ],
                        [
                            -157.81611117531324,
                            21.298962198672971
                        ],
                        [
                            -157.81611557991781,
                            21.29896205440037
                        ],
                        [
                            -157.81611545129397,
                            21.298958616096495
                        ],
                        [
                            -157.81604156623493,
                            21.298961028726001
                        ],
                        [
                            -157.81604023421383,
                            21.298925263178518
                        ],
                        [
                            -157.81595413429685,
                            21.298928076763936
                        ],
                        [
                            -157.81595546532589,
                            21.298963843207673
                        ],
                        [
                            -157.81591532925481,
                            21.298965155303293
                        ],
                        [
                            -157.81591539649736,
                            21.298966989658052
                        ],
                        [
                            -157.81591968538783,
                            21.298966849996795
                        ],
                        [
                            -157.81592373010494,
                            21.299075522843022
                        ],
                        [
                            -157.81590412151238,
                            21.29907616360078
                        ],
                        [
                            -157.81590832016664,
                            21.299188963310694
                        ],
                        [
                            -157.815927928767,
                            21.299188323456512
                        ],
                        [
                            -157.81593805866984,
                            21.29946069452593
                        ],
                        [
                            -157.81593366176187,
                            21.29946083884743
                        ],
                        [
                            -157.81593376407906,
                            21.299463589486276
                        ],
                        [
                            -157.81596103548461,
                            21.299462698198433
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 77,
                "NUMBER": "1159",
                "PROPER_NAME": "PHYSICAL SCIENCE BUILDING",
                "DISPLAY_NAME": "PHYSICAL SCIENCE BUILDING (PHYSCI) - 1159",
                "ADDRESS": "2565 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PHYSICAL SCIENCE BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "PSB , ",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1159_01.jpg",
                "HEIGHT (ft)": 49.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 219.32615210913389,
                "SHAPE_Area": 1412.2744626269407
            }
        },
        {
            "type": "Feature",
            "id": 78,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81655876374259,
                            21.299719195051043
                        ],
                        [
                            -157.81656072209563,
                            21.299719132034511
                        ],
                        [
                            -157.81655981663903,
                            21.299694366455871
                        ],
                        [
                            -157.81694635625132,
                            21.299681958790554
                        ],
                        [
                            -157.81694277005167,
                            21.299583832635967
                        ],
                        [
                            -157.81697909256627,
                            21.299582667847652
                        ],
                        [
                            -157.81697803486708,
                            21.299553549567452
                        ],
                        [
                            -157.81698476325579,
                            21.29955333397945
                        ],
                        [
                            -157.81699552116191,
                            21.299552988623908
                        ],
                        [
                            -157.81699149825437,
                            21.299442938260988
                        ],
                        [
                            -157.81698074036345,
                            21.299443282713312
                        ],
                        [
                            -157.81697981041293,
                            21.299417834901668
                        ],
                        [
                            -157.81693675278723,
                            21.299419217941267
                        ],
                        [
                            -157.81692956393286,
                            21.299222734242274
                        ],
                        [
                            -157.81679696630152,
                            21.299226992016038
                        ],
                        [
                            -157.81679291039333,
                            21.299116024477446
                        ],
                        [
                            -157.81679279932303,
                            21.299113883565227
                        ],
                        [
                            -157.81671649656113,
                            21.299116050932678
                        ],
                        [
                            -157.81671553301004,
                            21.29908625667419
                        ],
                        [
                            -157.81669107709524,
                            21.299086951973667
                        ],
                        [
                            -157.81669211486613,
                            21.299119034137799
                        ],
                        [
                            -157.81668771811994,
                            21.299119159509392
                        ],
                        [
                            -157.81669177577965,
                            21.299230380008925
                        ],
                        [
                            -157.81655477549566,
                            21.299234777375347
                        ],
                        [
                            -157.81634194680876,
                            21.299242166342282
                        ],
                        [
                            -157.81634436887316,
                            21.299308541893613
                        ],
                        [
                            -157.81631794516181,
                            21.299309392230878
                        ],
                        [
                            -157.81631851627643,
                            21.299324985146345
                        ],
                        [
                            -157.81629406346269,
                            21.299325769843843
                        ],
                        [
                            -157.81629513656236,
                            21.29935511498293
                        ],
                        [
                            -157.81631959227272,
                            21.299354330305828
                        ],
                        [
                            -157.81632016342357,
                            21.299369918704532
                        ],
                        [
                            -157.81634658714577,
                            21.299369068367429
                        ],
                        [
                            -157.816349022737,
                            21.299435560550354
                        ],
                        [
                            -157.81636663725516,
                            21.299434996056618
                        ],
                        [
                            -157.81636665383704,
                            21.299435453288616
                        ],
                        [
                            -157.81637007877393,
                            21.299435343675526
                        ],
                        [
                            -157.81637006219927,
                            21.299434885540208
                        ],
                        [
                            -157.81642705774402,
                            21.299433055927299
                        ],
                        [
                            -157.81642707527556,
                            21.299433514972741
                        ],
                        [
                            -157.81643049925572,
                            21.299433404448298
                        ],
                        [
                            -157.81643048268811,
                            21.299432945409638
                        ],
                        [
                            -157.81648479381525,
                            21.299431202594374
                        ],
                        [
                            -157.81648481039028,
                            21.299431660729702
                        ],
                        [
                            -157.81648823629104,
                            21.299431551120978
                        ],
                        [
                            -157.81648821971601,
                            21.29943109298565
                        ],
                        [
                            -157.81654522104353,
                            21.299429263373248
                        ],
                        [
                            -157.81654523762597,
                            21.299429720605243
                        ],
                        [
                            -157.81669838602801,
                            21.299424804424532
                        ],
                        [
                            -157.81670337178531,
                            21.299561217059161
                        ],
                        [
                            -157.81636136445272,
                            21.299572196564025
                        ],
                        [
                            -157.81636250479852,
                            21.299603377863942
                        ],
                        [
                            -157.81637424718863,
                            21.299603000626828
                        ],
                        [
                            -157.81637840318788,
                            21.299716716973879
                        ],
                        [
                            -157.81655846355449,
                            21.299710936858325
                        ],
                        [
                            -157.81655876374259,
                            21.299719195051043
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 78,
                "NUMBER": "1126",
                "PROPER_NAME": "BILGER HALL",
                "DISPLAY_NAME": "BILGER HALL (BIL) - 1126",
                "ADDRESS": "2545 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BILGER HALL AND ADDITION",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1126_01.jpg",
                "HEIGHT (ft)": 46.800000000000004,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 353.88091120388367,
                "SHAPE_Area": 2828.5324990753284
            }
        },
        {
            "type": "Feature",
            "id": 79,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81710499776179,
                            21.299727499975415
                        ],
                        [
                            -157.81710461786551,
                            21.29972751085597
                        ],
                        [
                            -157.81710480613489,
                            21.299733014728925
                        ],
                        [
                            -157.817194867735,
                            21.299730296171266
                        ],
                        [
                            -157.81727635312433,
                            21.299648872655418
                        ],
                        [
                            -157.81787623779172,
                            21.299630863251171
                        ],
                        [
                            -157.81787603463246,
                            21.299624927452687
                        ],
                        [
                            -157.81787473298397,
                            21.299622671577502
                        ],
                        [
                            -157.81787412047439,
                            21.299604761174216
                        ],
                        [
                            -157.81787534406018,
                            21.299604724599664
                        ],
                        [
                            -157.81787513993706,
                            21.299598788794377
                        ],
                        [
                            -157.81787383925268,
                            21.299596532925975
                        ],
                        [
                            -157.81787321797515,
                            21.299578392999894
                        ],
                        [
                            -157.81787444156072,
                            21.299578356425322
                        ],
                        [
                            -157.81787423840152,
                            21.299572420626806
                        ],
                        [
                            -157.81787293675345,
                            21.299570164751614
                        ],
                        [
                            -157.81787231643267,
                            21.299552025735615
                        ],
                        [
                            -157.81787353906134,
                            21.299551988250926
                        ],
                        [
                            -157.81787333590216,
                            21.299546052452396
                        ],
                        [
                            -157.81787203425429,
                            21.299543796577201
                        ],
                        [
                            -157.81787142250653,
                            21.29952591147406
                        ],
                        [
                            -157.81787264512775,
                            21.299525874892709
                        ],
                        [
                            -157.81787244121415,
                            21.299519912890553
                        ],
                        [
                            -157.81787113956653,
                            21.299517657015357
                        ],
                        [
                            -157.81787052705718,
                            21.299499746611875
                        ],
                        [
                            -157.8178717506421,
                            21.29949971003731
                        ],
                        [
                            -157.81787154748295,
                            21.29949377423873
                        ],
                        [
                            -157.81787024487161,
                            21.299491518356778
                        ],
                        [
                            -157.81786961674689,
                            21.299473149824639
                        ],
                        [
                            -157.81787084033886,
                            21.29947311234671
                        ],
                        [
                            -157.81787065202624,
                            21.299467610279816
                        ],
                        [
                            -157.81785401444378,
                            21.29946812126645
                        ],
                        [
                            -157.8178540300519,
                            21.299468580298399
                        ],
                        [
                            -157.81777573596165,
                            21.29947093289752
                        ],
                        [
                            -157.81777572035372,
                            21.299470473865558
                        ],
                        [
                            -157.81777376299661,
                            21.299470533289831
                        ],
                        [
                            -157.81777125165718,
                            21.2993971612526
                        ],
                        [
                            -157.81777320997728,
                            21.299397101835098
                        ],
                        [
                            -157.81777302167549,
                            21.299391598864862
                        ],
                        [
                            -157.81777106431943,
                            21.299391658289149
                        ],
                        [
                            -157.81776855298784,
                            21.29931828534799
                        ],
                        [
                            -157.81777051130686,
                            21.29931822593047
                        ],
                        [
                            -157.81777049472785,
                            21.299317767795085
                        ],
                        [
                            -157.81778811088046,
                            21.29931723839541
                        ],
                        [
                            -157.8177881274523,
                            21.299317697434141
                        ],
                        [
                            -157.81786348447565,
                            21.29931543260178
                        ],
                        [
                            -157.81786350875788,
                            21.299316132899921
                        ],
                        [
                            -157.81786546611301,
                            21.299316073474508
                        ],
                        [
                            -157.81786523866447,
                            21.299309438281043
                        ],
                        [
                            -157.81786393702586,
                            21.299307181502492
                        ],
                        [
                            -157.81786332450244,
                            21.299289272905305
                        ],
                        [
                            -157.81786454712895,
                            21.299289235420602
                        ],
                        [
                            -157.81786434398438,
                            21.299283297815215
                        ],
                        [
                            -157.81786304233154,
                            21.299281042843351
                        ],
                        [
                            -157.81786242201852,
                            21.299262902923463
                        ],
                        [
                            -157.81786364463758,
                            21.299262866342076
                        ],
                        [
                            -157.81786343388401,
                            21.299256674830534
                        ],
                        [
                            -157.81786213297136,
                            21.299254447868954
                        ],
                        [
                            -157.81786151952025,
                            21.299236534748211
                        ],
                        [
                            -157.81786274213906,
                            21.299236498166838
                        ],
                        [
                            -157.817862539944,
                            21.299230562374884
                        ],
                        [
                            -157.81786123734213,
                            21.299228305589555
                        ],
                        [
                            -157.81786062579002,
                            21.299210396095653
                        ],
                        [
                            -157.81786184840863,
                            21.29921035951428
                        ],
                        [
                            -157.81786164622082,
                            21.299204422818974
                        ],
                        [
                            -157.81786034361195,
                            21.299202166936976
                        ],
                        [
                            -157.817859730132,
                            21.299184257429495
                        ],
                        [
                            -157.81786095372158,
                            21.299184219951542
                        ],
                        [
                            -157.81786075056982,
                            21.299178283249436
                        ],
                        [
                            -157.81785944891789,
                            21.299176028277561
                        ],
                        [
                            -157.81785882079379,
                            21.299157659744832
                        ],
                        [
                            -157.81786004341919,
                            21.29915762226009
                        ],
                        [
                            -157.81785985607792,
                            21.299152119296448
                        ],
                        [
                            -157.81785716399742,
                            21.299152200662594
                        ],
                        [
                            -157.8178543950286,
                            21.299071260917984
                        ],
                        [
                            -157.81792357546303,
                            21.299002132488532
                        ],
                        [
                            -157.81792804549207,
                            21.298997665001263
                        ],
                        [
                            -157.81792515938383,
                            21.298913287031471
                        ],
                        [
                            -157.81792320204127,
                            21.298913345554482
                        ],
                        [
                            -157.81792295031451,
                            21.298906009159165
                        ],
                        [
                            -157.81792099297928,
                            21.29890606677883
                        ],
                        [
                            -157.81792124372757,
                            21.298913404974034
                        ],
                        [
                            -157.81789481957421,
                            21.298914198645512
                        ],
                        [
                            -157.81789456881998,
                            21.298906861353672
                        ],
                        [
                            -157.81789310128789,
                            21.298906906152386
                        ],
                        [
                            -157.81789335204925,
                            21.298914242540903
                        ],
                        [
                            -157.81786692788859,
                            21.298915037111311
                        ],
                        [
                            -157.81786667713575,
                            21.298907699819491
                        ],
                        [
                            -157.81786520864694,
                            21.298907743707851
                        ],
                        [
                            -157.81786546036361,
                            21.298915081006456
                        ],
                        [
                            -157.81784099355269,
                            21.298915816147119
                        ],
                        [
                            -157.81784036522799,
                            21.298897472907431
                        ],
                        [
                            -157.81766983229028,
                            21.298902597755855
                        ],
                        [
                            -157.81766936202661,
                            21.298888840333113
                        ],
                        [
                            -157.81741441837002,
                            21.29889650212726
                        ],
                        [
                            -157.81741488957383,
                            21.298910259556386
                        ],
                        [
                            -157.81735983901274,
                            21.298911913468586
                        ],
                        [
                            -157.81736003606665,
                            21.298917645961581
                        ],
                        [
                            -157.81733556925664,
                            21.298918381028614
                        ],
                        [
                            -157.81733538878137,
                            21.298913106671019
                        ],
                        [
                            -157.81732951673965,
                            21.298913284026057
                        ],
                        [
                            -157.81732969625801,
                            21.298918557473527
                        ],
                        [
                            -157.81731991049506,
                            21.298918851867111
                        ],
                        [
                            -157.81731921199872,
                            21.298898443888014
                        ],
                        [
                            -157.8171900282091,
                            21.298902326676018
                        ],
                        [
                            -157.8171907257381,
                            21.298922732841366
                        ],
                        [
                            -157.81710655990122,
                            21.298925262492123
                        ],
                        [
                            -157.81710636478499,
                            21.298919530012839
                        ],
                        [
                            -157.8170770075038,
                            21.298920412249469
                        ],
                        [
                            -157.81707873031607,
                            21.298970856120256
                        ],
                        [
                            -157.81707911021761,
                            21.298970844336317
                        ],
                        [
                            -157.81708071104717,
                            21.299017619585001
                        ],
                        [
                            -157.81708033018882,
                            21.299017630458827
                        ],
                        [
                            -157.81708051845777,
                            21.299023134332177
                        ],
                        [
                            -157.81708089835945,
                            21.29902312254826
                        ],
                        [
                            -157.8170834093518,
                            21.299096495486076
                        ],
                        [
                            -157.81708302945714,
                            21.299096506366652
                        ],
                        [
                            -157.81708321676945,
                            21.299102009329864
                        ],
                        [
                            -157.81708359762803,
                            21.299101998456049
                        ],
                        [
                            -157.81708422491596,
                            21.299120338977016
                        ],
                        [
                            -157.81707852343015,
                            21.299120523845492
                        ],
                        [
                            -157.81708055675833,
                            21.299175530211755
                        ],
                        [
                            -157.81706223958315,
                            21.299176088035757
                        ],
                        [
                            -157.81706493787632,
                            21.299254963935354
                        ],
                        [
                            -157.81702921683524,
                            21.299256024566589
                        ],
                        [
                            -157.81703240175995,
                            21.299349132281822
                        ],
                        [
                            -157.81706861287395,
                            21.299348028119301
                        ],
                        [
                            -157.81707052371851,
                            21.29941821690252
                        ],
                        [
                            -157.81709439182436,
                            21.299417501157272
                        ],
                        [
                            -157.81709690186304,
                            21.299490873182037
                        ],
                        [
                            -157.81709652196739,
                            21.2994908840626
                        ],
                        [
                            -157.81709671023663,
                            21.299496387935704
                        ],
                        [
                            -157.81709709110345,
                            21.299496376158579
                        ],
                        [
                            -157.81709960113551,
                            21.299569749086093
                        ],
                        [
                            -157.81709922027574,
                            21.299569759959876
                        ],
                        [
                            -157.81709940951617,
                            21.299575262936372
                        ],
                        [
                            -157.81709978941203,
                            21.299575252055796
                        ],
                        [
                            -157.81710229945193,
                            21.299648624079399
                        ],
                        [
                            -157.81710191954866,
                            21.299648635863296
                        ],
                        [
                            -157.81710210782521,
                            21.29965413883297
                        ],
                        [
                            -157.8171024877285,
                            21.29965412704906
                        ],
                        [
                            -157.81710499776179,
                            21.299727499975415
                        ]
                    ],
                    [
                        [
                            -157.81737340771397,
                            21.299251202974254
                        ],
                        [
                            -157.81740969678202,
                            21.299250111932512
                        ],
                        [
                            -157.81744567111349,
                            21.299281731337977
                        ],
                        [
                            -157.81744382674415,
                            21.299283573038135
                        ],
                        [
                            -157.81744863885086,
                            21.299424185224488
                        ],
                        [
                            -157.8174764153537,
                            21.299448598491814
                        ],
                        [
                            -157.81760046133502,
                            21.29944487001988
                        ],
                        [
                            -157.8176015725038,
                            21.299477321283927
                        ],
                        [
                            -157.81754734693155,
                            21.299531505061772
                        ],
                        [
                            -157.81741080467211,
                            21.299535609118166
                        ],
                        [
                            -157.81739957327204,
                            21.29952573653917
                        ],
                        [
                            -157.81743641428233,
                            21.299488923900626
                        ],
                        [
                            -157.81740915373626,
                            21.299464964140839
                        ],
                        [
                            -157.81738075091502,
                            21.29946581790113
                        ],
                        [
                            -157.81737340771397,
                            21.299251202974254
                        ]
                    ],
                    [
                        [
                            -157.81743046111163,
                            21.29922936332909
                        ],
                        [
                            -157.81742929784264,
                            21.29919535606032
                        ],
                        [
                            -157.81765683817008,
                            21.299188518056141
                        ],
                        [
                            -157.81765769844392,
                            21.299213652806667
                        ],
                        [
                            -157.81768653271234,
                            21.299238994929286
                        ],
                        [
                            -157.81772437933483,
                            21.299201177488428
                        ],
                        [
                            -157.81773448022909,
                            21.299210055601723
                        ],
                        [
                            -157.81773887359319,
                            21.299338457335868
                        ],
                        [
                            -157.81768298351909,
                            21.299394304354632
                        ],
                        [
                            -157.81765007590911,
                            21.299395293639851
                        ],
                        [
                            -157.81764609825063,
                            21.299279043621407
                        ],
                        [
                            -157.81761832174146,
                            21.29925463128513
                        ],
                        [
                            -157.81746827981894,
                            21.299259140126377
                        ],
                        [
                            -157.81746643545014,
                            21.299260981826837
                        ],
                        [
                            -157.81743046111163,
                            21.29922936332909
                        ]
                    ],
                    [
                        [
                            -157.81733552627981,
                            21.299088919136683
                        ],
                        [
                            -157.8171769811587,
                            21.299093683251481
                        ],
                        [
                            -157.8171744710765,
                            21.299020311222971
                        ],
                        [
                            -157.81733301515482,
                            21.299015547100087
                        ],
                        [
                            -157.81733552627981,
                            21.299088919136683
                        ]
                    ],
                    [
                        [
                            -157.81726683076548,
                            21.29954360684253
                        ],
                        [
                            -157.81718853663327,
                            21.299545960069423
                        ],
                        [
                            -157.81718403448755,
                            21.299414347832496
                        ],
                        [
                            -157.81726232758595,
                            21.299411994597651
                        ],
                        [
                            -157.81726683076548,
                            21.29954360684253
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 79,
                "NUMBER": "1049",
                "PROPER_NAME": "ART BUILDING",
                "DISPLAY_NAME": "ART BUILDING (ART) - 1049",
                "ADDRESS": "2535 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ART BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1049_01.jpg",
                "HEIGHT (ft)": 36.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 702.55290848246443,
                "SHAPE_Area": 5826.8063868797462
            }
        },
        {
            "type": "Feature",
            "id": 80,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81369399347182,
                            21.299786629251319
                        ],
                        [
                            -157.81369410383388,
                            21.299787771913437
                        ],
                        [
                            -157.81373641290054,
                            21.299784182872987
                        ],
                        [
                            -157.81372937279366,
                            21.299711299285828
                        ],
                        [
                            -157.81368916182672,
                            21.29971471159698
                        ],
                        [
                            -157.81368767191825,
                            21.299699288368252
                        ],
                        [
                            -157.81368645261531,
                            21.299699391793276
                        ],
                        [
                            -157.81368714867551,
                            21.299706589486121
                        ],
                        [
                            -157.81364129843649,
                            21.299710479674825
                        ],
                        [
                            -157.81364060430636,
                            21.299703281995484
                        ],
                        [
                            -157.8136393850034,
                            21.299703385420163
                        ],
                        [
                            -157.81364706498638,
                            21.299782894460737
                        ],
                        [
                            -157.8136941335876,
                            21.299778900839701
                        ],
                        [
                            -157.81369487322644,
                            21.299786554147932
                        ],
                        [
                            -157.81369399347182,
                            21.299786629251319
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 80,
                "NUMBER": "1181A",
                "PROPER_NAME": "JAKUAN TEAHOUSE",
                "DISPLAY_NAME": "JAKUAN TEAHOUSE (JAKUAN) - 1181A",
                "ADDRESS": "1777 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "JEFFERSON HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1181A_01.jpg",
                "HEIGHT (ft)": 15.700000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 39.850452898616169,
                "SHAPE_Area": 74.696093972423483
            }
        },
        {
            "type": "Feature",
            "id": 81,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81550713137506,
                            21.299814928301469
                        ],
                        [
                            -157.81550920788047,
                            21.2998665183434
                        ],
                        [
                            -157.81551263388516,
                            21.299866397011648
                        ],
                        [
                            -157.81551216271171,
                            21.299854702928059
                        ],
                        [
                            -157.81551069510542,
                            21.29985475583559
                        ],
                        [
                            -157.81551065811297,
                            21.299853838634569
                        ],
                        [
                            -157.81556742196298,
                            21.299851830624679
                        ],
                        [
                            -157.81556762446297,
                            21.299856874771777
                        ],
                        [
                            -157.81557104949624,
                            21.299856754335377
                        ],
                        [
                            -157.81557084700339,
                            21.29985170928494
                        ],
                        [
                            -157.81562614324653,
                            21.299849754163201
                        ],
                        [
                            -157.81562634574854,
                            21.299854798310321
                        ],
                        [
                            -157.81562977175295,
                            21.299854676976164
                        ],
                        [
                            -157.81562956828691,
                            21.299849632822262
                        ],
                        [
                            -157.81568486453679,
                            21.299847676777794
                        ],
                        [
                            -157.81568506703354,
                            21.299852721828277
                        ],
                        [
                            -157.81568849303792,
                            21.299852600492937
                        ],
                        [
                            -157.81568828956989,
                            21.299847556339007
                        ],
                        [
                            -157.81574358581921,
                            21.299845600275169
                        ],
                        [
                            -157.81574378832522,
                            21.299850644422339
                        ],
                        [
                            -157.81574721432958,
                            21.29985052308578
                        ],
                        [
                            -157.81574701085952,
                            21.299845478931832
                        ],
                        [
                            -157.81580230710108,
                            21.29984352375196
                        ],
                        [
                            -157.81580250960909,
                            21.299848567899151
                        ],
                        [
                            -157.81580593561341,
                            21.299848446561413
                        ],
                        [
                            -157.81580573214859,
                            21.299843401504095
                        ],
                        [
                            -157.81586102742568,
                            21.299841446298071
                        ],
                        [
                            -157.81586123185633,
                            21.299846491362189
                        ],
                        [
                            -157.81586465689668,
                            21.29984637001645
                        ],
                        [
                            -157.81586445342262,
                            21.299841325862449
                        ],
                        [
                            -157.81591974870642,
                            21.299839369733728
                        ],
                        [
                            -157.81591995314631,
                            21.299844413894537
                        ],
                        [
                            -157.81592337818665,
                            21.299844292547597
                        ],
                        [
                            -157.81592317471055,
                            21.299839248393575
                        ],
                        [
                            -157.81597846999381,
                            21.299837292245464
                        ],
                        [
                            -157.81597894120421,
                            21.299848986329486
                        ],
                        [
                            -157.81598236720859,
                            21.299848864988142
                        ],
                        [
                            -157.8159811131932,
                            21.299817683793258
                        ],
                        [
                            -157.81602855749117,
                            21.299816005741743
                        ],
                        [
                            -157.81602949557271,
                            21.299820562716551
                        ],
                        [
                            -157.81607060084812,
                            21.299819109265538
                        ],
                        [
                            -157.81606756226716,
                            21.299743670187087
                        ],
                        [
                            -157.8160734073131,
                            21.299742775395973
                        ],
                        [
                            -157.81607331481965,
                            21.299740482845014
                        ],
                        [
                            -157.81607257909641,
                            21.29974050838435
                        ],
                        [
                            -157.81607135821633,
                            21.299710242556145
                        ],
                        [
                            -157.81607209491057,
                            21.29971021612025
                        ],
                        [
                            -157.81607200338829,
                            21.299707922672727
                        ],
                        [
                            -157.8160641736302,
                            21.299708200036552
                        ],
                        [
                            -157.8160621475628,
                            21.299657870576794
                        ],
                        [
                            -157.81603352076053,
                            21.299658882432048
                        ],
                        [
                            -157.8160335061597,
                            21.299658539041143
                        ],
                        [
                            -157.81603008112364,
                            21.299658660390531
                        ],
                        [
                            -157.81603009475333,
                            21.299659004677988
                        ],
                        [
                            -157.81600318142924,
                            21.299659956311828
                        ],
                        [
                            -157.81600300291123,
                            21.299655526638439
                        ],
                        [
                            -157.81597118705346,
                            21.299656563925993
                        ],
                        [
                            -157.8159713735439,
                            21.299661081284295
                        ],
                        [
                            -157.81567776843784,
                            21.29967146582073
                        ],
                        [
                            -157.81567865922506,
                            21.299693592493369
                        ],
                        [
                            -157.81562336303298,
                            21.299695548538512
                        ],
                        [
                            -157.81562325301749,
                            21.299692796942207
                        ],
                        [
                            -157.81561982702408,
                            21.299692917373065
                        ],
                        [
                            -157.81561993800344,
                            21.299695668976156
                        ],
                        [
                            -157.81556464181085,
                            21.299697625001908
                        ],
                        [
                            -157.81556453179644,
                            21.299694873405628
                        ],
                        [
                            -157.81556110675967,
                            21.299694994745398
                        ],
                        [
                            -157.815561216774,
                            21.299697746341689
                        ],
                        [
                            -157.81550592058088,
                            21.299699702348089
                        ],
                        [
                            -157.81550581057482,
                            21.299696949848467
                        ],
                        [
                            -157.81550238553803,
                            21.299697071187055
                        ],
                        [
                            -157.81550249555127,
                            21.299699822783317
                        ],
                        [
                            -157.81546750754617,
                            21.299701059881684
                        ],
                        [
                            -157.81546741506213,
                            21.299698767330817
                        ],
                        [
                            -157.81546447890315,
                            21.299698871331728
                        ],
                        [
                            -157.81546458987961,
                            21.299701622934784
                        ],
                        [
                            -157.81546556859931,
                            21.299701588267819
                        ],
                        [
                            -157.81547007396134,
                            21.299813483123653
                        ],
                        [
                            -157.81546909621207,
                            21.299813516894059
                        ],
                        [
                            -157.81546920621741,
                            21.299816269393631
                        ],
                        [
                            -157.81547214334265,
                            21.29981616539952
                        ],
                        [
                            -157.81547210538653,
                            21.299815248191734
                        ],
                        [
                            -157.81550440218217,
                            21.29981410597842
                        ],
                        [
                            -157.81550443917456,
                            21.299815023179434
                        ],
                        [
                            -157.81550713137506,
                            21.299814928301469
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 81,
                "NUMBER": "1158",
                "PROPER_NAME": "KELLER HALL",
                "DISPLAY_NAME": "KELLER HALL (KELL) - 1158",
                "ADDRESS": "2565 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KELLER HALL AND KIOSK",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1158_01.jpg",
                "HEIGHT (ft)": 47.899999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 183.27201384005565,
                "SHAPE_Area": 1131.189244526676
            }
        },
        {
            "type": "Feature",
            "id": 82,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81890933343092,
                            21.300246721265623
                        ],
                        [
                            -157.8189113519548,
                            21.3003019759587
                        ],
                        [
                            -157.8190813714929,
                            21.300296521994252
                        ],
                        [
                            -157.8190793584113,
                            21.30024142272206
                        ],
                        [
                            -157.81907268302061,
                            21.300241636957846
                        ],
                        [
                            -157.81907204560198,
                            21.300224171751132
                        ],
                        [
                            -157.81910246621101,
                            21.300223195458042
                        ],
                        [
                            -157.81910203664992,
                            21.30021144565551
                        ],
                        [
                            -157.81910589069275,
                            21.300211321834091
                        ],
                        [
                            -157.81910533681045,
                            21.300196189768073
                        ],
                        [
                            -157.81910148373194,
                            21.300196313596263
                        ],
                        [
                            -157.81909831833559,
                            21.300109648092647
                        ],
                        [
                            -157.81910217236856,
                            21.300109525174527
                        ],
                        [
                            -157.81910161945763,
                            21.300094392211779
                        ],
                        [
                            -157.81909776638173,
                            21.300094516040009
                        ],
                        [
                            -157.8190973558338,
                            21.300083282206792
                        ],
                        [
                            -157.81906726309859,
                            21.300084247250094
                        ],
                        [
                            -157.81905777740496,
                            21.299826202131808
                        ],
                        [
                            -157.81908786912354,
                            21.299825237080999
                        ],
                        [
                            -157.81908745857604,
                            21.299814003247473
                        ],
                        [
                            -157.81909137432163,
                            21.299813877148768
                        ],
                        [
                            -157.8190908214041,
                            21.299798745088911
                        ],
                        [
                            -157.81908690663005,
                            21.299798870291024
                        ],
                        [
                            -157.81908374123122,
                            21.299712205687285
                        ],
                        [
                            -157.81908765601023,
                            21.299712079581777
                        ],
                        [
                            -157.81908710308568,
                            21.299696948425098
                        ],
                        [
                            -157.81908318928544,
                            21.299697072730677
                        ],
                        [
                            -157.81908275876125,
                            21.299685322920759
                        ],
                        [
                            -157.81886563246408,
                            21.299692288314322
                        ],
                        [
                            -157.8188707416636,
                            21.29983220156139
                        ],
                        [
                            -157.81889575767565,
                            21.299831398763448
                        ],
                        [
                            -157.81890517843354,
                            21.300089331403395
                        ],
                        [
                            -157.81888003895841,
                            21.300090137851416
                        ],
                        [
                            -157.81888515399615,
                            21.300230165864381
                        ],
                        [
                            -157.81891603840174,
                            21.300229174792477
                        ],
                        [
                            -157.81891667028881,
                            21.300246485480436
                        ],
                        [
                            -157.81890933343092,
                            21.300246721265623
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 82,
                "NUMBER": "1002",
                "PROPER_NAME": "HAWAI`I HALL",
                "DISPLAY_NAME": "HAWAI`I HALL - 1002",
                "ADDRESS": "2500 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HAWAII HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1002_01.jpg",
                "HEIGHT (ft)": 37.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 197.90896339908079,
                "SHAPE_Area": 1321.3850609378565
            }
        },
        {
            "type": "Feature",
            "id": 83,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81937786364745,
                            21.300452233861243
                        ],
                        [
                            -157.81946986445882,
                            21.300449613528212
                        ],
                        [
                            -157.81946670943907,
                            21.300352329643932
                        ],
                        [
                            -157.81964092230922,
                            21.300347367971526
                        ],
                        [
                            -157.81964407599943,
                            21.300444591320584
                        ],
                        [
                            -157.81973607680183,
                            21.300441971744878
                        ],
                        [
                            -157.81972841657833,
                            21.300205790646846
                        ],
                        [
                            -157.81963678327537,
                            21.300208401057816
                        ],
                        [
                            -157.81963696104285,
                            21.300213903954344
                        ],
                        [
                            -157.81957953679429,
                            21.300215540118629
                        ],
                        [
                            -157.819519881378,
                            21.300217239207079
                        ],
                        [
                            -157.81946238096387,
                            21.300218876603758
                        ],
                        [
                            -157.81946220465454,
                            21.300213433341334
                        ],
                        [
                            -157.81937020399053,
                            21.300216053677083
                        ],
                        [
                            -157.81937786364745,
                            21.300452233861243
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 83,
                "NUMBER": "1057",
                "PROPER_NAME": "CRAWFORD HALL",
                "DISPLAY_NAME": "CRAWFORD HALL (CR) - 1057",
                "ADDRESS": "2550 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CRAWFORD HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1057_01.jpg",
                "HEIGHT (ft)": 42,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 149.42252282558019,
                "SHAPE_Area": 766.7179884526023
            }
        },
        {
            "type": "Feature",
            "id": 84,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82024690666071,
                            21.30060873861715
                        ],
                        [
                            -157.82009021094484,
                            21.300613718031524
                        ],
                        [
                            -157.82009017777975,
                            21.300612800857319
                        ],
                        [
                            -157.82008767077636,
                            21.30061287994225
                        ],
                        [
                            -157.82008762006117,
                            21.300611504625859
                        ],
                        [
                            -157.82007588147113,
                            21.300611878532493
                        ],
                        [
                            -157.82007589805727,
                            21.300612336667921
                        ],
                        [
                            -157.82003865064792,
                            21.300613522732448
                        ],
                        [
                            -157.82003863309799,
                            21.300613064590259
                        ],
                        [
                            -157.8200268945223,
                            21.300613436686788
                        ],
                        [
                            -157.82002694427297,
                            21.300614811996436
                        ],
                        [
                            -157.82002412474537,
                            21.300614915087365
                        ],
                        [
                            -157.82002432083453,
                            21.300620419015662
                        ],
                        [
                            -157.82002521823088,
                            21.300645180022691
                        ],
                        [
                            -157.82002542021908,
                            21.300650669538104
                        ],
                        [
                            -157.82002444056491,
                            21.300650699707873
                        ],
                        [
                            -157.82002475659706,
                            21.3006594124179
                        ],
                        [
                            -157.82002573528735,
                            21.300659382241353
                        ],
                        [
                            -157.82002679851456,
                            21.300688728215945
                        ],
                        [
                            -157.82002582078081,
                            21.300688759302592
                        ],
                        [
                            -157.82002603636215,
                            21.300694719579869
                        ],
                        [
                            -157.82002701505272,
                            21.300694689403322
                        ],
                        [
                            -157.8200279084879,
                            21.300719342878896
                        ],
                        [
                            -157.82002692979719,
                            21.300719373055422
                        ],
                        [
                            -157.82002733651146,
                            21.300730492130896
                        ],
                        [
                            -157.82003113271043,
                            21.300730370593367
                        ],
                        [
                            -157.82003118154765,
                            21.300731739572846
                        ],
                        [
                            -157.82004292206062,
                            21.300731367489977
                        ],
                        [
                            -157.82004290548181,
                            21.300730908451197
                        ],
                        [
                            -157.82008015292084,
                            21.300729722387118
                        ],
                        [
                            -157.82008016949973,
                            21.300730181425898
                        ],
                        [
                            -157.82009190906311,
                            21.300729807526167
                        ],
                        [
                            -157.82009182610349,
                            21.300727520462367
                        ],
                        [
                            -157.82034081670648,
                            21.300719588054928
                        ],
                        [
                            -157.82034084986591,
                            21.300720506132485
                        ],
                        [
                            -157.82034351212261,
                            21.300720420905048
                        ],
                        [
                            -157.82034356283296,
                            21.300721797124815
                        ],
                        [
                            -157.82035475567838,
                            21.300721440152159
                        ],
                        [
                            -157.82035473813465,
                            21.300720981106622
                        ],
                        [
                            -157.82039198652902,
                            21.300719795883371
                        ],
                        [
                            -157.82039200310891,
                            21.300720254922147
                        ],
                        [
                            -157.82040561330629,
                            21.300719819131643
                        ],
                        [
                            -157.8204055635521,
                            21.30071844382196
                        ],
                        [
                            -157.82040800981497,
                            21.300718366113369
                        ],
                        [
                            -157.82040758859637,
                            21.300707369797163
                        ],
                        [
                            -157.82040664167232,
                            21.30070740561893
                        ],
                        [
                            -157.82040574518325,
                            21.300682643714548
                        ],
                        [
                            -157.82040672291703,
                            21.300682612625693
                        ],
                        [
                            -157.82040650636355,
                            21.300676651438092
                        ],
                        [
                            -157.82040552862981,
                            21.300676682526948
                        ],
                        [
                            -157.82040436486932,
                            21.300644584118409
                        ],
                        [
                            -157.82040534356676,
                            21.3006445530363
                        ],
                        [
                            -157.82040512797724,
                            21.300638591855414
                        ],
                        [
                            -157.82040407388598,
                            21.300638527553001
                        ],
                        [
                            -157.82040325183428,
                            21.300613860122873
                        ],
                        [
                            -157.82040398464147,
                            21.300613838157854
                        ],
                        [
                            -157.82040357004965,
                            21.300602373931508
                        ],
                        [
                            -157.82039965526096,
                            21.300602498259902
                        ],
                        [
                            -157.82039135195197,
                            21.300373686123127
                        ],
                        [
                            -157.8203937982091,
                            21.300373608414475
                        ],
                        [
                            -157.82039359830796,
                            21.300368097232063
                        ],
                        [
                            -157.82039482095814,
                            21.300368057922679
                        ],
                        [
                            -157.8203931761941,
                            21.300322670874674
                        ],
                        [
                            -157.82039709001145,
                            21.300322546539327
                        ],
                        [
                            -157.82039207106305,
                            21.300184068506276
                        ],
                        [
                            -157.81999965583455,
                            21.300196559387931
                        ],
                        [
                            -157.82000467440716,
                            21.300335038318796
                        ],
                        [
                            -157.8200085901525,
                            21.300334914006051
                        ],
                        [
                            -157.820010234726,
                            21.300380310085686
                        ],
                        [
                            -157.82001145834016,
                            21.300380270785844
                        ],
                        [
                            -157.82001165829917,
                            21.300385772934622
                        ],
                        [
                            -157.82001312586073,
                            21.300385726311401
                        ],
                        [
                            -157.82001652426118,
                            21.300479496812173
                        ],
                        [
                            -157.82001554555762,
                            21.3004795287954
                        ],
                        [
                            -157.82001583623935,
                            21.30048755294402
                        ],
                        [
                            -157.82002439572508,
                            21.300487282321114
                        ],
                        [
                            -157.82002431280969,
                            21.300484989837226
                        ],
                        [
                            -157.82011067438233,
                            21.300482240176681
                        ],
                        [
                            -157.82011070658365,
                            21.300483157344143
                        ],
                        [
                            -157.82011780528299,
                            21.300482929774436
                        ],
                        [
                            -157.82011756434724,
                            21.300476280935413
                        ],
                        [
                            -157.82011658468701,
                            21.300476312009128
                        ],
                        [
                            -157.82011293748701,
                            21.300375662248957
                        ],
                        [
                            -157.82029152977952,
                            21.300369977180235
                        ],
                        [
                            -157.82030011992919,
                            21.300607035671788
                        ],
                        [
                            -157.82027559167045,
                            21.300607824928605
                        ],
                        [
                            -157.82024690666071,
                            21.30060873861715
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 84,
                "NUMBER": "1019",
                "PROPER_NAME": "GEORGE HALL",
                "DISPLAY_NAME": "GEORGE HALL (GRG) - 1019",
                "ADDRESS": "2560 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "GEORGE HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1019_01.jpg",
                "HEIGHT (ft)": 37.899999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 285.42080299261784,
                "SHAPE_Area": 1714.1358377571689
            }
        },
        {
            "type": "Feature",
            "id": 85,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81666267643351,
                            21.300726772012698
                        ],
                        [
                            -157.8166638855385,
                            21.300756115394261
                        ],
                        [
                            -157.81674033821207,
                            21.300753631145351
                        ],
                        [
                            -157.81673925250445,
                            21.300724285017854
                        ],
                        [
                            -157.81682487893104,
                            21.300721503878325
                        ],
                        [
                            -157.8168250528943,
                            21.300725180995418
                        ],
                        [
                            -157.81682746164975,
                            21.300725092234597
                        ],
                        [
                            -157.8168273417908,
                            21.300721881647132
                        ],
                        [
                            -157.8168307677289,
                            21.300721771129506
                        ],
                        [
                            -157.81683068293532,
                            21.300719478632868
                        ],
                        [
                            -157.81682676908719,
                            21.300719605594612
                        ],
                        [
                            -157.81682517364465,
                            21.300676503576707
                        ],
                        [
                            -157.81682908846284,
                            21.300676375718371
                        ],
                        [
                            -157.81682900270533,
                            21.300674083214936
                        ],
                        [
                            -157.81682508885837,
                            21.300674210176719
                        ],
                        [
                            -157.81682349438731,
                            21.300631107262038
                        ],
                        [
                            -157.81682740919703,
                            21.300630980307034
                        ],
                        [
                            -157.81682732440353,
                            21.300628687810356
                        ],
                        [
                            -157.81682340959384,
                            21.300628814765375
                        ],
                        [
                            -157.81682181512301,
                            21.300585711850513
                        ],
                        [
                            -157.81682572993157,
                            21.300585584895476
                        ],
                        [
                            -157.81682564513807,
                            21.300583292398805
                        ],
                        [
                            -157.81682173129352,
                            21.300583419360599
                        ],
                        [
                            -157.81682013682297,
                            21.300540316445545
                        ],
                        [
                            -157.81682405066638,
                            21.300540189483712
                        ],
                        [
                            -157.81682396587289,
                            21.300537896987027
                        ],
                        [
                            -157.81682005202956,
                            21.300538023948857
                        ],
                        [
                            -157.81681845755929,
                            21.300494921033589
                        ],
                        [
                            -157.81682237140149,
                            21.300494794071756
                        ],
                        [
                            -157.81682228660802,
                            21.300492501575043
                        ],
                        [
                            -157.81681837180196,
                            21.300492628530115
                        ],
                        [
                            -157.81681677733198,
                            21.30044952561466
                        ],
                        [
                            -157.8168206921369,
                            21.30044939865957
                        ],
                        [
                            -157.81682060735065,
                            21.300447105259529
                        ],
                        [
                            -157.81681669253857,
                            21.300447233117943
                        ],
                        [
                            -157.81681509903279,
                            21.300404130209063
                        ],
                        [
                            -157.8168190128726,
                            21.300404003247198
                        ],
                        [
                            -157.81681892807913,
                            21.300401710750467
                        ],
                        [
                            -157.81681501423941,
                            21.300401837712354
                        ],
                        [
                            -157.81681341976275,
                            21.300358735699835
                        ],
                        [
                            -157.8168175283808,
                            21.300358601976896
                        ],
                        [
                            -157.81681743474869,
                            21.300356088990856
                        ],
                        [
                            -157.81669775262048,
                            21.300359977626997
                        ],
                        [
                            -157.81669609785101,
                            21.300315259929214
                        ],
                        [
                            -157.81660714696724,
                            21.300318149529467
                        ],
                        [
                            -157.81660701053036,
                            21.30031448171
                        ],
                        [
                            -157.81660456426064,
                            21.300314561170222
                        ],
                        [
                            -157.81660468220147,
                            21.300317769937504
                        ],
                        [
                            -157.81660125818624,
                            21.300317882271212
                        ],
                        [
                            -157.81660134297633,
                            21.300320174767897
                        ],
                        [
                            -157.81660525681383,
                            21.30032004781091
                        ],
                        [
                            -157.81660685122981,
                            21.300363149822743
                        ],
                        [
                            -157.81660293642,
                            21.300363277676293
                        ],
                        [
                            -157.81660302121014,
                            21.300365570172971
                        ],
                        [
                            -157.81660693697668,
                            21.300365443229541
                        ],
                        [
                            -157.81660853139294,
                            21.30040854524119
                        ],
                        [
                            -157.81660461658197,
                            21.300408673094708
                        ],
                        [
                            -157.81660470137209,
                            21.300410965591389
                        ],
                        [
                            -157.81660861618315,
                            21.300410837737861
                        ],
                        [
                            -157.81661020962127,
                            21.300453941549197
                        ],
                        [
                            -157.81660629578749,
                            21.300454067602814
                        ],
                        [
                            -157.81660638057039,
                            21.300456361002812
                        ],
                        [
                            -157.81661029441872,
                            21.300456233142533
                        ],
                        [
                            -157.81661188882109,
                            21.300499336960453
                        ],
                        [
                            -157.81660797498608,
                            21.300499463014035
                        ],
                        [
                            -157.81660805976901,
                            21.300501756414032
                        ],
                        [
                            -157.81661197361132,
                            21.300501629457095
                        ],
                        [
                            -157.81661356802118,
                            21.300544732371481
                        ],
                        [
                            -157.81660965321379,
                            21.300544859321619
                        ],
                        [
                            -157.81660973801121,
                            21.30054715091492
                        ],
                        [
                            -157.81661365281141,
                            21.300547024868134
                        ],
                        [
                            -157.81661524722878,
                            21.300590126878983
                        ],
                        [
                            -157.81661133241298,
                            21.300590254732445
                        ],
                        [
                            -157.8166114172104,
                            21.300592546325731
                        ],
                        [
                            -157.81661533297574,
                            21.300592420285721
                        ],
                        [
                            -157.81661549841647,
                            21.30059692033123
                        ],
                        [
                            -157.81661616405691,
                            21.300614917830273
                        ],
                        [
                            -157.81661692642948,
                            21.300635522289607
                        ],
                        [
                            -157.8166130125764,
                            21.300635650149815
                        ],
                        [
                            -157.8166130973666,
                            21.300637942646446
                        ],
                        [
                            -157.81661701121251,
                            21.300637815689562
                        ],
                        [
                            -157.81661860563048,
                            21.300680917700014
                        ],
                        [
                            -157.81661469177615,
                            21.300681045560221
                        ],
                        [
                            -157.81661477656635,
                            21.300683338056825
                        ],
                        [
                            -157.81661869042074,
                            21.300683210196635
                        ],
                        [
                            -157.81662028483171,
                            21.300726313110228
                        ],
                        [
                            -157.81661637001952,
                            21.300726440060284
                        ],
                        [
                            -157.8166164548025,
                            21.300728733460229
                        ],
                        [
                            -157.81661987978399,
                            21.300728622036782
                        ],
                        [
                            -157.81661999868172,
                            21.300731831714046
                        ],
                        [
                            -157.81662244592232,
                            21.300731752260688
                        ],
                        [
                            -157.81662230949246,
                            21.30072808353804
                        ],
                        [
                            -157.81666267643351,
                            21.300726772012698
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 85,
                "NUMBER": "1164",
                "PROPER_NAME": "EDMONDSON HALL",
                "DISPLAY_NAME": "EDMONDSON HALL (EDM) - 1164",
                "ADDRESS": "2538 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "EDMONDSON HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1164_01.jpg",
                "HEIGHT (ft)": 67.900000000000006,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 158.08155082147718,
                "SHAPE_Area": 941.8652274768674
            }
        },
        {
            "type": "Feature",
            "id": 86,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81820624197135,
                            21.300788272236606
                        ],
                        [
                            -157.81841038868518,
                            21.300781319610341
                        ],
                        [
                            -157.81841246858079,
                            21.300781248392287
                        ],
                        [
                            -157.81847069110501,
                            21.300779265918347
                        ],
                        [
                            -157.81847264853744,
                            21.300779199260059
                        ],
                        [
                            -157.8184806219441,
                            21.300778927311722
                        ],
                        [
                            -157.81847860708493,
                            21.300726972733475
                        ],
                        [
                            -157.81847063368107,
                            21.300727244681852
                        ],
                        [
                            -157.81837427403556,
                            21.300730526754613
                        ],
                        [
                            -157.81837347795778,
                            21.300710007879204
                        ],
                        [
                            -157.81847781099262,
                            21.300706453857877
                        ],
                        [
                            -157.81847768395679,
                            21.300703171851961
                        ],
                        [
                            -157.81853296837915,
                            21.300701288877359
                        ],
                        [
                            -157.81853302977669,
                            21.300702893729827
                        ],
                        [
                            -157.81853890111421,
                            21.300702692842449
                        ],
                        [
                            -157.81853883874544,
                            21.300701088886559
                        ],
                        [
                            -157.81862543918473,
                            21.300698138408983
                        ],
                        [
                            -157.8186255025112,
                            21.30069974327499
                        ],
                        [
                            -157.81863137384141,
                            21.300699543287738
                        ],
                        [
                            -157.81863131051492,
                            21.300697938421727
                        ],
                        [
                            -157.81868415248633,
                            21.300696138527119
                        ],
                        [
                            -157.81868421388552,
                            21.300697743379601
                        ],
                        [
                            -157.81869008521574,
                            21.300697543390271
                        ],
                        [
                            -157.81868987277505,
                            21.300692041154417
                        ],
                        [
                            -157.81868803395113,
                            21.300692103227561
                        ],
                        [
                            -157.81868611233216,
                            21.300642584843704
                        ],
                        [
                            -157.81868795212662,
                            21.300642521873979
                        ],
                        [
                            -157.81868773775813,
                            21.300637019624563
                        ],
                        [
                            -157.81868589989162,
                            21.300637082607821
                        ],
                        [
                            -157.81868361619206,
                            21.300578230561694
                        ],
                        [
                            -157.81869669433277,
                            21.300577784850471
                        ],
                        [
                            -157.81869443965493,
                            21.300519643072615
                        ],
                        [
                            -157.8186943587892,
                            21.300517579161074
                        ],
                        [
                            -157.81868121314955,
                            21.300518028012061
                        ],
                        [
                            -157.8186797841191,
                            21.300481174102924
                        ],
                        [
                            -157.81868168948074,
                            21.300481108883293
                        ],
                        [
                            -157.81868147704029,
                            21.3004756066473
                        ],
                        [
                            -157.818679570722,
                            21.300475670956828
                        ],
                        [
                            -157.81867764910487,
                            21.300426152571895
                        ],
                        [
                            -157.81867955639365,
                            21.300426087365803
                        ],
                        [
                            -157.81867934202535,
                            21.30042058511625
                        ],
                        [
                            -157.81867743666453,
                            21.300420650335891
                        ],
                        [
                            -157.81867552632619,
                            21.30037140937074
                        ],
                        [
                            -157.81867581397543,
                            21.300371120498259
                        ],
                        [
                            -157.81867742137919,
                            21.300371065834462
                        ],
                        [
                            -157.81867720796765,
                            21.300365564494996
                        ],
                        [
                            -157.81867175513486,
                            21.300365750257775
                        ],
                        [
                            -157.81861655996923,
                            21.30031765112086
                        ],
                        [
                            -157.81861636092128,
                            21.300312523885879
                        ],
                        [
                            -157.81861049057761,
                            21.300312722976763
                        ],
                        [
                            -157.81861062064183,
                            21.300316108894002
                        ],
                        [
                            -157.8185240174378,
                            21.300318950946622
                        ],
                        [
                            -157.81852389036473,
                            21.300315673457252
                        ],
                        [
                            -157.8185180190498,
                            21.30031587344148
                        ],
                        [
                            -157.81851814522381,
                            21.300319142794027
                        ],
                        [
                            -157.81843154201877,
                            21.300321984798874
                        ],
                        [
                            -157.81843141787181,
                            21.300318823867432
                        ],
                        [
                            -157.81842554752797,
                            21.300319022951836
                        ],
                        [
                            -157.81842566883353,
                            21.300322177539588
                        ],
                        [
                            -157.81833894799874,
                            21.300325022284277
                        ],
                        [
                            -157.81833882870566,
                            21.300321977924298
                        ],
                        [
                            -157.81833295739781,
                            21.300322176998691
                        ],
                        [
                            -157.81833307577017,
                            21.300325215931871
                        ],
                        [
                            -157.81824658924222,
                            21.300328053240168
                        ],
                        [
                            -157.8182464748173,
                            21.300325123644946
                        ],
                        [
                            -157.8182406044661,
                            21.300325323626218
                        ],
                        [
                            -157.81824071702081,
                            21.30032824598117
                        ],
                        [
                            -157.81815411285589,
                            21.300331086932612
                        ],
                        [
                            -157.81815400425569,
                            21.300328273012287
                        ],
                        [
                            -157.81814813294048,
                            21.300328472983562
                        ],
                        [
                            -157.81814833017427,
                            21.300333583944692
                        ],
                        [
                            -157.81814481218925,
                            21.300337129436702
                        ],
                        [
                            -157.81809700050999,
                            21.300385328295949
                        ],
                        [
                            -157.81809151682367,
                            21.300385514726539
                        ],
                        [
                            -157.81809173020611,
                            21.300391016969076
                        ],
                        [
                            -157.8180947029872,
                            21.300390915890134
                        ],
                        [
                            -157.81809662343764,
                            21.300440435169406
                        ],
                        [
                            -157.81809365161223,
                            21.30044053715844
                        ],
                        [
                            -157.81809386403802,
                            21.300446038490826
                        ],
                        [
                            -157.8180968377842,
                            21.300445937418669
                        ],
                        [
                            -157.8180987582351,
                            21.300495456697661
                        ],
                        [
                            -157.81809578448792,
                            21.300495557769803
                        ],
                        [
                            -157.81809599883442,
                            21.30050106001903
                        ],
                        [
                            -157.81809897450952,
                            21.300500958960452
                        ],
                        [
                            -157.81810042745701,
                            21.300537817553671
                        ],
                        [
                            -157.81808695446463,
                            21.300538336330174
                        ],
                        [
                            -157.81808928643181,
                            21.300598476045504
                        ],
                        [
                            -157.81810269820332,
                            21.300598019172977
                        ],
                        [
                            -157.81810491128203,
                            21.300656873431929
                        ],
                        [
                            -157.81810204552843,
                            21.300656970745564
                        ],
                        [
                            -157.81810225891113,
                            21.300662472987948
                        ],
                        [
                            -157.81810512562873,
                            21.300662375681085
                        ],
                        [
                            -157.81810704608861,
                            21.300711894055645
                        ],
                        [
                            -157.81810417936282,
                            21.300711992265835
                        ],
                        [
                            -157.81810439275279,
                            21.300717493604854
                        ],
                        [
                            -157.81811026407624,
                            21.300717294539172
                        ],
                        [
                            -157.81811016020589,
                            21.300714612547178
                        ],
                        [
                            -157.81816303978891,
                            21.300712811274156
                        ],
                        [
                            -157.81816314269628,
                            21.300715493259403
                        ],
                        [
                            -157.81816901499087,
                            21.300715293295113
                        ],
                        [
                            -157.81816891111944,
                            21.300712611303091
                        ],
                        [
                            -157.81820326163253,
                            21.300711441445724
                        ],
                        [
                            -157.81820624197135,
                            21.300788272236606
                        ]
                    ],
                    [
                        [
                            -157.81843351541031,
                            21.300434468957416
                        ],
                        [
                            -157.81843590096906,
                            21.300434387237566
                        ],
                        [
                            -157.81843581959075,
                            21.300432267312228
                        ],
                        [
                            -157.81852241890752,
                            21.300429316873601
                        ],
                        [
                            -157.81852250124379,
                            21.300431437709058
                        ],
                        [
                            -157.81852476337571,
                            21.300431360541747
                        ],
                        [
                            -157.81852910429112,
                            21.300543254244094
                        ],
                        [
                            -157.81852684119357,
                            21.300543331404636
                        ],
                        [
                            -157.81852692840354,
                            21.30054556610148
                        ],
                        [
                            -157.81844032709063,
                            21.300548516525708
                        ],
                        [
                            -157.818440241817,
                            21.300546280939066
                        ],
                        [
                            -157.8184378552925,
                            21.300546362652124
                        ],
                        [
                            -157.81843351541031,
                            21.300434468957416
                        ]
                    ],
                    [
                        [
                            -157.81834428245273,
                            21.300549549548794
                        ],
                        [
                            -157.81834189785604,
                            21.300549631274023
                        ],
                        [
                            -157.81834198409209,
                            21.300551866867416
                        ],
                        [
                            -157.81825538466134,
                            21.300554822629653
                        ],
                        [
                            -157.818255297506,
                            21.30055258160948
                        ],
                        [
                            -157.81825340083336,
                            21.300552645078476
                        ],
                        [
                            -157.81824906205509,
                            21.300440751392344
                        ],
                        [
                            -157.81825095776236,
                            21.300440687916556
                        ],
                        [
                            -157.81825087548054,
                            21.30043856075778
                        ],
                        [
                            -157.81833747378519,
                            21.300435616731288
                        ],
                        [
                            -157.81833755611882,
                            21.300437737566718
                        ],
                        [
                            -157.81833994264156,
                            21.300437655855003
                        ],
                        [
                            -157.81834428245273,
                            21.300549549548794
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 86,
                "NUMBER": "1020",
                "PROPER_NAME": "QUEEN LILI`UOKALANI CENTER FOR STUDENT SERVICES",
                "DISPLAY_NAME": "QUEEN LILI`UOKALANI CENTER FOR STUDENT SERVICES - 1020",
                "ADDRESS": "2600 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "QUEEN LILIUOKALANI CENTER FOR STUDENT SERVICES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "QLCSS , ",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1020_01.jpg",
                "HEIGHT (ft)": 62.899999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 343.44486248780305,
                "SHAPE_Area": 2508.8134513257332
            }
        },
        {
            "type": "Feature",
            "id": 87,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81950128996735,
                            21.30062358310915
                        ],
                        [
                            -157.8195104914945,
                            21.30084295658142
                        ],
                        [
                            -157.81962888123846,
                            21.300838595258561
                        ],
                        [
                            -157.81961968049183,
                            21.30061922269461
                        ],
                        [
                            -157.81950128996735,
                            21.30062358310915
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 87,
                "NUMBER": "1002A",
                "PROPER_NAME": "QUADRANGLE LOOP BUILDING",
                "DISPLAY_NAME": "QUADRANGLE LOOP BUILDING - 1002A",
                "ADDRESS": "2500 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "QUADRANGLE LOOP BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1002A_01.jpg",
                "HEIGHT (ft)": 17.400000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 73.18763483775669,
                "SHAPE_Area": 298.70701911477727
            }
        },
        {
            "type": "Feature",
            "id": 88,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81893224495857,
                            21.300886104951481
                        ],
                        [
                            -157.81894993015894,
                            21.300885523525363
                        ],
                        [
                            -157.81894958146262,
                            21.300876201701588
                        ],
                        [
                            -157.81895842262716,
                            21.300875909622665
                        ],
                        [
                            -157.81895856578703,
                            21.300879708481119
                        ],
                        [
                            -157.81902414693619,
                            21.300877549807289
                        ],
                        [
                            -157.8190228008807,
                            21.300841641427866
                        ],
                        [
                            -157.81901174774785,
                            21.30084200561561
                        ],
                        [
                            -157.81901123055547,
                            21.300828194565096
                        ],
                        [
                            -157.81901221312418,
                            21.30082816171155
                        ],
                        [
                            -157.81901214786905,
                            21.300826435777672
                        ],
                        [
                            -157.81913864413823,
                            21.300822272620007
                        ],
                        [
                            -157.81913875909387,
                            21.300825379283435
                        ],
                        [
                            -157.81914244442785,
                            21.300825258794895
                        ],
                        [
                            -157.81914330643812,
                            21.300848276911584
                        ],
                        [
                            -157.81927053844203,
                            21.300844089909599
                        ],
                        [
                            -157.8192711082508,
                            21.300859281710263
                        ],
                        [
                            -157.81927847604314,
                            21.300859038900402
                        ],
                        [
                            -157.81927792473067,
                            21.300844307055332
                        ],
                        [
                            -157.81928676685027,
                            21.300844015869139
                        ],
                        [
                            -157.81928711262873,
                            21.300853222942031
                        ],
                        [
                            -157.8193455708882,
                            21.300851299636872
                        ],
                        [
                            -157.8193440864444,
                            21.300811708065773
                        ],
                        [
                            -157.81946198550642,
                            21.300807827634358
                        ],
                        [
                            -157.81945643722679,
                            21.300659818743625
                        ],
                        [
                            -157.81939748824078,
                            21.300661758522242
                        ],
                        [
                            -157.81939611578971,
                            21.300625160669181
                        ],
                        [
                            -157.81935386846371,
                            21.300626550902578
                        ],
                        [
                            -157.8193540028708,
                            21.300630119335175
                        ],
                        [
                            -157.81933631866431,
                            21.300630700812039
                        ],
                        [
                            -157.81933618425046,
                            21.30062713328277
                        ],
                        [
                            -157.81933074978741,
                            21.300627311064922
                        ],
                        [
                            -157.81932855914249,
                            21.300568845418063
                        ],
                        [
                            -157.81935290817282,
                            21.300568046007957
                        ],
                        [
                            -157.81935536409395,
                            21.300567965672172
                        ],
                        [
                            -157.81935976682712,
                            21.300567820399888
                        ],
                        [
                            -157.81935969863585,
                            21.300565978811335
                        ],
                        [
                            -157.81935529493157,
                            21.300566124980204
                        ],
                        [
                            -157.81935283901046,
                            21.300566205315985
                        ],
                        [
                            -157.81935242407249,
                            21.300555156647466
                        ],
                        [
                            -157.81935488095735,
                            21.300555076318442
                        ],
                        [
                            -157.81935391469867,
                            21.30052929580425
                        ],
                        [
                            -157.81932714154968,
                            21.300530177580093
                        ],
                        [
                            -157.819326830835,
                            21.300521890404571
                        ],
                        [
                            -157.81933420053835,
                            21.300521647605002
                        ],
                        [
                            -157.81933247452889,
                            21.300475611355683
                        ],
                        [
                            -157.81929019252991,
                            21.300477003138283
                        ],
                        [
                            -157.81921944564235,
                            21.300415201756731
                        ],
                        [
                            -157.81922371862203,
                            21.300410905400863
                        ],
                        [
                            -157.81922048196458,
                            21.300408078566008
                        ],
                        [
                            -157.81921620994885,
                            21.300412374928566
                        ],
                        [
                            -157.81916054450369,
                            21.300363749599828
                        ],
                        [
                            -157.81916481844735,
                            21.300359453252202
                        ],
                        [
                            -157.81915942498372,
                            21.300354742166881
                        ],
                        [
                            -157.8191523862896,
                            21.300361817818228
                        ],
                        [
                            -157.81912146339639,
                            21.300334806263756
                        ],
                        [
                            -157.81911643631219,
                            21.300339859786995
                        ],
                        [
                            -157.81912013152143,
                            21.300343086429958
                        ],
                        [
                            -157.81894450586057,
                            21.300519652040851
                        ],
                        [
                            -157.818940812579,
                            21.300516425407601
                        ],
                        [
                            -157.8189357845113,
                            21.300521479821331
                        ],
                        [
                            -157.8189490508444,
                            21.300533069476543
                        ],
                        [
                            -157.81893803844324,
                            21.300544141834333
                        ],
                        [
                            -157.81891650600875,
                            21.300544843511862
                        ],
                        [
                            -157.8189167738451,
                            21.300551979466746
                        ],
                        [
                            -157.81893149109104,
                            21.300551492844473
                        ],
                        [
                            -157.81893825343707,
                            21.300731954621572
                        ],
                        [
                            -157.81889455294754,
                            21.300733395066516
                        ],
                        [
                            -157.81889486363775,
                            21.300741682241526
                        ],
                        [
                            -157.81891119696417,
                            21.300741143727137
                        ],
                        [
                            -157.81891150765529,
                            21.300749430902165
                        ],
                        [
                            -157.81890401645606,
                            21.300749676443559
                        ],
                        [
                            -157.81890687896683,
                            21.300826098076573
                        ],
                        [
                            -157.81893807418791,
                            21.300825071244677
                        ],
                        [
                            -157.81893879786648,
                            21.300844406170551
                        ],
                        [
                            -157.81893069243279,
                            21.300844672696936
                        ],
                        [
                            -157.81893224495857,
                            21.300886104951481
                        ]
                    ],
                    [
                        [
                            -157.81913481702028,
                            21.300693914617067
                        ],
                        [
                            -157.81913383445968,
                            21.300693946568035
                        ],
                        [
                            -157.8191338695178,
                            21.300694867369042
                        ],
                        [
                            -157.81900860180156,
                            21.30069899036631
                        ],
                        [
                            -157.81900856771531,
                            21.300698068668741
                        ],
                        [
                            -157.81900758418354,
                            21.300698101515543
                        ],
                        [
                            -157.81900546282515,
                            21.300641476562724
                        ],
                        [
                            -157.81900644538541,
                            21.300641444612491
                        ],
                        [
                            -157.81900629051546,
                            21.300637301479952
                        ],
                        [
                            -157.81900530698411,
                            21.300637334326762
                        ],
                        [
                            -157.81900318563342,
                            21.300580708470253
                        ],
                        [
                            -157.81900416819329,
                            21.300580676520017
                        ],
                        [
                            -157.81900413409986,
                            21.300579755725771
                        ],
                        [
                            -157.81912940075088,
                            21.300575632720324
                        ],
                        [
                            -157.81912943483786,
                            21.300576554417912
                        ],
                        [
                            -157.81913041836887,
                            21.300576521570367
                        ],
                        [
                            -157.81913253977561,
                            21.300633146524213
                        ],
                        [
                            -157.8191315572154,
                            21.300633178475181
                        ],
                        [
                            -157.81913171208885,
                            21.300637321607773
                        ],
                        [
                            -157.81913269561301,
                            21.300637289663563
                        ],
                        [
                            -157.81913481702028,
                            21.300693914617067
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 88,
                "NUMBER": "1014",
                "PROPER_NAME": "SAUNDERS HALL",
                "DISPLAY_NAME": "SAUNDERS HALL (SAUND) - 1014",
                "ADDRESS": "2424 MAILE WAY",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "SAUNDERS HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "Porteus Hall",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1014_01.jpg",
                "HEIGHT (ft)": 85.400000000000006,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 304.6551499690089,
                "SHAPE_Area": 2036.4359930526405
            }
        },
        {
            "type": "Feature",
            "id": 89,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81759803501336,
                            21.300906079487611
                        ],
                        [
                            -157.81759814714863,
                            21.300909293634394
                        ],
                        [
                            -157.81760010453206,
                            21.300909233309739
                        ],
                        [
                            -157.81759999236061,
                            21.300906023679648
                        ],
                        [
                            -157.81765871202046,
                            21.300904203075554
                        ],
                        [
                            -157.81765882418594,
                            21.300907413609007
                        ],
                        [
                            -157.81766078157659,
                            21.300907352380289
                        ],
                        [
                            -157.81766066940384,
                            21.300904142750177
                        ],
                        [
                            -157.8176858685764,
                            21.300903362204561
                        ],
                        [
                            -157.81768598171365,
                            21.300906571841455
                        ],
                        [
                            -157.81768794006823,
                            21.30090651061921
                        ],
                        [
                            -157.817687825967,
                            21.300903300975545
                        ],
                        [
                            -157.81771278215527,
                            21.300902527752616
                        ],
                        [
                            -157.81771289432916,
                            21.300905737382745
                        ],
                        [
                            -157.81771485171257,
                            21.300905677056733
                        ],
                        [
                            -157.81771473954586,
                            21.300902466523265
                        ],
                        [
                            -157.8177396938062,
                            21.3009016932828
                        ],
                        [
                            -157.81773980790132,
                            21.300904903829824
                        ],
                        [
                            -157.81774176528472,
                            21.300904843503499
                        ],
                        [
                            -157.81774165118955,
                            21.300901632956478
                        ],
                        [
                            -157.81776685228976,
                            21.300900852412251
                        ],
                        [
                            -157.81776696446485,
                            21.300904062042388
                        ],
                        [
                            -157.81776892185547,
                            21.300904000812423
                        ],
                        [
                            -157.81776880968036,
                            21.300900791182276
                        ],
                        [
                            -157.81779376201268,
                            21.300900017920199
                        ],
                        [
                            -157.81779387515226,
                            21.300903227557132
                        ],
                        [
                            -157.81779583252842,
                            21.300903168133534
                        ],
                        [
                            -157.81779571843208,
                            21.300899957586491
                        ],
                        [
                            -157.81782067751189,
                            21.300899184367822
                        ],
                        [
                            -157.81782079065209,
                            21.300902394004758
                        ],
                        [
                            -157.81782274707152,
                            21.300902333670717
                        ],
                        [
                            -157.81782263490246,
                            21.300899123137214
                        ],
                        [
                            -157.8178478340746,
                            21.300898342567272
                        ],
                        [
                            -157.81784794817932,
                            21.300901552210995
                        ],
                        [
                            -157.81784990556267,
                            21.300901491883408
                        ],
                        [
                            -157.81784979145792,
                            21.300898282239686
                        ],
                        [
                            -157.81785199955141,
                            21.300898212832621
                        ],
                        [
                            -157.81785192736569,
                            21.300896149885581
                        ],
                        [
                            -157.81785534652451,
                            21.30089604381654
                        ],
                        [
                            -157.81785527921485,
                            21.300894214881851
                        ],
                        [
                            -157.81785187063772,
                            21.300894323735395
                        ],
                        [
                            -157.81785095595097,
                            21.3008686366353
                        ],
                        [
                            -157.81785437510911,
                            21.30086853056623
                        ],
                        [
                            -157.81785430977791,
                            21.300866695321698
                        ],
                        [
                            -157.81785089061259,
                            21.300866802294092
                        ],
                        [
                            -157.81784998454356,
                            21.300841122481589
                        ],
                        [
                            -157.81785340370104,
                            21.300841016412523
                        ],
                        [
                            -157.81785333932658,
                            21.300839182078079
                        ],
                        [
                            -157.8178499201691,
                            21.300839288147163
                        ],
                        [
                            -157.81784901410012,
                            21.300813608334572
                        ],
                        [
                            -157.81785243324978,
                            21.300813503168833
                        ],
                        [
                            -157.81785236887529,
                            21.300811668834399
                        ],
                        [
                            -157.81784894875454,
                            21.300811774896705
                        ],
                        [
                            -157.81784804268565,
                            21.300786095084042
                        ],
                        [
                            -157.81785146280583,
                            21.300785989021733
                        ],
                        [
                            -157.81785139843134,
                            21.300784154687289
                        ],
                        [
                            -157.81784797831122,
                            21.300784260749605
                        ],
                        [
                            -157.81784707224242,
                            21.300758580936872
                        ],
                        [
                            -157.81785049235475,
                            21.300758475777887
                        ],
                        [
                            -157.81785042701634,
                            21.300756641436671
                        ],
                        [
                            -157.81784700690409,
                            21.300756746595656
                        ],
                        [
                            -157.81784610082812,
                            21.30073106768619
                        ],
                        [
                            -157.81784952094702,
                            21.300730961623856
                        ],
                        [
                            -157.81784945657256,
                            21.300729127289408
                        ],
                        [
                            -157.81784603741767,
                            21.30072923335851
                        ],
                        [
                            -157.81784513134903,
                            21.300703553545638
                        ],
                        [
                            -157.81784855049611,
                            21.300703448379856
                        ],
                        [
                            -157.81784848515773,
                            21.300701614038633
                        ],
                        [
                            -157.81784506601068,
                            21.300701719204408
                        ],
                        [
                            -157.81784415993491,
                            21.3006760402948
                        ],
                        [
                            -157.81784757908861,
                            21.300675934225673
                        ],
                        [
                            -157.81784751375022,
                            21.300674099884443
                        ],
                        [
                            -157.81784409459658,
                            21.30067420595357
                        ],
                        [
                            -157.8178431885209,
                            21.30064852704389
                        ],
                        [
                            -157.81784660768116,
                            21.300648420071411
                        ],
                        [
                            -157.81784654329951,
                            21.300646586640287
                        ],
                        [
                            -157.81784312414649,
                            21.300646692709424
                        ],
                        [
                            -157.81784221807814,
                            21.300621012896332
                        ],
                        [
                            -157.81784563723053,
                            21.300620906827188
                        ],
                        [
                            -157.81784557189218,
                            21.300619072485947
                        ],
                        [
                            -157.81784215273979,
                            21.300619178555092
                        ],
                        [
                            -157.8178412466643,
                            21.300593499645284
                        ],
                        [
                            -157.81784466582329,
                            21.300593392672774
                        ],
                        [
                            -157.81784460241278,
                            21.300591558345069
                        ],
                        [
                            -157.81784118228992,
                            21.30059166531079
                        ],
                        [
                            -157.81784027622169,
                            21.300565985497574
                        ],
                        [
                            -157.81784369633678,
                            21.30056587943518
                        ],
                        [
                            -157.8178436309984,
                            21.30056404509391
                        ],
                        [
                            -157.81784021088339,
                            21.300564151156308
                        ],
                        [
                            -157.81783930481527,
                            21.300538471343017
                        ],
                        [
                            -157.8178427249297,
                            21.300538365280612
                        ],
                        [
                            -157.81784266055527,
                            21.300536530946111
                        ],
                        [
                            -157.81783924043367,
                            21.300536637911872
                        ],
                        [
                            -157.81783833340171,
                            21.300510958091721
                        ],
                        [
                            -157.81784175351549,
                            21.300510852029312
                        ],
                        [
                            -157.81784168914109,
                            21.300509017694814
                        ],
                        [
                            -157.81783826999126,
                            21.300509123764005
                        ],
                        [
                            -157.81783736295938,
                            21.300483443943779
                        ],
                        [
                            -157.81784078306532,
                            21.300483338784698
                        ],
                        [
                            -157.81784071772699,
                            21.300481504443425
                        ],
                        [
                            -157.81783729858503,
                            21.300481609609289
                        ],
                        [
                            -157.81783639250995,
                            21.300455930699105
                        ],
                        [
                            -157.8178398116585,
                            21.300455824629896
                        ],
                        [
                            -157.81783974728413,
                            21.300453990295395
                        ],
                        [
                            -157.81783632813557,
                            21.300454096364607
                        ],
                        [
                            -157.81783542203888,
                            21.300428420164362
                        ],
                        [
                            -157.81783884117962,
                            21.300428314998484
                        ],
                        [
                            -157.81783877584127,
                            21.300426480657208
                        ],
                        [
                            -157.81783535670061,
                            21.300426585823086
                        ],
                        [
                            -157.81783445065457,
                            21.300400903299412
                        ],
                        [
                            -157.81783786980191,
                            21.300400797230182
                        ],
                        [
                            -157.8178378054275,
                            21.300398962895674
                        ],
                        [
                            -157.81783438628025,
                            21.3003990689649
                        ],
                        [
                            -157.81783348021264,
                            21.300373389151165
                        ],
                        [
                            -157.81783689935932,
                            21.300373283081925
                        ],
                        [
                            -157.8178368349777,
                            21.300371449650751
                        ],
                        [
                            -157.81783341487437,
                            21.300371554809875
                        ],
                        [
                            -157.81783250879963,
                            21.300345875899406
                        ],
                        [
                            -157.81783592890957,
                            21.300345769836934
                        ],
                        [
                            -157.8178358645352,
                            21.300343935502408
                        ],
                        [
                            -157.81783244442531,
                            21.300344041564884
                        ],
                        [
                            -157.81783237128303,
                            21.300341977707635
                        ],
                        [
                            -157.81783016416904,
                            21.300342046218269
                        ],
                        [
                            -157.81783005006449,
                            21.300338836574387
                        ],
                        [
                            -157.81782809268861,
                            21.300338896902073
                        ],
                        [
                            -157.81782820679308,
                            21.300342106545973
                        ],
                        [
                            -157.81780300578092,
                            21.300342888007236
                        ],
                        [
                            -157.81780289361205,
                            21.300339677473545
                        ],
                        [
                            -157.81780093622893,
                            21.300339738704256
                        ],
                        [
                            -157.81780104936169,
                            21.300342949244715
                        ],
                        [
                            -157.81777609133997,
                            21.300343722471663
                        ],
                        [
                            -157.81777597724383,
                            21.300340511924436
                        ],
                        [
                            -157.81777402083188,
                            21.300340572258264
                        ],
                        [
                            -157.81777413396404,
                            21.300343782798734
                        ],
                        [
                            -157.81774918076911,
                            21.300344555152176
                        ],
                        [
                            -157.81774906858698,
                            21.300341346425185
                        ],
                        [
                            -157.81774711121108,
                            21.30034140675194
                        ],
                        [
                            -157.81774722338596,
                            21.300344616382269
                        ],
                        [
                            -157.81772202430142,
                            21.300345397844911
                        ],
                        [
                            -157.81772191020644,
                            21.300342187297687
                        ],
                        [
                            -157.81771995283057,
                            21.300342247624133
                        ],
                        [
                            -157.81772006692546,
                            21.300345458171339
                        ],
                        [
                            -157.81769511082419,
                            21.300346232303106
                        ],
                        [
                            -157.81769499865769,
                            21.300343021769454
                        ],
                        [
                            -157.81769304128173,
                            21.300343082095569
                        ],
                        [
                            -157.8176931534482,
                            21.300346292629218
                        ],
                        [
                            -157.81766819928916,
                            21.300347064963855
                        ],
                        [
                            -157.81766808518816,
                            21.300343855320008
                        ],
                        [
                            -157.81766612780501,
                            21.300343916549156
                        ],
                        [
                            -157.81766624190598,
                            21.300347126193007
                        ],
                        [
                            -157.81764104089336,
                            21.300347907629913
                        ],
                        [
                            -157.81764092872803,
                            21.300344697096286
                        ],
                        [
                            -157.81763897135212,
                            21.300344757421779
                        ],
                        [
                            -157.81763908351738,
                            21.30034796795541
                        ],
                        [
                            -157.81763686676402,
                            21.300348036395771
                        ],
                        [
                            -157.81763693990354,
                            21.300350100252992
                        ],
                        [
                            -157.81763352943287,
                            21.300350206379136
                        ],
                        [
                            -157.81763359381196,
                            21.300352039810289
                        ],
                        [
                            -157.81763701970559,
                            21.300351933792498
                        ],
                        [
                            -157.81763792573906,
                            21.300377613605743
                        ],
                        [
                            -157.81763450080877,
                            21.300377719630308
                        ],
                        [
                            -157.81763456518064,
                            21.300379553964788
                        ],
                        [
                            -157.81763799011097,
                            21.300379447940241
                        ],
                        [
                            -157.81763884043187,
                            21.300403536491768
                        ],
                        [
                            -157.81761168315589,
                            21.300404358382558
                        ],
                        [
                            -157.81760865935846,
                            21.300404450060565
                        ],
                        [
                            -157.81756084750771,
                            21.300405897410631
                        ],
                        [
                            -157.81756291444682,
                            21.300466001837993
                        ],
                        [
                            -157.81760909218968,
                            21.300464575528579
                        ],
                        [
                            -157.81761380242833,
                            21.300464430655762
                        ],
                        [
                            -157.81764095889594,
                            21.300463590691585
                        ],
                        [
                            -157.81764180931103,
                            21.3004876674995
                        ],
                        [
                            -157.81763838437095,
                            21.300487774427339
                        ],
                        [
                            -157.8176384477789,
                            21.300489608755026
                        ],
                        [
                            -157.81764187368293,
                            21.300489501833955
                        ],
                        [
                            -157.81764277970962,
                            21.3005151825502
                        ],
                        [
                            -157.81763935478338,
                            21.300515287671356
                        ],
                        [
                            -157.81763941915526,
                            21.300517122005804
                        ],
                        [
                            -157.81764284505272,
                            21.300517015988081
                        ],
                        [
                            -157.81764375108671,
                            21.300542695800917
                        ],
                        [
                            -157.81764032518865,
                            21.300542801818629
                        ],
                        [
                            -157.81764038956052,
                            21.300544636153077
                        ],
                        [
                            -157.81764381546586,
                            21.300544529232027
                        ],
                        [
                            -157.81764472149268,
                            21.30057020994813
                        ],
                        [
                            -157.81764129656517,
                            21.300570315069265
                        ],
                        [
                            -157.81764136093707,
                            21.300572149403706
                        ],
                        [
                            -157.81764478682859,
                            21.300572044289343
                        ],
                        [
                            -157.81764569286997,
                            21.300597723198695
                        ],
                        [
                            -157.81764226697786,
                            21.300597828313052
                        ],
                        [
                            -157.81764233230649,
                            21.300599663557595
                        ],
                        [
                            -157.81764575724193,
                            21.300599557533133
                        ],
                        [
                            -157.8176466632834,
                            21.300625236442414
                        ],
                        [
                            -157.81764323834014,
                            21.300625343370207
                        ],
                        [
                            -157.81764330271926,
                            21.300627176801296
                        ],
                        [
                            -157.81764672765536,
                            21.300627070776841
                        ],
                        [
                            -157.81764763368969,
                            21.300652750589375
                        ],
                        [
                            -157.81764420875299,
                            21.300652856613837
                        ],
                        [
                            -157.81764427409607,
                            21.300654690051697
                        ],
                        [
                            -157.81764769902557,
                            21.300654584930594
                        ],
                        [
                            -157.81764860506721,
                            21.300680263839716
                        ],
                        [
                            -157.81764518012264,
                            21.300680370767502
                        ],
                        [
                            -157.81764524449457,
                            21.300682205101921
                        ],
                        [
                            -157.81764866943917,
                            21.300682098174136
                        ],
                        [
                            -157.81764957547367,
                            21.300707777986538
                        ],
                        [
                            -157.81764615053572,
                            21.300707884010965
                        ],
                        [
                            -157.81764621587155,
                            21.300709718352167
                        ],
                        [
                            -157.81764964080958,
                            21.300709612327722
                        ],
                        [
                            -157.81765054685138,
                            21.300735291236723
                        ],
                        [
                            -157.81764712190557,
                            21.300735398164473
                        ],
                        [
                            -157.81764718531355,
                            21.300737232492107
                        ],
                        [
                            -157.81765061122334,
                            21.300737125571132
                        ],
                        [
                            -157.81765151725804,
                            21.300762805383396
                        ],
                        [
                            -157.81764809231879,
                            21.300762911407798
                        ],
                        [
                            -157.81764815669072,
                            21.3007647457422
                        ],
                        [
                            -157.81765158259395,
                            21.300764639724573
                        ],
                        [
                            -157.81765248863593,
                            21.300790318633425
                        ],
                        [
                            -157.8176490627321,
                            21.300790424651048
                        ],
                        [
                            -157.81764912806076,
                            21.300792259895552
                        ],
                        [
                            -157.81765255397184,
                            21.300792152974594
                        ],
                        [
                            -157.81765346000668,
                            21.300817832786716
                        ],
                        [
                            -157.81765003410223,
                            21.300817938804325
                        ],
                        [
                            -157.81765006628819,
                            21.300818855971531
                        ],
                        [
                            -157.81762755732763,
                            21.30081955333122
                        ],
                        [
                            -157.81762748809018,
                            21.300817604232083
                        ],
                        [
                            -157.81762504184076,
                            21.300817680093441
                        ],
                        [
                            -157.81762511107817,
                            21.300819629192567
                        ],
                        [
                            -157.81759819848585,
                            21.300820462734624
                        ],
                        [
                            -157.81759812924156,
                            21.300818514538825
                        ],
                        [
                            -157.81759568299213,
                            21.300818590399743
                        ],
                        [
                            -157.81759577954904,
                            21.300821341901326
                        ],
                        [
                            -157.81759665405033,
                            21.300847829122535
                        ],
                        [
                            -157.8175986322106,
                            21.300902162970356
                        ],
                        [
                            -157.8175978945753,
                            21.300902185792541
                        ],
                        [
                            -157.81759803501336,
                            21.300906079487611
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 89,
                "NUMBER": "1167",
                "PROPER_NAME": "WEBSTER HALL",
                "DISPLAY_NAME": "WEBSTER HALL (WEB) - 1167",
                "ADDRESS": "2528 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WEBSTER HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1167_01.jpg",
                "HEIGHT (ft)": 53.600000000000001,
                "LEED STATUS": "Silver",
                "LEED LINK": "https://www.usgbc.org/projects/university-hawaii-translational-lab",
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 229.94998528944558,
                "SHAPE_Area": 1364.6843867954376
            }
        },
        {
            "type": "Feature",
            "id": 90,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81725155480936,
                            21.300968095184523
                        ],
                        [
                            -157.81713264597028,
                            21.300971779959319
                        ],
                        [
                            -157.81713581726666,
                            21.301061657943208
                        ],
                        [
                            -157.81736885346348,
                            21.301054437192221
                        ],
                        [
                            -157.81736631769354,
                            21.300982579079175
                        ],
                        [
                            -157.81742731585166,
                            21.300980688747927
                        ],
                        [
                            -157.81742705740388,
                            21.30097335230721
                        ],
                        [
                            -157.81754557381001,
                            21.300969679020746
                        ],
                        [
                            -157.81754395153152,
                            21.300922675975187
                        ],
                        [
                            -157.81754496782403,
                            21.300922645173998
                        ],
                        [
                            -157.81754444996724,
                            21.300907970478825
                        ],
                        [
                            -157.81759804280978,
                            21.300906309906885
                        ],
                        [
                            -157.8175978945753,
                            21.300902185792541
                        ],
                        [
                            -157.8175986322106,
                            21.300902162970356
                        ],
                        [
                            -157.81759571427168,
                            21.30081950033345
                        ],
                        [
                            -157.81756976783939,
                            21.300820303620561
                        ],
                        [
                            -157.81756973170874,
                            21.300819277115441
                        ],
                        [
                            -157.81756728358928,
                            21.300819345735686
                        ],
                        [
                            -157.81756732158996,
                            21.300820379481063
                        ],
                        [
                            -157.81754138768153,
                            21.300821183755176
                        ],
                        [
                            -157.81753938543369,
                            21.300764441299574
                        ],
                        [
                            -157.8174747956208,
                            21.300766441944784
                        ],
                        [
                            -157.81724138864558,
                            21.300773674709163
                        ],
                        [
                            -157.8172434000181,
                            21.300830708119495
                        ],
                        [
                            -157.81721771102792,
                            21.300831504127647
                        ],
                        [
                            -157.81721764032352,
                            21.30082949810468
                        ],
                        [
                            -157.81721470521401,
                            21.300829588591821
                        ],
                        [
                            -157.81721477591117,
                            21.300831595518126
                        ],
                        [
                            -157.81718835217782,
                            21.300832414362638
                        ],
                        [
                            -157.81718828147376,
                            21.30083040833966
                        ],
                        [
                            -157.81718534443644,
                            21.300830498812754
                        ],
                        [
                            -157.81718541514041,
                            21.300832504835718
                        ],
                        [
                            -157.81715899622665,
                            21.300833323709483
                        ],
                        [
                            -157.81715892552299,
                            21.300831317686512
                        ],
                        [
                            -157.81715598944234,
                            21.30083140906919
                        ],
                        [
                            -157.8171560562902,
                            21.300833415065057
                        ],
                        [
                            -157.81712987747585,
                            21.300834225684582
                        ],
                        [
                            -157.81712980677264,
                            21.300832219661636
                        ],
                        [
                            -157.81712687069194,
                            21.300832311043802
                        ],
                        [
                            -157.81712701696372,
                            21.300836437854461
                        ],
                        [
                            -157.8171276899933,
                            21.300836417290373
                        ],
                        [
                            -157.81712853938129,
                            21.300860491379261
                        ],
                        [
                            -157.81712665529389,
                            21.300860547696711
                        ],
                        [
                            -157.81712678804885,
                            21.300864677122512
                        ],
                        [
                            -157.8171292342989,
                            21.300864601268444
                        ],
                        [
                            -157.81713105496004,
                            21.300916189508765
                        ],
                        [
                            -157.81712860870914,
                            21.300916265362801
                        ],
                        [
                            -157.81712870525007,
                            21.300919017767562
                        ],
                        [
                            -157.81712992886114,
                            21.300918979392257
                        ],
                        [
                            -157.81713008106584,
                            21.300923328478529
                        ],
                        [
                            -157.81713252919411,
                            21.300923258961411
                        ],
                        [
                            -157.8171324394776,
                            21.300920737872477
                        ],
                        [
                            -157.81718895683764,
                            21.300918985967794
                        ],
                        [
                            -157.81718993552934,
                            21.300918955807845
                        ],
                        [
                            -157.81719002523241,
                            21.300921478703472
                        ],
                        [
                            -157.81719247239673,
                            21.300921409178688
                        ],
                        [
                            -157.81719238365037,
                            21.300918887193191
                        ],
                        [
                            -157.81724645288182,
                            21.30091720478714
                        ],
                        [
                            -157.81724685662454,
                            21.300928668934993
                        ],
                        [
                            -157.81724269790195,
                            21.300928797798683
                        ],
                        [
                            -157.81724277884609,
                            21.300931090268268
                        ],
                        [
                            -157.8172469375688,
                            21.300930961404575
                        ],
                        [
                            -157.81724697071618,
                            21.300931878578506
                        ],
                        [
                            -157.81725027319592,
                            21.300931777122063
                        ],
                        [
                            -157.81725155480936,
                            21.300968095184523
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 90,
                "NUMBER": "1168",
                "PROPER_NAME": "SPALDING HALL",
                "DISPLAY_NAME": "SPALDING HALL (SPAL) - 1168",
                "ADDRESS": "2540 MAILE WAY",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "SPALDING HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1168_01.jpg",
                "HEIGHT (ft)": 56.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 189.88054314355426,
                "SHAPE_Area": 1102.2769024500203
            }
        },
        {
            "type": "Feature",
            "id": 91,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81390117818421,
                            21.300831413992732
                        ],
                        [
                            -157.81390775636368,
                            21.301025166896078
                        ],
                        [
                            -157.8139677030297,
                            21.301023369783614
                        ],
                        [
                            -157.8139611257281,
                            21.300829617789038
                        ],
                        [
                            -157.81390117818421,
                            21.300831413992732
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 91,
                "NUMBER": "1179B",
                "PROPER_NAME": "LINCOLN HALL ANNEX 2",
                "DISPLAY_NAME": "LINCOLN HALL ANNEX 2 - 1179B",
                "ADDRESS": "1821 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "LINCOLN HALL ANNEX 2",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1179B_01.jpg",
                "HEIGHT (ft)": 16.699999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.361483168209233,
                "SHAPE_Area": 133.51630549057211
            }
        },
        {
            "type": "Feature",
            "id": 92,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81951686595531,
                            21.301016310469283
                        ],
                        [
                            -157.81953900889766,
                            21.301025717424459
                        ],
                        [
                            -157.81954624290509,
                            21.301009760087897
                        ],
                        [
                            -157.81952391262286,
                            21.301000635484211
                        ],
                        [
                            -157.81951686595531,
                            21.301016310469283
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 92,
                "NUMBER": "1252B",
                "PROPER_NAME": "PARKING KIOSK - MAILE WAY",
                "DISPLAY_NAME": "PARKING KIOSK - MAILE WAY - 1252B",
                "ADDRESS": "2600 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PARKING KIOSK - MAILE WAY",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1252B_01.jpg",
                "HEIGHT (ft)": 8.5999999999999996,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 8.8513223142344479,
                "SHAPE_Area": 4.7984925591154219
            }
        },
        {
            "type": "Feature",
            "id": 93,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81568841351753,
                            21.301187345658668
                        ],
                        [
                            -157.81578546310621,
                            21.301184254285893
                        ],
                        [
                            -157.81578027944099,
                            21.301041370210552
                        ],
                        [
                            -157.81574769786869,
                            21.301042408379033
                        ],
                        [
                            -157.81574758422352,
                            21.301039267396586
                        ],
                        [
                            -157.81574423253772,
                            21.301039373897421
                        ],
                        [
                            -157.81574354315717,
                            21.301020382504156
                        ],
                        [
                            -157.81574689484253,
                            21.30102027600331
                        ],
                        [
                            -157.81574679539943,
                            21.301017528095326
                        ],
                        [
                            -157.81576665675047,
                            21.301016895468738
                        ],
                        [
                            -157.8157664427047,
                            21.30101100566818
                        ],
                        [
                            -157.81577272663239,
                            21.301010805974766
                        ],
                        [
                            -157.81577075995256,
                            21.30095656706931
                        ],
                        [
                            -157.81576447506325,
                            21.300956766755974
                        ],
                        [
                            -157.81576426197421,
                            21.300950877865485
                        ],
                        [
                            -157.81574434760111,
                            21.300951511925781
                        ],
                        [
                            -157.81574372615651,
                            21.300934388317003
                        ],
                        [
                            -157.81574801957066,
                            21.300930082260795
                        ],
                        [
                            -157.81574342465191,
                            21.300926059652031
                        ],
                        [
                            -157.81573916857067,
                            21.300930398492877
                        ],
                        [
                            -157.81570713761135,
                            21.300931417944621
                        ],
                        [
                            -157.81570615778844,
                            21.300904402406381
                        ],
                        [
                            -157.81570936001771,
                            21.300904300274691
                        ],
                        [
                            -157.8157139219127,
                            21.30089993287153
                        ],
                        [
                            -157.81570905851501,
                            21.300895971609716
                        ],
                        [
                            -157.81570585532199,
                            21.300896073734613
                        ],
                        [
                            -157.81570487550647,
                            21.300869057292921
                        ],
                        [
                            -157.81573690645951,
                            21.300868036937629
                        ],
                        [
                            -157.81574146639235,
                            21.300872094532519
                        ],
                        [
                            -157.81574575883349,
                            21.300867789372806
                        ],
                        [
                            -157.81574116392389,
                            21.300863765860694
                        ],
                        [
                            -157.81574044479055,
                            21.30084391603744
                        ],
                        [
                            -157.81573872170259,
                            21.30084397076218
                        ],
                        [
                            -157.8157365424324,
                            21.300783902592528
                        ],
                        [
                            -157.81573841498025,
                            21.300783842595873
                        ],
                        [
                            -157.81573819996427,
                            21.300777953691743
                        ],
                        [
                            -157.81573632838769,
                            21.300778012791849
                        ],
                        [
                            -157.81573574401824,
                            21.300761916597811
                        ],
                        [
                            -157.81573761752253,
                            21.300761857511269
                        ],
                        [
                            -157.8157374025138,
                            21.30075596770379
                        ],
                        [
                            -157.81573111859697,
                            21.300756167396379
                        ],
                        [
                            -157.81573117790586,
                            21.300757788494973
                        ],
                        [
                            -157.81571400198763,
                            21.30075833522444
                        ],
                        [
                            -157.81571394170774,
                            21.300756715022416
                        ],
                        [
                            -157.81570765779088,
                            21.300756914714125
                        ],
                        [
                            -157.81570771709954,
                            21.300758535812719
                        ],
                        [
                            -157.81564361956825,
                            21.300760577160631
                        ],
                        [
                            -157.81564356025311,
                            21.300758956965385
                        ],
                        [
                            -157.81563727536505,
                            21.300759157551024
                        ],
                        [
                            -157.81563733467291,
                            21.30076077864959
                        ],
                        [
                            -157.81562015779053,
                            21.300761325362675
                        ],
                        [
                            -157.81562009944679,
                            21.300759704270881
                        ],
                        [
                            -157.81561837056898,
                            21.300759759857069
                        ],
                        [
                            -157.81561778621239,
                            21.300743663663191
                        ],
                        [
                            -157.81561951509002,
                            21.300743608077017
                        ],
                        [
                            -157.81561930201389,
                            21.300737718283145
                        ],
                        [
                            -157.81561757313631,
                            21.300737773869336
                        ],
                        [
                            -157.81561539391473,
                            21.300677705699741
                        ],
                        [
                            -157.81561712375552,
                            21.300677650120338
                        ],
                        [
                            -157.81561690970824,
                            21.300671761222979
                        ],
                        [
                            -157.81561517986754,
                            21.300671816802399
                        ],
                        [
                            -157.81561459648231,
                            21.300655719711823
                        ],
                        [
                            -157.81561632632284,
                            21.300655664132417
                        ],
                        [
                            -157.81561611227559,
                            21.300649775235048
                        ],
                        [
                            -157.81560982739219,
                            21.30064997581988
                        ],
                        [
                            -157.81560988670702,
                            21.300651596015136
                        ],
                        [
                            -157.81559271079411,
                            21.300652143636118
                        ],
                        [
                            -157.8155926514867,
                            21.300650522537524
                        ],
                        [
                            -157.8155863666033,
                            21.300650723121478
                        ],
                        [
                            -157.81558642591784,
                            21.300652343316731
                        ],
                        [
                            -157.81552232842628,
                            21.300654385523849
                        ],
                        [
                            -157.81552226911245,
                            21.300652765328618
                        ],
                        [
                            -157.81551598423619,
                            21.300652965006577
                        ],
                        [
                            -157.81551604354999,
                            21.300654585201823
                        ],
                        [
                            -157.81549886763688,
                            21.300655132813191
                        ],
                        [
                            -157.81549880832327,
                            21.30065351261797
                        ],
                        [
                            -157.81549252441096,
                            21.300653712301848
                        ],
                        [
                            -157.81549273845329,
                            21.300659601199133
                        ],
                        [
                            -157.81549446732268,
                            21.300659546517519
                        ],
                        [
                            -157.81549505165873,
                            21.300675643614682
                        ],
                        [
                            -157.81549332182522,
                            21.300675698289503
                        ],
                        [
                            -157.81549353586752,
                            21.300681587186769
                        ],
                        [
                            -157.81549526473719,
                            21.300681532505159
                        ],
                        [
                            -157.81549744390981,
                            21.300741600674016
                        ],
                        [
                            -157.81549571407552,
                            21.300741655348812
                        ],
                        [
                            -157.81549592811066,
                            21.300747545149399
                        ],
                        [
                            -157.81549765698108,
                            21.300747490467796
                        ],
                        [
                            -157.81549824132455,
                            21.300763586661475
                        ],
                        [
                            -157.81549651149001,
                            21.300763641336271
                        ],
                        [
                            -157.81549672552515,
                            21.300769531136837
                        ],
                        [
                            -157.81549845439585,
                            21.300769476455244
                        ],
                        [
                            -157.81549903873938,
                            21.300785572648891
                        ],
                        [
                            -157.81549730890455,
                            21.300785627323673
                        ],
                        [
                            -157.815497522947,
                            21.300791516220897
                        ],
                        [
                            -157.81549925278185,
                            21.300791461546094
                        ],
                        [
                            -157.81550143195534,
                            21.300851529714279
                        ],
                        [
                            -157.81549970115583,
                            21.300851584382272
                        ],
                        [
                            -157.81549991615501,
                            21.300857474189574
                        ],
                        [
                            -157.81550164502673,
                            21.300857419507999
                        ],
                        [
                            -157.81550223552526,
                            21.30087370997359
                        ],
                        [
                            -157.81550050664612,
                            21.300873765558503
                        ],
                        [
                            -157.8155007197247,
                            21.300879654448867
                        ],
                        [
                            -157.81550905071862,
                            21.300879389675806
                        ],
                        [
                            -157.81550983412163,
                            21.300900959101696
                        ],
                        [
                            -157.8154948759267,
                            21.300901435596167
                        ],
                        [
                            -157.81549517750415,
                            21.30090975342091
                        ],
                        [
                            -157.81548922527611,
                            21.300909942791453
                        ],
                        [
                            -157.81548952212674,
                            21.300918128688007
                        ],
                        [
                            -157.81548399320369,
                            21.300918303873576
                        ],
                        [
                            -157.81548558162737,
                            21.300962112288985
                        ],
                        [
                            -157.81552855282729,
                            21.300960743485362
                        ],
                        [
                            -157.81553325282863,
                            21.301090334390295
                        ],
                        [
                            -157.81556550462861,
                            21.301089308396968
                        ],
                        [
                            -157.81556823149617,
                            21.301089220990097
                        ],
                        [
                            -157.81557793751031,
                            21.301088911688787
                        ],
                        [
                            -157.81557921347573,
                            21.301124078788966
                        ],
                        [
                            -157.8155928169347,
                            21.301123646052741
                        ],
                        [
                            -157.81559399731285,
                            21.301156186326267
                        ],
                        [
                            -157.81559499309191,
                            21.301183613921651
                        ],
                        [
                            -157.81560706920169,
                            21.301183230058154
                        ],
                        [
                            -157.8156881712595,
                            21.301180646222519
                        ],
                        [
                            -157.81568841351753,
                            21.301187345658668
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 93,
                "NUMBER": "1201",
                "PROPER_NAME": "PARADISE PALMS CAFE",
                "DISPLAY_NAME": "PARADISE PALMS CAFE - 1201",
                "ADDRESS": "2560 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PARADISE PALMS CAFE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1201_01.jpg",
                "HEIGHT (ft)": 27.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 204.71873756912106,
                "SHAPE_Area": 1253.5708815609312
            }
        },
        {
            "type": "Feature",
            "id": 94,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81390960580089,
                            21.301079635333785
                        ],
                        [
                            -157.81391618206459,
                            21.301273387315337
                        ],
                        [
                            -157.81397613075939,
                            21.301271590218207
                        ],
                        [
                            -157.81396955248903,
                            21.301077838221701
                        ],
                        [
                            -157.81390960580089,
                            21.301079635333785
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 94,
                "NUMBER": "1179A",
                "PROPER_NAME": "LINCOLN HALL ANNEX 1",
                "DISPLAY_NAME": "LINCOLN HALL ANNEX 1 - 1179A",
                "ADDRESS": "1821 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "LINCOLN HALL ANNEX 1",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1179A_01.jpg",
                "HEIGHT (ft)": 18,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.361483188197219,
                "SHAPE_Area": 133.51709664557978
            }
        },
        {
            "type": "Feature",
            "id": 95,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81374626845411,
                            21.300880121396602
                        ],
                        [
                            -157.81376162281347,
                            21.301306115324497
                        ],
                        [
                            -157.81384456167456,
                            21.301303489319956
                        ],
                        [
                            -157.81382920707557,
                            21.300877495388381
                        ],
                        [
                            -157.81374626845411,
                            21.300880121396602
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 95,
                "NUMBER": "1077B",
                "PROPER_NAME": "MAILE-EAST BUILDING B",
                "DISPLAY_NAME": "MAILE-EAST BUILDING B - 1077B",
                "ADDRESS": "1859 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAILE-EAST BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "Temporary Portable 2 , TP 2 , TP2",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1077B_01.jpg",
                "HEIGHT (ft)": 14.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 111.58429598437877,
                "SHAPE_Area": 406.19351614519508
            }
        },
        {
            "type": "Feature",
            "id": 96,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81358039364196,
                            21.30141125602773
                        ],
                        [
                            -157.81366379044877,
                            21.301414635461271
                        ],
                        [
                            -157.81368735626575,
                            21.300903767870082
                        ],
                        [
                            -157.81360395974548,
                            21.300900388461447
                        ],
                        [
                            -157.81358039364196,
                            21.30141125602773
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 96,
                "NUMBER": "1077A",
                "PROPER_NAME": "MAILE-EAST BUILDING A",
                "DISPLAY_NAME": "MAILE-EAST BUILDING A - 1077A",
                "ADDRESS": "1859 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAILE-EAST BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "Temporary Portable 1 , TP 1 , TP1",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1077A_01.jpg",
                "HEIGHT (ft)": 13.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 130.52808160230396,
                "SHAPE_Area": 490.1677318147062
            }
        },
        {
            "type": "Feature",
            "id": 97,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81760080703694,
                            21.301471939194965
                        ],
                        [
                            -157.81761154435299,
                            21.301526596568639
                        ],
                        [
                            -157.81781377742908,
                            21.301491706568722
                        ],
                        [
                            -157.81780304003942,
                            21.301437049204377
                        ],
                        [
                            -157.81760080703694,
                            21.301471939194965
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 97,
                "NUMBER": "1025B",
                "PROPER_NAME": "MAILE WAY BUILDING 2 - COPF-BGM OFFICE",
                "DISPLAY_NAME": "MAILE WAY BUILDING 2 - COPF-BGM OFFICE - 1025B",
                "ADDRESS": "2525 MAILE WAY",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "GILMORE HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1025B_01.jpg",
                "HEIGHT (ft)": 16.199999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 54.967785783997641,
                "SHAPE_Area": 131.23528090203746
            }
        },
        {
            "type": "Feature",
            "id": 98,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81589871011207,
                            21.301549868873895
                        ],
                        [
                            -157.81589430642322,
                            21.301550009530587
                        ],
                        [
                            -157.81589445652313,
                            21.301554135464201
                        ],
                        [
                            -157.8158966588496,
                            21.301554065139253
                        ],
                        [
                            -157.81589991116442,
                            21.301643482049272
                        ],
                        [
                            -157.81589770883659,
                            21.301643552374202
                        ],
                        [
                            -157.81589785892211,
                            21.301647680114446
                        ],
                        [
                            -157.81590006125722,
                            21.301647608886181
                        ],
                        [
                            -157.81590291397058,
                            21.301726020600469
                        ],
                        [
                            -157.81590071164152,
                            21.301726090925378
                        ],
                        [
                            -157.81590086173432,
                            21.301730217762238
                        ],
                        [
                            -157.81590306405619,
                            21.301730148340667
                        ],
                        [
                            -157.81590631925766,
                            21.301819566172792
                        ],
                        [
                            -157.81590411692724,
                            21.301819636497683
                        ],
                        [
                            -157.81590426413553,
                            21.301823762410816
                        ],
                        [
                            -157.81590866783256,
                            21.301823621754245
                        ],
                        [
                            -157.81590859278967,
                            21.301821557884168
                        ],
                        [
                            -157.81597098026617,
                            21.301819564948193
                        ],
                        [
                            -157.81597105530989,
                            21.301821628818285
                        ],
                        [
                            -157.81597545900689,
                            21.301821488159959
                        ],
                        [
                            -157.81597538492701,
                            21.301819424296649
                        ],
                        [
                            -157.81603703764785,
                            21.30181745507462
                        ],
                        [
                            -157.81603711173582,
                            21.301819518034605
                        ],
                        [
                            -157.81604151639672,
                            21.301819377381324
                        ],
                        [
                            -157.81604144134477,
                            21.301817314414553
                        ],
                        [
                            -157.81610309407233,
                            21.301815344264902
                        ],
                        [
                            -157.81610316911792,
                            21.301817408135022
                        ],
                        [
                            -157.81610757281484,
                            21.301817267473226
                        ],
                        [
                            -157.81610749873315,
                            21.301815203609884
                        ],
                        [
                            -157.81616915145298,
                            21.301813234339278
                        ],
                        [
                            -157.81616922650673,
                            21.301815297306071
                        ],
                        [
                            -157.81617363020365,
                            21.301815156642544
                        ],
                        [
                            -157.81617355514982,
                            21.301813093675744
                        ],
                        [
                            -157.81623520884037,
                            21.301811123484288
                        ],
                        [
                            -157.81623528292388,
                            21.301813187347673
                        ],
                        [
                            -157.81623968662072,
                            21.301813046682387
                        ],
                        [
                            -157.81623961253717,
                            21.301810982819021
                        ],
                        [
                            -157.81630126525604,
                            21.301809013499831
                        ],
                        [
                            -157.81630134030442,
                            21.301811077370012
                        ],
                        [
                            -157.81630574400126,
                            21.301810936702992
                        ],
                        [
                            -157.81630566895282,
                            21.301808872832829
                        ],
                        [
                            -157.81636805546245,
                            21.301806879742323
                        ],
                        [
                            -157.81636813148293,
                            21.301808942715958
                        ],
                        [
                            -157.81637253517971,
                            21.301808802047187
                        ],
                        [
                            -157.81637238507375,
                            21.301804675210168
                        ],
                        [
                            -157.81637018273622,
                            21.301804746444521
                        ],
                        [
                            -157.81636693013795,
                            21.301715329531842
                        ],
                        [
                            -157.81636913247414,
                            21.301715258297474
                        ],
                        [
                            -157.81636898140428,
                            21.30171113145364
                        ],
                        [
                            -157.8163667800321,
                            21.301711202694772
                        ],
                        [
                            -157.81636392803597,
                            21.301632790983575
                        ],
                        [
                            -157.81636612940702,
                            21.301632719742408
                        ],
                        [
                            -157.81636598026506,
                            21.301628592912078
                        ],
                        [
                            -157.81636377793743,
                            21.301628663243129
                        ],
                        [
                            -157.81636052533401,
                            21.301539247232199
                        ],
                        [
                            -157.81636272670366,
                            21.301539175991028
                        ],
                        [
                            -157.81636257659784,
                            21.30153504915388
                        ],
                        [
                            -157.81635817290922,
                            21.301535189822776
                        ],
                        [
                            -157.81635824699453,
                            21.301537253686231
                        ],
                        [
                            -157.81629586156293,
                            21.301539246785211
                        ],
                        [
                            -157.81629578555066,
                            21.301537182908213
                        ],
                        [
                            -157.81629138186199,
                            21.301537323575339
                        ],
                        [
                            -157.81629145691028,
                            21.301539387445573
                        ],
                        [
                            -157.81622980430416,
                            21.301541356766442
                        ],
                        [
                            -157.81622972828555,
                            21.301539293792789
                        ],
                        [
                            -157.81622532459687,
                            21.301539434458181
                        ],
                        [
                            -157.81622540061539,
                            21.301541497431849
                        ],
                        [
                            -157.81621243349835,
                            21.301541912109567
                        ],
                        [
                            -157.81617720303154,
                            21.301543036515703
                        ],
                        [
                            -157.81616374607367,
                            21.301543467618199
                        ],
                        [
                            -157.81616367199112,
                            21.30154140375479
                        ],
                        [
                            -157.81615926830241,
                            21.301541544418441
                        ],
                        [
                            -157.81615934334886,
                            21.30154360828865
                        ],
                        [
                            -157.81609768977782,
                            21.301545577554155
                        ],
                        [
                            -157.81609761473223,
                            21.301543513683978
                        ],
                        [
                            -157.81609321103625,
                            21.301543655249237
                        ],
                        [
                            -157.81609328705295,
                            21.301545718222876
                        ],
                        [
                            -157.81603163251748,
                            21.301547687457312
                        ],
                        [
                            -157.81603155842953,
                            21.301545624497262
                        ],
                        [
                            -157.81602715474074,
                            21.301545765157446
                        ],
                        [
                            -157.81602722882141,
                            21.301547829020844
                        ],
                        [
                            -157.81596557621333,
                            21.301549798244555
                        ],
                        [
                            -157.81596550116961,
                            21.301547734374402
                        ],
                        [
                            -157.81596109748079,
                            21.301547875032853
                        ],
                        [
                            -157.81596117252445,
                            21.301549938903001
                        ],
                        [
                            -157.81589878612604,
                            21.301551931847474
                        ],
                        [
                            -157.81589871011207,
                            21.301549868873895
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 98,
                "NUMBER": "1088",
                "PROPER_NAME": "AGRICULTURAL ENGINEERING INSTITUTE",
                "DISPLAY_NAME": "AGRICULTURAL ENGINEERING INSTITUTE (AEI) - 1088",
                "ADDRESS": "3131 MAILE WAY",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "AGRICULTURAL ENGINEERING INSTITUTE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1088_01.jpg",
                "HEIGHT (ft)": 23,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 166.99606442331216,
                "SHAPE_Area": 1440.2139187560713
            }
        },
        {
            "type": "Feature",
            "id": 99,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81491614033649,
                            21.301921735056524
                        ],
                        [
                            -157.81491646305946,
                            21.301932220260287
                        ],
                        [
                            -157.81492514112429,
                            21.301931958866241
                        ],
                        [
                            -157.81492524282839,
                            21.30193490372865
                        ],
                        [
                            -157.81492719249883,
                            21.30193484518815
                        ],
                        [
                            -157.81492708469858,
                            21.301931698826948
                        ],
                        [
                            -157.81498004021103,
                            21.30193009966094
                        ],
                        [
                            -157.81498014801241,
                            21.301933246022159
                        ],
                        [
                            -157.81498212854348,
                            21.301933185891553
                        ],
                        [
                            -157.81498202683824,
                            21.301930241029126
                        ],
                        [
                            -157.81499562922573,
                            21.301929830921434
                        ],
                        [
                            -157.81499573093123,
                            21.301932775783872
                        ],
                        [
                            -157.8149977104911,
                            21.301932716549651
                        ],
                        [
                            -157.81499760268935,
                            21.301929570188424
                        ],
                        [
                            -157.81505084939889,
                            21.301927962210026
                        ],
                        [
                            -157.81505095720178,
                            21.301931108571274
                        ],
                        [
                            -157.81505293869677,
                            21.301931048446622
                        ],
                        [
                            -157.81505283699011,
                            21.301928103584167
                        ],
                        [
                            -157.81506643937752,
                            21.301927693470734
                        ],
                        [
                            -157.81506654012773,
                            21.301930637423069
                        ],
                        [
                            -157.81506859200499,
                            21.301930575987068
                        ],
                        [
                            -157.8150684842017,
                            21.301927429625835
                        ],
                        [
                            -157.81512124203289,
                            21.301925838057119
                        ],
                        [
                            -157.8151213508157,
                            21.301928982618492
                        ],
                        [
                            -157.81512329952218,
                            21.301928924068921
                        ],
                        [
                            -157.81512319974203,
                            21.301925979220005
                        ],
                        [
                            -157.81513241103326,
                            21.301925700791919
                        ],
                        [
                            -157.81512848446678,
                            21.301811506393729
                        ],
                        [
                            -157.81506450046635,
                            21.30181363864066
                        ],
                        [
                            -157.81506439264865,
                            21.301810494086066
                        ],
                        [
                            -157.8150624111625,
                            21.301810553307572
                        ],
                        [
                            -157.81506251286939,
                            21.301813498170063
                        ],
                        [
                            -157.81504891048533,
                            21.301813909187015
                        ],
                        [
                            -157.81504880974987,
                            21.301810963427975
                        ],
                        [
                            -157.81504683018437,
                            21.301811023566231
                        ],
                        [
                            -157.81504693798723,
                            21.301814169927496
                        ],
                        [
                            -157.81499369036933,
                            21.301815776093118
                        ],
                        [
                            -157.81499358255314,
                            21.301812631538546
                        ],
                        [
                            -157.81499160203091,
                            21.301812690766006
                        ],
                        [
                            -157.81499170276524,
                            21.301815636525028
                        ],
                        [
                            -157.81497810135224,
                            21.301816046639683
                        ],
                        [
                            -157.81497799964703,
                            21.301813101777213
                        ],
                        [
                            -157.81497602008875,
                            21.301813161011292
                        ],
                        [
                            -157.81497612789011,
                            21.301816307372533
                        ],
                        [
                            -157.81492317242575,
                            21.3018179056359
                        ],
                        [
                            -157.81492306461831,
                            21.301814760178011
                        ],
                        [
                            -157.81492111494944,
                            21.301814818718537
                        ],
                        [
                            -157.81492121664627,
                            21.301817764484326
                        ],
                        [
                            -157.81491253858817,
                            21.3018180258785
                        ],
                        [
                            -157.81491266824247,
                            21.301821812896748
                        ],
                        [
                            -157.81488983630189,
                            21.3018224967681
                        ],
                        [
                            -157.81488954549994,
                            21.301814041705125
                        ],
                        [
                            -157.81489209202954,
                            21.301813964783737
                        ],
                        [
                            -157.81489202956203,
                            21.301812137690359
                        ],
                        [
                            -157.81488948303246,
                            21.301812214611747
                        ],
                        [
                            -157.81488920709717,
                            21.301804189666825
                        ],
                        [
                            -157.81488778045835,
                            21.301762828774603
                        ],
                        [
                            -157.81489170005193,
                            21.301762710030111
                        ],
                        [
                            -157.81489160953274,
                            21.301760053427657
                        ],
                        [
                            -157.81488790495601,
                            21.301760166459335
                        ],
                        [
                            -157.81488752046016,
                            21.301748969852866
                        ],
                        [
                            -157.81489122406541,
                            21.30174885771773
                        ],
                        [
                            -157.81489113354618,
                            21.301746201115268
                        ],
                        [
                            -157.8148872178088,
                            21.301746319886927
                        ],
                        [
                            -157.81488551943855,
                            21.301696890716372
                        ],
                        [
                            -157.81488820288916,
                            21.301696809338935
                        ],
                        [
                            -157.81488813968954,
                            21.301694953331914
                        ],
                        [
                            -157.81488545527503,
                            21.301695034702561
                        ],
                        [
                            -157.81488500901497,
                            21.301682043529592
                        ],
                        [
                            -157.81488769245806,
                            21.301681963055486
                        ],
                        [
                            -157.81488762925846,
                            21.301680107048455
                        ],
                        [
                            -157.81488494484421,
                            21.301680188419102
                        ],
                        [
                            -157.81488324956217,
                            21.301630855029252
                        ],
                        [
                            -157.81488593301157,
                            21.301630773651794
                        ],
                        [
                            -157.81488586884078,
                            21.301628918541315
                        ],
                        [
                            -157.81488318539144,
                            21.301628999918769
                        ],
                        [
                            -157.81488273913146,
                            21.301616008745711
                        ],
                        [
                            -157.81488542257333,
                            21.301615928271591
                        ],
                        [
                            -157.81488535937373,
                            21.301614072264535
                        ],
                        [
                            -157.81488267496795,
                            21.301614152731894
                        ],
                        [
                            -157.81488062238702,
                            21.301554438687234
                        ],
                        [
                            -157.8148784509431,
                            21.3015545046994
                        ],
                        [
                            -157.81487846571551,
                            21.30155494656087
                        ],
                        [
                            -157.81475822655145,
                            21.301558576000385
                        ],
                        [
                            -157.81475850790162,
                            21.301566766303853
                        ],
                        [
                            -157.81475596234026,
                            21.301566843230205
                        ],
                        [
                            -157.81475602384219,
                            21.301568670316808
                        ],
                        [
                            -157.81475857036753,
                            21.301568593397249
                        ],
                        [
                            -157.81476026431068,
                            21.30161784818274
                        ],
                        [
                            -157.81475757989762,
                            21.301617929551412
                        ],
                        [
                            -157.81475764405957,
                            21.301619785565208
                        ],
                        [
                            -157.81476032750146,
                            21.301619705093081
                        ],
                        [
                            -157.81476077472908,
                            21.301632694466079
                        ],
                        [
                            -157.81475809031576,
                            21.30163277583474
                        ],
                        [
                            -157.81475815447766,
                            21.301634631848533
                        ],
                        [
                            -157.81476083792711,
                            21.301634550473079
                        ],
                        [
                            -157.81476253413939,
                            21.301683882965694
                        ],
                        [
                            -157.81475984972511,
                            21.301683964334359
                        ],
                        [
                            -157.81475991388703,
                            21.301685820348141
                        ],
                        [
                            -157.81476259830134,
                            21.30168573897949
                        ],
                        [
                            -157.81476304455063,
                            21.301698730152282
                        ],
                        [
                            -157.81476036013609,
                            21.301698811520929
                        ],
                        [
                            -157.81476042430526,
                            21.301700666631373
                        ],
                        [
                            -157.81476310775591,
                            21.301700585255936
                        ],
                        [
                            -157.81476480396125,
                            21.301749918651556
                        ],
                        [
                            -157.81476212050973,
                            21.301750000026978
                        ],
                        [
                            -157.814762183715,
                            21.30175185513064
                        ],
                        [
                            -157.81476486813051,
                            21.301751773762003
                        ],
                        [
                            -157.81476531437985,
                            21.301764764934713
                        ],
                        [
                            -157.81476262996412,
                            21.301764846303335
                        ],
                        [
                            -157.8147626941261,
                            21.301766702317099
                        ],
                        [
                            -157.81476537854184,
                            21.301766620948477
                        ],
                        [
                            -157.81476707221074,
                            21.30181591005983
                        ],
                        [
                            -157.81476452568114,
                            21.3018159869793
                        ],
                        [
                            -157.81476458814706,
                            21.301817814072663
                        ],
                        [
                            -157.81476713468393,
                            21.301817736249838
                        ],
                        [
                            -157.81476742547889,
                            21.301826191312703
                        ],
                        [
                            -157.81479749881433,
                            21.301825284734395
                        ],
                        [
                            -157.81479814667941,
                            21.301844148454833
                        ],
                        [
                            -157.81479540923092,
                            21.301844231257192
                        ],
                        [
                            -157.81479554208593,
                            21.301848099602989
                        ],
                        [
                            -157.81479155884827,
                            21.301848220607045
                        ],
                        [
                            -157.81479165975966,
                            21.301851143782528
                        ],
                        [
                            -157.81479557452857,
                            21.301851025909794
                        ],
                        [
                            -157.81479812881096,
                            21.301925346775622
                        ],
                        [
                            -157.8147950702741,
                            21.30192543906043
                        ],
                        [
                            -157.81479516733665,
                            21.301928241154609
                        ],
                        [
                            -157.81479805038541,
                            21.301928153957494
                        ],
                        [
                            -157.81479814552011,
                            21.301930956038095
                        ],
                        [
                            -157.81480126577108,
                            21.301930861477725
                        ],
                        [
                            -157.81480117203532,
                            21.301928125354411
                        ],
                        [
                            -157.81489056290391,
                            21.301925425946504
                        ],
                        [
                            -157.81489065267644,
                            21.301928055441969
                        ],
                        [
                            -157.81489377294187,
                            21.3019279590732
                        ],
                        [
                            -157.81489367981337,
                            21.301925267220234
                        ],
                        [
                            -157.81489635651332,
                            21.301925186698679
                        ],
                        [
                            -157.81489625888332,
                            21.301922334914067
                        ],
                        [
                            -157.81489342115444,
                            21.301922420625253
                        ],
                        [
                            -157.8148929952695,
                            21.301910014089039
                        ],
                        [
                            -157.81491567694289,
                            21.301909317415465
                        ],
                        [
                            -157.81491614033649,
                            21.301921735056524
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 99,
                "NUMBER": "1198B",
                "PROPER_NAME": "ST. JOHN PLANT SCIENCE LABORATORY 2",
                "DISPLAY_NAME": "ST. JOHN PLANT SCIENCE LABORATORY 2 (STJHN) - 1198B",
                "ADDRESS": "3190 MAILE WAY",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ST. JOHN PLANT SCIENCE LABORATORY 1 AND 2",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "St John , Saint John",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1198B_01.jpg",
                "HEIGHT (ft)": 15.1,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 183.01288253525726,
                "SHAPE_Area": 796.49485014057802
            }
        },
        {
            "type": "Feature",
            "id": 100,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81477333681102,
                            21.302339890213066
                        ],
                        [
                            -157.81477644549327,
                            21.302338835269133
                        ],
                        [
                            -157.8147762009512,
                            21.302332185504429
                        ],
                        [
                            -157.81480262233723,
                            21.302331331801469
                        ],
                        [
                            -157.8148049801018,
                            21.302395298437435
                        ],
                        [
                            -157.81539606036301,
                            21.302376170324994
                        ],
                        [
                            -157.81539254668414,
                            21.302280794633688
                        ],
                        [
                            -157.81537356640445,
                            21.302281409020431
                        ],
                        [
                            -157.81537295838902,
                            21.302264900717137
                        ],
                        [
                            -157.81539193769538,
                            21.302264287226919
                        ],
                        [
                            -157.81538964007447,
                            21.302201925431454
                        ],
                        [
                            -157.81539942623417,
                            21.302201608577089
                        ],
                        [
                            -157.81538915318887,
                            21.301922816194683
                        ],
                        [
                            -157.81520762125498,
                            21.3019286848637
                        ],
                        [
                            -157.81521789487743,
                            21.302207482667885
                        ],
                        [
                            -157.8152262124799,
                            21.302207214203992
                        ],
                        [
                            -157.81522782602801,
                            21.302251004722049
                        ],
                        [
                            -157.81521510372789,
                            21.302251416527042
                        ],
                        [
                            -157.81521414885802,
                            21.302225508724369
                        ],
                        [
                            -157.81493328828202,
                            21.302234597494728
                        ],
                        [
                            -157.81492539831501,
                            21.30202045851264
                        ],
                        [
                            -157.81475316349469,
                            21.302026031708579
                        ],
                        [
                            -157.81475627145528,
                            21.302110403065949
                        ],
                        [
                            -157.81474648626619,
                            21.30211071988991
                        ],
                        [
                            -157.81474635084024,
                            21.302107052078561
                        ],
                        [
                            -157.81474439342702,
                            21.3021071141759
                        ],
                        [
                            -157.81474988015907,
                            21.302253790984185
                        ],
                        [
                            -157.81475269789303,
                            21.302275790294427
                        ],
                        [
                            -157.81475641860575,
                            21.302293017938585
                        ],
                        [
                            -157.81476176768132,
                            21.302309864077881
                        ],
                        [
                            -157.81477333681102,
                            21.302339890213066
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 100,
                "NUMBER": "1090",
                "PROPER_NAME": "SHERMAN LABORATORY",
                "DISPLAY_NAME": "SHERMAN LABORATORY (SHER) - 1090",
                "ADDRESS": "1910 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "SHERMAN LABORATORY",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1090_01.jpg",
                "HEIGHT (ft)": 30,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 294.86914070154143,
                "SHAPE_Area": 2159.5630740753691
            }
        },
        {
            "type": "Feature",
            "id": 101,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8155016377936,
                            21.302354016232709
                        ],
                        [
                            -157.81550380706204,
                            21.302410989308907
                        ],
                        [
                            -157.81563916588215,
                            21.302406209167913
                        ],
                        [
                            -157.81565613921171,
                            21.30233774510388
                        ],
                        [
                            -157.81559070364185,
                            21.302339942306897
                        ],
                        [
                            -157.81558862481108,
                            21.302351183908389
                        ],
                        [
                            -157.8155016377936,
                            21.302354016232709
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 101,
                "NUMBER": "1138",
                "PROPER_NAME": "UH CANCER CENTER FREEZER FACILITY",
                "DISPLAY_NAME": "UH CANCER CENTER FREEZER FACILITY - 1138",
                "ADDRESS": "EDMONDSON ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UH CANCER CENTER FREEZER FACILITY",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1138_01.jpg",
                "HEIGHT (ft)": 17.300000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 45.227850972572021,
                "SHAPE_Area": 102.07100104381934
            }
        },
        {
            "type": "Feature",
            "id": 102,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81486230170802,
                            21.302809598126622
                        ],
                        [
                            -157.81490927594263,
                            21.302808114058049
                        ],
                        [
                            -157.81490828580411,
                            21.302780600686003
                        ],
                        [
                            -157.81503404185412,
                            21.302776626992507
                        ],
                        [
                            -157.81503447066098,
                            21.302788550234986
                        ],
                        [
                            -157.81503642711934,
                            21.302788488127902
                        ],
                        [
                            -157.81503599926901,
                            21.302776565795561
                        ],
                        [
                            -157.81505948638517,
                            21.302775823286709
                        ],
                        [
                            -157.81506047655191,
                            21.302803336659188
                        ],
                        [
                            -157.81513093404277,
                            21.302801110892624
                        ],
                        [
                            -157.81512994387012,
                            21.3027735966166
                        ],
                        [
                            -157.81515343579849,
                            21.302772855031876
                        ],
                        [
                            -157.81515383148081,
                            21.302783861100927
                        ],
                        [
                            -157.81521548539715,
                            21.302781912983026
                        ],
                        [
                            -157.81521508971016,
                            21.302770906913882
                        ],
                        [
                            -157.81523857681862,
                            21.302770165283295
                        ],
                        [
                            -157.81523956702603,
                            21.302797677752942
                        ],
                        [
                            -157.81531002933519,
                            21.302795451945066
                        ],
                        [
                            -157.81530904008579,
                            21.302767938578654
                        ],
                        [
                            -157.81535014205033,
                            21.30276663979317
                        ],
                        [
                            -157.81535050558313,
                            21.302776727792349
                        ],
                        [
                            -157.81540971320189,
                            21.302774857236336
                        ],
                        [
                            -157.81540935062898,
                            21.302764769243879
                        ],
                        [
                            -157.81546023969608,
                            21.302763160811168
                        ],
                        [
                            -157.8154612299376,
                            21.302790674184802
                        ],
                        [
                            -157.81550820416908,
                            21.302789189948427
                        ],
                        [
                            -157.81550246328442,
                            21.302629629019922
                        ],
                        [
                            -157.81547408181342,
                            21.302630509685443
                        ],
                        [
                            -157.81547431280285,
                            21.302636929893829
                        ],
                        [
                            -157.81546330401818,
                            21.302637276990421
                        ],
                        [
                            -157.81546300674978,
                            21.302629023338181
                        ],
                        [
                            -157.8154617831247,
                            21.302629061700674
                        ],
                        [
                            -157.81546207942188,
                            21.302637316249459
                        ],
                        [
                            -157.81542109995766,
                            21.302638610505817
                        ],
                        [
                            -157.81542057266122,
                            21.302623937555374
                        ],
                        [
                            -157.81545714745846,
                            21.302622781225889
                        ],
                        [
                            -157.81545092193315,
                            21.302451169280975
                        ],
                        [
                            -157.815285950342,
                            21.302456382187504
                        ],
                        [
                            -157.81529212456434,
                            21.302627996479821
                        ],
                        [
                            -157.81532075205075,
                            21.302627091378799
                        ],
                        [
                            -157.81532128029394,
                            21.302641765239208
                        ],
                        [
                            -157.81528588862463,
                            21.302642883795983
                        ],
                        [
                            -157.81528565764341,
                            21.302636463587735
                        ],
                        [
                            -157.81528370022309,
                            21.302636525691014
                        ],
                        [
                            -157.81528393120419,
                            21.302642945899276
                        ],
                        [
                            -157.81526925250066,
                            21.302643408976767
                        ],
                        [
                            -157.81526902152015,
                            21.302636988768512
                        ],
                        [
                            -157.81526706409983,
                            21.302637050871613
                        ],
                        [
                            -157.81526729508019,
                            21.302643471079865
                        ],
                        [
                            -157.81522594823545,
                            21.302644777156129
                        ],
                        [
                            -157.81522541999448,
                            21.302630104199203
                        ],
                        [
                            -157.81526199575649,
                            21.302628947919089
                        ],
                        [
                            -157.81525582225797,
                            21.302457367960937
                        ],
                        [
                            -157.81509070217203,
                            21.302462585050211
                        ],
                        [
                            -157.81509697280077,
                            21.302634170207646
                        ],
                        [
                            -157.81512560028781,
                            21.302633265139946
                        ],
                        [
                            -157.81512612857679,
                            21.302647930870023
                        ],
                        [
                            -157.81509275603423,
                            21.302648985912313
                        ],
                        [
                            -157.8150925267141,
                            21.302642600044607
                        ],
                        [
                            -157.81509056833701,
                            21.30264266123552
                        ],
                        [
                            -157.81509079862099,
                            21.302649047109998
                        ],
                        [
                            -157.81507416152544,
                            21.302649573167972
                        ],
                        [
                            -157.8150739322061,
                            21.302643187300291
                        ],
                        [
                            -157.815071974793,
                            21.302643248497763
                        ],
                        [
                            -157.81507220506893,
                            21.302649635275582
                        ],
                        [
                            -157.81503085822328,
                            21.302650941303739
                        ],
                        [
                            -157.81503033166885,
                            21.302636300880881
                        ],
                        [
                            -157.81506690838836,
                            21.302635145553431
                        ],
                        [
                            -157.81506067753367,
                            21.302463533574677
                        ],
                        [
                            -157.81489570979096,
                            21.302468746124372
                        ],
                        [
                            -157.81490188356625,
                            21.302640359506359
                        ],
                        [
                            -157.81493051105394,
                            21.302639454471972
                        ],
                        [
                            -157.81493103759843,
                            21.302654094894692
                        ],
                        [
                            -157.81489761877125,
                            21.302655151378953
                        ],
                        [
                            -157.81489738704585,
                            21.302648705870681
                        ],
                        [
                            -157.81489542962544,
                            21.302648767969441
                        ],
                        [
                            -157.81489566135798,
                            21.302655212574379
                        ],
                        [
                            -157.81488517132811,
                            21.302655544315382
                        ],
                        [
                            -157.81488494055998,
                            21.302649099717257
                        ],
                        [
                            -157.8148565589639,
                            21.302649995634987
                        ],
                        [
                            -157.81486230170802,
                            21.302809598126622
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 102,
                "NUMBER": "1169",
                "PROPER_NAME": "POPE LABORATORY",
                "DISPLAY_NAME": "POPE LABORATORY - 1169",
                "ADDRESS": "3190 MAILE WAY",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "POPE LABORATORY COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1169_01.jpg",
                "HEIGHT (ft)": 21.400000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 369.7785519709214,
                "SHAPE_Area": 2054.4013031370187
            }
        },
        {
            "type": "Feature",
            "id": 103,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81382618985887,
                            21.302393884255395
                        ],
                        [
                            -157.81382578708312,
                            21.302393622143466
                        ],
                        [
                            -157.81382355722894,
                            21.302396640005391
                        ],
                        [
                            -157.81382516739703,
                            21.302397684832986
                        ],
                        [
                            -157.81382656105046,
                            21.302395799346769
                        ],
                        [
                            -157.81384427193709,
                            21.3024072924423
                        ],
                        [
                            -157.81384287731257,
                            21.302409178825215
                        ],
                        [
                            -157.81384448748094,
                            21.302410223652618
                        ],
                        [
                            -157.81384588210545,
                            21.302408337269693
                        ],
                        [
                            -157.81386359106,
                            21.302419831253061
                        ],
                        [
                            -157.81386219836347,
                            21.302421717649729
                        ],
                        [
                            -157.8138638075682,
                            21.302422762470165
                        ],
                        [
                            -157.81386520122865,
                            21.30242087608028
                        ],
                        [
                            -157.81388291115019,
                            21.302432370068534
                        ],
                        [
                            -157.81388151749709,
                            21.302434255555234
                        ],
                        [
                            -157.81388312766603,
                            21.302435300382292
                        ],
                        [
                            -157.81388452131912,
                            21.302433414895596
                        ],
                        [
                            -157.81390223221493,
                            21.302444907985382
                        ],
                        [
                            -157.81390083759072,
                            21.302446794368787
                        ],
                        [
                            -157.81390244775994,
                            21.302447839195672
                        ],
                        [
                            -157.8139035626867,
                            21.302446330264182
                        ],
                        [
                            -157.81392127357836,
                            21.302457824255438
                        ],
                        [
                            -157.81392015768773,
                            21.302459333180252
                        ],
                        [
                            -157.81392176785724,
                            21.302460378006963
                        ],
                        [
                            -157.81392288374781,
                            21.302458869082141
                        ],
                        [
                            -157.81394059272191,
                            21.302470362154558
                        ],
                        [
                            -157.81393947779532,
                            21.302471871086301
                        ],
                        [
                            -157.81394108796508,
                            21.302472915912837
                        ],
                        [
                            -157.81394220289164,
                            21.302471406981088
                        ],
                        [
                            -157.81395991282545,
                            21.302482900961728
                        ],
                        [
                            -157.81395879789898,
                            21.302484409893601
                        ],
                        [
                            -157.81396040806905,
                            21.302485454719964
                        ],
                        [
                            -157.81396152299553,
                            21.302483945788079
                        ],
                        [
                            -157.81397923293963,
                            21.302495438863474
                        ],
                        [
                            -157.81397811801324,
                            21.302496947795479
                        ],
                        [
                            -157.81397972817632,
                            21.302497993525005
                        ],
                        [
                            -157.81398084213879,
                            21.3024964845862
                        ],
                        [
                            -157.81399855304991,
                            21.302507977666476
                        ],
                        [
                            -157.81399743812361,
                            21.302509486598613
                        ],
                        [
                            -157.81399904829422,
                            21.302510531424623
                        ],
                        [
                            -157.8140001632205,
                            21.30250902249248
                        ],
                        [
                            -157.81401787316352,
                            21.302520516467393
                        ],
                        [
                            -157.8140167582373,
                            21.302522025399657
                        ],
                        [
                            -157.8140183684082,
                            21.302523070225497
                        ],
                        [
                            -157.81401948333439,
                            21.302521561293222
                        ],
                        [
                            -157.8140371932877,
                            21.302533054362886
                        ],
                        [
                            -157.81403607836157,
                            21.302534563295282
                        ],
                        [
                            -157.8140376885255,
                            21.302535609024289
                        ],
                        [
                            -157.81403880248769,
                            21.30253410008509
                        ],
                        [
                            -157.81405651340799,
                            21.302545593159635
                        ],
                        [
                            -157.81405539848197,
                            21.302547102092163
                        ],
                        [
                            -157.81405700768946,
                            21.302548146910866
                        ],
                        [
                            -157.81405812357943,
                            21.30254663798512
                        ],
                        [
                            -157.8140758335316,
                            21.302558131954299
                        ],
                        [
                            -157.81407471860567,
                            21.302559640886955
                        ],
                        [
                            -157.81407632877739,
                            21.302560685712276
                        ],
                        [
                            -157.81407744370335,
                            21.302559176779607
                        ],
                        [
                            -157.81409515366585,
                            21.302570669843544
                        ],
                        [
                            -157.81409403873997,
                            21.30257217877633
                        ],
                        [
                            -157.81409564891197,
                            21.302573223601478
                        ],
                        [
                            -157.8140967628739,
                            21.302571714661887
                        ],
                        [
                            -157.81411447379614,
                            21.30258320863404
                        ],
                        [
                            -157.81411335790642,
                            21.302584717560162
                        ],
                        [
                            -157.81411496807871,
                            21.302585762385149
                        ],
                        [
                            -157.81411608300448,
                            21.302584253452206
                        ],
                        [
                            -157.81413379392978,
                            21.302595747422451
                        ],
                        [
                            -157.8141326790041,
                            21.302597256355494
                        ],
                        [
                            -157.81413428917668,
                            21.302598301180314
                        ],
                        [
                            -157.81413540410233,
                            21.302596792247254
                        ],
                        [
                            -157.81415311407403,
                            21.302608285305439
                        ],
                        [
                            -157.81415199914844,
                            21.302609794238617
                        ],
                        [
                            -157.81415360932127,
                            21.302610839063259
                        ],
                        [
                            -157.81415472328294,
                            21.302609330123278
                        ],
                        [
                            -157.81417243325041,
                            21.302620824082886
                        ],
                        [
                            -157.8141713183249,
                            21.302622333016195
                        ],
                        [
                            -157.81417292849804,
                            21.302623377840664
                        ],
                        [
                            -157.81417404342352,
                            21.302621868907345
                        ],
                        [
                            -157.81419175435803,
                            21.302633362871838
                        ],
                        [
                            -157.81419063943261,
                            21.302634871805278
                        ],
                        [
                            -157.81419224960601,
                            21.302635916629576
                        ],
                        [
                            -157.8144138499741,
                            21.302336046038612
                        ],
                        [
                            -157.81441223980218,
                            21.302335001216498
                        ],
                        [
                            -157.81441112488136,
                            21.302336510151662
                        ],
                        [
                            -157.81439341492685,
                            21.302325016217502
                        ],
                        [
                            -157.81439452984779,
                            21.302323507282463
                        ],
                        [
                            -157.81439291967615,
                            21.302322462460172
                        ],
                        [
                            -157.81439180475522,
                            21.302323971395207
                        ],
                        [
                            -157.81437409479653,
                            21.302312478362474
                        ],
                        [
                            -157.81437520971753,
                            21.302310969427563
                        ],
                        [
                            -157.81437359954617,
                            21.302309924605098
                        ],
                        [
                            -157.81437248462518,
                            21.302311433540002
                        ],
                        [
                            -157.81435477371284,
                            21.30229993959523
                        ],
                        [
                            -157.81435588959789,
                            21.302298430667243
                        ],
                        [
                            -157.81435427942682,
                            21.302297385844604
                        ],
                        [
                            -157.81435316546964,
                            21.302298894786169
                        ],
                        [
                            -157.81433545456039,
                            21.302287400839489
                        ],
                        [
                            -157.81433656948158,
                            21.302285891904837
                        ],
                        [
                            -157.81433495931077,
                            21.302284847082024
                        ],
                        [
                            -157.81433384438961,
                            21.302286356016669
                        ],
                        [
                            -157.81431613444008,
                            21.302274862978205
                        ],
                        [
                            -157.81431724936135,
                            21.302273354043685
                        ],
                        [
                            -157.81431563919082,
                            21.302272309220704
                        ],
                        [
                            -157.81431452426955,
                            21.302273818155214
                        ],
                        [
                            -157.81430486421081,
                            21.3022675492237
                        ],
                        [
                            -157.81428590960257,
                            21.302293198391148
                        ],
                        [
                            -157.8142778606782,
                            21.302287974288152
                        ],
                        [
                            -157.81427925337553,
                            21.302286086984392
                        ],
                        [
                            -157.8142776441691,
                            21.302285042167824
                        ],
                        [
                            -157.81427624667381,
                            21.302286926727604
                        ],
                        [
                            -157.81425853865693,
                            21.302275433696884
                        ],
                        [
                            -157.8142599332605,
                            21.302273549116883
                        ],
                        [
                            -157.8142583230904,
                            21.302272504293352
                        ],
                        [
                            -157.81425692944353,
                            21.302274389783488
                        ],
                        [
                            -157.81423922046579,
                            21.30226289674405
                        ],
                        [
                            -157.81424061315604,
                            21.302261010343937
                        ],
                        [
                            -157.81423900298623,
                            21.30225996552025
                        ],
                        [
                            -157.81423761029598,
                            21.302261851920349
                        ],
                        [
                            -157.81421989940063,
                            21.30225035796208
                        ],
                        [
                            -157.81422129401165,
                            21.30224847247905
                        ],
                        [
                            -157.81421968384936,
                            21.302247426751851
                        ],
                        [
                            -157.81421828923109,
                            21.302249313138191
                        ],
                        [
                            -157.81420057929552,
                            21.302237820088159
                        ],
                        [
                            -157.81420197391387,
                            21.302235933701951
                        ],
                        [
                            -157.81420036374465,
                            21.302234888877916
                        ],
                        [
                            -157.81419896913349,
                            21.302236774360754
                        ],
                        [
                            -157.81418126016493,
                            21.302225281315604
                        ],
                        [
                            -157.81418265285555,
                            21.30222339491598
                        ],
                        [
                            -157.81418104268656,
                            21.302222350091771
                        ],
                        [
                            -157.81417964999594,
                            21.302224236491366
                        ],
                        [
                            -157.81416193910977,
                            21.302212742527384
                        ],
                        [
                            -157.81416333372115,
                            21.302210857044841
                        ],
                        [
                            -157.81416172355969,
                            21.302209811317123
                        ],
                        [
                            -157.81416032990501,
                            21.302211697709762
                        ],
                        [
                            -157.81414261901469,
                            21.302200204647203
                        ],
                        [
                            -157.81414401363341,
                            21.302198318261492
                        ],
                        [
                            -157.81414240346498,
                            21.302197273436938
                        ],
                        [
                            -157.81414100885351,
                            21.302199158919279
                        ],
                        [
                            -157.81412329989411,
                            21.302187665868399
                        ],
                        [
                            -157.81412469258507,
                            21.302185779469266
                        ],
                        [
                            -157.81412308241693,
                            21.302184734644538
                        ],
                        [
                            -157.81412168972597,
                            21.302186621043639
                        ],
                        [
                            -157.81410397981296,
                            21.302175127080702
                        ],
                        [
                            -157.81410537346071,
                            21.302173241591873
                        ],
                        [
                            -157.81410376329285,
                            21.302172196766971
                        ],
                        [
                            -157.81410236964507,
                            21.302174082255785
                        ],
                        [
                            -157.81408465876393,
                            21.302162589187475
                        ],
                        [
                            -157.81408605338299,
                            21.302160702802272
                        ],
                        [
                            -157.81408444321539,
                            21.302159657977196
                        ],
                        [
                            -157.81408304859636,
                            21.302161544362388
                        ],
                        [
                            -157.81406533965338,
                            21.302150050402421
                        ],
                        [
                            -157.81406673234468,
                            21.302148164003789
                        ],
                        [
                            -157.81406512217737,
                            21.302147119178539
                        ],
                        [
                            -157.81406372948609,
                            21.30214900557716
                        ],
                        [
                            -157.81404601958224,
                            21.302137511608485
                        ],
                        [
                            -157.81404741323033,
                            21.302135626120148
                        ],
                        [
                            -157.81404580305605,
                            21.302134582198065
                        ],
                        [
                            -157.8140444094152,
                            21.30213646678305
                        ],
                        [
                            -157.81402669854324,
                            21.302124973709013
                        ],
                        [
                            -157.81402809316265,
                            21.302123087324297
                        ],
                        [
                            -157.81402648298865,
                            21.302122043402036
                        ],
                        [
                            -157.81402425315002,
                            21.302125060363757
                        ],
                        [
                            -157.81402465496876,
                            21.302125321565068
                        ],
                        [
                            -157.81382618985887,
                            21.302393884255395
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 103,
                "NUMBER": "1188",
                "PROPER_NAME": "CAMPUS SERVICES",
                "DISPLAY_NAME": "CAMPUS SERVICES - 1188",
                "ADDRESS": "1951 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CAMPUS SERVICES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1188_01.jpg",
                "HEIGHT (ft)": 19.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 191.17285403997289,
                "SHAPE_Area": 1745.4386692818125
            }
        },
        {
            "type": "Feature",
            "id": 104,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81332684778849,
                            21.303359174116835
                        ],
                        [
                            -157.81349869549101,
                            21.303473080130228
                        ],
                        [
                            -157.81353347080727,
                            21.303427006785164
                        ],
                        [
                            -157.8133616221638,
                            21.303313100801141
                        ],
                        [
                            -157.81332684778849,
                            21.303359174116835
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 104,
                "NUMBER": "1193A",
                "PROPER_NAME": "PHYSICAL PLANT BUILDING 1",
                "DISPLAY_NAME": "PHYSICAL PLANT BUILDING 1 - 1193A",
                "ADDRESS": "2002 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PHYSICAL PLANT BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1193A_01.jpg",
                "HEIGHT (ft)": 14.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 56.165154811592245,
                "SHAPE_Area": 136.4075693957995
            }
        },
        {
            "type": "Feature",
            "id": 105,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81302764967771,
                            21.303265055429307
                        ],
                        [
                            -157.81317347951716,
                            21.303356752701209
                        ],
                        [
                            -157.81317511872504,
                            21.30335778328573
                        ],
                        [
                            -157.81318658740446,
                            21.303364996432922
                        ],
                        [
                            -157.81320033305852,
                            21.30334580422506
                        ],
                        [
                            -157.81320524779065,
                            21.303348895957448
                        ],
                        [
                            -157.81320634752601,
                            21.303347359822471
                        ],
                        [
                            -157.8132014327939,
                            21.303344268090111
                        ],
                        [
                            -157.81323771902541,
                            21.303293600891607
                        ],
                        [
                            -157.81324263473516,
                            21.303296690822989
                        ],
                        [
                            -157.81324373445523,
                            21.303295156494393
                        ],
                        [
                            -157.81323881876,
                            21.30329206475637
                        ],
                        [
                            -157.81325256344351,
                            21.303272871633311
                        ],
                        [
                            -157.81323413125463,
                            21.303261280337939
                        ],
                        [
                            -157.81323578085977,
                            21.303258975683423
                        ],
                        [
                            -157.81323465384091,
                            21.303258267608236
                        ],
                        [
                            -157.81326489347151,
                            21.303216044190943
                        ],
                        [
                            -157.81327052565888,
                            21.30321958635211
                        ],
                        [
                            -157.81326997579569,
                            21.303220353968193
                        ],
                        [
                            -157.81327243316048,
                            21.303221899833339
                        ],
                        [
                            -157.8132740827501,
                            21.303219596985077
                        ],
                        [
                            -157.81327295573854,
                            21.303218888006796
                        ],
                        [
                            -157.81330511987716,
                            21.303173977021455
                        ],
                        [
                            -157.81330624592459,
                            21.303174685992722
                        ],
                        [
                            -157.81330789552038,
                            21.303172382240714
                        ],
                        [
                            -157.81330676850175,
                            21.303171674165998
                        ],
                        [
                            -157.8133381078184,
                            21.303127915500863
                        ],
                        [
                            -157.81333923386566,
                            21.303128624471888
                        ],
                        [
                            -157.8133408834604,
                            21.30312632071951
                        ],
                        [
                            -157.81333975644193,
                            21.303125612645022
                        ],
                        [
                            -157.81337192053914,
                            21.303080701644529
                        ],
                        [
                            -157.81337304658621,
                            21.303081410615338
                        ],
                        [
                            -157.81337469617984,
                            21.303079106862555
                        ],
                        [
                            -157.81337223880894,
                            21.303077561902271
                        ],
                        [
                            -157.8133716879901,
                            21.303078328608617
                        ],
                        [
                            -157.81335612274574,
                            21.303068539931257
                        ],
                        [
                            -157.81338801189384,
                            21.303024012734799
                        ],
                        [
                            -157.81338391531779,
                            21.303021437192321
                        ],
                        [
                            -157.81338315974153,
                            21.303022492442615
                        ],
                        [
                            -157.81335243883947,
                            21.30300317092631
                        ],
                        [
                            -157.81335319537979,
                            21.303002115682951
                        ],
                        [
                            -157.81335073801762,
                            21.30300056981908
                        ],
                        [
                            -157.81336888058811,
                            21.302975235745624
                        ],
                        [
                            -157.81333078664272,
                            21.30295127753141
                        ],
                        [
                            -157.81331264406907,
                            21.302976611600645
                        ],
                        [
                            -157.8133114153884,
                            21.302975838668427
                        ],
                        [
                            -157.81331065884069,
                            21.302976894814925
                        ],
                        [
                            -157.81327993892191,
                            21.302957573292961
                        ],
                        [
                            -157.81328069449853,
                            21.302956518043139
                        ],
                        [
                            -157.81327659793357,
                            21.302953941594865
                        ],
                        [
                            -157.81324471070442,
                            21.302998467879966
                        ],
                        [
                            -157.81322914548446,
                            21.302988678288212
                        ],
                        [
                            -157.81322969437571,
                            21.302987911568749
                        ],
                        [
                            -157.81322723701518,
                            21.302986365703141
                        ],
                        [
                            -157.81322558838434,
                            21.302988669461232
                        ],
                        [
                            -157.81322640751179,
                            21.302989183846449
                        ],
                        [
                            -157.81322558271802,
                            21.302990335270433
                        ],
                        [
                            -157.81322589060744,
                            21.3029905289604
                        ],
                        [
                            -157.81319455032602,
                            21.303034287598358
                        ],
                        [
                            -157.81319342523688,
                            21.303033579536542
                        ],
                        [
                            -157.81319177468436,
                            21.303035882377316
                        ],
                        [
                            -157.81319290170137,
                            21.303036590452724
                        ],
                        [
                            -157.81316156332068,
                            21.303080350000322
                        ],
                        [
                            -157.81316043630349,
                            21.3030796419247
                        ],
                        [
                            -157.81315878767779,
                            21.303081944778672
                        ],
                        [
                            -157.81315991373106,
                            21.303082652847525
                        ],
                        [
                            -157.81312774957109,
                            21.303127563804445
                        ],
                        [
                            -157.81312662448164,
                            21.303126855742171
                        ],
                        [
                            -157.81312497392699,
                            21.303129158582166
                        ],
                        [
                            -157.8131274322599,
                            21.303130703552771
                        ],
                        [
                            -157.81312798212346,
                            21.303129935937164
                        ],
                        [
                            -157.81314385427623,
                            21.303139919221842
                        ],
                        [
                            -157.81311361559293,
                            21.303182142623665
                        ],
                        [
                            -157.81311248857523,
                            21.303181434547689
                        ],
                        [
                            -157.8131108399476,
                            21.303183737401092
                        ],
                        [
                            -157.81309394340255,
                            21.303173110901675
                        ],
                        [
                            -157.81302764967771,
                            21.303265055429307
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 105,
                "NUMBER": "1121",
                "PROPER_NAME": "PACIFIC BIOSCIENCES RESEARCH CENTER",
                "DISPLAY_NAME": "PACIFIC BIOSCIENCES RESEARCH CENTER (PBRC) - 1121",
                "ADDRESS": "1993 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PACIFIC BIOSCIENCE RESEARCH CENTER COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1121_01.jpg",
                "HEIGHT (ft)": 22.400000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": "https://www.hawaii.edu/sustainability/pv_system/pacific-biosciences-research-center/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2019/08/Pacific_Biomedial_Reearch_Center_11-12-19_14_52-1-scaled.jpeg",
                "PORTABLE?": null,
                "SHAPE_Length": 144.52945793017795,
                "SHAPE_Area": 773.41602681305142
            }
        },
        {
            "type": "Feature",
            "id": 106,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81337983735918,
                            21.303696847932446
                        ],
                        [
                            -157.81338153764338,
                            21.303694595127297
                        ],
                        [
                            -157.81338113682199,
                            21.303694329414451
                        ],
                        [
                            -157.81342618507904,
                            21.303634642200944
                        ],
                        [
                            -157.8134265868716,
                            21.303634907017123
                        ],
                        [
                            -157.81342710037302,
                            21.303634225869512
                        ],
                        [
                            -157.81342731667726,
                            21.303633940117205
                        ],
                        [
                            -157.81342828618313,
                            21.30363265510794
                        ],
                        [
                            -157.81342788632574,
                            21.303632389402022
                        ],
                        [
                            -157.81348525938662,
                            21.303556372700122
                        ],
                        [
                            -157.81341796453236,
                            21.303511768509249
                        ],
                        [
                            -157.81342858910125,
                            21.303497690942045
                        ],
                        [
                            -157.81342897842009,
                            21.303497948443148
                        ],
                        [
                            -157.81342982903172,
                            21.303496823398632
                        ],
                        [
                            -157.81333249565989,
                            21.303432308950409
                        ],
                        [
                            -157.81332133002223,
                            21.30344713883208
                        ],
                        [
                            -157.81331051456942,
                            21.303439970049681
                        ],
                        [
                            -157.81325113066038,
                            21.303518614017882
                        ],
                        [
                            -157.81326194707961,
                            21.303525782810972
                        ],
                        [
                            -157.81321519755207,
                            21.303587721873047
                        ],
                        [
                            -157.81337983735918,
                            21.303696847932446
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 106,
                "NUMBER": "1193",
                "PROPER_NAME": "PHYSICAL PLANT BUILDING",
                "DISPLAY_NAME": "PHYSICAL PLANT BUILDING - 1193",
                "ADDRESS": "2002 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PHYSICAL PLANT BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1193_01.jpg",
                "HEIGHT (ft)": 13.4,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 86.932242099118469,
                "SHAPE_Area": 436.79691407866216
            }
        },
        {
            "type": "Feature",
            "id": 107,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81311667244037,
                            21.303674104579059
                        ],
                        [
                            -157.81329086061515,
                            21.303784089446072
                        ],
                        [
                            -157.81333436051486,
                            21.303723590034178
                        ],
                        [
                            -157.81316017141754,
                            21.303613604303116
                        ],
                        [
                            -157.81311667244037,
                            21.303674104579059
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 107,
                "NUMBER": "1193B",
                "PROPER_NAME": "PHYSICAL PLANT BUILDING 2",
                "DISPLAY_NAME": "PHYSICAL PLANT BUILDING 2 - 1193B",
                "ADDRESS": "2002 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PHYSICAL PLANT BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1193B_01.jpg",
                "HEIGHT (ft)": 15.200000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 59.728546199143189,
                "SHAPE_Area": 175.95607387941385
            }
        },
        {
            "type": "Feature",
            "id": 108,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81357888997616,
                            21.303846751549663
                        ],
                        [
                            -157.81361306037181,
                            21.303881192981613
                        ],
                        [
                            -157.81362489344653,
                            21.303870883828594
                        ],
                        [
                            -157.81362989377624,
                            21.30387592476287
                        ],
                        [
                            -157.81378049380652,
                            21.303744713233637
                        ],
                        [
                            -157.81373848964913,
                            21.303702374286811
                        ],
                        [
                            -157.813587888672,
                            21.30383358486921
                        ],
                        [
                            -157.8135907230575,
                            21.303836441495672
                        ],
                        [
                            -157.81357888997616,
                            21.303846751549663
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 108,
                "NUMBER": "1149A",
                "PROPER_NAME": "PĀMOA BUILDING A - OSI / OPD",
                "DISPLAY_NAME": "PĀMOA BUILDING A - OSI / OPD - 1149A",
                "ADDRESS": "1980 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PAMOA BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1149A_01.jpg",
                "HEIGHT (ft)": 17.699999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 58.814377492705233,
                "SHAPE_Area": 145.2372490120089
            }
        },
        {
            "type": "Feature",
            "id": 109,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.81418079885674,
                                21.303945477324618
                            ],
                            [
                                -157.81452259004666,
                                21.303934701695702
                            ],
                            [
                                -157.81452430255982,
                                21.303934647813779
                            ],
                            [
                                -157.81461531747783,
                                21.303931777558567
                            ],
                            [
                                -157.81461521904964,
                                21.303929026045175
                            ],
                            [
                                -157.81452420414055,
                                21.303931895397078
                            ],
                            [
                                -157.81452410169871,
                                21.303929043579227
                            ],
                            [
                                -157.81451472129632,
                                21.303667770649874
                            ],
                            [
                                -157.81474372430708,
                                21.303660550585359
                            ],
                            [
                                -157.81475309473598,
                                21.30392155514129
                            ],
                            [
                                -157.81475320659769,
                                21.303924675332116
                            ],
                            [
                                -157.81466243853492,
                                21.30392753746397
                            ],
                            [
                                -157.81466253696399,
                                21.303930288977362
                            ],
                            [
                                -157.81474663240178,
                                21.303927636405241
                            ],
                            [
                                -157.81475330599238,
                                21.30392742685234
                            ],
                            [
                                -157.81475501850548,
                                21.30392737296804
                            ],
                            [
                                -157.81509681065191,
                                21.303916594368626
                            ],
                            [
                                -157.81508525186246,
                                21.303594691378859
                            ],
                            [
                                -157.81508218869558,
                                21.303509400698257
                            ],
                            [
                                -157.81507925254778,
                                21.3035094938488
                            ],
                            [
                                -157.81508231571294,
                                21.303594784529391
                            ],
                            [
                                -157.81480046603173,
                                21.303603672682648
                            ],
                            [
                                -157.81479276123667,
                                21.303389070694596
                            ],
                            [
                                -157.81507461051481,
                                21.303380181631624
                            ],
                            [
                                -157.81507766395106,
                                21.303465242783936
                            ],
                            [
                                -157.81508060009077,
                                21.303465150536717
                            ],
                            [
                                -157.81507754568889,
                                21.30338008937759
                            ],
                            [
                                -157.8150659869215,
                                21.303058186370347
                            ],
                            [
                                -157.8147182184386,
                                21.303069152349707
                            ],
                            [
                                -157.81472780104554,
                                21.303336030446022
                            ],
                            [
                                -157.81450306533458,
                                21.303343117060603
                            ],
                            [
                                -157.81449348314902,
                                21.303076237163918
                            ],
                            [
                                -157.81414998143902,
                                21.303087067609145
                            ],
                            [
                                -157.81418079885674,
                                21.303945477324618
                            ]
                        ],
                        [
                            [
                                -157.81444655932685,
                                21.30381590333614
                            ],
                            [
                                -157.81430563381045,
                                21.303820346021855
                            ],
                            [
                                -157.81430089210289,
                                21.30368828319547
                            ],
                            [
                                -157.81444181749305,
                                21.303683840507812
                            ],
                            [
                                -157.81444655932685,
                                21.30381590333614
                            ]
                        ],
                        [
                            [
                                -157.8149415988641,
                                21.303315515306526
                            ],
                            [
                                -157.81480067477543,
                                21.303319959340236
                            ],
                            [
                                -157.81479593358088,
                                21.303187896507065
                            ],
                            [
                                -157.81493685657932,
                                21.303183452464591
                            ],
                            [
                                -157.8149415988641,
                                21.303315515306526
                            ]
                        ],
                        [
                            [
                                -157.81481758458361,
                                21.303671977466053
                            ],
                            [
                                -157.8149585090016,
                                21.303667534337286
                            ],
                            [
                                -157.81496325130561,
                                21.303799596269471
                            ],
                            [
                                -157.81482232675407,
                                21.303804040299596
                            ],
                            [
                                -157.81481758458361,
                                21.303671977466053
                            ]
                        ],
                        [
                            [
                                -157.81442917369603,
                                21.303331658209213
                            ],
                            [
                                -157.81428824863534,
                                21.303336101805424
                            ],
                            [
                                -157.81428350780564,
                                21.303204050722769
                            ],
                            [
                                -157.81442443177613,
                                21.303199607117786
                            ],
                            [
                                -157.81442917369603,
                                21.303331658209213
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81466590545955,
                                21.303908146247252
                            ],
                            [
                                -157.81466625766623,
                                21.303917957727975
                            ],
                            [
                                -157.81466630110407,
                                21.30391915231445
                            ],
                            [
                                -157.81466923628872,
                                21.303919060068054
                            ],
                            [
                                -157.81466884160793,
                                21.303908054007632
                            ],
                            [
                                -157.81466590545955,
                                21.303908146247252
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.8150568741018,
                                21.303459242416636
                            ],
                            [
                                -157.8150569725384,
                                21.303461993930291
                            ],
                            [
                                -157.81506724180832,
                                21.303461669660109
                            ],
                            [
                                -157.81506871614744,
                                21.303461623129042
                            ],
                            [
                                -157.81506861674669,
                                21.303458871608598
                            ],
                            [
                                -157.8150568741018,
                                21.303459242416636
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.8150588574172,
                                21.303514497736096
                            ],
                            [
                                -157.815058956825,
                                21.303517248353188
                            ],
                            [
                                -157.81506793398955,
                                21.303516966477055
                            ],
                            [
                                -157.81507070043119,
                                21.303516878455341
                            ],
                            [
                                -157.81507060198712,
                                21.303514127845034
                            ],
                            [
                                -157.8150588574172,
                                21.303514497736096
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81454822317286,
                                21.303911856709171
                            ],
                            [
                                -157.8145486188086,
                                21.30392286277625
                            ],
                            [
                                -157.8145501702904,
                                21.303922814083254
                            ],
                            [
                                -157.81455155399328,
                                21.303922770531901
                            ],
                            [
                                -157.81455115932133,
                                21.303911764471614
                            ],
                            [
                                -157.81454822317286,
                                21.303911856709171
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81472462365821,
                                21.303906295087899
                            ],
                            [
                                -157.81472497125893,
                                21.303915960187158
                            ],
                            [
                                -157.81472501931432,
                                21.303917300251843
                            ],
                            [
                                -157.81472795546293,
                                21.303917208011192
                            ],
                            [
                                -157.81472755980658,
                                21.303906202847244
                            ],
                            [
                                -157.81472462365821,
                                21.303906295087899
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81460694232902,
                                21.303910006501159
                            ],
                            [
                                -157.81460733701965,
                                21.303921010754841
                            ],
                            [
                                -157.81461027316828,
                                21.303920918516251
                            ],
                            [
                                -157.81460987848467,
                                21.303909913359252
                            ],
                            [
                                -157.81460694232902,
                                21.303910006501159
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.8150548976225,
                                21.303404216605909
                            ],
                            [
                                -157.81505499606629,
                                21.303406967216219
                            ],
                            [
                                -157.81506475620648,
                                21.303406659235222
                            ],
                            [
                                -157.81506674062766,
                                21.303406597325043
                            ],
                            [
                                -157.81506664218364,
                                21.303403846714712
                            ],
                            [
                                -157.8150548976225,
                                21.303404216605909
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81506083389004,
                                21.303569524449564
                            ],
                            [
                                -157.81506093233392,
                                21.303572275059832
                            ],
                            [
                                -157.8150696732682,
                                21.303571999650675
                            ],
                            [
                                -157.81507267594452,
                                21.303571905162073
                            ],
                            [
                                -157.81507257750766,
                                21.30356915364845
                            ],
                            [
                                -157.81506083389004,
                                21.303569524449564
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 109,
                "NUMBER": "1172",
                "PROPER_NAME": "BIOMEDICAL SCIENCES BUILDING",
                "DISPLAY_NAME": "BIOMEDICAL SCIENCES BUILDING (BIOMD) - 1172",
                "ADDRESS": "1960 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BIOMEDICAL SCIENCES BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1172_01.jpg",
                "HEIGHT (ft)": 149.40000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 891.5516812342828,
                "SHAPE_Area": 6103.6463454687
            }
        },
        {
            "type": "Feature",
            "id": 110,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81367789951275,
                            21.303924311780523
                        ],
                        [
                            -157.81371990468293,
                            21.303966649846988
                        ],
                        [
                            -157.81387050376307,
                            21.303835439135682
                        ],
                        [
                            -157.81382849956154,
                            21.303793099306041
                        ],
                        [
                            -157.81367789951275,
                            21.303924311780523
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 110,
                "NUMBER": "1149C",
                "PROPER_NAME": "PĀMOA BUILDING C - FIRE SAFETY OFFICE",
                "DISPLAY_NAME": "PĀMOA BUILDING C - FIRE SAFETY OFFICE - 1149C",
                "ADDRESS": "1980 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PAMOA BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1149C_01.jpg",
                "HEIGHT (ft)": 19.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.462135760173318,
                "SHAPE_Area": 136.51099585200777
            }
        },
        {
            "type": "Feature",
            "id": 111,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81352327156773,
                            21.303891764600472
                        ],
                        [
                            -157.81366328772305,
                            21.304032894576672
                        ],
                        [
                            -157.81370846780408,
                            21.30399353085615
                        ],
                        [
                            -157.81356845067498,
                            21.30385240090984
                        ],
                        [
                            -157.81352327156773,
                            21.303891764600472
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 111,
                "NUMBER": "1149B",
                "PROPER_NAME": "PĀMOA BUILDING B - CAMPUS SECURITY",
                "DISPLAY_NAME": "PĀMOA BUILDING B - CAMPUS SECURITY - 1149B",
                "ADDRESS": "1980 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PAMOA BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1149B_01.jpg",
                "HEIGHT (ft)": 15.4,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.462273038993381,
                "SHAPE_Area": 136.51140462564769
            }
        },
        {
            "type": "Feature",
            "id": 112,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81291610657547,
                            21.304278800318887
                        ],
                        [
                            -157.81298049398376,
                            21.304342985028196
                        ],
                        [
                            -157.81302401379813,
                            21.304304645074637
                        ],
                        [
                            -157.81303328863584,
                            21.304296474308554
                        ],
                        [
                            -157.81303697729393,
                            21.30430015092378
                        ],
                        [
                            -157.81307353007617,
                            21.304336589497176
                        ],
                        [
                            -157.81310777598898,
                            21.304306421199332
                        ],
                        [
                            -157.81310773487988,
                            21.304306378450082
                        ],
                        [
                            -157.81313927105313,
                            21.304278596754948
                        ],
                        [
                            -157.81314037494454,
                            21.304277624364765
                        ],
                        [
                            -157.81317248004731,
                            21.304249340778227
                        ],
                        [
                            -157.81317252212764,
                            21.304249382630925
                        ],
                        [
                            -157.81319380285524,
                            21.304230636552123
                        ],
                        [
                            -157.81319892036475,
                            21.304226128602632
                        ],
                        [
                            -157.81331967163339,
                            21.304119750727772
                        ],
                        [
                            -157.81339957787478,
                            21.30404935668215
                        ],
                        [
                            -157.81335933545188,
                            21.304009241562905
                        ],
                        [
                            -157.81336575684031,
                            21.304003584658716
                        ],
                        [
                            -157.81319674159815,
                            21.303835101267872
                        ],
                        [
                            -157.81281147884107,
                            21.304174500355956
                        ],
                        [
                            -157.81283562287192,
                            21.304198569855629
                        ],
                        [
                            -157.81280993914535,
                            21.304221195590841
                        ],
                        [
                            -157.81289042283873,
                            21.30430142696942
                        ],
                        [
                            -157.81291610657547,
                            21.304278800318887
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 112,
                "NUMBER": "1194",
                "PROPER_NAME": "MAINTENANCE SHOPS",
                "DISPLAY_NAME": "MAINTENANCE SHOPS - 1194",
                "ADDRESS": "2002 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAINTENANCE SHOPS AND STORAGE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1194_01.jpg",
                "HEIGHT (ft)": 18.900000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 180.41714910408501,
                "SHAPE_Area": 1731.5643085065519
            }
        },
        {
            "type": "Feature",
            "id": 113,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81397221596791,
                            21.304407411417486
                        ],
                        [
                            -157.81402053171993,
                            21.304455882739337
                        ],
                        [
                            -157.81414122278545,
                            21.304350233775288
                        ],
                        [
                            -157.81409290703192,
                            21.30430176158394
                        ],
                        [
                            -157.81397221596791,
                            21.304407411417486
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 113,
                "NUMBER": "1202B",
                "PROPER_NAME": "MĀLAMA 2 - ENVIRONMENTAL HEALTH AND SAFETY OFFICE",
                "DISPLAY_NAME": "MĀLAMA 2 - ENVIRONMENTAL HEALTH AND SAFETY OFFICE (EHSO) - 1202B",
                "ADDRESS": "2040 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MALAMA 1 AND 2 - ENVIRONMENTAL HEALTH AND SAFETY OFFICE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "EHSO",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1202B_01.jpg",
                "HEIGHT (ft)": 15.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 48.950150878348587,
                "SHAPE_Area": 125.79554492664602
            }
        },
        {
            "type": "Feature",
            "id": 114,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81499707928884,
                            21.304450880926414
                        ],
                        [
                            -157.81501500395538,
                            21.304506319878758
                        ],
                        [
                            -157.81500909926666,
                            21.304526527762288
                        ],
                        [
                            -157.81500773236087,
                            21.304531207628763
                        ],
                        [
                            -157.81500931870556,
                            21.304531620809193
                        ],
                        [
                            -157.8150474950377,
                            21.304541544191462
                        ],
                        [
                            -157.81504867253309,
                            21.30454185060243
                        ],
                        [
                            -157.8150498492943,
                            21.304537921016276
                        ],
                        [
                            -157.81506036641136,
                            21.304502853243001
                        ],
                        [
                            -157.81506069242798,
                            21.304501748887173
                        ],
                        [
                            -157.81506390750641,
                            21.304491038362002
                        ],
                        [
                            -157.81506446316681,
                            21.304489186713777
                        ],
                        [
                            -157.81506542594568,
                            21.304485974718315
                        ],
                        [
                            -157.81506894121628,
                            21.304474254511167
                        ],
                        [
                            -157.81506927107409,
                            21.304473151989157
                        ],
                        [
                            -157.81507754372561,
                            21.304445566538256
                        ],
                        [
                            -157.8150779686442,
                            21.304444150306225
                        ],
                        [
                            -157.81507880661692,
                            21.304441354797543
                        ],
                        [
                            -157.81507942073691,
                            21.304439305718695
                        ],
                        [
                            -157.81507912724763,
                            21.30443839755246
                        ],
                        [
                            -157.81507592421912,
                            21.304428491917754
                        ],
                        [
                            -157.81506550333506,
                            21.304396263294581
                        ],
                        [
                            -157.81503721508253,
                            21.304308784030436
                        ],
                        [
                            -157.81492327736316,
                            21.304341138676211
                        ],
                        [
                            -157.8149515645957,
                            21.30442861704622
                        ],
                        [
                            -157.81498665842821,
                            21.304418651395849
                        ],
                        [
                            -157.81499707928884,
                            21.304450880926414
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 114,
                "NUMBER": "1003D",
                "PROPER_NAME": "COTTAGE 4 - ELECTRICIAN",
                "DISPLAY_NAME": "COTTAGE 4 - ELECTRICIAN - 1003D",
                "ADDRESS": "2010 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "COTTAGE 4 - ELECTRICIAN",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1003D_01.jpg",
                "HEIGHT (ft)": 15.4,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 70.565031102929623,
                "SHAPE_Area": 221.96143154968166
            }
        },
        {
            "type": "Feature",
            "id": 115,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81335568647239,
                            21.304375268075454
                        ],
                        [
                            -157.81343201011023,
                            21.304455830321523
                        ],
                        [
                            -157.81343525829161,
                            21.304459259003835
                        ],
                        [
                            -157.81343808682828,
                            21.30446224477636
                        ],
                        [
                            -157.81344190281979,
                            21.304459070077005
                        ],
                        [
                            -157.81344318971122,
                            21.304457997795812
                        ],
                        [
                            -157.81358053210948,
                            21.304343279210471
                        ],
                        [
                            -157.81358997405295,
                            21.304335423970223
                        ],
                        [
                            -157.8135864477016,
                            21.304331701534803
                        ],
                        [
                            -157.81357892659889,
                            21.304323762820825
                        ],
                        [
                            -157.81352170296424,
                            21.304263361648925
                        ],
                        [
                            -157.81341516672271,
                            21.304352011537471
                        ],
                        [
                            -157.81340126971514,
                            21.304337342774531
                        ],
                        [
                            -157.81335568647239,
                            21.304375268075454
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 115,
                "NUMBER": "1194E",
                "PROPER_NAME": "MAINTENANCE GARAGE AND STORAGE",
                "DISPLAY_NAME": "MAINTENANCE GARAGE AND STORAGE - 1194E",
                "ADDRESS": "2002 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAINTENANCE GARAGE AND STORAGE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1194E_01.jpg",
                "HEIGHT (ft)": 19.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 67.920022162963392,
                "SHAPE_Area": 239.21170686668498
            }
        },
        {
            "type": "Feature",
            "id": 116,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81337950907326,
                            21.304225224204899
                        ],
                        [
                            -157.81343845596882,
                            21.304176181176814
                        ],
                        [
                            -157.81340594841063,
                            21.304141867069859
                        ],
                        [
                            -157.81303066321192,
                            21.304454094409675
                        ],
                        [
                            -157.81306381982924,
                            21.304489090707445
                        ],
                        [
                            -157.81338015622379,
                            21.30422590721383
                        ],
                        [
                            -157.81337950907326,
                            21.304225224204899
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 116,
                "NUMBER": "1194G",
                "PROPER_NAME": "MAINTENANCE SHOP STORAGE",
                "DISPLAY_NAME": "MAINTENANCE SHOP STORAGE - 1194G",
                "ADDRESS": "2002 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAINTENANCE SHOPS AND STORAGE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1194G_01.jpg",
                "HEIGHT (ft)": 13.300000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 114.47963210640319,
                "SHAPE_Area": 268.86937355548537
            }
        },
        {
            "type": "Feature",
            "id": 117,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81403965174519,
                            21.304475845992012
                        ],
                        [
                            -157.81408830791295,
                            21.304524428101875
                        ],
                        [
                            -157.81420927487287,
                            21.304418036642112
                        ],
                        [
                            -157.81416061773274,
                            21.304369454559627
                        ],
                        [
                            -157.81403965174519,
                            21.304475845992012
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 117,
                "NUMBER": "1202A",
                "PROPER_NAME": "MĀLAMA 1 - ENVIRONMENTAL HEALTH AND SAFETY OFFICE",
                "DISPLAY_NAME": "MĀLAMA 1 - ENVIRONMENTAL HEALTH AND SAFETY OFFICE (EHSO) - 1202A",
                "ADDRESS": "2040 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MALAMA 1 AND 2 - ENVIRONMENTAL HEALTH AND SAFETY OFFICE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "EHSO",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1202A_01.jpg",
                "HEIGHT (ft)": 14.1,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 49.170308002746587,
                "SHAPE_Area": 126.9302456532813
            }
        },
        {
            "type": "Feature",
            "id": 118,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81500079741153,
                            21.304719306747344
                        ],
                        [
                            -157.81500700868054,
                            21.304701621479857
                        ],
                        [
                            -157.8150076844677,
                            21.304699696600025
                        ],
                        [
                            -157.81500948688074,
                            21.304694564492749
                        ],
                        [
                            -157.8149880464149,
                            21.304613044324924
                        ],
                        [
                            -157.81498775288966,
                            21.30461214067526
                        ],
                        [
                            -157.81498097911768,
                            21.304591301466356
                        ],
                        [
                            -157.81500049203547,
                            21.304585733087336
                        ],
                        [
                            -157.81497937017127,
                            21.304520743570517
                        ],
                        [
                            -157.81486527150494,
                            21.304553311138935
                        ],
                        [
                            -157.81488639333662,
                            21.304618298861048
                        ],
                        [
                            -157.81489904509985,
                            21.304614687691323
                        ],
                        [
                            -157.8149046108565,
                            21.304631812692236
                        ],
                        [
                            -157.81492686786839,
                            21.304625460536869
                        ],
                        [
                            -157.8149283703695,
                            21.304630077500676
                        ],
                        [
                            -157.81494420720054,
                            21.30467442981659
                        ],
                        [
                            -157.81494363497586,
                            21.304676062727477
                        ],
                        [
                            -157.81494248366286,
                            21.304679342955094
                        ],
                        [
                            -157.81493552926042,
                            21.304699175762259
                        ],
                        [
                            -157.81493465384753,
                            21.304701710830191
                        ],
                        [
                            -157.81496120460505,
                            21.304709900955906
                        ],
                        [
                            -157.81498074601924,
                            21.304715926877094
                        ],
                        [
                            -157.81498163489792,
                            21.304713395517272
                        ],
                        [
                            -157.81500079741153,
                            21.304719306747344
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 118,
                "NUMBER": "1003C",
                "PROPER_NAME": "COTTAGE 3 - PLUMBING",
                "DISPLAY_NAME": "COTTAGE 3 - PLUMBING - 1003C",
                "ADDRESS": "2010 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "COTTAGE 3 - PLUMBING",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1003C_01.jpg",
                "HEIGHT (ft)": 16.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 66.301885653228126,
                "SHAPE_Area": 180.9754653182234
            }
        },
        {
            "type": "Feature",
            "id": 120,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81320397762849,
                            21.304633239379125
                        ],
                        [
                            -157.81320370201394,
                            21.304633467799217
                        ],
                        [
                            -157.81320500301359,
                            21.304634840189422
                        ],
                        [
                            -157.81342678892446,
                            21.30445031986828
                        ],
                        [
                            -157.8133771361077,
                            21.304397910116148
                        ],
                        [
                            -157.81337612776557,
                            21.304398748576812
                        ],
                        [
                            -157.81337572150045,
                            21.304398320215533
                        ],
                        [
                            -157.81337462290085,
                            21.304399233924318
                        ],
                        [
                            -157.813375029166,
                            21.304399662285601
                        ],
                        [
                            -157.81333219240437,
                            21.304435302403437
                        ],
                        [
                            -157.81333178613926,
                            21.304434874042052
                        ],
                        [
                            -157.81333068753915,
                            21.304435787750517
                        ],
                        [
                            -157.81333109379699,
                            21.30443621701524
                        ],
                        [
                            -157.81328825606482,
                            21.304471855307259
                        ],
                        [
                            -157.81328784979979,
                            21.304471426945778
                        ],
                        [
                            -157.81328675216309,
                            21.304472340660727
                        ],
                        [
                            -157.81328715842091,
                            21.304472769925553
                        ],
                        [
                            -157.81324431968918,
                            21.304508410005134
                        ],
                        [
                            -157.81324391439537,
                            21.304507980747005
                        ],
                        [
                            -157.81324281579418,
                            21.304508894454841
                        ],
                        [
                            -157.81324322205197,
                            21.304509323719778
                        ],
                        [
                            -157.81320038523435,
                            21.304544962897275
                        ],
                        [
                            -157.81319997897663,
                            21.304544533632242
                        ],
                        [
                            -157.8131988803749,
                            21.304545447339763
                        ],
                        [
                            -157.81319928566867,
                            21.304545876597995
                        ],
                        [
                            -157.81315644882272,
                            21.304581516666516
                        ],
                        [
                            -157.81315604256503,
                            21.304581087401381
                        ],
                        [
                            -157.81315494396276,
                            21.304582001108592
                        ],
                        [
                            -157.81315624399755,
                            21.304583373492338
                        ],
                        [
                            -157.81315651961208,
                            21.304583145072339
                        ],
                        [
                            -157.81320397762849,
                            21.304633239379125
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 120,
                "NUMBER": "1194F",
                "PROPER_NAME": "MAINTENANCE STORAGE",
                "DISPLAY_NAME": "MAINTENANCE STORAGE - 1194F",
                "ADDRESS": "2002 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAINTENANCE STORAGE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1194F_01.jpg",
                "HEIGHT (ft)": 18.900000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 77.886381454058181,
                "SHAPE_Area": 238.46370327412151
            }
        },
        {
            "type": "Feature",
            "id": 121,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81423459806135,
                            21.304644412869248
                        ],
                        [
                            -157.81430380874565,
                            21.304714418199577
                        ],
                        [
                            -157.81446039897261,
                            21.304578463948211
                        ],
                        [
                            -157.81434859585582,
                            21.304465376757118
                        ],
                        [
                            -157.81431124426021,
                            21.304497807197762
                        ],
                        [
                            -157.81436148860911,
                            21.304548628181372
                        ],
                        [
                            -157.814339940276,
                            21.30456733729341
                        ],
                        [
                            -157.81433228642652,
                            21.304559596421413
                        ],
                        [
                            -157.81423459806135,
                            21.304644412869248
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 121,
                "NUMBER": "1200",
                "PROPER_NAME": "ENVIRONMENTAL PROTECTION FACILITY",
                "DISPLAY_NAME": "ENVIRONMENTAL PROTECTION FACILITY - 1200",
                "ADDRESS": "2040 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ENVIRONMENTAL PROTECTION FACILITY",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1200_01.jpg",
                "HEIGHT (ft)": 17.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 80.75508756429214,
                "SHAPE_Area": 264.71536898466326
            }
        },
        {
            "type": "Feature",
            "id": 122,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81434779817846,
                            21.304761451466266
                        ],
                        [
                            -157.81437096225011,
                            21.304786110088816
                        ],
                        [
                            -157.8144679954215,
                            21.304706060648112
                        ],
                        [
                            -157.81444483038081,
                            21.30468140203174
                        ],
                        [
                            -157.81434779817846,
                            21.304761451466266
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 122,
                "NUMBER": "1202C",
                "PROPER_NAME": "MĀLAMA 3 - DIVE SAFETY",
                "DISPLAY_NAME": "MĀLAMA 3 - DIVE SAFETY - 1202C",
                "ADDRESS": "2040 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MALAMA 3 AND 4 - DIVE SAFETY",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1202C_01.jpg",
                "HEIGHT (ft)": 13.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 34.094340010270528,
                "SHAPE_Area": 48.769527392523031
            }
        },
        {
            "type": "Feature",
            "id": 123,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8143985136717,
                            21.304807150835504
                        ],
                        [
                            -157.81441781803275,
                            21.304827700743196
                        ],
                        [
                            -157.81451046483491,
                            21.30475126915897
                        ],
                        [
                            -157.81449116046988,
                            21.304730719261595
                        ],
                        [
                            -157.8143985136717,
                            21.304807150835504
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 123,
                "NUMBER": "1202D",
                "PROPER_NAME": "MĀLAMA 4 - DIVE SAFETY",
                "DISPLAY_NAME": "MĀLAMA 4 - DIVE SAFETY - 1202D",
                "ADDRESS": "2040 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MALAMA 3 AND 4 - DIVE SAFETY",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1202D_01.jpg",
                "HEIGHT (ft)": 13.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 31.6701088937237,
                "SHAPE_Area": 38.805972810970566
            }
        },
        {
            "type": "Feature",
            "id": 124,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81361262138293,
                            21.304795653398237
                        ],
                        [
                            -157.81361871855481,
                            21.304801924352553
                        ],
                        [
                            -157.813611997637,
                            21.304807663168031
                        ],
                        [
                            -157.81366052352467,
                            21.30485757788189
                        ],
                        [
                            -157.81383564076657,
                            21.304708071242121
                        ],
                        [
                            -157.81378711389954,
                            21.304658156570664
                        ],
                        [
                            -157.81365084671162,
                            21.304774495445635
                        ],
                        [
                            -157.81364474953938,
                            21.304768224492456
                        ],
                        [
                            -157.81361262138293,
                            21.304795653398237
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 124,
                "NUMBER": "1132C",
                "PROPER_NAME": "TRANSPORTATION SERVICES - AUTO MAINT/STORAGE",
                "DISPLAY_NAME": "TRANSPORTATION SERVICES - AUTO MAINT/STORAGE - 1132C",
                "ADDRESS": "2027 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "TRANSPORTATION SERVICES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1132C_01.jpg",
                "HEIGHT (ft)": 17.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 65.976388872361014,
                "SHAPE_Area": 187.92000252607863
            }
        },
        {
            "type": "Feature",
            "id": 125,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81469439017079,
                            21.304750069793769
                        ],
                        [
                            -157.81474019702702,
                            21.304881332407177
                        ],
                        [
                            -157.81491516986546,
                            21.304827710210681
                        ],
                        [
                            -157.81490740861156,
                            21.304805470114687
                        ],
                        [
                            -157.8149409143351,
                            21.304795202400911
                        ],
                        [
                            -157.81491489115538,
                            21.304720630436485
                        ],
                        [
                            -157.8148804548062,
                            21.304731184288922
                        ],
                        [
                            -157.81487139970011,
                            21.304705237506376
                        ],
                        [
                            -157.81482672638484,
                            21.304718928080437
                        ],
                        [
                            -157.81481942125041,
                            21.30469799478422
                        ],
                        [
                            -157.81478591553488,
                            21.304708263377893
                        ],
                        [
                            -157.81479025320769,
                            21.304720691141739
                        ],
                        [
                            -157.81469439017079,
                            21.304750069793769
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 125,
                "NUMBER": "1003B",
                "PROPER_NAME": "COTTAGE 2 -  COPF-BGM OFFICE",
                "DISPLAY_NAME": "COTTAGE 2 -  COPF-BGM OFFICE - 1003B",
                "ADDRESS": "2010 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "COTTAGE 2 -  COPF-BGM OFFICE",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1003B_01.jpg",
                "HEIGHT (ft)": 16,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 78.977953771792642,
                "SHAPE_Area": 323.76355506918185
            }
        },
        {
            "type": "Feature",
            "id": 126,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81380496427246,
                            21.304966561155908
                        ],
                        [
                            -157.81384624345986,
                            21.305007987981732
                        ],
                        [
                            -157.81397606335358,
                            21.304894776208975
                        ],
                        [
                            -157.81393478512197,
                            21.304853349421037
                        ],
                        [
                            -157.81380496427246,
                            21.304966561155908
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 126,
                "NUMBER": "1132E",
                "PROPER_NAME": "TRANSPORTATION SERVICES - OFFICE",
                "DISPLAY_NAME": "TRANSPORTATION SERVICES - OFFICE - 1132E",
                "ADDRESS": "2027 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "TRANSPORTATION SERVICES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1132E_01.jpg",
                "HEIGHT (ft)": 15.300000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 49.34073633377416,
                "SHAPE_Area": 115.42157186321926
            }
        },
        {
            "type": "Feature",
            "id": 127,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.81448707931352,
                                21.305054945734767
                            ],
                            [
                                -157.81461143704223,
                                21.305057523897325
                            ],
                            [
                                -157.81461341864221,
                                21.304973582301116
                            ],
                            [
                                -157.81448906099126,
                                21.304971003239949
                            ],
                            [
                                -157.81448707931352,
                                21.305054945734767
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81463746368914,
                                21.305001391793358
                            ],
                            [
                                -157.81463623775099,
                                21.305051224033509
                            ],
                            [
                                -157.81463818280227,
                                21.30505126574165
                            ],
                            [
                                -157.81467906641689,
                                21.305052149098923
                            ],
                            [
                                -157.81467938919758,
                                21.30503907120276
                            ],
                            [
                                -157.81467946821672,
                                21.305035830399515
                            ],
                            [
                                -157.81467951559341,
                                21.305033890253583
                            ],
                            [
                                -157.81467959971485,
                                21.305030494103352
                            ],
                            [
                                -157.8146796467002,
                                21.305028602737686
                            ],
                            [
                                -157.81468043544177,
                                21.304996495523451
                            ],
                            [
                                -157.81464933298355,
                                21.304995823811225
                            ],
                            [
                                -157.81463760679199,
                                21.304995570459131
                            ],
                            [
                                -157.81463746368914,
                                21.305001391793358
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 127,
                "NUMBER": "1048",
                "PROPER_NAME": "ENERGY HOUSE",
                "DISPLAY_NAME": "ENERGY HOUSE - 1048",
                "ADDRESS": "2020 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ENERGY HOUSE",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1048_01.jpg",
                "HEIGHT (ft)": 26.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 65.608591435097566,
                "SHAPE_Area": 147.31648156967398
            }
        },
        {
            "type": "Feature",
            "id": 129,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81014402576653,
                            21.30565761318411
                        ],
                        [
                            -157.81018753325017,
                            21.305685227568347
                        ],
                        [
                            -157.81022673419534,
                            21.305630990741808
                        ],
                        [
                            -157.81018322768321,
                            21.305603376374776
                        ],
                        [
                            -157.81014402576653,
                            21.30565761318411
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 129,
                "NUMBER": "1010A",
                "PROPER_NAME": "MAGOON STORAGE SHED - TPSS",
                "DISPLAY_NAME": "MAGOON STORAGE SHED - TPSS - 1010A",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1010A_01.jpg",
                "HEIGHT (ft)": 19,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 25.404908984401199,
                "SHAPE_Area": 39.527673663283451
            }
        },
        {
            "type": "Feature",
            "id": 131,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80996954001517,
                            21.306123578796502
                        ],
                        [
                            -157.81004232658546,
                            21.306165595246373
                        ],
                        [
                            -157.81019559634439,
                            21.305932428929818
                        ],
                        [
                            -157.81012280983106,
                            21.305890413451795
                        ],
                        [
                            -157.80996954001517,
                            21.306123578796502
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 131,
                "NUMBER": "1010C",
                "PROPER_NAME": "MAGOON GREENHOUSE 9 - NREM",
                "DISPLAY_NAME": "MAGOON GREENHOUSE 9 - NREM - 1010C",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1010C_01.jpg",
                "HEIGHT (ft)": 11,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 78.365987142588793,
                "SHAPE_Area": 268.83486939875382
            }
        },
        {
            "type": "Feature",
            "id": 132,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81006459540473,
                            21.306177937640808
                        ],
                        [
                            -157.81013702262652,
                            21.306220291183855
                        ],
                        [
                            -157.81029151988452,
                            21.305988274437532
                        ],
                        [
                            -157.8102190907899,
                            21.30594592185281
                        ],
                        [
                            -157.81006459540473,
                            21.306177937640808
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 132,
                "NUMBER": "1010B",
                "PROPER_NAME": "MAGOON GREENHOUSE 8 - TPSS",
                "DISPLAY_NAME": "MAGOON GREENHOUSE 8 - TPSS - 1010B",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1010B_01.jpg",
                "HEIGHT (ft)": 11,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 78.25988755731025,
                "SHAPE_Area": 268.10891393178065
            }
        },
        {
            "type": "Feature",
            "id": 135,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80971765578406,
                            21.306428904557123
                        ],
                        [
                            -157.80976852533328,
                            21.306497126018993
                        ],
                        [
                            -157.81001899176687,
                            21.306333124274939
                        ],
                        [
                            -157.80996817081072,
                            21.306264965562697
                        ],
                        [
                            -157.80971765578406,
                            21.306428904557123
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 135,
                "NUMBER": "1034A",
                "PROPER_NAME": "MAGOON GREENHOUSE 3 - TPSS",
                "DISPLAY_NAME": "MAGOON GREENHOUSE 3 - TPSS - 1034A",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1034A_01.jpg",
                "HEIGHT (ft)": 12,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 81.810115546827689,
                "SHAPE_Area": 291.88089181673109
            }
        },
        {
            "type": "Feature",
            "id": 136,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80887857894717,
                            21.306473938068429
                        ],
                        [
                            -157.8088843630554,
                            21.306474899570038
                        ],
                        [
                            -157.80888487655704,
                            21.306472189429407
                        ],
                        [
                            -157.80887909245621,
                            21.306471227024488
                        ],
                        [
                            -157.80882155051418,
                            21.306394019050071
                        ],
                        [
                            -157.80876294575415,
                            21.30643237570003
                        ],
                        [
                            -157.80870898028473,
                            21.306359966511891
                        ],
                        [
                            -157.80876758406407,
                            21.306321609872903
                        ],
                        [
                            -157.8087569311615,
                            21.30630731693417
                        ],
                        [
                            -157.80876014095551,
                            21.306305214893364
                        ],
                        [
                            -157.80875902035388,
                            21.3063037109494
                        ],
                        [
                            -157.80875580961046,
                            21.306305811176678
                        ],
                        [
                            -157.80873674695673,
                            21.306280231392474
                        ],
                        [
                            -157.80873995672854,
                            21.30627813206204
                        ],
                        [
                            -157.80873883613461,
                            21.306276627214622
                        ],
                        [
                            -157.80873562344902,
                            21.306278729234567
                        ],
                        [
                            -157.80871214419173,
                            21.306247223572591
                        ],
                        [
                            -157.80871317023528,
                            21.306241803285626
                        ],
                        [
                            -157.80871027819006,
                            21.306241322080471
                        ],
                        [
                            -157.80870925118245,
                            21.306246742360585
                        ],
                        [
                            -157.80866659943581,
                            21.306274657660243
                        ],
                        [
                            -157.80866547787869,
                            21.306273152805549
                        ],
                        [
                            -157.80866387298141,
                            21.306274203825037
                        ],
                        [
                            -157.80866499358183,
                            21.306275707769586
                        ],
                        [
                            -157.80865897233224,
                            21.306279648168758
                        ],
                        [
                            -157.80865785173188,
                            21.306278144224173
                        ],
                        [
                            -157.80865624684179,
                            21.306279194340267
                        ],
                        [
                            -157.80865736743488,
                            21.306280699188193
                        ],
                        [
                            -157.80863789842726,
                            21.306293440922467
                        ],
                        [
                            -157.80863677783429,
                            21.306291936074413
                        ],
                        [
                            -157.80863517292931,
                            21.30629298799694
                        ],
                        [
                            -157.80863629352962,
                            21.306294491941671
                        ],
                        [
                            -157.80863543777841,
                            21.306295052305938
                        ],
                        [
                            -157.8086144181427,
                            21.306308809305285
                        ],
                        [
                            -157.80861329657861,
                            21.306307305353592
                        ],
                        [
                            -157.80861168975997,
                            21.306308355455556
                        ],
                        [
                            -157.80861281132405,
                            21.306309859407264
                        ],
                        [
                            -157.80856895586768,
                            21.306338562944454
                        ],
                        [
                            -157.80856317080344,
                            21.306337601425504
                        ],
                        [
                            -157.80856265826779,
                            21.306340310668428
                        ],
                        [
                            -157.80856844235362,
                            21.306341273987247
                        ],
                        [
                            -157.8085971097704,
                            21.306379738162239
                        ],
                        [
                            -157.8085955048715,
                            21.306380789180981
                        ],
                        [
                            -157.80859662547195,
                            21.306382293125974
                        ],
                        [
                            -157.8085982303636,
                            21.306381243010552
                        ],
                        [
                            -157.80860243620859,
                            21.30638688553978
                        ],
                        [
                            -157.80860083131691,
                            21.306387935655241
                        ],
                        [
                            -157.80860195191019,
                            21.306389440503533
                        ],
                        [
                            -157.80860355680917,
                            21.306388389484731
                        ],
                        [
                            -157.80870027595313,
                            21.306518162101192
                        ],
                        [
                            -157.80869867105335,
                            21.306519213120868
                        ],
                        [
                            -157.80869979261982,
                            21.306520717072068
                        ],
                        [
                            -157.80870139751963,
                            21.306519666052385
                        ],
                        [
                            -157.80870560240837,
                            21.306525308572471
                        ],
                        [
                            -157.80870399654458,
                            21.306526359585387
                        ],
                        [
                            -157.80870511907514,
                            21.306527863543383
                        ],
                        [
                            -157.8087067239677,
                            21.306526813426967
                        ],
                        [
                            -157.8087353914552,
                            21.30656527758093
                        ],
                        [
                            -157.80873436348165,
                            21.306570697854102
                        ],
                        [
                            -157.80873725649008,
                            21.306571179969307
                        ],
                        [
                            -157.80873828350687,
                            21.306565758785954
                        ],
                        [
                            -157.80882669610989,
                            21.306507895855621
                        ],
                        [
                            -157.80882781671366,
                            21.306509399799204
                        ],
                        [
                            -157.80882942257642,
                            21.306508348785073
                        ],
                        [
                            -157.80882830100867,
                            21.306506844834672
                        ],
                        [
                            -157.80883432226364,
                            21.306502904429767
                        ],
                        [
                            -157.80883544286749,
                            21.3065044083733
                        ],
                        [
                            -157.80883704873017,
                            21.306503357359073
                        ],
                        [
                            -157.80883592716967,
                            21.306501852505384
                        ],
                        [
                            -157.80887857894717,
                            21.306473938068429
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 136,
                "NUMBER": "1032",
                "PROPER_NAME": "SMALL ANIMAL CARE FACILITY",
                "DISPLAY_NAME": "SMALL ANIMAL CARE FACILITY - 1032",
                "ADDRESS": "2721 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1032_01.jpg",
                "HEIGHT (ft)": 24,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 122.60596394021451,
                "SHAPE_Area": 486.51303780906215
            }
        },
        {
            "type": "Feature",
            "id": 137,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80978410818298,
                            21.306518742306057
                        ],
                        [
                            -157.80983484734764,
                            21.306586881522314
                        ],
                        [
                            -157.81008501165672,
                            21.306423297622811
                        ],
                        [
                            -157.8100343191573,
                            21.306355221142237
                        ],
                        [
                            -157.80978410818298,
                            21.306518742306057
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 137,
                "NUMBER": "1034B",
                "PROPER_NAME": "MAGOON GREENHOUSE 2 - TPSS",
                "DISPLAY_NAME": "MAGOON GREENHOUSE 2 - TPSS - 1034B",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1034B_01.jpg",
                "HEIGHT (ft)": 14,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 81.675271742214932,
                "SHAPE_Area": 290.92008074845319
            }
        },
        {
            "type": "Feature",
            "id": 139,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.80901906308253,
                                21.306604923739137
                            ],
                            [
                                -157.80902967806028,
                                21.306597975946719
                            ],
                            [
                                -157.8090308082119,
                                21.306599491700663
                            ],
                            [
                                -157.80903546880589,
                                21.306596440527208
                            ],
                            [
                                -157.80903433961822,
                                21.3065949247801
                            ],
                            [
                                -157.80905445216302,
                                21.306581759350301
                            ],
                            [
                                -157.80905558231478,
                                21.306583275104096
                            ],
                            [
                                -157.80906024290778,
                                21.306580223929899
                            ],
                            [
                                -157.80905911371997,
                                21.306578708182961
                            ],
                            [
                                -157.80906948544137,
                                21.306571919468908
                            ],
                            [
                                -157.80907061462926,
                                21.306573435215771
                            ],
                            [
                                -157.80907527521435,
                                21.306570384944468
                            ],
                            [
                                -157.80907414601916,
                                21.306568870100961
                            ],
                            [
                                -157.80909426049223,
                                21.306555703776329
                            ],
                            [
                                -157.80909538968024,
                                21.306557219523043
                            ],
                            [
                                -157.80910005123559,
                                21.306554168354477
                            ],
                            [
                                -157.80909892108357,
                                21.306552652600974
                            ],
                            [
                                -157.80910953606124,
                                21.30654570389979
                            ],
                            [
                                -157.80906046666431,
                                21.306479871805603
                            ],
                            [
                                -157.80896999178111,
                                21.306539091606325
                            ],
                            [
                                -157.80901906308253,
                                21.306604923739137
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.80912054859229,
                                21.306458456795319
                            ],
                            [
                                -157.80912727605133,
                                21.306467484989724
                            ],
                            [
                                -157.80912567116221,
                                21.30646853511033
                            ],
                            [
                                -157.8091267917616,
                                21.306470039955396
                            ],
                            [
                                -157.80916211874944,
                                21.306446918464683
                            ],
                            [
                                -157.80916099814985,
                                21.306445413619844
                            ],
                            [
                                -157.80915939229723,
                                21.306446463733959
                            ],
                            [
                                -157.80914481098728,
                                21.306426903364784
                            ],
                            [
                                -157.80914641589035,
                                21.306425851437307
                            ],
                            [
                                -157.80914529529107,
                                21.306424346592376
                            ],
                            [
                                -157.80914368942402,
                                21.306425398513017
                            ],
                            [
                                -157.80911564937182,
                                21.306387779016518
                            ],
                            [
                                -157.80911725523137,
                                21.306386727999463
                            ],
                            [
                                -157.80911613366868,
                                21.306385223147537
                            ],
                            [
                                -157.80908080763885,
                                21.306408346442581
                            ],
                            [
                                -157.80908192920128,
                                21.306409851294749
                            ],
                            [
                                -157.80908353409731,
                                21.306408800271207
                            ],
                            [
                                -157.8091115751233,
                                21.306446417972925
                            ],
                            [
                                -157.80910996925579,
                                21.306447469893218
                            ],
                            [
                                -157.80911108985484,
                                21.306448974738373
                            ],
                            [
                                -157.80911269667905,
                                21.306447923728225
                            ],
                            [
                                -157.80912054859229,
                                21.306458456795319
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.80888676985961,
                                21.306593564813085
                            ],
                            [
                                -157.80888516398895,
                                21.306594616731065
                            ],
                            [
                                -157.80888628459397,
                                21.3065961206743
                            ],
                            [
                                -157.80892161165525,
                                21.306572998334278
                            ],
                            [
                                -157.80892049009336,
                                21.306571493481105
                            ],
                            [
                                -157.80891888423042,
                                21.306572544496099
                            ],
                            [
                                -157.80889084420426,
                                21.306534925867492
                            ],
                            [
                                -157.80889245007421,
                                21.306533873949398
                            ],
                            [
                                -157.80889132851289,
                                21.30653236909605
                            ],
                            [
                                -157.80885600144268,
                                21.306555493236726
                            ],
                            [
                                -157.8088571230038,
                                21.306556998090297
                            ],
                            [
                                -157.80885872886694,
                                21.3065559470759
                            ],
                            [
                                -157.80888676985961,
                                21.306593564813085
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 139,
                "NUMBER": "1009",
                "PROPER_NAME": "MAGOON GREENHOUSE 12 - TPSS",
                "DISPLAY_NAME": "MAGOON GREENHOUSE 12 - TPSS - 1009",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1009_01.jpg",
                "HEIGHT (ft)": 26,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 90.262462157373918,
                "SHAPE_Area": 158.80475036606282
            }
        },
        {
            "type": "Feature",
            "id": 140,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80985080861964,
                            21.306608794081743
                        ],
                        [
                            -157.80990146297205,
                            21.30667669870228
                        ],
                        [
                            -157.8101507652533,
                            21.306513388662278
                        ],
                        [
                            -157.81010015755956,
                            21.306445547680386
                        ],
                        [
                            -157.80985080861964,
                            21.306608794081743
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 140,
                "NUMBER": "1034C",
                "PROPER_NAME": "MAGOON GREENHOUSE 1 - TPSS",
                "DISPLAY_NAME": "MAGOON GREENHOUSE 1 - TPSS - 1034C",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1034C_01.jpg",
                "HEIGHT (ft)": 16,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 81.441097133325655,
                "SHAPE_Area": 289.25398693568718
            }
        },
        {
            "type": "Feature",
            "id": 142,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80981057845111,
                            21.306851532525446
                        ],
                        [
                            -157.80989288932082,
                            21.306962316350784
                        ],
                        [
                            -157.80989452618161,
                            21.306961246574556
                        ],
                        [
                            -157.80988794246667,
                            21.306952436238475
                        ],
                        [
                            -157.81012914903886,
                            21.306795029539582
                        ],
                        [
                            -157.81013576107026,
                            21.306803915951512
                        ],
                        [
                            -157.81013725097824,
                            21.306803017680526
                        ],
                        [
                            -157.81005443135925,
                            21.306691710019422
                        ],
                        [
                            -157.8100529805746,
                            21.30669265825275
                        ],
                        [
                            -157.81005982433197,
                            21.306701857975138
                        ],
                        [
                            -157.80981863177311,
                            21.306859450776358
                        ],
                        [
                            -157.80981203408777,
                            21.306850580715128
                        ],
                        [
                            -157.80981057845111,
                            21.306851532525446
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 142,
                "NUMBER": "1005",
                "PROPER_NAME": "MAGOON HEADHOUSE - TPSS",
                "DISPLAY_NAME": "MAGOON HEADHOUSE - TPSS (MAGOON) - 1005",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1005_01.jpg",
                "HEIGHT (ft)": 19,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 96.542817966872889,
                "SHAPE_Area": 388.83231672482106
            }
        },
        {
            "type": "Feature",
            "id": 143,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80917666012948,
                            21.306924974833375
                        ],
                        [
                            -157.80922647372685,
                            21.306991312642243
                        ],
                        [
                            -157.80946707894947,
                            21.306832655089838
                        ],
                        [
                            -157.80941726528997,
                            21.306766317348451
                        ],
                        [
                            -157.80917666012948,
                            21.306924974833375
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 143,
                "NUMBER": "1008B",
                "PROPER_NAME": "MAGOON GREENHOUSE 11 - TPSS",
                "DISPLAY_NAME": "MAGOON GREENHOUSE 11 - TPSS - 1008B",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1008B_01.jpg",
                "HEIGHT (ft)": 23,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 78.996743371206463,
                "SHAPE_Area": 274.04002567495428
            }
        },
        {
            "type": "Feature",
            "id": 145,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80924267097947,
                            21.307010493276088
                        ],
                        [
                            -157.80929187099943,
                            21.307076535833733
                        ],
                        [
                            -157.80953140591188,
                            21.306919831873053
                        ],
                        [
                            -157.80948220488014,
                            21.306853787568194
                        ],
                        [
                            -157.80924267097947,
                            21.307010493276088
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 145,
                "NUMBER": "1008A",
                "PROPER_NAME": "MAGOON GREENHOUSE 10 - TPSS",
                "DISPLAY_NAME": "MAGOON GREENHOUSE 10 - TPSS - 1008A",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1008A_01.jpg",
                "HEIGHT (ft)": 24,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 78.440295180428834,
                "SHAPE_Area": 270.19431755360068
            }
        },
        {
            "type": "Feature",
            "id": 148,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80954274551632,
                            21.307075873851289
                        ],
                        [
                            -157.8095759981951,
                            21.307121283942195
                        ],
                        [
                            -157.80974732415868,
                            21.307011115643149
                        ],
                        [
                            -157.80971407241236,
                            21.306965705591033
                        ],
                        [
                            -157.80954274551632,
                            21.307075873851289
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 148,
                "NUMBER": "1008C",
                "PROPER_NAME": "MAGOON FIELD LABORATORY - PEPS",
                "DISPLAY_NAME": "MAGOON FIELD LABORATORY - PEPS - 1008C",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1008C_01.jpg",
                "HEIGHT (ft)": 20,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.301461204364784,
                "SHAPE_Area": 131.40486061292023
            }
        },
        {
            "type": "Feature",
            "id": 154,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80924781202637,
                            21.307528294469453
                        ],
                        [
                            -157.80930519002641,
                            21.307603794655162
                        ],
                        [
                            -157.80935337410509,
                            21.307571639014999
                        ],
                        [
                            -157.80917561502997,
                            21.307337734221246
                        ],
                        [
                            -157.80912743195105,
                            21.307369890723276
                        ],
                        [
                            -157.80916315120635,
                            21.307416893859262
                        ],
                        [
                            -157.80913945415926,
                            21.307432706144226
                        ],
                        [
                            -157.8092241159259,
                            21.307544107675895
                        ],
                        [
                            -157.80924781202637,
                            21.307528294469453
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 154,
                "NUMBER": "1013D",
                "PROPER_NAME": "HALE TUAHINE",
                "DISPLAY_NAME": "HALE TUAHINE - 1013D",
                "ADDRESS": "2727 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1013D_01.jpg",
                "HEIGHT (ft)": 23,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 81.883148319765894,
                "SHAPE_Area": 240.74438063987415
            }
        },
        {
            "type": "Feature",
            "id": 155,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81157921545432,
                            21.307488111804673
                        ],
                        [
                            -157.81158083196786,
                            21.307490409698769
                        ],
                        [
                            -157.81158818941162,
                            21.307485861619028
                        ],
                        [
                            -157.81169819828355,
                            21.307642114469687
                        ],
                        [
                            -157.81169084276283,
                            21.307646662567546
                        ],
                        [
                            -157.81169245927981,
                            21.307648960460689
                        ],
                        [
                            -157.81189843489418,
                            21.307521614641093
                        ],
                        [
                            -157.81189681741122,
                            21.307519316743019
                        ],
                        [
                            -157.81188946094576,
                            21.307523863940059
                        ],
                        [
                            -157.81183984881173,
                            21.307453398905349
                        ],
                        [
                            -157.81183780647549,
                            21.307454661872399
                        ],
                        [
                            -157.81181839284008,
                            21.307427087964289
                        ],
                        [
                            -157.81182043614004,
                            21.30742582500427
                        ],
                        [
                            -157.81179832608075,
                            21.307394419752754
                        ],
                        [
                            -157.81181365133122,
                            21.307384944847051
                        ],
                        [
                            -157.81181257236599,
                            21.307383413211085
                        ],
                        [
                            -157.81183402848296,
                            21.307370148526815
                        ],
                        [
                            -157.81183510648435,
                            21.307371680155832
                        ],
                        [
                            -157.81184695936659,
                            21.307364353372133
                        ],
                        [
                            -157.81184588040841,
                            21.307362820833031
                        ],
                        [
                            -157.81186733651955,
                            21.307349556144214
                        ],
                        [
                            -157.81186841451387,
                            21.307351088676374
                        ],
                        [
                            -157.81188169646452,
                            21.307342875821345
                        ],
                        [
                            -157.81188816735244,
                            21.307352067420776
                        ],
                        [
                            -157.81188980276085,
                            21.307351057238129
                        ],
                        [
                            -157.81183156189812,
                            21.307268333718739
                        ],
                        [
                            -157.81174492070193,
                            21.307321900699357
                        ],
                        [
                            -157.81177620000696,
                            21.307366325302919
                        ],
                        [
                            -157.81157921545432,
                            21.307488111804673
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 155,
                "NUMBER": "1012A",
                "PROPER_NAME": "INSTITUTE FOR ASTRONOMY - MACHINE SHOP",
                "DISPLAY_NAME": "INSTITUTE FOR ASTRONOMY - MACHINE SHOP - 1012A",
                "ADDRESS": "2680 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "INSTITUTE FOR ASTRONOMY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1012A_01.jpg",
                "HEIGHT (ft)": 31,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 132.35781427946941,
                "SHAPE_Area": 610.32650437053985
            }
        },
        {
            "type": "Feature",
            "id": 156,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81143292658879,
                            21.307229511598727
                        ],
                        [
                            -157.81145287960248,
                            21.307257851818076
                        ],
                        [
                            -157.81151602045608,
                            21.307218815297123
                        ],
                        [
                            -157.81151656090415,
                            21.307219580671099
                        ],
                        [
                            -157.811532702904,
                            21.307209599339473
                        ],
                        [
                            -157.81156101401811,
                            21.307249811291761
                        ],
                        [
                            -157.81156346617175,
                            21.307248295564129
                        ],
                        [
                            -157.81155375843178,
                            21.307234508137512
                        ],
                        [
                            -157.81161015703492,
                            21.307199640064436
                        ],
                        [
                            -157.81161420120839,
                            21.307205384367538
                        ],
                        [
                            -157.81161665336072,
                            21.307203868639064
                        ],
                        [
                            -157.81161260822321,
                            21.307198124329208
                        ],
                        [
                            -157.81166900584242,
                            21.307163255324795
                        ],
                        [
                            -157.81167305097404,
                            21.307169000536724
                        ],
                        [
                            -157.8116755031252,
                            21.307167484807334
                        ],
                        [
                            -157.81167145895751,
                            21.307161739602282
                        ],
                        [
                            -157.81172785558553,
                            21.307126870569881
                        ],
                        [
                            -157.81172866480202,
                            21.307128019974709
                        ],
                        [
                            -157.8117298913626,
                            21.307127261661311
                        ],
                        [
                            -157.81174768746769,
                            21.307152537678657
                        ],
                        [
                            -157.81173297455106,
                            21.3071616338677
                        ],
                        [
                            -157.81173459202776,
                            21.307163931767157
                        ],
                        [
                            -157.81174807839105,
                            21.307155592988185
                        ],
                        [
                            -157.8117763895489,
                            21.307195805810039
                        ],
                        [
                            -157.81177884169952,
                            21.307194290079114
                        ],
                        [
                            -157.81176913490609,
                            21.307180502670874
                        ],
                        [
                            -157.81182553248419,
                            21.307145633611881
                        ],
                        [
                            -157.81182957665769,
                            21.307151378813497
                        ],
                        [
                            -157.81183202881428,
                            21.307149862178395
                        ],
                        [
                            -157.81182798463351,
                            21.307144117880171
                        ],
                        [
                            -157.81188438217714,
                            21.307109249703341
                        ],
                        [
                            -157.81188842733056,
                            21.30711499310376
                        ],
                        [
                            -157.81189087754356,
                            21.307113478260796
                        ],
                        [
                            -157.81188683433254,
                            21.307107733067372
                        ],
                        [
                            -157.81194323281298,
                            21.307072864876172
                        ],
                        [
                            -157.81195293865994,
                            21.307086651364816
                        ],
                        [
                            -157.8119553907998,
                            21.307085136534468
                        ],
                        [
                            -157.81194649322842,
                            21.307072496732975
                        ],
                        [
                            -157.81198940342239,
                            21.307045966404093
                        ],
                        [
                            -157.81198778593551,
                            21.307043669410277
                        ],
                        [
                            -157.81197307304376,
                            21.30705276562162
                        ],
                        [
                            -157.8119358633038,
                            21.306999915732284
                        ],
                        [
                            -157.81194199416103,
                            21.306996125046826
                        ],
                        [
                            -157.81194037667544,
                            21.306993828052608
                        ],
                        [
                            -157.81193424583279,
                            21.306997616931323
                        ],
                        [
                            -157.81189744689348,
                            21.306944515179705
                        ],
                        [
                            -157.81190316696129,
                            21.306940978156899
                        ],
                        [
                            -157.81190154949141,
                            21.306938679355657
                        ],
                        [
                            -157.81189582845241,
                            21.306942217274941
                        ],
                        [
                            -157.81185861876673,
                            21.306889367370413
                        ],
                        [
                            -157.8118729227956,
                            21.306880523939995
                        ],
                        [
                            -157.81187130435558,
                            21.306878226035046
                        ],
                        [
                            -157.81185781803214,
                            21.30688656392234
                        ],
                        [
                            -157.81182950689168,
                            21.306846352921152
                        ],
                        [
                            -157.81182705474748,
                            21.306847868653154
                        ],
                        [
                            -157.8118359523103,
                            21.306860506653511
                        ],
                        [
                            -157.81180652847337,
                            21.30687869906312
                        ],
                        [
                            -157.81180733673253,
                            21.306879847557408
                        ],
                        [
                            -157.81178036407718,
                            21.306896523320251
                        ],
                        [
                            -157.81177632086155,
                            21.306890779931177
                        ],
                        [
                            -157.81177386775212,
                            21.306892295655526
                        ],
                        [
                            -157.81177791192439,
                            21.306898039954799
                        ],
                        [
                            -157.81172151539752,
                            21.306932909009543
                        ],
                        [
                            -157.81171747026991,
                            21.30692716379885
                        ],
                        [
                            -157.81171501908,
                            21.306928680439245
                        ],
                        [
                            -157.81171906228684,
                            21.30693442473304
                        ],
                        [
                            -157.81166266476879,
                            21.306969293759781
                        ],
                        [
                            -157.81166185651762,
                            21.306968144361484
                        ],
                        [
                            -157.81166062995806,
                            21.306968902674456
                        ],
                        [
                            -157.81164283388881,
                            21.30694362664908
                        ],
                        [
                            -157.81165754678815,
                            21.306934530466936
                        ],
                        [
                            -157.81165592932228,
                            21.306932231663517
                        ],
                        [
                            -157.81164244297526,
                            21.306940570436048
                        ],
                        [
                            -157.81161413189304,
                            21.306900358497757
                        ],
                        [
                            -157.8116116797386,
                            21.306901875129817
                        ],
                        [
                            -157.81162138554325,
                            21.306915661635902
                        ],
                        [
                            -157.81156498897528,
                            21.306950530636033
                        ],
                        [
                            -157.8115609457306,
                            21.306944791758831
                        ],
                        [
                            -157.81155849266906,
                            21.30694630115654
                        ],
                        [
                            -157.81156253682676,
                            21.306952046363968
                        ],
                        [
                            -157.81150613927488,
                            21.306986914432777
                        ],
                        [
                            -157.81150209414733,
                            21.306981170120601
                        ],
                        [
                            -157.81149964199042,
                            21.306982686750896
                        ],
                        [
                            -157.8115036871107,
                            21.306988431966467
                        ],
                        [
                            -157.81144728953163,
                            21.307023300014119
                        ],
                        [
                            -157.81143758278051,
                            21.30700951258844
                        ],
                        [
                            -157.81143513062977,
                            21.307011028314385
                        ],
                        [
                            -157.81144402816707,
                            21.307023666334132
                        ],
                        [
                            -157.81140111692528,
                            21.307050196512872
                        ],
                        [
                            -157.8114027343955,
                            21.307052494415252
                        ],
                        [
                            -157.81141622171504,
                            21.307044157476639
                        ],
                        [
                            -157.81144695850296,
                            21.307087814940925
                        ],
                        [
                            -157.8114420551629,
                            21.307090846399731
                        ],
                        [
                            -157.81144367359093,
                            21.307093145211901
                        ],
                        [
                            -157.81144857693099,
                            21.307090113753048
                        ],
                        [
                            -157.81147933794597,
                            21.307133757832265
                        ],
                        [
                            -157.81147441231005,
                            21.307136804492067
                        ],
                        [
                            -157.81147602882561,
                            21.307139101483671
                        ],
                        [
                            -157.8114809563823,
                            21.307136055740781
                        ],
                        [
                            -157.81151171741598,
                            21.307179699814736
                        ],
                        [
                            -157.81149552795813,
                            21.307189708814224
                        ],
                        [
                            -157.81149598070132,
                            21.307190351611297
                        ],
                        [
                            -157.81143292658879,
                            21.307229511598727
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 156,
                "NUMBER": "1012C",
                "PROPER_NAME": "INSTITUTE FOR ASTRONOMY - LABORATORY AND OFFICES",
                "DISPLAY_NAME": "INSTITUTE FOR ASTRONOMY - LABORATORY AND OFFICES (IFA C) - 1012C",
                "ADDRESS": "2680 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "INSTITUTE FOR ASTRONOMY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1012C_01.jpg",
                "HEIGHT (ft)": 39,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 238.34837156457294,
                "SHAPE_Area": 1297.6155716950586
            }
        },
        {
            "type": "Feature",
            "id": 159,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8199462576213,
                            21.298093921990759
                        ],
                        [
                            -157.81993740536319,
                            21.297980797822291
                        ],
                        [
                            -157.81993594123409,
                            21.297980900480123
                        ],
                        [
                            -157.81993602006077,
                            21.297981893859589
                        ],
                        [
                            -157.81972889921201,
                            21.297996126133484
                        ],
                        [
                            -157.81972668351173,
                            21.297967818195652
                        ],
                        [
                            -157.81954823632836,
                            21.297980080483523
                        ],
                        [
                            -157.81955045975346,
                            21.298008503207164
                        ],
                        [
                            -157.81956600848463,
                            21.298007434243715
                        ],
                        [
                            -157.8195731985536,
                            21.2980993161712
                        ],
                        [
                            -157.81953657834006,
                            21.298101832726648
                        ],
                        [
                            -157.81953815365603,
                            21.298121966809227
                        ],
                        [
                            -157.8199462576213,
                            21.298093921990759
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 159,
                "NUMBER": "1124A",
                "PROPER_NAME": "ADMINISTRATIVE SERVICES BUILDING 2",
                "DISPLAY_NAME": "ADMINISTRATIVE SERVICES BUILDING 2 - 1124A",
                "ADDRESS": "2440 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ADMINISTRATIVE SERVICES BUILDING 2 COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "Admin Services 2",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1124A_01.jpg",
                "HEIGHT (ft)": 15.1,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 119.53205537889171,
                "SHAPE_Area": 547.79229858388214
            }
        },
        {
            "type": "Feature",
            "id": 160,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81921992544778,
                            21.297225686380262
                        ],
                        [
                            -157.81921960095067,
                            21.297031838084674
                        ],
                        [
                            -157.81915962809808,
                            21.297031925026722
                        ],
                        [
                            -157.81915995154537,
                            21.297225774215335
                        ],
                        [
                            -157.81921992544778,
                            21.297225686380262
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 160,
                "NUMBER": "1103B",
                "PROPER_NAME": "BACHMAN ANNEX 10",
                "DISPLAY_NAME": "BACHMAN ANNEX 10 - 1103B",
                "ADDRESS": "2444 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BACHMAN HALL AND ANNEXES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1103B_01.jpg",
                "HEIGHT (ft)": 16.199999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.360467017835703,
                "SHAPE_Area": 133.50862315798651
            }
        },
        {
            "type": "Feature",
            "id": 161,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81688763693302,
                            21.293047880147316
                        ],
                        [
                            -157.81704394717033,
                            21.2929209239534
                        ],
                        [
                            -157.81700563152393,
                            21.292879489872142
                        ],
                        [
                            -157.81684932130128,
                            21.293006446031569
                        ],
                        [
                            -157.81688763693302,
                            21.293047880147316
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 161,
                "NUMBER": "1108U",
                "PROPER_NAME": "MAKAI CAMPUS 16",
                "DISPLAY_NAME": "MAKAI CAMPUS 16 - 1108U",
                "ADDRESS": "1395 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ARMY AND AIR FORCE ROTC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1108U_01.jpg",
                "HEIGHT (ft)": 16.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.056122348874766,
                "SHAPE_Area": 130.24168624253792
            }
        },
        {
            "type": "Feature",
            "id": 162,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81377953857,
                            21.30465036473494
                        ],
                        [
                            -157.81383973391027,
                            21.304712281884949
                        ],
                        [
                            -157.81396158554904,
                            21.30460824928031
                        ],
                        [
                            -157.81390139115942,
                            21.304546332179545
                        ],
                        [
                            -157.81377953857,
                            21.30465036473494
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 162,
                "NUMBER": "1132A",
                "PROPER_NAME": "TRANSPORTATION SERVICES - PRE-FAB BUILDING",
                "DISPLAY_NAME": "TRANSPORTATION SERVICES - PRE-FAB BUILDING - 1132A",
                "ADDRESS": "2027 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "TRANSPORTATION SERVICES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1132A_01.jpg",
                "HEIGHT (ft)": 17.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 52.743578428298761,
                "SHAPE_Area": 158.54940248146343
            }
        },
        {
            "type": "Feature",
            "id": 163,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81141603970931,
                            21.307238853479546
                        ],
                        [
                            -157.81138772863792,
                            21.307198641504748
                        ],
                        [
                            -157.81138527744017,
                            21.307200158139924
                        ],
                        [
                            -157.81139498421237,
                            21.307213943761997
                        ],
                        [
                            -157.81133858554938,
                            21.307248812663573
                        ],
                        [
                            -157.81133454235712,
                            21.307243067457801
                        ],
                        [
                            -157.81133208923018,
                            21.307244584078511
                        ],
                        [
                            -157.81133613435759,
                            21.30725032839463
                        ],
                        [
                            -157.81127973663143,
                            21.307285197281857
                        ],
                        [
                            -157.81127569150539,
                            21.307279452964448
                        ],
                        [
                            -157.81127324031249,
                            21.307280968694524
                        ],
                        [
                            -157.81127728350324,
                            21.307286713901686
                        ],
                        [
                            -157.81122088672109,
                            21.307321581871214
                        ],
                        [
                            -157.81121117900972,
                            21.307307794426212
                        ],
                        [
                            -157.81120872780843,
                            21.307309311058621
                        ],
                        [
                            -157.81121762534232,
                            21.307321949089829
                        ],
                        [
                            -157.81117471397343,
                            21.307348479203942
                        ],
                        [
                            -157.81117633240703,
                            21.307350777115222
                        ],
                        [
                            -157.81119063556309,
                            21.307341932837147
                        ],
                        [
                            -157.81122784413606,
                            21.307394783777362
                        ],
                        [
                            -157.81122212306389,
                            21.307398321671965
                        ],
                        [
                            -157.81122374151326,
                            21.307400617776157
                        ],
                        [
                            -157.81122946257094,
                            21.307397081688162
                        ],
                        [
                            -157.81126667214963,
                            21.307449930820876
                        ],
                        [
                            -157.81126095107609,
                            21.307453468716719
                        ],
                        [
                            -157.81126256854088,
                            21.307455767523781
                        ],
                        [
                            -157.81126828865047,
                            21.307452229621077
                        ],
                        [
                            -157.81130549825636,
                            21.307505078746168
                        ],
                        [
                            -157.81130427265447,
                            21.30750583706299
                        ],
                        [
                            -157.81130525058185,
                            21.307507225252838
                        ],
                        [
                            -157.81127868563993,
                            21.307523649052538
                        ],
                        [
                            -157.81126881016959,
                            21.307509621930677
                        ],
                        [
                            -157.81126635800143,
                            21.307511138556958
                        ],
                        [
                            -157.81127525651564,
                            21.307523776592419
                        ],
                        [
                            -157.81123234605246,
                            21.307550307628514
                        ],
                        [
                            -157.81123396353229,
                            21.30755260462918
                        ],
                        [
                            -157.81124867458959,
                            21.307543508473827
                        ],
                        [
                            -157.81128588419494,
                            21.307596359410113
                        ],
                        [
                            -157.81127975330367,
                            21.307600149166092
                        ],
                        [
                            -157.81128137174147,
                            21.307602447076498
                        ],
                        [
                            -157.81128750264008,
                            21.307598656417127
                        ],
                        [
                            -157.81132471227988,
                            21.307651506442451
                        ],
                        [
                            -157.81131858138718,
                            21.307655296199759
                        ],
                        [
                            -157.81132019885493,
                            21.307657595006336
                        ],
                        [
                            -157.81132632974769,
                            21.307653805248975
                        ],
                        [
                            -157.81136353845795,
                            21.307706654356515
                        ],
                        [
                            -157.81134882642644,
                            21.307715750514504
                        ],
                        [
                            -157.81135044486655,
                            21.307718048424316
                        ],
                        [
                            -157.81136393033088,
                            21.307709710576564
                        ],
                        [
                            -157.81139224148617,
                            21.307749922557246
                        ],
                        [
                            -157.81139469365723,
                            21.307748405929299
                        ],
                        [
                            -157.81138498782386,
                            21.307734619409903
                        ],
                        [
                            -157.81144138473309,
                            21.307699751392594
                        ],
                        [
                            -157.81144542891971,
                            21.307705494796416
                        ],
                        [
                            -157.8114478820462,
                            21.307703979077772
                        ],
                        [
                            -157.81144383690281,
                            21.307698234763858
                        ],
                        [
                            -157.8115002347561,
                            21.307663365828851
                        ],
                        [
                            -157.81150427892962,
                            21.307669111038017
                        ],
                        [
                            -157.81150673109096,
                            21.307667595311635
                        ],
                        [
                            -157.8115026859534,
                            21.307661850095723
                        ],
                        [
                            -157.81155908474344,
                            21.307626981146331
                        ],
                        [
                            -157.81156879154381,
                            21.307640768566433
                        ],
                        [
                            -157.81157124371131,
                            21.307639251935736
                        ],
                        [
                            -157.81156234515726,
                            21.307626614817909
                        ],
                        [
                            -157.8116052565525,
                            21.307600083702944
                        ],
                        [
                            -157.81160363906622,
                            21.307597786705564
                        ],
                        [
                            -157.81159015362491,
                            21.307606124573763
                        ],
                        [
                            -157.81157100783736,
                            21.307578932857012
                        ],
                        [
                            -157.81156978319282,
                            21.307579692085959
                        ],
                        [
                            -157.81155171733252,
                            21.307554032914833
                        ],
                        [
                            -157.81155784822261,
                            21.307550242245171
                        ],
                        [
                            -157.81155622978088,
                            21.307547944337241
                        ],
                        [
                            -157.81155009889082,
                            21.307551735006861
                        ],
                        [
                            -157.81151288919827,
                            21.307498884124861
                        ],
                        [
                            -157.81151902007235,
                            21.307495095263203
                        ],
                        [
                            -157.81151740356705,
                            21.307492796465223
                        ],
                        [
                            -157.81151127267844,
                            21.307496587133503
                        ],
                        [
                            -157.81147406396977,
                            21.307443737154014
                        ],
                        [
                            -157.8114752895703,
                            21.307442978835887
                        ],
                        [
                            -157.81147475009294,
                            21.307442212565231
                        ],
                        [
                            -157.81150785279763,
                            21.307421747087155
                        ],
                        [
                            -157.81141075865864,
                            21.307283680226277
                        ],
                        [
                            -157.81143408004951,
                            21.307269474793895
                        ],
                        [
                            -157.81143461952607,
                            21.307270241064657
                        ],
                        [
                            -157.81145341907913,
                            21.307258618088785
                        ],
                        [
                            -157.81143238710513,
                            21.307228746231296
                        ],
                        [
                            -157.81141603970931,
                            21.307238853479546
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 163,
                "NUMBER": "1012B",
                "PROPER_NAME": "INSTITUTE FOR ASTRONOMY - ADMINISTRATION",
                "DISPLAY_NAME": "INSTITUTE FOR ASTRONOMY - ADMINISTRATION (IFA B) - 1012B",
                "ADDRESS": "2680 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "INSTITUTE FOR ASTRONOMY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1012B_01.jpg",
                "HEIGHT (ft)": 38,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 213.38983003631716,
                "SHAPE_Area": 1208.5837037589602
            }
        },
        {
            "type": "Feature",
            "id": 164,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.81429581411217,
                                21.304166496168225
                            ],
                            [
                                -157.81436382971353,
                                21.304237643965955
                            ],
                            [
                                -157.81440690171212,
                                21.304201483974456
                            ],
                            [
                                -157.81433888514084,
                                21.304130336186859
                            ],
                            [
                                -157.81429581411217,
                                21.304166496168225
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81434998998776,
                                21.304121154700248
                            ],
                            [
                                -157.81441795312989,
                                21.304192233449427
                            ],
                            [
                                -157.81446098341286,
                                21.304156102960746
                            ],
                            [
                                -157.81439302027204,
                                21.304085023325129
                            ],
                            [
                                -157.81434998998776,
                                21.304121154700248
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 164,
                "NUMBER": "1172F",
                "PROPER_NAME": "BIOMEDICAL SCIENCES MECHANICAL BUILDING",
                "DISPLAY_NAME": "BIOMEDICAL SCIENCES MECHANICAL BUILDING - 1172F",
                "ADDRESS": "1960 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BIOMEDICAL SCIENCES BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1172F_01.jpg",
                "HEIGHT (ft)": 27.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 66.262725863612033,
                "SHAPE_Area": 126.7533555654059
            }
        },
        {
            "type": "Feature",
            "id": 165,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81597474625602,
                            21.291748016457024
                        ],
                        [
                            -157.81598674129825,
                            21.291734186800827
                        ],
                        [
                            -157.81597749547268,
                            21.29172718101881
                        ],
                        [
                            -157.81596546315913,
                            21.291741090813961
                        ],
                        [
                            -157.81597474625602,
                            21.291748016457024
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 165,
                "NUMBER": "1252J",
                "PROPER_NAME": "PARKING KIOSK - WAI`ALAE AVE 3",
                "DISPLAY_NAME": "PARKING KIOSK - WAI`ALAE AVE 3 - 1252J",
                "ADDRESS": "2600 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PARKING KIOSKS - WAIALAE AVE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1252J_01.jpg",
                "HEIGHT (ft)": 8.0999999999999996,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 6.4195407095207235,
                "SHAPE_Area": 2.4367240666938992
            }
        },
        {
            "type": "Feature",
            "id": 166,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81601584316397,
                            21.291779226769478
                        ],
                        [
                            -157.81602786575075,
                            21.291765327743011
                        ],
                        [
                            -157.81601846663597,
                            21.291758324498545
                        ],
                        [
                            -157.8160065160142,
                            21.291772264683097
                        ],
                        [
                            -157.81601584316397,
                            21.291779226769478
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 166,
                "NUMBER": "1252I",
                "PROPER_NAME": "PARKING KIOSK - WAI`ALAE AVE 2",
                "DISPLAY_NAME": "PARKING KIOSK - WAI`ALAE AVE 2 - 1252I",
                "ADDRESS": "2600 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PARKING KIOSKS - WAIALAE AVE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1252I_01.jpg",
                "HEIGHT (ft)": 8.3000000000000007,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 6.4429182746813751,
                "SHAPE_Area": 2.4579715910149922
            }
        },
        {
            "type": "Feature",
            "id": 167,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81605698693593,
                            21.291810003774533
                        ],
                        [
                            -157.8160689355129,
                            21.291796078026263
                        ],
                        [
                            -157.81605958871302,
                            21.291789161877414
                        ],
                        [
                            -157.81604762388008,
                            21.29180307124966
                        ],
                        [
                            -157.81605698693593,
                            21.291810003774533
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 167,
                "NUMBER": "1252H",
                "PROPER_NAME": "PARKING KIOSK - WAI`ALAE AVE 1",
                "DISPLAY_NAME": "PARKING KIOSK - WAI`ALAE AVE 1 - 1252H",
                "ADDRESS": "2600 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PARKING KIOSKS - WAIALAE AVE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1252H_01.jpg",
                "HEIGHT (ft)": 8.0999999999999996,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 6.4293063587588835,
                "SHAPE_Area": 2.4460327964733652
            }
        },
        {
            "type": "Feature",
            "id": 168,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81915949023724,
                            21.296950716439181
                        ],
                        [
                            -157.81915958405014,
                            21.297007151027429
                        ],
                        [
                            -157.81936643129592,
                            21.297006847770625
                        ],
                        [
                            -157.81936633740403,
                            21.296950413178834
                        ],
                        [
                            -157.81915949023724,
                            21.296950716439181
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 168,
                "NUMBER": "1103A",
                "PROPER_NAME": "BACHMAN ANNEX 9",
                "DISPLAY_NAME": "BACHMAN ANNEX 9 - 1103A",
                "ADDRESS": "2444 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BACHMAN HALL AND ANNEXES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1103A_01.jpg",
                "HEIGHT (ft)": 17.300000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.411468549272271,
                "SHAPE_Area": 134.05507844401137
            }
        },
        {
            "type": "Feature",
            "id": 169,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81939130533291,
                            21.293608259529833
                        ],
                        [
                            -157.8193687002474,
                            21.293641652032527
                        ],
                        [
                            -157.81935877825978,
                            21.293635751952255
                        ],
                        [
                            -157.81926257340075,
                            21.293777863563438
                        ],
                        [
                            -157.81927249540064,
                            21.293783762746212
                        ],
                        [
                            -157.81925775827938,
                            21.293805530475037
                        ],
                        [
                            -157.81930850131161,
                            21.293835702842085
                        ],
                        [
                            -157.81944776837548,
                            21.293629980997345
                        ],
                        [
                            -157.81940890547602,
                            21.293606873405714
                        ],
                        [
                            -157.8194031854355,
                            21.293615323359099
                        ],
                        [
                            -157.81939130533291,
                            21.293608259529833
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 169,
                "NUMBER": "1171A",
                "PROPER_NAME": "VARSITY BUILDING A - FINANCIAL MANAGEMENT OFFICE",
                "DISPLAY_NAME": "VARSITY BUILDING A - FINANCIAL MANAGEMENT OFFICE - 1171A",
                "ADDRESS": "1408 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "VARSITY BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1171A_01.jpg",
                "HEIGHT (ft)": 14.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 68.845565785362297,
                "SHAPE_Area": 189.22920837004099
            }
        },
        {
            "type": "Feature",
            "id": 170,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81389063844614,
                            21.303096907870231
                        ],
                        [
                            -157.81413207612013,
                            21.302770286363668
                        ],
                        [
                            -157.81409464804327,
                            21.302745989723917
                        ],
                        [
                            -157.81409409059049,
                            21.302746742835268
                        ],
                        [
                            -157.81406028276521,
                            21.302724797026375
                        ],
                        [
                            -157.81406084023254,
                            21.302724042108487
                        ],
                        [
                            -157.81404635253648,
                            21.302714637802005
                        ],
                        [
                            -157.81404579508362,
                            21.302715390913182
                        ],
                        [
                            -157.81401198631622,
                            21.302693444185056
                        ],
                        [
                            -157.81401254377641,
                            21.302692690170645
                        ],
                        [
                            -157.81399805512996,
                            21.302683284950131
                        ],
                        [
                            -157.8139974976697,
                            21.302684038964472
                        ],
                        [
                            -157.81396369084484,
                            21.302662092240823
                        ],
                        [
                            -157.81396424830515,
                            21.302661338226574
                        ],
                        [
                            -157.81394975966495,
                            21.30265193300216
                        ],
                        [
                            -157.81394920220461,
                            21.302652687016355
                        ],
                        [
                            -157.81391539443038,
                            21.302630740276772
                        ],
                        [
                            -157.81391595189081,
                            21.302629986262708
                        ],
                        [
                            -157.81389985405701,
                            21.30261953531086
                        ],
                        [
                            -157.81389929562536,
                            21.302620290221434
                        ],
                        [
                            -157.81386709900073,
                            21.302599388306515
                        ],
                        [
                            -157.8138676564613,
                            21.30259863429259
                        ],
                        [
                            -157.81385316784088,
                            21.302589228157021
                        ],
                        [
                            -157.81385261037303,
                            21.30258998307421
                        ],
                        [
                            -157.81381880262808,
                            21.302568036316416
                        ],
                        [
                            -157.81381936105993,
                            21.302567281406116
                        ],
                        [
                            -157.81380487147456,
                            21.302557876163181
                        ],
                        [
                            -157.8138043140066,
                            21.302558631080224
                        ],
                        [
                            -157.81377050724021,
                            21.302536684320089
                        ],
                        [
                            -157.81377106470822,
                            21.302535929403163
                        ],
                        [
                            -157.81375657609306,
                            21.30252652416311
                        ],
                        [
                            -157.81375601766106,
                            21.302527279073196
                        ],
                        [
                            -157.81374434660935,
                            21.302519701376553
                        ],
                        [
                            -157.8137449050341,
                            21.302518947369862
                        ],
                        [
                            -157.81373403857873,
                            21.302511892986665
                        ],
                        [
                            -157.81372902140191,
                            21.302518682721072
                        ],
                        [
                            -157.81372982600428,
                            21.302519205131926
                        ],
                        [
                            -157.81371923130365,
                            21.302533537689943
                        ],
                        [
                            -157.8137184267085,
                            21.302533014375701
                        ],
                        [
                            -157.8136824300297,
                            21.302583322381988
                        ],
                        [
                            -157.81367920969902,
                            21.302581231820682
                        ],
                        [
                            -157.81354204160118,
                            21.302766794669655
                        ],
                        [
                            -157.81354526097701,
                            21.302768884323502
                        ],
                        [
                            -157.81349340414687,
                            21.302839036315675
                        ],
                        [
                            -157.81376144688053,
                            21.303013040738954
                        ],
                        [
                            -157.81376088844658,
                            21.303013795648923
                        ],
                        [
                            -157.81376571896905,
                            21.303016930134088
                        ],
                        [
                            -157.81376627643175,
                            21.303016176120643
                        ],
                        [
                            -157.81389063844614,
                            21.303096907870231
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 170,
                "NUMBER": "1210",
                "PROPER_NAME": "AGRICULTURAL SCIENCE BUILDING",
                "DISPLAY_NAME": "AGRICULTURAL SCIENCE BUILDING (AGSCI) - 1210",
                "ADDRESS": "1955 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "AGRICULTURAL SCIENCE BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1210_01.jpg",
                "HEIGHT (ft)": 57.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 191.17291966254643,
                "SHAPE_Area": 2212.3579801444848
            }
        },
        {
            "type": "Feature",
            "id": 171,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81373090672946,
                            21.302490974614841
                        ],
                        [
                            -157.81380517562658,
                            21.302540161040266
                        ],
                        [
                            -157.81383028908277,
                            21.302506858472274
                        ],
                        [
                            -157.81382869251024,
                            21.302505801093087
                        ],
                        [
                            -157.81384280710014,
                            21.302487102868767
                        ],
                        [
                            -157.81386791387791,
                            21.302453789406499
                        ],
                        [
                            -157.81379524252824,
                            21.302405661298909
                        ],
                        [
                            -157.81373090672946,
                            21.302490974614841
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 171,
                "NUMBER": "1210A",
                "PROPER_NAME": "AGRICULTURAL SCIENCE MECHANICAL BUILDING",
                "DISPLAY_NAME": "AGRICULTURAL SCIENCE MECHANICAL BUILDING - 1210A",
                "ADDRESS": "1955 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "AGRICULTURAL SCIENCE BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1210A_01.jpg",
                "HEIGHT (ft)": 24.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 41.99677563422469,
                "SHAPE_Area": 107.67338621315011
            }
        },
        {
            "type": "Feature",
            "id": 172,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8198055531866,
                            21.294283150377112
                        ],
                        [
                            -157.8198329008093,
                            21.294321134598881
                        ],
                        [
                            -157.81987343119775,
                            21.294295505887938
                        ],
                        [
                            -157.81984608453982,
                            21.294257520775798
                        ],
                        [
                            -157.8198055531866,
                            21.294283150377112
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 172,
                "NUMBER": "1214",
                "PROPER_NAME": "COMMUNICATION VAULT (LOWER CAMPUS ROAD)",
                "DISPLAY_NAME": "COMMUNICATION VAULT (LOWER CAMPUS ROAD) - 1214",
                "ADDRESS": "1400 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "COMMUNICATION VAULT (LOWER CAMPUS ROAD)",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1214_01.jpg",
                "HEIGHT (ft)": 11.9,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 20.289606921428991,
                "SHAPE_Area": 25.729259311631207
            }
        },
        {
            "type": "Feature",
            "id": 173,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81658928446504,
                            21.301759378026972
                        ],
                        [
                            -157.81659124953487,
                            21.30175932228552
                        ],
                        [
                            -157.81659114521298,
                            21.301756098256881
                        ],
                        [
                            -157.81666389040382,
                            21.301754034264789
                        ],
                        [
                            -157.81666395198036,
                            21.301756336535188
                        ],
                        [
                            -157.81666837483158,
                            21.301756211350931
                        ],
                        [
                            -157.81666830073098,
                            21.301753908089076
                        ],
                        [
                            -157.81674103339017,
                            21.301751843975399
                        ],
                        [
                            -157.81674110749915,
                            21.301754146333941
                        ],
                        [
                            -157.81674553035035,
                            21.301754021147648
                        ],
                        [
                            -157.81674545624853,
                            21.301751717885764
                        ],
                        [
                            -157.81681818890732,
                            21.301749653738639
                        ],
                        [
                            -157.81681829323418,
                            21.30175287776737
                        ],
                        [
                            -157.81682025830398,
                            21.301752822023243
                        ],
                        [
                            -157.81681987121308,
                            21.301740847578447
                        ],
                        [
                            -157.81687589595907,
                            21.301739256744927
                        ],
                        [
                            -157.81687550885638,
                            21.301727283203373
                        ],
                        [
                            -157.8168914801094,
                            21.301726829972907
                        ],
                        [
                            -157.81689091457289,
                            21.301709329140568
                        ],
                        [
                            -157.81687494332175,
                            21.301709782371073
                        ],
                        [
                            -157.81687446652478,
                            21.301695044729065
                        ],
                        [
                            -157.81702386289047,
                            21.301690804802629
                        ],
                        [
                            -157.81701915807821,
                            21.301545274449229
                        ],
                        [
                            -157.81686779678563,
                            21.301549571026584
                        ],
                        [
                            -157.81686807175748,
                            21.301558091023619
                        ],
                        [
                            -157.81681401408269,
                            21.301559625223796
                        ],
                        [
                            -157.81681230083993,
                            21.30150643422602
                        ],
                        [
                            -157.81681222673697,
                            21.301504130964059
                        ],
                        [
                            -157.81681025493015,
                            21.301504185757473
                        ],
                        [
                            -157.81681032901861,
                            21.301506490826107
                        ],
                        [
                            -157.8167688022852,
                            21.301507668652174
                        ],
                        [
                            -157.81676872531278,
                            21.30150536265986
                        ],
                        [
                            -157.81676676215972,
                            21.301505420223773
                        ],
                        [
                            -157.81676684010324,
                            21.301507725319524
                        ],
                        [
                            -157.81673759648697,
                            21.301508554072118
                        ],
                        [
                            -157.81673752238518,
                            21.301506250810178
                        ],
                        [
                            -157.81673309954141,
                            21.30150637599661
                        ],
                        [
                            -157.8167331736359,
                            21.301508680161884
                        ],
                        [
                            -157.81666044110389,
                            21.301510743374443
                        ],
                        [
                            -157.8166603669961,
                            21.301508441015862
                        ],
                        [
                            -157.8166559441523,
                            21.301508566200241
                        ],
                        [
                            -157.81665601826003,
                            21.301510868558839
                        ],
                        [
                            -157.81658328667712,
                            21.30151293355139
                        ],
                        [
                            -157.81658315506991,
                            21.301508903506999
                        ],
                        [
                            -157.8165811900034,
                            21.301508959248512
                        ],
                        [
                            -157.81658329211018,
                            21.301574010875498
                        ],
                        [
                            -157.81650515414978,
                            21.301576229330628
                        ],
                        [
                            -157.81650521458647,
                            21.301578071767587
                        ],
                        [
                            -157.81650865394545,
                            21.301577973095785
                        ],
                        [
                            -157.81651048400551,
                            21.301634619476275
                        ],
                        [
                            -157.81650802815409,
                            21.30163468892956
                        ],
                        [
                            -157.81650816173223,
                            21.301638833718236
                        ],
                        [
                            -157.8165106195116,
                            21.301638764278515
                        ],
                        [
                            -157.8165124505359,
                            21.301695410665452
                        ],
                        [
                            -157.81650999274834,
                            21.30169548100849
                        ],
                        [
                            -157.81651012632651,
                            21.301699625797145
                        ],
                        [
                            -157.81651258410687,
                            21.301699556357441
                        ],
                        [
                            -157.81651413921631,
                            21.30174768274075
                        ],
                        [
                            -157.81651069986785,
                            21.301747779605801
                        ],
                        [
                            -157.81651075934062,
                            21.301749622035949
                        ],
                        [
                            -157.81658889738563,
                            21.301747404485845
                        ],
                        [
                            -157.81658928446504,
                            21.301759378026972
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 173,
                "NUMBER": "1089",
                "PROPER_NAME": "GILMORE HALL",
                "DISPLAY_NAME": "GILMORE HALL (GIL) - 1089",
                "ADDRESS": "3050 MAILE WAY",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "GILMORE HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1089_01.jpg",
                "HEIGHT (ft)": 75.700000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 172.98227963887462,
                "SHAPE_Area": 1165.6234548830109
            }
        },
        {
            "type": "Feature",
            "id": 174,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81707775433111,
                            21.30168848703255
                        ],
                        [
                            -157.81713602247109,
                            21.301686630927545
                        ],
                        [
                            -157.81713454575569,
                            21.30164590747038
                        ],
                        [
                            -157.81717207497982,
                            21.301644712297186
                        ],
                        [
                            -157.81716653579807,
                            21.301492001353086
                        ],
                        [
                            -157.81706777447226,
                            21.301495147430366
                        ],
                        [
                            -157.81707331450843,
                            21.301647859283051
                        ],
                        [
                            -157.81707627666066,
                            21.30164776447219
                        ],
                        [
                            -157.81707775433111,
                            21.30168848703255
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 174,
                "NUMBER": "1089A",
                "PROPER_NAME": "GILMORE MECHANICAL BUILDING",
                "DISPLAY_NAME": "GILMORE MECHANICAL BUILDING - 1089A",
                "ADDRESS": "3050 MAILE WAY",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "GILMORE HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1089A_01.jpg",
                "HEIGHT (ft)": 12.9,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 63.352298025008253,
                "SHAPE_Area": 200.67327476886686
            }
        },
        {
            "type": "Feature",
            "id": 175,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81753175785792,
                            21.298223743379328
                        ],
                        [
                            -157.81753322625315,
                            21.298223710333641
                        ],
                        [
                            -157.81753318511559,
                            21.298222104719787
                        ],
                        [
                            -157.8175576570622,
                            21.298221556657278
                        ],
                        [
                            -157.81755769820001,
                            21.298223162271135
                        ],
                        [
                            -157.81755916659523,
                            21.298223129225217
                        ],
                        [
                            -157.8175590255471,
                            21.298217624779603
                        ],
                        [
                            -157.81763586891836,
                            21.298215904373656
                        ],
                        [
                            -157.81763598348437,
                            21.298220381478309
                        ],
                        [
                            -157.81763745091567,
                            21.29822034842492
                        ],
                        [
                            -157.81763733732078,
                            21.2982158704237
                        ],
                        [
                            -157.81770194375159,
                            21.29821442446994
                        ],
                        [
                            -157.81770196727737,
                            21.298215339769765
                        ],
                        [
                            -157.81770343470137,
                            21.298215307619149
                        ],
                        [
                            -157.81770341214676,
                            21.298214391422743
                        ],
                        [
                            -157.81777970403374,
                            21.298212682434389
                        ],
                        [
                            -157.81777973778904,
                            21.298214006138583
                        ],
                        [
                            -157.81778071639789,
                            21.298213984104418
                        ],
                        [
                            -157.81777954820089,
                            21.298168168579345
                        ],
                        [
                            -157.81770080934089,
                            21.298169931746301
                        ],
                        [
                            -157.8176971437899,
                            21.298168671964156
                        ],
                        [
                            -157.81769342006717,
                            21.298167574383569
                        ],
                        [
                            -157.81768964489842,
                            21.298166641761931
                        ],
                        [
                            -157.81768582790116,
                            21.298165876877007
                        ],
                        [
                            -157.81768197582281,
                            21.298165279776168
                        ],
                        [
                            -157.8176780982736,
                            21.298164854140499
                        ],
                        [
                            -157.81767420491443,
                            21.298164597327698
                        ],
                        [
                            -157.81767030149985,
                            21.29816451299174
                        ],
                        [
                            -157.8176663995969,
                            21.298164601213898
                        ],
                        [
                            -157.81766250404681,
                            21.29816485931801
                        ],
                        [
                            -157.81765862735887,
                            21.298165290102116
                        ],
                        [
                            -157.81765477631657,
                            21.298165889096929
                        ],
                        [
                            -157.81765096054468,
                            21.298166658176864
                        ],
                        [
                            -157.8176471858628,
                            21.29816759286583
                        ],
                        [
                            -157.81764346287403,
                            21.298168693238317
                        ],
                        [
                            -157.81763979931861,
                            21.298169955735172
                        ],
                        [
                            -157.81763620291511,
                            21.298171379507231
                        ],
                        [
                            -157.8175578911723,
                            21.298173132960358
                        ],
                        [
                            -157.81755775108809,
                            21.298167628521501
                        ],
                        [
                            -157.8175562826934,
                            21.298167661567433
                        ],
                        [
                            -157.81755642374148,
                            21.298173166013072
                        ],
                        [
                            -157.817531950839,
                            21.298173714068987
                        ],
                        [
                            -157.81753181075575,
                            21.298168209630163
                        ],
                        [
                            -157.81753034139714,
                            21.298168242669092
                        ],
                        [
                            -157.81753175785792,
                            21.298223743379328
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 175,
                "NUMBER": "1192A",
                "PROPER_NAME": "KUYKENDALL MECHANICAL BUILDING",
                "DISPLAY_NAME": "KUYKENDALL MECHANICAL BUILDING - 1192A",
                "ADDRESS": "1733 DONAGHO ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KUYKENDALL HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1192A_01.jpg",
                "HEIGHT (ft)": 11.4,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 67.22480713239537,
                "SHAPE_Area": 131.94545558525436
            }
        },
        {
            "type": "Feature",
            "id": 176,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81465166184347,
                            21.298159355092604
                        ],
                        [
                            -157.81399037102889,
                            21.298180190765002
                        ],
                        [
                            -157.81399041976698,
                            21.29818156516404
                        ],
                        [
                            -157.81399439426627,
                            21.298181439596487
                        ],
                        [
                            -157.81399450137428,
                            21.298184429667447
                        ],
                        [
                            -157.81399052688215,
                            21.298184554331645
                        ],
                        [
                            -157.81399527897,
                            21.298316981370583
                        ],
                        [
                            -157.81399925250906,
                            21.298316855796291
                        ],
                        [
                            -157.8139993596171,
                            21.298319845867212
                        ],
                        [
                            -157.81399538608525,
                            21.298319970538167
                        ],
                        [
                            -157.81399543481612,
                            21.298321345840503
                        ],
                        [
                            -157.81465672722771,
                            21.298300510184756
                        ],
                        [
                            -157.81465667751948,
                            21.298299135778848
                        ],
                        [
                            -157.81465270398792,
                            21.298299260465356
                        ],
                        [
                            -157.81465259589547,
                            21.298296271290791
                        ],
                        [
                            -157.81465656943422,
                            21.298296145700931
                        ],
                        [
                            -157.81465181868023,
                            21.298163718666359
                        ],
                        [
                            -157.81464784514506,
                            21.298163844256262
                        ],
                        [
                            -157.81464773801659,
                            21.298160855088433
                        ],
                        [
                            -157.81465171158789,
                            21.298160724981827
                        ],
                        [
                            -157.81465166184347,
                            21.298159355092604
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 176,
                "NUMBER": "1182",
                "PROPER_NAME": "HALE MĀNOA",
                "DISPLAY_NAME": "HALE MĀNOA - 1182",
                "ADDRESS": "1711 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE MANOA",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1182_01.jpg",
                "HEIGHT (ft)": 121,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 171.85083254967944,
                "SHAPE_Area": 1072.6143938523783
            }
        },
        {
            "type": "Feature",
            "id": 178,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81661128711096,
                            21.299121331347525
                        ],
                        [
                            -157.81669211486613,
                            21.299119034137799
                        ],
                        [
                            -157.81669107709524,
                            21.299086951973667
                        ],
                        [
                            -157.81671553301004,
                            21.29908625667419
                        ],
                        [
                            -157.81671649656113,
                            21.299116050932678
                        ],
                        [
                            -157.81679279932303,
                            21.299113883565227
                        ],
                        [
                            -157.81679186506008,
                            21.299085004646738
                        ],
                        [
                            -157.81681632096038,
                            21.299084311139268
                        ],
                        [
                            -157.81681641077034,
                            21.299087060786995
                        ],
                        [
                            -157.8168203234811,
                            21.299086950076777
                        ],
                        [
                            -157.81682023464222,
                            21.299084199532484
                        ],
                        [
                            -157.81692490602114,
                            21.299081225171726
                        ],
                        [
                            -157.81691612636072,
                            21.298809865431021
                        ],
                        [
                            -157.81681145421774,
                            21.298812838885215
                        ],
                        [
                            -157.81681136633563,
                            21.298810089250967
                        ],
                        [
                            -157.81680745363224,
                            21.298810199961302
                        ],
                        [
                            -157.81680754150705,
                            21.29881295049891
                        ],
                        [
                            -157.81678504199263,
                            21.298813590007356
                        ],
                        [
                            -157.81678495411822,
                            21.298810839469756
                        ],
                        [
                            -157.81678104140758,
                            21.298810951082835
                        ],
                        [
                            -157.81678112928191,
                            21.298813701620428
                        ],
                        [
                            -157.81676352114141,
                            21.298814201161338
                        ],
                        [
                            -157.81676347720443,
                            21.298812825892547
                        ],
                        [
                            -157.81676054219307,
                            21.298812909146925
                        ],
                        [
                            -157.8167605861228,
                            21.298814285319054
                        ],
                        [
                            -157.8167292835092,
                            21.298815173693058
                        ],
                        [
                            -157.81672923860134,
                            21.298813799320833
                        ],
                        [
                            -157.8167263045539,
                            21.298813882581399
                        ],
                        [
                            -157.81672634849056,
                            21.298815257850187
                        ],
                        [
                            -157.81670874035001,
                            21.298815757385348
                        ],
                        [
                            -157.81670865150588,
                            21.298813007744339
                        ],
                        [
                            -157.81670473783851,
                            21.298813118445519
                        ],
                        [
                            -157.81670482763926,
                            21.298815868996641
                        ],
                        [
                            -157.81668232812467,
                            21.298816508491292
                        ],
                        [
                            -157.81668224073155,
                            21.298813818484263
                        ],
                        [
                            -157.8166783280281,
                            21.298813929191599
                        ],
                        [
                            -157.81667841445724,
                            21.298816619191857
                        ],
                        [
                            -157.81657373546713,
                            21.298819363891894
                        ],
                        [
                            -157.81658252132837,
                            21.299090954033456
                        ],
                        [
                            -157.81661027962394,
                            21.29909016453076
                        ],
                        [
                            -157.81661128711096,
                            21.299121331347525
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 178,
                "NUMBER": "1126A",
                "PROPER_NAME": "BILGER ADDITION",
                "DISPLAY_NAME": "BILGER ADDITION (BILA) - 1126A",
                "ADDRESS": "2545 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BILGER HALL AND ADDITION",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1126A_01.jpg",
                "HEIGHT (ft)": 82.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 148.345263097615,
                "SHAPE_Area": 1122.796037139346
            }
        },
        {
            "type": "Feature",
            "id": 180,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81708531424508,
                            21.297897534680938
                        ],
                        [
                            -157.81708922791728,
                            21.297897420356399
                        ],
                        [
                            -157.81708916645061,
                            21.297895585138523
                        ],
                        [
                            -157.81713027211103,
                            21.29789437803494
                        ],
                        [
                            -157.81713033357821,
                            21.297896213252827
                        ],
                        [
                            -157.81713424918541,
                            21.297896098037434
                        ],
                        [
                            -157.81713397303966,
                            21.297887842722069
                        ],
                        [
                            -157.8171325036044,
                            21.29788788569439
                        ],
                        [
                            -157.81713103208131,
                            21.297843861269179
                        ],
                        [
                            -157.81713249959552,
                            21.297843817379967
                        ],
                        [
                            -157.81713236199738,
                            21.29783969062898
                        ],
                        [
                            -157.81719304085141,
                            21.29783790739701
                        ],
                        [
                            -157.81719428306232,
                            21.297875053603139
                        ],
                        [
                            -157.8171874324411,
                            21.297875254792675
                        ],
                        [
                            -157.81718755538407,
                            21.297878924325129
                        ],
                        [
                            -157.81718951270551,
                            21.297878866713368
                        ],
                        [
                            -157.81719002436441,
                            21.297878892894087
                        ],
                        [
                            -157.81719052282011,
                            21.297879002997291
                        ],
                        [
                            -157.81719099268616,
                            21.297879192397943
                        ],
                        [
                            -157.81719142148219,
                            21.297879454684562
                        ],
                        [
                            -157.81719179480001,
                            21.297879783432172
                        ],
                        [
                            -157.81719210213063,
                            21.29788016682285
                        ],
                        [
                            -157.81719233294316,
                            21.297880595748655
                        ],
                        [
                            -157.81719248060585,
                            21.297881055708746
                        ],
                        [
                            -157.81719254042207,
                            21.297881531312481
                        ],
                        [
                            -157.81719260189723,
                            21.29788336562703
                        ],
                        [
                            -157.81719651653299,
                            21.29788325130675
                        ],
                        [
                            -157.81719630185171,
                            21.297876831209205
                        ],
                        [
                            -157.81728634341971,
                            21.297874185591112
                        ],
                        [
                            -157.81728655810491,
                            21.297880605688729
                        ],
                        [
                            -157.81729047274789,
                            21.297880490462916
                        ],
                        [
                            -157.8172904112715,
                            21.297878656148349
                        ],
                        [
                            -157.81729043303372,
                            21.297878225384039
                        ],
                        [
                            -157.81729052606792,
                            21.29787780234772
                        ],
                        [
                            -157.81729068931622,
                            21.297877398776023
                        ],
                        [
                            -157.81729091693009,
                            21.297877022758367
                        ],
                        [
                            -157.81729120592382,
                            21.297876686017837
                        ],
                        [
                            -157.81729154660763,
                            21.297876394810089
                        ],
                        [
                            -157.81729193216179,
                            21.29787615812106
                        ],
                        [
                            -157.8172923529111,
                            21.297875980399755
                        ],
                        [
                            -157.81729279725232,
                            21.297875866081565
                        ],
                        [
                            -157.81729325455348,
                            21.297875818705336
                        ],
                        [
                            -157.81729521187489,
                            21.29787576109236
                        ],
                        [
                            -157.81729508988593,
                            21.297872092469994
                        ],
                        [
                            -157.81728823926474,
                            21.297872293663652
                        ],
                        [
                            -157.81728615294605,
                            21.297809924285058
                        ],
                        [
                            -157.81729300260042,
                            21.29780972308458
                        ],
                        [
                            -157.81729288061149,
                            21.297806054462168
                        ],
                        [
                            -157.81728602999337,
                            21.297806255655892
                        ],
                        [
                            -157.81728394366786,
                            21.297743887180221
                        ],
                        [
                            -157.81729079525422,
                            21.297743685089895
                        ],
                        [
                            -157.81729067229415,
                            21.297740017364028
                        ],
                        [
                            -157.81728382071518,
                            21.297740218551027
                        ],
                        [
                            -157.81728173536121,
                            21.297677849178374
                        ],
                        [
                            -157.81728858597336,
                            21.29767764798456
                        ],
                        [
                            -157.81728846302053,
                            21.297673979355327
                        ],
                        [
                            -157.81728161240855,
                            21.297674180549148
                        ],
                        [
                            -157.81727952609106,
                            21.297611811169311
                        ],
                        [
                            -157.81728637670011,
                            21.29761160997543
                        ],
                        [
                            -157.81728625375456,
                            21.297607940442848
                        ],
                        [
                            -157.81727940314565,
                            21.297608141636719
                        ],
                        [
                            -157.81727731682852,
                            21.297545772256449
                        ],
                        [
                            -157.81728416743456,
                            21.297545571062528
                        ],
                        [
                            -157.81728404448177,
                            21.297541902433267
                        ],
                        [
                            -157.81728208716478,
                            21.297541960046317
                        ],
                        [
                            -157.81728157647814,
                            21.297541932969384
                        ],
                        [
                            -157.81728107800899,
                            21.297541824673154
                        ],
                        [
                            -157.81728060717998,
                            21.297541635266018
                        ],
                        [
                            -157.81728017839197,
                            21.297541372076321
                        ],
                        [
                            -157.81727980507472,
                            21.297541043328916
                        ],
                        [
                            -157.81727949871572,
                            21.297540659041861
                        ],
                        [
                            -157.81727926886009,
                            21.297540231026264
                        ],
                        [
                            -157.81727911926956,
                            21.297539771052687
                        ],
                        [
                            -157.81727905945314,
                            21.297539295448964
                        ],
                        [
                            -157.81727899798403,
                            21.297537460230991
                        ],
                        [
                            -157.81727508335018,
                            21.297537575456957
                        ],
                        [
                            -157.81727529803521,
                            21.297543995554793
                        ],
                        [
                            -157.81725670256327,
                            21.297544542418489
                        ],
                        [
                            -157.81725394195391,
                            21.297461994687094
                        ],
                        [
                            -157.81727253644431,
                            21.297461448719798
                        ],
                        [
                            -157.81727275112925,
                            21.29746786881768
                        ],
                        [
                            -157.81727666672521,
                            21.297467753598436
                        ],
                        [
                            -157.81727660524885,
                            21.297465919283784
                        ],
                        [
                            -157.81727663317756,
                            21.297465440683119
                        ],
                        [
                            -157.81727675067074,
                            21.297464972649145
                        ],
                        [
                            -157.81727695277149,
                            21.297464532311441
                        ],
                        [
                            -157.81727723264564,
                            21.297464130462686
                        ],
                        [
                            -157.81727758343743,
                            21.297463780605565
                        ],
                        [
                            -157.81727799349315,
                            21.297463493498832
                        ],
                        [
                            -157.817278451188,
                            21.29746327628796
                        ],
                        [
                            -157.81727894102707,
                            21.297463137897946
                        ],
                        [
                            -157.81727944948665,
                            21.297463081847308
                        ],
                        [
                            -157.81728140680261,
                            21.29746302423424
                        ],
                        [
                            -157.81728128384987,
                            21.297459355604921
                        ],
                        [
                            -157.81727443324783,
                            21.29745955679893
                        ],
                        [
                            -157.81727234596769,
                            21.297397187410951
                        ],
                        [
                            -157.81727919753072,
                            21.297396986223681
                        ],
                        [
                            -157.81727907554193,
                            21.297393317601113
                        ],
                        [
                            -157.81727222397907,
                            21.297393518788386
                        ],
                        [
                            -157.8172701376632,
                            21.297331149406773
                        ],
                        [
                            -157.81727698825924,
                            21.297330948212661
                        ],
                        [
                            -157.81727686627769,
                            21.297327278686748
                        ],
                        [
                            -157.81727001567461,
                            21.297327480784187
                        ],
                        [
                            -157.81726792935916,
                            21.297265111402137
                        ],
                        [
                            -157.81727477898821,
                            21.297264910201211
                        ],
                        [
                            -157.81727465699944,
                            21.297261241578617
                        ],
                        [
                            -157.81726780640665,
                            21.297261442772765
                        ],
                        [
                            -157.81726572009157,
                            21.297199073390303
                        ],
                        [
                            -157.81727257164539,
                            21.29719887220287
                        ],
                        [
                            -157.81727244869273,
                            21.297195203573477
                        ],
                        [
                            -157.81726559713908,
                            21.297195404760906
                        ],
                        [
                            -157.81726351178833,
                            21.297133035384793
                        ],
                        [
                            -157.81727036237518,
                            21.297132834190538
                        ],
                        [
                            -157.81727023942253,
                            21.297129165561117
                        ],
                        [
                            -157.81726828211103,
                            21.297129223174267
                        ],
                        [
                            -157.81726777242588,
                            21.29712919158742
                        ],
                        [
                            -157.81726727689323,
                            21.297129077891498
                        ],
                        [
                            -157.81726680896446,
                            21.297128887601364
                        ],
                        [
                            -157.81726638210546,
                            21.297128624425216
                        ],
                        [
                            -157.81726600973872,
                            21.29712829749127
                        ],
                        [
                            -157.81726570336605,
                            21.297127915010893
                        ],
                        [
                            -157.81726547059765,
                            21.297127489684996
                        ],
                        [
                            -157.81726531905801,
                            21.297127032407879
                        ],
                        [
                            -157.81726525441496,
                            21.297126557673597
                        ],
                        [
                            -157.8172651919748,
                            21.297124723352113
                        ],
                        [
                            -157.81726127831581,
                            21.297124838585049
                        ],
                        [
                            -157.81726149300056,
                            21.297131258683148
                        ],
                        [
                            -157.81717145189339,
                            21.297133903405857
                        ],
                        [
                            -157.81717123721256,
                            21.297127483307825
                        ],
                        [
                            -157.81716732258963,
                            21.297127598531802
                        ],
                        [
                            -157.81716738406467,
                            21.297129432846507
                        ],
                        [
                            -157.81716735325122,
                            21.297129910523502
                        ],
                        [
                            -157.81716723480136,
                            21.297130377647303
                        ],
                        [
                            -157.81716703174413,
                            21.29713081707478
                        ],
                        [
                            -157.81716675187761,
                            21.297131218020027
                        ],
                        [
                            -157.8171664010936,
                            21.297131566973633
                        ],
                        [
                            -157.81716599199532,
                            21.297131854990237
                        ],
                        [
                            -157.81716553623644,
                            21.297132071311061
                        ],
                        [
                            -157.81716504734783,
                            21.297132211514263
                        ],
                        [
                            -157.81716454079549,
                            21.29713227028817
                        ],
                        [
                            -157.81716258348399,
                            21.297132327900083
                        ],
                        [
                            -157.81716270547003,
                            21.297135996522684
                        ],
                        [
                            -157.81716955605691,
                            21.297135795332544
                        ],
                        [
                            -157.81717079922927,
                            21.297172941548101
                        ],
                        [
                            -157.817110119685,
                            21.297174724778113
                        ],
                        [
                            -157.81710998209431,
                            21.297170597123511
                        ],
                        [
                            -157.81710851458683,
                            21.297170641012841
                        ],
                        [
                            -157.81710704114616,
                            21.297126615667526
                        ],
                        [
                            -157.81710850865321,
                            21.297126571778172
                        ],
                        [
                            -157.8171082325008,
                            21.297118317365502
                        ],
                        [
                            -157.81710431787812,
                            21.297118432588036
                        ],
                        [
                            -157.81710436471036,
                            21.297119807877454
                        ],
                        [
                            -157.81706325926586,
                            21.297121014984828
                        ],
                        [
                            -157.81706321339792,
                            21.297119639702185
                        ],
                        [
                            -157.81705929877526,
                            21.297119754923646
                        ],
                        [
                            -157.81705957395377,
                            21.297128010232832
                        ],
                        [
                            -157.81706104242474,
                            21.29712796635069
                        ],
                        [
                            -157.81706251488777,
                            21.29717199168898
                        ],
                        [
                            -157.81706104738754,
                            21.297172034674574
                        ],
                        [
                            -157.81706118498403,
                            21.297176161425799
                        ],
                        [
                            -157.81700050543915,
                            21.297177944616141
                        ],
                        [
                            -157.8169992632736,
                            21.297140798408112
                        ],
                        [
                            -157.81700611482449,
                            21.297140597231422
                        ],
                        [
                            -157.81700599187846,
                            21.297136928602121
                        ],
                        [
                            -157.81700403456688,
                            21.297136986212184
                        ],
                        [
                            -157.81700357395457,
                            21.29713696581015
                        ],
                        [
                            -157.81700312159569,
                            21.297136877711868
                        ],
                        [
                            -157.81700269096345,
                            21.297136724722176
                        ],
                        [
                            -157.81700229070404,
                            21.297136510515408
                        ],
                        [
                            -157.81700193136996,
                            21.297136241489497
                        ],
                        [
                            -157.81700162064351,
                            21.297135921311995
                        ],
                        [
                            -157.81700136808433,
                            21.297135559987385
                        ],
                        [
                            -157.81700117843968,
                            21.297135166582937
                        ],
                        [
                            -157.81700105645677,
                            21.297134750165931
                        ],
                        [
                            -157.81700100591178,
                            21.297134320700202
                        ],
                        [
                            -157.8170009444388,
                            21.29713248638555
                        ],
                        [
                            -157.81699702981584,
                            21.297132601605547
                        ],
                        [
                            -157.81699724448907,
                            21.297139021703444
                        ],
                        [
                            -157.81690720530776,
                            21.297141666297861
                        ],
                        [
                            -157.81690699063844,
                            21.297135246200032
                        ],
                        [
                            -157.8169030750515,
                            21.297135361411073
                        ],
                        [
                            -157.81690313652325,
                            21.297137195725707
                        ],
                        [
                            -157.81690311476012,
                            21.297137626489935
                        ],
                        [
                            -157.81690302171819,
                            21.297138050429389
                        ],
                        [
                            -157.81690285846977,
                            21.297138454000727
                        ],
                        [
                            -157.81690262989949,
                            21.297138829107787
                        ],
                        [
                            -157.81690234186314,
                            21.297139166757812
                        ],
                        [
                            -157.81690200022371,
                            21.297139457054747
                        ],
                        [
                            -157.81690161563481,
                            21.297139693749727
                        ],
                        [
                            -157.81690119488727,
                            21.297139871470144
                        ],
                        [
                            -157.81690075054803,
                            21.2971399857874
                        ],
                        [
                            -157.81690029324909,
                            21.297140033162659
                        ],
                        [
                            -157.81689833593751,
                            21.297140090771492
                        ],
                        [
                            -157.81689845791698,
                            21.29714375939399
                        ],
                        [
                            -157.81690530850403,
                            21.297143558214628
                        ],
                        [
                            -157.8169073946672,
                            21.29720592759486
                        ],
                        [
                            -157.81690054407727,
                            21.297206128774175
                        ],
                        [
                            -157.81690066605677,
                            21.297209797396629
                        ],
                        [
                            -157.81690751761079,
                            21.297209596224111
                        ],
                        [
                            -157.81690960281767,
                            21.297271964693792
                        ],
                        [
                            -157.81690275221743,
                            21.297272166776391
                        ],
                        [
                            -157.81690287516085,
                            21.2972758354056
                        ],
                        [
                            -157.81690972575404,
                            21.297275634226359
                        ],
                        [
                            -157.81691181191798,
                            21.297338003605748
                        ],
                        [
                            -157.81690496132191,
                            21.297338204784943
                        ],
                        [
                            -157.81690508426536,
                            21.297341873414123
                        ],
                        [
                            -157.81691193486162,
                            21.297341672234939
                        ],
                        [
                            -157.81691402102595,
                            21.297404041613909
                        ],
                        [
                            -157.81690717042682,
                            21.29740424279305
                        ],
                        [
                            -157.81690729337029,
                            21.297407911422209
                        ],
                        [
                            -157.8169141439696,
                            21.297407710243075
                        ],
                        [
                            -157.81691623013435,
                            21.297470079621629
                        ],
                        [
                            -157.8169093785682,
                            21.297470280793934
                        ],
                        [
                            -157.81690950151167,
                            21.297473949423082
                        ],
                        [
                            -157.81691145882772,
                            21.297473891814313
                        ],
                        [
                            -157.81691191944105,
                            21.297473912216642
                        ],
                        [
                            -157.81691237084419,
                            21.297473999405117
                        ],
                        [
                            -157.81691280244124,
                            21.297474152401858
                        ],
                        [
                            -157.81691320270136,
                            21.297474366608842
                        ],
                        [
                            -157.81691356202882,
                            21.297474636538304
                        ],
                        [
                            -157.816913872763,
                            21.297474955812643
                        ],
                        [
                            -157.81691412532248,
                            21.297475317137387
                        ],
                        [
                            -157.81691431496728,
                            21.297475710541931
                        ],
                        [
                            -157.81691443694294,
                            21.297476127862321
                        ],
                        [
                            -157.81691448748776,
                            21.29747655732805
                        ],
                        [
                            -157.81691454895957,
                            21.297478391642617
                        ],
                        [
                            -157.81691846359166,
                            21.297478276424972
                        ],
                        [
                            -157.81691824892215,
                            21.297471856327363
                        ],
                        [
                            -157.8169368443842,
                            21.297471309500711
                        ],
                        [
                            -157.81693960481604,
                            21.297553857228976
                        ],
                        [
                            -157.81692100934359,
                            21.29755440405544
                        ],
                        [
                            -157.81692079467399,
                            21.297547983957877
                        ],
                        [
                            -157.81691687908335,
                            21.297548098265395
                        ],
                        [
                            -157.81691694151908,
                            21.297549932586723
                        ],
                        [
                            -157.81691691975587,
                            21.297550363350933
                        ],
                        [
                            -157.81691682574973,
                            21.297550787283587
                        ],
                        [
                            -157.81691666249358,
                            21.297551191758238
                        ],
                        [
                            -157.81691643489381,
                            21.297551565968707
                        ],
                        [
                            -157.81691614589269,
                            21.297551903611932
                        ],
                        [
                            -157.81691580521621,
                            21.297552193915614
                        ],
                        [
                            -157.81691541965509,
                            21.297552431507121
                        ],
                        [
                            -157.8169150008342,
                            21.297552609241084
                        ],
                        [
                            -157.81691455457312,
                            21.297552722641402
                        ],
                        [
                            -157.8169140972729,
                            21.297552770016644
                        ],
                        [
                            -157.81691213995583,
                            21.297552827625392
                        ],
                        [
                            -157.81691226289215,
                            21.297556497157835
                        ],
                        [
                            -157.81691911349836,
                            21.297556295978829
                        ],
                        [
                            -157.81692119966397,
                            21.297618665356435
                        ],
                        [
                            -157.81691434905485,
                            21.297618866535398
                        ],
                        [
                            -157.81691447103449,
                            21.2976225351577
                        ],
                        [
                            -157.81692132164378,
                            21.297622333978744
                        ],
                        [
                            -157.81692340877368,
                            21.297684703362709
                        ],
                        [
                            -157.81691655816149,
                            21.297684904541619
                        ],
                        [
                            -157.81691668014116,
                            21.297688573163899
                        ],
                        [
                            -157.81692353076076,
                            21.297688371081659
                        ],
                        [
                            -157.81692561692714,
                            21.297750740458429
                        ],
                        [
                            -157.81691876631189,
                            21.297750941637279
                        ],
                        [
                            -157.81691888829158,
                            21.297754610259538
                        ],
                        [
                            -157.81692573987092,
                            21.29775440908746
                        ],
                        [
                            -157.81692782507378,
                            21.297816778457033
                        ],
                        [
                            -157.81692097445546,
                            21.297816979635837
                        ],
                        [
                            -157.81692109739905,
                            21.297820648264857
                        ],
                        [
                            -157.81692794801756,
                            21.297820447086043
                        ],
                        [
                            -157.81693003418474,
                            21.297882816461978
                        ],
                        [
                            -157.81692318356335,
                            21.297883017640725
                        ],
                        [
                            -157.81692330649975,
                            21.297886687173062
                        ],
                        [
                            -157.81692526382122,
                            21.297886629564402
                        ],
                        [
                            -157.81692577451616,
                            21.297886655739131
                        ],
                        [
                            -157.81692627393559,
                            21.297886765849903
                        ],
                        [
                            -157.81692674380849,
                            21.29788695434792
                        ],
                        [
                            -157.81692717259682,
                            21.297887217538545
                        ],
                        [
                            -157.81692754591407,
                            21.29788754628672
                        ],
                        [
                            -157.81692785324395,
                            21.297887929677831
                        ],
                        [
                            -157.81692808405569,
                            21.297888358603963
                        ],
                        [
                            -157.81692823171758,
                            21.297888818564264
                        ],
                        [
                            -157.81692829153292,
                            21.297889294168034
                        ],
                        [
                            -157.81692835300481,
                            21.297891128482544
                        ],
                        [
                            -157.81693226764065,
                            21.297891014168414
                        ],
                        [
                            -157.81693205297088,
                            21.297884594071071
                        ],
                        [
                            -157.81702209357695,
                            21.297881948588056
                        ],
                        [
                            -157.81702230921456,
                            21.297888368692242
                        ],
                        [
                            -157.8170262228937,
                            21.297888253465821
                        ],
                        [
                            -157.81702616142061,
                            21.297886419151311
                        ],
                        [
                            -157.81702618319082,
                            21.297885987483735
                        ],
                        [
                            -157.81702627718246,
                            21.297885565357728
                        ],
                        [
                            -157.8170264404387,
                            21.297885160882984
                        ],
                        [
                            -157.81702666804605,
                            21.297884785769053
                        ],
                        [
                            -157.81702695704035,
                            21.297884449028995
                        ],
                        [
                            -157.81702729772465,
                            21.297884157821805
                        ],
                        [
                            -157.81702768327926,
                            21.297883921133415
                        ],
                        [
                            -157.81702810307218,
                            21.297883742502659
                        ],
                        [
                            -157.81702854837025,
                            21.297883629095288
                        ],
                        [
                            -157.81702900567149,
                            21.297883581719788
                        ],
                        [
                            -157.81703096395688,
                            21.297883524116671
                        ],
                        [
                            -157.81703084101056,
                            21.297879855487643
                        ],
                        [
                            -157.81702398942531,
                            21.297880056663733
                        ],
                        [
                            -157.81702274822121,
                            21.297842910465128
                        ],
                        [
                            -157.81708342611182,
                            21.29784112726604
                        ],
                        [
                            -157.81708356466532,
                            21.297845254927093
                        ],
                        [
                            -157.81708503217229,
                            21.297845211941638
                        ],
                        [
                            -157.81708650560222,
                            21.297889237283492
                        ],
                        [
                            -157.81708503713088,
                            21.297889280262186
                        ],
                        [
                            -157.81708531424508,
                            21.297897534680938
                        ]
                    ],
                    [
                        [
                            -157.81703376903135,
                            21.297205887212272
                        ],
                        [
                            -157.81713946867345,
                            21.297202782576722
                        ],
                        [
                            -157.81714038989861,
                            21.297202823380058
                        ],
                        [
                            -157.81714129269633,
                            21.297202998659042
                        ],
                        [
                            -157.81714215493267,
                            21.297203303741185
                        ],
                        [
                            -157.81714295449558,
                            21.29720373124395
                        ],
                        [
                            -157.81714367409964,
                            21.297204272915337
                        ],
                        [
                            -157.81714429460396,
                            21.297204911456404
                        ],
                        [
                            -157.8171448006872,
                            21.297205634112
                        ],
                        [
                            -157.8171451809414,
                            21.297206420927377
                        ],
                        [
                            -157.8171454239442,
                            21.29720725375444
                        ],
                        [
                            -157.81714552503504,
                            21.297208112685855
                        ],
                        [
                            -157.81715245811623,
                            21.297415399180046
                        ],
                        [
                            -157.81715240032301,
                            21.297416357271125
                        ],
                        [
                            -157.81715216727829,
                            21.297417291545759
                        ],
                        [
                            -157.81715176306901,
                            21.297418173124157
                        ],
                        [
                            -157.81715120235626,
                            21.297418976814438
                        ],
                        [
                            -157.81715050174347,
                            21.297419675631591
                        ],
                        [
                            -157.81714968065347,
                            21.297420251644308
                        ],
                        [
                            -157.81714876720599,
                            21.297420684272229
                        ],
                        [
                            -157.81714778656402,
                            21.297420961044743
                        ],
                        [
                            -157.8171467696306,
                            21.297421074951902
                        ],
                        [
                            -157.81704106983204,
                            21.297424179584702
                        ],
                        [
                            -157.81704014956946,
                            21.297424138787537
                        ],
                        [
                            -157.81703924677055,
                            21.297423963507953
                        ],
                        [
                            -157.81703838453319,
                            21.297423658425245
                        ],
                        [
                            -157.81703758401278,
                            21.297423230011837
                        ],
                        [
                            -157.81703686439363,
                            21.297422690146657
                        ],
                        [
                            -157.81703624389615,
                            21.297422050701851
                        ],
                        [
                            -157.81703573780555,
                            21.297421328949277
                        ],
                        [
                            -157.81703535852986,
                            21.297420540333754
                        ],
                        [
                            -157.81703511456348,
                            21.297419707499788
                        ],
                        [
                            -157.8170350134732,
                            21.297418848568366
                        ],
                        [
                            -157.81702808054987,
                            21.297211562980412
                        ],
                        [
                            -157.81702812408267,
                            21.29721070054854
                        ],
                        [
                            -157.81702831111539,
                            21.297209854482929
                        ],
                        [
                            -157.81702863761902,
                            21.297209046436642
                        ],
                        [
                            -157.81702909380249,
                            21.29720829531206
                        ],
                        [
                            -157.8170296708316,
                            21.297207620921672
                        ],
                        [
                            -157.81703035315365,
                            21.297207039417167
                        ],
                        [
                            -157.81703112330251,
                            21.297206565130065
                        ],
                        [
                            -157.81703196382659,
                            21.297206210585145
                        ],
                        [
                            -157.81703285250526,
                            21.297205981949947
                        ],
                        [
                            -157.81703376903135,
                            21.297205887212272
                        ]
                    ],
                    [
                        [
                            -157.8171654665563,
                            21.297804289061833
                        ],
                        [
                            -157.81716542301675,
                            21.29780515239705
                        ],
                        [
                            -157.81716523598385,
                            21.297805998462739
                        ],
                        [
                            -157.81716490852278,
                            21.297806805599095
                        ],
                        [
                            -157.81716445233795,
                            21.297807556723946
                        ],
                        [
                            -157.81716387627085,
                            21.297808231121454
                        ],
                        [
                            -157.81716319394641,
                            21.297808812626339
                        ],
                        [
                            -157.81716242283079,
                            21.297809286907107
                        ],
                        [
                            -157.81716158326017,
                            21.297809642362644
                        ],
                        [
                            -157.81716069362128,
                            21.297809870088216
                        ],
                        [
                            -157.81715977805538,
                            21.297809964833199
                        ],
                        [
                            -157.81705407797088,
                            21.29781307036443
                        ],
                        [
                            -157.81705305858154,
                            21.297813008995927
                        ],
                        [
                            -157.81705206556984,
                            21.29781278339577
                        ],
                        [
                            -157.81705112875204,
                            21.297812401904039
                        ],
                        [
                            -157.8170502750238,
                            21.297811876453864
                        ],
                        [
                            -157.81704953126638,
                            21.297811220785071
                        ],
                        [
                            -157.81704891659177,
                            21.297810455809934
                        ],
                        [
                            -157.81704845203262,
                            21.297809603357674
                        ],
                        [
                            -157.81704815088136,
                            21.297808688816659
                        ],
                        [
                            -157.81704802256024,
                            21.29780773935482
                        ],
                        [
                            -157.81704108770145,
                            21.297600453761515
                        ],
                        [
                            -157.81704114645945,
                            21.297599495677311
                        ],
                        [
                            -157.81704137951243,
                            21.297598560499576
                        ],
                        [
                            -157.81704178372294,
                            21.297597678921498
                        ],
                        [
                            -157.81704234443697,
                            21.297596875231651
                        ],
                        [
                            -157.81704304505112,
                            21.297596176415023
                        ],
                        [
                            -157.8170438651714,
                            21.297595601299466
                        ],
                        [
                            -157.81704477862024,
                            21.297595168672196
                        ],
                        [
                            -157.8170457592708,
                            21.297594890997011
                        ],
                        [
                            -157.81704677619823,
                            21.297594777993865
                        ],
                        [
                            -157.81715247612627,
                            21.297591672459884
                        ],
                        [
                            -157.81715339735391,
                            21.297591713263245
                        ],
                        [
                            -157.81715430015399,
                            21.297591888542268
                        ],
                        [
                            -157.81715516238535,
                            21.297592194527766
                        ],
                        [
                            -157.81715596195033,
                            21.297592622030557
                        ],
                        [
                            -157.81715668253463,
                            21.297593161902043
                        ],
                        [
                            -157.81715730206943,
                            21.29759380133968
                        ],
                        [
                            -157.81715780815395,
                            21.297594523995283
                        ],
                        [
                            -157.81715818840186,
                            21.297595311713987
                        ],
                        [
                            -157.81715843140526,
                            21.297596144541025
                        ],
                        [
                            -157.81715853249634,
                            21.297597003472394
                        ],
                        [
                            -157.8171654665563,
                            21.297804289061833
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 180,
                "NUMBER": "1047",
                "PROPER_NAME": "SAKAMAKI HALL",
                "DISPLAY_NAME": "SAKAMAKI HALL (SAKAM) - 1047",
                "ADDRESS": "2530 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "SAKAMAKI HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1047_01.jpg",
                "HEIGHT (ft)": 55.700000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 490.3039204200216,
                "SHAPE_Area": 2348.9705878571481
            }
        },
        {
            "type": "Feature",
            "id": 181,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81921111050463,
                            21.293489266529658
                        ],
                        [
                            -157.81921169957616,
                            21.293489615757387
                        ],
                        [
                            -157.81923740154414,
                            21.293504898043366
                        ],
                        [
                            -157.81924850836538,
                            21.293511502052851
                        ],
                        [
                            -157.81924861198198,
                            21.293511563306897
                        ],
                        [
                            -157.81924866282279,
                            21.293511594378831
                        ],
                        [
                            -157.81925739804402,
                            21.293516787819037
                        ],
                        [
                            -157.81925754387694,
                            21.293516873760765
                        ],
                        [
                            -157.8192604066804,
                            21.293518576860134
                        ],
                        [
                            -157.81927311184674,
                            21.293526130703338
                        ],
                        [
                            -157.81927435136907,
                            21.293526868434736
                        ],
                        [
                            -157.81927450199262,
                            21.293526958023634
                        ],
                        [
                            -157.81928143452376,
                            21.293531080043088
                        ],
                        [
                            -157.81929207892608,
                            21.293537408885424
                        ],
                        [
                            -157.81940890547602,
                            21.293606873405714
                        ],
                        [
                            -157.81944776837548,
                            21.293629980997345
                        ],
                        [
                            -157.81948002746151,
                            21.29358232749874
                        ],
                        [
                            -157.81930537094846,
                            21.293478479045863
                        ],
                        [
                            -157.81930128868976,
                            21.293484509457578
                        ],
                        [
                            -157.81929841697982,
                            21.293488749708157
                        ],
                        [
                            -157.8192841902374,
                            21.29348028993315
                        ],
                        [
                            -157.81926563953829,
                            21.293469259490177
                        ],
                        [
                            -157.8192364175811,
                            21.293451884654271
                        ],
                        [
                            -157.81922439028472,
                            21.293469650395771
                        ],
                        [
                            -157.8192154990426,
                            21.293482785669724
                        ],
                        [
                            -157.81921111050463,
                            21.293489266529658
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 181,
                "NUMBER": "1171C",
                "PROPER_NAME": "VARSITY BUILDING C - FINANCIAL MANAGEMENT OFFICE",
                "DISPLAY_NAME": "VARSITY BUILDING C - FINANCIAL MANAGEMENT OFFICE - 1171C",
                "ADDRESS": "1406 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "VARSITY BUILDINGS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1171C_01.jpg",
                "HEIGHT (ft)": 15.200000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 70.646302027932478,
                "SHAPE_Area": 171.38352869018848
            }
        },
        {
            "type": "Feature",
            "id": 182,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81518330791218,
                            21.301800198940104
                        ],
                        [
                            -157.81518032545171,
                            21.301803187131075
                        ],
                        [
                            -157.81519033655528,
                            21.301811963583674
                        ],
                        [
                            -157.81519625287339,
                            21.301806037448952
                        ],
                        [
                            -157.81519606957818,
                            21.301800884128006
                        ],
                        [
                            -157.81524500173595,
                            21.301799354114518
                        ],
                        [
                            -157.81524518504014,
                            21.301804506532154
                        ],
                        [
                            -157.81525150971856,
                            21.301810049993708
                        ],
                        [
                            -157.81525387119331,
                            21.301807684381668
                        ],
                        [
                            -157.81525827486786,
                            21.301807546452135
                        ],
                        [
                            -157.81526079918333,
                            21.301809759461218
                        ],
                        [
                            -157.81526671453474,
                            21.301803833317077
                        ],
                        [
                            -157.8152665448649,
                            21.301799024283458
                        ],
                        [
                            -157.81528905305612,
                            21.301798320917026
                        ],
                        [
                            -157.8152891017985,
                            21.301799696219064
                        ],
                        [
                            -157.81529032541661,
                            21.301799657857508
                        ],
                        [
                            -157.81529027667423,
                            21.301798282555467
                        ],
                        [
                            -157.81529174424918,
                            21.301798235974157
                        ],
                        [
                            -157.81529179394829,
                            21.301799612186318
                        ],
                        [
                            -157.81529301660245,
                            21.301799573817974
                        ],
                        [
                            -157.81529296690337,
                            21.301798197605805
                        ],
                        [
                            -157.81531547605849,
                            21.301797494242624
                        ],
                        [
                            -157.81531564766502,
                            21.301802302386506
                        ],
                        [
                            -157.81532197138225,
                            21.301807845838745
                        ],
                        [
                            -157.81532433381977,
                            21.30180548023246
                        ],
                        [
                            -157.8153287374943,
                            21.301805342301083
                        ],
                        [
                            -157.81533126181085,
                            21.301807555309139
                        ],
                        [
                            -157.81533717812343,
                            21.301801629169187
                        ],
                        [
                            -157.81533700651616,
                            21.301796821025274
                        ],
                        [
                            -157.81538593867327,
                            21.301795290970663
                        ],
                        [
                            -157.81538611028941,
                            21.301800098211242
                        ],
                        [
                            -157.81539243400206,
                            21.301805642564307
                        ],
                        [
                            -157.81539479548181,
                            21.30180327604684
                        ],
                        [
                            -157.81539919914903,
                            21.301803139016947
                        ],
                        [
                            -157.81540172443059,
                            21.301805352030801
                        ],
                        [
                            -157.81540763977645,
                            21.301799425881427
                        ],
                        [
                            -157.81540746913805,
                            21.301794616840947
                        ],
                        [
                            -157.8154564012948,
                            21.30179308676577
                        ],
                        [
                            -157.81545657194204,
                            21.30179789490294
                        ],
                        [
                            -157.81546289759251,
                            21.301803438363695
                        ],
                        [
                            -157.81546525809995,
                            21.30180107274175
                        ],
                        [
                            -157.81546966177439,
                            21.301800934806653
                        ],
                        [
                            -157.81547218609313,
                            21.301803147812709
                        ],
                        [
                            -157.81547810240011,
                            21.301797221667524
                        ],
                        [
                            -157.81547793175943,
                            21.301792412626991
                        ],
                        [
                            -157.81552686391581,
                            21.301790882531254
                        ],
                        [
                            -157.81552703552927,
                            21.301795690675245
                        ],
                        [
                            -157.81553335925454,
                            21.301801234119903
                        ],
                        [
                            -157.81553572072485,
                            21.301798868503695
                        ],
                        [
                            -157.81554012439923,
                            21.301798730566766
                        ],
                        [
                            -157.81554264968295,
                            21.301800943578598
                        ],
                        [
                            -157.81554856502322,
                            21.301795017423995
                        ],
                        [
                            -157.815548394373,
                            21.301790209286779
                        ],
                        [
                            -157.81559732652903,
                            21.301788679170478
                        ],
                        [
                            -157.81559749718807,
                            21.301793486404385
                        ],
                        [
                            -157.81560382187999,
                            21.301799029853296
                        ],
                        [
                            -157.81560618334916,
                            21.301796664236033
                        ],
                        [
                            -157.81561058701629,
                            21.30179652720059
                        ],
                        [
                            -157.81561311134439,
                            21.301798739301283
                        ],
                        [
                            -157.81561902764579,
                            21.301792813150858
                        ],
                        [
                            -157.81561885602935,
                            21.30178800500682
                        ],
                        [
                            -157.81566778818498,
                            21.301786474869957
                        ],
                        [
                            -157.81566795981027,
                            21.301791282110681
                        ],
                        [
                            -157.81567428449765,
                            21.301796826460404
                        ],
                        [
                            -157.81567664596571,
                            21.30179446084211
                        ],
                        [
                            -157.81568104963281,
                            21.30179432380482
                        ],
                        [
                            -157.81568357396196,
                            21.30179653590449
                        ],
                        [
                            -157.81568949026061,
                            21.301790609751457
                        ],
                        [
                            -157.81568931961303,
                            21.301785800710832
                        ],
                        [
                            -157.81573825176827,
                            21.301784270553391
                        ],
                        [
                            -157.81573842338142,
                            21.301789079600844
                        ],
                        [
                            -157.81574474711476,
                            21.301794623037917
                        ],
                        [
                            -157.81575411136677,
                            21.301785240387623
                        ],
                        [
                            -157.81575092269426,
                            21.3017824454442
                        ],
                        [
                            -157.81574987920203,
                            21.301753149304719
                        ],
                        [
                            -157.81578559937071,
                            21.301752032050015
                        ],
                        [
                            -157.8157809933364,
                            21.301622718250826
                        ],
                        [
                            -157.81574527319907,
                            21.301623835506017
                        ],
                        [
                            -157.81574423067136,
                            21.30159453937285
                        ],
                        [
                            -157.81574721311651,
                            21.301591551171089
                        ],
                        [
                            -157.81573720199236,
                            21.301582774750536
                        ],
                        [
                            -157.81573128569707,
                            21.301588701809216
                        ],
                        [
                            -157.81573145635338,
                            21.301593509946628
                        ],
                        [
                            -157.81568252425419,
                            21.301595041008405
                        ],
                        [
                            -157.81568235264277,
                            21.30159023196088
                        ],
                        [
                            -157.81567602892022,
                            21.301584688521849
                        ],
                        [
                            -157.81567366745571,
                            21.301587054140356
                        ],
                        [
                            -157.81566926378756,
                            21.30158719208109
                        ],
                        [
                            -157.81566673850531,
                            21.301584979071187
                        ],
                        [
                            -157.81566082317119,
                            21.301590906134038
                        ],
                        [
                            -157.81566099383241,
                            21.301595713368069
                        ],
                        [
                            -157.8156120626968,
                            21.301597244416051
                        ],
                        [
                            -157.81561189011651,
                            21.301592436265132
                        ],
                        [
                            -157.81560556640389,
                            21.301586891920238
                        ],
                        [
                            -157.81560320493099,
                            21.301589258441023
                        ],
                        [
                            -157.81559880126281,
                            21.301589396379907
                        ],
                        [
                            -157.81559627598892,
                            21.301587182465671
                        ],
                        [
                            -157.81559036064473,
                            21.301593110429227
                        ],
                        [
                            -157.81559053226763,
                            21.301597917670012
                        ],
                        [
                            -157.81554160016771,
                            21.301599448690663
                        ],
                        [
                            -157.81554142855364,
                            21.301594640546547
                        ],
                        [
                            -157.8155351038798,
                            21.301589096192334
                        ],
                        [
                            -157.81553274241304,
                            21.301591461808762
                        ],
                        [
                            -157.8155283387448,
                            21.301591599745787
                        ],
                        [
                            -157.81552581442864,
                            21.301589386740648
                        ],
                        [
                            -157.81551989908897,
                            21.30159531379827
                        ],
                        [
                            -157.81552006973837,
                            21.301600121935572
                        ],
                        [
                            -157.81547113763804,
                            21.301601652935645
                        ],
                        [
                            -157.81547096603353,
                            21.301596843888241
                        ],
                        [
                            -157.81546464135513,
                            21.30159130043484
                        ],
                        [
                            -157.81546227988727,
                            21.301593666050202
                        ],
                        [
                            -157.815457876219,
                            21.301593803985387
                        ],
                        [
                            -157.81545535094,
                            21.301591590972468
                        ],
                        [
                            -157.81544943656868,
                            21.301597517130908
                        ],
                        [
                            -157.81544960720854,
                            21.301602326171526
                        ],
                        [
                            -157.81540067510787,
                            21.301603857151029
                        ],
                        [
                            -157.81540050350566,
                            21.301599048103668
                        ],
                        [
                            -157.81539417979388,
                            21.301593504654509
                        ],
                        [
                            -157.81539181736096,
                            21.301595870262055
                        ],
                        [
                            -157.81538741369266,
                            21.301596008195386
                        ],
                        [
                            -157.81538488937869,
                            21.301593795188225
                        ],
                        [
                            -157.81537897307672,
                            21.301599721330494
                        ],
                        [
                            -157.81537914468544,
                            21.301604529474513
                        ],
                        [
                            -157.81533021355554,
                            21.301606059536905
                        ],
                        [
                            -157.81533004097724,
                            21.301601252289469
                        ],
                        [
                            -157.81532371727539,
                            21.301595707934457
                        ],
                        [
                            -157.81532135579803,
                            21.301598074451086
                        ],
                        [
                            -157.81531695212973,
                            21.301598212382562
                        ],
                        [
                            -157.81531442686011,
                            21.301595998464272
                        ],
                        [
                            -157.81530851151206,
                            21.301601925514031
                        ],
                        [
                            -157.8153086831185,
                            21.301606733658026
                        ],
                        [
                            -157.81525975006036,
                            21.301608263686283
                        ],
                        [
                            -157.81525957941219,
                            21.301603456452458
                        ],
                        [
                            -157.81525325378516,
                            21.301597912081345
                        ],
                        [
                            -157.81525089231394,
                            21.301600277693577
                        ],
                        [
                            -157.81524654960558,
                            21.301600387143928
                        ],
                        [
                            -157.8152439652977,
                            21.301598202620813
                        ],
                        [
                            -157.81523804899015,
                            21.301604128757852
                        ],
                        [
                            -157.81523823228696,
                            21.301609282078928
                        ],
                        [
                            -157.81518929922834,
                            21.301610812086619
                        ],
                        [
                            -157.81518911592599,
                            21.301605659668908
                        ],
                        [
                            -157.81518279222232,
                            21.301600116212182
                        ],
                        [
                            -157.81517342795527,
                            21.301609497926389
                        ],
                        [
                            -157.81517661661272,
                            21.301612292880133
                        ],
                        [
                            -157.81517762685712,
                            21.301640671844641
                        ],
                        [
                            -157.81514190574649,
                            21.301641789867858
                        ],
                        [
                            -157.81514656873225,
                            21.301772707579588
                        ],
                        [
                            -157.81518228986738,
                            21.301771590460188
                        ],
                        [
                            -157.81518330791218,
                            21.301800198940104
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 182,
                "NUMBER": "1198A",
                "PROPER_NAME": "ST. JOHN PLANT SCIENCE LABORATORY 1",
                "DISPLAY_NAME": "ST. JOHN PLANT SCIENCE LABORATORY 1 (STJHN) - 1198A",
                "ADDRESS": "3190 MAILE WAY",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ST. JOHN PLANT SCIENCE LABORATORY 1 AND 2",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "St John , Saint John",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1198A_01.jpg",
                "HEIGHT (ft)": 93.700000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 208.20539327536895,
                "SHAPE_Area": 1384.5151683809788
            }
        },
        {
            "type": "Feature",
            "id": 183,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81751047693655,
                            21.297846866485429
                        ],
                        [
                            -157.81751060566717,
                            21.297843427278977
                        ],
                        [
                            -157.8175084026025,
                            21.297843355789798
                        ],
                        [
                            -157.81751027809347,
                            21.297792917319125
                        ],
                        [
                            -157.81751248115737,
                            21.297792988808244
                        ],
                        [
                            -157.81751260988781,
                            21.297789549601742
                        ],
                        [
                            -157.81751040778786,
                            21.297789478119423
                        ],
                        [
                            -157.81751228520434,
                            21.297739039661895
                        ],
                        [
                            -157.8175144863396,
                            21.297739111137385
                        ],
                        [
                            -157.81751461506988,
                            21.297735671930877
                        ],
                        [
                            -157.81751241297073,
                            21.297735600448597
                        ],
                        [
                            -157.8175142884715,
                            21.297685160170449
                        ],
                        [
                            -157.81751649056264,
                            21.297685232556006
                        ],
                        [
                            -157.81751661929277,
                            21.297681793349454
                        ],
                        [
                            -157.81751294945499,
                            21.297681673612463
                        ],
                        [
                            -157.81751287221545,
                            21.29768373731704
                        ],
                        [
                            -157.81749012077216,
                            21.297682993872666
                        ],
                        [
                            -157.81749074340402,
                            21.29766625661485
                        ],
                        [
                            -157.8174731285763,
                            21.297665681153955
                        ],
                        [
                            -157.81747250594245,
                            21.297682418411615
                        ],
                        [
                            -157.81744853156604,
                            21.297681632040106
                        ],
                        [
                            -157.81744860781367,
                            21.297679571942172
                        ],
                        [
                            -157.81744493894723,
                            21.297679451307136
                        ],
                        [
                            -157.81744488194173,
                            21.297681516057214
                        ],
                        [
                            -157.81741452679125,
                            21.297680521332932
                        ],
                        [
                            -157.81741460208266,
                            21.297678460324924
                        ],
                        [
                            -157.81741093417304,
                            21.297678340599262
                        ],
                        [
                            -157.81740479170654,
                            21.297843412822623
                        ],
                        [
                            -157.81740846057696,
                            21.297843533458721
                        ],
                        [
                            -157.81740853781093,
                            21.297841470657637
                        ],
                        [
                            -157.81743887378104,
                            21.297842457118996
                        ],
                        [
                            -157.81743879651131,
                            21.297844524436822
                        ],
                        [
                            -157.81744246635299,
                            21.297844644175616
                        ],
                        [
                            -157.81744254262259,
                            21.297842581367718
                        ],
                        [
                            -157.81747275714724,
                            21.297843566066263
                        ],
                        [
                            -157.81747267989246,
                            21.297845631577434
                        ],
                        [
                            -157.81747634877027,
                            21.297845751308735
                        ],
                        [
                            -157.81747642601056,
                            21.297843687604217
                        ],
                        [
                            -157.81750688434175,
                            21.297844682140234
                        ],
                        [
                            -157.8175068080586,
                            21.297846746754885
                        ],
                        [
                            -157.81751047693655,
                            21.297846866485429
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 183,
                "NUMBER": "1046D",
                "PROPER_NAME": "KRAUSS HALL PRI BUILDING 3 - PHYSICS ANITA LAB",
                "DISPLAY_NAME": "KRAUSS HALL PRI BUILDING 3 - PHYSICS ANITA LAB - 1046D",
                "ADDRESS": "2500 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KRAUSS HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1046D_01.jpg",
                "HEIGHT (ft)": 17.199999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 65.876394631806079,
                "SHAPE_Area": 195.7393953627201
            }
        },
        {
            "type": "Feature",
            "id": 184,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81749557260218,
                            21.298066695786741
                        ],
                        [
                            -157.81749749309685,
                            21.298121728469027
                        ],
                        [
                            -157.81770511134366,
                            21.298115364660237
                        ],
                        [
                            -157.81770319073536,
                            21.298060336493403
                        ],
                        [
                            -157.81749557260218,
                            21.298066695786741
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 184,
                "NUMBER": "1125",
                "PROPER_NAME": "KUYKENDALL ANNEX - CTAHR",
                "DISPLAY_NAME": "KUYKENDALL ANNEX - CTAHR (KUYAN) - 1125",
                "ADDRESS": "1733 DONAGHO ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KUYKENDALL HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1125_01.jpg",
                "HEIGHT (ft)": 16.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.289731051128712,
                "SHAPE_Area": 131.34599932368431
            }
        },
        {
            "type": "Feature",
            "id": 185,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82019613945229,
                            21.297848899969409
                        ],
                        [
                            -157.82019894253281,
                            21.297778750520347
                        ],
                        [
                            -157.82003260006391,
                            21.297772913828521
                        ],
                        [
                            -157.82002979691202,
                            21.297843062367857
                        ],
                        [
                            -157.82019613945229,
                            21.297848899969409
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 185,
                "NUMBER": "1024",
                "PROPER_NAME": "BACHMAN ANNEX 6",
                "DISPLAY_NAME": "BACHMAN ANNEX 6 - 1024",
                "ADDRESS": "2444 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ADMINISTRATIVE SERVICES BUILDING 2 COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1024_01.jpg",
                "HEIGHT (ft)": 17.699999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 50.078554767899661,
                "SHAPE_Area": 134.18926634577338
            }
        },
        {
            "type": "Feature",
            "id": 186,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81788610143582,
                            21.296530969571958
                        ],
                        [
                            -157.81788933039624,
                            21.296531249716935
                        ],
                        [
                            -157.81788936494308,
                            21.296530907574503
                        ],
                        [
                            -157.8178897300258,
                            21.296530939950554
                        ],
                        [
                            -157.81789003088917,
                            21.296527912994637
                        ],
                        [
                            -157.81788966484257,
                            21.296527880611819
                        ],
                        [
                            -157.81788981166579,
                            21.296526396468714
                        ],
                        [
                            -157.81789017771959,
                            21.296526427948194
                        ],
                        [
                            -157.81789047761185,
                            21.296523401888841
                        ],
                        [
                            -157.81789011252914,
                            21.296523369512794
                        ],
                        [
                            -157.81789014611206,
                            21.29652302736358
                        ],
                        [
                            -157.81788831875639,
                            21.296522867276487
                        ],
                        [
                            -157.8178936247987,
                            21.296469417489799
                        ],
                        [
                            -157.817893976401,
                            21.29646944796438
                        ],
                        [
                            -157.81789401094778,
                            21.296469105821927
                        ],
                        [
                            -157.81789437603757,
                            21.296469137294622
                        ],
                        [
                            -157.81789467690064,
                            21.296466110338667
                        ],
                        [
                            -157.8178939428727,
                            21.296466046462861
                        ],
                        [
                            -157.81789409450809,
                            21.296464563256944
                        ],
                        [
                            -157.81789482372372,
                            21.296464626195544
                        ],
                        [
                            -157.81789512361564,
                            21.296461600136166
                        ],
                        [
                            -157.81789475853313,
                            21.296461567760133
                        ],
                        [
                            -157.81789479308713,
                            21.296461224714346
                        ],
                        [
                            -157.81789442703348,
                            21.296461193234883
                        ],
                        [
                            -157.81789973403409,
                            21.296407743454186
                        ],
                        [
                            -157.81790010683497,
                            21.296407774981024
                        ],
                        [
                            -157.81790013946113,
                            21.296407431921711
                        ],
                        [
                            -157.81790050552189,
                            21.296407462497797
                        ],
                        [
                            -157.81790079482499,
                            21.296404434557232
                        ],
                        [
                            -157.81790005981176,
                            21.296404373384711
                        ],
                        [
                            -157.81790021338929,
                            21.296402888385618
                        ],
                        [
                            -157.81790093586446,
                            21.296402950373466
                        ],
                        [
                            -157.81790122516756,
                            21.296399922432883
                        ],
                        [
                            -157.81790085910683,
                            21.296399891856783
                        ],
                        [
                            -157.81790089173299,
                            21.296399548797449
                        ],
                        [
                            -157.81790054397928,
                            21.296399519253331
                        ],
                        [
                            -157.81790584038578,
                            21.296346067590704
                        ],
                        [
                            -157.81790767449385,
                            21.296346226821566
                        ],
                        [
                            -157.81790770904055,
                            21.29634588467912
                        ],
                        [
                            -157.81790807412284,
                            21.29634591705511
                        ],
                        [
                            -157.81790837499247,
                            21.296342889195717
                        ],
                        [
                            -157.81790800893185,
                            21.296342858619639
                        ],
                        [
                            -157.81790815576909,
                            21.29634137266979
                        ],
                        [
                            -157.81790852181524,
                            21.296341405052544
                        ],
                        [
                            -157.81790882170651,
                            21.296338378993063
                        ],
                        [
                            -157.81790845662428,
                            21.296338346617077
                        ],
                        [
                            -157.81790849117098,
                            21.296338004474634
                        ],
                        [
                            -157.8179052603013,
                            21.29633772251
                        ],
                        [
                            -157.81790522671128,
                            21.296338065562548
                        ],
                        [
                            -157.81790364209618,
                            21.296337927958543
                        ],
                        [
                            -157.81790367665013,
                            21.296337584912749
                        ],
                        [
                            -157.81790045154946,
                            21.296337304795319
                        ],
                        [
                            -157.81790041700273,
                            21.296337646937754
                        ],
                        [
                            -157.81790005094939,
                            21.296337615458338
                        ],
                        [
                            -157.8178998772446,
                            21.296339327067138
                        ],
                        [
                            -157.81782675582568,
                            21.296332960423115
                        ],
                        [
                            -157.81782692953854,
                            21.29633124791107
                        ],
                        [
                            -157.81782656348523,
                            21.296331216431476
                        ],
                        [
                            -157.81782659803935,
                            21.296330873385703
                        ],
                        [
                            -157.81782336812677,
                            21.296330592329614
                        ],
                        [
                            -157.81782333453654,
                            21.296330935382159
                        ],
                        [
                            -157.81782174992884,
                            21.296330796874031
                        ],
                        [
                            -157.81782178447577,
                            21.296330454731599
                        ],
                        [
                            -157.81781855457041,
                            21.296330172772088
                        ],
                        [
                            -157.81781852097296,
                            21.296330516727963
                        ],
                        [
                            -157.81781815492687,
                            21.296330484345017
                        ],
                        [
                            -157.81781782707219,
                            21.296333752316556
                        ],
                        [
                            -157.81781037795068,
                            21.296333103756872
                        ],
                        [
                            -157.81780850257462,
                            21.296332319088719
                        ],
                        [
                            -157.81774644493402,
                            21.29627841510764
                        ],
                        [
                            -157.81774576422947,
                            21.296276746280522
                        ],
                        [
                            -157.81774638921101,
                            21.296270436873016
                        ],
                        [
                            -157.81774647879647,
                            21.296270444729398
                        ],
                        [
                            -157.81774652390015,
                            21.296269987930529
                        ],
                        [
                            -157.81775000136889,
                            21.296270291504921
                        ],
                        [
                            -157.81775003495926,
                            21.296269948452412
                        ],
                        [
                            -157.8177504010124,
                            21.296269979932166
                        ],
                        [
                            -157.81775114475511,
                            21.296262440940691
                        ],
                        [
                            -157.81775077870199,
                            21.29626240946094
                        ],
                        [
                            -157.81775081228514,
                            21.296262067311773
                        ],
                        [
                            -157.81774276882049,
                            21.296261366694718
                        ],
                        [
                            -157.8177427352301,
                            21.29626170974722
                        ],
                        [
                            -157.81774237014812,
                            21.296261677370882
                        ],
                        [
                            -157.81774220028279,
                            21.296263390813234
                        ],
                        [
                            -157.81766828710838,
                            21.296256952592966
                        ],
                        [
                            -157.81766831971336,
                            21.29625661224371
                        ],
                        [
                            -157.81766795463142,
                            21.296256579867212
                        ],
                        [
                            -157.81766798917866,
                            21.296256237724844
                        ],
                        [
                            -157.81766555110036,
                            21.296256024562176
                        ],
                        [
                            -157.81766548295533,
                            21.296256710660387
                        ],
                        [
                            -157.81766389833425,
                            21.29625657395751
                        ],
                        [
                            -157.81766396647927,
                            21.296255887859289
                        ],
                        [
                            -157.81766152935768,
                            21.296255675606698
                        ],
                        [
                            -157.81766149577433,
                            21.296256017755837
                        ],
                        [
                            -157.81766112972849,
                            21.29625598537255
                        ],
                        [
                            -157.81766109513785,
                            21.296256332934966
                        ],
                        [
                            -157.81758717910236,
                            21.296249891949049
                        ],
                        [
                            -157.81758721557756,
                            21.296249549820242
                        ],
                        [
                            -157.81758685049567,
                            21.296249517443574
                        ],
                        [
                            -157.81758688408641,
                            21.2962491743911
                        ],
                        [
                            -157.81758365513298,
                            21.296248894240623
                        ],
                        [
                            -157.81758358314642,
                            21.296249578505019
                        ],
                        [
                            -157.81758200238835,
                            21.296249440925127
                        ],
                        [
                            -157.81758207052653,
                            21.296248755730293
                        ],
                        [
                            -157.81757884062367,
                            21.296248473766276
                        ],
                        [
                            -157.81757880703293,
                            21.29624881681875
                        ],
                        [
                            -157.81757844097987,
                            21.296248785338626
                        ],
                        [
                            -157.81757840739633,
                            21.296249127487741
                        ],
                        [
                            -157.81750527833185,
                            21.296242760652497
                        ],
                        [
                            -157.81750531963402,
                            21.296242417654224
                        ],
                        [
                            -157.81750495358102,
                            21.296242386173944
                        ],
                        [
                            -157.81750498812863,
                            21.296242044031608
                        ],
                        [
                            -157.81750175919004,
                            21.296241762072896
                        ],
                        [
                            -157.8175016900876,
                            21.296242447260912
                        ],
                        [
                            -157.81750010258236,
                            21.296242309632834
                        ],
                        [
                            -157.81750017458378,
                            21.296241623561802
                        ],
                        [
                            -157.81749694466689,
                            21.296241343402905
                        ],
                        [
                            -157.81749691011925,
                            21.296241685545244
                        ],
                        [
                            -157.81749654503739,
                            21.296241653168376
                        ],
                        [
                            -157.81749651144642,
                            21.296241996220822
                        ],
                        [
                            -157.81742338817429,
                            21.296235629390928
                        ],
                        [
                            -157.81742342465711,
                            21.296235286358822
                        ],
                        [
                            -157.81742305764749,
                            21.296235253968252
                        ],
                        [
                            -157.8174230921953,
                            21.296234911825959
                        ],
                        [
                            -157.81741986324988,
                            21.29623463076901
                        ],
                        [
                            -157.81741979318315,
                            21.296235315950206
                        ],
                        [
                            -157.81741820857707,
                            21.296235177438341
                        ],
                        [
                            -157.81741827767269,
                            21.296234493153737
                        ],
                        [
                            -157.81741504873452,
                            21.296234211193376
                        ],
                        [
                            -157.81741501417949,
                            21.296234554239007
                        ],
                        [
                            -157.81741464909044,
                            21.296234522765303
                        ],
                        [
                            -157.81741460491079,
                            21.296234863936551
                        ],
                        [
                            -157.81734148840212,
                            21.296228496215463
                        ],
                        [
                            -157.81734152776244,
                            21.296228155010375
                        ],
                        [
                            -157.81734116170952,
                            21.29622812352974
                        ],
                        [
                            -157.81734119626472,
                            21.296227780484134
                        ],
                        [
                            -157.81733796635581,
                            21.296227499418872
                        ],
                        [
                            -157.81733789340421,
                            21.296228183676341
                        ],
                        [
                            -157.81733631553121,
                            21.296228047017802
                        ],
                        [
                            -157.81733638174993,
                            21.296227360906251
                        ],
                        [
                            -157.81733315279772,
                            21.296227080751013
                        ],
                        [
                            -157.81733311824971,
                            21.296227422893281
                        ],
                        [
                            -157.81733275316793,
                            21.296227390516059
                        ],
                        [
                            -157.81733272246834,
                            21.296227733588776
                        ],
                        [
                            -157.81725959632956,
                            21.296221365764694
                        ],
                        [
                            -157.81725963184161,
                            21.296221023629208
                        ],
                        [
                            -157.81725926579597,
                            21.296220991245058
                        ],
                        [
                            -157.81725929938025,
                            21.296220649096039
                        ],
                        [
                            -157.81725607044285,
                            21.296220367132658
                        ],
                        [
                            -157.81725600903607,
                            21.296221054181366
                        ],
                        [
                            -157.81725441961808,
                            21.296220914730771
                        ],
                        [
                            -157.81725448582995,
                            21.296220229522607
                        ],
                        [
                            -157.81725125688533,
                            21.296219948462472
                        ],
                        [
                            -157.81725122233715,
                            21.296220290604719
                        ],
                        [
                            -157.81725085628429,
                            21.296220259123888
                        ],
                        [
                            -157.81725081402487,
                            21.296220601211957
                        ],
                        [
                            -157.81717770427417,
                            21.296214234371099
                        ],
                        [
                            -157.81717773593806,
                            21.296213891305204
                        ],
                        [
                            -157.81717736892134,
                            21.29621385981746
                        ],
                        [
                            -157.81717740346969,
                            21.29621351767522
                        ],
                        [
                            -157.81717417452546,
                            21.296213236613621
                        ],
                        [
                            -157.81717410542871,
                            21.296213920898076
                        ],
                        [
                            -157.817172520816,
                            21.296213783287261
                        ],
                        [
                            -157.81717258991995,
                            21.296213098099468
                        ],
                        [
                            -157.81716936001186,
                            21.296212817031002
                        ],
                        [
                            -157.81716932545623,
                            21.296213160076576
                        ],
                        [
                            -157.81716896037457,
                            21.296213127699005
                        ],
                        [
                            -157.81716891812218,
                            21.296213468883693
                        ],
                        [
                            -157.8170950136427,
                            21.296207035894895
                        ],
                        [
                            -157.81709504724901,
                            21.296206691035888
                        ],
                        [
                            -157.81709468120349,
                            21.296206658651386
                        ],
                        [
                            -157.81709471575201,
                            21.296206316509188
                        ],
                        [
                            -157.81709227863249,
                            21.296206104248409
                        ],
                        [
                            -157.81709221050653,
                            21.296206787636255
                        ],
                        [
                            -157.81709062587956,
                            21.296206651831348
                        ],
                        [
                            -157.81709069401998,
                            21.296205966636833
                        ],
                        [
                            -157.81708825593654,
                            21.296205754369236
                        ],
                        [
                            -157.81708822235191,
                            21.296206096518201
                        ],
                        [
                            -157.81708785726303,
                            21.296206065043794
                        ],
                        [
                            -157.81708782272895,
                            21.29620640537933
                        ],
                        [
                            -157.81701390478543,
                            21.296199969550358
                        ],
                        [
                            -157.81701394318253,
                            21.29619962833862
                        ],
                        [
                            -157.81701357712979,
                            21.296199596857281
                        ],
                        [
                            -157.81701361168575,
                            21.296199253811757
                        ],
                        [
                            -157.8170103817784,
                            21.296198972740267
                        ],
                        [
                            -157.81701031460153,
                            21.296199657941511
                        ],
                        [
                            -157.81700872420575,
                            21.296199520288535
                        ],
                        [
                            -157.81700879717329,
                            21.296198834224587
                        ],
                        [
                            -157.81700556822264,
                            21.296198554063121
                        ],
                        [
                            -157.81700553367392,
                            21.296198896205304
                        ],
                        [
                            -157.81700516859232,
                            21.296198863827382
                        ],
                        [
                            -157.81700512729623,
                            21.296199205922125
                        ],
                        [
                            -157.81693201275277,
                            21.296192838941629
                        ],
                        [
                            -157.81693204730169,
                            21.296192496799463
                        ],
                        [
                            -157.81693168125625,
                            21.296192464414613
                        ],
                        [
                            -157.81693171580517,
                            21.296192122272451
                        ],
                        [
                            -157.81692848589822,
                            21.296191841199402
                        ],
                        [
                            -157.81692841773534,
                            21.296192529103848
                        ],
                        [
                            -157.8169268331232,
                            21.296192391490742
                        ],
                        [
                            -157.81692690128605,
                            21.296191703586313
                        ],
                        [
                            -157.81692367235027,
                            21.296191421616594
                        ],
                        [
                            -157.8169236377941,
                            21.29619176466209
                        ],
                        [
                            -157.81692327174142,
                            21.296191733180557
                        ],
                        [
                            -157.81692323709129,
                            21.296192087969466
                        ],
                        [
                            -157.81685011689623,
                            21.296185705556276
                        ],
                        [
                            -157.81685028675003,
                            21.296183994825299
                        ],
                        [
                            -157.81684992166853,
                            21.296183962447046
                        ],
                        [
                            -157.8168499552537,
                            21.29618362029813
                        ],
                        [
                            -157.81684672535442,
                            21.296183338320194
                        ],
                        [
                            -157.81684661209925,
                            21.296184481216404
                        ],
                        [
                            -157.81684502845846,
                            21.296184342705985
                        ],
                        [
                            -157.81684514170641,
                            21.296183200713099
                        ],
                        [
                            -157.81684191179988,
                            21.296182919638404
                        ],
                        [
                            -157.81684187821466,
                            21.29618326178732
                        ],
                        [
                            -157.81684151216203,
                            21.296183230305605
                        ],
                        [
                            -157.81684121224225,
                            21.296186257265582
                        ],
                        [
                            -157.81684157733102,
                            21.2961862887405
                        ],
                        [
                            -157.8168414304906,
                            21.296187773785611
                        ],
                        [
                            -157.81684106444516,
                            21.296187741400558
                        ],
                        [
                            -157.81684076548927,
                            21.296190768367303
                        ],
                        [
                            -157.81684113057804,
                            21.296190799842247
                        ],
                        [
                            -157.81684109602168,
                            21.296191142887718
                        ],
                        [
                            -157.81684292434269,
                            21.296191302089401
                        ],
                        [
                            -157.81683762467753,
                            21.296244752778232
                        ],
                        [
                            -157.81683725862476,
                            21.296244721296507
                        ],
                        [
                            -157.81683722503954,
                            21.296245063445408
                        ],
                        [
                            -157.81683685898673,
                            21.296245031963682
                        ],
                        [
                            -157.81683656003057,
                            21.296248058930392
                        ],
                        [
                            -157.81683729117228,
                            21.296248121887075
                        ],
                        [
                            -157.81683714336779,
                            21.296249606925389
                        ],
                        [
                            -157.81683641222614,
                            21.296249543968706
                        ],
                        [
                            -157.81683611231327,
                            21.296252570025299
                        ],
                        [
                            -157.81683647836607,
                            21.296252601507032
                        ],
                        [
                            -157.81683644380971,
                            21.296252944552478
                        ],
                        [
                            -157.81683680891305,
                            21.29625297422076
                        ],
                        [
                            -157.81683151019899,
                            21.296306425818937
                        ],
                        [
                            -157.81683114413883,
                            21.296306395240531
                        ],
                        [
                            -157.81683111054633,
                            21.296306738292767
                        ],
                        [
                            -157.81683074450061,
                            21.296306705907682
                        ],
                        [
                            -157.81683044458026,
                            21.296309732867549
                        ],
                        [
                            -157.81683118342625,
                            21.29630979678182
                        ],
                        [
                            -157.81683102695371,
                            21.296311280855793
                        ],
                        [
                            -157.81683029773953,
                            21.296311217912628
                        ],
                        [
                            -157.81682999686245,
                            21.296314243962396
                        ],
                        [
                            -157.81683036290821,
                            21.296314276347484
                        ],
                        [
                            -157.81683032835178,
                            21.296314619392945
                        ],
                        [
                            -157.8168306944047,
                            21.296314650874699
                        ],
                        [
                            -157.81682539569232,
                            21.296368101568738
                        ],
                        [
                            -157.81682502867531,
                            21.296368070080216
                        ],
                        [
                            -157.81682499508278,
                            21.296368413132427
                        ],
                        [
                            -157.81682462903692,
                            21.296368380747321
                        ],
                        [
                            -157.81682432912345,
                            21.296371406803829
                        ],
                        [
                            -157.81682506025851,
                            21.296371470663932
                        ],
                        [
                            -157.81682491245371,
                            21.296372955702207
                        ],
                        [
                            -157.8168241822826,
                            21.296372891848879
                        ],
                        [
                            -157.81682388139797,
                            21.296375918801942
                        ],
                        [
                            -157.81682424745105,
                            21.296375950283718
                        ],
                        [
                            -157.81682421385852,
                            21.296376293335932
                        ],
                        [
                            -157.81682457991161,
                            21.296376324817707
                        ],
                        [
                            -157.81681927928028,
                            21.296429773690754
                        ],
                        [
                            -157.81681745190582,
                            21.296429616302134
                        ],
                        [
                            -157.81681741734934,
                            21.296429959347584
                        ],
                        [
                            -157.81681705226001,
                            21.29642992787257
                        ],
                        [
                            -157.81681675138228,
                            21.296432953922253
                        ],
                        [
                            -157.81681711646439,
                            21.296432986300609
                        ],
                        [
                            -157.81681697059449,
                            21.296434470449075
                        ],
                        [
                            -157.81681660454123,
                            21.296434438967278
                        ],
                        [
                            -157.8168163046202,
                            21.296437465927053
                        ],
                        [
                            -157.81681666970954,
                            21.296437497402074
                        ],
                        [
                            -157.81681663515303,
                            21.296437840447524
                        ],
                        [
                            -157.81681986603616,
                            21.296438120626391
                        ],
                        [
                            -157.81681997927737,
                            21.296436979536924
                        ],
                        [
                            -157.81682156292806,
                            21.296437117144375
                        ],
                        [
                            -157.81682144967962,
                            21.296438259137183
                        ],
                        [
                            -157.81682467862774,
                            21.296438540205742
                        ],
                        [
                            -157.81682471318422,
                            21.296438197160285
                        ],
                        [
                            -157.81682507826631,
                            21.296438229538627
                        ],
                        [
                            -157.81682524910642,
                            21.296436516104514
                        ],
                        [
                            -157.81689837146686,
                            21.296442884094169
                        ],
                        [
                            -157.81689833594663,
                            21.296443227132869
                        ],
                        [
                            -157.81689870199992,
                            21.296443258614492
                        ],
                        [
                            -157.8168986684075,
                            21.296443601666727
                        ],
                        [
                            -157.81690189736318,
                            21.296443881830474
                        ],
                        [
                            -157.81690196356962,
                            21.296443197525889
                        ],
                        [
                            -157.81690354240095,
                            21.296443335098697
                        ],
                        [
                            -157.81690348197074,
                            21.296444020347277
                        ],
                        [
                            -157.81690671188309,
                            21.296444301421047
                        ],
                        [
                            -157.81690674547548,
                            21.296443958368812
                        ],
                        [
                            -157.81690711055768,
                            21.296443990746976
                        ],
                        [
                            -157.81690713354706,
                            21.296443647620187
                        ],
                        [
                            -157.81698026748327,
                            21.296450015655886
                        ],
                        [
                            -157.81698023197046,
                            21.296450357791272
                        ],
                        [
                            -157.81698059801658,
                            21.296450390176052
                        ],
                        [
                            -157.81698056442437,
                            21.296450733228315
                        ],
                        [
                            -157.8169837933732,
                            21.296451014293847
                        ],
                        [
                            -157.81698386044195,
                            21.296450342642746
                        ],
                        [
                            -157.8169854480571,
                            21.29645046672567
                        ],
                        [
                            -157.8169853789521,
                            21.29645115191332
                        ],
                        [
                            -157.81698860790095,
                            21.29645143297876
                        ],
                        [
                            -157.81698864148592,
                            21.296451090829834
                        ],
                        [
                            -157.81698900657537,
                            21.296451122304482
                        ],
                        [
                            -157.81698903342021,
                            21.296450779204779
                        ],
                        [
                            -157.81706295534255,
                            21.296457215077357
                        ],
                        [
                            -157.8170629217361,
                            21.296457559936332
                        ],
                        [
                            -157.81706328683279,
                            21.296457590507483
                        ],
                        [
                            -157.81706325227685,
                            21.296457933553011
                        ],
                        [
                            -157.81706569036436,
                            21.296458145821155
                        ],
                        [
                            -157.81706575753392,
                            21.296457461523243
                        ],
                        [
                            -157.81706734210573,
                            21.296457604555204
                        ],
                        [
                            -157.81706727497229,
                            21.296458284336428
                        ],
                        [
                            -157.81706971113201,
                            21.296458496590983
                        ],
                        [
                            -157.81706974568792,
                            21.296458153545455
                        ],
                        [
                            -157.81707011077739,
                            21.296458185019922
                        ],
                        [
                            -157.81707014534055,
                            21.296457841071057
                        ],
                        [
                            -157.81714405955339,
                            21.29646427775749
                        ],
                        [
                            -157.8171440249904,
                            21.296464621706363
                        ],
                        [
                            -157.81714439007268,
                            21.296464654084012
                        ],
                        [
                            -157.81714435648809,
                            21.296464996233006
                        ],
                        [
                            -157.81714758640157,
                            21.296465277302193
                        ],
                        [
                            -157.81714765355636,
                            21.296464594810907
                        ],
                        [
                            -157.81714923812834,
                            21.296464737842108
                        ],
                        [
                            -157.81714917101695,
                            21.296465414913367
                        ],
                        [
                            -157.81715239995938,
                            21.296465696879025
                        ],
                        [
                            -157.8171524335512,
                            21.296465353826697
                        ],
                        [
                            -157.81715279959741,
                            21.296465386211107
                        ],
                        [
                            -157.81715283313139,
                            21.296465050385496
                        ],
                        [
                            -157.81722594980911,
                            21.296471410063411
                        ],
                        [
                            -157.81722592103699,
                            21.296471753149611
                        ],
                        [
                            -157.81722628611934,
                            21.296471785527086
                        ],
                        [
                            -157.81722625349158,
                            21.296472128586213
                        ],
                        [
                            -157.81723429697109,
                            21.296472828325022
                        ],
                        [
                            -157.81723432959882,
                            21.296472485265891
                        ],
                        [
                            -157.81723469564508,
                            21.296472517650127
                        ],
                        [
                            -157.81723473020062,
                            21.296472174604563
                        ],
                        [
                            -157.81730785164174,
                            21.296478542411116
                        ],
                        [
                            -157.81730781708637,
                            21.296478885456704
                        ],
                        [
                            -157.81730818313989,
                            21.296478916937435
                        ],
                        [
                            -157.81730814955566,
                            21.296479259086478
                        ],
                        [
                            -157.81731137849883,
                            21.29647954104912
                        ],
                        [
                            -157.8173114427828,
                            21.296478855827395
                        ],
                        [
                            -157.81731302355016,
                            21.296478992506589
                        ],
                        [
                            -157.81731296311457,
                            21.296479678658759
                        ],
                        [
                            -157.81731619302894,
                            21.296479959724746
                        ],
                        [
                            -157.81731622661314,
                            21.296479617575702
                        ],
                        [
                            -157.81731659169554,
                            21.296479649952989
                        ],
                        [
                            -157.8173166262581,
                            21.296479306004041
                        ],
                        [
                            -157.81738974770815,
                            21.296485673775329
                        ],
                        [
                            -157.8173897141169,
                            21.296486016827735
                        ],
                        [
                            -157.8173900791993,
                            21.296486049204855
                        ],
                        [
                            -157.81739004561524,
                            21.296486391353916
                        ],
                        [
                            -157.8173932755372,
                            21.296486671515101
                        ],
                        [
                            -157.8173933446331,
                            21.296485987230518
                        ],
                        [
                            -157.81739492442952,
                            21.296486124805529
                        ],
                        [
                            -157.81739486014592,
                            21.2964868100273
                        ],
                        [
                            -157.81739808908952,
                            21.296487091988308
                        ],
                        [
                            -157.81739812268077,
                            21.296486748935902
                        ],
                        [
                            -157.81739848777042,
                            21.296486780409669
                        ],
                        [
                            -157.81739852231837,
                            21.29648643826738
                        ],
                        [
                            -157.81747164474848,
                            21.296492805106841
                        ],
                        [
                            -157.81747161019348,
                            21.296493148152493
                        ],
                        [
                            -157.81747197528318,
                            21.296493179626097
                        ],
                        [
                            -157.81747194169211,
                            21.29649352267851
                        ],
                        [
                            -157.81747998517454,
                            21.296494222405681
                        ],
                        [
                            -157.8174800187584,
                            21.296493880256605
                        ],
                        [
                            -157.81748038480478,
                            21.296493912640308
                        ],
                        [
                            -157.81748041357631,
                            21.29649356955402
                        ],
                        [
                            -157.81755355238732,
                            21.296499938280014
                        ],
                        [
                            -157.81755350628009,
                            21.296500279437755
                        ],
                        [
                            -157.81755387136261,
                            21.296500311814523
                        ],
                        [
                            -157.81755383874281,
                            21.296500653970391
                        ],
                        [
                            -157.81755706768718,
                            21.296500935928361
                        ],
                        [
                            -157.81755713294118,
                            21.296500249809931
                        ],
                        [
                            -157.81755872333372,
                            21.296500388361249
                        ],
                        [
                            -157.81755865230352,
                            21.296501073535712
                        ],
                        [
                            -157.81756188221902,
                            21.296501354597023
                        ],
                        [
                            -157.81756191483879,
                            21.296501012441151
                        ],
                        [
                            -157.81756228089966,
                            21.296501043017997
                        ],
                        [
                            -157.81756232122345,
                            21.296500701819625
                        ],
                        [
                            -157.81763543403235,
                            21.296507068520839
                        ],
                        [
                            -157.81763540236943,
                            21.296507411586855
                        ],
                        [
                            -157.81763576843036,
                            21.296507442163531
                        ],
                        [
                            -157.81763573483966,
                            21.296507785216004
                        ],
                        [
                            -157.81763896379161,
                            21.29650806626908
                        ],
                        [
                            -157.8176390328864,
                            21.296507381984362
                        ],
                        [
                            -157.81764061558235,
                            21.296507518674066
                        ],
                        [
                            -157.8176405484009,
                            21.296508204779002
                        ],
                        [
                            -157.81764377831684,
                            21.296508485838757
                        ],
                        [
                            -157.81764381190754,
                            21.29650814278628
                        ],
                        [
                            -157.81764417699011,
                            21.296508175162852
                        ],
                        [
                            -157.81764421057358,
                            21.296507833013731
                        ],
                        [
                            -157.81771732917485,
                            21.29651419972031
                        ],
                        [
                            -157.81771729848325,
                            21.296514541889771
                        ],
                        [
                            -157.81771766452977,
                            21.296514574272958
                        ],
                        [
                            -157.81771763093923,
                            21.296514917325464
                        ],
                        [
                            -157.81772085989161,
                            21.296515198376976
                        ],
                        [
                            -157.81772092128921,
                            21.296514512231365
                        ],
                        [
                            -157.81772251457389,
                            21.296514650801459
                        ],
                        [
                            -157.81772244547224,
                            21.296515335989568
                        ],
                        [
                            -157.81772567442462,
                            21.296515617040992
                        ],
                        [
                            -157.81772570800791,
                            21.296515274891828
                        ],
                        [
                            -157.81772607309776,
                            21.296515306364892
                        ],
                        [
                            -157.81772610572438,
                            21.296514963305633
                        ],
                        [
                            -157.81779922913239,
                            21.296521332720815
                        ],
                        [
                            -157.81779919555652,
                            21.296521673966648
                        ],
                        [
                            -157.81779956064636,
                            21.296521705439556
                        ],
                        [
                            -157.81779952706324,
                            21.296522047588741
                        ],
                        [
                            -157.81780275697272,
                            21.296522329548807
                        ],
                        [
                            -157.81780282409559,
                            21.296521650670481
                        ],
                        [
                            -157.81780440875585,
                            21.296521782855503
                        ],
                        [
                            -157.81780434158242,
                            21.296522468057205
                        ],
                        [
                            -157.81780757054244,
                            21.296522748203731
                        ],
                        [
                            -157.81780760412553,
                            21.296522406054546
                        ],
                        [
                            -157.81780796921541,
                            21.296522437527432
                        ],
                        [
                            -157.81780800476966,
                            21.296522089971752
                        ],
                        [
                            -157.8178811031178,
                            21.296528460078981
                        ],
                        [
                            -157.81788095637296,
                            21.296530175490659
                        ],
                        [
                            -157.81788132146289,
                            21.296530206963372
                        ],
                        [
                            -157.81788128690883,
                            21.296530550009148
                        ],
                        [
                            -157.81788451778982,
                            21.296530831071095
                        ],
                        [
                            -157.81788463103018,
                            21.296529689077211
                        ],
                        [
                            -157.8178862146834,
                            21.296529826674732
                        ],
                        [
                            -157.81788610143582,
                            21.296530969571958
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 186,
                "NUMBER": "1143",
                "PROPER_NAME": "LAW LIBRARY",
                "DISPLAY_NAME": "LAW LIBRARY - 1143",
                "ADDRESS": "2525 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "LAW SCHOOL AND LIBRARY",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1143_01.jpg",
                "HEIGHT (ft)": 19,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 289.74767247308193,
                "SHAPE_Area": 3009.1141506983263
            }
        },
        {
            "type": "Feature",
            "id": 187,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81895682658663,
                            21.29660211405357
                        ],
                        [
                            -157.81895668931168,
                            21.296605782664347
                        ],
                        [
                            -157.81896060390068,
                            21.296605911313435
                        ],
                        [
                            -157.81896074116833,
                            21.296602243606007
                        ],
                        [
                            -157.81899205401001,
                            21.296603274575041
                        ],
                        [
                            -157.81899191673588,
                            21.296606943185864
                        ],
                        [
                            -157.81899583035388,
                            21.296607072730708
                        ],
                        [
                            -157.81899663971402,
                            21.296585521694798
                        ],
                        [
                            -157.81907198827324,
                            21.296588003524846
                        ],
                        [
                            -157.81907191963717,
                            21.296589837830357
                        ],
                        [
                            -157.81907314258473,
                            21.296589878029828
                        ],
                        [
                            -157.81907327736815,
                            21.296589537493727
                        ],
                        [
                            -157.81907450031568,
                            21.296589577693208
                        ],
                        [
                            -157.81907461031454,
                            21.296589926270538
                        ],
                        [
                            -157.8190758332621,
                            21.296589966469984
                        ],
                        [
                            -157.81907590189809,
                            21.296588132164484
                        ],
                        [
                            -157.81915125046183,
                            21.296590613959165
                        ],
                        [
                            -157.81915119898733,
                            21.296591989462517
                        ],
                        [
                            -157.81915132137487,
                            21.296591993934744
                        ],
                        [
                            -157.81915130325763,
                            21.296592451826871
                        ],
                        [
                            -157.81915705274645,
                            21.296592641224773
                        ],
                        [
                            -157.81915719098035,
                            21.296588972620381
                        ],
                        [
                            -157.81915328602324,
                            21.296588844946847
                        ],
                        [
                            -157.81915593516331,
                            21.296518231004047
                        ],
                        [
                            -157.81915983819076,
                            21.296518358663906
                        ],
                        [
                            -157.81915997641718,
                            21.296514690962805
                        ],
                        [
                            -157.81915607243317,
                            21.296514562392851
                        ],
                        [
                            -157.81915985498853,
                            21.296413684671602
                        ],
                        [
                            -157.8191637599266,
                            21.296413814151446
                        ],
                        [
                            -157.81916389719603,
                            21.296410145540197
                        ],
                        [
                            -157.81915999225083,
                            21.296410016963694
                        ],
                        [
                            -157.81916264030065,
                            21.29633941746571
                        ],
                        [
                            -157.81916654525116,
                            21.296339545138729
                        ],
                        [
                            -157.81916668251313,
                            21.296335877430757
                        ],
                        [
                            -157.81916093303425,
                            21.296335688033633
                        ],
                        [
                            -157.81916091587379,
                            21.296336146835891
                        ],
                        [
                            -157.81916079348645,
                            21.296336142363657
                        ],
                        [
                            -157.81916074308441,
                            21.296337504323724
                        ],
                        [
                            -157.81908540428097,
                            21.296335023510174
                        ],
                        [
                            -157.81908547291656,
                            21.296333189204606
                        ],
                        [
                            -157.81908424997113,
                            21.29633314900531
                        ],
                        [
                            -157.81908411520243,
                            21.296333487734756
                        ],
                        [
                            -157.81908289128589,
                            21.296333448432041
                        ],
                        [
                            -157.81908278128714,
                            21.296333099854696
                        ],
                        [
                            -157.81908155834171,
                            21.296333059655396
                        ],
                        [
                            -157.81908148970606,
                            21.296334893960974
                        ],
                        [
                            -157.81900614127531,
                            21.296332412141076
                        ],
                        [
                            -157.81900620027281,
                            21.29633057776795
                        ],
                        [
                            -157.81900032937122,
                            21.296330383899797
                        ],
                        [
                            -157.81900028647601,
                            21.296331530001964
                        ],
                        [
                            -157.81900064887296,
                            21.296331657212811
                        ],
                        [
                            -157.81900060597781,
                            21.296332803314989
                        ],
                        [
                            -157.81900023500032,
                            21.296332905505249
                        ],
                        [
                            -157.81900019209792,
                            21.296334052510769
                        ],
                        [
                            -157.819004115355,
                            21.296334181219386
                        ],
                        [
                            -157.81900309232117,
                            21.296361483550559
                        ],
                        [
                            -157.81896786399122,
                            21.296360323027297
                        ],
                        [
                            -157.81896955911077,
                            21.296315139174553
                        ],
                        [
                            -157.81897102684499,
                            21.29631518651269
                        ],
                        [
                            -157.81897103065333,
                            21.296315071808763
                        ],
                        [
                            -157.81897152020974,
                            21.296315088794849
                        ],
                        [
                            -157.81897172231237,
                            21.29630970058238
                        ],
                        [
                            -157.81896780773116,
                            21.296309571933914
                        ],
                        [
                            -157.81896767045711,
                            21.29631324054483
                        ],
                        [
                            -157.81890112936748,
                            21.296311048134076
                        ],
                        [
                            -157.81890126663595,
                            21.296307380426629
                        ],
                        [
                            -157.81889735206218,
                            21.29630725087317
                        ],
                        [
                            -157.81889721478638,
                            21.296310919483965
                        ],
                        [
                            -157.81883067369307,
                            21.296308727948787
                        ],
                        [
                            -157.81883081097052,
                            21.296305059338124
                        ],
                        [
                            -157.81882689638974,
                            21.296304930686386
                        ],
                        [
                            -157.81882675911942,
                            21.29630859839369
                        ],
                        [
                            -157.81876021802967,
                            21.296306406830748
                        ],
                        [
                            -157.81876035530885,
                            21.296302738220234
                        ],
                        [
                            -157.81875644072829,
                            21.296302609566865
                        ],
                        [
                            -157.81875630344899,
                            21.296306278177369
                        ],
                        [
                            -157.81868976237004,
                            21.296304085683325
                        ],
                        [
                            -157.81868989964374,
                            21.296300417976273
                        ],
                        [
                            -157.81868598507057,
                            21.296300288417928
                        ],
                        [
                            -157.81868584779679,
                            21.296303956124973
                        ],
                        [
                            -157.81861930670695,
                            21.29630176540984
                        ],
                        [
                            -157.81861944398963,
                            21.296298096799585
                        ],
                        [
                            -157.81861552941669,
                            21.296297967239614
                        ],
                        [
                            -157.81861539214114,
                            21.296301634946502
                        ],
                        [
                            -157.81854885105486,
                            21.296299444203605
                        ],
                        [
                            -157.81854898833927,
                            21.296295775593507
                        ],
                        [
                            -157.81854507376653,
                            21.296295646031879
                        ],
                        [
                            -157.81854487261234,
                            21.296301034249886
                        ],
                        [
                            -157.8185453612119,
                            21.296301050327116
                        ],
                        [
                            -157.81854535740328,
                            21.296301165031011
                        ],
                        [
                            -157.81854682512983,
                            21.296301213276184
                        ],
                        [
                            -157.81854538077948,
                            21.296339730048484
                        ],
                        [
                            -157.81851015246338,
                            21.296338569429782
                        ],
                        [
                            -157.81851052714276,
                            21.296328596817929
                        ],
                        [
                            -157.81851308578823,
                            21.296328680726507
                        ],
                        [
                            -157.81851319482891,
                            21.296329028394037
                        ],
                        [
                            -157.81851441777394,
                            21.296329068597458
                        ],
                        [
                            -157.8185144606729,
                            21.296327922495578
                        ],
                        [
                            -157.81851409826919,
                            21.296327796187057
                        ],
                        [
                            -157.81851414116812,
                            21.296326650085174
                        ],
                        [
                            -157.81851451311698,
                            21.296326546999435
                        ],
                        [
                            -157.81851455601594,
                            21.296325400897548
                        ],
                        [
                            -157.81851333307816,
                            21.296325359790785
                        ],
                        [
                            -157.81851319732988,
                            21.296325700319613
                        ],
                        [
                            -157.81851001709455,
                            21.296325595786609
                        ],
                        [
                            -157.81850990805387,
                            21.296325248119075
                        ],
                        [
                            -157.81850868511609,
                            21.296325207012263
                        ],
                        [
                            -157.81850864220988,
                            21.296326354017484
                        ],
                        [
                            -157.81850900460637,
                            21.296326481229368
                        ],
                        [
                            -157.81850898364243,
                            21.296327053832023
                        ],
                        [
                            -157.81843327770886,
                            21.296324559309159
                        ],
                        [
                            -157.81843333671347,
                            21.296322724936562
                        ],
                        [
                            -157.81843211376852,
                            21.296322684732552
                        ],
                        [
                            -157.81843197802726,
                            21.296323024357964
                        ],
                        [
                            -157.81843075508235,
                            21.296322984153949
                        ],
                        [
                            -157.81843064604186,
                            21.296322636486373
                        ],
                        [
                            -157.81842942213305,
                            21.296322596275576
                        ],
                        [
                            -157.81842935348931,
                            21.296324430580501
                        ],
                        [
                            -157.81835401475823,
                            21.296321944923676
                        ],
                        [
                            -157.81835364851705,
                            21.29632193693206
                        ],
                        [
                            -157.81835366948877,
                            21.296321363426113
                        ],
                        [
                            -157.81835404047382,
                            21.296321260333961
                        ],
                        [
                            -157.818354083374,
                            21.296320114232177
                        ],
                        [
                            -157.81834821246764,
                            21.29631992124467
                        ],
                        [
                            -157.8183481695674,
                            21.296321067346433
                        ],
                        [
                            -157.81834853197094,
                            21.296321193655324
                        ],
                        [
                            -157.8183484890707,
                            21.29632233975709
                        ],
                        [
                            -157.81834811808565,
                            21.296322442849242
                        ],
                        [
                            -157.81834807517822,
                            21.296323589854364
                        ],
                        [
                            -157.81835198879457,
                            21.296323718510472
                        ],
                        [
                            -157.81834923727976,
                            21.29639708343689
                        ],
                        [
                            -157.81834532269758,
                            21.296396954773844
                        ],
                        [
                            -157.81834527979726,
                            21.296398100875614
                        ],
                        [
                            -157.818345642201,
                            21.296398227184511
                        ],
                        [
                            -157.81834559930067,
                            21.296399373286263
                        ],
                        [
                            -157.81834522831542,
                            21.296399476378401
                        ],
                        [
                            -157.81834518540788,
                            21.296400623383512
                        ],
                        [
                            -157.81834909902628,
                            21.29640075203978
                        ],
                        [
                            -157.8183463475066,
                            21.296474116965346
                        ],
                        [
                            -157.81834242329052,
                            21.296473987331137
                        ],
                        [
                            -157.81834238134681,
                            21.296475134343002
                        ],
                        [
                            -157.8183427427868,
                            21.296475260645128
                        ],
                        [
                            -157.81834269988641,
                            21.296476406746883
                        ],
                        [
                            -157.818342328901,
                            21.296476509839007
                        ],
                        [
                            -157.81834228600061,
                            21.296477655940766
                        ],
                        [
                            -157.81834621022401,
                            21.296477784671637
                        ],
                        [
                            -157.8183434586922,
                            21.296551150499702
                        ],
                        [
                            -157.81833953448131,
                            21.296551019961996
                        ],
                        [
                            -157.8183394915736,
                            21.296552166967082
                        ],
                        [
                            -157.8183398539777,
                            21.29655229327599
                        ],
                        [
                            -157.81833981107002,
                            21.29655344028107
                        ],
                        [
                            -157.81833943912767,
                            21.296553542463069
                        ],
                        [
                            -157.81833939719112,
                            21.296554688571565
                        ],
                        [
                            -157.81834526713564,
                            21.296554882456391
                        ],
                        [
                            -157.81834531099997,
                            21.296553736361414
                        ],
                        [
                            -157.81834494860311,
                            21.296553609149157
                        ],
                        [
                            -157.81834497053887,
                            21.29655303565
                        ],
                        [
                            -157.81842068397205,
                            21.296555570922333
                        ],
                        [
                            -157.81842061565288,
                            21.296557364576895
                        ],
                        [
                            -157.81842183956363,
                            21.296557404787844
                        ],
                        [
                            -157.81842197530517,
                            21.296557065162457
                        ],
                        [
                            -157.81842319825202,
                            21.296557105366631
                        ],
                        [
                            -157.81842330729265,
                            21.296557453034207
                        ],
                        [
                            -157.8184245302395,
                            21.296557493238371
                        ],
                        [
                            -157.81842459855858,
                            21.296555699583813
                        ],
                        [
                            -157.81849995318061,
                            21.2965581419625
                        ],
                        [
                            -157.81849872708455,
                            21.296590696981841
                        ],
                        [
                            -157.81850264070829,
                            21.296590825634794
                        ],
                        [
                            -157.81850277798728,
                            21.296587157928247
                        ],
                        [
                            -157.81853409274584,
                            21.296588188995738
                        ],
                        [
                            -157.81853395449653,
                            21.296591857598919
                        ],
                        [
                            -157.81853786908428,
                            21.296591986257809
                        ],
                        [
                            -157.81853800636961,
                            21.296588317647849
                        ],
                        [
                            -157.81860454757089,
                            21.29659051020769
                        ],
                        [
                            -157.81860441028721,
                            21.29659417881776
                        ],
                        [
                            -157.81860832487516,
                            21.296594307475015
                        ],
                        [
                            -157.81860846215875,
                            21.296590638864938
                        ],
                        [
                            -157.81867500336361,
                            21.296592831396996
                        ],
                        [
                            -157.81867486608888,
                            21.296596499103863
                        ],
                        [
                            -157.81867878067706,
                            21.296596627759506
                        ],
                        [
                            -157.81867891795167,
                            21.296592960052607
                        ],
                        [
                            -157.8187454591673,
                            21.296595151653566
                        ],
                        [
                            -157.81874532188712,
                            21.296598820263924
                        ],
                        [
                            -157.8187492364755,
                            21.296598948917914
                        ],
                        [
                            -157.81874937375559,
                            21.296595280307557
                        ],
                        [
                            -157.81881591496759,
                            21.296597472784086
                        ],
                        [
                            -157.81881577768914,
                            21.296601141394568
                        ],
                        [
                            -157.81881969227771,
                            21.296601270046924
                        ],
                        [
                            -157.81881983919516,
                            21.296597601504082
                        ],
                        [
                            -157.81888637077162,
                            21.2965997938852
                        ],
                        [
                            -157.81888623350213,
                            21.296603461592497
                        ],
                        [
                            -157.81889014809093,
                            21.296603590243215
                        ],
                        [
                            -157.81889028535309,
                            21.296599923439253
                        ],
                        [
                            -157.81895682658663,
                            21.29660211405357
                        ]
                    ],
                    [
                        [
                            -157.81853964546661,
                            21.296502640724121
                        ],
                        [
                            -157.81854063670335,
                            21.296465940201234
                        ],
                        [
                            -157.81854124865475,
                            21.296465960757935
                        ],
                        [
                            -157.8185413586595,
                            21.296466308432215
                        ],
                        [
                            -157.8185425816057,
                            21.296466348635487
                        ],
                        [
                            -157.81854262450452,
                            21.296465202533607
                        ],
                        [
                            -157.81854226113654,
                            21.296465076218368
                        ],
                        [
                            -157.81854230499931,
                            21.296463930123252
                        ],
                        [
                            -157.81854267598456,
                            21.296463827030685
                        ],
                        [
                            -157.8185427188906,
                            21.296462680025481
                        ],
                        [
                            -157.81854149594449,
                            21.296462639822195
                        ],
                        [
                            -157.81854136019609,
                            21.296462980351052
                        ],
                        [
                            -157.81854071740685,
                            21.296462958674493
                        ],
                        [
                            -157.81854170190249,
                            21.296426498406081
                        ],
                        [
                            -157.81896479286419,
                            21.296440429546351
                        ],
                        [
                            -157.81896342582996,
                            21.296476883523425
                        ],
                        [
                            -157.81896281483503,
                            21.296476863878375
                        ],
                        [
                            -157.81896270483648,
                            21.296476515300981
                        ],
                        [
                            -157.81896148188994,
                            21.296476475100754
                        ],
                        [
                            -157.81896143802322,
                            21.296477622099449
                        ],
                        [
                            -157.81896180139887,
                            21.29647774751048
                        ],
                        [
                            -157.81896175849602,
                            21.296478894515953
                        ],
                        [
                            -157.81896138751097,
                            21.296478997609441
                        ],
                        [
                            -157.81896134365144,
                            21.296480143704819
                        ],
                        [
                            -157.81896256756914,
                            21.296480183008473
                        ],
                        [
                            -157.81896270330216,
                            21.296479844285926
                        ],
                        [
                            -157.81896331333317,
                            21.296479863924212
                        ],
                        [
                            -157.81896193772434,
                            21.296516546398845
                        ],
                        [
                            -157.81853964546661,
                            21.296502640724121
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 187,
                "NUMBER": "1142",
                "PROPER_NAME": "LAW SCHOOL",
                "DISPLAY_NAME": "LAW SCHOOL (LAW) - 1142",
                "ADDRESS": "2515 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "LAW SCHOOL AND LIBRARY",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1142_01.jpg",
                "HEIGHT (ft)": 28.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 373.86102482042145,
                "SHAPE_Area": 2121.4882652390638
            }
        },
        {
            "type": "Feature",
            "id": 188,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81423580969874,
                            21.30130970848618
                        ],
                        [
                            -157.81423463989159,
                            21.301275047131806
                        ],
                        [
                            -157.81423529721013,
                            21.301274822302684
                        ],
                        [
                            -157.81423590616512,
                            21.301274497759959
                        ],
                        [
                            -157.81423644932599,
                            21.30127408331807
                        ],
                        [
                            -157.8142369102188,
                            21.301273589701609
                        ],
                        [
                            -157.81423727813151,
                            21.301273030385925
                        ],
                        [
                            -157.81423754135193,
                            21.301272423356298
                        ],
                        [
                            -157.81423769302376,
                            21.301271782115226
                        ],
                        [
                            -157.81423773009575,
                            21.3012711265158
                        ],
                        [
                            -157.81423764952388,
                            21.301270475507732
                        ],
                        [
                            -157.81423745504068,
                            21.301269844474934
                        ],
                        [
                            -157.81423715034245,
                            21.301269253318054
                        ],
                        [
                            -157.81423674590926,
                            21.30126871746852
                        ],
                        [
                            -157.81423625222126,
                            21.301268252357801
                        ],
                        [
                            -157.81423568171533,
                            21.301267869817622
                        ],
                        [
                            -157.81423505260491,
                            21.301267582623755
                        ],
                        [
                            -157.81423438122616,
                            21.301267397215021
                        ],
                        [
                            -157.81423323472728,
                            21.30123343524809
                        ],
                        [
                            -157.81423389204565,
                            21.301233210418978
                        ],
                        [
                            -157.81423450100047,
                            21.301232885876232
                        ],
                        [
                            -157.81423504319724,
                            21.301232471427546
                        ],
                        [
                            -157.81423550505383,
                            21.301231977817874
                        ],
                        [
                            -157.81423587199527,
                            21.301231419398729
                        ],
                        [
                            -157.81423613619404,
                            21.301230810569216
                        ],
                        [
                            -157.81423628785859,
                            21.301230170231477
                        ],
                        [
                            -157.81423632493056,
                            21.301229514632048
                        ],
                        [
                            -157.81423624340201,
                            21.301228862713845
                        ],
                        [
                            -157.8142360489116,
                            21.301228232584407
                        ],
                        [
                            -157.81423574518462,
                            21.301227640530957
                        ],
                        [
                            -157.81423534074432,
                            21.301227105584758
                        ],
                        [
                            -157.81423484705644,
                            21.301226640474059
                        ],
                        [
                            -157.81423427655071,
                            21.301226257933866
                        ],
                        [
                            -157.81423364840438,
                            21.301225970746792
                        ],
                        [
                            -157.81423297606909,
                            21.301225784427942
                        ],
                        [
                            -157.81423182185173,
                            21.30119158300829
                        ],
                        [
                            -157.81423247917715,
                            21.301191357275826
                        ],
                        [
                            -157.81423308716785,
                            21.301191032726297
                        ],
                        [
                            -157.8142336303284,
                            21.301190618284402
                        ],
                        [
                            -157.8142340921849,
                            21.301190124674726
                        ],
                        [
                            -157.81423446009015,
                            21.301189566262366
                        ],
                        [
                            -157.81423472332492,
                            21.301188957426053
                        ],
                        [
                            -157.81423487498941,
                            21.301188317088315
                        ],
                        [
                            -157.81423491109743,
                            21.301187661482093
                        ],
                        [
                            -157.81423483053283,
                            21.301187009570675
                        ],
                        [
                            -157.81423463507855,
                            21.301186379434426
                        ],
                        [
                            -157.81423433134441,
                            21.301185788284332
                        ],
                        [
                            -157.81423392787536,
                            21.301185252441591
                        ],
                        [
                            -157.81423343418766,
                            21.301184787330875
                        ],
                        [
                            -157.81423286367482,
                            21.301184405694027
                        ],
                        [
                            -157.81423223457199,
                            21.301184117596829
                        ],
                        [
                            -157.81423156320082,
                            21.301183931284765
                        ],
                        [
                            -157.81423040341022,
                            21.301149583476629
                        ],
                        [
                            -157.81423106072819,
                            21.301149358647496
                        ],
                        [
                            -157.81423166968267,
                            21.30114903410476
                        ],
                        [
                            -157.81423221188638,
                            21.30114861875273
                        ],
                        [
                            -157.81423267374271,
                            21.301148125143047
                        ],
                        [
                            -157.81423304068392,
                            21.301147566723891
                        ],
                        [
                            -157.8142333048753,
                            21.301146958797705
                        ],
                        [
                            -157.81423345750369,
                            21.301146318466756
                        ],
                        [
                            -157.81423349361171,
                            21.301145662860531
                        ],
                        [
                            -157.81423341208318,
                            21.301145010942321
                        ],
                        [
                            -157.81423321759291,
                            21.301144380812861
                        ],
                        [
                            -157.81423291385886,
                            21.301143789662763
                        ],
                        [
                            -157.81423250942601,
                            21.301143253813226
                        ],
                        [
                            -157.81423201477446,
                            21.301142788695739
                        ],
                        [
                            -157.81423144619691,
                            21.301142406169127
                        ],
                        [
                            -157.81423081709426,
                            21.30114211807193
                        ],
                        [
                            -157.81423014474487,
                            21.301141933559762
                        ],
                        [
                            -157.81422898729537,
                            21.301107654425554
                        ],
                        [
                            -157.81422958086293,
                            21.301107325257433
                        ],
                        [
                            -157.81423010957135,
                            21.301106909810308
                        ],
                        [
                            -157.8142305569468,
                            21.301106418808747
                        ],
                        [
                            -157.81423091420504,
                            21.301105865741707
                        ],
                        [
                            -157.81423116965567,
                            21.30110526588442
                        ],
                        [
                            -157.81423131546396,
                            21.301104634539303
                        ],
                        [
                            -157.81423135148501,
                            21.301103989773129
                        ],
                        [
                            -157.81423127277586,
                            21.301103346908679
                        ],
                        [
                            -157.81423108303281,
                            21.301102725846579
                        ],
                        [
                            -157.81423078791627,
                            21.301102141984302
                        ],
                        [
                            -157.81423039405061,
                            21.301101610726182
                        ],
                        [
                            -157.81422991383653,
                            21.301101148420567
                        ],
                        [
                            -157.81422935973268,
                            21.301100764189187
                        ],
                        [
                            -157.81422874512549,
                            21.301100471677174
                        ],
                        [
                            -157.81422757828329,
                            21.301065921459838
                        ],
                        [
                            -157.81422817185066,
                            21.30106559229171
                        ],
                        [
                            -157.81422869958777,
                            21.301065177741126
                        ],
                        [
                            -157.81422914889094,
                            21.301064686753147
                        ],
                        [
                            -157.81422950518515,
                            21.301064133679311
                        ],
                        [
                            -157.81422975967178,
                            21.301063533815228
                        ],
                        [
                            -157.81422990740791,
                            21.301062902483689
                        ],
                        [
                            -157.81422994150827,
                            21.301062256800595
                        ],
                        [
                            -157.81422986376307,
                            21.301061613942931
                        ],
                        [
                            -157.81422967497679,
                            21.301060993790962
                        ],
                        [
                            -157.81422937986034,
                            21.301060409928684
                        ],
                        [
                            -157.81422898599482,
                            21.301059878670564
                        ],
                        [
                            -157.81422850578807,
                            21.301059415461616
                        ],
                        [
                            -157.81422794974924,
                            21.30105903211998
                        ],
                        [
                            -157.8142273351495,
                            21.301058738704633
                        ],
                        [
                            -157.81422615366012,
                            21.301023731268909
                        ],
                        [
                            -157.81422677146347,
                            21.301023385107179
                        ],
                        [
                            -157.81422731868207,
                            21.301022945398955
                        ],
                        [
                            -157.81422777689971,
                            21.301022424661937
                        ],
                        [
                            -157.81422813346197,
                            21.301021838164587
                        ],
                        [
                            -157.8142283785846,
                            21.301021203905727
                        ],
                        [
                            -157.81422850345442,
                            21.301020538987661
                        ],
                        [
                            -157.81422850501289,
                            21.301019864166776
                        ],
                        [
                            -157.81422838407181,
                            21.301019198420008
                        ],
                        [
                            -157.81422814335622,
                            21.301018562544488
                        ],
                        [
                            -157.81422779043996,
                            21.301017973757986
                        ],
                        [
                            -157.81422733577406,
                            21.301017451105334
                        ],
                        [
                            -157.81422679274496,
                            21.301017008231661
                        ],
                        [
                            -157.81422617570291,
                            21.30101665878896
                        ],
                        [
                            -157.81422550479638,
                            21.301016414663259
                        ],
                        [
                            -157.81422479927511,
                            21.301016279603758
                        ],
                        [
                            -157.81422407933101,
                            21.301016260076469
                        ],
                        [
                            -157.81422336616339,
                            21.301016357134142
                        ],
                        [
                            -157.81422268102233,
                            21.301016565506202
                        ],
                        [
                            -157.81422204515067,
                            21.301016880825365
                        ],
                        [
                            -157.8142214750078,
                            21.301017294173739
                        ],
                        [
                            -157.8142209890172,
                            21.30101779213031
                        ],
                        [
                            -157.81422060174665,
                            21.301018361246857
                        ],
                        [
                            -157.81422032202383,
                            21.301018982614448
                        ],
                        [
                            -157.81422016154636,
                            21.301019640054498
                        ],
                        [
                            -157.81422012143037,
                            21.301020314603658
                        ],
                        [
                            -157.81419053338163,
                            21.301021191982791
                        ],
                        [
                            -157.81419036413519,
                            21.301020539446458
                        ],
                        [
                            -157.81419008083992,
                            21.301019924048799
                        ],
                        [
                            -157.81418968914889,
                            21.30101936209066
                        ],
                        [
                            -157.81418920145566,
                            21.301018870823796
                        ],
                        [
                            -157.81418863114649,
                            21.30101846389335
                        ],
                        [
                            -157.81418799643481,
                            21.301018154075148
                        ],
                        [
                            -157.81418731460613,
                            21.30101794962145
                        ],
                        [
                            -157.81418660489575,
                            21.30101785608819
                        ],
                        [
                            -157.81418589040908,
                            21.301017877251702
                        ],
                        [
                            -157.81418518850421,
                            21.301018012330928
                        ],
                        [
                            -157.81418452138794,
                            21.30101825696541
                        ],
                        [
                            -157.81418390839701,
                            21.301018604064303
                        ],
                        [
                            -157.81418336696913,
                            21.3010190429098
                        ],
                        [
                            -157.81418291357829,
                            21.301019562777295
                        ],
                        [
                            -157.81418255992941,
                            21.301020146584925
                        ],
                        [
                            -157.81418231868406,
                            21.301020778160872
                        ],
                        [
                            -157.81418219481424,
                            21.301021438568984
                        ],
                        [
                            -157.8141314778122,
                            21.301022943057834
                        ],
                        [
                            -157.81413123596636,
                            21.301022327952182
                        ],
                        [
                            -157.81413088770344,
                            21.301021759976241
                        ],
                        [
                            -157.81413044543859,
                            21.301021253671721
                        ],
                        [
                            -157.81412991870246,
                            21.301020822656639
                        ],
                        [
                            -157.81412932282376,
                            21.301020478783073
                        ],
                        [
                            -157.8141286750591,
                            21.301020233916692
                        ],
                        [
                            -157.81412799176641,
                            21.301020091786313
                        ],
                        [
                            -157.81412729410883,
                            21.301020057961424
                        ],
                        [
                            -157.81412659943715,
                            21.301020132564293
                        ],
                        [
                            -157.81412592799401,
                            21.301020315737578
                        ],
                        [
                            -157.81412529816672,
                            21.301020598576951
                        ],
                        [
                            -157.81412472638564,
                            21.30102097577786
                        ],
                        [
                            -157.81412423103808,
                            21.30102143843602
                        ],
                        [
                            -157.81412382190109,
                            21.301021969455881
                        ],
                        [
                            -157.81412351449188,
                            21.301022557202785
                        ],
                        [
                            -157.81412331376063,
                            21.301023185450589
                        ],
                        [
                            -157.81409306329198,
                            21.301024082535921
                        ],
                        [
                            -157.81409280913263,
                            21.301023440241757
                        ],
                        [
                            -157.81409244082292,
                            21.301022847732945
                        ],
                        [
                            -157.81409196879943,
                            21.301022325861005
                        ],
                        [
                            -157.81409140741968,
                            21.301021887374549
                        ],
                        [
                            -157.8140907729474,
                            21.301021547745808
                        ],
                        [
                            -157.81409008555997,
                            21.301021315247489
                        ],
                        [
                            -157.8140893644709,
                            21.301021198145506
                        ],
                        [
                            -157.81408863471347,
                            21.301021200229819
                        ],
                        [
                            -157.8140879155664,
                            21.301021321636291
                        ],
                        [
                            -157.81408722924377,
                            21.30102155710113
                        ],
                        [
                            -157.81408659700287,
                            21.301021900450429
                        ],
                        [
                            -157.81408603723821,
                            21.301022341876539
                        ],
                        [
                            -157.81408556838053,
                            21.301022867055107
                        ],
                        [
                            -157.81408520309154,
                            21.301023459814367
                        ],
                        [
                            -157.81408495404008,
                            21.3010241030792
                        ],
                        [
                            -157.81408482812597,
                            21.301024777927068
                        ],
                        [
                            -157.81408482840772,
                            21.301025463601544
                        ],
                        [
                            -157.81408495410261,
                            21.301026137512405
                        ],
                        [
                            -157.81408520439169,
                            21.301026781586074
                        ],
                        [
                            -157.8140855688456,
                            21.301027374067715
                        ],
                        [
                            -157.8140860379483,
                            21.301027899532656
                        ],
                        [
                            -157.81408659641448,
                            21.301028340708765
                        ],
                        [
                            -157.81408722989386,
                            21.301028683944068
                        ],
                        [
                            -157.81408791532445,
                            21.301028920042182
                        ],
                        [
                            -157.81408906650157,
                            21.301063015744102
                        ],
                        [
                            -157.81408836887971,
                            21.301063217703909
                        ],
                        [
                            -157.81408771858477,
                            21.301063528403965
                        ],
                        [
                            -157.81408713591745,
                            21.301063940760208
                        ],
                        [
                            -157.81408663834452,
                            21.301064440441493
                        ],
                        [
                            -157.81408624044107,
                            21.301065013096359
                        ],
                        [
                            -157.81408595390479,
                            21.30106564254617
                        ],
                        [
                            -157.81408578853447,
                            21.301066308985469
                        ],
                        [
                            -157.81408574835262,
                            21.301066991664619
                        ],
                        [
                            -157.81408583448265,
                            21.301067670716975
                        ],
                        [
                            -157.81408604419227,
                            21.301068326248728
                        ],
                        [
                            -157.8140863728357,
                            21.3010689365458
                        ],
                        [
                            -157.81408680897619,
                            21.301069485266567
                        ],
                        [
                            -157.81408733925642,
                            21.301069955152503
                        ],
                        [
                            -157.8140879493333,
                            21.301070331648287
                        ],
                        [
                            -157.81408861809444,
                            21.301070602861099
                        ],
                        [
                            -157.81408932823979,
                            21.30107076234528
                        ],
                        [
                            -157.81409048648322,
                            21.301105058649281
                        ],
                        [
                            -157.81408978599836,
                            21.301105256975362
                        ],
                        [
                            -157.81408913377535,
                            21.301105567661821
                        ],
                        [
                            -157.81408854919451,
                            21.301105978197786
                        ],
                        [
                            -157.81408804776569,
                            21.30110647785191
                        ],
                        [
                            -157.81408764888369,
                            21.301107052306648
                        ],
                        [
                            -157.8140873604122,
                            21.301107682646204
                        ],
                        [
                            -157.81408719406338,
                            21.301108350885382
                        ],
                        [
                            -157.81408715387431,
                            21.301109034467867
                        ],
                        [
                            -157.81408723998985,
                            21.301109715326909
                        ],
                        [
                            -157.81408745162736,
                            21.301110370872248
                        ],
                        [
                            -157.81408778122031,
                            21.301110982982767
                        ],
                        [
                            -157.81408821928156,
                            21.301111532620457
                        ],
                        [
                            -157.81408875149708,
                            21.301112001616641
                        ],
                        [
                            -157.81408936350925,
                            21.301112377222694
                        ],
                        [
                            -157.81409003516239,
                            21.301112648455888
                        ],
                        [
                            -157.81409074725758,
                            21.301112805243637
                        ],
                        [
                            -157.81409189311543,
                            21.301146722940086
                        ],
                        [
                            -157.81409123579004,
                            21.301146948671999
                        ],
                        [
                            -157.81409062683528,
                            21.30114727321422
                        ],
                        [
                            -157.8140900836745,
                            21.301147687655643
                        ],
                        [
                            -157.81408962278167,
                            21.301148181271707
                        ],
                        [
                            -157.81408925486875,
                            21.301148740587063
                        ],
                        [
                            -157.81408899164799,
                            21.301149347616452
                        ],
                        [
                            -157.81408883997565,
                            21.301149988857368
                        ],
                        [
                            -157.81408880290306,
                            21.301150644456747
                        ],
                        [
                            -157.81408888347423,
                            21.301151295464862
                        ],
                        [
                            -157.81408907795665,
                            21.301151926497798
                        ],
                        [
                            -157.81408938169014,
                            21.301152517648127
                        ],
                        [
                            -157.8140897870864,
                            21.301153053504777
                        ],
                        [
                            -157.81409028077357,
                            21.301153518615891
                        ],
                        [
                            -157.8140908512859,
                            21.301153900253198
                        ],
                        [
                            -157.81409147943162,
                            21.301154187440776
                        ],
                        [
                            -157.81409215176635,
                            21.301154373760188
                        ],
                        [
                            -157.81409330600226,
                            21.301188568856048
                        ],
                        [
                            -157.81409265219898,
                            21.30118883616867
                        ],
                        [
                            -157.81409205735514,
                            21.301189204173028
                        ],
                        [
                            -157.81409153603136,
                            21.301189660324248
                        ],
                        [
                            -157.81409110566537,
                            21.301190193904581
                        ],
                        [
                            -157.81409077700556,
                            21.301190786921968
                        ],
                        [
                            -157.81409056078564,
                            21.301191423191039
                        ],
                        [
                            -157.81409046293427,
                            21.301192084685816
                        ],
                        [
                            -157.81409048456035,
                            21.301192753346299
                        ],
                        [
                            -157.81409062775847,
                            21.301193408409318
                        ],
                        [
                            -157.81409088689722,
                            21.301194030864011
                        ],
                        [
                            -157.8140912544101,
                            21.301194602589245
                        ],
                        [
                            -157.81409172077372,
                            21.301195109063706
                        ],
                        [
                            -157.81409227068832,
                            21.301195534821936
                        ],
                        [
                            -157.81409288981084,
                            21.301195865308621
                        ],
                        [
                            -157.81409355986995,
                            21.301196094974657
                        ],
                        [
                            -157.81409470239424,
                            21.301229947603304
                        ],
                        [
                            -157.81409404954746,
                            21.30123021582607
                        ],
                        [
                            -157.81409345374678,
                            21.301230582920272
                        ],
                        [
                            -157.81409293434345,
                            21.30123103998843
                        ],
                        [
                            -157.81409250205675,
                            21.301231572651826
                        ],
                        [
                            -157.8140921753247,
                            21.301232165682787
                        ],
                        [
                            -157.81409195813353,
                            21.3012328028484
                        ],
                        [
                            -157.81409186028216,
                            21.301233464343174
                        ],
                        [
                            -157.81409188191546,
                            21.301234132100333
                        ],
                        [
                            -157.81409202511361,
                            21.301234787163352
                        ],
                        [
                            -157.81409228328849,
                            21.30123540961123
                        ],
                        [
                            -157.81409265175816,
                            21.301235982246613
                        ],
                        [
                            -157.81409311812192,
                            21.30123648872107
                        ],
                        [
                            -157.81409366804391,
                            21.301236913575952
                        ],
                        [
                            -157.81409428715935,
                            21.301237244965979
                        ],
                        [
                            -157.8140949572259,
                            21.30123747372869
                        ],
                        [
                            -157.81409613642921,
                            21.301272401648941
                        ],
                        [
                            -157.81409547911053,
                            21.301272626477495
                        ],
                        [
                            -157.81409487015526,
                            21.301272951019698
                        ],
                        [
                            -157.81409432698678,
                            21.301273366364466
                        ],
                        [
                            -157.81409386609351,
                            21.301273859980515
                        ],
                        [
                            -157.8140934981875,
                            21.301274418392524
                        ],
                        [
                            -157.81409323495924,
                            21.301275026325236
                        ],
                        [
                            -157.81409308329404,
                            21.301275666662807
                        ],
                        [
                            -157.81409304622142,
                            21.301276322262172
                        ],
                        [
                            -157.81409312677815,
                            21.301276975076956
                        ],
                        [
                            -157.81409332127524,
                            21.301277604303198
                        ],
                        [
                            -157.81409362596565,
                            21.301278196363668
                        ],
                        [
                            -157.81409403040558,
                            21.301278731310187
                        ],
                        [
                            -157.8140945240859,
                            21.301279197324622
                        ],
                        [
                            -157.81409509459871,
                            21.301279578961928
                        ],
                        [
                            -157.81409572370166,
                            21.301279867059659
                        ],
                        [
                            -157.81409639508027,
                            21.301280052468925
                        ],
                        [
                            -157.81409754379408,
                            21.30131409485265
                        ],
                        [
                            -157.81409687449474,
                            21.301314371089958
                        ],
                        [
                            -157.81409626701773,
                            21.301314751652718
                        ],
                        [
                            -157.81409573880094,
                            21.301315225823156
                        ],
                        [
                            -157.81409530636176,
                            21.301315777456644
                        ],
                        [
                            -157.81409498138342,
                            21.301316392181302
                        ],
                        [
                            -157.81409477656385,
                            21.301317049308658
                        ],
                        [
                            -157.81409469686048,
                            21.301317731709268
                        ],
                        [
                            -157.814094742469,
                            21.301318414992995
                        ],
                        [
                            -157.81409491546231,
                            21.301319081106655
                        ],
                        [
                            -157.81409520829561,
                            21.301319709219136
                        ],
                        [
                            -157.81409561341684,
                            21.301320279402635
                        ],
                        [
                            -157.81409611842537,
                            21.301320775308763
                        ],
                        [
                            -157.81409670705017,
                            21.3013211823686
                        ],
                        [
                            -157.81409736205637,
                            21.30132148600649
                        ],
                        [
                            -157.81409806324476,
                            21.301321680659751
                        ],
                        [
                            -157.81409879044517,
                            21.301321757152298
                        ],
                        [
                            -157.81409951956633,
                            21.301321714411003
                        ],
                        [
                            -157.81410023132227,
                            21.301321553203326
                        ],
                        [
                            -157.81410090156382,
                            21.30132127968281
                        ],
                        [
                            -157.81410151095423,
                            21.301320900940297
                        ],
                        [
                            -157.81410204107718,
                            21.301320429493455
                        ],
                        [
                            -157.81410247640818,
                            21.301319877880324
                        ],
                        [
                            -157.81410280233592,
                            21.30131926496912
                        ],
                        [
                            -157.81410301004726,
                            21.301318607862132
                        ],
                        [
                            -157.8141030935991,
                            21.301317926392024
                        ],
                        [
                            -157.81413318405637,
                            21.3013170354068
                        ],
                        [
                            -157.81413339665829,
                            21.301317690958882
                        ],
                        [
                            -157.81413372722304,
                            21.301318302172785
                        ],
                        [
                            -157.81413416625622,
                            21.301318850913834
                        ],
                        [
                            -157.81413470040772,
                            21.301319319020152
                        ],
                        [
                            -157.81413531145691,
                            21.301319694619281
                        ],
                        [
                            -157.81413598505344,
                            21.301319964059232
                        ],
                        [
                            -157.81413669715693,
                            21.301320119943501
                        ],
                        [
                            -157.81413742755356,
                            21.301320158516063
                        ],
                        [
                            -157.81413815313067,
                            21.301320076903881
                        ],
                        [
                            -157.81413885360928,
                            21.301319879481003
                        ],
                        [
                            -157.81413950678981,
                            21.301319569704525
                        ],
                        [
                            -157.81414009329205,
                            21.301319160085335
                        ],
                        [
                            -157.81414059375754,
                            21.3013186604243
                        ],
                        [
                            -157.81414099456057,
                            21.301318086886404
                        ],
                        [
                            -157.81414128303231,
                            21.301317456546762
                        ],
                        [
                            -157.81414145130179,
                            21.301316789224487
                        ],
                        [
                            -157.8141921529747,
                            21.301315285532031
                        ],
                        [
                            -157.81419236654804,
                            21.301315940187507
                        ],
                        [
                            -157.81419269905541,
                            21.301316549608217
                        ],
                        [
                            -157.8141931381106,
                            21.301317095639114
                        ],
                        [
                            -157.81419367226951,
                            21.301317562841913
                        ],
                        [
                            -157.81419428429729,
                            21.301317936640938
                        ],
                        [
                            -157.81419495501663,
                            21.301318204253619
                        ],
                        [
                            -157.81419566615622,
                            21.301318360130839
                        ],
                        [
                            -157.81419639462501,
                            21.301318398689556
                        ],
                        [
                            -157.8141971202021,
                            21.301318317077133
                        ],
                        [
                            -157.81419781875275,
                            21.301318119640406
                        ],
                        [
                            -157.81419847191867,
                            21.301317811670383
                        ],
                        [
                            -157.81419905648565,
                            21.301317402940732
                        ],
                        [
                            -157.81419955790034,
                            21.301316905092975
                        ],
                        [
                            -157.81419995964538,
                            21.301316334271732
                        ],
                        [
                            -157.81420025002299,
                            21.30131570665559
                        ],
                        [
                            -157.81420041924162,
                            21.301315041146697
                        ],
                        [
                            -157.81423010762785,
                            21.30131416086164
                        ],
                        [
                            -157.81423031646142,
                            21.301314805546394
                        ],
                        [
                            -157.81423063841638,
                            21.301315408568964
                        ],
                        [
                            -157.81423106689735,
                            21.301315950911683
                        ],
                        [
                            -157.81423158660456,
                            21.301316417109145
                        ],
                        [
                            -157.8142321831877,
                            21.301316793509386
                        ],
                        [
                            -157.81423284035401,
                            21.301317068253518
                        ],
                        [
                            -157.8142335379188,
                            21.30131723397221
                        ],
                        [
                            -157.81423425471161,
                            21.301317285999339
                        ],
                        [
                            -157.8142349714683,
                            21.301317222392374
                        ],
                        [
                            -157.8142356650325,
                            21.301317045698319
                        ],
                        [
                            -157.81423631706045,
                            21.301316759401452
                        ],
                        [
                            -157.81423690722249,
                            21.301316374199221
                        ],
                        [
                            -157.81423741809525,
                            21.301315899002738
                        ],
                        [
                            -157.81423783605311,
                            21.301315349976981
                        ],
                        [
                            -157.81423814747777,
                            21.301314742383621
                        ],
                        [
                            -157.81423834259206,
                            21.301314093318183
                        ],
                        [
                            -157.81423841738086,
                            21.301313422626908
                        ],
                        [
                            -157.81423836975682,
                            21.301312750169661
                        ],
                        [
                            -157.81423819860379,
                            21.301312094909761
                        ],
                        [
                            -157.8142379124377,
                            21.30131147678178
                        ],
                        [
                            -157.81423751690454,
                            21.301310912989887
                        ],
                        [
                            -157.81423702535446,
                            21.301310421695955
                        ],
                        [
                            -157.81423645021718,
                            21.301310015635003
                        ],
                        [
                            -157.81423580969874,
                            21.30130970848618
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 188,
                "NUMBER": "1076",
                "PROPER_NAME": "CENTER FOR KOREAN STUDIES",
                "DISPLAY_NAME": "CENTER FOR KOREAN STUDIES (CKS) - 1076",
                "ADDRESS": "1881 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CENTER FOR KOREAN STUDIES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1076_01.jpg",
                "HEIGHT (ft)": 48.300000000000004,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 101.98599147223661,
                "SHAPE_Area": 471.77601088062181
            }
        },
        {
            "type": "Feature",
            "id": 189,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82132540517134,
                            21.298581186007102
                        ],
                        [
                            -157.82125218700989,
                            21.298578927847011
                        ],
                        [
                            -157.82124906778168,
                            21.298667745499841
                        ],
                        [
                            -157.8213222869509,
                            21.298670003670054
                        ],
                        [
                            -157.82132540517134,
                            21.298581186007102
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 189,
                "NUMBER": "1041",
                "PROPER_NAME": "BUS SHELTER - WIST / EVERLY",
                "DISPLAY_NAME": "BUS SHELTER - WIST / EVERLY - 1041",
                "ADDRESS": "UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BUS SHELTER - WIST / EVERLY",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1041_01.jpg",
                "HEIGHT (ft)": 17.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 34.873969284458539,
                "SHAPE_Area": 74.760649564920271
            }
        },
        {
            "type": "Feature",
            "id": 190,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81626710419039,
                            21.298528798310883
                        ],
                        [
                            -157.81623358627706,
                            21.298529825492928
                        ],
                        [
                            -157.81623448339656,
                            21.298555505246302
                        ],
                        [
                            -157.8162346800074,
                            21.298561167271568
                        ],
                        [
                            -157.81629048183126,
                            21.298559455769649
                        ],
                        [
                            -157.81629683502098,
                            21.298559261056567
                        ],
                        [
                            -157.81629755817843,
                            21.29855923904119
                        ],
                        [
                            -157.81629736060125,
                            21.298553577009109
                        ],
                        [
                            -157.8162965200103,
                            21.298529503880836
                        ],
                        [
                            -157.81654558146437,
                            21.298521884603044
                        ],
                        [
                            -157.81654564403132,
                            21.298524063116727
                        ],
                        [
                            -157.81653538482237,
                            21.298524377624503
                        ],
                        [
                            -157.81649575093911,
                            21.298525589505157
                        ],
                        [
                            -157.81649579859194,
                            21.298526981964514
                        ],
                        [
                            -157.81649661501913,
                            21.298550344858477
                        ],
                        [
                            -157.81654259144472,
                            21.298548944504336
                        ],
                        [
                            -157.81654222745553,
                            21.298537939555853
                        ],
                        [
                            -157.81650650536588,
                            21.298539032597542
                        ],
                        [
                            -157.81650640979245,
                            21.298536281102393
                        ],
                        [
                            -157.81654604561368,
                            21.298535068329581
                        ],
                        [
                            -157.81654617336721,
                            21.298538736992043
                        ],
                        [
                            -157.81654690713495,
                            21.298538714146808
                        ],
                        [
                            -157.81655736978999,
                            21.298538393841859
                        ],
                        [
                            -157.81676147589707,
                            21.298532149261341
                        ],
                        [
                            -157.81675480825515,
                            21.298340786916189
                        ],
                        [
                            -157.81684187740345,
                            21.298338117035808
                        ],
                        [
                            -157.81684183924372,
                            21.298338428437177
                        ],
                        [
                            -157.81685465369389,
                            21.298370779494661
                        ],
                        [
                            -157.81685740772448,
                            21.298369821387581
                        ],
                        [
                            -157.81684530951327,
                            21.298339275822368
                        ],
                        [
                            -157.81686155063619,
                            21.298206672934278
                        ],
                        [
                            -157.81685802455797,
                            21.298206294920142
                        ],
                        [
                            -157.81685525533248,
                            21.298228901765206
                        ],
                        [
                            -157.81675102235596,
                            21.298232097809397
                        ],
                        [
                            -157.81673670138426,
                            21.297821020496404
                        ],
                        [
                            -157.81652139989998,
                            21.29782760734075
                        ],
                        [
                            -157.81652143541734,
                            21.297829672740583
                        ],
                        [
                            -157.81631057312509,
                            21.29783612430661
                        ],
                        [
                            -157.81631115628201,
                            21.297852861904524
                        ],
                        [
                            -157.81630797633227,
                            21.297852958786684
                        ],
                        [
                            -157.8163122148863,
                            21.297975863212727
                        ],
                        [
                            -157.81631543823664,
                            21.297975763925677
                        ],
                        [
                            -157.81631602047335,
                            21.297992496096533
                        ],
                        [
                            -157.81652691866137,
                            21.297986043881625
                        ],
                        [
                            -157.81652696671685,
                            21.297988108466207
                        ],
                        [
                            -157.81648071175675,
                            21.297989524028736
                        ],
                        [
                            -157.81648187810865,
                            21.298022999224582
                        ],
                        [
                            -157.81652815718442,
                            21.298021582928339
                        ],
                        [
                            -157.81653625548165,
                            21.298254069529062
                        ],
                        [
                            -157.81649093473564,
                            21.298255459138414
                        ],
                        [
                            -157.81649204052849,
                            21.298287107252552
                        ],
                        [
                            -157.81653735837074,
                            21.298285720333016
                        ],
                        [
                            -157.81653747832215,
                            21.298289159479598
                        ],
                        [
                            -157.81648120610535,
                            21.298290880407176
                        ],
                        [
                            -157.81648103836514,
                            21.298286065964682
                        ],
                        [
                            -157.81625888548865,
                            21.298292863536972
                        ],
                        [
                            -157.81625925231299,
                            21.298303391515475
                        ],
                        [
                            -157.81626035517863,
                            21.298335037801632
                        ],
                        [
                            -157.81626710419039,
                            21.298528798310883
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 190,
                "NUMBER": "1165",
                "PROPER_NAME": "HAWAI`I INSTITUTE OF GEOPHYSICS",
                "DISPLAY_NAME": "HAWAI`I INSTITUTE OF GEOPHYSICS (HIG) - 1165",
                "ADDRESS": "2525 CORREA ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HAWAII INSTITUTE OF GEOPHYSICS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1165_01.jpg",
                "HEIGHT (ft)": 53.399999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 392.14809054514859,
                "SHAPE_Area": 3095.915065043248
            }
        },
        {
            "type": "Feature",
            "id": 191,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81697476953818,
                            21.298503877510282
                        ],
                        [
                            -157.81697007003072,
                            21.298389477975441
                        ],
                        [
                            -157.81688001704228,
                            21.298392186568478
                        ],
                        [
                            -157.81688291084444,
                            21.298506840812461
                        ],
                        [
                            -157.81697476953818,
                            21.298503877510282
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 191,
                "NUMBER": "1165A",
                "PROPER_NAME": "HAWAI`I INSTITUTE OF GEOPHYSICS MECHANICAL BUILDING",
                "DISPLAY_NAME": "HAWAI`I INSTITUTE OF GEOPHYSICS MECHANICAL BUILDING - 1165A",
                "ADDRESS": "2525 CORREA ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HAWAII INSTITUTE OF GEOPHYSICS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1165A_01.jpg",
                "HEIGHT (ft)": 22.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 44.250547781314935,
                "SHAPE_Area": 119.74855874522092
            }
        },
        {
            "type": "Feature",
            "id": 192,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82083799363232,
                            21.303992984134201
                        ],
                        [
                            -157.82083907832134,
                            21.303990425202823
                        ],
                        [
                            -157.82084408402926,
                            21.303992287841766
                        ],
                        [
                            -157.82084448982098,
                            21.303991328574465
                        ],
                        [
                            -157.82084176013259,
                            21.303990313005148
                        ],
                        [
                            -157.82084492187158,
                            21.303982850570836
                        ],
                        [
                            -157.8208419634247,
                            21.303981750286457
                        ],
                        [
                            -157.82086676115617,
                            21.303923221740419
                        ],
                        [
                            -157.8208725636616,
                            21.303925380854007
                        ],
                        [
                            -157.82087301560946,
                            21.303924315309981
                        ],
                        [
                            -157.82086721406802,
                            21.303922156203164
                        ],
                        [
                            -157.82087651849764,
                            21.303900194934968
                        ],
                        [
                            -157.82080006999857,
                            21.303871749838798
                        ],
                        [
                            -157.82076086459523,
                            21.303964285817329
                        ],
                        [
                            -157.82083799363232,
                            21.303992984134201
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 192,
                "NUMBER": "1185A",
                "PROPER_NAME": "COLLEGE HILL COTTAGE",
                "DISPLAY_NAME": "COLLEGE HILL COTTAGE - 1185A",
                "ADDRESS": "2234 KAMEHAMEHA AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "COLLEGE HILL AND COTTAGE",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1185A_01.jpg",
                "HEIGHT (ft)": 21,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 41.67281649989053,
                "SHAPE_Area": 94.511800936698648
            }
        },
        {
            "type": "Feature",
            "id": 194,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8144362206024,
                            21.300574914195995
                        ],
                        [
                            -157.81443615530642,
                            21.300573079855372
                        ],
                        [
                            -157.81442946353036,
                            21.300383185415654
                        ],
                        [
                            -157.81442939824166,
                            21.30038135017168
                        ],
                        [
                            -157.81435891816847,
                            21.300383531264956
                        ],
                        [
                            -157.81435920080213,
                            21.300391558968155
                        ],
                        [
                            -157.81434549722866,
                            21.300391982771298
                        ],
                        [
                            -157.81434521362456,
                            21.300383955964634
                        ],
                        [
                            -157.81403123184617,
                            21.300393673645278
                        ],
                        [
                            -157.8140306998053,
                            21.300399429906378
                        ],
                        [
                            -157.81403021094692,
                            21.300399444528956
                        ],
                        [
                            -157.81403026580065,
                            21.300401738621165
                        ],
                        [
                            -157.81401854370819,
                            21.300402101380669
                        ],
                        [
                            -157.81401826108581,
                            21.300394074581103
                        ],
                        [
                            -157.81394778100235,
                            21.300396256404913
                        ],
                        [
                            -157.81394784532836,
                            21.300398090738661
                        ],
                        [
                            -157.81395567676697,
                            21.300397848719008
                        ],
                        [
                            -157.81395585413486,
                            21.300402894495235
                        ],
                        [
                            -157.81395414167008,
                            21.300402947469973
                        ],
                        [
                            -157.81395415727329,
                            21.300403405598342
                        ],
                        [
                            -157.8139480636209,
                            21.300404283204418
                        ],
                        [
                            -157.81395431818424,
                            21.300581793606106
                        ],
                        [
                            -157.81396046057412,
                            21.300582291302185
                        ],
                        [
                            -157.813960477134,
                            21.30058275034067
                        ],
                        [
                            -157.81396219055756,
                            21.300582698276116
                        ],
                        [
                            -157.81396236794004,
                            21.300587742245579
                        ],
                        [
                            -157.81395453744807,
                            21.300587985175202
                        ],
                        [
                            -157.81395460176685,
                            21.300589820412252
                        ],
                        [
                            -157.81402508290677,
                            21.300587638596728
                        ],
                        [
                            -157.8140247759261,
                            21.300578923242956
                        ],
                        [
                            -157.81403650188832,
                            21.300578560510846
                        ],
                        [
                            -157.81403662739081,
                            21.300581540773422
                        ],
                        [
                            -157.81403711624981,
                            21.300581526150854
                        ],
                        [
                            -157.81403805272024,
                            21.300587237654387
                        ],
                        [
                            -157.81435203491085,
                            21.300577519980394
                        ],
                        [
                            -157.81435172791083,
                            21.300568804626309
                        ],
                        [
                            -157.81436543246465,
                            21.300568380830224
                        ],
                        [
                            -157.8143657394655,
                            21.300577096184327
                        ],
                        [
                            -157.8144362206024,
                            21.300574914195995
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 194,
                "NUMBER": "1179",
                "PROPER_NAME": "LINCOLN HALL",
                "DISPLAY_NAME": "LINCOLN HALL - 1179",
                "ADDRESS": "1821 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "LINCOLN HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1179_01.jpg",
                "HEIGHT (ft)": 43.200000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 153.23384803308173,
                "SHAPE_Area": 1065.6839821363719
            }
        },
        {
            "type": "Feature",
            "id": 197,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82090347260282,
                            21.300504519562061
                        ],
                        [
                            -157.82090280897955,
                            21.300490311798661
                        ],
                        [
                            -157.82088446070836,
                            21.300491363066627
                        ],
                        [
                            -157.8208852135902,
                            21.300505378129774
                        ],
                        [
                            -157.82090347260282,
                            21.300504519562061
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 197,
                "NUMBER": "1252K",
                "PROPER_NAME": "PARKING KIOSK - ARCHITECTURE LOT 2",
                "DISPLAY_NAME": "PARKING KIOSK - ARCHITECTURE LOT 2 - 1252K",
                "ADDRESS": "2600 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PARKING KIOSK - ARCHITECTURE LOT 2",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1252K_01.jpg",
                "HEIGHT (ft)": 7.1000000000000005,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 6.9311803999774284,
                "SHAPE_Area": 2.973858411647901
            }
        },
        {
            "type": "Feature",
            "id": 199,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81337950907326,
                            21.304225224204899
                        ],
                        [
                            -157.81340388760518,
                            21.304250956612673
                        ],
                        [
                            -157.81335665745661,
                            21.304290252485846
                        ],
                        [
                            -157.81341516672271,
                            21.304352011537471
                        ],
                        [
                            -157.81357480054288,
                            21.304219199891353
                        ],
                        [
                            -157.81351629029277,
                            21.304157440886836
                        ],
                        [
                            -157.81346283546051,
                            21.304201914486434
                        ],
                        [
                            -157.81343845596882,
                            21.304176181176814
                        ],
                        [
                            -157.81337950907326,
                            21.304225224204899
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 199,
                "NUMBER": "1194D",
                "PROPER_NAME": "GROUND MAINTENANCE SERVICE",
                "DISPLAY_NAME": "GROUND MAINTENANCE SERVICE - 1194D",
                "ADDRESS": "2002 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "GROUND MAINTENANCE SERVICE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1194D_01.jpg",
                "HEIGHT (ft)": 26,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 70.191315232207117,
                "SHAPE_Area": 233.59536580675277
            }
        },
        {
            "type": "Feature",
            "id": 202,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81357930144918,
                            21.295253195492652
                        ],
                        [
                            -157.8136619468242,
                            21.295284074101406
                        ],
                        [
                            -157.81366935212682,
                            21.295281524533291
                        ],
                        [
                            -157.81374186343714,
                            21.295113600366651
                        ],
                        [
                            -157.8137379365011,
                            21.295107088158151
                        ],
                        [
                            -157.81365527197178,
                            21.295075723430692
                        ],
                        [
                            -157.81364765449058,
                            21.295078768367542
                        ],
                        [
                            -157.81357540393495,
                            21.295246380852419
                        ],
                        [
                            -157.81357930144918,
                            21.295253195492652
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 202,
                "NUMBER": "1211D",
                "PROPER_NAME": "FREAR HALL - BIKE STORAGE BUILDING",
                "DISPLAY_NAME": "FREAR HALL - BIKE STORAGE BUILDING - 1211D",
                "ADDRESS": "2569 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "FREAR HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1211D_01.jpg",
                "HEIGHT (ft)": 13.9,
                "LEED STATUS": "Silver",
                "LEED LINK": "https://www.usgbc.org/projects/university-hawaii-frear-hall",
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 61.90783601799032,
                "SHAPE_Area": 221.3067662002191
            }
        },
        {
            "type": "Feature",
            "id": 203,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80720927631231,
                            21.308345700594995
                        ],
                        [
                            -157.80703542392561,
                            21.308459350669839
                        ],
                        [
                            -157.80709606349686,
                            21.308540808144276
                        ],
                        [
                            -157.80726025736982,
                            21.308433471961003
                        ],
                        [
                            -157.80724172901583,
                            21.308408582375002
                        ],
                        [
                            -157.80723931292937,
                            21.308410160626281
                        ],
                        [
                            -157.80723089279809,
                            21.308398846533464
                        ],
                        [
                            -157.80724296551745,
                            21.308390955222585
                        ],
                        [
                            -157.80720927631231,
                            21.308345700594995
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 203,
                "NUMBER": "9620FM",
                "PROPER_NAME": "KAU`IOKAHALOA NUI MANAGERS OFFICE",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI MANAGERS OFFICE - 9620FM",
                "ADDRESS": "3030 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI MANAGERS OFFICE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620FM_01.jpg",
                "HEIGHT (ft)": 24,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 66.577493956866988,
                "SHAPE_Area": 235.32028850396239
            }
        },
        {
            "type": "Feature",
            "id": 204,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80757423017951,
                            21.308779898063261
                        ],
                        [
                            -157.80761608402312,
                            21.308752537530104
                        ],
                        [
                            -157.80762015440615,
                            21.308758005673141
                        ],
                        [
                            -157.80763222810788,
                            21.308750113438549
                        ],
                        [
                            -157.80762815772459,
                            21.308744645295771
                        ],
                        [
                            -157.80764666951822,
                            21.308732542835557
                        ],
                        [
                            -157.80756167114779,
                            21.308618367471137
                        ],
                        [
                            -157.80757454245688,
                            21.308609953315763
                        ],
                        [
                            -157.80755581280008,
                            21.308584793125753
                        ],
                        [
                            -157.80752896062839,
                            21.308548707614083
                        ],
                        [
                            -157.80751608063201,
                            21.308557123511324
                        ],
                        [
                            -157.80743105764418,
                            21.308442917196952
                        ],
                        [
                            -157.80741254395102,
                            21.308455018717712
                        ],
                        [
                            -157.80740847358368,
                            21.308449550570209
                        ],
                        [
                            -157.80739601029714,
                            21.30845769749299
                        ],
                        [
                            -157.80740008065695,
                            21.308463166544115
                        ],
                        [
                            -157.8073586183956,
                            21.308490271433445
                        ],
                        [
                            -157.80737939272447,
                            21.308518178884412
                        ],
                        [
                            -157.80737214927612,
                            21.30852291458147
                        ],
                        [
                            -157.80754621135205,
                            21.308756727234432
                        ],
                        [
                            -157.8075534547998,
                            21.308751992433614
                        ],
                        [
                            -157.80757423017951,
                            21.308779898063261
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 204,
                "NUMBER": "9620C",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING A",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING A - 9620C",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING A",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620C_01.jpg",
                "HEIGHT (ft)": 33,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 104.54814598305865,
                "SHAPE_Area": 402.82977329637424
            }
        },
        {
            "type": "Feature",
            "id": 205,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81563265981802,
                            21.298073534913588
                        ],
                        [
                            -157.81563608468684,
                            21.298073429830684
                        ],
                        [
                            -157.81563603594788,
                            21.298072053624718
                        ],
                        [
                            -157.81564582172524,
                            21.298071750293214
                        ],
                        [
                            -157.81564577394283,
                            21.298070374997369
                        ],
                        [
                            -157.8156521348441,
                            21.298070177651915
                        ],
                        [
                            -157.8156522323296,
                            21.298072929160508
                        ],
                        [
                            -157.81565565720567,
                            21.298072823173865
                        ],
                        [
                            -157.81565555972008,
                            21.298070071665272
                        ],
                        [
                            -157.81566216552869,
                            21.298069867009016
                        ],
                        [
                            -157.81566221426792,
                            21.298071243214977
                        ],
                        [
                            -157.81567787305246,
                            21.298070758073358
                        ],
                        [
                            -157.81567782430588,
                            21.298069382770727
                        ],
                        [
                            -157.81568443012168,
                            21.298069177210234
                        ],
                        [
                            -157.81568452663663,
                            21.298071929615389
                        ],
                        [
                            -157.81568795248384,
                            21.29807182273154
                        ],
                        [
                            -157.81568785499044,
                            21.298069072126268
                        ],
                        [
                            -157.81569421589168,
                            21.298068874779236
                        ],
                        [
                            -157.81569426463844,
                            21.298070250081871
                        ],
                        [
                            -157.81570356155774,
                            21.298069962278095
                        ],
                        [
                            -157.81570361030458,
                            21.298071337580733
                        ],
                        [
                            -157.81570409915537,
                            21.298071322952921
                        ],
                        [
                            -157.81570613267189,
                            21.298071260474398
                        ],
                        [
                            -157.81570752499533,
                            21.298071216972005
                        ],
                        [
                            -157.81570720132544,
                            21.298062045285693
                        ],
                        [
                            -157.81571356222636,
                            21.298061847937912
                        ],
                        [
                            -157.81571361096607,
                            21.298063224143885
                        ],
                        [
                            -157.81572535505214,
                            21.298062860510015
                        ],
                        [
                            -157.81572530631232,
                            21.298061484304043
                        ],
                        [
                            -157.81573215702787,
                            21.298061272334447
                        ],
                        [
                            -157.81573228572532,
                            21.298064941003567
                        ],
                        [
                            -157.81573571156514,
                            21.298064835022068
                        ],
                        [
                            -157.81573563064362,
                            21.298062542552142
                        ],
                        [
                            -157.8157473737657,
                            21.298062178909948
                        ],
                        [
                            -157.81574732501846,
                            21.298060803607306
                        ],
                        [
                            -157.81575417574126,
                            21.298060590733492
                        ],
                        [
                            -157.81575430443925,
                            21.298064259402608
                        ],
                        [
                            -157.81575773028632,
                            21.298064152517316
                        ],
                        [
                            -157.81575760061708,
                            21.298060484744756
                        ],
                        [
                            -157.81576469623997,
                            21.29806026546326
                        ],
                        [
                            -157.81576474402345,
                            21.298061640759123
                        ],
                        [
                            -157.81578627388623,
                            21.298060973781929
                        ],
                        [
                            -157.81578622610976,
                            21.298059597582728
                        ],
                        [
                            -157.81579332076146,
                            21.298059379196573
                        ],
                        [
                            -157.81579345043158,
                            21.298063046969148
                        ],
                        [
                            -157.81579687627138,
                            21.298062940986394
                        ],
                        [
                            -157.81579674660844,
                            21.298059272310482
                        ],
                        [
                            -157.81580359636004,
                            21.298059060331191
                        ],
                        [
                            -157.81580364510782,
                            21.298060435633843
                        ],
                        [
                            -157.81581538822982,
                            21.298060071986885
                        ],
                        [
                            -157.8158154691526,
                            21.298062364456833
                        ],
                        [
                            -157.81581889402125,
                            21.298062259370184
                        ],
                        [
                            -157.81581857130834,
                            21.298053087690541
                        ],
                        [
                            -157.81584107984256,
                            21.298052390553416
                        ],
                        [
                            -157.81584104670361,
                            21.298051473379349
                        ],
                        [
                            -157.81584838724066,
                            21.298051245880245
                        ],
                        [
                            -157.81584848376593,
                            21.298053997382102
                        ],
                        [
                            -157.81585190960556,
                            21.298053891398219
                        ],
                        [
                            -157.81585020343638,
                            21.298005512793367
                        ],
                        [
                            -157.8158656163431,
                            21.298005034937852
                        ],
                        [
                            -157.81586566508426,
                            21.298006411143856
                        ],
                        [
                            -157.81588523758742,
                            21.298005805363211
                        ],
                        [
                            -157.81588518884612,
                            21.298004429157203
                        ],
                        [
                            -157.81589203955915,
                            21.298004217180981
                        ],
                        [
                            -157.81589208830775,
                            21.298005592483655
                        ],
                        [
                            -157.8159116608181,
                            21.298004985796585
                        ],
                        [
                            -157.81591161206933,
                            21.298003610493907
                        ],
                        [
                            -157.81591846278232,
                            21.29800339851661
                        ],
                        [
                            -157.81591859244836,
                            21.298007067192589
                        ],
                        [
                            -157.81592201732298,
                            21.298006961200443
                        ],
                        [
                            -157.81592188765688,
                            21.298003292524445
                        ],
                        [
                            -157.81594317356095,
                            21.298002633747721
                        ],
                        [
                            -157.81594246963428,
                            21.297982686459203
                        ],
                        [
                            -157.81594638433,
                            21.297982564941464
                        ],
                        [
                            -157.8159462702728,
                            21.297979354394052
                        ],
                        [
                            -157.81594235654109,
                            21.297979475918577
                        ],
                        [
                            -157.8159418554047,
                            21.297965260260042
                        ],
                        [
                            -157.81594577009997,
                            21.297965138742292
                        ],
                        [
                            -157.81594565603552,
                            21.297961929098211
                        ],
                        [
                            -157.81594174230426,
                            21.297962050622747
                        ],
                        [
                            -157.81594152391176,
                            21.297955859960776
                        ],
                        [
                            -157.81594299144135,
                            21.297955814275316
                        ],
                        [
                            -157.81594234406484,
                            21.297937471805358
                        ],
                        [
                            -157.81594087653542,
                            21.297937517490823
                        ],
                        [
                            -157.81594065910687,
                            21.297931326835617
                        ],
                        [
                            -157.81594457283731,
                            21.29793120531107
                        ],
                        [
                            -157.81594445973681,
                            21.29792799567376
                        ],
                        [
                            -157.81594054504976,
                            21.29792811628819
                        ],
                        [
                            -157.81594004487016,
                            21.297913901539701
                        ],
                        [
                            -157.8159439585929,
                            21.297913780918481
                        ],
                        [
                            -157.81594384549965,
                            21.29791057037783
                        ],
                        [
                            -157.81593993080585,
                            21.297910691895606
                        ],
                        [
                            -157.81593969291055,
                            21.297903927443699
                        ],
                        [
                            -157.81594116043237,
                            21.297903882661565
                        ],
                        [
                            -157.8159398578857,
                            21.297866967302099
                        ],
                        [
                            -157.81593839035699,
                            21.297867012987577
                        ],
                        [
                            -157.81593815245452,
                            21.297860249438962
                        ],
                        [
                            -157.81594206714701,
                            21.297860127921165
                        ],
                        [
                            -157.81594195308259,
                            21.297856918277052
                        ],
                        [
                            -157.81593803839743,
                            21.297857038891511
                        ],
                        [
                            -157.81593753726128,
                            21.297842823232802
                        ],
                        [
                            -157.81594145194603,
                            21.297842702618354
                        ],
                        [
                            -157.81594133885281,
                            21.29783949207766
                        ],
                        [
                            -157.81593742416089,
                            21.297839613595485
                        ],
                        [
                            -157.8159372067324,
                            21.297833422940215
                        ],
                        [
                            -157.81593867426076,
                            21.297833377254733
                        ],
                        [
                            -157.81593802687726,
                            21.297815035687883
                        ],
                        [
                            -157.81593655935632,
                            21.297815080470016
                        ],
                        [
                            -157.81593634096393,
                            21.297808889807971
                        ],
                        [
                            -157.81594025565505,
                            21.297808768290153
                        ],
                        [
                            -157.81594014159066,
                            21.297805558646019
                        ],
                        [
                            -157.81593622786355,
                            21.297805680170622
                        ],
                        [
                            -157.81593572576355,
                            21.297791464505053
                        ],
                        [
                            -157.81593964141814,
                            21.29779134299401
                        ],
                        [
                            -157.81593952735375,
                            21.297788133349872
                        ],
                        [
                            -157.81593561363434,
                            21.297788253971145
                        ],
                        [
                            -157.8159349097082,
                            21.297768306682197
                        ],
                        [
                            -157.81591362479466,
                            21.297768966369585
                        ],
                        [
                            -157.81591349512865,
                            21.297765297693516
                        ],
                        [
                            -157.8159100702596,
                            21.297765403685748
                        ],
                        [
                            -157.81591019992553,
                            21.297769072361831
                        ],
                        [
                            -157.81590285940248,
                            21.297769299864303
                        ],
                        [
                            -157.81590281066096,
                            21.297767923658256
                        ],
                        [
                            -157.81586904888476,
                            21.297768969836707
                        ],
                        [
                            -157.81586909762598,
                            21.297770346042746
                        ],
                        [
                            -157.81586297972376,
                            21.297770535169352
                        ],
                        [
                            -157.81586277790038,
                            21.29776480354602
                        ],
                        [
                            -157.81586424543528,
                            21.297764756957836
                        ],
                        [
                            -157.8158637286968,
                            21.297750083170499
                        ],
                        [
                            -157.81586226020536,
                            21.297750128848566
                        ],
                        [
                            -157.81586203401503,
                            21.297743708670545
                        ],
                        [
                            -157.81586594870436,
                            21.297743587154375
                        ],
                        [
                            -157.81586583560548,
                            21.29774037751703
                        ],
                        [
                            -157.81586192188016,
                            21.297740499039982
                        ],
                        [
                            -157.8158612179711,
                            21.297720550847753
                        ],
                        [
                            -157.81583993306458,
                            21.297721210526145
                        ],
                        [
                            -157.81583980340042,
                            21.297717541850066
                        ],
                        [
                            -157.81583637853251,
                            21.297717647840852
                        ],
                        [
                            -157.81583650723269,
                            21.297721316510142
                        ],
                        [
                            -157.81582133830571,
                            21.297721786143534
                        ],
                        [
                            -157.81582120960593,
                            21.297718117474261
                        ],
                        [
                            -157.81581778376687,
                            21.297718224361223
                        ],
                        [
                            -157.81581791343052,
                            21.297721893037277
                        ],
                        [
                            -157.81581118519125,
                            21.297722100452415
                        ],
                        [
                            -157.81581113644333,
                            21.297720725149713
                        ],
                        [
                            -157.81576979022208,
                            21.297722005221118
                        ],
                        [
                            -157.81576983799843,
                            21.297723381420365
                        ],
                        [
                            -157.81576310975191,
                            21.297723589736894
                        ],
                        [
                            -157.81576298104633,
                            21.297719921970987
                        ],
                        [
                            -157.81575955522172,
                            21.297720027050079
                        ],
                        [
                            -157.81575968488391,
                            21.297723695726127
                        ],
                        [
                            -157.81574451595682,
                            21.29772416535257
                        ],
                        [
                            -157.81574438628778,
                            21.297720497579885
                        ],
                        [
                            -157.815740962391,
                            21.297720602672165
                        ],
                        [
                            -157.81574109108882,
                            21.297724271341405
                        ],
                        [
                            -157.81573436379895,
                            21.297724480566917
                        ],
                        [
                            -157.81573431409507,
                            21.297723104354105
                        ],
                        [
                            -157.81569296786623,
                            21.297724385309905
                        ],
                        [
                            -157.81569301661304,
                            21.297725760612575
                        ],
                        [
                            -157.81568628836646,
                            21.297725968926038
                        ],
                        [
                            -157.81568615870611,
                            21.29772230025004
                        ],
                        [
                            -157.8156827338309,
                            21.297722407141023
                        ],
                        [
                            -157.81568286253452,
                            21.297726074906901
                        ],
                        [
                            -157.81566769360006,
                            21.29772654542975
                        ],
                        [
                            -157.81566756491131,
                            21.29772287585719
                        ],
                        [
                            -157.81566413907223,
                            21.297722982741007
                        ],
                        [
                            -157.81566426873928,
                            21.297726650513674
                        ],
                        [
                            -157.81565754049268,
                            21.297726858825971
                        ],
                        [
                            -157.81565749174618,
                            21.297725483523312
                        ],
                        [
                            -157.81561614455313,
                            21.297726764453373
                        ],
                        [
                            -157.81561619329921,
                            21.297728139756046
                        ],
                        [
                            -157.81560946505255,
                            21.297728348066428
                        ],
                        [
                            -157.81560933635802,
                            21.297724679397241
                        ],
                        [
                            -157.81560591052613,
                            21.297724785376534
                        ],
                        [
                            -157.81560604017724,
                            21.297728454955841
                        ],
                        [
                            -157.81559087125717,
                            21.297728923665051
                        ],
                        [
                            -157.81559074159193,
                            21.297725255892423
                        ],
                        [
                            -157.81558731768789,
                            21.297725361884904
                        ],
                        [
                            -157.81558744638187,
                            21.297729030554081
                        ],
                        [
                            -157.81556616051085,
                            21.297729690190941
                        ],
                        [
                            -157.81556686438722,
                            21.297749637479196
                        ],
                        [
                            -157.81556294970508,
                            21.297749758085047
                        ],
                        [
                            -157.81556306279012,
                            21.297752968625623
                        ],
                        [
                            -157.81556697844351,
                            21.297752847123224
                        ],
                        [
                            -157.81556720462825,
                            21.297759266397698
                        ],
                        [
                            -157.81556573612954,
                            21.297759312976524
                        ],
                        [
                            -157.81556625380952,
                            21.297773985866829
                        ],
                        [
                            -157.81556772132996,
                            21.2977739410879
                        ],
                        [
                            -157.81556792410581,
                            21.297779672717827
                        ],
                        [
                            -157.81556180716731,
                            21.297779861840212
                        ],
                        [
                            -157.81556175938564,
                            21.297778486544338
                        ],
                        [
                            -157.81554805797376,
                            21.2977789113739
                        ],
                        [
                            -157.81554810671921,
                            21.297780286676556
                        ],
                        [
                            -157.81554125601681,
                            21.297780498639241
                        ],
                        [
                            -157.81554120727142,
                            21.297779123336586
                        ],
                        [
                            -157.81552750683065,
                            21.297779547267922
                        ],
                        [
                            -157.81552755460476,
                            21.297780923467126
                        ],
                        [
                            -157.81552070486626,
                            21.297781135435756
                        ],
                        [
                            -157.81552057617395,
                            21.297777466766625
                        ],
                        [
                            -157.8155171503409,
                            21.297777572744049
                        ],
                        [
                            -157.81551727999701,
                            21.297781241419965
                        ],
                        [
                            -157.81549599412585,
                            21.297781900144237
                        ],
                        [
                            -157.8154966979854,
                            21.29780184833557
                        ],
                        [
                            -157.81549278330192,
                            21.297801968939726
                        ],
                        [
                            -157.81549289638539,
                            21.297805179480264
                        ],
                        [
                            -157.8154968110762,
                            21.297805057972774
                        ],
                        [
                            -157.81549731216998,
                            21.297819273630878
                        ],
                        [
                            -157.81549339844267,
                            21.297819395145147
                        ],
                        [
                            -157.8154935105695,
                            21.297822604775558
                        ],
                        [
                            -157.81549742526079,
                            21.297822483268074
                        ],
                        [
                            -157.81549764363476,
                            21.297828673929843
                        ],
                        [
                            -157.81549617514258,
                            21.297828719604674
                        ],
                        [
                            -157.8154968224639,
                            21.297847062073981
                        ],
                        [
                            -157.81549828999232,
                            21.297847016392367
                        ],
                        [
                            -157.81549850933021,
                            21.297853207060907
                        ],
                        [
                            -157.8154945936742,
                            21.297853328561587
                        ],
                        [
                            -157.81549470772885,
                            21.297856538205558
                        ],
                        [
                            -157.81549862144988,
                            21.297856417594641
                        ],
                        [
                            -157.81549912350764,
                            21.297870633259443
                        ],
                        [
                            -157.81549520882231,
                            21.297870753863567
                        ],
                        [
                            -157.81549532190584,
                            21.297873964404076
                        ],
                        [
                            -157.8154992365985,
                            21.297873842896617
                        ],
                        [
                            -157.8154994627802,
                            21.29788026217097
                        ],
                        [
                            -157.81549799525141,
                            21.297880307852594
                        ],
                        [
                            -157.81549854412623,
                            21.29789589880642
                        ],
                        [
                            -157.81550001357573,
                            21.297895854041723
                        ],
                        [
                            -157.81550023975018,
                            21.297902274219396
                        ],
                        [
                            -157.8154987712573,
                            21.297902319894234
                        ],
                        [
                            -157.81549932109604,
                            21.297917910854807
                        ],
                        [
                            -157.81550078862517,
                            21.297917865173194
                        ],
                        [
                            -157.81550101576357,
                            21.297924285357638
                        ],
                        [
                            -157.8154971010768,
                            21.297924405961737
                        ],
                        [
                            -157.81549721416761,
                            21.297927615598898
                        ],
                        [
                            -157.81550112789051,
                            21.297927494988013
                        ],
                        [
                            -157.81550162994839,
                            21.297941710652726
                        ],
                        [
                            -157.81549771526119,
                            21.297941831256821
                        ],
                        [
                            -157.81549782834475,
                            21.297945041797313
                        ],
                        [
                            -157.81550174207536,
                            21.297944920283097
                        ],
                        [
                            -157.8155019614133,
                            21.297951110951576
                        ],
                        [
                            -157.81550049388386,
                            21.297951156633182
                        ],
                        [
                            -157.81550114024151,
                            21.297969499095476
                        ],
                        [
                            -157.81550260777115,
                            21.29796945341387
                        ],
                        [
                            -157.81550282614521,
                            21.297975644075546
                        ],
                        [
                            -157.8154989124138,
                            21.297975765589747
                        ],
                        [
                            -157.81549902454066,
                            21.297978975220108
                        ],
                        [
                            -157.8155029392361,
                            21.297978853712689
                        ],
                        [
                            -157.81550344033016,
                            21.297993069370548
                        ],
                        [
                            -157.81549952659827,
                            21.297993190884739
                        ],
                        [
                            -157.81549963872513,
                            21.297996400515093
                        ],
                        [
                            -157.81550355341381,
                            21.297996279911022
                        ],
                        [
                            -157.81550425728111,
                            21.298016227198584
                        ],
                        [
                            -157.81552554222941,
                            21.298015567564729
                        ],
                        [
                            -157.81552567188564,
                            21.29801923624057
                        ],
                        [
                            -157.81552909772432,
                            21.298019130263221
                        ],
                        [
                            -157.81552896806801,
                            21.29801546158739
                        ],
                        [
                            -157.81553581878131,
                            21.29801524962572
                        ],
                        [
                            -157.8155358665627,
                            21.298016624921559
                        ],
                        [
                            -157.81555543907376,
                            21.298016018276044
                        ],
                        [
                            -157.81555539129221,
                            21.298014642980228
                        ],
                        [
                            -157.81556713441026,
                            21.298014279350454
                        ],
                        [
                            -157.81556718315585,
                            21.298015654653064
                        ],
                        [
                            -157.81558675565239,
                            21.298015049810591
                        ],
                        [
                            -157.8155867069211,
                            21.298013672701284
                        ],
                        [
                            -157.81558964293797,
                            21.298013582246739
                        ],
                        [
                            -157.81558988958159,
                            21.298020576221074
                        ],
                        [
                            -157.81559747310359,
                            21.298020340505602
                        ],
                        [
                            -157.81559893253851,
                            21.298061726038139
                        ],
                        [
                            -157.81560235837821,
                            21.298061620059354
                        ],
                        [
                            -157.81560226185755,
                            21.298058868557554
                        ],
                        [
                            -157.81560960046696,
                            21.298058641055331
                        ],
                        [
                            -157.81560963359726,
                            21.298059559132724
                        ],
                        [
                            -157.81563214213196,
                            21.298058862023641
                        ],
                        [
                            -157.81563265981802,
                            21.298073534913588
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 205,
                "NUMBER": "1098",
                "PROPER_NAME": "MARINE SCIENCES BUILDING",
                "DISPLAY_NAME": "MARINE SCIENCES BUILDING (MSB) - 1098",
                "ADDRESS": "1000 POPE ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MARINE SCIENCES BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1098_01.jpg",
                "HEIGHT (ft)": 90.100000000000009,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 205.03711808828663,
                "SHAPE_Area": 1519.0815141533196
            }
        },
        {
            "type": "Feature",
            "id": 206,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.81449781385189,
                                21.303197310084958
                            ],
                            [
                                -157.81472256572047,
                                21.303190224485725
                            ],
                            [
                                -157.8147182184386,
                                21.303069152349707
                            ],
                            [
                                -157.81472225574834,
                                21.303069024502481
                            ],
                            [
                                -157.81472218578148,
                                21.303067051007471
                            ],
                            [
                                -157.81472209107667,
                                21.303064435931827
                            ],
                            [
                                -157.81472207597872,
                                21.303064034720649
                            ],
                            [
                                -157.81472193253703,
                                21.303060044343226
                            ],
                            [
                                -157.81472179389363,
                                21.303056176860554
                            ],
                            [
                                -157.81472153161775,
                                21.303048853946443
                            ],
                            [
                                -157.81472305867149,
                                21.303048244074663
                            ],
                            [
                                -157.81473206427592,
                                21.303044653300784
                            ],
                            [
                                -157.81473324606935,
                                21.303044181925635
                            ],
                            [
                                -157.81473364064314,
                                21.303044024805111
                            ],
                            [
                                -157.81474135710755,
                                21.303040948012388
                            ],
                            [
                                -157.81474255147575,
                                21.303040471305408
                            ],
                            [
                                -157.814744405402,
                                21.303039731841086
                            ],
                            [
                                -157.8147490726077,
                                21.303037871212528
                            ],
                            [
                                -157.81474946622475,
                                21.30303771318184
                            ],
                            [
                                -157.81475711112441,
                                21.303034664792751
                            ],
                            [
                                -157.81482604771821,
                                21.303007174197774
                            ],
                            [
                                -157.81481800252624,
                                21.302989458077853
                            ],
                            [
                                -157.81481300945657,
                                21.302978462086873
                            ],
                            [
                                -157.81479309403446,
                                21.302986404435408
                            ],
                            [
                                -157.81479531962952,
                                21.3029746615966
                            ],
                            [
                                -157.81479251811757,
                                21.302974195589524
                            ],
                            [
                                -157.81479144008321,
                                21.302979879348811
                            ],
                            [
                                -157.81478054307158,
                                21.302978066279721
                            ],
                            [
                                -157.81478211440916,
                                21.3029697715866
                            ],
                            [
                                -157.81478533851092,
                                21.302952765407955
                            ],
                            [
                                -157.81478253604271,
                                21.302952298490606
                            ],
                            [
                                -157.81478147003929,
                                21.302957924517635
                            ],
                            [
                                -157.81477057207994,
                                21.302956109634533
                            ],
                            [
                                -157.81477446358087,
                                21.302935579518515
                            ],
                            [
                                -157.81477536848399,
                                21.302930808769801
                            ],
                            [
                                -157.81477256601627,
                                21.302930341852306
                            ],
                            [
                                -157.8147714990487,
                                21.302935967872507
                            ],
                            [
                                -157.81476060205509,
                                21.302934152995604
                            ],
                            [
                                -157.81476539749599,
                                21.302908852124371
                            ],
                            [
                                -157.8147625959854,
                                21.302908386116854
                            ],
                            [
                                -157.81476152998886,
                                21.302914011240432
                            ],
                            [
                                -157.81475719101607,
                                21.302913289584769
                            ],
                            [
                                -157.81475241675628,
                                21.30290277754332
                            ],
                            [
                                -157.81475280546871,
                                21.302900707002934
                            ],
                            [
                                -157.81475292319206,
                                21.302900091720645
                            ],
                            [
                                -157.81475318191818,
                                21.302898723101521
                            ],
                            [
                                -157.81475542746023,
                                21.302886897291891
                            ],
                            [
                                -157.81475262500064,
                                21.302886429470753
                            ],
                            [
                                -157.81475037727688,
                                21.302898286883604
                            ],
                            [
                                -157.8147493513911,
                                21.302896026604532
                            ],
                            [
                                -157.81474244672287,
                                21.302880822710165
                            ],
                            [
                                -157.8147431483159,
                                21.302877121949226
                            ],
                            [
                                -157.81474325103662,
                                21.302876574315484
                            ],
                            [
                                -157.81474545744177,
                                21.302864940652213
                            ],
                            [
                                -157.81474265497539,
                                21.302864473734282
                            ],
                            [
                                -157.81474262801382,
                                21.302864469930817
                            ],
                            [
                                -157.81474129329632,
                                21.302871507869067
                            ],
                            [
                                -157.81474038736337,
                                21.302876286740837
                            ],
                            [
                                -157.81473784677394,
                                21.302870693126444
                            ],
                            [
                                -157.81473081044504,
                                21.302855198316287
                            ],
                            [
                                -157.81473154932135,
                                21.302854901788869
                            ],
                            [
                                -157.81474040862503,
                                21.302851160924238
                            ],
                            [
                                -157.81473968960324,
                                21.302849703209532
                            ],
                            [
                                -157.81473086028348,
                                21.302853431637903
                            ],
                            [
                                -157.81473013978015,
                                21.302853721067606
                            ],
                            [
                                -157.81473011136887,
                                21.302853657630234
                            ],
                            [
                                -157.81472809303037,
                                21.302854463690608
                            ],
                            [
                                -157.81472804854383,
                                21.302854481445031
                            ],
                            [
                                -157.81472139971495,
                                21.302857138454854
                            ],
                            [
                                -157.81471262082314,
                                21.302860468842781
                            ],
                            [
                                -157.81470377762147,
                                21.302863644297645
                            ],
                            [
                                -157.81469487298736,
                                21.302866666646491
                            ],
                            [
                                -157.81469046486299,
                                21.302868076500751
                            ],
                            [
                                -157.81468751032784,
                                21.302869021411524
                            ],
                            [
                                -157.81468590983442,
                                21.302869533199686
                            ],
                            [
                                -157.81467689106177,
                                21.302872243074244
                            ],
                            [
                                -157.81466782052522,
                                21.302874796297306
                            ],
                            [
                                -157.81465870113112,
                                21.302877191082576
                            ],
                            [
                                -157.81464953577859,
                                21.302879426547094
                            ],
                            [
                                -157.81464032832346,
                                21.302881502717984
                            ],
                            [
                                -157.81463913483287,
                                21.302881749969597
                            ],
                            [
                                -157.81463909718093,
                                21.302881756931459
                            ],
                            [
                                -157.81463897068633,
                                21.302881783142048
                            ],
                            [
                                -157.81463811335317,
                                21.302878099404861
                            ],
                            [
                                -157.81463490167792,
                                21.30287636937442
                            ],
                            [
                                -157.81463427393692,
                                21.302876030698258
                            ],
                            [
                                -157.81463407236288,
                                21.302875922678325
                            ],
                            [
                                -157.81462994046473,
                                21.30287390250103
                            ],
                            [
                                -157.81462755817032,
                                21.30287285133808
                            ],
                            [
                                -157.81462736988863,
                                21.302872768706685
                            ],
                            [
                                -157.81462572437729,
                                21.302872042533838
                            ],
                            [
                                -157.81462569266844,
                                21.302872029663018
                            ],
                            [
                                -157.81462142986982,
                                21.302870344624193
                            ],
                            [
                                -157.81461706655276,
                                21.302868812453305
                            ],
                            [
                                -157.81461263922412,
                                21.302867448765173
                            ],
                            [
                                -157.81460815654489,
                                21.302866255427556
                            ],
                            [
                                -157.81460362524825,
                                21.302865234294703
                            ],
                            [
                                -157.81459905303851,
                                21.302864386324213
                            ],
                            [
                                -157.81459444856219,
                                21.302863715190604
                            ],
                            [
                                -157.81458981857418,
                                21.302863220038041
                            ],
                            [
                                -157.81458517077874,
                                21.302862901824195
                            ],
                            [
                                -157.81458051191629,
                                21.302862761499945
                            ],
                            [
                                -157.814575852583,
                                21.302862800043332
                            ],
                            [
                                -157.81457119760583,
                                21.302863016584944
                            ],
                            [
                                -157.81456655663149,
                                21.302863410289373
                            ],
                            [
                                -157.81456193544363,
                                21.302863981197362
                            ],
                            [
                                -157.81455734465297,
                                21.302864728480259
                            ],
                            [
                                -157.81455278908641,
                                21.302865651268718
                            ],
                            [
                                -157.81454827841247,
                                21.302866746017276
                            ],
                            [
                                -157.81454381840751,
                                21.302868013670015
                            ],
                            [
                                -157.81453941681934,
                                21.302869449764582
                            ],
                            [
                                -157.81453508233076,
                                21.30287105345877
                            ],
                            [
                                -157.81453082074719,
                                21.302872822083302
                            ],
                            [
                                -157.81452663981639,
                                21.302874751175839
                            ],
                            [
                                -157.81452254630778,
                                21.302876838073907
                            ],
                            [
                                -157.81451854699071,
                                21.302879080115023
                            ],
                            [
                                -157.81451464960571,
                                21.302881473740165
                            ],
                            [
                                -157.81451187282073,
                                21.302883333226617
                            ],
                            [
                                -157.81451085708815,
                                21.302884013549708
                            ],
                            [
                                -157.8145071810271,
                                21.302886696915142
                            ],
                            [
                                -157.81450705975814,
                                21.302886792723417
                            ],
                            [
                                -157.81450517762525,
                                21.302888284509688
                            ],
                            [
                                -157.81450362340121,
                                21.302889517526662
                            ],
                            [
                                -157.81450348255197,
                                21.302893375813138
                            ],
                            [
                                -157.81450158977802,
                                21.302893310081345
                            ],
                            [
                                -157.81449962567194,
                                21.302893243846988
                            ],
                            [
                                -157.81449908315025,
                                21.302893217440012
                            ],
                            [
                                -157.81449766002203,
                                21.302893129722104
                            ],
                            [
                                -157.8144851862275,
                                21.302892358877102
                            ],
                            [
                                -157.81448523416361,
                                21.302891790983015
                            ],
                            [
                                -157.81448468598148,
                                21.302891749178489
                            ],
                            [
                                -157.81448463708145,
                                21.302892317065783
                            ],
                            [
                                -157.81447465997803,
                                21.302891435528988
                            ],
                            [
                                -157.81447145210331,
                                21.302891154558591
                            ],
                            [
                                -157.81447077102675,
                                21.302891095556717
                            ],
                            [
                                -157.81447023162889,
                                21.302891040263198
                            ],
                            [
                                -157.81445640906071,
                                21.302889445056184
                            ],
                            [
                                -157.8144564916773,
                                21.302888880116615
                            ],
                            [
                                -157.81445594564778,
                                21.302888810322109
                            ],
                            [
                                -157.8144558630384,
                                21.30288937435834
                            ],
                            [
                                -157.81444635244267,
                                21.302888020923969
                            ],
                            [
                                -157.81444332217367,
                                21.302887591241785
                            ],
                            [
                                -157.81444209349485,
                                21.302887418168069
                            ],
                            [
                                -157.81444155914866,
                                21.302887334001593
                            ],
                            [
                                -157.81442785524089,
                                21.302885006979661
                            ],
                            [
                                -157.81442797155952,
                                21.302884446794511
                            ],
                            [
                                -157.81442743058167,
                                21.302884348127034
                            ],
                            [
                                -157.81442731330631,
                                21.302884907402056
                            ],
                            [
                                -157.81442714871761,
                                21.30288487552717
                            ],
                            [
                                -157.81441916592223,
                                21.302883299781399
                            ],
                            [
                                -157.81441368457243,
                                21.302882222263133
                            ],
                            [
                                -157.81441315527067,
                                21.302882110127047
                            ],
                            [
                                -157.81439961430735,
                                21.302879058829383
                            ],
                            [
                                -157.8143997643063,
                                21.302878506108677
                            ],
                            [
                                -157.81439923127198,
                                21.302878378588641
                            ],
                            [
                                -157.8143990803091,
                                21.302878931302551
                            ],
                            [
                                -157.81439307426021,
                                21.302877408329298
                            ],
                            [
                                -157.81439049789518,
                                21.302876755997069
                            ],
                            [
                                -157.81439042190271,
                                21.302876735587059
                            ],
                            [
                                -157.81438729139808,
                                21.302875942938545
                            ],
                            [
                                -157.81438563569768,
                                21.30287552565073
                            ],
                            [
                                -157.81438511336106,
                                21.302875386461952
                            ],
                            [
                                -157.81437177865493,
                                21.302871619324364
                            ],
                            [
                                -157.81437196231246,
                                21.302871076778132
                            ],
                            [
                                -157.81437143721448,
                                21.302870921308859
                            ],
                            [
                                -157.81437125355697,
                                21.302871463855091
                            ],
                            [
                                -157.81436511951387,
                                21.302869553328428
                            ],
                            [
                                -157.81436438870358,
                                21.302869325041915
                            ],
                            [
                                -157.81436004996661,
                                21.3028679737155
                            ],
                            [
                                -157.8143580373158,
                                21.302867349746318
                            ],
                            [
                                -157.81435752484339,
                                21.302867182621895
                            ],
                            [
                                -157.81434440891897,
                                21.302862700636137
                            ],
                            [
                                -157.81434389171383,
                                21.302862522637675
                            ],
                            [
                                -157.81434330505326,
                                21.302864032584186
                            ],
                            [
                                -157.81434382227289,
                                21.302864208775997
                            ],
                            [
                                -157.81435388009803,
                                21.302867644770508
                            ],
                            [
                                -157.81435375595885,
                                21.302867978149788
                            ],
                            [
                                -157.81435325247332,
                                21.302869334202885
                            ],
                            [
                                -157.81435312833418,
                                21.302869667582165
                            ],
                            [
                                -157.8143491064364,
                                21.302880490754035
                            ],
                            [
                                -157.81434827878863,
                                21.302882719907089
                            ],
                            [
                                -157.81434502835353,
                                21.302891468009413
                            ],
                            [
                                -157.81434123435906,
                                21.302877130687683
                            ],
                            [
                                -157.81433847216215,
                                21.302877772505354
                            ],
                            [
                                -157.81434510110338,
                                21.30290282593095
                            ],
                            [
                                -157.81434456701805,
                                21.302902949545526
                            ],
                            [
                                -157.81433489256494,
                                21.302905197666369
                            ],
                            [
                                -157.81433435847237,
                                21.302905322184248
                            ],
                            [
                                -157.81433286145543,
                                21.302899665453335
                            ],
                            [
                                -157.81433009925806,
                                21.302900307270843
                            ],
                            [
                                -157.81433078320376,
                                21.302902892169676
                            ],
                            [
                                -157.81433669825105,
                                21.30292524846541
                            ],
                            [
                                -157.81433616415114,
                                21.302925373886623
                            ],
                            [
                                -157.81432837978193,
                                21.30292718182378
                            ],
                            [
                                -157.81432648970372,
                                21.302927621103571
                            ],
                            [
                                -157.81432595561105,
                                21.302927745621421
                            ],
                            [
                                -157.81432448855634,
                                21.302922199315052
                            ],
                            [
                                -157.81432172635851,
                                21.302922841132396
                            ],
                            [
                                -157.81432832630756,
                                21.302947783237347
                            ],
                            [
                                -157.81431758367302,
                                21.302950279489391
                            ],
                            [
                                -157.81431611564727,
                                21.302944734079514
                            ],
                            [
                                -157.81431335248504,
                                21.302945375889905
                            ],
                            [
                                -157.81431554469569,
                                21.302953657348215
                            ],
                            [
                                -157.81431853122052,
                                21.302964945462435
                            ],
                            [
                                -157.81431995340469,
                                21.302970317098552
                            ],
                            [
                                -157.81431941834066,
                                21.302970442512912
                            ],
                            [
                                -157.81430974485397,
                                21.302972689735526
                            ],
                            [
                                -157.81430920979716,
                                21.302972814246498
                            ],
                            [
                                -157.81430774177153,
                                21.302967268836589
                            ],
                            [
                                -157.8143049805295,
                                21.302967911563741
                            ],
                            [
                                -157.81431157952062,
                                21.302992852759047
                            ],
                            [
                                -157.81431104543495,
                                21.302992976373496
                            ],
                            [
                                -157.81430137193942,
                                21.302995224498865
                            ],
                            [
                                -157.81430083688255,
                                21.302995349009823
                            ],
                            [
                                -157.81429936324733,
                                21.302989781878978
                            ],
                            [
                                -157.81429660201206,
                                21.302990423702632
                            ],
                            [
                                -157.81430148130701,
                                21.303008866446035
                            ],
                            [
                                -157.81431006172625,
                                21.303011651529907
                            ],
                            [
                                -157.8143103521285,
                                21.303011742108367
                            ],
                            [
                                -157.81431720544907,
                                21.303013877229116
                            ],
                            [
                                -157.81431749682253,
                                21.303013966911017
                            ],
                            [
                                -157.8143281958788,
                                21.303017142732756
                            ],
                            [
                                -157.81432848923089,
                                21.303017226104856
                            ],
                            [
                                -157.81433540572334,
                                21.30301917737863
                            ],
                            [
                                -157.81433569811878,
                                21.303019259840589
                            ],
                            [
                                -157.81434230644496,
                                21.303021051752935
                            ],
                            [
                                -157.81434478261227,
                                21.303021697056231
                            ],
                            [
                                -157.81434892879574,
                                21.303022777816423
                            ],
                            [
                                -157.81435745283676,
                                21.303024900316405
                            ],
                            [
                                -157.81436489816122,
                                21.303026661989989
                            ],
                            [
                                -157.81436519646357,
                                21.303026729135912
                            ],
                            [
                                -157.81437221907117,
                                21.30302831076634
                            ],
                            [
                                -157.81437251640961,
                                21.303028377905452
                            ],
                            [
                                -157.81438150107408,
                                21.303030281416131
                            ],
                            [
                                -157.81438235469079,
                                21.303030462688266
                            ],
                            [
                                -157.81439222492759,
                                21.303032409477147
                            ],
                            [
                                -157.81440212424258,
                                21.303034216444999
                            ],
                            [
                                -157.81440242653122,
                                21.303034267357933
                            ],
                            [
                                -157.81440953312642,
                                21.303035473768716
                            ],
                            [
                                -157.81440983445111,
                                21.30303552467484
                            ],
                            [
                                -157.81441916294918,
                                21.303036987042059
                            ],
                            [
                                -157.81441978106528,
                                21.303037083542907
                            ],
                            [
                                -157.81442975097386,
                                21.3030385025492
                            ],
                            [
                                -157.81443974225618,
                                21.303039780776793
                            ],
                            [
                                -157.81444004659593,
                                21.303039816346498
                            ],
                            [
                                -157.81444721504386,
                                21.303040642864644
                            ],
                            [
                                -157.81444751842693,
                                21.303040677524198
                            ],
                            [
                                -157.81445493118889,
                                21.303041451560031
                            ],
                            [
                                -157.81446235324253,
                                21.303042148872919
                            ],
                            [
                                -157.81446361074228,
                                21.303077180325459
                            ],
                            [
                                -157.81449346771856,
                                21.303076237958592
                            ],
                            [
                                -157.81449781385189,
                                21.303197310084958
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81481061373029,
                                21.302945070398305
                            ],
                            [
                                -157.81481043691468,
                                21.302945120646093
                            ],
                            [
                                -157.81481027336255,
                                21.302945199895756
                            ],
                            [
                                -157.81481012504523,
                                21.302945302740856
                            ],
                            [
                                -157.81480999968153,
                                21.302945428332364
                            ],
                            [
                                -157.81480989922835,
                                21.302945573070488
                            ],
                            [
                                -157.81480982758495,
                                21.302945731562382
                            ],
                            [
                                -157.8148097857443,
                                21.302945900201475
                            ],
                            [
                                -157.81480977568492,
                                21.302946072677987
                            ],
                            [
                                -157.81480979842155,
                                21.302946242675318
                            ],
                            [
                                -157.8148098510768,
                                21.302946408366441
                            ],
                            [
                                -157.81480993467986,
                                21.302946561628087
                            ],
                            [
                                -157.81481004538941,
                                21.302946700626432
                            ],
                            [
                                -157.81481018037152,
                                21.302946818114407
                            ],
                            [
                                -157.81481033482103,
                                21.302946912251365
                            ],
                            [
                                -157.81481050393984,
                                21.302946980293367
                            ],
                            [
                                -157.81481068582912,
                                21.30294701861347
                            ],
                            [
                                -157.81481086602227,
                                21.302947028013172
                            ],
                            [
                                -157.81481104935366,
                                21.30294700671972
                            ],
                            [
                                -157.81481122616199,
                                21.302946957375273
                            ],
                            [
                                -157.8148113897069,
                                21.302946879028941
                            ],
                            [
                                -157.81481153610358,
                                21.302946775266935
                            ],
                            [
                                -157.81481166243847,
                                21.302946648778885
                            ],
                            [
                                -157.8148117619277,
                                21.302946504033951
                            ],
                            [
                                -157.81481183453502,
                                21.302946345548847
                            ],
                            [
                                -157.81481187636848,
                                21.302946177813091
                            ],
                            [
                                -157.81481188642059,
                                21.302946006239932
                            ],
                            [
                                -157.81481186466237,
                                21.302945834442699
                            ],
                            [
                                -157.81481181103592,
                                21.302945669648139
                            ],
                            [
                                -157.81481172744012,
                                21.302945515483142
                            ],
                            [
                                -157.81481161671607,
                                21.302945378291469
                            ],
                            [
                                -157.81481148269791,
                                21.302945260810304
                            ],
                            [
                                -157.8148113282484,
                                21.302945166673336
                            ],
                            [
                                -157.81481115912959,
                                21.302945098631348
                            ],
                            [
                                -157.81481098013944,
                                21.302945059428279
                            ],
                            [
                                -157.8148107951265,
                                21.30294504999463
                            ],
                            [
                                -157.81481061373029,
                                21.302945070398305
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 206,
                "NUMBER": "1172B",
                "PROPER_NAME": "DANIEL K. INOUYE CENTER FOR MICROBIAL OCEANOGRAPHY: RESEARCH AND EDUCATION",
                "DISPLAY_NAME": "DANIEL K. INOUYE CENTER FOR MICROBIAL OCEANOGRAPHY: RESEARCH AND EDUCATION (C-MORE HALE) - 1172B",
                "ADDRESS": "1950 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "C-MORE (DANIEL K. INOUYE CENTER FOR MICROBIAL OCEANOGRAPHY: RESEARCH AND EDUCATION)",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1172B_01.jpg",
                "HEIGHT (ft)": 49.100000000000001,
                "LEED STATUS": "Platinum",
                "LEED LINK": "https://www.usgbc.org/projects/university-hawaii-c-more-hale",
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 203.857848961228,
                "SHAPE_Area": 1261.8092926770407
            }
        },
        {
            "type": "Feature",
            "id": 208,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81546047609814,
                            21.301227589040117
                        ],
                        [
                            -157.81546050665676,
                            21.301228827802412
                        ],
                        [
                            -157.81546238936056,
                            21.301230147356517
                        ],
                        [
                            -157.81546243714072,
                            21.301231522651872
                        ],
                        [
                            -157.81546286525216,
                            21.30123151030779
                        ],
                        [
                            -157.81546296081245,
                            21.301234260898511
                        ],
                        [
                            -157.8154649181925,
                            21.301234201502258
                        ],
                        [
                            -157.81546234209321,
                            21.301159913899799
                        ],
                        [
                            -157.81546038567811,
                            21.301159973302834
                        ],
                        [
                            -157.81545962125381,
                            21.301137961350239
                        ],
                        [
                            -157.81546158043736,
                            21.301137917324326
                        ],
                        [
                            -157.81545900350523,
                            21.301063613454229
                        ],
                        [
                            -157.81545704612745,
                            21.301063672850518
                        ],
                        [
                            -157.81545714168772,
                            21.301066423441267
                        ],
                        [
                            -157.81545652939968,
                            21.301066442619412
                        ],
                        [
                            -157.8154565771726,
                            21.301067818818115
                        ],
                        [
                            -157.81545497322963,
                            21.301069244820631
                        ],
                        [
                            -157.81545501633391,
                            21.301070481864468
                        ],
                        [
                            -157.81541831691396,
                            21.301071599389239
                        ],
                        [
                            -157.81541827287504,
                            21.301070358725259
                        ],
                        [
                            -157.81541639017357,
                            21.301069039170756
                        ],
                        [
                            -157.81541634337225,
                            21.301067662075489
                        ],
                        [
                            -157.81541560862809,
                            21.301067684908407
                        ],
                        [
                            -157.81541565640782,
                            21.301069060203783
                        ],
                        [
                            -157.81541386925139,
                            21.301070493046673
                        ],
                        [
                            -157.81541391232633,
                            21.301071733703864
                        ],
                        [
                            -157.81537721194232,
                            21.301072851212858
                        ],
                        [
                            -157.81537716887487,
                            21.301071609652332
                        ],
                        [
                            -157.8153752861738,
                            21.301070290097382
                        ],
                        [
                            -157.81537523840169,
                            21.301068913898678
                        ],
                        [
                            -157.81537450462147,
                            21.301068936738201
                        ],
                        [
                            -157.81537455239356,
                            21.301070312936904
                        ],
                        [
                            -157.81537276525123,
                            21.301071743972649
                        ],
                        [
                            -157.81537280831861,
                            21.301072985533189
                        ],
                        [
                            -157.81533610793443,
                            21.301074103033166
                        ],
                        [
                            -157.81533606580231,
                            21.301072865092802
                        ],
                        [
                            -157.81533418213766,
                            21.301071545530622
                        ],
                        [
                            -157.81533413436594,
                            21.301070169331922
                        ],
                        [
                            -157.81533340154965,
                            21.301070192178052
                        ],
                        [
                            -157.81533344835745,
                            21.301071568369949
                        ],
                        [
                            -157.81533166121469,
                            21.301072999405253
                        ],
                        [
                            -157.81533170334674,
                            21.301074237345635
                        ],
                        [
                            -157.81529500392637,
                            21.30107535484342
                        ],
                        [
                            -157.81529496085963,
                            21.301074113282908
                        ],
                        [
                            -157.81529307815933,
                            21.301072793727069
                        ],
                        [
                            -157.81529303038795,
                            21.301071417528377
                        ],
                        [
                            -157.81529229564379,
                            21.301071440360754
                        ],
                        [
                            -157.81529234437906,
                            21.301072816566236
                        ],
                        [
                            -157.815290556272,
                            21.301074247594279
                        ],
                        [
                            -157.81529058777144,
                            21.301075489073373
                        ],
                        [
                            -157.81525389991813,
                            21.301076606643601
                        ],
                        [
                            -157.81525385685174,
                            21.301075365083076
                        ],
                        [
                            -157.81525197318788,
                            21.301074045520004
                        ],
                        [
                            -157.81525192637361,
                            21.301072670231459
                        ],
                        [
                            -157.81525119260786,
                            21.301072691263755
                        ],
                        [
                            -157.81525124037881,
                            21.301074067462441
                        ],
                        [
                            -157.81524945226411,
                            21.301075499393384
                        ],
                        [
                            -157.8152494953377,
                            21.301076740050551
                        ],
                        [
                            -157.81521277951558,
                            21.301077859221646
                        ],
                        [
                            -157.81521274706012,
                            21.301076616832464
                        ],
                        [
                            -157.81521086436052,
                            21.301075297275741
                        ],
                        [
                            -157.81521081754664,
                            21.301073921987182
                        ],
                        [
                            -157.81521008281695,
                            21.301073943012526
                        ],
                        [
                            -157.81521013058753,
                            21.301075319211211
                        ],
                        [
                            -157.81520834343635,
                            21.301076751148482
                        ],
                        [
                            -157.81520838650238,
                            21.301077992708979
                        ],
                        [
                            -157.81517169190121,
                            21.301079110213717
                        ],
                        [
                            -157.8151716488355,
                            21.30107786865322
                        ],
                        [
                            -157.81516976614358,
                            21.301076548192711
                        ],
                        [
                            -157.81516971740217,
                            21.301075172890588
                        ],
                        [
                            -157.81516929025517,
                            21.301075185240713
                        ],
                        [
                            -157.81516885328472,
                            21.301062595237052
                        ],
                        [
                            -157.81517178936213,
                            21.301062504792647
                        ],
                        [
                            -157.81517172367978,
                            21.301060597274791
                        ],
                        [
                            -157.81517680707378,
                            21.301060443354356
                        ],
                        [
                            -157.81517682510903,
                            21.301060959316786
                        ],
                        [
                            -157.81517780476543,
                            21.301060929175396
                        ],
                        [
                            -157.81517907518378,
                            21.301062267006255
                        ],
                        [
                            -157.81518347976376,
                            21.301062133601128
                        ],
                        [
                            -157.81518465077849,
                            21.301060719910772
                        ],
                        [
                            -157.81518563331946,
                            21.301060690693035
                        ],
                        [
                            -157.8151855855491,
                            21.301059314494374
                        ],
                        [
                            -157.81518460685663,
                            21.301059344642582
                        ],
                        [
                            -157.81518333643828,
                            21.301058006811768
                        ],
                        [
                            -157.81518119489084,
                            21.301058072135241
                        ],
                        [
                            -157.81518044707883,
                            21.301036518318288
                        ],
                        [
                            -157.81518258958988,
                            21.30103645300159
                        ],
                        [
                            -157.81518376058995,
                            21.301035041117906
                        ],
                        [
                            -157.81518474314521,
                            21.301035010093511
                        ],
                        [
                            -157.81518469536761,
                            21.301033634798159
                        ],
                        [
                            -157.81518371668258,
                            21.301033664043032
                        ],
                        [
                            -157.81518244626443,
                            21.301032326212219
                        ],
                        [
                            -157.81518030471733,
                            21.301032391535703
                        ],
                        [
                            -157.81517955786208,
                            21.301010838628816
                        ],
                        [
                            -157.81518169844492,
                            21.30101077329854
                        ],
                        [
                            -157.81518287041595,
                            21.301009360518297
                        ],
                        [
                            -157.81518385296383,
                            21.301009330397232
                        ],
                        [
                            -157.81518380519347,
                            21.301007954198546
                        ],
                        [
                            -157.81518282650134,
                            21.301007984346771
                        ],
                        [
                            -157.81518155608342,
                            21.30100664651594
                        ],
                        [
                            -157.81517941453671,
                            21.301006711839431
                        ],
                        [
                            -157.81517866672482,
                            21.300985158022364
                        ],
                        [
                            -157.81518080827121,
                            21.30098509269887
                        ],
                        [
                            -157.81518198023477,
                            21.300983680821972
                        ],
                        [
                            -157.81518296278969,
                            21.300983649797551
                        ],
                        [
                            -157.81518291404819,
                            21.300982274495411
                        ],
                        [
                            -157.81518193632741,
                            21.300982303747091
                        ],
                        [
                            -157.81518066494576,
                            21.300980965909471
                        ],
                        [
                            -157.81517852436338,
                            21.300981031239772
                        ],
                        [
                            -157.81517777654429,
                            21.300959478325971
                        ],
                        [
                            -157.81517991712639,
                            21.300959412995677
                        ],
                        [
                            -157.815181089097,
                            21.300958000215442
                        ],
                        [
                            -157.8151820716445,
                            21.300957970094352
                        ],
                        [
                            -157.81518202386692,
                            21.300956594799
                        ],
                        [
                            -157.81518104614631,
                            21.300956624050684
                        ],
                        [
                            -157.81517977476489,
                            21.300955286213075
                        ],
                        [
                            -157.81517763418285,
                            21.300955351543369
                        ],
                        [
                            -157.81517688720467,
                            21.300933813993055
                        ],
                        [
                            -157.81517902695282,
                            21.300933732395876
                        ],
                        [
                            -157.81518019891593,
                            21.300932320518964
                        ],
                        [
                            -157.81518118147054,
                            21.30093228949454
                        ],
                        [
                            -157.81518113369296,
                            21.300930914199178
                        ],
                        [
                            -157.81518015500134,
                            21.300930944347417
                        ],
                        [
                            -157.81517888459132,
                            21.300929605613259
                        ],
                        [
                            -157.81517448000804,
                            21.300929739921791
                        ],
                        [
                            -157.81517330417466,
                            21.300931153578205
                        ],
                        [
                            -157.81517232549029,
                            21.30093118282306
                        ],
                        [
                            -157.81517234352552,
                            21.300931698785497
                        ],
                        [
                            -157.81516725916481,
                            21.30093185360256
                        ],
                        [
                            -157.81516719432332,
                            21.300929961448212
                        ],
                        [
                            -157.81516425729185,
                            21.300930050982519
                        ],
                        [
                            -157.81516382050989,
                            21.300917437491862
                        ],
                        [
                            -157.81516424862764,
                            21.300917424245164
                        ],
                        [
                            -157.81516420085745,
                            21.300916048046485
                        ],
                        [
                            -157.81516598799973,
                            21.300914617012918
                        ],
                        [
                            -157.81516594586904,
                            21.300913379072533
                        ],
                        [
                            -157.81520264042894,
                            21.30091226156712
                        ],
                        [
                            -157.81520268352392,
                            21.300913499514294
                        ],
                        [
                            -157.81520456525746,
                            21.300914819064253
                        ],
                        [
                            -157.81520461302802,
                            21.30091619526295
                        ],
                        [
                            -157.81520534777141,
                            21.30091617243092
                        ],
                        [
                            -157.81520530000086,
                            21.30091479623222
                        ],
                        [
                            -157.81520708714274,
                            21.300913365198198
                        ],
                        [
                            -157.81520703247332,
                            21.30091212807292
                        ],
                        [
                            -157.81524374921807,
                            21.300911008907928
                        ],
                        [
                            -157.81524379230612,
                            21.300912247758443
                        ],
                        [
                            -157.81524567500401,
                            21.300913567314744
                        ],
                        [
                            -157.81524572278218,
                            21.300914942610117
                        ],
                        [
                            -157.81524645655438,
                            21.300914920674455
                        ],
                        [
                            -157.81524640878345,
                            21.300913544475744
                        ],
                        [
                            -157.81524819688889,
                            21.300912113448074
                        ],
                        [
                            -157.81524815282964,
                            21.300910875494107
                        ],
                        [
                            -157.81528485317287,
                            21.300909758011422
                        ],
                        [
                            -157.81528489626848,
                            21.300910995958606
                        ],
                        [
                            -157.81528677896677,
                            21.300912315514459
                        ],
                        [
                            -157.81528682674534,
                            21.300913690809821
                        ],
                        [
                            -157.81528756051028,
                            21.300913669777337
                        ],
                        [
                            -157.81528751274618,
                            21.300912292675285
                        ],
                        [
                            -157.81528929988733,
                            21.30091086164035
                        ],
                        [
                            -157.81528925678441,
                            21.3009096245965
                        ],
                        [
                            -157.81532595713472,
                            21.300908506201484
                        ],
                        [
                            -157.8153260002307,
                            21.300909744148672
                        ],
                        [
                            -157.81532788292932,
                            21.300911063704085
                        ],
                        [
                            -157.81532793070829,
                            21.300912438999468
                        ],
                        [
                            -157.81532835881879,
                            21.300912426655689
                        ],
                        [
                            -157.81532845434049,
                            21.300915181763145
                        ],
                        [
                            -157.81533041172349,
                            21.300915121464943
                        ],
                        [
                            -157.81532783568898,
                            21.300840833861059
                        ],
                        [
                            -157.81532587831418,
                            21.300840893255938
                        ],
                        [
                            -157.815325115837,
                            21.300818881316516
                        ],
                        [
                            -157.81532707321873,
                            21.300818821018279
                        ],
                        [
                            -157.815324497185,
                            21.300744533413685
                        ],
                        [
                            -157.81532253981152,
                            21.300744592808584
                        ],
                        [
                            -157.81532263439817,
                            21.300747344295953
                        ],
                        [
                            -157.81532202308267,
                            21.300747362577106
                        ],
                        [
                            -157.81532207085436,
                            21.300748738775848
                        ],
                        [
                            -157.81532046691382,
                            21.300750164777224
                        ],
                        [
                            -157.81532051004598,
                            21.300751398207748
                        ],
                        [
                            -157.815283809742,
                            21.300752515700065
                        ],
                        [
                            -157.81528376663911,
                            21.300751278656211
                        ],
                        [
                            -157.81528188394284,
                            21.30074995910039
                        ],
                        [
                            -157.8152818371355,
                            21.300748582908444
                        ],
                        [
                            -157.81528110240018,
                            21.300748604837509
                        ],
                        [
                            -157.81528115017872,
                            21.300749980132892
                        ],
                        [
                            -157.81527936302507,
                            21.300751412974527
                        ],
                        [
                            -157.81527940612793,
                            21.300752650018396
                        ],
                        [
                            -157.81524270582381,
                            21.300753767501732
                        ],
                        [
                            -157.81524266272126,
                            21.300752530457867
                        ],
                        [
                            -157.81524078002536,
                            21.300751210901606
                        ],
                        [
                            -157.81524073321839,
                            21.300749834709659
                        ],
                        [
                            -157.81523999848307,
                            21.300749856638546
                        ],
                        [
                            -157.81524004625399,
                            21.300751232837282
                        ],
                        [
                            -157.81523825910716,
                            21.300752664775121
                        ],
                        [
                            -157.81523830220968,
                            21.300753901818986
                        ],
                        [
                            -157.81520159708575,
                            21.300755019259391
                        ],
                        [
                            -157.81520155398354,
                            21.30075378221553
                        ],
                        [
                            -157.81519967128804,
                            21.300752462658828
                        ],
                        [
                            -157.81519962256084,
                            21.30075108554998
                        ],
                        [
                            -157.81519888974611,
                            21.300751108395598
                        ],
                        [
                            -157.81519893655272,
                            21.300752484587534
                        ],
                        [
                            -157.81519714940552,
                            21.300753916524904
                        ],
                        [
                            -157.81519719347162,
                            21.300755153575544
                        ],
                        [
                            -157.81516049702293,
                            21.300756271068035
                        ],
                        [
                            -157.81516045489226,
                            21.300755033127636
                        ],
                        [
                            -157.81515857219713,
                            21.300753713570483
                        ],
                        [
                            -157.81515852442701,
                            21.300752337371765
                        ],
                        [
                            -157.81515779064836,
                            21.300752360210421
                        ],
                        [
                            -157.81515783841851,
                            21.300753736409142
                        ],
                        [
                            -157.81515605127817,
                            21.30075516744273
                        ],
                        [
                            -157.8151560934088,
                            21.300756405383133
                        ],
                        [
                            -157.81511939406818,
                            21.300757522846268
                        ],
                        [
                            -157.8151193509739,
                            21.300756284899087
                        ],
                        [
                            -157.81511746827914,
                            21.300754965341493
                        ],
                        [
                            -157.81511742050938,
                            21.300753589142776
                        ],
                        [
                            -157.81511668576681,
                            21.300753611974461
                        ],
                        [
                            -157.81511673450052,
                            21.300754988179964
                        ],
                        [
                            -157.81511494735977,
                            21.300756419213084
                        ],
                        [
                            -157.81511498949732,
                            21.300757656250141
                        ],
                        [
                            -157.8150782901493,
                            21.300758774607612
                        ],
                        [
                            -157.8150782470554,
                            21.300757536660441
                        ],
                        [
                            -157.815076364361,
                            21.300756217102421
                        ],
                        [
                            -157.81507631658437,
                            21.300754841807052
                        ],
                        [
                            -157.81507558185629,
                            21.300754862831869
                        ],
                        [
                            -157.81507563058236,
                            21.3007562399407
                        ],
                        [
                            -157.81507384247729,
                            21.30075767096659
                        ],
                        [
                            -157.81507388557841,
                            21.300758908010426
                        ],
                        [
                            -157.81503718623028,
                            21.300760026358912
                        ],
                        [
                            -157.81503714313669,
                            21.300758788411734
                        ],
                        [
                            -157.81503525947878,
                            21.30075746884647
                        ],
                        [
                            -157.81503521266646,
                            21.300756093557901
                        ],
                        [
                            -157.81503447890228,
                            21.300756114589337
                        ],
                        [
                            -157.8150345266713,
                            21.30075749078804
                        ],
                        [
                            -157.81503273855859,
                            21.30075892271681
                        ],
                        [
                            -157.81503278165212,
                            21.300760160663977
                        ],
                        [
                            -157.81499608231107,
                            21.300761278100129
                        ],
                        [
                            -157.81499603921782,
                            21.300760040152962
                        ],
                        [
                            -157.81499415556752,
                            21.300758719683916
                        ],
                        [
                            -157.8149941087556,
                            21.300757344395347
                        ],
                        [
                            -157.8149933749842,
                            21.300757366329943
                        ],
                        [
                            -157.81499342275279,
                            21.300758742528618
                        ],
                        [
                            -157.81499163464696,
                            21.300760173553595
                        ],
                        [
                            -157.81499167773291,
                            21.3007614124041
                        ],
                        [
                            -157.81495497839168,
                            21.300762529831253
                        ],
                        [
                            -157.81495493530608,
                            21.300761290980756
                        ],
                        [
                            -157.81495305261279,
                            21.300759971421392
                        ],
                        [
                            -157.8149530038734,
                            21.300758596119252
                        ],
                        [
                            -157.81495227106592,
                            21.300758618060456
                        ],
                        [
                            -157.81495231787022,
                            21.30075999425236
                        ],
                        [
                            -157.81495053072791,
                            21.300761425283667
                        ],
                        [
                            -157.81495057381355,
                            21.300762664134162
                        ],
                        [
                            -157.81491387350823,
                            21.300763781545534
                        ],
                        [
                            -157.81491383138689,
                            21.300762542701829
                        ],
                        [
                            -157.814911948694,
                            21.300761223142022
                        ],
                        [
                            -157.81491189995498,
                            21.300759847839892
                        ],
                        [
                            -157.81491116714028,
                            21.300759870684253
                        ],
                        [
                            -157.8149112139514,
                            21.300761245972808
                        ],
                        [
                            -157.81490942680873,
                            21.300762677003643
                        ],
                        [
                            -157.81490946990124,
                            21.300763914950796
                        ],
                        [
                            -157.81487276959578,
                            21.300765032353173
                        ],
                        [
                            -157.81487272650361,
                            21.300763794406027
                        ],
                        [
                            -157.81487084477504,
                            21.300762474852561
                        ],
                        [
                            -157.81487079603639,
                            21.300761099550449
                        ],
                        [
                            -157.81487006226499,
                            21.300761121484491
                        ],
                        [
                            -157.81487011003244,
                            21.300762497683166
                        ],
                        [
                            -157.81486832288937,
                            21.300763928713565
                        ],
                        [
                            -157.81486836598154,
                            21.30076516666071
                        ],
                        [
                            -157.81483166567594,
                            21.300766284054088
                        ],
                        [
                            -157.81483162258408,
                            21.300765046106946
                        ],
                        [
                            -157.81482974085591,
                            21.30076372655304
                        ],
                        [
                            -157.81482969211766,
                            21.300762351250921
                        ],
                        [
                            -157.81482895834623,
                            21.300762373184796
                        ],
                        [
                            -157.81482900612053,
                            21.300763748480129
                        ],
                        [
                            -157.81482721896981,
                            21.300765180413407
                        ],
                        [
                            -157.81482726206167,
                            21.300766418360531
                        ],
                        [
                            -157.81479056175593,
                            21.300767535744921
                        ],
                        [
                            -157.81479051866441,
                            21.300766297797779
                        ],
                        [
                            -157.81478863597266,
                            21.300764978236661
                        ],
                        [
                            -157.81478858916989,
                            21.300763602044785
                        ],
                        [
                            -157.81478816008868,
                            21.300763615283742
                        ],
                        [
                            -157.81478806548301,
                            21.300760867409906
                        ],
                        [
                            -157.81478610810939,
                            21.300760926798546
                        ],
                        [
                            -157.81478868289341,
                            21.30083521619855
                        ],
                        [
                            -157.814790640268,
                            21.300835156809928
                        ],
                        [
                            -157.8147914036366,
                            21.300857167851479
                        ],
                        [
                            -157.81478944722565,
                            21.300857227246901
                        ],
                        [
                            -157.81479202201771,
                            21.300931515742839
                        ],
                        [
                            -157.81479397939356,
                            21.300931456354224
                        ],
                        [
                            -157.81479388388186,
                            21.300928701246931
                        ],
                        [
                            -157.81479449519807,
                            21.30092868296774
                        ],
                        [
                            -157.81479444742411,
                            21.300927307672435
                        ],
                        [
                            -157.81479605137872,
                            21.300925880773097
                        ],
                        [
                            -157.81479600828717,
                            21.300924642825979
                        ],
                        [
                            -157.814832708632,
                            21.30092352544224
                        ],
                        [
                            -157.81483275172386,
                            21.300924763389364
                        ],
                        [
                            -157.81483463441072,
                            21.300926083853437
                        ],
                        [
                            -157.81483468218511,
                            21.300927459148745
                        ],
                        [
                            -157.81483541596455,
                            21.300927436311543
                        ],
                        [
                            -157.81483536915414,
                            21.30092606102302
                        ],
                        [
                            -157.81483715534287,
                            21.300924629082981
                        ],
                        [
                            -157.81483711224377,
                            21.300923392039198
                        ],
                        [
                            -157.8148738135524,
                            21.300922274653271
                        ],
                        [
                            -157.81487385568789,
                            21.300923511690257
                        ],
                        [
                            -157.81487573837512,
                            21.300924832153882
                        ],
                        [
                            -157.81487578614986,
                            21.300926207449201
                        ],
                        [
                            -157.81487651992208,
                            21.300926185515156
                        ],
                        [
                            -157.81487647311855,
                            21.300924809323313
                        ],
                        [
                            -157.81487825930688,
                            21.300923377382816
                        ],
                        [
                            -157.81487821717135,
                            21.300922140345811
                        ],
                        [
                            -157.81491491751589,
                            21.300921022944088
                        ],
                        [
                            -157.81491495965173,
                            21.300922259981096
                        ],
                        [
                            -157.81491684233936,
                            21.300923580444277
                        ],
                        [
                            -157.81491689011449,
                            21.300924955739596
                        ],
                        [
                            -157.81491762485066,
                            21.300924933812166
                        ],
                        [
                            -157.81491757707553,
                            21.300923558516843
                        ],
                        [
                            -157.81491936327072,
                            21.300922125672553
                        ],
                        [
                            -157.81491932113485,
                            21.300920888635545
                        ],
                        [
                            -157.81495602147925,
                            21.300919771224819
                        ],
                        [
                            -157.81495606457935,
                            21.300921008268624
                        ],
                        [
                            -157.81495794631067,
                            21.300922327821237
                        ],
                        [
                            -157.81495799407168,
                            21.300923704923242
                        ],
                        [
                            -157.8149587288151,
                            21.300923682092289
                        ],
                        [
                            -157.81495868007565,
                            21.300922306790174
                        ],
                        [
                            -157.81496046819109,
                            21.30092087486236
                        ],
                        [
                            -157.81496042509818,
                            21.300919636915218
                        ],
                        [
                            -157.81499712447848,
                            21.300918519488711
                        ],
                        [
                            -157.81499716853565,
                            21.300919757442642
                        ],
                        [
                            -157.81499905123127,
                            21.300921077001604
                        ],
                        [
                            -157.81499909803597,
                            21.300922453193472
                        ],
                        [
                            -157.81499983277939,
                            21.300922430362355
                        ],
                        [
                            -157.81499978403954,
                            21.300921055060236
                        ],
                        [
                            -157.81500157215459,
                            21.300919623131943
                        ],
                        [
                            -157.81500152906133,
                            21.300918385184801
                        ],
                        [
                            -157.81503824097265,
                            21.300917267837537
                        ],
                        [
                            -157.81503827249901,
                            21.300918505703237
                        ],
                        [
                            -157.81504015519502,
                            21.300919825261754
                        ],
                        [
                            -157.81504020200009,
                            21.30092120145364
                        ],
                        [
                            -157.81504063011784,
                            21.300921188207258
                        ],
                        [
                            -157.81504106784595,
                            21.300933802607865
                        ],
                        [
                            -157.81503813177838,
                            21.300933892146773
                        ],
                        [
                            -157.81503819758939,
                            21.300935783404526
                        ],
                        [
                            -157.81503311322859,
                            21.300935938217538
                        ],
                        [
                            -157.81503309519383,
                            21.300935422255105
                        ],
                        [
                            -157.81503211650221,
                            21.300935452402459
                        ],
                        [
                            -157.8150308451296,
                            21.30093411366046
                        ],
                        [
                            -157.81502644151021,
                            21.300934247971906
                        ],
                        [
                            -157.81502526664659,
                            21.300935660730648
                        ],
                        [
                            -157.81502428699105,
                            21.300935690871189
                        ],
                        [
                            -157.81502433573107,
                            21.300937066173315
                        ],
                        [
                            -157.81502531345151,
                            21.300937036922534
                        ],
                        [
                            -157.81502658483137,
                            21.300938374761234
                        ],
                        [
                            -157.81502860391376,
                            21.300938313997644
                        ],
                        [
                            -157.81502935075437,
                            21.300959866001008
                        ],
                        [
                            -157.81502733166445,
                            21.300959927667943
                        ],
                        [
                            -157.81502615679338,
                            21.300961341330016
                        ],
                        [
                            -157.81502517810884,
                            21.300961370574001
                        ],
                        [
                            -157.81502522588497,
                            21.300962745869338
                        ],
                        [
                            -157.81502620360558,
                            21.300962716618564
                        ],
                        [
                            -157.81502747498561,
                            21.300964054457264
                        ],
                        [
                            -157.81502949406837,
                            21.300963993693678
                        ],
                        [
                            -157.81503024187302,
                            21.300985545703771
                        ],
                        [
                            -157.81502822181153,
                            21.300985608267236
                        ],
                        [
                            -157.81502704694751,
                            21.300987021025978
                        ],
                        [
                            -157.81502606825555,
                            21.300987051173305
                        ],
                        [
                            -157.81502611603167,
                            21.300988426468614
                        ],
                        [
                            -157.81502709375971,
                            21.300988396314523
                        ],
                        [
                            -157.81502836513272,
                            21.300989735056564
                        ],
                        [
                            -157.81503038422306,
                            21.30098967338963
                        ],
                        [
                            -157.81503113298447,
                            21.301011226309807
                        ],
                        [
                            -157.81502911196594,
                            21.301011287963142
                        ],
                        [
                            -157.81502793709444,
                            21.301012701625218
                        ],
                        [
                            -157.81502695840956,
                            21.3010127308692
                        ],
                        [
                            -157.81502700618569,
                            21.301014106164509
                        ],
                        [
                            -157.81502798487057,
                            21.301014076920545
                        ],
                        [
                            -157.81502925528713,
                            21.301015414752452
                        ],
                        [
                            -157.81503127617532,
                            21.301015369359202
                        ],
                        [
                            -157.81503202313928,
                            21.301036906005631
                        ],
                        [
                            -157.81503000307711,
                            21.301036968569104
                        ],
                        [
                            -157.81502882821266,
                            21.301038381327839
                        ],
                        [
                            -157.81502784856366,
                            21.301038410565006
                        ],
                        [
                            -157.81502789633257,
                            21.301039786763667
                        ],
                        [
                            -157.81502887502486,
                            21.301039756616351
                        ],
                        [
                            -157.81503014543438,
                            21.301041095351618
                        ],
                        [
                            -157.81503216548936,
                            21.301041033691487
                        ],
                        [
                            -157.81503291244613,
                            21.301062571241214
                        ],
                        [
                            -157.81503089239808,
                            21.301062631997986
                        ],
                        [
                            -157.81502971753343,
                            21.301064044756711
                        ],
                        [
                            -157.81502873884097,
                            21.301064074904026
                        ],
                        [
                            -157.81502878661709,
                            21.301065450199328
                        ],
                        [
                            -157.81502976433836,
                            21.301065420948579
                        ],
                        [
                            -157.8150310357193,
                            21.301066758787279
                        ],
                        [
                            -157.81503543933542,
                            21.301066625379235
                        ],
                        [
                            -157.81503661227217,
                            21.301065212606915
                        ],
                        [
                            -157.81503759482038,
                            21.301065182486706
                        ],
                        [
                            -157.81503757665527,
                            21.301064682784382
                        ],
                        [
                            -157.8150426610205,
                            21.301064527971441
                        ],
                        [
                            -157.81504272766509,
                            21.301066435496079
                        ],
                        [
                            -157.81504566373533,
                            21.301066345957231
                        ],
                        [
                            -157.81504609969511,
                            21.301078940470628
                        ],
                        [
                            -157.81504567157688,
                            21.301078953717006
                        ],
                        [
                            -157.81504571934593,
                            21.30108032991566
                        ],
                        [
                            -157.81504393220044,
                            21.301081760947756
                        ],
                        [
                            -157.81504397529403,
                            21.301082998894888
                        ],
                        [
                            -157.81500727490868,
                            21.301084116322915
                        ],
                        [
                            -157.81500723184436,
                            21.301082874762443
                        ],
                        [
                            -157.81500534914667,
                            21.301081555203503
                        ],
                        [
                            -157.81500530233473,
                            21.301080179914976
                        ],
                        [
                            -157.81500456759775,
                            21.301080201842758
                        ],
                        [
                            -157.81500461537365,
                            21.301081577138071
                        ],
                        [
                            -157.81500282822054,
                            21.301083009073043
                        ],
                        [
                            -157.81500287128483,
                            21.301084250633533
                        ],
                        [
                            -157.81496617089931,
                            21.301085368052568
                        ],
                        [
                            -157.81496612783533,
                            21.301084126492086
                        ],
                        [
                            -157.81496424513804,
                            21.301082806932701
                        ],
                        [
                            -157.81496419833368,
                            21.301081430740862
                        ],
                        [
                            -157.81496346358949,
                            21.301081453571783
                        ],
                        [
                            -157.81496351136502,
                            21.301082828867088
                        ],
                        [
                            -157.81496172421876,
                            21.301084259898289
                        ],
                        [
                            -157.81496176727543,
                            21.301085502362088
                        ],
                        [
                            -157.81492506785372,
                            21.301086619778921
                        ],
                        [
                            -157.81492502379717,
                            21.301085381825015
                        ],
                        [
                            -157.8149231411075,
                            21.301084061361848
                        ],
                        [
                            -157.81492309333234,
                            21.301082686066568
                        ],
                        [
                            -157.81492266617806,
                            21.301082699319402
                        ],
                        [
                            -157.8149225696711,
                            21.301079947818675
                        ],
                        [
                            -157.81492061229324,
                            21.3010800072087
                        ],
                        [
                            -157.81492318810595,
                            21.301154296614087
                        ],
                        [
                            -157.81492514549205,
                            21.301154236320745
                        ],
                        [
                            -157.81492590983655,
                            21.301176248272018
                        ],
                        [
                            -157.81492395149345,
                            21.301176307655219
                        ],
                        [
                            -157.81492652730697,
                            21.301250597059877
                        ],
                        [
                            -157.81492848469438,
                            21.301250536766574
                        ],
                        [
                            -157.81492838915131,
                            21.301247785272682
                        ],
                        [
                            -157.81492900143277,
                            21.301247766999857
                        ],
                        [
                            -157.81492895270091,
                            21.30124639079445
                        ],
                        [
                            -157.81493055760734,
                            21.30124496570744
                        ],
                        [
                            -157.81493051452199,
                            21.30124372685701
                        ],
                        [
                            -157.81496721398284,
                            21.301242609440834
                        ],
                        [
                            -157.81496725707572,
                            21.30124384738793
                        ],
                        [
                            -157.81496913976781,
                            21.301245167850688
                        ],
                        [
                            -157.81496918754334,
                            21.301246543145972
                        ],
                        [
                            -157.81496992132443,
                            21.301246520308265
                        ],
                        [
                            -157.8149698735489,
                            21.301245145012977
                        ],
                        [
                            -157.8149716616683,
                            21.30124371308526
                        ],
                        [
                            -157.81497161857533,
                            21.301242475138157
                        ],
                        [
                            -157.81500832960324,
                            21.301241357794435
                        ],
                        [
                            -157.81500836112926,
                            21.301242595660085
                        ],
                        [
                            -157.81501024382172,
                            21.301243916122406
                        ],
                        [
                            -157.8150102925616,
                            21.301245291424483
                        ],
                        [
                            -157.81501102537874,
                            21.301245268579802
                        ],
                        [
                            -157.81501097856673,
                            21.301243893291304
                        ],
                        [
                            -157.8150127657218,
                            21.301242461356352
                        ],
                        [
                            -157.81501272165733,
                            21.301241224305794
                        ],
                        [
                            -157.81504943462022,
                            21.301240106063315
                        ],
                        [
                            -157.81504946518265,
                            21.301241343922189
                        ],
                        [
                            -157.81505134787548,
                            21.301242664384059
                        ],
                        [
                            -157.81505139661573,
                            21.301244039686129
                        ],
                        [
                            -157.8150521294256,
                            21.301244017744622
                        ],
                        [
                            -157.8150520826205,
                            21.301242641552779
                        ],
                        [
                            -157.81505386881122,
                            21.30124120961057
                        ],
                        [
                            -157.81505382667427,
                            21.30123997257358
                        ],
                        [
                            -157.81509052709859,
                            21.301238855137203
                        ],
                        [
                            -157.81509056923585,
                            21.301240092174194
                        ],
                        [
                            -157.81509245192905,
                            21.301241412635626
                        ],
                        [
                            -157.81509249970577,
                            21.301242787930928
                        ],
                        [
                            -157.81509323444351,
                            21.301242766002801
                        ],
                        [
                            -157.81509318666681,
                            21.301241390707499
                        ],
                        [
                            -157.81509497286439,
                            21.301239957861497
                        ],
                        [
                            -157.8150949307271,
                            21.301238720824522
                        ],
                        [
                            -157.8151316311513,
                            21.301237603379146
                        ],
                        [
                            -157.81513167425285,
                            21.301238840422929
                        ],
                        [
                            -157.81513355598972,
                            21.301240159973776
                        ],
                        [
                            -157.81513360375229,
                            21.301241537075761
                        ],
                        [
                            -157.81513433849733,
                            21.301241514244133
                        ],
                        [
                            -157.81513429072024,
                            21.30124013894882
                        ],
                        [
                            -157.81513607787414,
                            21.301238707012491
                        ],
                        [
                            -157.81513603477978,
                            21.301237469065367
                        ],
                        [
                            -157.81517274677108,
                            21.301236351692442
                        ],
                        [
                            -157.81517277829846,
                            21.301237589558124
                        ],
                        [
                            -157.81517466099967,
                            21.301238909115334
                        ],
                        [
                            -157.81517470780597,
                            21.301240285307198
                        ],
                        [
                            -157.81517544255095,
                            21.301240262475375
                        ],
                        [
                            -157.81517539477349,
                            21.301238887180059
                        ],
                        [
                            -157.81517718192697,
                            21.301237455243268
                        ],
                        [
                            -157.8151771388323,
                            21.30123621729614
                        ],
                        [
                            -157.81521383346532,
                            21.301235100695408
                        ],
                        [
                            -157.81521387656755,
                            21.301236337739187
                        ],
                        [
                            -157.81521576023306,
                            21.301237657302739
                        ],
                        [
                            -157.81521580703972,
                            21.30123903349461
                        ],
                        [
                            -157.81521654081354,
                            21.301239011559151
                        ],
                        [
                            -157.81521649304293,
                            21.301237635360515
                        ],
                        [
                            -157.81521828115999,
                            21.301236203430058
                        ],
                        [
                            -157.81521823805772,
                            21.301234966386257
                        ],
                        [
                            -157.81525494330117,
                            21.301233848947831
                        ],
                        [
                            -157.81525498640374,
                            21.301235085991632
                        ],
                        [
                            -157.81525686910567,
                            21.30123640554795
                        ],
                        [
                            -157.81525691687665,
                            21.301237781746618
                        ],
                        [
                            -157.81525765065047,
                            21.301237759810981
                        ],
                        [
                            -157.81525760287948,
                            21.30123638361232
                        ],
                        [
                            -157.81525939003222,
                            21.301234951674619
                        ],
                        [
                            -157.81525934692959,
                            21.301233714630815
                        ],
                        [
                            -157.81529605989164,
                            21.301232596334341
                        ],
                        [
                            -157.81529609045612,
                            21.301233834193265
                        ],
                        [
                            -157.81529797315844,
                            21.30123515374914
                        ],
                        [
                            -157.81529802092982,
                            21.301236529947811
                        ],
                        [
                            -157.81529875470363,
                            21.301236508011996
                        ],
                        [
                            -157.81529870693225,
                            21.301235131813325
                        ],
                        [
                            -157.8153004940846,
                            21.301233699875187
                        ],
                        [
                            -157.81530045194557,
                            21.301232462838165
                        ],
                        [
                            -157.81533715140506,
                            21.301231345341023
                        ],
                        [
                            -157.81533719450834,
                            21.301232582384838
                        ],
                        [
                            -157.81533907721104,
                            21.301233901940272
                        ],
                        [
                            -157.81533912497554,
                            21.301235279042285
                        ],
                        [
                            -157.81533985972055,
                            21.30123525620974
                        ],
                        [
                            -157.81533981098485,
                            21.301233880004276
                        ],
                        [
                            -157.81534159812955,
                            21.301232448968999
                        ],
                        [
                            -157.81534155599743,
                            21.301231211028636
                        ],
                        [
                            -157.81537826799521,
                            21.301230092707378
                        ],
                        [
                            -157.81537829855316,
                            21.301231331469658
                        ],
                        [
                            -157.81538018125622,
                            21.301232651024641
                        ],
                        [
                            -157.81538022902836,
                            21.30123402722333
                        ],
                        [
                            -157.8153809628094,
                            21.301234004383819
                        ],
                        [
                            -157.81538091503725,
                            21.301232628185133
                        ],
                        [
                            -157.8153827031455,
                            21.301231197156202
                        ],
                        [
                            -157.8153826600491,
                            21.301229959209046
                        ],
                        [
                            -157.81541937204676,
                            21.301228840878792
                        ],
                        [
                            -157.81541940260504,
                            21.301230079641076
                        ],
                        [
                            -157.81542128627243,
                            21.301231399202393
                        ],
                        [
                            -157.81542133308827,
                            21.301232774490959
                        ],
                        [
                            -157.81542206686208,
                            21.301232752554629
                        ],
                        [
                            -157.81542201908954,
                            21.301231376355936
                        ],
                        [
                            -157.81542380719739,
                            21.301229945326533
                        ],
                        [
                            -157.8154237640934,
                            21.301228708282707
                        ],
                        [
                            -157.81546047609814,
                            21.301227589040117
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 208,
                "NUMBER": "1175",
                "PROPER_NAME": "MOORE HALL",
                "DISPLAY_NAME": "MOORE HALL (MOORE) - 1175",
                "ADDRESS": "1890 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MOORE HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1175_01.jpg",
                "HEIGHT (ft)": 78.100000000000009,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 359.39551489957393,
                "SHAPE_Area": 2223.5215394891748
            }
        },
        {
            "type": "Feature",
            "id": 210,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8198179216503,
                            21.297541496442896
                        ],
                        [
                            -157.81991093761945,
                            21.297540568642411
                        ],
                        [
                            -157.8199108474856,
                            21.297532539573826
                        ],
                        [
                            -157.81992847024134,
                            21.297532364116794
                        ],
                        [
                            -157.81998232088986,
                            21.297531825651173
                        ],
                        [
                            -157.81998186237914,
                            21.29749145259807
                        ],
                        [
                            -157.82008173075795,
                            21.297490456208653
                        ],
                        [
                            -157.82025503243261,
                            21.297488726034072
                        ],
                        [
                            -157.82025372880091,
                            21.297374029578993
                        ],
                        [
                            -157.82018812940498,
                            21.297374683617484
                        ],
                        [
                            -157.82018773292788,
                            21.297339816262678
                        ],
                        [
                            -157.82018973139554,
                            21.29733979594317
                        ],
                        [
                            -157.82018970034244,
                            21.29733704399597
                        ],
                        [
                            -157.82018744762686,
                            21.297138845860079
                        ],
                        [
                            -157.82016635627613,
                            21.297139057558066
                        ],
                        [
                            -157.82016509378698,
                            21.297028030060638
                        ],
                        [
                            -157.82013425309867,
                            21.29702833782828
                        ],
                        [
                            -157.82013131566248,
                            21.297028366922497
                        ],
                        [
                            -157.82013143984261,
                            21.297039378324886
                        ],
                        [
                            -157.81992289137096,
                            21.297041460210341
                        ],
                        [
                            -157.81992201544224,
                            21.296964383963463
                        ],
                        [
                            -157.81979408415418,
                            21.296965660479611
                        ],
                        [
                            -157.81979634638856,
                            21.29716477470911
                        ],
                        [
                            -157.81963005757353,
                            21.297166433458461
                        ],
                        [
                            -157.81962981737527,
                            21.297145329462165
                        ],
                        [
                            -157.81963801752593,
                            21.29714524784999
                        ],
                        [
                            -157.81963803955904,
                            21.29714719661904
                        ],
                        [
                            -157.81964122185269,
                            21.29714716654059
                        ],
                        [
                            -157.81964117978359,
                            21.297143381037003
                        ],
                        [
                            -157.81958426941901,
                            21.297143948529296
                        ],
                        [
                            -157.81958544646449,
                            21.297247634457623
                        ],
                        [
                            -157.81979726330846,
                            21.29724552171778
                        ],
                        [
                            -157.81979849650665,
                            21.297354024924338
                        ],
                        [
                            -157.81979008810981,
                            21.297354108697128
                        ],
                        [
                            -157.81979094092159,
                            21.297429120527969
                        ],
                        [
                            -157.8197993483588,
                            21.297429036748561
                        ],
                        [
                            -157.81980053653328,
                            21.297533640601415
                        ],
                        [
                            -157.81981783151429,
                            21.297533468277855
                        ],
                        [
                            -157.8198179216503,
                            21.297541496442896
                        ]
                    ],
                    [
                        [
                            -157.82013189236912,
                            21.297337620736045
                        ],
                        [
                            -157.81998013053291,
                            21.297339135037227
                        ],
                        [
                            -157.81997847368868,
                            21.297193240207342
                        ],
                        [
                            -157.82013023441101,
                            21.297191725893924
                        ],
                        [
                            -157.82013189236912,
                            21.297337620736045
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 210,
                "NUMBER": "1107",
                "PROPER_NAME": "BACHMAN HALL",
                "DISPLAY_NAME": "BACHMAN HALL - 1107",
                "ADDRESS": "2444 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BACHMAN HALL AND ANNEXES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1107_01.jpg",
                "HEIGHT (ft)": 28.900000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 342.14351440807059,
                "SHAPE_Area": 2255.8452383970857
            }
        },
        {
            "type": "Feature",
            "id": 211,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81557605847217,
                            21.302219678475247
                        ],
                        [
                            -157.81564652129782,
                            21.302217474200127
                        ],
                        [
                            -157.81564583503931,
                            21.302198215427925
                        ],
                        [
                            -157.8156663858922,
                            21.302197572314878
                        ],
                        [
                            -157.81566540718507,
                            21.302170058117042
                        ],
                        [
                            -157.8156742145417,
                            21.302169784043976
                        ],
                        [
                            -157.8156722551893,
                            21.302114756537783
                        ],
                        [
                            -157.81568987088161,
                            21.302114205686937
                        ],
                        [
                            -157.8156830102327,
                            21.301921609843792
                        ],
                        [
                            -157.81556557274371,
                            21.3019252839592
                        ],
                        [
                            -157.81556665085074,
                            21.301955548775126
                        ],
                        [
                            -157.81554316296527,
                            21.301956283224214
                        ],
                        [
                            -157.81548444372601,
                            21.301958120239259
                        ],
                        [
                            -157.81549276530865,
                            21.302191755606366
                        ],
                        [
                            -157.81549316592552,
                            21.302202991171978
                        ],
                        [
                            -157.81552399365128,
                            21.302202026539689
                        ],
                        [
                            -157.81552359302486,
                            21.302190791877379
                        ],
                        [
                            -157.81555148463374,
                            21.302189919496122
                        ],
                        [
                            -157.8155749725637,
                            21.302189184144282
                        ],
                        [
                            -157.81557605847217,
                            21.302219678475247
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 211,
                "NUMBER": "1251",
                "PROPER_NAME": "DANCE BUILDING",
                "DISPLAY_NAME": "DANCE BUILDING (DB) - 1251",
                "ADDRESS": "1820 EDMONDSON ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "DANCE BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1251_01.jpg",
                "HEIGHT (ft)": 26.100000000000001,
                "LEED STATUS": "Gold",
                "LEED LINK": "https://www.usgbc.org/projects/university-hawaii-dance-building",
                "PV LINK": "https://www.hawaii.edu/sustainability/pv_system/the-dance-building/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2024/04/20190917_091910.jpg",
                "PORTABLE?": null,
                "SHAPE_Length": 109.1469774510433,
                "SHAPE_Area": 592.34451339031307
            }
        },
        {
            "type": "Feature",
            "id": 212,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.81912766145305,
                                21.295726840048822
                            ],
                            [
                                -157.81912476048808,
                                21.295729305828107
                            ],
                            [
                                -157.81912772046448,
                                21.295732364699319
                            ],
                            [
                                -157.81937606486829,
                                21.295521248051411
                            ],
                            [
                                -157.81937310489053,
                                21.295518189184452
                            ],
                            [
                                -157.81937020489042,
                                21.295520655878509
                            ],
                            [
                                -157.81933369365277,
                                21.295482934331098
                            ],
                            [
                                -157.81933659461657,
                                21.295480467644417
                            ],
                            [
                                -157.81933363366934,
                                21.295477409673396
                            ],
                            [
                                -157.81933073271276,
                                21.295479875456692
                            ],
                            [
                                -157.81929422245904,
                                21.295442153908233
                            ],
                            [
                                -157.81929712341545,
                                21.295439688125551
                            ],
                            [
                                -157.81929416344096,
                                21.295436629257324
                            ],
                            [
                                -157.81929126248457,
                                21.295439095039956
                            ],
                            [
                                -157.81925475128702,
                                21.295401373476928
                            ],
                            [
                                -157.81925765224321,
                                21.29539890769491
                            ],
                            [
                                -157.81925469227033,
                                21.29539584882605
                            ],
                            [
                                -157.81925179130693,
                                21.295398315511374
                            ],
                            [
                                -157.8192138001402,
                                21.295359064957434
                            ],
                            [
                                -157.81921670110339,
                                21.295356598272765
                            ],
                            [
                                -157.81921374016829,
                                21.295353539396487
                            ],
                            [
                                -157.81921083920514,
                                21.295356006081111
                            ],
                            [
                                -157.81917432901236,
                                21.295318284508937
                            ],
                            [
                                -157.81917722997531,
                                21.295315817824921
                            ],
                            [
                                -157.81917426999851,
                                21.29531275985811
                            ],
                            [
                                -157.81917136904281,
                                21.295315225638735
                            ],
                            [
                                -157.81913485790614,
                                21.295277504051988
                            ],
                            [
                                -157.8191377588617,
                                21.295275038271985
                            ],
                            [
                                -157.81913479889374,
                                21.2952719794012
                            ],
                            [
                                -157.81913189793821,
                                21.29527444518116
                            ],
                            [
                                -157.81909538778552,
                                21.295236723593369
                            ],
                            [
                                -157.81909828777697,
                                21.295234257807262
                            ],
                            [
                                -157.81909532877452,
                                21.295231198942609
                            ],
                            [
                                -157.81909242781202,
                                21.295233665625261
                            ],
                            [
                                -157.81905591671548,
                                21.29519594402289
                            ],
                            [
                                -157.81905881767781,
                                21.295193477340867
                            ],
                            [
                                -157.81905585674923,
                                21.295190418462052
                            ],
                            [
                                -157.8190529557869,
                                21.295192885144047
                            ],
                            [
                                -157.81901644567432,
                                21.295155163540628
                            ],
                            [
                                -157.81901934663642,
                                21.295152696859265
                            ],
                            [
                                -157.81901638666614,
                                21.295149638889939
                            ],
                            [
                                -157.81901348571128,
                                21.29515210466791
                            ],
                            [
                                -157.81897697465484,
                                21.295114383049921
                            ],
                            [
                                -157.8189798756095,
                                21.29511191727256
                            ],
                            [
                                -157.81897691564086,
                                21.295108859302601
                            ],
                            [
                                -157.81890506718787,
                                21.295169936611892
                            ],
                            [
                                -157.81885243887604,
                                21.295115563490409
                            ],
                            [
                                -157.8187447413074,
                                21.295207116196803
                            ],
                            [
                                -157.81877450825721,
                                21.29523787146201
                            ],
                            [
                                -157.81875028827179,
                                21.295258460509764
                            ],
                            [
                                -157.8187731486511,
                                21.295282079298573
                            ],
                            [
                                -157.81872857142932,
                                21.295319974473898
                            ],
                            [
                                -157.81873153042551,
                                21.295323033344701
                            ],
                            [
                                -157.81873443139554,
                                21.295320566668671
                            ],
                            [
                                -157.81877094243544,
                                21.295358288337852
                            ],
                            [
                                -157.8187680414652,
                                21.295360755014492
                            ],
                            [
                                -157.8187710014341,
                                21.295363812988089
                            ],
                            [
                                -157.81877390239714,
                                21.295361347214737
                            ],
                            [
                                -157.8188104134571,
                                21.295399068876112
                            ],
                            [
                                -157.81880751249386,
                                21.295401534650079
                            ],
                            [
                                -157.81881047245719,
                                21.295404593526378
                            ],
                            [
                                -157.81881337342045,
                                21.295402127752364
                            ],
                            [
                                -157.81884988450042,
                                21.29543984940593
                            ],
                            [
                                -157.81884698353699,
                                21.295442315180559
                            ],
                            [
                                -157.81884994350193,
                                21.295445374056225
                            ],
                            [
                                -157.81885284447262,
                                21.295442907378213
                            ],
                            [
                                -157.81888935556546,
                                21.295480629927315
                            ],
                            [
                                -157.8188864546018,
                                21.2954830957026
                            ],
                            [
                                -157.81888941360447,
                                21.29548615457087
                            ],
                            [
                                -157.81889231457535,
                                21.295483687892194
                            ],
                            [
                                -157.81892882569548,
                                21.295521409530146
                            ],
                            [
                                -157.81892592472437,
                                21.295523876209437
                            ],
                            [
                                -157.81892888566369,
                                21.295526934187265
                            ],
                            [
                                -157.81893178662759,
                                21.295524468411262
                            ],
                            [
                                -157.81896829680383,
                                21.295562190034648
                            ],
                            [
                                -157.81896539583974,
                                21.295564655811262
                            ],
                            [
                                -157.81896835580957,
                                21.295567714685028
                            ],
                            [
                                -157.81897125677366,
                                21.295565248908364
                            ],
                            [
                                -157.81900924792319,
                                21.295604499515576
                            ],
                            [
                                -157.8190063469589,
                                21.295606965292876
                            ],
                            [
                                -157.81900930693038,
                                21.295610024165988
                            ],
                            [
                                -157.81901220790192,
                                21.295607557485305
                            ],
                            [
                                -157.81904871908296,
                                21.295645279099539
                            ],
                            [
                                -157.81904581811119,
                                21.29564774578084
                            ],
                            [
                                -157.81904877904822,
                                21.295650804660077
                            ],
                            [
                                -157.81905168001998,
                                21.295648337978729
                            ],
                            [
                                -157.81908818929327,
                                21.295686059571636
                            ],
                            [
                                -157.8190852883213,
                                21.295688526253596
                            ],
                            [
                                -157.81908824926714,
                                21.295691584228869
                            ],
                            [
                                -157.81909115023194,
                                21.295689118450195
                            ],
                            [
                                -157.81912766145305,
                                21.295726840048822
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81935216979949,
                                21.295594215374649
                            ],
                            [
                                -157.8193771680975,
                                21.295620042516585
                            ],
                            [
                                -157.81939032454002,
                                21.295633635981631
                            ],
                            [
                                -157.81947870044996,
                                21.295558508313146
                            ],
                            [
                                -157.81942738733045,
                                21.295505495154448
                            ],
                            [
                                -157.81933901240006,
                                21.295580621900129
                            ],
                            [
                                -157.81935216979949,
                                21.295594215374649
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 212,
                "NUMBER": "1152",
                "PROPER_NAME": "OTTO KLUM GYMNASIUM",
                "DISPLAY_NAME": "OTTO KLUM GYMNASIUM (KLUM) - 1152",
                "ADDRESS": "1333 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "OTTO KLUM GYMNASIUM",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1152_01.jpg",
                "HEIGHT (ft)": 40.800000000000004,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 265.94206834524942,
                "SHAPE_Area": 2330.4774620309136
            }
        },
        {
            "type": "Feature",
            "id": 214,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81742382821375,
                            21.297207710548523
                        ],
                        [
                            -157.81747326355841,
                            21.297209365102038
                        ],
                        [
                            -157.81750969847548,
                            21.297210585013008
                        ],
                        [
                            -157.817527313141,
                            21.297211174017697
                        ],
                        [
                            -157.8176124095759,
                            21.297214019504981
                        ],
                        [
                            -157.81777213953461,
                            21.297219353191004
                        ],
                        [
                            -157.8178142738457,
                            21.297220762130255
                        ],
                        [
                            -157.81783188658028,
                            21.29722135199297
                        ],
                        [
                            -157.81788542926094,
                            21.297223144585946
                        ],
                        [
                            -157.81791848543497,
                            21.297224250338239
                        ],
                        [
                            -157.81792518857006,
                            21.297048174183509
                        ],
                        [
                            -157.8179501418588,
                            21.297049008010909
                        ],
                        [
                            -157.8179540174178,
                            21.296947214970952
                        ],
                        [
                            -157.81784393412812,
                            21.296943533780919
                        ],
                        [
                            -157.81783639262557,
                            21.297141621478588
                        ],
                        [
                            -157.8178158425257,
                            21.297140932389418
                        ],
                        [
                            -157.81777518369006,
                            21.297139570854721
                        ],
                        [
                            -157.8176154539689,
                            21.297134218205404
                        ],
                        [
                            -157.81753106498255,
                            21.297131391242683
                        ],
                        [
                            -157.81751241820831,
                            21.297130766078769
                        ],
                        [
                            -157.81751953980583,
                            21.296932684496216
                        ],
                        [
                            -157.81743440592274,
                            21.296929841415388
                        ],
                        [
                            -157.81742382821375,
                            21.297207710548523
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 214,
                "NUMBER": "1046",
                "PROPER_NAME": "KRAUSS HALL",
                "DISPLAY_NAME": "KRAUSS HALL (KRAUSS) - 1046",
                "ADDRESS": "2500 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KRAUSS HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1046_01.jpg",
                "HEIGHT (ft)": 17.300000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 213.27407787219789,
                "SHAPE_Area": 871.32407841717134
            }
        },
        {
            "type": "Feature",
            "id": 215,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.81239284462708,
                                21.304156161362325
                            ],
                            [
                                -157.81239066807493,
                                21.304159137119388
                            ],
                            [
                                -157.81249657769686,
                                21.304227202428272
                            ],
                            [
                                -157.81254443177627,
                                21.304163312839055
                            ],
                            [
                                -157.81243712567408,
                                21.304094004579039
                            ],
                            [
                                -157.81239284462708,
                                21.304156161362325
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81234692628911,
                                21.304235514320759
                            ],
                            [
                                -157.81248330733555,
                                21.30432241717158
                            ],
                            [
                                -157.81248746722895,
                                21.304316516688097
                            ],
                            [
                                -157.81249165443222,
                                21.304310576648135
                            ],
                            [
                                -157.81250259535912,
                                21.304295057764232
                            ],
                            [
                                -157.81236697967017,
                                21.304208644547792
                            ],
                            [
                                -157.81234692628911,
                                21.304235514320759
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 215,
                "NUMBER": "1195A",
                "PROPER_NAME": "MAINTENANCE WAREHOUSE ANNEX",
                "DISPLAY_NAME": "MAINTENANCE WAREHOUSE ANNEX - 1195A",
                "ADDRESS": "2002 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PACIFIC BIOSCIENCE RESEARCH CENTER COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1195A_01.jpg",
                "HEIGHT (ft)": 12.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 85.534971464442449,
                "SHAPE_Area": 178.0695267002063
            }
        },
        {
            "type": "Feature",
            "id": 216,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82305706142805,
                            21.298027003896689
                        ],
                        [
                            -157.82314080645978,
                            21.298030773976119
                        ],
                        [
                            -157.82314335354442,
                            21.297981100720278
                        ],
                        [
                            -157.82315340707808,
                            21.297981552252221
                        ],
                        [
                            -157.82315756887414,
                            21.297900391723829
                        ],
                        [
                            -157.82314751341815,
                            21.29789994017889
                        ],
                        [
                            -157.82306376846722,
                            21.297896169202822
                        ],
                        [
                            -157.82305706142805,
                            21.298027003896689
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 216,
                "NUMBER": "1257A",
                "PROPER_NAME": "FROG 1",
                "DISPLAY_NAME": "FROG 1 - 1257A",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "FROG 1",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1257A_01.jpg",
                "HEIGHT (ft)": 18.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": "https://www.hawaii.edu/sustainability/pv_system/frog-buildings/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2019/08/2020-04-27-FROG1-2_drone.jpg",
                "PORTABLE?": null,
                "SHAPE_Length": 48.483340558462103,
                "SHAPE_Area": 135.50756977838253
            }
        },
        {
            "type": "Feature",
            "id": 217,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82285103996873,
                            21.298017704420509
                        ],
                        [
                            -157.82293478402062,
                            21.298021474595277
                        ],
                        [
                            -157.82293733118124,
                            21.297971800442344
                        ],
                        [
                            -157.82294738566972,
                            21.297972252896635
                        ],
                        [
                            -157.82295154661421,
                            21.297891092371717
                        ],
                        [
                            -157.82294149309513,
                            21.297890639924685
                        ],
                        [
                            -157.82285774816015,
                            21.29788686884654
                        ],
                        [
                            -157.82285103996873,
                            21.298017704420509
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 217,
                "NUMBER": "1257B",
                "PROPER_NAME": "FROG 2",
                "DISPLAY_NAME": "FROG 2 - 1257B",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "FROG 2",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1257B_01.jpg",
                "HEIGHT (ft)": 16.699999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": "https://www.hawaii.edu/sustainability/pv_system/frog-buildings/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2019/08/2020-04-27-FROG1-2_drone.jpg",
                "PORTABLE?": null,
                "SHAPE_Length": 48.483348654407138,
                "SHAPE_Area": 135.50678826222904
            }
        },
        {
            "type": "Feature",
            "id": 218,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81685389604067,
                            21.30036061205335
                        ],
                        [
                            -157.81685665472659,
                            21.300360522138543
                        ],
                        [
                            -157.81685643255273,
                            21.300355280914168
                        ],
                        [
                            -157.81685641308479,
                            21.300354822758536
                        ],
                        [
                            -157.81685614294832,
                            21.300348468220399
                        ],
                        [
                            -157.81690556879525,
                            21.30034686257985
                        ],
                        [
                            -157.81690564251028,
                            21.300348853266428
                        ],
                        [
                            -157.81691151376063,
                            21.300348661468682
                        ],
                        [
                            -157.81690768689634,
                            21.300245199110673
                        ],
                        [
                            -157.81680630414678,
                            21.300248492861826
                        ],
                        [
                            -157.81680558137364,
                            21.300228959197138
                        ],
                        [
                            -157.81675039714455,
                            21.300230751975597
                        ],
                        [
                            -157.81674510926564,
                            21.300230924381591
                        ],
                        [
                            -157.81664706472191,
                            21.300234108710512
                        ],
                        [
                            -157.81665012108593,
                            21.300316754253561
                        ],
                        [
                            -157.81669609785101,
                            21.300315259929214
                        ],
                        [
                            -157.81669775262048,
                            21.300359977626997
                        ],
                        [
                            -157.81681743474869,
                            21.300356088990856
                        ],
                        [
                            -157.8168175283808,
                            21.300358601976896
                        ],
                        [
                            -157.81685377792809,
                            21.30035742406282
                        ],
                        [
                            -157.81685389604067,
                            21.30036061205335
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 218,
                "NUMBER": "1258",
                "PROPER_NAME": "EDMONDSON-SNYDER CONNECTOR BUILDING",
                "DISPLAY_NAME": "EDMONDSON-SNYDER CONNECTOR BUILDING - 1258",
                "ADDRESS": "2538 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "EDMONDSON HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1258_01.jpg",
                "HEIGHT (ft)": 68.900000000000006,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 83.880538314953654,
                "SHAPE_Area": 331.49437525698266
            }
        },
        {
            "type": "Feature",
            "id": 220,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81537485025089,
                            21.293503509403852
                        ],
                        [
                            -157.81560973540658,
                            21.293549047177482
                        ],
                        [
                            -157.81562755666187,
                            21.293468199877022
                        ],
                        [
                            -157.81539249298052,
                            21.293422581378007
                        ],
                        [
                            -157.81537485025089,
                            21.293503509403852
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 220,
                "NUMBER": "1115B",
                "PROPER_NAME": "LES MURAKAMI STADIUM BATTING CAGES",
                "DISPLAY_NAME": "LES MURAKAMI STADIUM BATTING CAGES - 1115B",
                "ADDRESS": "LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "LES MURAKAMI STADIUM AND BATTING CAGES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1115B_01.jpg",
                "HEIGHT (ft)": 15.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 68.069632104393477,
                "SHAPE_Area": 227.55495374046887
            }
        },
        {
            "type": "Feature",
            "id": 221,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8168271554778,
                            21.295001540626082
                        ],
                        [
                            -157.81700483772821,
                            21.294850495032538
                        ],
                        [
                            -157.81695747133179,
                            21.294801562413397
                        ],
                        [
                            -157.81696835220438,
                            21.294792312284908
                        ],
                        [
                            -157.8169407234443,
                            21.294763766081424
                        ],
                        [
                            -157.8169298396661,
                            21.294773017994522
                        ],
                        [
                            -157.81684388349851,
                            21.294684219395599
                        ],
                        [
                            -157.81680055219985,
                            21.294721053193566
                        ],
                        [
                            -157.81678322296335,
                            21.294703146325858
                        ],
                        [
                            -157.81682656397183,
                            21.294666303566611
                        ],
                        [
                            -157.81677996925887,
                            21.294618163178754
                        ],
                        [
                            -157.8167908491495,
                            21.294608914861353
                        ],
                        [
                            -157.81676321948655,
                            21.294580369527868
                        ],
                        [
                            -157.81675234152425,
                            21.294589617857081
                        ],
                        [
                            -157.81670574685941,
                            21.294541477450494
                        ],
                        [
                            -157.81666240489682,
                            21.29457832017269
                        ],
                        [
                            -157.8166450747008,
                            21.294560416898609
                        ],
                        [
                            -157.81668841764036,
                            21.294523572380861
                        ],
                        [
                            -157.81660224100372,
                            21.29443453452576
                        ],
                        [
                            -157.81661312284746,
                            21.294425282619741
                        ],
                        [
                            -157.81658549130333,
                            21.29439673995612
                        ],
                        [
                            -157.81657461333742,
                            21.294405989177498
                        ],
                        [
                            -157.81652724823181,
                            21.294357051034716
                        ],
                        [
                            -157.81634956421217,
                            21.29450809612398
                        ],
                        [
                            -157.81636140476422,
                            21.294520329990398
                        ],
                        [
                            -157.81634835080368,
                            21.294531427589064
                        ],
                        [
                            -157.81636183670207,
                            21.294545361462674
                        ],
                        [
                            -157.81636038669185,
                            21.294546594331514
                        ],
                        [
                            -157.81636268883662,
                            21.294548972886552
                        ],
                        [
                            -157.81636413884684,
                            21.294547740017709
                        ],
                        [
                            -157.81638782188196,
                            21.29457220866491
                        ],
                        [
                            -157.81638637090776,
                            21.294573441527188
                        ],
                        [
                            -157.81638887286559,
                            21.294576026556623
                        ],
                        [
                            -157.81639032287586,
                            21.294574793687541
                        ],
                        [
                            -157.81640558320495,
                            21.294590559464037
                        ],
                        [
                            -157.81641718715679,
                            21.294580694730367
                        ],
                        [
                            -157.81646849883725,
                            21.294633709650881
                        ],
                        [
                            -157.81652770362936,
                            21.294694880757476
                        ],
                        [
                            -157.81651504177569,
                            21.294705644161024
                        ],
                        [
                            -157.81653642174655,
                            21.294727734229252
                        ],
                        [
                            -157.81654258574488,
                            21.294722493637153
                        ],
                        [
                            -157.81656067694453,
                            21.294741184608501
                        ],
                        [
                            -157.81656466495568,
                            21.29473779421793
                        ],
                        [
                            -157.81660545167327,
                            21.294779933258539
                        ],
                        [
                            -157.81660146269073,
                            21.294783324546614
                        ],
                        [
                            -157.81661823742337,
                            21.294800656591043
                        ],
                        [
                            -157.8166120734314,
                            21.294805896282501
                        ],
                        [
                            -157.81663345246724,
                            21.294827986332699
                        ],
                        [
                            -157.81664575134633,
                            21.29481753023158
                        ],
                        [
                            -157.81670561500107,
                            21.294879381648347
                        ],
                        [
                            -157.81675626817082,
                            21.294931716121891
                        ],
                        [
                            -157.81674502720358,
                            21.294941271760354
                        ],
                        [
                            -157.81676048645733,
                            21.294957243975052
                        ],
                        [
                            -157.81675903547489,
                            21.294958477743801
                        ],
                        [
                            -157.81676133859631,
                            21.294960856300648
                        ],
                        [
                            -157.8167627886076,
                            21.294959623428458
                        ],
                        [
                            -157.8167864708102,
                            21.294984092017746
                        ],
                        [
                            -157.81678502079882,
                            21.294985324890149
                        ],
                        [
                            -157.81678752277051,
                            21.294987909914184
                        ],
                        [
                            -157.81678897374579,
                            21.294986677048534
                        ],
                        [
                            -157.81680225992073,
                            21.295000403512368
                        ],
                        [
                            -157.8168153138779,
                            21.294989307686095
                        ],
                        [
                            -157.8168271554778,
                            21.295001540626082
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 221,
                "NUMBER": "1254",
                "PROPER_NAME": "CLARENCE T.C. CHING ATHLETICS COMPLEX",
                "DISPLAY_NAME": "CLARENCE T.C. CHING ATHLETICS COMPLEX - 1254",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CLARENCE TC CHING ATHLETICS COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1254_01.jpg",
                "HEIGHT (ft)": 52.300000000000004,
                "LEED STATUS": "Gold",
                "LEED LINK": "https://www.usgbc.org/projects/university-hawaii-athletic-complex",
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 245.51297605013821,
                "SHAPE_Area": 1885.2650215494477
            }
        },
        {
            "type": "Feature",
            "id": 222,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81416250071501,
                            21.295896069734248
                        ],
                        [
                            -157.81422221977724,
                            21.295906284122633
                        ],
                        [
                            -157.81422802075977,
                            21.295876495057225
                        ],
                        [
                            -157.81425402830175,
                            21.295880943184159
                        ],
                        [
                            -157.81425499448605,
                            21.295875978636278
                        ],
                        [
                            -157.81430989748432,
                            21.295885368598455
                        ],
                        [
                            -157.81431508316629,
                            21.295858738866148
                        ],
                        [
                            -157.81427860117992,
                            21.295852499614732
                        ],
                        [
                            -157.81428161222235,
                            21.295837041240869
                        ],
                        [
                            -157.8142631902578,
                            21.295833890525842
                        ],
                        [
                            -157.8142693209814,
                            21.295802409021828
                        ],
                        [
                            -157.81424331441642,
                            21.295797960904618
                        ],
                        [
                            -157.81424915961244,
                            21.295767946301776
                        ],
                        [
                            -157.81418944059601,
                            21.295757732828658
                        ],
                        [
                            -157.81418359538847,
                            21.295787747428907
                        ],
                        [
                            -157.81413350850292,
                            21.295779180922477
                        ],
                        [
                            -157.81413935372009,
                            21.29574916632437
                        ],
                        [
                            -157.81408035766145,
                            21.295739076250825
                        ],
                        [
                            -157.81407451243288,
                            21.295769090846356
                        ],
                        [
                            -157.81403092720805,
                            21.295761635216824
                        ],
                        [
                            -157.81403677243776,
                            21.295731621526514
                        ],
                        [
                            -157.81400932098424,
                            21.295726925601393
                        ],
                        [
                            -157.8140149902793,
                            21.29569781496539
                        ],
                        [
                            -157.81395527131878,
                            21.295687600507801
                        ],
                        [
                            -157.81394960296197,
                            21.295716712954764
                        ],
                        [
                            -157.81392768954683,
                            21.295712964851457
                        ],
                        [
                            -157.81393335887162,
                            21.295683852412203
                        ],
                        [
                            -157.8138782143578,
                            21.295674420879688
                        ],
                        [
                            -157.81388849836438,
                            21.295621613428377
                        ],
                        [
                            -157.81394701303287,
                            21.295631622483256
                        ],
                        [
                            -157.81394936459196,
                            21.295619548987652
                        ],
                        [
                            -157.8140184393767,
                            21.295631362422757
                        ],
                        [
                            -157.81404712792934,
                            21.295670257658678
                        ],
                        [
                            -157.81409993903191,
                            21.295679289658164
                        ],
                        [
                            -157.81414376361903,
                            21.295650895927864
                        ],
                        [
                            -157.81415324123481,
                            21.295602227527809
                        ],
                        [
                            -157.81412294392857,
                            21.295561156452248
                        ],
                        [
                            -157.8140715777815,
                            21.295552371330679
                        ],
                        [
                            -157.81402654487948,
                            21.2955815478986
                        ],
                        [
                            -157.81402644126385,
                            21.295581606792233
                        ],
                        [
                            -157.81395899913812,
                            21.295570071365965
                        ],
                        [
                            -157.81396182323127,
                            21.295555570177697
                        ],
                        [
                            -157.81393449213397,
                            21.295550895867706
                        ],
                        [
                            -157.81393888664246,
                            21.295528328537518
                        ],
                        [
                            -157.81399463274755,
                            21.295537863660222
                        ],
                        [
                            -157.81399937815664,
                            21.295513490214095
                        ],
                        [
                            -157.81403068299622,
                            21.295518844760512
                        ],
                        [
                            -157.81404158124957,
                            21.295462878856402
                        ],
                        [
                            -157.81401027738514,
                            21.295457524319303
                        ],
                        [
                            -157.81401502374504,
                            21.295433151782394
                        ],
                        [
                            -157.8139827562859,
                            21.295427633260893
                        ],
                        [
                            -157.81398574524351,
                            21.295412286757184
                        ],
                        [
                            -157.81398618459312,
                            21.29541003047494
                        ],
                        [
                            -157.81392959622642,
                            21.295400352100781
                        ],
                        [
                            -157.81392915591209,
                            21.295402608376044
                        ],
                        [
                            -157.81392836968772,
                            21.295406648215526
                        ],
                        [
                            -157.81392739448069,
                            21.295411655157221
                        ],
                        [
                            -157.8139261679128,
                            21.295417954885295
                        ],
                        [
                            -157.81390497844504,
                            21.295414330226226
                        ],
                        [
                            -157.81390840483328,
                            21.295396727428667
                        ],
                        [
                            -157.8136996310578,
                            21.295361019433972
                        ],
                        [
                            -157.81369800533577,
                            21.29536936975181
                        ],
                        [
                            -157.81367296246231,
                            21.2953650864353
                        ],
                        [
                            -157.81367146749702,
                            21.295372758325303
                        ],
                        [
                            -157.81363992300558,
                            21.295367363178752
                        ],
                        [
                            -157.8136349121929,
                            21.29539309073035
                        ],
                        [
                            -157.81360312705038,
                            21.29538765322803
                        ],
                        [
                            -157.81359222766841,
                            21.295443619993293
                        ],
                        [
                            -157.81362401379349,
                            21.295449056601637
                        ],
                        [
                            -157.81361939907708,
                            21.295472752510467
                        ],
                        [
                            -157.81367598744541,
                            21.295482430989189
                        ],
                        [
                            -157.81367269178571,
                            21.29549935535297
                        ],
                        [
                            -157.81385103400797,
                            21.295529859510548
                        ],
                        [
                            -157.81384536564573,
                            21.295558971050522
                        ],
                        [
                            -157.81387387018412,
                            21.295563846969717
                        ],
                        [
                            -157.8138724636739,
                            21.295571067790096
                        ],
                        [
                            -157.8138727255141,
                            21.295571112094631
                        ],
                        [
                            -157.81387282562201,
                            21.295571129964515
                        ],
                        [
                            -157.81386983665593,
                            21.295586475561898
                        ],
                        [
                            -157.81386947566446,
                            21.295586414297606
                        ],
                        [
                            -157.81386943144079,
                            21.295586639833413
                        ],
                        [
                            -157.8138275318538,
                            21.295579472469754
                        ],
                        [
                            -157.81380033745742,
                            21.295574820782729
                        ],
                        [
                            -157.81379012078858,
                            21.295627281800702
                        ],
                        [
                            -157.81375888139559,
                            21.295621938510944
                        ],
                        [
                            -157.81375950371083,
                            21.295618744897013
                        ],
                        [
                            -157.81372209960696,
                            21.295612348163012
                        ],
                        [
                            -157.81369307427696,
                            21.295607383628685
                        ],
                        [
                            -157.81368777497903,
                            21.295606477217166
                        ],
                        [
                            -157.81366924270935,
                            21.295701639763426
                        ],
                        [
                            -157.81366799604479,
                            21.295708039623499
                        ],
                        [
                            -157.81368477765051,
                            21.295710909630802
                        ],
                        [
                            -157.81370232069511,
                            21.295713910574367
                        ],
                        [
                            -157.81370356735826,
                            21.295707510713981
                        ],
                        [
                            -157.81372993487128,
                            21.295712021081101
                        ],
                        [
                            -157.81372685936685,
                            21.295727817759975
                        ],
                        [
                            -157.81372649838232,
                            21.295727755592022
                        ],
                        [
                            -157.81371586243066,
                            21.295782369135992
                        ],
                        [
                            -157.81376137388588,
                            21.295790152802152
                        ],
                        [
                            -157.81376014426303,
                            21.295796471478003
                        ],
                        [
                            -157.81379674556493,
                            21.295802732459347
                        ],
                        [
                            -157.81380254663449,
                            21.295772942508702
                        ],
                        [
                            -157.81382590400042,
                            21.295776938396202
                        ],
                        [
                            -157.81382010294982,
                            21.295806726541159
                        ],
                        [
                            -157.81387982194613,
                            21.295816941048386
                        ],
                        [
                            -157.81388562299256,
                            21.295787151997523
                        ],
                        [
                            -157.81393426494498,
                            21.295795471707009
                        ],
                        [
                            -157.81392846390784,
                            21.295825260759962
                        ],
                        [
                            -157.81398818292834,
                            21.295835474326068
                        ],
                        [
                            -157.81399398298294,
                            21.295805686167096
                        ],
                        [
                            -157.81403829117369,
                            21.295813263438042
                        ],
                        [
                            -157.81403249015642,
                            21.295843052495481
                        ],
                        [
                            -157.81405849672117,
                            21.295847500645312
                        ],
                        [
                            -157.81405269570627,
                            21.295877289703455
                        ],
                        [
                            -157.8141124137874,
                            21.295887504123325
                        ],
                        [
                            -157.81411821576205,
                            21.295857714166083
                        ],
                        [
                            -157.81416830266559,
                            21.295866281581532
                        ],
                        [
                            -157.81416250071501,
                            21.295896069734248
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 222,
                "NUMBER": "1211",
                "PROPER_NAME": "FREAR HALL",
                "DISPLAY_NAME": "FREAR HALL - 1211",
                "ADDRESS": "2569 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "FREAR HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1211_01.jpg",
                "HEIGHT (ft)": 114.90000000000001,
                "LEED STATUS": "Silver",
                "LEED LINK": "https://www.usgbc.org/projects/university-hawaii-frear-hall",
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 430.7488002482188,
                "SHAPE_Area": 1820.7799621087186
            }
        },
        {
            "type": "Feature",
            "id": 223,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82014463092088,
                            21.299658455681392
                        ],
                        [
                            -157.82015637131968,
                            21.299658087199962
                        ],
                        [
                            -157.82016576768581,
                            21.299657792623265
                        ],
                        [
                            -157.82016549058639,
                            21.299649998030421
                        ],
                        [
                            -157.8201882414649,
                            21.299649283951645
                        ],
                        [
                            -157.82018851951503,
                            21.299657080357957
                        ],
                        [
                            -157.82019819165134,
                            21.299656776872101
                        ],
                        [
                            -157.8202099320429,
                            21.299656409290243
                        ],
                        [
                            -157.82020983908109,
                            21.299653805065855
                        ],
                        [
                            -157.82021290142114,
                            21.299653713610592
                        ],
                        [
                            -157.82021245945336,
                            21.299641333152884
                        ],
                        [
                            -157.82030161064165,
                            21.299638540597119
                        ],
                        [
                            -157.82030174138711,
                            21.299642208377563
                        ],
                        [
                            -157.82030467648835,
                            21.299642116028672
                        ],
                        [
                            -157.82030483171513,
                            21.299646460620576
                        ],
                        [
                            -157.82031693368754,
                            21.29964608201502
                        ],
                        [
                            -157.82032720171887,
                            21.299645759210687
                        ],
                        [
                            -157.82032691670929,
                            21.299637746845097
                        ],
                        [
                            -157.82034648852459,
                            21.299637134224643
                        ],
                        [
                            -157.82034677449914,
                            21.299645146597022
                        ],
                        [
                            -157.82035704252326,
                            21.299644824694202
                        ],
                        [
                            -157.82036891115987,
                            21.299644452579813
                        ],
                        [
                            -157.82036876140253,
                            21.299640267926435
                        ],
                        [
                            -157.82037340413399,
                            21.299640123405386
                        ],
                        [
                            -157.82037299679325,
                            21.299628717045724
                        ],
                        [
                            -157.82037054669996,
                            21.299628793824304
                        ],
                        [
                            -157.82036889391415,
                            21.299582479837476
                        ],
                        [
                            -157.82037182998536,
                            21.299582386590796
                        ],
                        [
                            -157.82037173387153,
                            21.299579693811932
                        ],
                        [
                            -157.82037742665821,
                            21.29957951419172
                        ],
                        [
                            -157.82037703371901,
                            21.299568477419864
                        ],
                        [
                            -157.82037671458295,
                            21.299559546969721
                        ],
                        [
                            -157.82036808574068,
                            21.299559818029959
                        ],
                        [
                            -157.82036736657744,
                            21.299539652012232
                        ],
                        [
                            -157.82037599541849,
                            21.299539380951973
                        ],
                        [
                            -157.82037568514087,
                            21.299530669184502
                        ],
                        [
                            -157.82037527467233,
                            21.29951917156032
                        ],
                        [
                            -157.82036958092405,
                            21.299519351173814
                        ],
                        [
                            -157.82036948482468,
                            21.29951665658826
                        ],
                        [
                            -157.82036654876921,
                            21.299516748028285
                        ],
                        [
                            -157.82036489694798,
                            21.299470434047699
                        ],
                        [
                            -157.82036734703868,
                            21.29947035726908
                        ],
                        [
                            -157.82036694066215,
                            21.299458950916001
                        ],
                        [
                            -157.82036229889312,
                            21.299459096347253
                        ],
                        [
                            -157.82036214817197,
                            21.29945491168705
                        ],
                        [
                            -157.82035028147848,
                            21.299455283815192
                        ],
                        [
                            -157.82034001346759,
                            21.299455605718215
                        ],
                        [
                            -157.82033977530531,
                            21.299455613082682
                        ],
                        [
                            -157.82034006127969,
                            21.299463625455193
                        ],
                        [
                            -157.82032072667857,
                            21.299464231608123
                        ],
                        [
                            -157.82032044071246,
                            21.299456218332274
                        ],
                        [
                            -157.82031017173759,
                            21.299456540226714
                        ],
                        [
                            -157.82029806977354,
                            21.299456919735849
                        ],
                        [
                            -157.82029822500743,
                            21.299461263424476
                        ],
                        [
                            -157.82029528990259,
                            21.299461356676758
                        ],
                        [
                            -157.82029542064794,
                            21.299465024457266
                        ],
                        [
                            -157.82020611721347,
                            21.299467822270344
                        ],
                        [
                            -157.82020598892944,
                            21.299464208710557
                        ],
                        [
                            -157.82020305383901,
                            21.299464300154529
                        ],
                        [
                            -157.82020289860793,
                            21.299459956465945
                        ],
                        [
                            -157.82019079568701,
                            21.299460335057244
                        ],
                        [
                            -157.82018136076192,
                            21.299460631172284
                        ],
                        [
                            -157.82018164523248,
                            21.299468589330729
                        ],
                        [
                            -157.82016084886934,
                            21.299469241227563
                        ],
                        [
                            -157.82016056291192,
                            21.299461227951845
                        ],
                        [
                            -157.82014960451937,
                            21.299461571201441
                        ],
                        [
                            -157.82013750256232,
                            21.299461949795635
                        ],
                        [
                            -157.82013765682035,
                            21.299466294380789
                        ],
                        [
                            -157.82013472268659,
                            21.299466386733663
                        ],
                        [
                            -157.82013485245682,
                            21.299470055410708
                        ],
                        [
                            -157.82004586818181,
                            21.299472842728576
                        ],
                        [
                            -157.82004573893781,
                            21.299469229162092
                        ],
                        [
                            -157.82004280481124,
                            21.299469320610037
                        ],
                        [
                            -157.82004264862817,
                            21.299464976011407
                        ],
                        [
                            -157.82003054665654,
                            21.299465356404578
                        ],
                        [
                            -157.82002013787576,
                            21.299465681817946
                        ],
                        [
                            -157.8200204213737,
                            21.299473639969502
                        ],
                        [
                            -157.82000084957355,
                            21.299474253456324
                        ],
                        [
                            -157.82000055724041,
                            21.299466073912058
                        ],
                        [
                            -157.81999014748845,
                            21.299466400220147
                        ],
                        [
                            -157.81997828080171,
                            21.299466771418626
                        ],
                        [
                            -157.8199784295841,
                            21.299470956065136
                        ],
                        [
                            -157.81997378684375,
                            21.299471102382213
                        ],
                        [
                            -157.81997419318986,
                            21.299482508734823
                        ],
                        [
                            -157.81997676092314,
                            21.29948242736647
                        ],
                        [
                            -157.81997842306916,
                            21.299529002498399
                        ],
                        [
                            -157.81997532598706,
                            21.299529099126215
                        ],
                        [
                            -157.81997542207924,
                            21.299531793711658
                        ],
                        [
                            -157.81996972738122,
                            21.299531971498133
                        ],
                        [
                            -157.81997012220342,
                            21.299543010089774
                        ],
                        [
                            -157.8199704403149,
                            21.299551945049512
                        ],
                        [
                            -157.81997920221451,
                            21.299551670425707
                        ],
                        [
                            -157.819979857352,
                            21.29957188026021
                        ],
                        [
                            -157.81997116101994,
                            21.299572152633569
                        ],
                        [
                            -157.81997148008821,
                            21.299581088503377
                        ],
                        [
                            -157.81997187394654,
                            21.299592127088204
                        ],
                        [
                            -157.81997756769019,
                            21.299591948391662
                        ],
                        [
                            -157.81997766282566,
                            21.299594642066992
                        ],
                        [
                            -157.81998066637922,
                            21.299594548396943
                        ],
                        [
                            -157.81998232756916,
                            21.29964112261823
                        ],
                        [
                            -157.81997976080427,
                            21.299641203089958
                        ],
                        [
                            -157.81998016715065,
                            21.299652609442372
                        ],
                        [
                            -157.81998480988227,
                            21.299652464932077
                        ],
                        [
                            -157.8199849596287,
                            21.29965664958527
                        ],
                        [
                            -157.81999692083903,
                            21.29965627362936
                        ],
                        [
                            -157.8200074520883,
                            21.299655944559731
                        ],
                        [
                            -157.82000716071892,
                            21.29964776502236
                        ],
                        [
                            -157.82002648858875,
                            21.299647159762674
                        ],
                        [
                            -157.820026773058,
                            21.299655117017519
                        ],
                        [
                            -157.82003730430719,
                            21.299654787946004
                        ],
                        [
                            -157.82004940628718,
                            21.299654408456412
                        ],
                        [
                            -157.82004925203185,
                            21.299650063871404
                        ],
                        [
                            -157.82005218616922,
                            21.299649971520175
                        ],
                        [
                            -157.82005205788909,
                            21.299646357960516
                        ],
                        [
                            -157.82014103552126,
                            21.299643570596967
                        ],
                        [
                            -157.82014147555523,
                            21.299655951041085
                        ],
                        [
                            -157.82014453796023,
                            21.299655851457004
                        ],
                        [
                            -157.82014463092088,
                            21.299658455681392
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 223,
                "NUMBER": "1015",
                "PROPER_NAME": "GARTLEY HALL",
                "DISPLAY_NAME": "GARTLEY HALL (GAR) - 1015",
                "ADDRESS": "2430 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "GARTLEY HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1015_01.jpg",
                "HEIGHT (ft)": 36,
                "LEED STATUS": "Gold",
                "LEED LINK": "https://www.usgbc.org/projects/university-hawaii-gartley-hall",
                "PV LINK": "https://www.hawaii.edu/sustainability/pv-system/gartley-hall/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2019/08/Gartley_Hall_snapshot_11-12-19_14_33-e1598481423165.jpg",
                "PORTABLE?": null,
                "SHAPE_Length": 151.14604919081941,
                "SHAPE_Area": 815.88970434804219
            }
        },
        {
            "type": "Feature",
            "id": 224,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.814823684999,
                            21.296101740106824
                        ],
                        [
                            -157.81491073141237,
                            21.296045948067242
                        ],
                        [
                            -157.81491375872548,
                            21.296050096068416
                        ],
                        [
                            -157.81491335660527,
                            21.296050355220171
                        ],
                        [
                            -157.81491624470939,
                            21.296054312529222
                        ],
                        [
                            -157.81515172229777,
                            21.295903384170387
                        ],
                        [
                            -157.8151390133022,
                            21.295885968584862
                        ],
                        [
                            -157.81514657971971,
                            21.295881118248285
                        ],
                        [
                            -157.8151484132776,
                            21.295883629932884
                        ],
                        [
                            -157.81517053599347,
                            21.295869450672487
                        ],
                        [
                            -157.81514522860238,
                            21.295834772051446
                        ],
                        [
                            -157.81515808636499,
                            21.295826530597697
                        ],
                        [
                            -157.81513646515779,
                            21.295796902580364
                        ],
                        [
                            -157.81512327409112,
                            21.295805356693027
                        ],
                        [
                            -157.81512225122071,
                            21.295803927556239
                        ],
                        [
                            -157.81502418742514,
                            21.295786672622597
                        ],
                        [
                            -157.81500938524781,
                            21.295766668532998
                        ],
                        [
                            -157.81495999975198,
                            21.295758983497461
                        ],
                        [
                            -157.81495513289121,
                            21.295751508910637
                        ],
                        [
                            -157.81465908938839,
                            21.295699940197668
                        ],
                        [
                            -157.81465882527806,
                            21.295701260900657
                        ],
                        [
                            -157.81458873720507,
                            21.295745955763149
                        ],
                        [
                            -157.81456829270874,
                            21.295717941288931
                        ],
                        [
                            -157.81451555146862,
                            21.295751878767444
                        ],
                        [
                            -157.8145306812539,
                            21.295772612434174
                        ],
                        [
                            -157.81453242533956,
                            21.295771494577355
                        ],
                        [
                            -157.81453809185606,
                            21.295779260278955
                        ],
                        [
                            -157.81452445116167,
                            21.295788003874897
                        ],
                        [
                            -157.81452398490637,
                            21.295787365507774
                        ],
                        [
                            -157.81451976227922,
                            21.295790072134697
                        ],
                        [
                            -157.81468200642055,
                            21.296012396283608
                        ],
                        [
                            -157.81468623001544,
                            21.29600968965963
                        ],
                        [
                            -157.81468544051572,
                            21.296008609968982
                        ],
                        [
                            -157.8146988758028,
                            21.295999998615802
                        ],
                        [
                            -157.81470354021852,
                            21.296006392232929
                        ],
                        [
                            -157.81470123801836,
                            21.296007868420414
                        ],
                        [
                            -157.81471636882603,
                            21.296028601175717
                        ],
                        [
                            -157.81475302857484,
                            21.296005103794382
                        ],
                        [
                            -157.81477096128128,
                            21.296029725495394
                        ],
                        [
                            -157.81473439164992,
                            21.296053163891322
                        ],
                        [
                            -157.81475640374305,
                            21.296083326807093
                        ],
                        [
                            -157.81478393124567,
                            21.296065685024686
                        ],
                        [
                            -157.81480928339678,
                            21.29610042544309
                        ],
                        [
                            -157.81481844179365,
                            21.296094555564466
                        ],
                        [
                            -157.814823684999,
                            21.296101740106824
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 224,
                "NUMBER": "1161",
                "PROPER_NAME": "GATEWAY HOUSE",
                "DISPLAY_NAME": "GATEWAY HOUSE - 1161",
                "ADDRESS": "2563 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "GATEWAY HOUSE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1161_01.jpg",
                "HEIGHT (ft)": 100.8,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 199.2121230169397,
                "SHAPE_Area": 1763.816887320527
            }
        },
        {
            "type": "Feature",
            "id": 225,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81330052434984,
                            21.294920096329395
                        ],
                        [
                            -157.81331234885346,
                            21.294922892575194
                        ],
                        [
                            -157.8133309397229,
                            21.294924558504022
                        ],
                        [
                            -157.81333101108379,
                            21.294923714337699
                        ],
                        [
                            -157.81333123071059,
                            21.294922892898029
                        ],
                        [
                            -157.81333159263866,
                            21.294922116727694
                        ],
                        [
                            -157.8133320851272,
                            21.294921407425285
                        ],
                        [
                            -157.81333269646447,
                            21.294920782976039
                        ],
                        [
                            -157.81333340914807,
                            21.294920262227702
                        ],
                        [
                            -157.8133342037913,
                            21.29491985859449
                        ],
                        [
                            -157.81333505812304,
                            21.29491958456682
                        ],
                        [
                            -157.81333507008807,
                            21.294919655115574
                        ],
                        [
                            -157.81333513121857,
                            21.294919845258402
                        ],
                        [
                            -157.81333522522306,
                            21.29492002298554
                        ],
                        [
                            -157.81333535021719,
                            21.294920182863361
                        ],
                        [
                            -157.81333550431674,
                            21.294920319458257
                        ],
                        [
                            -157.8133356808107,
                            21.294920428205948
                        ],
                        [
                            -157.81333587392288,
                            21.294920508162328
                        ],
                        [
                            -157.81333607983404,
                            21.294920554783506
                        ],
                        [
                            -157.81333629181134,
                            21.294920566215257
                        ],
                        [
                            -157.81333650115801,
                            21.294920545106439
                        ],
                        [
                            -157.8133367050041,
                            21.294920488726632
                        ],
                        [
                            -157.81333689465279,
                            21.294920399724706
                        ],
                        [
                            -157.81333706429169,
                            21.294920281673232
                        ],
                        [
                            -157.81333721003625,
                            21.294920138158378
                        ],
                        [
                            -157.81333732799462,
                            21.294919973669678
                        ],
                        [
                            -157.81333741236162,
                            21.294919790876349
                        ],
                        [
                            -157.81333746113702,
                            21.294919598798206
                        ],
                        [
                            -157.8133374713488,
                            21.294919527502394
                        ],
                        [
                            -157.81333833894828,
                            21.294919762176683
                        ],
                        [
                            -157.81333915440987,
                            21.294920127474917
                        ],
                        [
                            -157.8133398937087,
                            21.294920614193792
                        ],
                        [
                            -157.81334053768282,
                            21.294921207744018
                        ],
                        [
                            -157.81334106812704,
                            21.294921894446368
                        ],
                        [
                            -157.81334146979307,
                            21.294922652511993
                        ],
                        [
                            -157.81334173416531,
                            21.294923462006299
                        ],
                        [
                            -157.81334181066586,
                            21.294924019033736
                        ],
                        [
                            -157.81334185080766,
                            21.294924302077725
                        ],
                        [
                            -157.81335789126854,
                            21.294922099775754
                        ],
                        [
                            -157.81336032889001,
                            21.29492176554233
                        ],
                        [
                            -157.81336307863441,
                            21.294920975490719
                        ],
                        [
                            -157.81337472494454,
                            21.294917630135611
                        ],
                        [
                            -157.8133748012736,
                            21.29491760808898
                        ],
                        [
                            -157.81337818482714,
                            21.294916636407123
                        ],
                        [
                            -157.81337790596004,
                            21.294915831327618
                        ],
                        [
                            -157.8133777738806,
                            21.294914992954158
                        ],
                        [
                            -157.81337779031364,
                            21.294914146593776
                        ],
                        [
                            -157.81337795604901,
                            21.294913313933428
                        ],
                        [
                            -157.81337826704259,
                            21.294912518432731
                        ],
                        [
                            -157.81337871251031,
                            21.294911782600376
                        ],
                        [
                            -157.81337928170421,
                            21.294911124428406
                        ],
                        [
                            -157.81337995904249,
                            21.294910563681555
                        ],
                        [
                            -157.8133799933222,
                            21.294910616319839
                        ],
                        [
                            -157.81338011744674,
                            21.294910764447419
                        ],
                        [
                            -157.81338026487884,
                            21.294910891057985
                        ],
                        [
                            -157.81338043371963,
                            21.294910992524546
                        ],
                        [
                            -157.81338061723642,
                            21.294911066992899
                        ],
                        [
                            -157.81338081158805,
                            21.294911112629144
                        ],
                        [
                            -157.8133810119696,
                            21.294911127592645
                        ],
                        [
                            -157.81338121164103,
                            21.294911110932514
                        ],
                        [
                            -157.81338140673952,
                            21.294911063524886
                        ],
                        [
                            -157.81338158953216,
                            21.294910988025407
                        ],
                        [
                            -157.81338175616332,
                            21.294910884406914
                        ],
                        [
                            -157.81338190467625,
                            21.294910756269172
                        ],
                        [
                            -157.81338202636687,
                            21.294910607164372
                        ],
                        [
                            -157.81338212119167,
                            21.294910442512535
                        ],
                        [
                            -157.81338218528782,
                            21.294910263189838
                        ],
                        [
                            -157.81338221761888,
                            21.294910078222877
                        ],
                        [
                            -157.81338221623537,
                            21.294909890308048
                        ],
                        [
                            -157.81338218302159,
                            21.294909704878986
                        ],
                        [
                            -157.81338216517884,
                            21.294909646032863
                        ],
                        [
                            -157.81338306240676,
                            21.294909552081915
                        ],
                        [
                            -157.81338396526527,
                            21.294909597292691
                        ],
                        [
                            -157.81338484676536,
                            21.29490978147491
                        ],
                        [
                            -157.81338568381702,
                            21.294910099045453
                        ],
                        [
                            -157.81338645430867,
                            21.294910542621327
                        ],
                        [
                            -157.81338713617217,
                            21.294911099399506
                        ],
                        [
                            -157.81338770929631,
                            21.294911752977185
                        ],
                        [
                            -157.81338816032422,
                            21.294912486095782
                        ],
                        [
                            -157.81340419630811,
                            21.294903515561462
                        ],
                        [
                            -157.813418599437,
                            21.294892373509526
                        ],
                        [
                            -157.81341801274579,
                            21.294891728870219
                        ],
                        [
                            -157.81341754816521,
                            21.294891002883265
                        ],
                        [
                            -157.8134172190376,
                            21.294890214613904
                        ],
                        [
                            -157.81341703192891,
                            21.294889386693203
                        ],
                        [
                            -157.81341699341965,
                            21.2948885399455
                        ],
                        [
                            -157.81341710427071,
                            21.294887699671069
                        ],
                        [
                            -157.81341736141641,
                            21.294886887529636
                        ],
                        [
                            -157.81341775792092,
                            21.294886126960474
                        ],
                        [
                            -157.8134178106524,
                            21.294886162564421
                        ],
                        [
                            -157.813417986313,
                            21.294886255045128
                        ],
                        [
                            -157.81341817473626,
                            21.294886318707331
                        ],
                        [
                            -157.81341837206656,
                            21.294886353523875
                        ],
                        [
                            -157.81341857254958,
                            21.294886355840593
                        ],
                        [
                            -157.81341877038022,
                            21.294886328326751
                        ],
                        [
                            -157.81341896171008,
                            21.294886270051826
                        ],
                        [
                            -157.81341913977019,
                            21.294886183678273
                        ],
                        [
                            -157.81341929973377,
                            21.294886070075464
                        ],
                        [
                            -157.81341943770906,
                            21.294885933732889
                        ],
                        [
                            -157.81341955077531,
                            21.294885778243522
                        ],
                        [
                            -157.81341963408406,
                            21.294885607186764
                        ],
                        [
                            -157.8134196866279,
                            21.294885425975817
                        ],
                        [
                            -157.81341970547891,
                            21.294885239107018
                        ],
                        [
                            -157.81341969252858,
                            21.294885051110651
                        ],
                        [
                            -157.81341964676236,
                            21.294884868303281
                        ],
                        [
                            -157.81341956910777,
                            21.294884695208403
                        ],
                        [
                            -157.81341946145642,
                            21.294884536356289
                        ],
                        [
                            -157.81341942135708,
                            21.294884488193944
                        ],
                        [
                            -157.81342021219507,
                            21.294884078209744
                        ],
                        [
                            -157.81342106466391,
                            21.294883796037983
                        ],
                        [
                            -157.81342195458654,
                            21.294883651445481
                        ],
                        [
                            -157.8134228578582,
                            21.294883645165733
                        ],
                        [
                            -157.81342375037431,
                            21.294883777932196
                        ],
                        [
                            -157.81342460709538,
                            21.294884046858151
                        ],
                        [
                            -157.81342540397472,
                            21.294884445450386
                        ],
                        [
                            -157.81342612086482,
                            21.294884961822795
                        ],
                        [
                            -157.81343078921341,
                            21.294879084756598
                        ],
                        [
                            -157.81343727367215,
                            21.294870922269329
                        ],
                        [
                            -157.81343916572382,
                            21.294867582224427
                        ],
                        [
                            -157.81344525942148,
                            21.294856822446608
                        ],
                        [
                            -157.81344527604696,
                            21.294856792751947
                        ],
                        [
                            -157.81344602895535,
                            21.294855463752821
                        ],
                        [
                            -157.81344522426343,
                            21.294855077753059
                        ],
                        [
                            -157.81344449859685,
                            21.294854573966337
                        ],
                        [
                            -157.81344387211044,
                            21.294853963375388
                        ],
                        [
                            -157.81344336103083,
                            21.294853265969181
                        ],
                        [
                            -157.81344298064994,
                            21.294852498116519
                        ],
                        [
                            -157.81344273947602,
                            21.294851680655388
                        ],
                        [
                            -157.81344264598107,
                            21.294850838940395
                        ],
                        [
                            -157.81344270096227,
                            21.294849993755133
                        ],
                        [
                            -157.81344276542725,
                            21.294850008663804
                        ],
                        [
                            -157.81344296479409,
                            21.294850029943813
                        ],
                        [
                            -157.81344316440018,
                            21.294850021413644
                        ],
                        [
                            -157.81344336135388,
                            21.294849983052913
                        ],
                        [
                            -157.81344354795846,
                            21.294849913000586
                        ],
                        [
                            -157.81344371935825,
                            21.294849815739372
                        ],
                        [
                            -157.81344387167587,
                            21.294849693952123
                        ],
                        [
                            -157.81344400103404,
                            21.294849550321654
                        ],
                        [
                            -157.81344410258424,
                            21.294849388427373
                        ],
                        [
                            -157.81344417531906,
                            21.29484921368249
                        ],
                        [
                            -157.81344421536124,
                            21.29484902876985
                        ],
                        [
                            -157.81344422265272,
                            21.294848840916174
                        ],
                        [
                            -157.81344419715722,
                            21.294848654638155
                        ],
                        [
                            -157.81344413883858,
                            21.294848474452458
                        ],
                        [
                            -157.81344404957375,
                            21.294848306696089
                        ],
                        [
                            -157.81344393223995,
                            21.29484815319606
                        ],
                        [
                            -157.81344378967086,
                            21.294848021199506
                        ],
                        [
                            -157.81344362667144,
                            21.294847912547059
                        ],
                        [
                            -157.81344356906973,
                            21.294847883232524
                        ],
                        [
                            -157.81344413347986,
                            21.294847220509649
                        ],
                        [
                            -157.8134448050705,
                            21.294846655205028
                        ],
                        [
                            -157.81344556734661,
                            21.294846200753263
                        ],
                        [
                            -157.81344606535509,
                            21.294846004614808
                        ],
                        [
                            -157.81344639995044,
                            21.294845871465046
                        ],
                        [
                            -157.81344727872656,
                            21.294845674397237
                        ],
                        [
                            -157.81344817952686,
                            21.294845615703302
                        ],
                        [
                            -157.81344908015998,
                            21.294845697937014
                        ],
                        [
                            -157.81344995173808,
                            21.29484591728113
                        ],
                        [
                            -157.81345134867206,
                            21.294840731733963
                        ],
                        [
                            -157.81345264626549,
                            21.294835913166118
                        ],
                        [
                            -157.81345337252989,
                            21.294833219860507
                        ],
                        [
                            -157.8134545230657,
                            21.294828948613592
                        ],
                        [
                            -157.81345534231681,
                            21.29482091512293
                        ],
                        [
                            -157.81345543230992,
                            21.294820031338709
                        ],
                        [
                            -157.81345629969204,
                            21.294811525714461
                        ],
                        [
                            -157.81345539894312,
                            21.29481145793423
                        ],
                        [
                            -157.81345452340813,
                            21.294811251209687
                        ],
                        [
                            -157.81345369422752,
                            21.294810913820413
                        ],
                        [
                            -157.81345293738295,
                            21.294810451369877
                        ],
                        [
                            -157.81345227202908,
                            21.294809879350716
                        ],
                        [
                            -157.81345171637844,
                            21.294809210538808
                        ],
                        [
                            -157.81345159658798,
                            21.294809002818088
                        ],
                        [
                            -157.81345128568651,
                            21.294808465819649
                        ],
                        [
                            -157.8134509923245,
                            21.294807665155041
                        ],
                        [
                            -157.81345106760983,
                            21.294807653038287
                        ],
                        [
                            -157.81345127144846,
                            21.294807597561686
                        ],
                        [
                            -157.81345146013305,
                            21.294807508552825
                        ],
                        [
                            -157.81345163073564,
                            21.294807390508019
                        ],
                        [
                            -157.81345177647998,
                            21.294807246993052
                        ],
                        [
                            -157.81345189347419,
                            21.294807082497453
                        ],
                        [
                            -157.81345197880489,
                            21.294806899710863
                        ],
                        [
                            -157.81345202758007,
                            21.294806707632659
                        ],
                        [
                            -157.81345204073469,
                            21.294806509883024
                        ],
                        [
                            -157.81345201726123,
                            21.294806311875181
                        ],
                        [
                            -157.8134519570873,
                            21.294806122642523
                        ],
                        [
                            -157.81345186308999,
                            21.294805944012104
                        ],
                        [
                            -157.81345173712464,
                            21.294805785030903
                        ],
                        [
                            -157.81345158399625,
                            21.29480564753959
                        ],
                        [
                            -157.8134514075096,
                            21.294805537888688
                        ],
                        [
                            -157.81345121341906,
                            21.294805459732327
                        ],
                        [
                            -157.81345100751531,
                            21.294805412207939
                        ],
                        [
                            -157.81345093143284,
                            21.294805403541087
                        ],
                        [
                            -157.81345096209662,
                            21.294805306191165
                        ],
                        [
                            -157.81345118280205,
                            21.294804590455495
                        ],
                        [
                            -157.81345157161675,
                            21.294803827121861
                        ],
                        [
                            -157.81345209097015,
                            21.294803133366049
                        ],
                        [
                            -157.81345272527312,
                            21.294802529856177
                        ],
                        [
                            -157.81345329905292,
                            21.294802140926407
                        ],
                        [
                            -157.81345345703787,
                            21.294802033633328
                        ],
                        [
                            -157.8134542659283,
                            21.294801656298251
                        ],
                        [
                            -157.81345512968059,
                            21.294801409438023
                        ],
                        [
                            -157.81345590063754,
                            21.29480131459653
                        ],
                        [
                            -157.81345602607442,
                            21.294801299219774
                        ],
                        [
                            -157.81345332045038,
                            21.294783982038695
                        ],
                        [
                            -157.81345241343456,
                            21.294781212175355
                        ],
                        [
                            -157.8134478464971,
                            21.294767248806878
                        ],
                        [
                            -157.81344698746292,
                            21.294767508347785
                        ],
                        [
                            -157.81344609384502,
                            21.294767633039811
                        ],
                        [
                            -157.81344519075532,
                            21.294767616736248
                        ],
                        [
                            -157.8134443022694,
                            21.29476746231699
                        ],
                        [
                            -157.81344345343419,
                            21.294767171765375
                        ],
                        [
                            -157.81344266731051,
                            21.294766754277894
                        ],
                        [
                            -157.81344196598096,
                            21.294766220850853
                        ],
                        [
                            -157.81344136667974,
                            21.294765586060027
                        ],
                        [
                            -157.81344142285391,
                            21.294765553030594
                        ],
                        [
                            -157.81344157994744,
                            21.294765436697336
                        ],
                        [
                            -157.81344171504534,
                            21.294765298527675
                        ],
                        [
                            -157.81344182427767,
                            21.294765140301099
                        ],
                        [
                            -157.81344190470912,
                            21.294764967417262
                        ],
                        [
                            -157.81344195340455,
                            21.294764785275788
                        ],
                        [
                            -157.81344196839993,
                            21.294764598379803
                        ],
                        [
                            -157.81344195158675,
                            21.294764411259607
                        ],
                        [
                            -157.81344190099378,
                            21.29476422932159
                        ],
                        [
                            -157.81344182044032,
                            21.294764057109674
                        ],
                        [
                            -157.81344170891893,
                            21.294763900037065
                        ],
                        [
                            -157.81344157314069,
                            21.29476376266804
                        ],
                        [
                            -157.8134414140477,
                            21.29476364771941
                        ],
                        [
                            -157.81344123643046,
                            21.29476355883849
                        ],
                        [
                            -157.81344104701446,
                            21.294763498782874
                        ],
                        [
                            -157.81344084964806,
                            21.294763468483069
                        ],
                        [
                            -157.81344064913617,
                            21.294763469779731
                        ],
                        [
                            -157.8134404512767,
                            21.294763500906974
                        ],
                        [
                            -157.81344038751465,
                            21.294763518525286
                        ],
                        [
                            -157.81344028630858,
                            21.294762676755923
                        ],
                        [
                            -157.81344033550639,
                            21.294761831529868
                        ],
                        [
                            -157.81344053204231,
                            21.294761004506899
                        ],
                        [
                            -157.81344087187233,
                            21.2947602191466
                        ],
                        [
                            -157.81344134517613,
                            21.294759497964506
                        ],
                        [
                            -157.81344193830702,
                            21.2947588598356
                        ],
                        [
                            -157.81344263570489,
                            21.294758321814594
                        ],
                        [
                            -157.81344341893973,
                            21.294757898225814
                        ],
                        [
                            -157.81343971253213,
                            21.294751655872361
                        ],
                        [
                            -157.81343797204548,
                            21.294748722943609
                        ],
                        [
                            -157.81343188241971,
                            21.294740360698075
                        ],
                        [
                            -157.81343165741299,
                            21.294740051055964
                        ],
                        [
                            -157.81343162872091,
                            21.294740022848611
                        ],
                        [
                            -157.81343185841186,
                            21.294739628783084
                        ],
                        [
                            -157.81343188675635,
                            21.294739580199852
                        ],
                        [
                            -157.81343220345926,
                            21.294739034074841
                        ],
                        [
                            -157.8134325042046,
                            21.294738194235645
                        ],
                        [
                            -157.81343280987812,
                            21.294737340880328
                        ],
                        [
                            -157.81343309395058,
                            21.294735575852435
                        ],
                        [
                            -157.81343304561713,
                            21.294733791316837
                        ],
                        [
                            -157.81343266829836,
                            21.294732041501028
                        ],
                        [
                            -157.81343197217657,
                            21.294730378873414
                        ],
                        [
                            -157.81343097803693,
                            21.294728855977116
                        ],
                        [
                            -157.81343088725001,
                            21.294728757771008
                        ],
                        [
                            -157.81342971733997,
                            21.29472751639663
                        ],
                        [
                            -157.81342822829342,
                            21.294726403763978
                        ],
                        [
                            -157.81342655497539,
                            21.294725550911952
                        ],
                        [
                            -157.81342474924776,
                            21.294724981694273
                        ],
                        [
                            -157.81342286493626,
                            21.294724715461584
                        ],
                        [
                            -157.81342095980932,
                            21.294724760751606
                        ],
                        [
                            -157.81341909268625,
                            21.294725115268829
                        ],
                        [
                            -157.81341731957448,
                            21.294725766760632
                        ],
                        [
                            -157.81341569362593,
                            21.294726698437302
                        ],
                        [
                            -157.81341426520959,
                            21.294727879938677
                        ],
                        [
                            -157.81341339462119,
                            21.294728738345423
                        ],
                        [
                            -157.81341028539043,
                            21.294731802406069
                        ],
                        [
                            -157.81340172723597,
                            21.294740235744907
                        ],
                        [
                            -157.81339479951205,
                            21.294735169479505
                        ],
                        [
                            -157.81338816502918,
                            21.294730318481108
                        ],
                        [
                            -157.8133729985758,
                            21.294722712521757
                        ],
                        [
                            -157.81336215996456,
                            21.294719345965134
                        ],
                        [
                            -157.81335729836925,
                            21.2947178346489
                        ],
                        [
                            -157.81335631931643,
                            21.294680806832808
                        ],
                        [
                            -157.81335625147733,
                            21.294678210012272
                        ],
                        [
                            -157.81335610782565,
                            21.294677012008055
                        ],
                        [
                            -157.81335598581373,
                            21.29467600025469
                        ],
                        [
                            -157.81335531469097,
                            21.294673865330168
                        ],
                        [
                            -157.81335425782152,
                            21.294671871325136
                        ],
                        [
                            -157.81335284844144,
                            21.294670080807773
                        ],
                        [
                            -157.81335112757756,
                            21.294668546463928
                        ],
                        [
                            -157.81334914883095,
                            21.294667315647768
                        ],
                        [
                            -157.81334697360083,
                            21.294666424927694
                        ],
                        [
                            -157.81334466431539,
                            21.294665902748946
                        ],
                        [
                            -157.81334229508585,
                            21.294665763184835
                        ],
                        [
                            -157.8133399342978,
                            21.294666013041198
                        ],
                        [
                            -157.81333972176253,
                            21.294666071166539
                        ],
                        [
                            -157.81333931889782,
                            21.294666183056826
                        ],
                        [
                            -157.81333765722206,
                            21.294666642008025
                        ],
                        [
                            -157.81333553051957,
                            21.294667631584094
                        ],
                        [
                            -157.81333361997437,
                            21.29466895242135
                        ],
                        [
                            -157.81333198181136,
                            21.294670565167014
                        ],
                        [
                            -157.81333066945083,
                            21.294672419607895
                        ],
                        [
                            -157.81332971901367,
                            21.29467445908509
                        ],
                        [
                            -157.81332916087365,
                            21.294676622382259
                        ],
                        [
                            -157.81332909390412,
                            21.294677640030415
                        ],
                        [
                            -157.81332905683178,
                            21.294678175479191
                        ],
                        [
                            -157.81332900207735,
                            21.294678391906725
                        ],
                        [
                            -157.8133290129102,
                            21.294678843677993
                        ],
                        [
                            -157.81332914230526,
                            21.294683739156124
                        ],
                        [
                            -157.81332929769243,
                            21.294689599637792
                        ],
                        [
                            -157.81332924369983,
                            21.294689601063919
                        ],
                        [
                            -157.81331163781272,
                            21.294690121959931
                        ],
                        [
                            -157.81331033840814,
                            21.294690433284675
                        ],
                        [
                            -157.81330910628972,
                            21.294690950256143
                        ],
                        [
                            -157.81330797376734,
                            21.294691659317753
                        ],
                        [
                            -157.8133069705392,
                            21.294692541875751
                        ],
                        [
                            -157.81330612291302,
                            21.294693574786763
                        ],
                        [
                            -157.81330545311613,
                            21.294694730964707
                        ],
                        [
                            -157.81330497871264,
                            21.294695980091067
                        ],
                        [
                            -157.81330471214289,
                            21.294697289409932
                        ],
                        [
                            -157.81330378557834,
                            21.294697555701138
                        ],
                        [
                            -157.81330317302633,
                            21.294697731157051
                        ],
                        [
                            -157.81328844462186,
                            21.294701962684808
                        ],
                        [
                            -157.81328872252422,
                            21.294702767757645
                        ],
                        [
                            -157.8132888555669,
                            21.294703606137958
                        ],
                        [
                            -157.81328883816954,
                            21.294704452491526
                        ],
                        [
                            -157.81328867147008,
                            21.294705285145007
                        ],
                        [
                            -157.81328836241155,
                            21.294706079755805
                        ],
                        [
                            -157.81328791597295,
                            21.294706816484489
                        ],
                        [
                            -157.81328734774337,
                            21.294707474662978
                        ],
                        [
                            -157.81328667040574,
                            21.294708035409503
                        ],
                        [
                            -157.81328663612612,
                            21.2947079827712
                        ],
                        [
                            -157.81328651200181,
                            21.294707834643557
                        ],
                        [
                            -157.81328636360612,
                            21.294707708026127
                        ],
                        [
                            -157.81328619477287,
                            21.294707605656143
                        ],
                        [
                            -157.81328601124915,
                            21.294707532091039
                        ],
                        [
                            -157.8132858168978,
                            21.294707486454698
                        ],
                        [
                            -157.81328561748043,
                            21.294707471497894
                        ],
                        [
                            -157.81328541685261,
                            21.294707487247784
                        ],
                        [
                            -157.81328522271829,
                            21.294707534662113
                        ],
                        [
                            -157.81328503991861,
                            21.294707611064833
                        ],
                        [
                            -157.8132848713598,
                            21.294707714669649
                        ],
                        [
                            -157.8132847247748,
                            21.294707842820909
                        ],
                        [
                            -157.81328460212038,
                            21.294707991918848
                        ],
                        [
                            -157.81328450825953,
                            21.294708156577425
                        ],
                        [
                            -157.81328444320673,
                            21.294708334989959
                        ],
                        [
                            -157.81328441086831,
                            21.294708520860237
                        ],
                        [
                            -157.81328441225173,
                            21.294708708775069
                        ],
                        [
                            -157.81328444643654,
                            21.294708893307604
                        ],
                        [
                            -157.81328446427918,
                            21.294708952153741
                        ],
                        [
                            -157.81328356608134,
                            21.294709047000751
                        ],
                        [
                            -157.81328266418799,
                            21.294709001796292
                        ],
                        [
                            -157.81328178268924,
                            21.294708817613596
                        ],
                        [
                            -157.81328094467503,
                            21.294708500035799
                        ],
                        [
                            -157.81328017514866,
                            21.294708056466291
                        ],
                        [
                            -157.81327949328647,
                            21.294707499687732
                        ],
                        [
                            -157.81327891919972,
                            21.294706846102926
                        ],
                        [
                            -157.81327846818016,
                            21.294706112080721
                        ],
                        [
                            -157.81327778745882,
                            21.294706493932178
                        ],
                        [
                            -157.81327737884627,
                            21.294706721415693
                        ],
                        [
                            -157.81327727523097,
                            21.294706780308886
                        ],
                        [
                            -157.81326243316795,
                            21.294715083514056
                        ],
                        [
                            -157.81325825356876,
                            21.294718315282761
                        ],
                        [
                            -157.81324803005324,
                            21.294726224649779
                        ],
                        [
                            -157.8132486167431,
                            21.294726869289622
                        ],
                        [
                            -157.81324908131506,
                            21.294727596180334
                        ],
                        [
                            -157.81324941044147,
                            21.294728384449982
                        ],
                        [
                            -157.81324959754906,
                            21.294729212370825
                        ],
                        [
                            -157.81324963605732,
                            21.294730059118535
                        ],
                        [
                            -157.81324952520546,
                            21.294730899392839
                        ],
                        [
                            -157.8132492680592,
                            21.294731711533998
                        ],
                        [
                            -157.81324887059768,
                            21.294732471192621
                        ],
                        [
                            -157.81324881785903,
                            21.294732436491962
                        ],
                        [
                            -157.81324864316264,
                            21.294732344017884
                        ],
                        [
                            -157.81324845473966,
                            21.2947322803555
                        ],
                        [
                            -157.81324825740958,
                            21.294732245538778
                        ],
                        [
                            -157.8132480569268,
                            21.294732243221862
                        ],
                        [
                            -157.81324785813246,
                            21.294732270728712
                        ],
                        [
                            -157.81324766680271,
                            21.294732329003452
                        ],
                        [
                            -157.81324748970661,
                            21.294732415383624
                        ],
                        [
                            -157.81324732975031,
                            21.294732528082942
                        ],
                        [
                            -157.81324719081113,
                            21.294732664418582
                        ],
                        [
                            -157.81324707870149,
                            21.294732820817959
                        ],
                        [
                            -157.81324699539988,
                            21.294732990971298
                        ],
                        [
                            -157.81324694188476,
                            21.294733173078725
                        ],
                        [
                            -157.8132469230336,
                            21.294733359947497
                        ],
                        [
                            -157.81324693598367,
                            21.294733547943874
                        ],
                        [
                            -157.81324698175692,
                            21.294733729847938
                        ],
                        [
                            -157.81324705940395,
                            21.294733903846225
                        ],
                        [
                            -157.81324716705501,
                            21.294734062698438
                        ],
                        [
                            -157.81324720715426,
                            21.294734110860826
                        ],
                        [
                            -157.81324641631664,
                            21.29473452084423
                        ],
                        [
                            -157.81324556386289,
                            21.294734801208467
                        ],
                        [
                            -157.81324467392656,
                            21.294734947606742
                        ],
                        [
                            -157.81324377161974,
                            21.29473495389237
                        ],
                        [
                            -157.81324287910473,
                            21.294734821125008
                        ],
                        [
                            -157.81324202142102,
                            21.294734552191361
                        ],
                        [
                            -157.81324122454299,
                            21.294734153598327
                        ],
                        [
                            -157.81324050765431,
                            21.294733637225189
                        ],
                        [
                            -157.81322935580388,
                            21.294747676772243
                        ],
                        [
                            -157.81322515417966,
                            21.294755092886124
                        ],
                        [
                            -157.81322059954172,
                            21.29476313527012
                        ],
                        [
                            -157.81322140520365,
                            21.294763520374364
                        ],
                        [
                            -157.81322212989784,
                            21.294764025058537
                        ],
                        [
                            -157.81322275638294,
                            21.29476463565026
                        ],
                        [
                            -157.81322326842505,
                            21.294765333063875
                        ],
                        [
                            -157.81322364880461,
                            21.294766100916977
                        ],
                        [
                            -157.81322388998447,
                            21.294766917475034
                        ],
                        [
                            -157.81322398347086,
                            21.294767760093436
                        ],
                        [
                            -157.81322392752458,
                            21.294768605271777
                        ],
                        [
                            -157.81322386402354,
                            21.294768590369817
                        ],
                        [
                            -157.81322366369295,
                            21.294768569082763
                        ],
                        [
                            -157.81322346408697,
                            21.294768577612672
                        ],
                        [
                            -157.81322326809726,
                            21.294768615979951
                        ],
                        [
                            -157.81322308149993,
                            21.294768685128698
                        ],
                        [
                            -157.81322290912897,
                            21.294768783286223
                        ],
                        [
                            -157.81322275681126,
                            21.294768905073266
                        ],
                        [
                            -157.81322262841684,
                            21.294769048710357
                        ],
                        [
                            -157.81322252590257,
                            21.2947692105977
                        ],
                        [
                            -157.81322245413139,
                            21.29476938534928
                        ],
                        [
                            -157.81322241408901,
                            21.294769570261849
                        ],
                        [
                            -157.81322240679725,
                            21.29476975811551
                        ],
                        [
                            -157.81322243132854,
                            21.294769944386751
                        ],
                        [
                            -157.8132224906108,
                            21.294770124579308
                        ],
                        [
                            -157.81322257891145,
                            21.294770292328987
                        ],
                        [
                            -157.81322269624496,
                            21.294770445829158
                        ],
                        [
                            -157.8132228388138,
                            21.294770577825886
                        ],
                        [
                            -157.81322300182021,
                            21.294770685575205
                        ],
                        [
                            -157.81322306037845,
                            21.294770715799945
                        ],
                        [
                            -157.81322249596766,
                            21.29477137852205
                        ],
                        [
                            -157.8132218243766,
                            21.294771943825765
                        ],
                        [
                            -157.81322106113635,
                            21.294772398269711
                        ],
                        [
                            -157.81322022853249,
                            21.294772727556815
                        ],
                        [
                            -157.81321935072049,
                            21.294772924630237
                        ],
                        [
                            -157.81321844896394,
                            21.29477298241283
                        ],
                        [
                            -157.81321754928811,
                            21.294772901088045
                        ],
                        [
                            -157.81321667674695,
                            21.294772681735964
                        ],
                        [
                            -157.81321320923408,
                            21.294785553175913
                        ],
                        [
                            -157.81321210635835,
                            21.294789650402755
                        ],
                        [
                            -157.81321119612139,
                            21.29479856947556
                        ],
                        [
                            -157.81321099723755,
                            21.294800529332406
                        ],
                        [
                            -157.81321032970376,
                            21.294807073298017
                        ],
                        [
                            -157.81321122949583,
                            21.294807140169425
                        ],
                        [
                            -157.81321210599427,
                            21.294807346902012
                        ],
                        [
                            -157.813212935167,
                            21.294807685195785
                        ],
                        [
                            -157.81321369201072,
                            21.294808147647373
                        ],
                        [
                            -157.81321435639973,
                            21.294808719660633
                        ],
                        [
                            -157.81321491301318,
                            21.294809388480068
                        ],
                        [
                            -157.81321534273997,
                            21.294810133192982
                        ],
                        [
                            -157.81321563707183,
                            21.294810932961401
                        ],
                        [
                            -157.81321557240386,
                            21.294810943346114
                        ],
                        [
                            -157.81321537920425,
                            21.294810994380519
                        ],
                        [
                            -157.81321519734658,
                            21.294811073499954
                        ],
                        [
                            -157.81321503261418,
                            21.294811180745231
                        ],
                        [
                            -157.81321488794228,
                            21.294811310716685
                        ],
                        [
                            -157.81321476912154,
                            21.29481146255176
                        ],
                        [
                            -157.81321467812322,
                            21.294811630844031
                        ],
                        [
                            -157.81321461788974,
                            21.294811809290504
                        ],
                        [
                            -157.81321458940678,
                            21.294811995187974
                        ],
                        [
                            -157.81321459464567,
                            21.294812183129977
                        ],
                        [
                            -157.81321463267875,
                            21.294812368593043
                        ],
                        [
                            -157.81321470260011,
                            21.294812544343646
                        ],
                        [
                            -157.81321480251103,
                            21.294812706754879
                        ],
                        [
                            -157.81321492954152,
                            21.294812853096285
                        ],
                        [
                            -157.81321507988679,
                            21.294812977017358
                        ],
                        [
                            -157.81321525164807,
                            21.294813074891124
                        ],
                        [
                            -157.81321543615752,
                            21.294813145753075
                        ],
                        [
                            -157.81321563150189,
                            21.29481318778295
                        ],
                        [
                            -157.81321569699597,
                            21.294813194568455
                        ],
                        [
                            -157.81321544658212,
                            21.294814008563783
                        ],
                        [
                            -157.81321505680233,
                            21.294814771890021
                        ],
                        [
                            -157.81321453745508,
                            21.294815464741689
                        ],
                        [
                            -157.81321390315111,
                            21.294816068250633
                        ],
                        [
                            -157.81321317234219,
                            21.294816565382533
                        ],
                        [
                            -157.8132123634511,
                            21.294816942716416
                        ],
                        [
                            -157.81321149873449,
                            21.29481718956858
                        ],
                        [
                            -157.81321060330436,
                            21.294817299792307
                        ],
                        [
                            -157.81321190338315,
                            21.294825621048037
                        ],
                        [
                            -157.81321330890015,
                            21.294834616975923
                        ],
                        [
                            -157.81321449534281,
                            21.294838241610485
                        ],
                        [
                            -157.81321622273992,
                            21.294843525069226
                        ],
                        [
                            -157.81321878090077,
                            21.294851350200524
                        ],
                        [
                            -157.81321964090688,
                            21.294851089764283
                        ],
                        [
                            -157.81322053548209,
                            21.294850965983631
                        ],
                        [
                            -157.81322143857949,
                            21.294850981385078
                        ],
                        [
                            -157.81322232705833,
                            21.294851136708868
                        ],
                        [
                            -157.81322317589354,
                            21.294851427261591
                        ],
                        [
                            -157.81322396201699,
                            21.294851844750088
                        ],
                        [
                            -157.81322466334606,
                            21.294852378178017
                        ],
                        [
                            -157.81322526168279,
                            21.294853012962783
                        ],
                        [
                            -157.81322520647242,
                            21.294853045998941
                        ],
                        [
                            -157.81322504841478,
                            21.294853162325179
                        ],
                        [
                            -157.81322491331653,
                            21.294853300494655
                        ],
                        [
                            -157.81322480409119,
                            21.294853457817737
                        ],
                        [
                            -157.81322472461605,
                            21.294853631611588
                        ],
                        [
                            -157.81322467592034,
                            21.294853813752983
                        ],
                        [
                            -157.81322466314981,
                            21.294853963625641
                        ],
                        [
                            -157.81322466092467,
                            21.294854000648936
                        ],
                        [
                            -157.81322467773757,
                            21.29485418776914
                        ],
                        [
                            -157.81322472736639,
                            21.294854369700413
                        ],
                        [
                            -157.81322480888355,
                            21.294854541919218
                        ],
                        [
                            -157.81322491944087,
                            21.294854698985166
                        ],
                        [
                            -157.81322505618289,
                            21.294854836361157
                        ],
                        [
                            -157.81322521527576,
                            21.294854951309983
                        ],
                        [
                            -157.81322539192908,
                            21.294855040184334
                        ],
                        [
                            -157.81322558134511,
                            21.294855100240195
                        ],
                        [
                            -157.81322577968274,
                            21.294855129643711
                        ],
                        [
                            -157.81322598018747,
                            21.294855129250649
                        ],
                        [
                            -157.81322617804707,
                            21.294855098123666
                        ],
                        [
                            -157.8132262408453,
                            21.294855080498643
                        ],
                        [
                            -157.81322634205017,
                            21.294855922268074
                        ],
                        [
                            -157.81322629381501,
                            21.294856767500789
                        ],
                        [
                            -157.81322609728497,
                            21.294857593620105
                        ],
                        [
                            -157.81322575745361,
                            21.2948583789799
                        ],
                        [
                            -157.81322528414842,
                            21.294859100161315
                        ],
                        [
                            -157.81322469100897,
                            21.294859739192724
                        ],
                        [
                            -157.81322399360985,
                            21.294860277212756
                        ],
                        [
                            -157.81322321038115,
                            21.294860699897121
                        ],
                        [
                            -157.81323278225281,
                            21.294875728423641
                        ],
                        [
                            -157.81324467122283,
                            21.294889225780132
                        ],
                        [
                            -157.81324535907007,
                            21.29488867685199
                        ],
                        [
                            -157.81324613468925,
                            21.294888241466428
                        ],
                        [
                            -157.81324697484533,
                            21.294887932107052
                        ],
                        [
                            -157.81324785922399,
                            21.294887757664547
                        ],
                        [
                            -157.81324876177106,
                            21.294887721568767
                        ],
                        [
                            -157.81324965837464,
                            21.29488782545647
                        ],
                        [
                            -157.81325052399521,
                            21.294888066440979
                        ],
                        [
                            -157.8132513365212,
                            21.294888437139264
                        ],
                        [
                            -157.81325129170338,
                            21.29488849644699
                        ],
                        [
                            -157.81325119102257,
                            21.294888670091357
                        ],
                        [
                            -157.81325112395484,
                            21.294888859330332
                        ],
                        [
                            -157.81325109153659,
                            21.29488905513734
                        ],
                        [
                            -157.81325109765962,
                            21.29488925302287
                        ],
                        [
                            -157.81325113947582,
                            21.294889447546485
                        ],
                        [
                            -157.81325121703591,
                            21.294889632384848
                        ],
                        [
                            -157.81325132653512,
                            21.294889801187381
                        ],
                        [
                            -157.8132514670385,
                            21.294889950333936
                        ],
                        [
                            -157.81325163280619,
                            21.294890074363703
                        ],
                        [
                            -157.81325181905501,
                            21.29489016872601
                        ],
                        [
                            -157.81325201904491,
                            21.294890232469967
                        ],
                        [
                            -157.81325222799273,
                            21.29489026104488
                        ],
                        [
                            -157.81325244009327,
                            21.294890257119967
                        ],
                        [
                            -157.81325264766437,
                            21.29489021702755
                        ],
                        [
                            -157.8132528448937,
                            21.294890144340165
                        ],
                        [
                            -157.81325302597611,
                            21.294890041727097
                        ],
                        [
                            -157.81325308513635,
                            21.294889996974717
                        ],
                        [
                            -157.81325352261098,
                            21.294890737225227
                        ],
                        [
                            -157.81325382273383,
                            21.294891536131026
                        ],
                        [
                            -157.81325397893889,
                            21.294892371061106
                        ],
                        [
                            -157.81325398563868,
                            21.294893217584548
                        ],
                        [
                            -157.81325384397101,
                            21.294894054027996
                        ],
                        [
                            -157.81325355509563,
                            21.294894856008121
                        ],
                        [
                            -157.81325313073881,
                            21.294895603733032
                        ],
                        [
                            -157.81325257975695,
                            21.294896274680411
                        ],
                        [
                            -157.81326448724997,
                            21.294904583095487
                        ],
                        [
                            -157.8132675595017,
                            21.294906726819047
                        ],
                        [
                            -157.81328405526401,
                            21.29491493207399
                        ],
                        [
                            -157.81328446616968,
                            21.294914178833835
                        ],
                        [
                            -157.81328500468615,
                            21.294913499667953
                        ],
                        [
                            -157.81328565622439,
                            21.294912910734507
                        ],
                        [
                            -157.81328640133972,
                            21.294912432674359
                        ],
                        [
                            -157.81328722067448,
                            21.294912075288341
                        ],
                        [
                            -157.81328809100091,
                            21.294911850156716
                        ],
                        [
                            -157.81328899010589,
                            21.29491176254324
                        ],
                        [
                            -157.81328989194247,
                            21.294911814974441
                        ],
                        [
                            -157.81328987499788,
                            21.294911884415985
                        ],
                        [
                            -157.81328985220412,
                            21.294912082097639
                        ],
                        [
                            -157.81328986700225,
                            21.294912280044326
                        ],
                        [
                            -157.81328991847923,
                            21.294912471925883
                        ],
                        [
                            -157.81329000377957,
                            21.29491265320523
                        ],
                        [
                            -157.81329012198287,
                            21.294912818455554
                        ],
                        [
                            -157.81329026832046,
                            21.294912961319479
                        ],
                        [
                            -157.8132904399296,
                            21.294913078163283
                        ],
                        [
                            -157.8132906300921,
                            21.294913165326022
                        ],
                        [
                            -157.81329083401741,
                            21.294913219160399
                        ],
                        [
                            -157.81329104398714,
                            21.294913240515335
                        ],
                        [
                            -157.81329125520358,
                            21.294913226646866
                        ],
                        [
                            -157.81329146090496,
                            21.294913179314094
                        ],
                        [
                            -157.81329165433672,
                            21.294913099372785
                        ],
                        [
                            -157.81329182970103,
                            21.294912988588848
                        ],
                        [
                            -157.81329198214937,
                            21.294912850541646
                        ],
                        [
                            -157.81329210682605,
                            21.294912689713886
                        ],
                        [
                            -157.81329214491831,
                            21.294912627648564
                        ],
                        [
                            -157.81329285014701,
                            21.294913155683368
                        ],
                        [
                            -157.81329345430387,
                            21.294913785992005
                        ],
                        [
                            -157.81329393824882,
                            21.294914501275134
                        ],
                        [
                            -157.81329429154576,
                            21.294915280681195
                        ],
                        [
                            -157.81329450086687,
                            21.294916103338281
                        ],
                        [
                            -157.8132945625234,
                            21.294916948442413
                        ],
                        [
                            -157.81329447574726,
                            21.294917791596642
                        ],
                        [
                            -157.81329424073419,
                            21.294918608410818
                        ],
                        [
                            -157.81330052434984,
                            21.294920096329395
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 225,
                "NUMBER": "1122B",
                "PROPER_NAME": "HALE ALOHA - LEHUA TOWER",
                "DISPLAY_NAME": "HALE ALOHA - LEHUA TOWER - 1122B",
                "ADDRESS": "2571 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE ALOHA - LEHUA TOWER",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1122B_01.jpg",
                "HEIGHT (ft)": 120.60000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 98.31941526832793,
                "SHAPE_Area": 500.27083856117252
            }
        },
        {
            "type": "Feature",
            "id": 226,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81258757486563,
                            21.294627184216186
                        ],
                        [
                            -157.81258758927214,
                            21.294627310792372
                        ],
                        [
                            -157.81258764074812,
                            21.294627502674096
                        ],
                        [
                            -157.81258772605466,
                            21.294627683050443
                        ],
                        [
                            -157.81258784425694,
                            21.2946278483012
                        ],
                        [
                            -157.8125879906008,
                            21.294627990262359
                        ],
                        [
                            -157.81258816125242,
                            21.294628106196711
                        ],
                        [
                            -157.81258827549865,
                            21.294628163916208
                        ],
                        [
                            -157.8125876563023,
                            21.294628926525867
                        ],
                        [
                            -157.81258690783645,
                            21.294629581623632
                        ],
                        [
                            -157.81258605338692,
                            21.294630110402561
                        ],
                        [
                            -157.81258511717442,
                            21.294630497675922
                        ],
                        [
                            -157.81258412435449,
                            21.294630731877081
                        ],
                        [
                            -157.81258310388748,
                            21.294630807790007
                        ],
                        [
                            -157.81258208471925,
                            21.294630722005358
                        ],
                        [
                            -157.81258109382429,
                            21.294630476520201
                        ],
                        [
                            -157.81257672607398,
                            21.294646930761353
                        ],
                        [
                            -157.81257654637511,
                            21.294648661291529
                        ],
                        [
                            -157.8125752498222,
                            21.294661147830002
                        ],
                        [
                            -157.81257497399346,
                            21.294663805463149
                        ],
                        [
                            -157.8125759941766,
                            21.294663884931293
                        ],
                        [
                            -157.81257698608647,
                            21.294664124099913
                        ],
                        [
                            -157.81257792087879,
                            21.294664513731675
                        ],
                        [
                            -157.81257877258648,
                            21.294665046416235
                        ],
                        [
                            -157.81257951822121,
                            21.294665703923663
                        ],
                        [
                            -157.81258013380895,
                            21.294666470727194
                        ],
                        [
                            -157.81258049675608,
                            21.294667128245084
                        ],
                        [
                            -157.8125805699311,
                            21.294667258849401
                        ],
                        [
                            -157.81258060508728,
                            21.294667322334679
                        ],
                        [
                            -157.81258091680792,
                            21.294668236957236
                        ],
                        [
                            -157.81258079908952,
                            21.294668251484417
                        ],
                        [
                            -157.81258060781772,
                            21.294668302531669
                        ],
                        [
                            -157.81258042595263,
                            21.294668382553777
                        ],
                        [
                            -157.81258026122725,
                            21.294668488895059
                        ],
                        [
                            -157.81258011847552,
                            21.294668619782904
                        ],
                        [
                            -157.81257999966877,
                            21.294668769810837
                        ],
                        [
                            -157.81257990769868,
                            21.294668938999269
                        ],
                        [
                            -157.81257985598577,
                            21.294669086423912
                        ],
                        [
                            -157.81257982629626,
                            21.294669239808343
                        ],
                        [
                            -157.81257981926333,
                            21.294669395881364
                        ],
                        [
                            -157.81257983503696,
                            21.294669551314445
                        ],
                        [
                            -157.81257987328075,
                            21.294669702792699
                        ],
                        [
                            -157.81257993317911,
                            21.29466984708559
                        ],
                        [
                            -157.8125800340386,
                            21.294670011310622
                        ],
                        [
                            -157.81258016108282,
                            21.294670155845818
                        ],
                        [
                            -157.81258031143469,
                            21.294670278864075
                        ],
                        [
                            -157.81258048126028,
                            21.294670377628201
                        ],
                        [
                            -157.81258066673311,
                            21.294670448497623
                        ],
                        [
                            -157.81258086208433,
                            21.294670489624885
                        ],
                        [
                            -157.81258097960682,
                            21.29467049948785
                        ],
                        [
                            -157.81258071863664,
                            21.294671427234732
                        ],
                        [
                            -157.81258029518924,
                            21.294672301438801
                        ],
                        [
                            -157.81257972104893,
                            21.294673095081535
                        ],
                        [
                            -157.81257901468217,
                            21.294673789321976
                        ],
                        [
                            -157.81257819362037,
                            21.294674361699105
                        ],
                        [
                            -157.81257728111311,
                            21.294674797922656
                        ],
                        [
                            -157.81257630426552,
                            21.294675083729651
                        ],
                        [
                            -157.81257528915347,
                            21.294675212980298
                        ],
                        [
                            -157.81257544978106,
                            21.294676216875921
                        ],
                        [
                            -157.81257797113111,
                            21.294691980743853
                        ],
                        [
                            -157.8125786522225,
                            21.294694073282027
                        ],
                        [
                            -157.81257880461487,
                            21.294694542312921
                        ],
                        [
                            -157.81258324475772,
                            21.294708199461596
                        ],
                        [
                            -157.81258421972854,
                            21.294707907317612
                        ],
                        [
                            -157.81258523296378,
                            21.294707771729968
                        ],
                        [
                            -157.81258625647428,
                            21.294707797018127
                        ],
                        [
                            -157.81258726037203,
                            21.294707983874698
                        ],
                        [
                            -157.81258821773324,
                            21.294708323979172
                        ],
                        [
                            -157.81258909969199,
                            21.294708810804238
                        ],
                        [
                            -157.8125898832381,
                            21.294709428829933
                        ],
                        [
                            -157.8125905444121,
                            21.294710160722815
                        ],
                        [
                            -157.81259044177494,
                            21.294710217815702
                        ],
                        [
                            -157.81259028468088,
                            21.294710334148132
                        ],
                        [
                            -157.8125901505461,
                            21.294710472323874
                        ],
                        [
                            -157.81259004131297,
                            21.294710630549861
                        ],
                        [
                            -157.81258996282287,
                            21.294710801640168
                        ],
                        [
                            -157.81258991509029,
                            21.294710983788136
                        ],
                        [
                            -157.81258989911547,
                            21.294711172483883
                        ],
                        [
                            -157.81258991817361,
                            21.294711361419939
                        ],
                        [
                            -157.81258996927784,
                            21.294711544308981
                        ],
                        [
                            -157.81259005092096,
                            21.294711715757071
                        ],
                        [
                            -157.81259016069507,
                            21.294711870707683
                        ],
                        [
                            -157.81259029536258,
                            21.29471200459086
                        ],
                        [
                            -157.81259045350541,
                            21.294712117726803
                        ],
                        [
                            -157.81259062920151,
                            21.294712205691642
                        ],
                        [
                            -157.81259081958095,
                            21.294712265754999
                        ],
                        [
                            -157.81259101598317,
                            21.294712296048985
                        ],
                        [
                            -157.81259121649492,
                            21.294712294753332
                        ],
                        [
                            -157.81259141243393,
                            21.294712262710174
                        ],
                        [
                            -157.81259152644915,
                            21.294712229185681
                        ],
                        [
                            -157.81259166436425,
                            21.294713180524468
                        ],
                        [
                            -157.81259162966975,
                            21.294714139679485
                        ],
                        [
                            -157.81259142451108,
                            21.294715079564167
                        ],
                        [
                            -157.81259105488203,
                            21.294715974022491
                        ],
                        [
                            -157.81259052869692,
                            21.294716797815401
                        ],
                        [
                            -157.81258986445835,
                            21.294717527585277
                        ],
                        [
                            -157.81258907871941,
                            21.294718142670938
                        ],
                        [
                            -157.8125881937948,
                            21.294718625161998
                        ],
                        [
                            -157.81259529882635,
                            21.294729695734265
                        ],
                        [
                            -157.81259568155218,
                            21.294730291057764
                        ],
                        [
                            -157.81259751896957,
                            21.294733155117378
                        ],
                        [
                            -157.81260901300874,
                            21.294746247721864
                        ],
                        [
                            -157.81260979396455,
                            21.294745628085433
                        ],
                        [
                            -157.8126106750845,
                            21.294745139243695
                        ],
                        [
                            -157.81261163214782,
                            21.294744796383402
                        ],
                        [
                            -157.81261263520855,
                            21.294744607423844
                        ],
                        [
                            -157.81261365914739,
                            21.294744579414889
                        ],
                        [
                            -157.81261467214853,
                            21.294744713035527
                        ],
                        [
                            -157.81261564823038,
                            21.294745002682106
                        ],
                        [
                            -157.81261655852691,
                            21.294745441827292
                        ],
                        [
                            -157.81261648743705,
                            21.294745531664756
                        ],
                        [
                            -157.81261638973436,
                            21.294745694489055
                        ],
                        [
                            -157.81261632083968,
                            21.294745871067413
                        ],
                        [
                            -157.81261628562328,
                            21.294746055110455
                        ],
                        [
                            -157.81261628218633,
                            21.294746242991248
                        ],
                        [
                            -157.81261631251476,
                            21.294746427496687
                        ],
                        [
                            -157.81261637468793,
                            21.294746607709808
                        ],
                        [
                            -157.81261647016072,
                            21.294746775943903
                        ],
                        [
                            -157.81261659180089,
                            21.294746926348147
                        ],
                        [
                            -157.81261673634896,
                            21.294747054892365
                        ],
                        [
                            -157.81261689993173,
                            21.294747158132125
                        ],
                        [
                            -157.81261707816583,
                            21.294747233301059
                        ],
                        [
                            -157.81261727248796,
                            21.294747282551512
                        ],
                        [
                            -157.81261747187625,
                            21.294747301122474
                        ],
                        [
                            -157.8126176715185,
                            21.294747288076593
                        ],
                        [
                            -157.81261786561677,
                            21.294747245179732
                        ],
                        [
                            -157.81261805031556,
                            21.294747172404723
                        ],
                        [
                            -157.81261821884578,
                            21.294747072413958
                        ],
                        [
                            -157.81261831099621,
                            21.294747000792839
                        ],
                        [
                            -157.81261882486044,
                            21.294747831019322
                        ],
                        [
                            -157.81261918587796,
                            21.294748728825159
                        ],
                        [
                            -157.81261937978621,
                            21.294749669718257
                        ],
                        [
                            -157.81261940292555,
                            21.294750629281257
                        ],
                        [
                            -157.81261925455695,
                            21.294751579503874
                        ],
                        [
                            -157.8126189378043,
                            21.294752491499676
                        ],
                        [
                            -157.81261846345907,
                            21.294753341856659
                        ],
                        [
                            -157.81261784329843,
                            21.294754104459617
                        ],
                        [
                            -157.81263035800717,
                            21.294762775847019
                        ],
                        [
                            -157.81263102520654,
                            21.294763237668768
                        ],
                        [
                            -157.81263239123967,
                            21.294764183216785
                        ],
                        [
                            -157.81264835669919,
                            21.294772158040495
                        ],
                        [
                            -157.81264882528271,
                            21.294771304932599
                        ],
                        [
                            -157.8126494396962,
                            21.294770537772042
                        ],
                        [
                            -157.81265018241547,
                            21.294769878116551
                        ],
                        [
                            -157.81265103305356,
                            21.29476934389011
                        ],
                        [
                            -157.81265196738255,
                            21.294768951182785
                        ],
                        [
                            -157.8126529592902,
                            21.294768710651095
                        ],
                        [
                            -157.81265397884505,
                            21.294768628407613
                        ],
                        [
                            -157.81265499902898,
                            21.294768707875313
                        ],
                        [
                            -157.81265496724117,
                            21.294768825091712
                        ],
                        [
                            -157.81265494444659,
                            21.294769022773242
                        ],
                        [
                            -157.81265496021504,
                            21.294769219823415
                        ],
                        [
                            -157.81265496770132,
                            21.294769247881305
                        ],
                        [
                            -157.81265501072724,
                            21.294769411698343
                        ],
                        [
                            -157.81265509603398,
                            21.294769592074644
                        ],
                        [
                            -157.81265521423643,
                            21.294769757325358
                        ],
                        [
                            -157.81265530602303,
                            21.294769851021975
                        ],
                        [
                            -157.81265546163232,
                            21.294769971606804
                        ],
                        [
                            -157.81265563416741,
                            21.294770066404435
                        ],
                        [
                            -157.81265581939246,
                            21.294770133087507
                        ],
                        [
                            -157.81265601276004,
                            21.294770170018896
                        ],
                        [
                            -157.81265620952283,
                            21.294770176291909
                        ],
                        [
                            -157.81265634457691,
                            21.294770163693762
                        ],
                        [
                            -157.81265655027821,
                            21.294770116361764
                        ],
                        [
                            -157.81265674276074,
                            21.294770034607705
                        ],
                        [
                            -157.81265691715416,
                            21.294769924720981
                        ],
                        [
                            -157.81265706863903,
                            21.294769786667569
                        ],
                        [
                            -157.8126571933017,
                            21.294769627646996
                        ],
                        [
                            -157.81265725393379,
                            21.294769519667948
                        ],
                        [
                            -157.81265806861535,
                            21.294770101777381
                        ],
                        [
                            -157.81265876763575,
                            21.294770802318354
                        ],
                        [
                            -157.81265933186953,
                            21.294771602184788
                        ],
                        [
                            -157.81265940483425,
                            21.294771758985881
                        ],
                        [
                            -157.81265974413336,
                            21.294772480477477
                        ],
                        [
                            -157.81265987238515,
                            21.294772954758344
                        ],
                        [
                            -157.81265999500599,
                            21.294773410028302
                        ],
                        [
                            -157.81266007600829,
                            21.294774366385912
                        ],
                        [
                            -157.81265998350227,
                            21.294775322422975
                        ],
                        [
                            -157.81265972349624,
                            21.294776250176785
                        ],
                        [
                            -157.81267727883139,
                            21.294780344410491
                        ],
                        [
                            -157.81269528571156,
                            21.294781986414566
                        ],
                        [
                            -157.81269537050619,
                            21.294781030323094
                        ],
                        [
                            -157.81269562474313,
                            21.294780100721752
                        ],
                        [
                            -157.81269604242138,
                            21.294779224669899
                        ],
                        [
                            -157.81269660985777,
                            21.294778425559151
                        ],
                        [
                            -157.81269731239072,
                            21.294777728581003
                        ],
                        [
                            -157.81269812964788,
                            21.294777149852749
                        ],
                        [
                            -157.81269903737228,
                            21.294776709077862
                        ],
                        [
                            -157.81270001331453,
                            21.294776416036683
                        ],
                        [
                            -157.81270003259141,
                            21.294776536323475
                        ],
                        [
                            -157.8127000917932,
                            21.294776726452898
                        ],
                        [
                            -157.81270018676796,
                            21.294776903283818
                        ],
                        [
                            -157.81270031176854,
                            21.294777062258742
                        ],
                        [
                            -157.81270046490346,
                            21.294777198847367
                        ],
                        [
                            -157.81270064043281,
                            21.294777307588898
                        ],
                        [
                            -157.8127007633833,
                            21.294777361756168
                        ],
                        [
                            -157.81270095371755,
                            21.294777417614789
                        ],
                        [
                            -157.81270115038311,
                            21.294777443498546
                        ],
                        [
                            -157.81270134868879,
                            21.29477743879001
                        ],
                        [
                            -157.81270154390427,
                            21.294777403601497
                        ],
                        [
                            -157.81270173137293,
                            21.294777338772381
                        ],
                        [
                            -157.81270185138919,
                            21.294777278188448
                        ],
                        [
                            -157.81270202102118,
                            21.294777161040965
                        ],
                        [
                            -157.81270216580228,
                            21.294777017519898
                        ],
                        [
                            -157.81270228280454,
                            21.294776852121522
                        ],
                        [
                            -157.81270236619383,
                            21.294776671128428
                        ],
                        [
                            -157.81270241594112,
                            21.294776478153953
                        ],
                        [
                            -157.81270242848004,
                            21.294776357188191
                        ],
                        [
                            -157.8127034184123,
                            21.294776602665888
                        ],
                        [
                            -157.81270435025598,
                            21.294776999503284
                        ],
                        [
                            -157.8127051990368,
                            21.294777536683558
                        ],
                        [
                            -157.8127059378819,
                            21.294778199562895
                        ],
                        [
                            -157.81270654959343,
                            21.294778969048831
                        ],
                        [
                            -157.81270701410378,
                            21.294779823318443
                        ],
                        [
                            -157.81270732002753,
                            21.294780739706674
                        ],
                        [
                            -157.8127074569868,
                            21.294781690135267
                        ],
                        [
                            -157.81272534879278,
                            21.29477917663549
                        ],
                        [
                            -157.81274265474406,
                            21.294774234303617
                        ],
                        [
                            -157.8127423430077,
                            21.294773321487995
                        ],
                        [
                            -157.8127421983298,
                            21.294772371908365
                        ],
                        [
                            -157.8127422262761,
                            21.294771412705689
                        ],
                        [
                            -157.81274242470116,
                            21.294770470966522
                        ],
                        [
                            -157.81274278952449,
                            21.294769574667168
                        ],
                        [
                            -157.81274330801961,
                            21.294768748109352
                        ],
                        [
                            -157.81274396747449,
                            21.294768013788154
                        ],
                        [
                            -157.81274474940105,
                            21.294767393254535
                        ],
                        [
                            -157.81274480935741,
                            21.294767489436751
                        ],
                        [
                            -157.81274493348846,
                            21.294767636661433
                        ],
                        [
                            -157.81274507995593,
                            21.294767763265721
                        ],
                        [
                            -157.81274524879612,
                            21.294767864732897
                        ],
                        [
                            -157.81274543231234,
                            21.294767939201918
                        ],
                        [
                            -157.81274562667085,
                            21.294767983935543
                        ],
                        [
                            -157.81274582801598,
                            21.294767998906586
                        ],
                        [
                            -157.81274602405784,
                            21.294767983185096
                        ],
                        [
                            -157.81274621519427,
                            21.294767936855358
                        ],
                        [
                            -157.8127463966768,
                            21.294767861068358
                        ],
                        [
                            -157.8127465639968,
                            21.294767757706889
                        ],
                        [
                            -157.81274671299749,
                            21.294767629338793
                        ],
                        [
                            -157.81274683661638,
                            21.294767480248076
                        ],
                        [
                            -157.81274693049238,
                            21.294767313783151
                        ],
                        [
                            -157.81274699456745,
                            21.294767137170737
                        ],
                        [
                            -157.81274702593538,
                            21.294766952197129
                        ],
                        [
                            -157.81274702551659,
                            21.294766764289129
                        ],
                        [
                            -157.81274699133243,
                            21.294766579756516
                        ],
                        [
                            -157.81274695651715,
                            21.294766473814366
                        ],
                        [
                            -157.81274797066581,
                            21.29476634455591
                        ],
                        [
                            -157.81274899411872,
                            21.294766377069816
                        ],
                        [
                            -157.81274999700969,
                            21.29476656933867
                        ],
                        [
                            -157.812750951422,
                            21.294766916648562
                        ],
                        [
                            -157.81275182948983,
                            21.294767407962304
                        ],
                        [
                            -157.81275260817392,
                            21.294768031373323
                        ],
                        [
                            -157.81275326449327,
                            21.29476876774832
                        ],
                        [
                            -157.81275378030068,
                            21.294769596181336
                        ],
                        [
                            -157.81276518823412,
                            21.294763165014789
                        ],
                        [
                            -157.81276601712202,
                            21.294762698388546
                        ],
                        [
                            -157.81276928330456,
                            21.29476085773361
                        ],
                        [
                            -157.81278046979747,
                            21.294752232477357
                        ],
                        [
                            -157.81278325453479,
                            21.294750085790774
                        ],
                        [
                            -157.81278259240304,
                            21.294749352988458
                        ],
                        [
                            -157.8127820717543,
                            21.294748527231548
                        ],
                        [
                            -157.81278170493064,
                            21.29474763209523
                        ],
                        [
                            -157.81278150524523,
                            21.294746690258147
                        ],
                        [
                            -157.81278147437919,
                            21.294745732447399
                        ],
                        [
                            -157.81278161599948,
                            21.294744782177002
                        ],
                        [
                            -157.81278192602562,
                            21.294743867423229
                        ],
                        [
                            -157.81278239557219,
                            21.294743014321732
                        ],
                        [
                            -157.81278248950426,
                            21.29474308093172
                        ],
                        [
                            -157.81278266420762,
                            21.29474317250293
                        ],
                        [
                            -157.81278285263036,
                            21.294743236165825
                        ],
                        [
                            -157.81278304900368,
                            21.294743270072946
                        ],
                        [
                            -157.81278324852258,
                            21.294743272383613
                        ],
                        [
                            -157.81278344635308,
                            21.294743244870528
                        ],
                        [
                            -157.812783639618,
                            21.294743185706576
                        ],
                        [
                            -157.81278381390598,
                            21.294743101450905
                        ],
                        [
                            -157.81278397186082,
                            21.294742989533109
                        ],
                        [
                            -157.81278410913285,
                            21.294742853035082
                        ],
                        [
                            -157.812784221942,
                            21.294742695715602
                        ],
                        [
                            -157.8127843071818,
                            21.294742521906809
                        ],
                        [
                            -157.81278435873344,
                            21.294742344302662
                        ],
                        [
                            -157.81278437758522,
                            21.294742157433969
                        ],
                        [
                            -157.81278436462847,
                            21.294741970340919
                        ],
                        [
                            -157.81278431884851,
                            21.29474178934009
                        ],
                        [
                            -157.81278424120205,
                            21.294741615341596
                        ],
                        [
                            -157.81278413450812,
                            21.294741457399265
                        ],
                        [
                            -157.81278405612895,
                            21.294741374637958
                        ],
                        [
                            -157.81278494300267,
                            21.294740889449432
                        ],
                        [
                            -157.81278590194989,
                            21.294740552021764
                        ],
                        [
                            -157.81278690688018,
                            21.294740370301451
                        ],
                        [
                            -157.81278793077547,
                            21.294740347711471
                        ],
                        [
                            -157.81278894276213,
                            21.294740487647626
                        ],
                        [
                            -157.81278991590187,
                            21.294740783596186
                        ],
                        [
                            -157.81279082325648,
                            21.294741229043431
                        ],
                        [
                            -157.81279103891399,
                            21.294741382333992
                        ],
                        [
                            -157.81279163794571,
                            21.294741810248905
                        ],
                        [
                            -157.812791974899,
                            21.294741383515465
                        ],
                        [
                            -157.81279294584755,
                            21.294740151816629
                        ],
                        [
                            -157.81279418751538,
                            21.294738578739214
                        ],
                        [
                            -157.8128023932878,
                            21.294728176267945
                        ],
                        [
                            -157.81280350402818,
                            21.294726221939928
                        ],
                        [
                            -157.81280355291932,
                            21.294726135559358
                        ],
                        [
                            -157.81280589072841,
                            21.294722025364504
                        ],
                        [
                            -157.81280615375195,
                            21.29472156197399
                        ],
                        [
                            -157.81281090173522,
                            21.294713212909851
                        ],
                        [
                            -157.81280999143098,
                            21.294712774669048
                        ],
                        [
                            -157.81280917285,
                            21.29471219795316
                        ],
                        [
                            -157.81280846897337,
                            21.294711501895481
                        ],
                        [
                            -157.81280789893387,
                            21.294710704698744
                        ],
                        [
                            -157.81280747989302,
                            21.294709829972142
                        ],
                        [
                            -157.81280722226501,
                            21.294708901277236
                        ],
                        [
                            -157.81280713547841,
                            21.294707944878859
                        ],
                        [
                            -157.81280722027225,
                            21.294706988787265
                        ],
                        [
                            -157.81280733475802,
                            21.294707016696456
                        ],
                        [
                            -157.81280753316065,
                            21.294707037970404
                        ],
                        [
                            -157.81280773372319,
                            21.294707030351116
                        ],
                        [
                            -157.81280792972015,
                            21.294706991080986
                        ],
                        [
                            -157.81280811439706,
                            21.294706921015774
                        ],
                        [
                            -157.8128082857898,
                            21.294706824658558
                        ],
                        [
                            -157.81280844005005,
                            21.294706701078823
                        ],
                        [
                            -157.81280856623079,
                            21.294706560797238
                        ],
                        [
                            -157.81280866647089,
                            21.294706400945966
                        ],
                        [
                            -157.81280873779724,
                            21.294706226266108
                        ],
                        [
                            -157.81280877809436,
                            21.294706041938564
                        ],
                        [
                            -157.8128087861671,
                            21.294705853430383
                        ],
                        [
                            -157.81280876068698,
                            21.294705665345617
                        ],
                        [
                            -157.81280870331852,
                            21.294705486973221
                        ],
                        [
                            -157.81280861405449,
                            21.294705319216536
                        ],
                        [
                            -157.81280849767813,
                            21.294705166626251
                        ],
                        [
                            -157.81280835510975,
                            21.294705034629171
                        ],
                        [
                            -157.81280819113985,
                            21.294704926872694
                        ],
                        [
                            -157.8128080864816,
                            21.294704875544678
                        ],
                        [
                            -157.81280870664838,
                            21.294704112037643
                        ],
                        [
                            -157.81280945511369,
                            21.294703456938869
                        ],
                        [
                            -157.81281030956293,
                            21.294702928158785
                        ],
                        [
                            -157.81281124577535,
                            21.294702540884192
                        ],
                        [
                            -157.81281223859546,
                            21.294702306681682
                        ],
                        [
                            -157.81281325906292,
                            21.294702230767381
                        ],
                        [
                            -157.81281427823188,
                            21.294702316550659
                        ],
                        [
                            -157.81281526816389,
                            21.294702562027688
                        ],
                        [
                            -157.81281814683356,
                            21.294691719070663
                        ],
                        [
                            -157.81281903946146,
                            21.29468835662643
                        ],
                        [
                            -157.81281963685382,
                            21.294686107786102
                        ],
                        [
                            -157.81282027213575,
                            21.294679980961156
                        ],
                        [
                            -157.81282030963604,
                            21.294679632517227
                        ],
                        [
                            -157.81282138794305,
                            21.294669233073694
                        ],
                        [
                            -157.81282036775968,
                            21.294669153607028
                        ],
                        [
                            -157.8128193768132,
                            21.294668914446621
                        ],
                        [
                            -157.81281844106348,
                            21.29466852390604
                        ],
                        [
                            -157.81281759031151,
                            21.29466799213278
                        ],
                        [
                            -157.81281684468291,
                            21.294667333723023
                        ],
                        [
                            -157.8128162281227,
                            21.29466656781684
                        ],
                        [
                            -157.81281575684304,
                            21.294665716209948
                        ],
                        [
                            -157.81281544511364,
                            21.294664802491102
                        ],
                        [
                            -157.81281557442776,
                            21.294664784431983
                        ],
                        [
                            -157.81281577538198,
                            21.294664728032409
                        ],
                        [
                            -157.81281596502336,
                            21.294664639934396
                        ],
                        [
                            -157.81281613465512,
                            21.294664522786785
                        ],
                        [
                            -157.81281628039989,
                            21.29466437927239
                        ],
                        [
                            -157.81281639643805,
                            21.294664213867144
                        ],
                        [
                            -157.81281645519297,
                            21.294664099551053
                        ],
                        [
                            -157.81281650674146,
                            21.294663952064358
                        ],
                        [
                            -157.81281653626311,
                            21.294663798643224
                        ],
                        [
                            -157.81281654312852,
                            21.294663642558508
                        ],
                        [
                            -157.81281652719133,
                            21.294663487137861
                        ],
                        [
                            -157.81281648879133,
                            21.294663335694764
                        ],
                        [
                            -157.81281642874717,
                            21.294663191457907
                        ],
                        [
                            -157.81281636409466,
                            21.29466307988498
                        ],
                        [
                            -157.81281623909402,
                            21.294662920910138
                        ],
                        [
                            -157.81281608595913,
                            21.294662784321616
                        ],
                        [
                            -157.8128159104298,
                            21.294662675580206
                        ],
                        [
                            -157.81281571634707,
                            21.2946625965198
                        ],
                        [
                            -157.81281551140037,
                            21.294662549904785
                        ],
                        [
                            -157.8128153832823,
                            21.294662539063864
                        ],
                        [
                            -157.81281564328711,
                            21.294661611309742
                        ],
                        [
                            -157.81281606673312,
                            21.294660737105016
                        ],
                        [
                            -157.81281663990822,
                            21.294659943454619
                        ],
                        [
                            -157.81281734723777,
                            21.294659249219922
                        ],
                        [
                            -157.8128181692625,
                            21.294658676848375
                        ],
                        [
                            -157.81281908176905,
                            21.29465824062348
                        ],
                        [
                            -157.81282005861613,
                            21.294657954815051
                        ],
                        [
                            -157.81282107180013,
                            21.294657825549312
                        ],
                        [
                            -157.81282007412315,
                            21.294651582413692
                        ],
                        [
                            -157.81281861836479,
                            21.294642484045951
                        ],
                        [
                            -157.81281858074576,
                            21.294642247092522
                        ],
                        [
                            -157.81281838979513,
                            21.294641057788322
                        ],
                        [
                            -157.81281311807209,
                            21.294624839090311
                        ],
                        [
                            -157.81281214213831,
                            21.294625131228869
                        ],
                        [
                            -157.81281112890375,
                            21.294625266817935
                        ],
                        [
                            -157.81281010635763,
                            21.294625241537947
                        ],
                        [
                            -157.81280910149621,
                            21.294625054675944
                        ],
                        [
                            -157.81280814413492,
                            21.294624714572706
                        ],
                        [
                            -157.81280726217591,
                            21.294624227748766
                        ],
                        [
                            -157.81280647959315,
                            21.294623609730873
                        ],
                        [
                            -157.81280581842569,
                            21.294622876935449
                        ],
                        [
                            -157.81280592009151,
                            21.294622820738965
                        ],
                        [
                            -157.81280607718534,
                            21.294622704406319
                        ],
                        [
                            -157.81280621228373,
                            21.294622566237187
                        ],
                        [
                            -157.81280632054543,
                            21.294622408907582
                        ],
                        [
                            -157.81280639904247,
                            21.294622236913821
                        ],
                        [
                            -157.81280644774588,
                            21.29462205386924
                        ],
                        [
                            -157.81280646372045,
                            21.294621865173454
                        ],
                        [
                            -157.81280644458931,
                            21.294621677125829
                        ],
                        [
                            -157.81280639365835,
                            21.294621495098514
                        ],
                        [
                            -157.81280631242069,
                            21.294621324428206
                        ],
                        [
                            -157.81280620325813,
                            21.294621170118635
                        ],
                        [
                            -157.81280606937108,
                            21.294621036693876
                        ],
                        [
                            -157.81280590932212,
                            21.294620920834543
                        ],
                        [
                            -157.81280573363327,
                            21.294620831966576
                        ],
                        [
                            -157.81280554324658,
                            21.294620772806798
                        ],
                        [
                            -157.81280534588052,
                            21.294620742506265
                        ],
                        [
                            -157.81280514634003,
                            21.294620742905639
                        ],
                        [
                            -157.81280494846615,
                            21.294620775838812
                        ],
                        [
                            -157.81280483638608,
                            21.294620808473699
                        ],
                        [
                            -157.8128046984624,
                            21.294619858038349
                        ],
                        [
                            -157.81280473219158,
                            21.294618898876418
                        ],
                        [
                            -157.81280493831261,
                            21.294617958998192
                        ],
                        [
                            -157.8128053079401,
                            21.29461706453932
                        ],
                        [
                            -157.81280583315981,
                            21.294616240738854
                        ],
                        [
                            -157.81280649739688,
                            21.29461551096805
                        ],
                        [
                            -157.81280728409101,
                            21.29461489679143
                        ],
                        [
                            -157.81280816805773,
                            21.29461441338902
                        ],
                        [
                            -157.8128076263487,
                            21.294613569415844
                        ],
                        [
                            -157.81279884286846,
                            21.294599883444494
                        ],
                        [
                            -157.8127957795113,
                            21.294596393724948
                        ],
                        [
                            -157.81279042555769,
                            21.294590295120784
                        ],
                        [
                            -157.81279018007143,
                            21.294590015145285
                        ],
                        [
                            -157.81278734882247,
                            21.294586790852495
                        ],
                        [
                            -157.81278656786824,
                            21.294587410489836
                        ],
                        [
                            -157.81278568674981,
                            21.294587899332576
                        ],
                        [
                            -157.81278473065174,
                            21.294588242200732
                        ],
                        [
                            -157.81278372759226,
                            21.29458843116138
                        ],
                        [
                            -157.81278270366175,
                            21.294588458268077
                        ],
                        [
                            -157.81278168969033,
                            21.294588325545035
                        ],
                        [
                            -157.81278071457302,
                            21.294588035906248
                        ],
                        [
                            -157.81277980427689,
                            21.294587596761961
                        ],
                        [
                            -157.81277987536654,
                            21.294587506924415
                        ],
                        [
                            -157.81277997306896,
                            21.294587344100005
                        ],
                        [
                            -157.81278004099943,
                            21.294587167514766
                        ],
                        [
                            -157.81278007621563,
                            21.294586983471678
                        ],
                        [
                            -157.81278007965233,
                            21.294586795590867
                        ],
                        [
                            -157.81278005029489,
                            21.294586610188912
                        ],
                        [
                            -157.81277998715041,
                            21.294586430872378
                        ],
                        [
                            -157.81277989172614,
                            21.29458626294138
                        ],
                        [
                            -157.81277977022145,
                            21.294586112797369
                        ],
                        [
                            -157.81277962588209,
                            21.294585984451111
                        ],
                        [
                            -157.81277946256375,
                            21.294585881331098
                        ],
                        [
                            -157.81277928462916,
                            21.29458580619195
                        ],
                        [
                            -157.81277908935053,
                            21.294585756031537
                        ],
                        [
                            -157.81277889092632,
                            21.294585737467575
                        ],
                        [
                            -157.81277869129158,
                            21.294585749610324
                        ],
                        [
                            -157.81277849622236,
                            21.294585793403922
                        ],
                        [
                            -157.81277831248775,
                            21.294585866185923
                        ],
                        [
                            -157.81277814299392,
                            21.294585966170079
                        ],
                        [
                            -157.81277805180758,
                            21.294586037798076
                        ],
                        [
                            -157.81277753697904,
                            21.294585207565252
                        ],
                        [
                            -157.81277717692481,
                            21.294584309766506
                        ],
                        [
                            -157.81277698302296,
                            21.294583367970201
                        ],
                        [
                            -157.81277695987532,
                            21.294582409310497
                        ],
                        [
                            -157.81277710823542,
                            21.294581459991001
                        ],
                        [
                            -157.81277742403003,
                            21.294580547084685
                        ],
                        [
                            -157.81277789933765,
                            21.294579696733969
                        ],
                        [
                            -157.81277851854009,
                            21.294578933220194
                        ],
                        [
                            -157.81277156762377,
                            21.29457411790893
                        ],
                        [
                            -157.8127714142496,
                            21.294574011130525
                        ],
                        [
                            -157.81276397156242,
                            21.294568855385961
                        ],
                        [
                            -157.8127536140407,
                            21.294563681791512
                        ],
                        [
                            -157.81275313303814,
                            21.294563440807281
                        ],
                        [
                            -157.81274800515357,
                            21.294560880566987
                        ],
                        [
                            -157.81274753657132,
                            21.29456173367522
                        ],
                        [
                            -157.8127469221665,
                            21.29456249993288
                        ],
                        [
                            -157.81274617847762,
                            21.294563160485421
                        ],
                        [
                            -157.81274532784107,
                            21.294563694712448
                        ],
                        [
                            -157.81274439447751,
                            21.294564087427148
                        ],
                        [
                            -157.81274340353522,
                            21.294564327966256
                        ],
                        [
                            -157.81274238398183,
                            21.294564410210352
                        ],
                        [
                            -157.81274136380648,
                            21.294564329839908
                        ],
                        [
                            -157.81274139262268,
                            21.294564222539808
                        ],
                        [
                            -157.81274141725058,
                            21.294564036615249
                        ],
                        [
                            -157.81274140718557,
                            21.294563849542591
                        ],
                        [
                            -157.81274136527583,
                            21.294563666762272
                        ],
                        [
                            -157.8127412914923,
                            21.294563491887629
                        ],
                        [
                            -157.81274118867589,
                            21.294563331262438
                        ],
                        [
                            -157.81274105680487,
                            21.294563187596701
                        ],
                        [
                            -157.81274090103662,
                            21.294563066897993
                        ],
                        [
                            -157.81274072831266,
                            21.294562972038268
                        ],
                        [
                            -157.81274054288153,
                            21.29456290535078
                        ],
                        [
                            -157.81274034930422,
                            21.294562868475843
                        ],
                        [
                            -157.8127401523422,
                            21.294562862320461
                        ],
                        [
                            -157.81273995164926,
                            21.294562886199778
                        ],
                        [
                            -157.81273976034862,
                            21.294562940860569
                        ],
                        [
                            -157.81273958134642,
                            21.294563024516602
                        ],
                        [
                            -157.8127394194839,
                            21.294563134491817
                        ],
                        [
                            -157.81273927865297,
                            21.294563266296745
                        ],
                        [
                            -157.81273916367303,
                            21.294563419965343
                        ],
                        [
                            -157.81273910889698,
                            21.29456351895184
                        ],
                        [
                            -157.81273829420891,
                            21.294562937746161
                        ],
                        [
                            -157.81273759422515,
                            21.294562237198726
                        ],
                        [
                            -157.81273703096284,
                            21.294561436436016
                        ],
                        [
                            -157.81273661773517,
                            21.294560558136705
                        ],
                        [
                            -157.81273636686234,
                            21.294559628585962
                        ],
                        [
                            -157.81273628683076,
                            21.29455867133181
                        ],
                        [
                            -157.81273637836489,
                            21.294557716191189
                        ],
                        [
                            -157.81273663933388,
                            21.294556788443995
                        ],
                        [
                            -157.81271908402297,
                            21.29455269421754
                        ],
                        [
                            -157.81270107717023,
                            21.294551052217258
                        ],
                        [
                            -157.81270098938259,
                            21.294552020935122
                        ],
                        [
                            -157.81270072830458,
                            21.29455296223232
                        ],
                        [
                            -157.81270030092284,
                            21.294553846346282
                        ],
                        [
                            -157.81269971897822,
                            21.294554651678489
                        ],
                        [
                            -157.81269900003844,
                            21.294555351251148
                        ],
                        [
                            -157.81269816448309,
                            21.294555928043618
                        ],
                        [
                            -157.81269723752573,
                            21.294556363262569
                        ],
                        [
                            -157.81269647524383,
                            21.294556578312633
                        ],
                        [
                            -157.81269607317338,
                            21.294539787786608
                        ],
                        [
                            -157.81269581414375,
                            21.294537593432782
                        ],
                        [
                            -157.81269515446007,
                            21.294535475751076
                        ],
                        [
                            -157.81269411097909,
                            21.294533496290921
                        ],
                        [
                            -157.81269271789313,
                            21.29453171853077
                        ],
                        [
                            -157.81269101527943,
                            21.294530193343114
                        ],
                        [
                            -157.81268905576758,
                            21.294528968978856
                        ],
                        [
                            -157.81268690076385,
                            21.294528081103334
                        ],
                        [
                            -157.8126846126963,
                            21.294527558161967
                        ],
                        [
                            -157.8126822627697,
                            21.294527416014652
                        ],
                        [
                            -157.81267992229758,
                            21.294527656971205
                        ],
                        [
                            -157.81267766168764,
                            21.294528276107947
                        ],
                        [
                            -157.81267555147096,
                            21.294529253144429
                        ],
                        [
                            -157.81267365259765,
                            21.294530560505542
                        ],
                        [
                            -157.81267202614123,
                            21.294532155259368
                        ],
                        [
                            -157.81267071874581,
                            21.294533990758687
                        ],
                        [
                            -157.81266977230865,
                            21.294536011288908
                        ],
                        [
                            -157.81266921431205,
                            21.29453815561337
                        ],
                        [
                            -157.81266906167917,
                            21.294540357000667
                        ],
                        [
                            -157.81266940700627,
                            21.294554730559067
                        ],
                        [
                            -157.81266991510819,
                            21.294575841842217
                        ],
                        [
                            -157.81265387750241,
                            21.294581653141506
                        ],
                        [
                            -157.81263901948284,
                            21.294590020318999
                        ],
                        [
                            -157.81262591214752,
                            21.294600648381685
                        ],
                        [
                            -157.81261681483352,
                            21.294592553976198
                        ],
                        [
                            -157.81261291461834,
                            21.294589083644951
                        ],
                        [
                            -157.81261141214318,
                            21.294587963683522
                        ],
                        [
                            -157.81261080445105,
                            21.294587654050954
                        ],
                        [
                            -157.81260972635204,
                            21.294587104411882
                        ],
                        [
                            -157.81260790618578,
                            21.294586533276991
                        ],
                        [
                            -157.81260600838345,
                            21.294586266940083
                        ],
                        [
                            -157.81260408974956,
                            21.294586313932424
                        ],
                        [
                            -157.81260220910326,
                            21.294586671958733
                        ],
                        [
                            -157.81260042340136,
                            21.294587330580161
                        ],
                        [
                            -157.81259878678148,
                            21.294588270304036
                        ],
                        [
                            -157.81259734864165,
                            21.29458946166698
                        ],
                        [
                            -157.81259615361114,
                            21.294590868848264
                        ],
                        [
                            -157.81259523770231,
                            21.294592448739209
                        ],
                        [
                            -157.81259462827416,
                            21.294594155459979
                        ],
                        [
                            -157.81259434312668,
                            21.294595933125979
                        ],
                        [
                            -157.81259439326894,
                            21.294597731225043
                        ],
                        [
                            -157.81259477529534,
                            21.29459949372302
                        ],
                        [
                            -157.81259547903107,
                            21.294601167248107
                        ],
                        [
                            -157.81259592562643,
                            21.294601851554368
                        ],
                        [
                            -157.81259598751765,
                            21.294601946846889
                        ],
                        [
                            -157.81259596787703,
                            21.294601991877808
                        ],
                        [
                            -157.81259466301509,
                            21.29460399181125
                        ],
                        [
                            -157.81259454199042,
                            21.294604177959148
                        ],
                        [
                            -157.81259029361715,
                            21.294610690336768
                        ],
                        [
                            -157.8125887000995,
                            21.294613704547167
                        ],
                        [
                            -157.81258546027368,
                            21.294619824741218
                        ],
                        [
                            -157.81258637056936,
                            21.294620263886539
                        ],
                        [
                            -157.81258718914893,
                            21.294620840603432
                        ],
                        [
                            -157.81258789398797,
                            21.294621536668782
                        ],
                        [
                            -157.81258846306201,
                            21.294622333859387
                        ],
                        [
                            -157.81258888306525,
                            21.294623208593283
                        ],
                        [
                            -157.81258913972786,
                            21.294624137281659
                        ],
                        [
                            -157.81258922651301,
                            21.294625093680086
                        ],
                        [
                            -157.81258914172508,
                            21.294626048868178
                        ],
                        [
                            -157.81258901664384,
                            21.294626019980711
                        ],
                        [
                            -157.81258880666741,
                            21.29462599952825
                        ],
                        [
                            -157.81258859641525,
                            21.294626013402642
                        ],
                        [
                            -157.8125883907141,
                            21.294626060734565
                        ],
                        [
                            -157.81258819823901,
                            21.294626141585219
                        ],
                        [
                            -157.81258802383846,
                            21.294626252375217
                        ],
                        [
                            -157.81258792291149,
                            21.294626336581846
                        ],
                        [
                            -157.81258779637906,
                            21.294626476739797
                        ],
                        [
                            -157.81258769576078,
                            21.294626636522963
                        ],
                        [
                            -157.8125876240386,
                            21.29462681119589
                        ],
                        [
                            -157.81258758333814,
                            21.294626995581829
                        ],
                        [
                            -157.81258757486563,
                            21.294627184216186
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 226,
                "NUMBER": "1122A",
                "PROPER_NAME": "HALE ALOHA - `ILIMA TOWER",
                "DISPLAY_NAME": "HALE ALOHA - `ILIMA TOWER - 1122A",
                "ADDRESS": "2575 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE ALOHA - ILIMA TOWER",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1122A_01.jpg",
                "HEIGHT (ft)": 119.90000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 99.605506364223203,
                "SHAPE_Area": 497.57098402786124
            }
        },
        {
            "type": "Feature",
            "id": 227,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.812730168473,
                            21.294166317656682
                        ],
                        [
                            -157.8127302940409,
                            21.294166165869505
                        ],
                        [
                            -157.81273038888764,
                            21.294165998508028
                        ],
                        [
                            -157.81273045490474,
                            21.294165820102521
                        ],
                        [
                            -157.81273048822209,
                            21.29416563243247
                        ],
                        [
                            -157.81273048781776,
                            21.294165442717787
                        ],
                        [
                            -157.81273045365549,
                            21.29416525547515
                        ],
                        [
                            -157.81273041789095,
                            21.294165147719525
                        ],
                        [
                            -157.81273144550093,
                            21.294165022169498
                        ],
                        [
                            -157.81273248049462,
                            21.294165057474927
                        ],
                        [
                            -157.8127334948974,
                            21.294165256148638
                        ],
                        [
                            -157.81273445985065,
                            21.294165610759972
                        ],
                        [
                            -157.8127353465174,
                            21.294166111168238
                        ],
                        [
                            -157.81273613187309,
                            21.29416674366021
                        ],
                        [
                            -157.81273679291499,
                            21.294167491812576
                        ],
                        [
                            -157.81273731151771,
                            21.294168332009392
                        ],
                        [
                            -157.81274888259898,
                            21.294161864953487
                        ],
                        [
                            -157.81274972211529,
                            21.294161394788571
                        ],
                        [
                            -157.81275303560201,
                            21.294159543626286
                        ],
                        [
                            -157.81276438932383,
                            21.29415085450422
                        ],
                        [
                            -157.81276721562747,
                            21.294148691849482
                        ],
                        [
                            -157.81276654972976,
                            21.294147948179919
                        ],
                        [
                            -157.81276602532182,
                            21.294147110652407
                        ],
                        [
                            -157.81276565860838,
                            21.294146201965994
                        ],
                        [
                            -157.81276545803962,
                            21.294145250185345
                        ],
                        [
                            -157.81276543306575,
                            21.294144278865261
                        ],
                        [
                            -157.81276557958458,
                            21.294143318692058
                        ],
                        [
                            -157.81276589643642,
                            21.294142394049057
                        ],
                        [
                            -157.81276637472126,
                            21.294141532878598
                        ],
                        [
                            -157.81276646960961,
                            21.294141600398721
                        ],
                        [
                            -157.81276664622553,
                            21.294141693790195
                        ],
                        [
                            -157.8127668355969,
                            21.294141759266562
                        ],
                        [
                            -157.81276703581773,
                            21.294141794104192
                        ],
                        [
                            -157.8127672382202,
                            21.294141797338575
                        ],
                        [
                            -157.8127674370138,
                            21.294141769832255
                        ],
                        [
                            -157.81276763220575,
                            21.294141710681892
                        ],
                        [
                            -157.81276780884278,
                            21.294141625989639
                        ],
                        [
                            -157.8127679690808,
                            21.294141513307746
                        ],
                        [
                            -157.81276810852538,
                            21.294141375726401
                        ],
                        [
                            -157.81276822335246,
                            21.294141217018613
                        ],
                        [
                            -157.81276831041305,
                            21.294141041536768
                        ],
                        [
                            -157.81276836390677,
                            21.294140862139525
                        ],
                        [
                            -157.81276838373682,
                            21.294140673470945
                        ],
                        [
                            -157.81276837176574,
                            21.294140483674671
                        ],
                        [
                            -157.812768326015,
                            21.294140299060473
                        ],
                        [
                            -157.81276824837607,
                            21.294140124158641
                        ],
                        [
                            -157.81276814074047,
                            21.294139963499479
                        ],
                        [
                            -157.81276806141219,
                            21.294139878924717
                        ],
                        [
                            -157.81276896082733,
                            21.294139392017765
                        ],
                        [
                            -157.81276993231569,
                            21.294139052871692
                        ],
                        [
                            -157.81277094975795,
                            21.294138873046329
                        ],
                        [
                            -157.81277198615061,
                            21.294138854157996
                        ],
                        [
                            -157.81277301062747,
                            21.294138998699133
                        ],
                        [
                            -157.81277399527195,
                            21.294139301955912
                        ],
                        [
                            -157.81277491026873,
                            21.294139755587526
                        ],
                        [
                            -157.81277512783137,
                            21.294139911601693
                        ],
                        [
                            -157.81277573258603,
                            21.294140346784083
                        ],
                        [
                            -157.81277607438639,
                            21.294139916471213
                        ],
                        [
                            -157.81277706278243,
                            21.294138672247861
                        ],
                        [
                            -157.81277832576671,
                            21.294137084866353
                        ],
                        [
                            -157.81278667011708,
                            21.294126586708593
                        ],
                        [
                            -157.81278780221791,
                            21.294124612656457
                        ],
                        [
                            -157.81278785207272,
                            21.29412452628268
                        ],
                        [
                            -157.81279023454448,
                            21.294120374846489
                        ],
                        [
                            -157.81279050242262,
                            21.294119906973229
                        ],
                        [
                            -157.81279534070205,
                            21.294111474529846
                        ],
                        [
                            -157.81279442083513,
                            21.294111027187718
                        ],
                        [
                            -157.81279359461882,
                            21.294110441384113
                        ],
                        [
                            -157.81279288504868,
                            21.294109734445602
                        ],
                        [
                            -157.8127923122068,
                            21.294108926388422
                        ],
                        [
                            -157.81279189134133,
                            21.294108039001447
                        ],
                        [
                            -157.81279163477245,
                            21.294107098569928
                        ],
                        [
                            -157.8127915500082,
                            21.294106130441676
                        ],
                        [
                            -157.81279163971533,
                            21.294105162640612
                        ],
                        [
                            -157.81279175611394,
                            21.294105192370058
                        ],
                        [
                            -157.81279195643629,
                            21.294105214560922
                        ],
                        [
                            -157.81279215892579,
                            21.294105206955212
                        ],
                        [
                            -157.81279235781363,
                            21.29410516770546
                        ],
                        [
                            -157.81279254538143,
                            21.294105097660616
                        ],
                        [
                            -157.81279271870847,
                            21.294105000413637
                        ],
                        [
                            -157.81279287393926,
                            21.294104875937325
                        ],
                        [
                            -157.81279300269574,
                            21.294104734255136
                        ],
                        [
                            -157.81279310517115,
                            21.294104572542846
                        ],
                        [
                            -157.81279317831263,
                            21.294104395618014
                        ],
                        [
                            -157.81279321994126,
                            21.294104208751403
                        ],
                        [
                            -157.81279322881687,
                            21.294104017509937
                        ],
                        [
                            -157.8127932043007,
                            21.294103829431958
                        ],
                        [
                            -157.81279314599033,
                            21.29410364834273
                        ],
                        [
                            -157.8127930567484,
                            21.294103477876028
                        ],
                        [
                            -157.81279293845921,
                            21.294103323465478
                        ],
                        [
                            -157.81279279590595,
                            21.29410318966173
                        ],
                        [
                            -157.8127926309873,
                            21.294103080091769
                        ],
                        [
                            -157.81279252440896,
                            21.294103027846845
                        ],
                        [
                            -157.81279315523395,
                            21.294102257187767
                        ],
                        [
                            -157.81279391434245,
                            21.294101596743641
                        ],
                        [
                            -157.81279478134772,
                            21.294101064438454
                        ],
                        [
                            -157.81279573009414,
                            21.294100676348769
                        ],
                        [
                            -157.81279673544074,
                            21.294100442234548
                        ],
                        [
                            -157.81279776937674,
                            21.294100369125328
                        ],
                        [
                            -157.81279880103583,
                            21.294100459513579
                        ],
                        [
                            -157.81279980055194,
                            21.29410071138188
                        ],
                        [
                            -157.81280275824133,
                            21.294089749733853
                        ],
                        [
                            -157.81280367525989,
                            21.294086350422404
                        ],
                        [
                            -157.81280428827492,
                            21.294084076397155
                        ],
                        [
                            -157.81280495592773,
                            21.294077879335671
                        ],
                        [
                            -157.81280499346414,
                            21.294077526375048
                        ],
                        [
                            -157.81280612672271,
                            21.29406700536072
                        ],
                        [
                            -157.81280509501306,
                            21.294066921295887
                        ],
                        [
                            -157.81280409351135,
                            21.294066676640742
                        ],
                        [
                            -157.81280314819182,
                            21.294066277902211
                        ],
                        [
                            -157.81280228787685,
                            21.294065737027633
                        ],
                        [
                            -157.81280153751882,
                            21.294065067743855
                        ],
                        [
                            -157.81280091719253,
                            21.294064290970425
                        ],
                        [
                            -157.81280044408845,
                            21.294063426703172
                        ],
                        [
                            -157.8128001305268,
                            21.294062501227287
                        ],
                        [
                            -157.81280026079702,
                            21.29406248407831
                        ],
                        [
                            -157.8128004665771,
                            21.294062426809365
                        ],
                        [
                            -157.81280065718158,
                            21.294062338718131
                        ],
                        [
                            -157.81280082971156,
                            21.29406222068755
                        ],
                        [
                            -157.81280097739798,
                            21.294062075380058
                        ],
                        [
                            -157.8128010963346,
                            21.294061909091827
                        ],
                        [
                            -157.81280115510376,
                            21.29406179296905
                        ],
                        [
                            -157.81280120799067,
                            21.294061644182939
                        ],
                        [
                            -157.81280123866964,
                            21.294061489285756
                        ],
                        [
                            -157.81280124648782,
                            21.294061331573328
                        ],
                        [
                            -157.81280123127888,
                            21.294061174401374
                        ],
                        [
                            -157.81280119336648,
                            21.294061021114121
                        ],
                        [
                            -157.81280113355723,
                            21.29406087497313
                        ],
                        [
                            -157.81280106891947,
                            21.29406076159351
                        ],
                        [
                            -157.81280094296997,
                            21.294060600805199
                        ],
                        [
                            -157.81280078792241,
                            21.294060462396395
                        ],
                        [
                            -157.81280061048776,
                            21.294060350931389
                        ],
                        [
                            -157.81280041545642,
                            21.294060270057521
                        ],
                        [
                            -157.81280020762617,
                            21.294060222518794
                        ],
                        [
                            -157.81280007662417,
                            21.294060210754154
                        ],
                        [
                            -157.81280034538986,
                            21.294059272221077
                        ],
                        [
                            -157.81280077661049,
                            21.294058389940581
                        ],
                        [
                            -157.81280135948734,
                            21.294057588228029
                        ],
                        [
                            -157.81280207842411,
                            21.29405688865474
                        ],
                        [
                            -157.8128029120484,
                            21.294056311847989
                        ],
                        [
                            -157.8128038370962,
                            21.294055873904661
                        ],
                        [
                            -157.81280482647713,
                            21.29405558728115
                        ],
                        [
                            -157.81280585312967,
                            21.294055460820516
                        ],
                        [
                            -157.81280486765385,
                            21.294049139175691
                        ],
                        [
                            -157.81280343112104,
                            21.294039928019362
                        ],
                        [
                            -157.81280339353114,
                            21.294039687452575
                        ],
                        [
                            -157.81280320558889,
                            21.29403848371528
                        ],
                        [
                            -157.81279793462636,
                            21.294022052725381
                        ],
                        [
                            -157.81279694712993,
                            21.294022344782483
                        ],
                        [
                            -157.81279592041957,
                            21.294022478469788
                        ],
                        [
                            -157.81279488539059,
                            21.294022447681499
                        ],
                        [
                            -157.81279386996675,
                            21.294022256228097
                        ],
                        [
                            -157.81279290303567,
                            21.294021907926911
                        ],
                        [
                            -157.81279201247051,
                            21.294021412911796
                        ],
                        [
                            -157.81279122225953,
                            21.294020784902816
                        ],
                        [
                            -157.81279055636227,
                            21.294020041233374
                        ],
                        [
                            -157.81279065899886,
                            21.294019984140338
                        ],
                        [
                            -157.81279081801983,
                            21.294019867821262
                        ],
                        [
                            -157.81279095505991,
                            21.29401972785903
                        ],
                        [
                            -157.81279106526341,
                            21.294019568736335
                        ],
                        [
                            -157.81279114666634,
                            21.294019394956251
                        ],
                        [
                            -157.81279119633339,
                            21.294019211918449
                        ],
                        [
                            -157.81279121232961,
                            21.294019020512643
                        ],
                        [
                            -157.81279119414572,
                            21.29401883000445
                        ],
                        [
                            -157.81279114370301,
                            21.294018645397955
                        ],
                        [
                            -157.81279106248275,
                            21.294018472114107
                        ],
                        [
                            -157.81279095286993,
                            21.294018315241374
                        ],
                        [
                            -157.81279081808333,
                            21.294018179386317
                        ],
                        [
                            -157.81279065612176,
                            21.294018061706705
                        ],
                        [
                            -157.81279047754919,
                            21.294017971915014
                        ],
                        [
                            -157.81279028622117,
                            21.294017910038438
                        ],
                        [
                            -157.81279008693537,
                            21.294017878820988
                        ],
                        [
                            -157.81278988449674,
                            21.294017880103329
                        ],
                        [
                            -157.81278968471042,
                            21.294017911216237
                        ],
                        [
                            -157.8127895697319,
                            21.294017944734094
                        ],
                        [
                            -157.81278943383799,
                            21.29401698166556
                        ],
                        [
                            -157.81278947343731,
                            21.29401601170429
                        ],
                        [
                            -157.81278968446389,
                            21.294015061019916
                        ],
                        [
                            -157.81279006284458,
                            21.294014156685396
                        ],
                        [
                            -157.81279059679511,
                            21.294013325719309
                        ],
                        [
                            -157.81279127264685,
                            21.294012589706593
                        ],
                        [
                            -157.81279207094789,
                            21.294011970191413
                        ],
                        [
                            -157.81279296746325,
                            21.294011484167235
                        ],
                        [
                            -157.81279242295898,
                            21.294010628430271
                        ],
                        [
                            -157.81278358901542,
                            21.293996748777321
                        ],
                        [
                            -157.81278050295776,
                            21.29399320650106
                        ],
                        [
                            -157.81277510928194,
                            21.293987015470968
                        ],
                        [
                            -157.8127748619051,
                            21.293986730965173
                        ],
                        [
                            -157.81277200984627,
                            21.293983458645958
                        ],
                        [
                            -157.81277121632849,
                            21.29398408271172
                        ],
                        [
                            -157.81277032362524,
                            21.293984574183028
                        ],
                        [
                            -157.81276935402218,
                            21.293984918762778
                        ],
                        [
                            -157.81276833748686,
                            21.293985105821701
                        ],
                        [
                            -157.81276730200838,
                            21.29398513104023
                        ],
                        [
                            -157.81276627748906,
                            21.293984991919135
                        ],
                        [
                            -157.81276529086708,
                            21.29398469497211
                        ],
                        [
                            -157.81276437100101,
                            21.293984247629869
                        ],
                        [
                            -157.81276444305425,
                            21.293984157799109
                        ],
                        [
                            -157.81276454366969,
                            21.293983992285064
                        ],
                        [
                            -157.81276461257104,
                            21.293983814803269
                        ],
                        [
                            -157.81276464973658,
                            21.293983628063732
                        ],
                        [
                            -157.81276465318777,
                            21.293983438376234
                        ],
                        [
                            -157.81276462384491,
                            21.293983251167596
                        ],
                        [
                            -157.81276456169357,
                            21.293983068244511
                        ],
                        [
                            -157.81276446570038,
                            21.293982897875875
                        ],
                        [
                            -157.81276434320358,
                            21.293982745446556
                        ],
                        [
                            -157.81276419748426,
                            21.293982615039369
                        ],
                        [
                            -157.81276403244544,
                            21.293982510147263
                        ],
                        [
                            -157.81276385250771,
                            21.293982433579774
                        ],
                        [
                            -157.81276365530937,
                            21.293982382502449
                        ],
                        [
                            -157.81276345399431,
                            21.293982363918108
                        ],
                        [
                            -157.81276325243982,
                            21.293982375143951
                        ],
                        [
                            -157.81276305448702,
                            21.29398241801383
                        ],
                        [
                            -157.81276286882539,
                            21.293982490782266
                        ],
                        [
                            -157.81276269738996,
                            21.293982592559512
                        ],
                        [
                            -157.81276260428348,
                            21.293982663270587
                        ],
                        [
                            -157.81276208568119,
                            21.29398182307386
                        ],
                        [
                            -157.8127617257299,
                            21.293980912628339
                        ],
                        [
                            -157.8127615328869,
                            21.293979959095392
                        ],
                        [
                            -157.81276151369639,
                            21.293978987816086
                        ],
                        [
                            -157.81276166792617,
                            21.293978027697243
                        ],
                        [
                            -157.81276199053914,
                            21.293977105805041
                        ],
                        [
                            -157.81276247458501,
                            21.293976247385356
                        ],
                        [
                            -157.81276310636622,
                            21.293975477636497
                        ],
                        [
                            -157.81275609060066,
                            21.293970578756142
                        ],
                        [
                            -157.8127559353066,
                            21.293970471060813
                        ],
                        [
                            -157.81274842396013,
                            21.293965226299967
                        ],
                        [
                            -157.81273796412029,
                            21.293959955321505
                        ],
                        [
                            -157.81273747737256,
                            21.293959709779823
                        ],
                        [
                            -157.81273229880702,
                            21.293957101302563
                        ],
                        [
                            -157.81273182148649,
                            21.29395796247978
                        ],
                        [
                            -157.81273119641622,
                            21.293958736792796
                        ],
                        [
                            -157.81273044209138,
                            21.293959401787369
                        ],
                        [
                            -157.81272957986269,
                            21.293959939546273
                        ],
                        [
                            -157.81272863300126,
                            21.293960333069247
                        ],
                        [
                            -157.81272762952528,
                            21.293960574423416
                        ],
                        [
                            -157.81272659554674,
                            21.293960652952286
                        ],
                        [
                            -157.81272556383792,
                            21.293960568887005
                        ],
                        [
                            -157.81272559363236,
                            21.293960459787005
                        ],
                        [
                            -157.81272561923853,
                            21.293960272062559
                        ],
                        [
                            -157.81272561015919,
                            21.293960082286674
                        ],
                        [
                            -157.81272556826411,
                            21.293959897699658
                        ],
                        [
                            -157.81272549450264,
                            21.293959720115012
                        ],
                        [
                            -157.81272539073726,
                            21.293959557676331
                        ],
                        [
                            -157.81272525791735,
                            21.29395941219714
                        ],
                        [
                            -157.8127251009127,
                            21.293959289565016
                        ],
                        [
                            -157.81272492667432,
                            21.293959192972633
                        ],
                        [
                            -157.81272473948286,
                            21.293959124793037
                        ],
                        [
                            -157.81272454393718,
                            21.293959086701243
                        ],
                        [
                            -157.81272434484137,
                            21.293959079633066
                        ],
                        [
                            -157.81272414126488,
                            21.293959102588651
                        ],
                        [
                            -157.81272394803722,
                            21.293959157235889
                        ],
                        [
                            -157.8127237661441,
                            21.293959240871526
                        ],
                        [
                            -157.81272360138337,
                            21.293959351729725
                        ],
                        [
                            -157.81272345860344,
                            21.293959486231071
                        ],
                        [
                            -157.81272334073233,
                            21.293959639879308
                        ],
                        [
                            -157.81272328498537,
                            21.293959739762357
                        ],
                        [
                            -157.81272246363315,
                            21.293959148572402
                        ],
                        [
                            -157.8127217579559,
                            21.293958437144141
                        ],
                        [
                            -157.81272119093455,
                            21.29395762461084
                        ],
                        [
                            -157.81272077586777,
                            21.293956735457847
                        ],
                        [
                            -157.81272052702519,
                            21.293955793273931
                        ],
                        [
                            -157.81272044900865,
                            21.29395482519325
                        ],
                        [
                            -157.81272054546335,
                            21.29395385743981
                        ],
                        [
                            -157.8127208142148,
                            21.293952920713537
                        ],
                        [
                            -157.81270306322691,
                            21.293948714894217
                        ],
                        [
                            -157.81268484888599,
                            21.29394699193319
                        ],
                        [
                            -157.81268475715621,
                            21.293947971463968
                        ],
                        [
                            -157.81268448828848,
                            21.293948922643601
                        ],
                        [
                            -157.81268405311766,
                            21.293949816639991
                        ],
                        [
                            -157.81268346051471,
                            21.293950629124229
                        ],
                        [
                            -157.81268272996047,
                            21.293951334938768
                        ],
                        [
                            -157.81268188281288,
                            21.293951915263133
                        ],
                        [
                            -157.8126809423577,
                            21.293952351290336
                        ],
                        [
                            -157.81267993662743,
                            21.29395263328087
                        ],
                        [
                            -157.81267976014524,
                            21.293945201655642
                        ],
                        [
                            -157.81267955143139,
                            21.293936382196474
                        ],
                        [
                            -157.81267950153648,
                            21.293934313082087
                        ],
                        [
                            -157.8126792685897,
                            21.293932231835825
                        ],
                        [
                            -157.81267867268377,
                            21.29393021488017
                        ],
                        [
                            -157.8126777297623,
                            21.293928317434354
                        ],
                        [
                            -157.81267646736453,
                            21.293926591185841
                        ],
                        [
                            -157.81267491884205,
                            21.293925084249537
                        ],
                        [
                            -157.81267312629407,
                            21.29392383576814
                        ],
                        [
                            -157.8126711395671,
                            21.293922880422077
                        ],
                        [
                            -157.81266901146466,
                            21.293922244782088
                        ],
                        [
                            -157.81266680064618,
                            21.29392194642638
                        ],
                        [
                            -157.81266456874241,
                            21.293921993016763
                        ],
                        [
                            -157.81266237552902,
                            21.293922383168127
                        ],
                        [
                            -157.81266027892642,
                            21.293923106448361
                        ],
                        [
                            -157.81265833981914,
                            21.293924143412347
                        ],
                        [
                            -157.81265660856167,
                            21.293925465506828
                        ],
                        [
                            -157.8126551326819,
                            21.293927036028101
                        ],
                        [
                            -157.81265395396085,
                            21.293928813714949
                        ],
                        [
                            -157.81265310268537,
                            21.293930748191205
                        ],
                        [
                            -157.8126526024096,
                            21.293932787226417
                        ],
                        [
                            -157.81265246802718,
                            21.293934876722282
                        ],
                        [
                            -157.81265257245221,
                            21.293939277870127
                        ],
                        [
                            -157.8126531183328,
                            21.293962286539479
                        ],
                        [
                            -157.81265315255627,
                            21.293963786407801
                        ],
                        [
                            -157.81265334555493,
                            21.293971921890055
                        ],
                        [
                            -157.812636963399,
                            21.293977793997545
                        ],
                        [
                            -157.81262189492864,
                            21.293986207571596
                        ],
                        [
                            -157.81260858841927,
                            21.293996917342593
                        ],
                        [
                            -157.81259941408965,
                            21.293988695015891
                        ],
                        [
                            -157.81259548060379,
                            21.293985168439782
                        ],
                        [
                            -157.81259396574922,
                            21.293984030323237
                        ],
                        [
                            -157.81259335231968,
                            21.293983715229885
                        ],
                        [
                            -157.81259226274545,
                            21.293983154669217
                        ],
                        [
                            -157.81259042244648,
                            21.293982570744923
                        ],
                        [
                            -157.81258850352614,
                            21.29398229432185
                        ],
                        [
                            -157.81258656181754,
                            21.293982334827778
                        ],
                        [
                            -157.81258465806013,
                            21.293982690884427
                        ],
                        [
                            -157.81258284825387,
                            21.293983351142735
                        ],
                        [
                            -157.8125811875,
                            21.29398429611684
                        ],
                        [
                            -157.81257972808081,
                            21.293985497267133
                        ],
                        [
                            -157.81257851271204,
                            21.293986916952548
                        ],
                        [
                            -157.8125775793265,
                            21.293988512981382
                        ],
                        [
                            -157.81257695626871,
                            21.29399023677054
                        ],
                        [
                            -157.8125766613168,
                            21.293992035145472
                        ],
                        [
                            -157.81257670453044,
                            21.293993855780524
                        ],
                        [
                            -157.81257708348238,
                            21.293995640841636
                        ],
                        [
                            -157.81257778896179,
                            21.293997336963827
                        ],
                        [
                            -157.81257823838175,
                            21.293998029420543
                        ],
                        [
                            -157.81257830122939,
                            21.293998125623187
                        ],
                        [
                            -157.81257828061769,
                            21.293998171550662
                        ],
                        [
                            -157.81257695246833,
                            21.294000191194606
                        ],
                        [
                            -157.81257682950911,
                            21.294000378232255
                        ],
                        [
                            -157.81257250448419,
                            21.294006955113868
                        ],
                        [
                            -157.81257087892556,
                            21.294009998910362
                        ],
                        [
                            -157.81256757691676,
                            21.294016181903604
                        ],
                        [
                            -157.81256849678238,
                            21.294016629246901
                        ],
                        [
                            -157.81256932299721,
                            21.294017215051571
                        ],
                        [
                            -157.81257003256582,
                            21.294017921990957
                        ],
                        [
                            -157.81257060539889,
                            21.294018730952164
                        ],
                        [
                            -157.81257102627001,
                            21.294019617436273
                        ],
                        [
                            -157.81257128283008,
                            21.294020558771429
                        ],
                        [
                            -157.81257136662896,
                            21.294021526892926
                        ],
                        [
                            -157.81257127789161,
                            21.294022493797282
                        ],
                        [
                            -157.81257115089761,
                            21.294022463089551
                        ],
                        [
                            -157.81257093803762,
                            21.294022441713373
                        ],
                        [
                            -157.81257072489467,
                            21.294022455567383
                        ],
                        [
                            -157.81257051823044,
                            21.294022502892528
                        ],
                        [
                            -157.81257032190786,
                            21.294022582812651
                        ],
                        [
                            -157.81257014460911,
                            21.294022694485626
                        ],
                        [
                            -157.81257004270418,
                            21.294022780492142
                        ],
                        [
                            -157.81256991434958,
                            21.294022921782435
                        ],
                        [
                            -157.81256981209995,
                            21.294023082974437
                        ],
                        [
                            -157.81256973897902,
                            21.294023259301344
                        ],
                        [
                            -157.81256969714914,
                            21.294023445548788
                        ],
                        [
                            -157.81256968784729,
                            21.294023636209022
                        ],
                        [
                            -157.81256970127535,
                            21.294023764585081
                        ],
                        [
                            -157.81256975176547,
                            21.294023959170051
                        ],
                        [
                            -157.81256983801381,
                            21.29402414226319
                        ],
                        [
                            -157.81256995620839,
                            21.294024308417303
                        ],
                        [
                            -157.81257010445768,
                            21.294024453102068
                        ],
                        [
                            -157.8125702770146,
                            21.294024571760019
                        ],
                        [
                            -157.81257039222427,
                            21.294024629486312
                        ],
                        [
                            -157.81256976236241,
                            21.294025400151327
                        ],
                        [
                            -157.81256900325337,
                            21.294026060594415
                        ],
                        [
                            -157.81256813625507,
                            21.294026591995088
                        ],
                        [
                            -157.81256718653745,
                            21.294026980980011
                        ],
                        [
                            -157.81256618119832,
                            21.294027214189551
                        ],
                        [
                            -157.8125651482267,
                            21.294027287304164
                        ],
                        [
                            -157.8125641165683,
                            21.294027196914499
                        ],
                        [
                            -157.81256311705314,
                            21.294026945044848
                        ],
                        [
                            -157.8125586292982,
                            21.294043580925404
                        ],
                        [
                            -157.8125584407656,
                            21.29404533126797
                        ],
                        [
                            -157.81255708039816,
                            21.294057962802853
                        ],
                        [
                            -157.81255679082966,
                            21.294060651054522
                        ],
                        [
                            -157.81255782253905,
                            21.294060735120869
                        ],
                        [
                            -157.81255882403298,
                            21.294060980680801
                        ],
                        [
                            -157.81255976935901,
                            21.294061378517334
                        ],
                        [
                            -157.81256062966574,
                            21.294061920296446
                        ],
                        [
                            -157.8125613800226,
                            21.294062589581248
                        ],
                        [
                            -157.81256200034758,
                            21.294063366355498
                        ],
                        [
                            -157.81256236611239,
                            21.294064032927192
                        ],
                        [
                            -157.8125624392726,
                            21.294064165338202
                        ],
                        [
                            -157.81256247345749,
                            21.294064229720018
                        ],
                        [
                            -157.81256278701039,
                            21.294065156099602
                        ],
                        [
                            -157.81256266736469,
                            21.294065170613194
                        ],
                        [
                            -157.81256247223087,
                            21.294065222536606
                        ],
                        [
                            -157.81256228940993,
                            21.29406530164859
                        ],
                        [
                            -157.81256212275019,
                            21.294065408879636
                        ],
                        [
                            -157.8125619771001,
                            21.294065540650436
                        ],
                        [
                            -157.81256185538041,
                            21.294065693368001
                        ],
                        [
                            -157.81256176243957,
                            21.29406586345301
                        ],
                        [
                            -157.8125617094459,
                            21.294066012375087
                        ],
                        [
                            -157.81256167870069,
                            21.294066167426198
                        ],
                        [
                            -157.81256167085928,
                            21.29406632530155
                        ],
                        [
                            -157.8125616860888,
                            21.294066482636151
                        ],
                        [
                            -157.81256172406464,
                            21.294066636076533
                        ],
                        [
                            -157.81256178397737,
                            21.294066782352228
                        ],
                        [
                            -157.81256188578584,
                            21.29406694839075
                        ],
                        [
                            -157.8125620137717,
                            21.294067095642752
                        ],
                        [
                            -157.81256216507231,
                            21.294067220474481
                        ],
                        [
                            -157.81256233681049,
                            21.294067321058876
                        ],
                        [
                            -157.81256252323195,
                            21.294067393741777
                        ],
                        [
                            -157.81256272146678,
                            21.294067435792758
                        ],
                        [
                            -157.81256284090932,
                            21.294067446572651
                        ],
                        [
                            -157.81256257214937,
                            21.294068384201942
                        ],
                        [
                            -157.81256214092008,
                            21.294069267385094
                        ],
                        [
                            -157.81256155707803,
                            21.294070069089955
                        ],
                        [
                            -157.81256083910398,
                            21.294070768668945
                        ],
                        [
                            -157.81256000548603,
                            21.294071344571126
                        ],
                        [
                            -157.81255908043744,
                            21.294071782513075
                        ],
                        [
                            -157.81255809105602,
                            21.294072069135112
                        ],
                        [
                            -157.81255706440325,
                            21.294072195594225
                        ],
                        [
                            -157.81255722299366,
                            21.294073213026383
                        ],
                        [
                            -157.81255971094478,
                            21.294089173598504
                        ],
                        [
                            -157.81256039180866,
                            21.294091294140273
                        ],
                        [
                            -157.8125605441642,
                            21.294091767687867
                        ],
                        [
                            -157.81256498283906,
                            21.294105605504747
                        ],
                        [
                            -157.81256597035096,
                            21.294105311642387
                        ],
                        [
                            -157.8125669970475,
                            21.294105179763196
                        ],
                        [
                            -157.8125680311276,
                            21.294105208739438
                        ],
                        [
                            -157.81256904751552,
                            21.294105400201019
                        ],
                        [
                            -157.81257001443925,
                            21.294105749406818
                        ],
                        [
                            -157.81257090500412,
                            21.294106244423094
                        ],
                        [
                            -157.8125716952145,
                            21.29410687243308
                        ],
                        [
                            -157.81257236111102,
                            21.294107616103354
                        ],
                        [
                            -157.81257225848157,
                            21.29410767229291
                        ],
                        [
                            -157.81257209945309,
                            21.294107789515099
                        ],
                        [
                            -157.81257196241268,
                            21.294107929477136
                        ],
                        [
                            -157.81257185124497,
                            21.294108088592878
                        ],
                        [
                            -157.81257177081292,
                            21.2941082614763
                        ],
                        [
                            -157.81257172113101,
                            21.294108446320688
                        ],
                        [
                            -157.81257170514175,
                            21.294108636823129
                        ],
                        [
                            -157.8125717232839,
                            21.294108827342697
                        ],
                        [
                            -157.81257177370787,
                            21.294109011961943
                        ],
                        [
                            -157.81257185493106,
                            21.294109185252559
                        ],
                        [
                            -157.81257196456528,
                            21.294109342119317
                        ],
                        [
                            -157.81257209938698,
                            21.29410947794991
                        ],
                        [
                            -157.81257226134849,
                            21.294109595629727
                        ],
                        [
                            -157.81257243992104,
                            21.294109685421653
                        ],
                        [
                            -157.81257263125633,
                            21.294109746395133
                        ],
                        [
                            -157.81257283054219,
                            21.294109777612842
                        ],
                        [
                            -157.81257303297366,
                            21.294109777234109
                        ],
                        [
                            -157.81257323276736,
                            21.294109745218115
                        ],
                        [
                            -157.81257334773878,
                            21.294109712603763
                        ],
                        [
                            -157.81257348267468,
                            21.294110674762265
                        ],
                        [
                            -157.81257344403778,
                            21.294111644730204
                        ],
                        [
                            -157.81257323300238,
                            21.294112596317561
                        ],
                        [
                            -157.81257285366345,
                            21.294113499741378
                        ],
                        [
                            -157.81257231970415,
                            21.294114331610022
                        ],
                        [
                            -157.81257164482201,
                            21.29411506672524
                        ],
                        [
                            -157.81257084651224,
                            21.294115687142636
                        ],
                        [
                            -157.81256995000282,
                            21.294116172262225
                        ],
                        [
                            -157.81257709519127,
                            21.29412740030789
                        ],
                        [
                            -157.81257747977082,
                            21.294128004678395
                        ],
                        [
                            -157.81257932842843,
                            21.294130908566537
                        ],
                        [
                            -157.81259090663374,
                            21.294144197800524
                        ],
                        [
                            -157.81259170111704,
                            21.294143573742478
                        ],
                        [
                            -157.81259259382179,
                            21.294143082272218
                        ],
                        [
                            -157.81259356341903,
                            21.2941427385969
                        ],
                        [
                            -157.81259457996285,
                            21.294142550635762
                        ],
                        [
                            -157.81259561542791,
                            21.294142527225016
                        ],
                        [
                            -157.81259663996261,
                            21.294142664540519
                        ],
                        [
                            -157.81259762658527,
                            21.294142961488546
                        ],
                        [
                            -157.81259854548057,
                            21.294143409728267
                        ],
                        [
                            -157.81259847439102,
                            21.294143499565745
                        ],
                        [
                            -157.81259837378258,
                            21.294143664176335
                        ],
                        [
                            -157.81259830487366,
                            21.294143842561386
                        ],
                        [
                            -157.81259826770787,
                            21.294144029300874
                        ],
                        [
                            -157.81259826425645,
                            21.29414421898835
                        ],
                        [
                            -157.81259829263522,
                            21.294144406190206
                        ],
                        [
                            -157.81259835575756,
                            21.29414458821681
                        ],
                        [
                            -157.81259845167241,
                            21.294144758774589
                        ],
                        [
                            -157.81259857413124,
                            21.294144911396515
                        ],
                        [
                            -157.81259871985179,
                            21.29414504199185
                        ],
                        [
                            -157.81259888492826,
                            21.294145147060249
                        ],
                        [
                            -157.81259906493617,
                            21.294145223785563
                        ],
                        [
                            -157.81259926213468,
                            21.294145274863091
                        ],
                        [
                            -157.81259946247877,
                            21.294145294344176
                        ],
                        [
                            -157.81259966501187,
                            21.294145281318663
                        ],
                        [
                            -157.81259986200104,
                            21.294145238442194
                        ],
                        [
                            -157.81260004862685,
                            21.294145165680746
                        ],
                        [
                            -157.81260022004804,
                            21.294145065710364
                        ],
                        [
                            -157.81260031316921,
                            21.29414499319271
                        ],
                        [
                            -157.81260083177108,
                            21.294145833389905
                        ],
                        [
                            -157.81260119171449,
                            21.294146744739063
                        ],
                        [
                            -157.81260138359269,
                            21.294147698265334
                        ],
                        [
                            -157.81260140375329,
                            21.294148668648059
                        ],
                        [
                            -157.81260124952223,
                            21.294149628766675
                        ],
                        [
                            -157.81260092690056,
                            21.294150551561824
                        ],
                        [
                            -157.81260044285312,
                            21.294151409980955
                        ],
                        [
                            -157.81259981106311,
                            21.294152180632466
                        ],
                        [
                            -157.81261244214818,
                            21.294160998286426
                        ],
                        [
                            -157.81261311505568,
                            21.294161469182338
                        ],
                        [
                            -157.81261449349057,
                            21.294162430175437
                        ],
                        [
                            -157.81263061865113,
                            21.294170556088012
                        ],
                        [
                            -157.81263109598024,
                            21.294169694007831
                        ],
                        [
                            -157.81263172105199,
                            21.29416891969527
                        ],
                        [
                            -157.81263247537109,
                            21.294168255604564
                        ],
                        [
                            -157.81263333760137,
                            21.294167717846243
                        ],
                        [
                            -157.81263428447161,
                            21.294167323420552
                        ],
                        [
                            -157.8126352879419,
                            21.294167082970358
                        ],
                        [
                            -157.81263632095803,
                            21.29416700443532
                        ],
                        [
                            -157.81263735363211,
                            21.294167088508015
                        ],
                        [
                            -157.81263732086606,
                            21.294167207524318
                        ],
                        [
                            -157.81263729710045,
                            21.2941674061024
                        ],
                        [
                            -157.81263731091929,
                            21.29416760584899
                        ],
                        [
                            -157.81263731936943,
                            21.294167633913684
                        ],
                        [
                            -157.81263736237344,
                            21.294167800440739
                        ],
                        [
                            -157.81263744862196,
                            21.294167983533853
                        ],
                        [
                            -157.8126375668167,
                            21.29416814968792
                        ],
                        [
                            -157.81263765955231,
                            21.294168245197998
                        ],
                        [
                            -157.81263781655369,
                            21.294168367836534
                        ],
                        [
                            -157.81263799079153,
                            21.294168464432683
                        ],
                        [
                            -157.81263817798424,
                            21.294168532612769
                        ],
                        [
                            -157.81263837353194,
                            21.294168570701387
                        ],
                        [
                            -157.81263857262934,
                            21.294168577762584
                        ],
                        [
                            -157.81263870961064,
                            21.294168565178019
                        ],
                        [
                            -157.81263891627501,
                            21.2941685178528
                        ],
                        [
                            -157.81263911260501,
                            21.294168437029271
                        ],
                        [
                            -157.81263928989665,
                            21.294168326259562
                        ],
                        [
                            -157.8126394442798,
                            21.294168187323198
                        ],
                        [
                            -157.81263956992763,
                            21.29416802559939
                        ],
                        [
                            -157.81263963248725,
                            21.294167917633928
                        ],
                        [
                            -157.81264045384745,
                            21.294168507920972
                        ],
                        [
                            -157.8126411595253,
                            21.294169219349588
                        ],
                        [
                            -157.8126417265469,
                            21.294170031883159
                        ],
                        [
                            -157.81264179949684,
                            21.294170190490945
                        ],
                        [
                            -157.81264214160652,
                            21.294170921939664
                        ],
                        [
                            -157.81264226885042,
                            21.294171401633786
                        ],
                        [
                            -157.81264239044884,
                            21.294171864123662
                        ],
                        [
                            -157.81264246845765,
                            21.294172833107677
                        ],
                        [
                            -157.81264237201674,
                            21.294173799054338
                        ],
                        [
                            -157.8126421032498,
                            21.294174737587099
                        ],
                        [
                            -157.81265985331302,
                            21.294178941600435
                        ],
                        [
                            -157.81267806863133,
                            21.294180666378953
                        ],
                        [
                            -157.81267815833928,
                            21.294179698577992
                        ],
                        [
                            -157.81267842036604,
                            21.294178759094233
                        ],
                        [
                            -157.81267884486954,
                            21.29417787315316
                        ],
                        [
                            -157.81267942295713,
                            21.294177067793729
                        ],
                        [
                            -157.81268013614797,
                            21.29417636366356
                        ],
                        [
                            -157.81268096499019,
                            21.294175782306763
                        ],
                        [
                            -157.81268188719099,
                            21.294175338923747
                        ],
                        [
                            -157.81268287565982,
                            21.294175045970849
                        ],
                        [
                            -157.81268289300155,
                            21.294175167147387
                        ],
                        [
                            -157.81268295410916,
                            21.294175360000427
                        ],
                        [
                            -157.81268304809791,
                            21.294175539534564
                        ],
                        [
                            -157.81268317404738,
                            21.294175700322974
                        ],
                        [
                            -157.81268332909491,
                            21.294175838731867
                        ],
                        [
                            -157.81268350652962,
                            21.294175950197012
                        ],
                        [
                            -157.81268363043625,
                            21.294176005274398
                        ],
                        [
                            -157.81268382303455,
                            21.294176062472108
                        ],
                        [
                            -157.81268402214425,
                            21.294176089323699
                        ],
                        [
                            -157.81268422301383,
                            21.29417608518839
                        ],
                        [
                            -157.81268442084971,
                            21.294176050164861
                        ],
                        [
                            -157.81268461093075,
                            21.294175985088916
                        ],
                        [
                            -157.8126847309465,
                            21.294175924504994
                        ],
                        [
                            -157.81268490347671,
                            21.294175806474549
                        ],
                        [
                            -157.81268505116338,
                            21.294175661167166
                        ],
                        [
                            -157.8126851691363,
                            21.294175494872231
                        ],
                        [
                            -157.81268525543143,
                            21.29417531209284
                        ],
                        [
                            -157.81268530615691,
                            21.294175117318471
                        ],
                        [
                            -157.81268531967413,
                            21.294174994552826
                        ],
                        [
                            -157.81268632015443,
                            21.294175246428605
                        ],
                        [
                            -157.81268726157521,
                            21.294175650560661
                        ],
                        [
                            -157.81268811702009,
                            21.294176197725196
                        ],
                        [
                            -157.81268886445741,
                            21.294176870602438
                        ],
                        [
                            -157.8126894789639,
                            21.294177651852156
                        ],
                        [
                            -157.81268994626254,
                            21.294178518788907
                        ],
                        [
                            -157.81269025209085,
                            21.294179446920587
                        ],
                        [
                            -157.81269038702754,
                            21.294180409079029
                        ],
                        [
                            -157.81270850213639,
                            21.294177927868375
                        ],
                        [
                            -157.81272603548763,
                            21.294172988042494
                        ],
                        [
                            -157.81272572289734,
                            21.294172061669965
                        ],
                        [
                            -157.81272558024204,
                            21.29417110036049
                        ],
                        [
                            -157.81272561309461,
                            21.294170130351688
                        ],
                        [
                            -157.81272581738918,
                            21.294169177813174
                        ],
                        [
                            -157.81272618903799,
                            21.294168271624578
                        ],
                        [
                            -157.81272671723511,
                            21.294167437004596
                        ],
                        [
                            -157.81272738830469,
                            21.294166696441518
                        ],
                        [
                            -157.8127281818237,
                            21.294166072376029
                        ],
                        [
                            -157.81272824177984,
                            21.294166168558231
                        ],
                        [
                            -157.81272836588863,
                            21.294166318492934
                        ],
                        [
                            -157.81272851523994,
                            21.294166446020949
                        ],
                        [
                            -157.81272868502157,
                            21.294166550204931
                        ],
                        [
                            -157.81272887045759,
                            21.294166625590872
                        ],
                        [
                            -157.81272906769243,
                            21.294166672151551
                        ],
                        [
                            -157.81272927096455,
                            21.294166687136194
                        ],
                        [
                            -157.81272946943054,
                            21.294166672177401
                        ],
                        [
                            -157.81272966308688,
                            21.294166626245556
                        ],
                        [
                            -157.81272984713056,
                            21.294166550479851
                        ],
                        [
                            -157.81273001699694,
                            21.294166446759409
                        ],
                        [
                            -157.812730168473,
                            21.294166317656682
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 227,
                "NUMBER": "1122C",
                "PROPER_NAME": "HALE ALOHA - MOKIHANA TOWER",
                "DISPLAY_NAME": "HALE ALOHA - MOKIHANA TOWER - 1122C",
                "ADDRESS": "2583 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE ALOHA - MOKIHANA TOWER",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1122C_01.jpg",
                "HEIGHT (ft)": 119.90000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 101.06168997099125,
                "SHAPE_Area": 509.7794330795324
            }
        },
        {
            "type": "Feature",
            "id": 228,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81324409592733,
                            21.294105436226218
                        ],
                        [
                            -157.81325584009466,
                            21.294108145181792
                        ],
                        [
                            -157.81327429009741,
                            21.294109694485879
                        ],
                        [
                            -157.81327435561658,
                            21.294108857505439
                        ],
                        [
                            -157.81327456845153,
                            21.294108041438175
                        ],
                        [
                            -157.81327492263028,
                            21.294107269730144
                        ],
                        [
                            -157.81327540738332,
                            21.294106563083368
                        ],
                        [
                            -157.81327600905661,
                            21.294105941276175
                        ],
                        [
                            -157.81327671209741,
                            21.294105420459914
                        ],
                        [
                            -157.81327749710459,
                            21.294105015855443
                        ],
                        [
                            -157.81327834374224,
                            21.294104739063428
                        ],
                        [
                            -157.81327835571449,
                            21.294104808708848
                        ],
                        [
                            -157.81327841685913,
                            21.294104997045022
                        ],
                        [
                            -157.81327851184145,
                            21.294105172972305
                        ],
                        [
                            -157.81327863684939,
                            21.294105331043479
                        ],
                        [
                            -157.81327878999869,
                            21.294105465824906
                        ],
                        [
                            -157.81327896650615,
                            21.294105572765943
                        ],
                        [
                            -157.81327915867513,
                            21.29410565000552
                        ],
                        [
                            -157.81327936266462,
                            21.294105695709806
                        ],
                        [
                            -157.81327957272021,
                            21.294105706224649
                        ],
                        [
                            -157.81327978111636,
                            21.294105683302359
                        ],
                        [
                            -157.81327998303354,
                            21.294105626908987
                        ],
                        [
                            -157.81328016978225,
                            21.294105538790003
                        ],
                        [
                            -157.81328033749247,
                            21.294105420724939
                        ],
                        [
                            -157.81328048130845,
                            21.294105277196515
                        ],
                        [
                            -157.81328059637448,
                            21.294105112687411
                        ],
                        [
                            -157.81328067976992,
                            21.294104930790631
                        ],
                        [
                            -157.81328072757393,
                            21.294104739609001
                        ],
                        [
                            -157.81328073585064,
                            21.294104669202945
                        ],
                        [
                            -157.81328159868386,
                            21.294104896616648
                        ],
                        [
                            -157.81328240937216,
                            21.294105255557607
                        ],
                        [
                            -157.81328314584769,
                            21.294105733222818
                        ],
                        [
                            -157.81328378794845,
                            21.29410631953283
                        ],
                        [
                            -157.81328431750555,
                            21.294106996291752
                        ],
                        [
                            -157.81328472212621,
                            21.294107746247803
                        ],
                        [
                            -157.81328498848268,
                            21.294108548529074
                        ],
                        [
                            -157.81328506888184,
                            21.294109100163716
                        ],
                        [
                            -157.81328511000908,
                            21.294109380504516
                        ],
                        [
                            -157.81330100539228,
                            21.294107107620434
                        ],
                        [
                            -157.81330342091786,
                            21.294106762390822
                        ],
                        [
                            -157.81330614275225,
                            21.294105964915605
                        ],
                        [
                            -157.81331767169368,
                            21.294102582598587
                        ],
                        [
                            -157.81331774899343,
                            21.294102559655421
                        ],
                        [
                            -157.81332109791532,
                            21.294101576889052
                        ],
                        [
                            -157.81332081704954,
                            21.294100780829272
                        ],
                        [
                            -157.81332068008621,
                            21.294099950551814
                        ],
                        [
                            -157.81332069164901,
                            21.294099110480769
                        ],
                        [
                            -157.81332085059282,
                            21.294098283192824
                        ],
                        [
                            -157.81332115383012,
                            21.294097493057752
                        ],
                        [
                            -157.81332159059869,
                            21.294096759874243
                        ],
                        [
                            -157.81332215109273,
                            21.294096104351127
                        ],
                        [
                            -157.81332281973781,
                            21.294095545349798
                        ],
                        [
                            -157.81332285403181,
                            21.2940955961814
                        ],
                        [
                            -157.81332297817016,
                            21.294095742502346
                        ],
                        [
                            -157.81332312561591,
                            21.294095867306254
                        ],
                        [
                            -157.81332329254249,
                            21.294095966952565
                        ],
                        [
                            -157.81332347606548,
                            21.294096040517594
                        ],
                        [
                            -157.81332366946668,
                            21.294096084340385
                        ],
                        [
                            -157.81332386792658,
                            21.294096098386976
                        ],
                        [
                            -157.81332406568364,
                            21.294096079906584
                        ],
                        [
                            -157.81332425885327,
                            21.294096032485378
                        ],
                        [
                            -157.81332443972437,
                            21.294095956069
                        ],
                        [
                            -157.81332460442684,
                            21.294095852436918
                        ],
                        [
                            -157.81332475004004,
                            21.294095725182125
                        ],
                        [
                            -157.81332486979497,
                            21.29409557696707
                        ],
                        [
                            -157.81332496365536,
                            21.29409541230844
                        ],
                        [
                            -157.81332502580887,
                            21.294095234778819
                        ],
                        [
                            -157.81332505716867,
                            21.294095050708382
                        ],
                        [
                            -157.81332505481404,
                            21.294094863690084
                        ],
                        [
                            -157.81332501965815,
                            21.294094680054091
                        ],
                        [
                            -157.81332500180102,
                            21.294094623014651
                        ],
                        [
                            -157.81332589232022,
                            21.294094523596161
                        ],
                        [
                            -157.81332678749891,
                            21.294094564235948
                        ],
                        [
                            -157.81332766326875,
                            21.294094741150786
                        ],
                        [
                            -157.81332849553982,
                            21.294095053267423
                        ],
                        [
                            -157.81332926224408,
                            21.294095487782819
                        ],
                        [
                            -157.81332994031348,
                            21.294096036403865
                        ],
                        [
                            -157.81333051447078,
                            21.294096680955032
                        ],
                        [
                            -157.81333096651801,
                            21.294097406853819
                        ],
                        [
                            -157.81334681456417,
                            21.294088421444986
                        ],
                        [
                            -157.81336102859044,
                            21.294077290708284
                        ],
                        [
                            -157.81336044376505,
                            21.294076654212503
                        ],
                        [
                            -157.81335997815796,
                            21.294075936348708
                        ],
                        [
                            -157.81335964606805,
                            21.294075157092283
                        ],
                        [
                            -157.81335945601805,
                            21.294074335474477
                        ],
                        [
                            -157.81335941166051,
                            21.294073496815972
                        ],
                        [
                            -157.81335951667697,
                            21.294072662824082
                        ],
                        [
                            -157.81335976702331,
                            21.294071856958443
                        ],
                        [
                            -157.81336015578555,
                            21.294071099948241
                        ],
                        [
                            -157.81336020852402,
                            21.294071134648846
                        ],
                        [
                            -157.81336038323423,
                            21.294071225316102
                        ],
                        [
                            -157.81336056973589,
                            21.294071288061421
                        ],
                        [
                            -157.8133607651591,
                            21.294071320154362
                        ],
                        [
                            -157.81336096468436,
                            21.294071321560963
                        ],
                        [
                            -157.81336116155728,
                            21.294071293137002
                        ],
                        [
                            -157.8133613509583,
                            21.294071234848502
                        ],
                        [
                            -157.81336152612576,
                            21.29407114845457
                        ],
                        [
                            -157.8133616841607,
                            21.294071034838158
                        ],
                        [
                            -157.81336182020021,
                            21.294070899385328
                        ],
                        [
                            -157.81336193133805,
                            21.294070743882386
                        ],
                        [
                            -157.81336201271131,
                            21.294070573715352
                        ],
                        [
                            -157.81336206428375,
                            21.294070393400958
                        ],
                        [
                            -157.81336208216351,
                            21.294070207428692
                        ],
                        [
                            -157.81336206822766,
                            21.294070022135539
                        ],
                        [
                            -157.8133620214833,
                            21.294069841128014
                        ],
                        [
                            -157.81336194382189,
                            21.294069668936455
                        ],
                        [
                            -157.81336183519278,
                            21.294069511884199
                        ],
                        [
                            -157.81336179508645,
                            21.294069464625196
                        ],
                        [
                            -157.81336257724507,
                            21.294069054579879
                        ],
                        [
                            -157.81336342104871,
                            21.294068770540317
                        ],
                        [
                            -157.81336430233489,
                            21.294068620466717
                        ],
                        [
                            -157.81336519792671,
                            21.294068609615987
                        ],
                        [
                            -157.81336608469806,
                            21.294068736921716
                        ],
                        [
                            -157.81336693568176,
                            21.294068999483638
                        ],
                        [
                            -157.81336772876634,
                            21.294069389918739
                        ],
                        [
                            -157.81336844283325,
                            21.294069897237474
                        ],
                        [
                            -157.8133730357774,
                            21.294064044031348
                        ],
                        [
                            -157.81337941584712,
                            21.294055912427002
                        ],
                        [
                            -157.81338127112306,
                            21.294052589287233
                        ],
                        [
                            -157.81338724675123,
                            21.294041883783798
                        ],
                        [
                            -157.81338726434052,
                            21.294041854095934
                        ],
                        [
                            -157.81338800273576,
                            21.294040531318203
                        ],
                        [
                            -157.8133872018314,
                            21.29404015437893
                        ],
                        [
                            -157.81338647996645,
                            21.294039657845985
                        ],
                        [
                            -157.81338585437493,
                            21.294039056295116
                        ],
                        [
                            -157.8133853422836,
                            21.294038365205378
                        ],
                        [
                            -157.8133849599046,
                            21.294037606372441
                        ],
                        [
                            -157.81338471576063,
                            21.294036798827566
                        ],
                        [
                            -157.81338461739608,
                            21.294035963401882
                        ],
                        [
                            -157.8133846684635,
                            21.294035125416098
                        ],
                        [
                            -157.81338473197874,
                            21.294035138511308
                        ],
                        [
                            -157.81338492941671,
                            21.294035159777746
                        ],
                        [
                            -157.81338512806505,
                            21.294035150337461
                        ],
                        [
                            -157.81338532214772,
                            21.294035109246348
                        ],
                        [
                            -157.81338550681625,
                            21.294035040083756
                        ],
                        [
                            -157.81338567628731,
                            21.294034942808981
                        ],
                        [
                            -157.81338582667635,
                            21.294034821008132
                        ],
                        [
                            -157.81338595410602,
                            21.294034677364092
                        ],
                        [
                            -157.81338605371343,
                            21.294034517262876
                        ],
                        [
                            -157.81338612452734,
                            21.294034341601073
                        ],
                        [
                            -157.81338616261976,
                            21.294034159384847
                        ],
                        [
                            -157.81338616893282,
                            21.294033973331029
                        ],
                        [
                            -157.81338614246636,
                            21.294033787949541
                        ],
                        [
                            -157.81338608412625,
                            21.29403361047385
                        ],
                        [
                            -157.81338599389807,
                            21.294033442710653
                        ],
                        [
                            -157.81338587749983,
                            21.294033292830761
                        ],
                        [
                            -157.81338573588093,
                            21.294033162647654
                        ],
                        [
                            -157.81338557286793,
                            21.294033055801858
                        ],
                        [
                            -157.81338551526653,
                            21.294033026487313
                        ],
                        [
                            -157.81338607001297,
                            21.294032366406498
                        ],
                        [
                            -157.81338673388157,
                            21.29403180195089
                        ],
                        [
                            -157.81338748651461,
                            21.294031347431186
                        ],
                        [
                            -157.81338797875151,
                            21.294031149445317
                        ],
                        [
                            -157.81338831045338,
                            21.294031016275191
                        ],
                        [
                            -157.81338918057864,
                            21.294030815532924
                        ],
                        [
                            -157.81339007466295,
                            21.294030752274814
                        ],
                        [
                            -157.8133909666596,
                            21.294030829027413
                        ],
                        [
                            -157.8133918334569,
                            21.294031042917624
                        ],
                        [
                            -157.81339318674037,
                            21.294025890487937
                        ],
                        [
                            -157.81339444358272,
                            21.294021104154655
                        ],
                        [
                            -157.81339514559386,
                            21.294018429649153
                        ],
                        [
                            -157.81339626023504,
                            21.294014186154101
                        ],
                        [
                            -157.81339702306931,
                            21.294006215502495
                        ],
                        [
                            -157.8133971072279,
                            21.294005338000822
                        ],
                        [
                            -157.81339791335898,
                            21.293996896988304
                        ],
                        [
                            -157.81339702028993,
                            21.293996833779033
                        ],
                        [
                            -157.81339614951401,
                            21.293996635218445
                        ],
                        [
                            -157.81339532607058,
                            21.2939963041932
                        ],
                        [
                            -157.81339457205669,
                            21.29399584989299
                        ],
                        [
                            -157.81339390857633,
                            21.293995285114033
                        ],
                        [
                            -157.81339335284903,
                            21.293994626238753
                        ],
                        [
                            -157.8133932320809,
                            21.293994420317887
                        ],
                        [
                            -157.81339292113049,
                            21.293993889642756
                        ],
                        [
                            -157.81339262577711,
                            21.293993097094507
                        ],
                        [
                            -157.81339270009812,
                            21.293993084970982
                        ],
                        [
                            -157.81339290105123,
                            21.293993028570654
                        ],
                        [
                            -157.81339308877088,
                            21.293992939555007
                        ],
                        [
                            -157.81339325648088,
                            21.29399282148982
                        ],
                        [
                            -157.81339340029663,
                            21.29399267796127
                        ],
                        [
                            -157.81339351535522,
                            21.293992514355427
                        ],
                        [
                            -157.81339359777928,
                            21.293992333355103
                        ],
                        [
                            -157.81339364655423,
                            21.293992141276913
                        ],
                        [
                            -157.81339365776648,
                            21.293991945320347
                        ],
                        [
                            -157.81339363330756,
                            21.293991750015703
                        ],
                        [
                            -157.81339357312669,
                            21.293991561686362
                        ],
                        [
                            -157.81339347814429,
                            21.293991385759153
                        ],
                        [
                            -157.81339335217245,
                            21.293991227681271
                        ],
                        [
                            -157.81339319998702,
                            21.293991092906722
                        ],
                        [
                            -157.81339302348687,
                            21.293990985062486
                        ],
                        [
                            -157.81339283035405,
                            21.29399090781623
                        ],
                        [
                            -157.81339262635746,
                            21.293990863015441
                        ],
                        [
                            -157.8133925512393,
                            21.293990854355382
                        ],
                        [
                            -157.81339257996791,
                            21.29399075789518
                        ],
                        [
                            -157.81339279388871,
                            21.293990046628615
                        ],
                        [
                            -157.81339317592509,
                            21.293989286860739
                        ],
                        [
                            -157.81339368657166,
                            21.293988596657133
                        ],
                        [
                            -157.81339431218171,
                            21.293987994892792
                        ],
                        [
                            -157.81339487921841,
                            21.293987605012145
                        ],
                        [
                            -157.81339503431079,
                            21.293987497698684
                        ],
                        [
                            -157.81339583452908,
                            21.293987119399141
                        ],
                        [
                            -157.81339668962335,
                            21.293986869767824
                        ],
                        [
                            -157.81339745289392,
                            21.293986771258666
                        ],
                        [
                            -157.81339757736623,
                            21.293986755875114
                        ],
                        [
                            -157.81339478471114,
                            21.293969595268681
                        ],
                        [
                            -157.81339386880811,
                            21.293966852444058
                        ],
                        [
                            -157.81338925161515,
                            21.293953028745051
                        ],
                        [
                            -157.8133884002751,
                            21.293953291050293
                        ],
                        [
                            -157.81338751530808,
                            21.293953419416745
                        ],
                        [
                            -157.81338661989099,
                            21.293953408587502
                        ],
                        [
                            -157.81338573714987,
                            21.293953259628946
                        ],
                        [
                            -157.81338489403743,
                            21.29395297724805
                        ],
                        [
                            -157.8133841107518,
                            21.293952567007565
                        ],
                        [
                            -157.81338341225262,
                            21.293952041730858
                        ],
                        [
                            -157.81338281481004,
                            21.293951415986896
                        ],
                        [
                            -157.81338286905611,
                            21.293951382943888
                        ],
                        [
                            -157.81338302614878,
                            21.293951266610637
                        ],
                        [
                            -157.81338315931097,
                            21.293951129330726
                        ],
                        [
                            -157.813383265651,
                            21.29395097108376
                        ],
                        [
                            -157.81338334414701,
                            21.293950799089664
                        ],
                        [
                            -157.8133833908999,
                            21.293950618741263
                        ],
                        [
                            -157.81338340588795,
                            21.293950432748623
                        ],
                        [
                            -157.81338338617599,
                            21.293950246511343
                        ],
                        [
                            -157.81338333556155,
                            21.29395006728334
                        ],
                        [
                            -157.81338325403016,
                            21.293949896871279
                        ],
                        [
                            -157.81338314345882,
                            21.293949741612124
                        ],
                        [
                            -157.81338300766683,
                            21.293949606049747
                        ],
                        [
                            -157.81338284856022,
                            21.293949492907768
                        ],
                        [
                            -157.81338267382114,
                            21.293949405853883
                        ],
                        [
                            -157.81338248439894,
                            21.293949346701599
                        ],
                        [
                            -157.81338228797577,
                            21.293949319118582
                        ],
                        [
                            -157.81338208842888,
                            21.293949320422023
                        ],
                        [
                            -157.81338189249107,
                            21.293949352466175
                        ],
                        [
                            -157.81338183065711,
                            21.293949370098058
                        ],
                        [
                            -157.81338172553089,
                            21.29394853643149
                        ],
                        [
                            -157.81338176793051,
                            21.293947697481205
                        ],
                        [
                            -157.81338195766747,
                            21.293946876733987
                        ],
                        [
                            -157.81338228877715,
                            21.29394609673254
                        ],
                        [
                            -157.81338275434558,
                            21.293945378206093
                        ],
                        [
                            -157.813383338791,
                            21.293944740919372
                        ],
                        [
                            -157.81338402749557,
                            21.29394420464391
                        ],
                        [
                            -157.8133848020511,
                            21.293943780994013
                        ],
                        [
                            -157.81338108546021,
                            21.293937609032238
                        ],
                        [
                            -157.81337934085238,
                            21.29393471040277
                        ],
                        [
                            -157.81337324948521,
                            21.293926449323202
                        ],
                        [
                            -157.81337302445075,
                            21.293926143294399
                        ],
                        [
                            -157.81337299671549,
                            21.293926115997174
                        ],
                        [
                            -157.81337322157853,
                            21.293925722800996
                        ],
                        [
                            -157.81337324799506,
                            21.293925674204168
                        ],
                        [
                            -157.81337356081173,
                            21.293925131665318
                        ],
                        [
                            -157.81337385380084,
                            21.293924297191761
                        ],
                        [
                            -157.81337415171819,
                            21.293923449202094
                        ],
                        [
                            -157.81337442122216,
                            21.293921697622242
                        ],
                        [
                            -157.81337436314152,
                            21.293919926568627
                        ],
                        [
                            -157.81337397701949,
                            21.293918192951612
                        ],
                        [
                            -157.81337327593727,
                            21.293916548356595
                        ],
                        [
                            -157.81337228070163,
                            21.293915042616739
                        ],
                        [
                            -157.81337218892958,
                            21.29391494711383
                        ],
                        [
                            -157.81337102178003,
                            21.293913722923055
                        ],
                        [
                            -157.81336953743076,
                            21.29391262658428
                        ],
                        [
                            -157.81336787267384,
                            21.293911789149941
                        ],
                        [
                            -157.81336607743575,
                            21.29391123536357
                        ],
                        [
                            -157.81336420844815,
                            21.293910982789484
                        ],
                        [
                            -157.81336231868144,
                            21.293911037221427
                        ],
                        [
                            -157.81336046886793,
                            21.2939113981842
                        ],
                        [
                            -157.81335871403624,
                            21.293912055225032
                        ],
                        [
                            -157.8133571073671,
                            21.293912987940868
                        ],
                        [
                            -157.8133556992147,
                            21.293914167778222
                        ],
                        [
                            -157.81335484021949,
                            21.293915023556469
                        ],
                        [
                            -157.81335177541698,
                            21.293918078896276
                        ],
                        [
                            -157.81334333989687,
                            21.293926491417828
                        ],
                        [
                            -157.8133364385626,
                            21.293921504835506
                        ],
                        [
                            -157.81332982760503,
                            21.293916729886476
                        ],
                        [
                            -157.81331473815106,
                            21.293909269009816
                        ],
                        [
                            -157.81330396636889,
                            21.293905990551512
                        ],
                        [
                            -157.81329913532602,
                            21.293904519199074
                        ],
                        [
                            -157.81329911910137,
                            21.293904018606714
                        ],
                        [
                            -157.81329903235493,
                            21.293901375579793
                        ],
                        [
                            -157.81329792512253,
                            21.293867588219896
                        ],
                        [
                            -157.81329784865886,
                            21.293865225316328
                        ],
                        [
                            -157.81329757032134,
                            21.293863033536976
                        ],
                        [
                            -157.81329689228852,
                            21.293860919341455
                        ],
                        [
                            -157.81329583138105,
                            21.293858948795794
                        ],
                        [
                            -157.81329442183491,
                            21.293857179958309
                        ],
                        [
                            -157.81329270658276,
                            21.293855668238425
                        ],
                        [
                            -157.81329073635541,
                            21.293854458259943
                        ],
                        [
                            -157.81328857158059,
                            21.293853587487806
                        ],
                        [
                            -157.81328627952746,
                            21.293853081691235
                        ],
                        [
                            -157.81328392753773,
                            21.293852957605967
                        ],
                        [
                            -157.81328158885961,
                            21.293853216651826
                        ],
                        [
                            -157.8132793329367,
                            21.293853853898053
                        ],
                        [
                            -157.81327723127791,
                            21.29385484726404
                        ],
                        [
                            -157.81327534387646,
                            21.293856168264313
                        ],
                        [
                            -157.81327372986308,
                            21.293857775759825
                        ],
                        [
                            -157.81327243974428,
                            21.293859622226975
                        ],
                        [
                            -157.81327150964808,
                            21.293861650103551
                        ],
                        [
                            -157.81327096994082,
                            21.293863799076533
                        ],
                        [
                            -157.8132708775893,
                            21.293865336898364
                        ],
                        [
                            -157.81327083080004,
                            21.293865521763411
                        ],
                        [
                            -157.81327083754522,
                            21.293866002414365
                        ],
                        [
                            -157.81327099458056,
                            21.293870816782679
                        ],
                        [
                            -157.81327149634609,
                            21.293886123744453
                        ],
                        [
                            -157.81327109968791,
                            21.293886063130966
                        ],
                        [
                            -157.81327023879825,
                            21.293885833924204
                        ],
                        [
                            -157.81326943003887,
                            21.293885474996806
                        ],
                        [
                            -157.81326869357173,
                            21.29388499642824
                        ],
                        [
                            -157.81326805338523,
                            21.293884411938485
                        ],
                        [
                            -157.81326752383617,
                            21.293883734276196
                        ],
                        [
                            -157.8132671211367,
                            21.29388298523703
                        ],
                        [
                            -157.81326685477342,
                            21.293882183859083
                        ],
                        [
                            -157.81326673324003,
                            21.293881352786961
                        ],
                        [
                            -157.81325636762162,
                            21.293882835343641
                        ],
                        [
                            -157.81324842332285,
                            21.293883970904787
                        ],
                        [
                            -157.813245933384,
                            21.293884700453187
                        ],
                        [
                            -157.81324532756082,
                            21.293884878666642
                        ],
                        [
                            -157.81323074634963,
                            21.293889156400148
                        ],
                        [
                            -157.81323102624344,
                            21.293889953356594
                        ],
                        [
                            -157.81323116320613,
                            21.293890783634133
                        ],
                        [
                            -157.81323115164287,
                            21.293891623705164
                        ],
                        [
                            -157.81323099271339,
                            21.293892449186345
                        ],
                        [
                            -157.8132306913966,
                            21.293893240238216
                        ],
                        [
                            -157.81323025366441,
                            21.293893973414715
                        ],
                        [
                            -157.81322969317077,
                            21.293894628937544
                        ],
                        [
                            -157.81322902451905,
                            21.293895188841873
                        ],
                        [
                            -157.81322898926848,
                            21.293895137100126
                        ],
                        [
                            -157.81322886608703,
                            21.293894991689267
                        ],
                        [
                            -157.81322871767765,
                            21.293894866878489
                        ],
                        [
                            -157.81322855075859,
                            21.293894766328748
                        ],
                        [
                            -157.81322836723592,
                            21.29389469276364
                        ],
                        [
                            -157.81322817479889,
                            21.293894648947546
                        ],
                        [
                            -157.81322797633203,
                            21.293894635804172
                        ],
                        [
                            -157.81322777762585,
                            21.293894652471
                        ],
                        [
                            -157.81322758638424,
                            21.293894699905699
                        ],
                        [
                            -157.81322740454223,
                            21.29389477721854
                        ],
                        [
                            -157.81322723888326,
                            21.293894879940407
                        ],
                        [
                            -157.81322709422685,
                            21.293895008105256
                        ],
                        [
                            -157.81322697350811,
                            21.293895156313443
                        ],
                        [
                            -157.81322688060439,
                            21.293895321882147
                        ],
                        [
                            -157.81322681749421,
                            21.293895498501602
                        ],
                        [
                            -157.81322678709824,
                            21.293895682578828
                        ],
                        [
                            -157.81322678946,
                            21.293895868693792
                        ],
                        [
                            -157.81322682364461,
                            21.29389605322633
                        ],
                        [
                            -157.81322684245828,
                            21.293896111175929
                        ],
                        [
                            -157.81322595290413,
                            21.293896210600739
                        ],
                        [
                            -157.813225057734,
                            21.293896169057124
                        ],
                        [
                            -157.81322418100879,
                            21.29389599123169
                        ],
                        [
                            -157.81322334872462,
                            21.29389568092127
                        ],
                        [
                            -157.81322258299278,
                            21.293895245508899
                        ],
                        [
                            -157.81322190298968,
                            21.293894697777219
                        ],
                        [
                            -157.81322132980478,
                            21.293894052329161
                        ],
                        [
                            -157.81322087775138,
                            21.293893327333457
                        ],
                        [
                            -157.8132202047521,
                            21.293893708335911
                        ],
                        [
                            -157.81321980191063,
                            21.293893937666859
                        ],
                        [
                            -157.81321969830316,
                            21.293893995656713
                        ],
                        [
                            -157.81320502875585,
                            21.293902312724473
                        ],
                        [
                            -157.81320090607787,
                            21.29390554128069
                        ],
                        [
                            -157.81319081570723,
                            21.293913442551908
                        ],
                        [
                            -157.81319140053125,
                            21.293914079048225
                        ],
                        [
                            -157.81319186517311,
                            21.293914796905639
                        ],
                        [
                            -157.81319219821845,
                            21.293915577072504
                        ],
                        [
                            -157.81319238827462,
                            21.293916397787122
                        ],
                        [
                            -157.81319243166729,
                            21.29391723643883
                        ],
                        [
                            -157.8131923266501,
                            21.293918070430603
                        ],
                        [
                            -157.81319207726702,
                            21.293918876302779
                        ],
                        [
                            -157.81319168753322,
                            21.293919634209121
                        ],
                        [
                            -157.81319163480214,
                            21.293919598605118
                        ],
                        [
                            -157.81319146105611,
                            21.293919507944487
                        ],
                        [
                            -157.81319127358356,
                            21.293919446095554
                        ],
                        [
                            -157.81319107816785,
                            21.293919413099093
                        ],
                        [
                            -157.81319087961393,
                            21.293919410795752
                        ],
                        [
                            -157.81319068274121,
                            21.293919439219525
                        ],
                        [
                            -157.81319049428973,
                            21.293919499321312
                        ],
                        [
                            -157.81319031719457,
                            21.293919585701477
                        ],
                        [
                            -157.81319015915966,
                            21.293919699317712
                        ],
                        [
                            -157.81319002312017,
                            21.29391983477041
                        ],
                        [
                            -157.81318991295339,
                            21.293919989376707
                        ],
                        [
                            -157.81318983061615,
                            21.293920159536846
                        ],
                        [
                            -157.81318978000746,
                            21.29392033985798
                        ],
                        [
                            -157.81318976213475,
                            21.293920524926882
                        ],
                        [
                            -157.81318977606315,
                            21.293920711123398
                        ],
                        [
                            -157.81318982376391,
                            21.293920893041079
                        ],
                        [
                            -157.81318990143225,
                            21.293921064329371
                        ],
                        [
                            -157.81319000814057,
                            21.293921220464799
                        ],
                        [
                            -157.81319004823956,
                            21.293921268627191
                        ],
                        [
                            -157.8131892670452,
                            21.293921678678526
                        ],
                        [
                            -157.81318842323483,
                            21.293921963620559
                        ],
                        [
                            -157.81318754196394,
                            21.293922111886616
                        ],
                        [
                            -157.81318664540191,
                            21.293922123632981
                        ],
                        [
                            -157.81318575959554,
                            21.29392199633315
                        ],
                        [
                            -157.81318490860576,
                            21.293921734673702
                        ],
                        [
                            -157.81318411456587,
                            21.293921343327654
                        ],
                        [
                            -157.81318340146422,
                            21.293920836014991
                        ],
                        [
                            -157.8131724293998,
                            21.293934821722637
                        ],
                        [
                            -157.81316830810542,
                            21.293942200460602
                        ],
                        [
                            -157.81316384153939,
                            21.29395020190973
                        ],
                        [
                            -157.8131646414715,
                            21.293950579746564
                        ],
                        [
                            -157.81316536429915,
                            21.293951076287204
                        ],
                        [
                            -157.81316598989662,
                            21.293951676935503
                        ],
                        [
                            -157.81316650102997,
                            21.293952367115708
                        ],
                        [
                            -157.81316688340041,
                            21.293953126852436
                        ],
                        [
                            -157.81316712754304,
                            21.293953934397575
                        ],
                        [
                            -157.81316722590631,
                            21.293954769823316
                        ],
                        [
                            -157.81316717579435,
                            21.293955608719134
                        ],
                        [
                            -157.81316711325033,
                            21.293955594727304
                        ],
                        [
                            -157.81316691484861,
                            21.293955573453822
                        ],
                        [
                            -157.81316671619311,
                            21.293955583797192
                        ],
                        [
                            -157.81316652211777,
                            21.293955623984719
                        ],
                        [
                            -157.81316633648532,
                            21.293955693140248
                        ],
                        [
                            -157.81316616701423,
                            21.293955790414824
                        ],
                        [
                            -157.8131660166251,
                            21.293955912215456
                        ],
                        [
                            -157.81316589015921,
                            21.29395605586614
                        ],
                        [
                            -157.81316578958052,
                            21.293956216863744
                        ],
                        [
                            -157.81316571974477,
                            21.293956390725583
                        ],
                        [
                            -157.81316568068095,
                            21.29395657383829
                        ],
                        [
                            -157.81316567436764,
                            21.293956759892069
                        ],
                        [
                            -157.81316570083379,
                            21.293956945273596
                        ],
                        [
                            -157.81316576013023,
                            21.293957123659485
                        ],
                        [
                            -157.81316584940876,
                            21.29395728960932
                        ],
                        [
                            -157.81316596676336,
                            21.293957440399485
                        ],
                        [
                            -157.81316610838198,
                            21.293957570582762
                        ],
                        [
                            -157.81316627139472,
                            21.293957677428747
                        ],
                        [
                            -157.81316632899603,
                            21.29395770674336
                        ],
                        [
                            -157.8131657732923,
                            21.293958365913294
                        ],
                        [
                            -157.81316511134378,
                            21.293958931284955
                        ],
                        [
                            -157.81316435678272,
                            21.293959385790043
                        ],
                        [
                            -157.81316353380058,
                            21.293959717855078
                        ],
                        [
                            -157.81316266368273,
                            21.293959917692849
                        ],
                        [
                            -157.81316176960604,
                            21.293959980046427
                        ],
                        [
                            -157.81316087663888,
                            21.29395990418918
                        ],
                        [
                            -157.81316001079904,
                            21.293959691207945
                        ],
                        [
                            -157.81315665291979,
                            21.293972476696066
                        ],
                        [
                            -157.81315558304686,
                            21.293976546150724
                        ],
                        [
                            -157.81315473793862,
                            21.293985397929088
                        ],
                        [
                            -157.81315455075293,
                            21.293987341607544
                        ],
                        [
                            -157.81315392988054,
                            21.29399383711954
                        ],
                        [
                            -157.81315482392779,
                            21.2939938985302
                        ],
                        [
                            -157.81315569469606,
                            21.293994097995384
                        ],
                        [
                            -157.81315651813162,
                            21.293994429925107
                        ],
                        [
                            -157.81315727214471,
                            21.29399488422635
                        ],
                        [
                            -157.81315793563138,
                            21.293995448102844
                        ],
                        [
                            -157.81315849135754,
                            21.29399610697887
                        ],
                        [
                            -157.8131589230822,
                            21.293996842672072
                        ],
                        [
                            -157.81315921939094,
                            21.293997636130797
                        ],
                        [
                            -157.81315915569445,
                            21.293997645618965
                        ],
                        [
                            -157.81315896345254,
                            21.293997697563491
                        ],
                        [
                            -157.81315878448027,
                            21.293997777606648
                        ],
                        [
                            -157.81315862071267,
                            21.293997884858712
                        ],
                        [
                            -157.81315847893325,
                            21.293998014850555
                        ],
                        [
                            -157.81315836108428,
                            21.293998165789109
                        ],
                        [
                            -157.81315827299261,
                            21.293998332295086
                        ],
                        [
                            -157.81315821373059,
                            21.293998509845025
                        ],
                        [
                            -157.81315818717556,
                            21.293998695756095
                        ],
                        [
                            -157.81315819340006,
                            21.293998880994902
                        ],
                        [
                            -157.81315823241854,
                            21.293999063754754
                        ],
                        [
                            -157.81315830234678,
                            21.293999238602055
                        ],
                        [
                            -157.81315840226438,
                            21.29399940010995
                        ],
                        [
                            -157.81315852932315,
                            21.293999542838026
                        ],
                        [
                            -157.81315867968209,
                            21.293999664952452
                        ],
                        [
                            -157.81315885048576,
                            21.293999761916083
                        ],
                        [
                            -157.81315903403757,
                            21.293999831867929
                        ],
                        [
                            -157.81315922843871,
                            21.293999871181011
                        ],
                        [
                            -157.8131592929613,
                            21.29399987886308
                        ],
                        [
                            -157.81315905031062,
                            21.294000686589449
                        ],
                        [
                            -157.81315866730191,
                            21.294001447253276
                        ],
                        [
                            -157.81315815666144,
                            21.29400213655277
                        ],
                        [
                            -157.81315753200707,
                            21.294002739226325
                        ],
                        [
                            -157.81315680892052,
                            21.294003235509219
                        ],
                        [
                            -157.81315600965826,
                            21.294003614717727
                        ],
                        [
                            -157.81315515360691,
                            21.294003863437677
                        ],
                        [
                            -157.81315426586383,
                            21.29400397732908
                        ],
                        [
                            -157.81315560798387,
                            21.29401222390068
                        ],
                        [
                            -157.81315705945508,
                            21.294021137944974
                        ],
                        [
                            -157.81315825774763,
                            21.294024726527908
                        ],
                        [
                            -157.81316000484037,
                            21.29402995682614
                        ],
                        [
                            -157.8131625915629,
                            21.294037704468202
                        ],
                        [
                            -157.81316344291102,
                            21.29403744126083
                        ],
                        [
                            -157.81316432883531,
                            21.294037313805699
                        ],
                        [
                            -157.81316522522397,
                            21.294037323739627
                        ],
                        [
                            -157.81316610603753,
                            21.294037472685744
                        ],
                        [
                            -157.81316695009937,
                            21.294037756881199
                        ],
                        [
                            -157.81316773242088,
                            21.294038167115907
                        ],
                        [
                            -157.81316843091963,
                            21.294038692393489
                        ],
                        [
                            -157.81316902932548,
                            21.294039318144964
                        ],
                        [
                            -157.8131689741227,
                            21.294039350277778
                        ],
                        [
                            -157.81316881895756,
                            21.294039466624408
                        ],
                        [
                            -157.81316868578784,
                            21.294039604807473
                        ],
                        [
                            -157.81316857849086,
                            21.294039762144152
                        ],
                        [
                            -157.81316850000184,
                            21.294039933234796
                        ],
                        [
                            -157.81316845324139,
                            21.294040114486442
                        ],
                        [
                            -157.81316844144203,
                            21.294040263462563
                        ],
                        [
                            -157.81316843921692,
                            21.294040300485861
                        ],
                        [
                            -157.81316845700812,
                            21.294040485806224
                        ],
                        [
                            -157.8131685076078,
                            21.294040666840957
                        ],
                        [
                            -157.81316858914624,
                            21.294040836349769
                        ],
                        [
                            -157.81316869971741,
                            21.294040991609062
                        ],
                        [
                            -157.81316883647318,
                            21.294041127178382
                        ],
                        [
                            -157.81316899461578,
                            21.29404124031376
                        ],
                        [
                            -157.81316917128262,
                            21.294041327381457
                        ],
                        [
                            -157.81316935974095,
                            21.294041386527205
                        ],
                        [
                            -157.81316955615696,
                            21.294041415013808
                        ],
                        [
                            -157.81316975474732,
                            21.294041412800478
                        ],
                        [
                            -157.81316995068531,
                            21.294041380756596
                        ],
                        [
                            -157.81317001348322,
                            21.294041363131576
                        ],
                        [
                            -157.81317011860099,
                            21.294042197701547
                        ],
                        [
                            -157.81317007523623,
                            21.294043036644936
                        ],
                        [
                            -157.81316988549793,
                            21.294043857391845
                        ],
                        [
                            -157.81316955438692,
                            21.294044637392801
                        ],
                        [
                            -157.81316908978104,
                            21.294045355925387
                        ],
                        [
                            -157.81316850534884,
                            21.294045991404602
                        ],
                        [
                            -157.81316781662855,
                            21.294046529485794
                        ],
                        [
                            -157.81316704303575,
                            21.294046953141439
                        ],
                        [
                            -157.81317663072568,
                            21.29406180562075
                        ],
                        [
                            -157.81318850658459,
                            21.29407512672622
                        ],
                        [
                            -157.81318918478195,
                            21.294074578633467
                        ],
                        [
                            -157.81318995172185,
                            21.294074143186744
                        ],
                        [
                            -157.8131907832128,
                            21.294073831959565
                        ],
                        [
                            -157.81319165894786,
                            21.294073652939268
                        ],
                        [
                            -157.81319255477894,
                            21.294073612279277
                        ],
                        [
                            -157.8131934446811,
                            21.294073709796127
                        ],
                        [
                            -157.81319430456429,
                            21.294073944416567
                        ],
                        [
                            -157.81319511231706,
                            21.29407430875758
                        ],
                        [
                            -157.81319506847063,
                            21.294074367168768
                        ],
                        [
                            -157.81319496875426,
                            21.294074540819938
                        ],
                        [
                            -157.81319490460029,
                            21.294074727369299
                        ],
                        [
                            -157.81319487412446,
                            21.294074921383224
                        ],
                        [
                            -157.81319488121861,
                            21.294075118372223
                        ],
                        [
                            -157.81319492304905,
                            21.294075311089202
                        ],
                        [
                            -157.81319500062324,
                            21.294075494120893
                        ],
                        [
                            -157.81319511109291,
                            21.294075662026906
                        ],
                        [
                            -157.81319525161729,
                            21.294075808463472
                        ],
                        [
                            -157.81319541643467,
                            21.294075930679789
                        ],
                        [
                            -157.81319560174032,
                            21.294076022325306
                        ],
                        [
                            -157.81319580077974,
                            21.294076084255803
                        ],
                        [
                            -157.81319600876247,
                            21.29407611282393
                        ],
                        [
                            -157.81319621895582,
                            21.294076106175435
                        ],
                        [
                            -157.81319642459076,
                            21.294076066972778
                        ],
                        [
                            -157.81319661893463,
                            21.29407599336168
                        ],
                        [
                            -157.81319679712433,
                            21.294075890728227
                        ],
                        [
                            -157.81319685725538,
                            21.294075845079306
                        ],
                        [
                            -157.81319729478554,
                            21.294076578103191
                        ],
                        [
                            -157.81319759786359,
                            21.294077368899416
                        ],
                        [
                            -157.81319775702468,
                            21.294078195719923
                        ],
                        [
                            -157.81319776957292,
                            21.294079034154141
                        ],
                        [
                            -157.81319763373284,
                            21.294079865218393
                        ],
                        [
                            -157.81319735357027,
                            21.294080662743038
                        ],
                        [
                            -157.81319693696312,
                            21.294081406005642
                        ],
                        [
                            -157.81319639563765,
                            21.29408207521432
                        ],
                        [
                            -157.81320825595009,
                            21.294090248693671
                        ],
                        [
                            -157.81321131688628,
                            21.29409235891255
                        ],
                        [
                            -157.81322772995998,
                            21.294100406397234
                        ],
                        [
                            -157.81322813313059,
                            21.294099655812694
                        ],
                        [
                            -157.81322866294735,
                            21.294098979295651
                        ],
                        [
                            -157.8132293038575,
                            21.294098392997462
                        ],
                        [
                            -157.81323004030099,
                            21.294097913972838
                        ],
                        [
                            -157.81323085096352,
                            21.294097555622354
                        ],
                        [
                            -157.81323171264637,
                            21.294097325912929
                        ],
                        [
                            -157.81323260405702,
                            21.294097235535126
                        ],
                        [
                            -157.81323349919214,
                            21.294097281595445
                        ],
                        [
                            -157.81323348224763,
                            21.294097351036996
                        ],
                        [
                            -157.81323346043237,
                            21.294097546918785
                        ],
                        [
                            -157.8132334771727,
                            21.294097743072406
                        ],
                        [
                            -157.81323352866389,
                            21.294097933147306
                        ],
                        [
                            -157.81323361493486,
                            21.294098113530136
                        ],
                        [
                            -157.81323373412314,
                            21.29409827607725
                        ],
                        [
                            -157.81323387951051,
                            21.294098417127724
                        ],
                        [
                            -157.81323405016931,
                            21.294098532158085
                        ],
                        [
                            -157.81323423938861,
                            21.294098616604039
                        ],
                        [
                            -157.81323444138499,
                            21.294098670424834
                        ],
                        [
                            -157.81323465040418,
                            21.294098689966312
                        ],
                        [
                            -157.81323485969892,
                            21.29409867518094
                        ],
                        [
                            -157.81323506347866,
                            21.294098626931248
                        ],
                        [
                            -157.81323525498883,
                            21.29409854607302
                        ],
                        [
                            -157.81323542746048,
                            21.294098435268687
                        ],
                        [
                            -157.81323557797299,
                            21.294098298111233
                        ],
                        [
                            -157.81323570071393,
                            21.294098138173233
                        ],
                        [
                            -157.81323573784212,
                            21.294098076101115
                        ],
                        [
                            -157.81323644121161,
                            21.294098595089036
                        ],
                        [
                            -157.8132370435026,
                            21.294099217254118
                        ],
                        [
                            -157.81323752945232,
                            21.294099922614205
                        ],
                        [
                            -157.81323788280523,
                            21.294100694793656
                        ],
                        [
                            -157.81323809700257,
                            21.294101510258084
                        ],
                        [
                            -157.81323816353617,
                            21.294102348169542
                        ],
                        [
                            -157.8132380826018,
                            21.294103184137903
                        ],
                        [
                            -157.81323785533732,
                            21.29410399648981
                        ],
                        [
                            -157.81324409592733,
                            21.294105436226218
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 228,
                "NUMBER": "1122D",
                "PROPER_NAME": "HALE ALOHA - LOKELANI TOWER",
                "DISPLAY_NAME": "HALE ALOHA - LOKELANI TOWER - 1122D",
                "ADDRESS": "2579 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE ALOHA - LOKELANI TOWER",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1122D_01.jpg",
                "HEIGHT (ft)": 121.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 98.483612778226629,
                "SHAPE_Area": 490.56332003136436
            }
        },
        {
            "type": "Feature",
            "id": 230,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81865180570463,
                            21.292612988740022
                        ],
                        [
                            -157.81867756409201,
                            21.292595727732696
                        ],
                        [
                            -157.81867642411825,
                            21.292594234557335
                        ],
                        [
                            -157.81867069853519,
                            21.292586729654118
                        ],
                        [
                            -157.81868022114915,
                            21.29258034988138
                        ],
                        [
                            -157.81868594673969,
                            21.292587853880949
                        ],
                        [
                            -157.81868708574967,
                            21.292589347049489
                        ],
                        [
                            -157.81873660610779,
                            21.292556162482843
                        ],
                        [
                            -157.81873754228459,
                            21.292555534871671
                        ],
                        [
                            -157.81873640423825,
                            21.292554041710218
                        ],
                        [
                            -157.8187306776824,
                            21.292546537705515
                        ],
                        [
                            -157.8187401993346,
                            21.292540157019008
                        ],
                        [
                            -157.81874592589071,
                            21.292547661023409
                        ],
                        [
                            -157.81874706490822,
                            21.292549153288221
                        ],
                        [
                            -157.81882739951735,
                            21.292495319294808
                        ],
                        [
                            -157.8188262605066,
                            21.292493826127171
                        ],
                        [
                            -157.81882053588319,
                            21.292486321235568
                        ],
                        [
                            -157.81883005752056,
                            21.292479941446917
                        ],
                        [
                            -157.81883578311536,
                            21.29248744544163
                        ],
                        [
                            -157.81883692116227,
                            21.292488938602446
                        ],
                        [
                            -157.81885357071519,
                            21.292477781103994
                        ],
                        [
                            -157.81885547503367,
                            21.292476506229931
                        ],
                        [
                            -157.81888036407457,
                            21.29245982719727
                        ],
                        [
                            -157.81888737955757,
                            21.292455126389655
                        ],
                        [
                            -157.8188862405465,
                            21.292453633222397
                        ],
                        [
                            -157.81888051398639,
                            21.292446129222551
                        ],
                        [
                            -157.81889003562588,
                            21.292439748526892
                        ],
                        [
                            -157.81889576122239,
                            21.292447252519668
                        ],
                        [
                            -157.81889634695517,
                            21.292448019091736
                        ],
                        [
                            -157.81889690119741,
                            21.292448745693626
                        ],
                        [
                            -157.81892231937323,
                            21.292431711720603
                        ],
                        [
                            -157.81891881170878,
                            21.292427114142722
                        ],
                        [
                            -157.81888330865212,
                            21.292380580686089
                        ],
                        [
                            -157.81886531722003,
                            21.292356998795089
                        ],
                        [
                            -157.81882630557382,
                            21.292305867742002
                        ],
                        [
                            -157.81880088742457,
                            21.292322899894607
                        ],
                        [
                            -157.81880202546273,
                            21.29232439395895
                        ],
                        [
                            -157.81880775201432,
                            21.292331897961169
                        ],
                        [
                            -157.81879823037869,
                            21.292338278652409
                        ],
                        [
                            -157.8187925038346,
                            21.292330773746524
                        ],
                        [
                            -157.81879136481817,
                            21.292329281482051
                        ],
                        [
                            -157.81874090837468,
                            21.292363093681058
                        ],
                        [
                            -157.8187420473908,
                            21.292364585945869
                        ],
                        [
                            -157.81874777296238,
                            21.292372091749943
                        ],
                        [
                            -157.81873825132169,
                            21.29237847243752
                        ],
                        [
                            -157.81873252575036,
                            21.292370966633136
                        ],
                        [
                            -157.81873138673427,
                            21.292369474368265
                        ],
                        [
                            -157.81872853460908,
                            21.292371384901056
                        ],
                        [
                            -157.81870633294596,
                            21.292386263339996
                        ],
                        [
                            -157.81865105023567,
                            21.292423308304642
                        ],
                        [
                            -157.81865219020074,
                            21.292424802383472
                        ],
                        [
                            -157.81865791578423,
                            21.292432306383787
                        ],
                        [
                            -157.81864839413589,
                            21.292438687065872
                        ],
                        [
                            -157.8186426685599,
                            21.292431182161913
                        ],
                        [
                            -157.81864152955157,
                            21.292429688993124
                        ],
                        [
                            -157.81859167777259,
                            21.292463096151536
                        ],
                        [
                            -157.81859107206955,
                            21.292463502040214
                        ],
                        [
                            -157.81859221108485,
                            21.292464994305977
                        ],
                        [
                            -157.81859793762325,
                            21.292472499218331
                        ],
                        [
                            -157.81858841500596,
                            21.292478879889988
                        ],
                        [
                            -157.81858268943168,
                            21.292471374984089
                        ],
                        [
                            -157.81858155041644,
                            21.292469882718255
                        ],
                        [
                            -157.81855579301245,
                            21.292487142815062
                        ],
                        [
                            -157.81858398303254,
                            21.292524092427424
                        ],
                        [
                            -157.81857026602822,
                            21.292533284825897
                        ],
                        [
                            -157.81855809769363,
                            21.292541438351794
                        ],
                        [
                            -157.81860365812932,
                            21.292601154279733
                        ],
                        [
                            -157.81862954251741,
                            21.292583807438611
                        ],
                        [
                            -157.81865180570463,
                            21.292612988740022
                        ]
                    ],
                    [
                        [
                            -157.81879834685037,
                            21.292439771873937
                        ],
                        [
                            -157.81877807644238,
                            21.2924132036317
                        ],
                        [
                            -157.81883113208295,
                            21.292377649853773
                        ],
                        [
                            -157.81885140249625,
                            21.292404218089938
                        ],
                        [
                            -157.81883023296618,
                            21.292418403659333
                        ],
                        [
                            -157.81882683036883,
                            21.292420684335259
                        ],
                        [
                            -157.81879834685037,
                            21.292439771873937
                        ]
                    ],
                    [
                        [
                            -157.81864677189171,
                            21.292541345198966
                        ],
                        [
                            -157.81862650149895,
                            21.292514776939409
                        ],
                        [
                            -157.81867955721123,
                            21.292479223213068
                        ],
                        [
                            -157.81869982760929,
                            21.292505791466564
                        ],
                        [
                            -157.81867883637207,
                            21.292519857212351
                        ],
                        [
                            -157.81867162413621,
                            21.292524691235386
                        ],
                        [
                            -157.81864677189171,
                            21.292541345198966
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 230,
                "NUMBER": "1114",
                "PROPER_NAME": "HALE ĀNUENUE",
                "DISPLAY_NAME": "HALE ĀNUENUE - 1114",
                "ADDRESS": "2741 VARSITY PLACE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE ANUENUE",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1114_01.jpg",
                "HEIGHT (ft)": 27.900000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 170.97333519222508,
                "SHAPE_Area": 556.83882067162938
            }
        },
        {
            "type": "Feature",
            "id": 231,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81311041436319,
                            21.301233258000281
                        ],
                        [
                            -157.81310277195769,
                            21.301233483244253
                        ],
                        [
                            -157.8131036356047,
                            21.301259180817265
                        ],
                        [
                            -157.81316631282502,
                            21.301257329175868
                        ],
                        [
                            -157.81316460233407,
                            21.30120647979507
                        ],
                        [
                            -157.81316439299712,
                            21.301200256678051
                        ],
                        [
                            -157.81316412054741,
                            21.301192169424233
                        ],
                        [
                            -157.81317648185689,
                            21.301191803104611
                        ],
                        [
                            -157.81320789903199,
                            21.301190875568292
                        ],
                        [
                            -157.81321700319859,
                            21.301190606425191
                        ],
                        [
                            -157.81321740481249,
                            21.301202536703791
                        ],
                        [
                            -157.81321694661,
                            21.301203415180066
                        ],
                        [
                            -157.81321704486703,
                            21.30120630491135
                        ],
                        [
                            -157.81321765239659,
                            21.301209879389649
                        ],
                        [
                            -157.81321961072527,
                            21.301209821833041
                        ],
                        [
                            -157.8132391969327,
                            21.301209242672698
                        ],
                        [
                            -157.81324115526138,
                            21.301209185115837
                        ],
                        [
                            -157.81326074146153,
                            21.301208606856296
                        ],
                        [
                            -157.81326270076138,
                            21.301208548402645
                        ],
                        [
                            -157.81328228696151,
                            21.301207970140599
                        ],
                        [
                            -157.81328424626136,
                            21.301207911686685
                        ],
                        [
                            -157.81330383245418,
                            21.301207334325461
                        ],
                        [
                            -157.81330579079011,
                            21.30120727586451
                        ],
                        [
                            -157.81330867670158,
                            21.301207190519364
                        ],
                        [
                            -157.8133253769974,
                            21.301206696694084
                        ],
                        [
                            -157.81332733532602,
                            21.301206639136215
                        ],
                        [
                            -157.81334692152606,
                            21.301206060866622
                        ],
                        [
                            -157.81334887985471,
                            21.301206003308504
                        ],
                        [
                            -157.81335030594519,
                            21.301205960064937
                        ],
                        [
                            -157.81336846606195,
                            21.301205424133045
                        ],
                        [
                            -157.81337042535449,
                            21.301205366581474
                        ],
                        [
                            -157.81339001156172,
                            21.301204787403517
                        ],
                        [
                            -157.81339196989035,
                            21.301204729844876
                        ],
                        [
                            -157.81341155609027,
                            21.301204151567742
                        ],
                        [
                            -157.8134135153901,
                            21.301204093112325
                        ],
                        [
                            -157.81343310158996,
                            21.301203514832675
                        ],
                        [
                            -157.81343505992584,
                            21.301203456370196
                        ],
                        [
                            -157.81343481328759,
                            21.301196114594276
                        ],
                        [
                            -157.81344068828045,
                            21.301195941013418
                        ],
                        [
                            -157.81344093587566,
                            21.301203283699472
                        ],
                        [
                            -157.81346350151782,
                            21.301202617114736
                        ],
                        [
                            -157.81346835636842,
                            21.301202473378787
                        ],
                        [
                            -157.81346638133596,
                            21.301143737350777
                        ],
                        [
                            -157.81341958100973,
                            21.301145119276878
                        ],
                        [
                            -157.81340130807618,
                            21.301145659839417
                        ],
                        [
                            -157.81339684952138,
                            21.301145791913719
                        ],
                        [
                            -157.8133963864947,
                            21.301132023708323
                        ],
                        [
                            -157.81339595301137,
                            21.301119138322445
                        ],
                        [
                            -157.81339518257323,
                            21.301096232878269
                        ],
                        [
                            -157.813408892806,
                            21.30109582817342
                        ],
                        [
                            -157.81340883138589,
                            21.301093992956961
                        ],
                        [
                            -157.81340708742633,
                            21.301042138769727
                        ],
                        [
                            -157.81340487016382,
                            21.300976235350088
                        ],
                        [
                            -157.81340365920332,
                            21.300940240303831
                        ],
                        [
                            -157.81340210118597,
                            21.300893922492357
                        ],
                        [
                            -157.81340788938363,
                            21.300893751913694
                        ],
                        [
                            -157.81340782699954,
                            21.300891916690404
                        ],
                        [
                            -157.81340106011808,
                            21.300892116503611
                        ],
                        [
                            -157.81340087490128,
                            21.300886609943976
                        ],
                        [
                            -157.81340764275367,
                            21.300886409234224
                        ],
                        [
                            -157.81340677807398,
                            21.300860713459169
                        ],
                        [
                            -157.81334516841514,
                            21.300862532976005
                        ],
                        [
                            -157.81334690867325,
                            21.300914245305808
                        ],
                        [
                            -157.81334718321995,
                            21.300922432850964
                        ],
                        [
                            -157.81334721924864,
                            21.30092346838898
                        ],
                        [
                            -157.81334736077554,
                            21.300927692731271
                        ],
                        [
                            -157.81332387820521,
                            21.300928386261486
                        ],
                        [
                            -157.8133082916122,
                            21.300928847289093
                        ],
                        [
                            -157.81329447821781,
                            21.300929255775795
                        ],
                        [
                            -157.81329408500994,
                            21.300917598379584
                        ],
                        [
                            -157.81329405880794,
                            21.300916779724254
                        ],
                        [
                            -157.81329405637311,
                            21.300916722793559
                        ],
                        [
                            -157.81329405247467,
                            21.300916608035642
                        ],
                        [
                            -157.81307664537897,
                            21.300923029989164
                        ],
                        [
                            -157.81307664831334,
                            21.300923144740281
                        ],
                        [
                            -157.81307665074809,
                            21.300923201670969
                        ],
                        [
                            -157.8130766695005,
                            21.300923747450245
                        ],
                        [
                            -157.81307455303957,
                            21.300923810213721
                        ],
                        [
                            -157.81307444120134,
                            21.300923812135053
                        ],
                        [
                            -157.81307079259813,
                            21.300923920101962
                        ],
                        [
                            -157.81307054597772,
                            21.300916578326134
                        ],
                        [
                            -157.81304550330634,
                            21.300917317727123
                        ],
                        [
                            -157.81304312553937,
                            21.30091738858437
                        ],
                        [
                            -157.81304510136903,
                            21.300976124617701
                        ],
                        [
                            -157.81311463309353,
                            21.30097407109994
                        ],
                        [
                            -157.81311492862596,
                            21.300982884841563
                        ],
                        [
                            -157.81311522904244,
                            21.300991810637864
                        ],
                        [
                            -157.81311601180613,
                            21.301015096495583
                        ],
                        [
                            -157.81311629899153,
                            21.301023629224282
                        ],
                        [
                            -157.81310356840743,
                            21.301024005582939
                        ],
                        [
                            -157.81310263196556,
                            21.30102357619198
                        ],
                        [
                            -157.81309954742898,
                            21.30102366735991
                        ],
                        [
                            -157.81309573316759,
                            21.301024236694051
                        ],
                        [
                            -157.81309579554775,
                            21.301026071917249
                        ],
                        [
                            -157.81309641257997,
                            21.301044426811721
                        ],
                        [
                            -157.81309647495286,
                            21.301046262938254
                        ],
                        [
                            -157.8130970919851,
                            21.30106461783269
                        ],
                        [
                            -157.81309714248897,
                            21.301066131365598
                        ],
                        [
                            -157.81309715340132,
                            21.301066453049085
                        ],
                        [
                            -157.81309777139751,
                            21.301084807950264
                        ],
                        [
                            -157.81309783281375,
                            21.301086643166673
                        ],
                        [
                            -157.81309844984605,
                            21.301104998061017
                        ],
                        [
                            -157.81309851125502,
                            21.301106834180757
                        ],
                        [
                            -157.81309912924408,
                            21.301125189985196
                        ],
                        [
                            -157.81309919066027,
                            21.301127025201581
                        ],
                        [
                            -157.8130998086566,
                            21.301145380102668
                        ],
                        [
                            -157.81309987007285,
                            21.301147215319041
                        ],
                        [
                            -157.81309989887532,
                            21.301148070128253
                        ],
                        [
                            -157.81310048710526,
                            21.301165570213293
                        ],
                        [
                            -157.81310054948545,
                            21.301167405436466
                        ],
                        [
                            -157.81310116748182,
                            21.301185760337471
                        ],
                        [
                            -157.81310122889806,
                            21.301187595553845
                        ],
                        [
                            -157.81310184592331,
                            21.301205951351335
                        ],
                        [
                            -157.81310186055987,
                            21.301206409472837
                        ],
                        [
                            -157.81310190733956,
                            21.301207786567723
                        ],
                        [
                            -157.81310252533601,
                            21.301226141468639
                        ],
                        [
                            -157.81310258675228,
                            21.301227976685002
                        ],
                        [
                            -157.81310846271006,
                            21.301227803122625
                        ],
                        [
                            -157.8131102291575,
                            21.301227751441029
                        ],
                        [
                            -157.81311041436319,
                            21.301233258000281
                        ]
                    ],
                    [
                        [
                            -157.81331311861541,
                            21.30114826486281
                        ],
                        [
                            -157.81328934385027,
                            21.301148967166924
                        ],
                        [
                            -157.81328535391361,
                            21.30114908447522
                        ],
                        [
                            -157.81328151920698,
                            21.301149198361166
                        ],
                        [
                            -157.81321763483521,
                            21.301151084896638
                        ],
                        [
                            -157.81321683559992,
                            21.3011273273538
                        ],
                        [
                            -157.81321596794004,
                            21.301101526765581
                        ],
                        [
                            -157.81321400864164,
                            21.301101585218753
                        ],
                        [
                            -157.81321436443133,
                            21.3011121393127
                        ],
                        [
                            -157.81320889731029,
                            21.3011123004047
                        ],
                        [
                            -157.81316910879195,
                            21.301113476053178
                        ],
                        [
                            -157.81316148085889,
                            21.301113700498753
                        ],
                        [
                            -157.81316072291301,
                            21.301091164629167
                        ],
                        [
                            -157.81315967168555,
                            21.301059894532091
                        ],
                        [
                            -157.81315847170504,
                            21.30102422026733
                        ],
                        [
                            -157.81321135428871,
                            21.301022658170567
                        ],
                        [
                            -157.81321129287105,
                            21.30102082295414
                        ],
                        [
                            -157.81320003079608,
                            21.301021155473432
                        ],
                        [
                            -157.81319985865858,
                            21.301016061855012
                        ],
                        [
                            -157.81319858170784,
                            21.300978087018464
                        ],
                        [
                            -157.81319836390597,
                            21.300971597341796
                        ],
                        [
                            -157.81321840326186,
                            21.300971005117454
                        ],
                        [
                            -157.81327390947075,
                            21.300969364840554
                        ],
                        [
                            -157.81329384661311,
                            21.30096877640332
                        ],
                        [
                            -157.81329551352803,
                            21.301018335438851
                        ],
                        [
                            -157.81329731468918,
                            21.301018282193215
                        ],
                        [
                            -157.81329747186143,
                            21.301018276977878
                        ],
                        [
                            -157.81329710854436,
                            21.30100745904107
                        ],
                        [
                            -157.81330158830875,
                            21.301007326215412
                        ],
                        [
                            -157.81334393583094,
                            21.301006075530694
                        ],
                        [
                            -157.81334999208681,
                            21.301005896907188
                        ],
                        [
                            -157.81335049857245,
                            21.301020975333419
                        ],
                        [
                            -157.81335183569189,
                            21.301060705879582
                        ],
                        [
                            -157.81335301080631,
                            21.301095640997019
                        ],
                        [
                            -157.81330012818836,
                            21.301097204040484
                        ],
                        [
                            -157.81330018864315,
                            21.301099039250118
                        ],
                        [
                            -157.8133114507242,
                            21.301098706724396
                        ],
                        [
                            -157.81331159796025,
                            21.301103060291517
                        ],
                        [
                            -157.81331289988825,
                            21.301141769759354
                        ],
                        [
                            -157.81331311861541,
                            21.30114826486281
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 231,
                "NUMBER": "1196",
                "PROPER_NAME": "HALE LAULIMA",
                "DISPLAY_NAME": "HALE LAULIMA - 1196",
                "ADDRESS": "1837 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE LAULIMA",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1196_01.jpg",
                "HEIGHT (ft)": 45.200000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 283.14638421422939,
                "SHAPE_Area": 837.45389097666316
            }
        },
        {
            "type": "Feature",
            "id": 232,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81328729591939,
                            21.300779023907683
                        ],
                        [
                            -157.81328730527423,
                            21.30077929950733
                        ],
                        [
                            -157.81328734777367,
                            21.30078048957057
                        ],
                        [
                            -157.81328735569386,
                            21.300780703729643
                        ],
                        [
                            -157.81328747998194,
                            21.30078419349503
                        ],
                        [
                            -157.81328748535128,
                            21.300784365176842
                        ],
                        [
                            -157.81327983130009,
                            21.300784602995119
                        ],
                        [
                            -157.81328011275917,
                            21.300792529509618
                        ],
                        [
                            -157.81328074481388,
                            21.30081033705687
                        ],
                        [
                            -157.81332030620501,
                            21.300809104670282
                        ],
                        [
                            -157.81334351233207,
                            21.300808381185362
                        ],
                        [
                            -157.81334251555413,
                            21.300780289594023
                        ],
                        [
                            -157.81334248006144,
                            21.300779307359718
                        ],
                        [
                            -157.81334119637924,
                            21.300743126605283
                        ],
                        [
                            -157.81339415668876,
                            21.3007414764629
                        ],
                        [
                            -157.81339458035035,
                            21.300753424062073
                        ],
                        [
                            -157.81339412309984,
                            21.300754304352459
                        ],
                        [
                            -157.81339422615116,
                            21.300757197731272
                        ],
                        [
                            -157.81339484039506,
                            21.300760776773512
                        ],
                        [
                            -157.81361256346062,
                            21.300753992560271
                        ],
                        [
                            -157.81361292308921,
                            21.300750382442111
                        ],
                        [
                            -157.81361282099752,
                            21.300747489070023
                        ],
                        [
                            -157.8136123024411,
                            21.300746639841861
                        ],
                        [
                            -157.8136124210412,
                            21.300746636161058
                        ],
                        [
                            -157.81361793739663,
                            21.300746464561801
                        ],
                        [
                            -157.81361812157326,
                            21.300746457729758
                        ],
                        [
                            -157.81361818713526,
                            21.300746456385177
                        ],
                        [
                            -157.8136182829949,
                            21.300749165421934
                        ],
                        [
                            -157.81361844816232,
                            21.300753808200255
                        ],
                        [
                            -157.81362997358895,
                            21.30075345040704
                        ],
                        [
                            -157.81364590845598,
                            21.30075295295838
                        ],
                        [
                            -157.81364382124346,
                            21.300694132120864
                        ],
                        [
                            -157.81359967979068,
                            21.300695507552554
                        ],
                        [
                            -157.81358991214887,
                            21.300695811789147
                        ],
                        [
                            -157.81357418942602,
                            21.300696301694504
                        ],
                        [
                            -157.81357372631334,
                            21.300683262522803
                        ],
                        [
                            -157.81357272946937,
                            21.300655173640433
                        ],
                        [
                            -157.81357272314304,
                            21.300655001048494
                        ],
                        [
                            -157.81357244263924,
                            21.300647073637098
                        ],
                        [
                            -157.81357243631291,
                            21.300646901045145
                        ],
                        [
                            -157.81357242851553,
                            21.300646671529307
                        ],
                        [
                            -157.81358517755655,
                            21.300646273582597
                        ],
                        [
                            -157.81357875559277,
                            21.300465294797753
                        ],
                        [
                            -157.81357793813874,
                            21.300442238154254
                        ],
                        [
                            -157.81357793084842,
                            21.300442065555512
                        ],
                        [
                            -157.81357774773946,
                            21.300436895974606
                        ],
                        [
                            -157.81357774236974,
                            21.300436724292794
                        ],
                        [
                            -157.81358558733413,
                            21.300436478772269
                        ],
                        [
                            -157.81358467472995,
                            21.300410744715485
                        ],
                        [
                            -157.81352190834332,
                            21.300412700691879
                        ],
                        [
                            -157.81352200349119,
                            21.300415378105058
                        ],
                        [
                            -157.81352422340748,
                            21.300477956171992
                        ],
                        [
                            -157.81349332858767,
                            21.300478918171752
                        ],
                        [
                            -157.81347126415577,
                            21.300479606366654
                        ],
                        [
                            -157.81347083953088,
                            21.300467657856913
                        ],
                        [
                            -157.8134590711289,
                            21.300468024767579
                        ],
                        [
                            -157.81345858130641,
                            21.300468039381688
                        ],
                        [
                            -157.81345024459006,
                            21.300468299496679
                        ],
                        [
                            -157.81344190883763,
                            21.300468559618043
                        ],
                        [
                            -157.81344141804394,
                            21.30046857512864
                        ],
                        [
                            -157.81339599327441,
                            21.300469990243872
                        ],
                        [
                            -157.81337361837095,
                            21.300470687077457
                        ],
                        [
                            -157.81335707511244,
                            21.300471202796146
                        ],
                        [
                            -157.81334824856623,
                            21.300471478423226
                        ],
                        [
                            -157.81330748872819,
                            21.300472748441695
                        ],
                        [
                            -157.81330624101577,
                            21.300472787522722
                        ],
                        [
                            -157.81324723412874,
                            21.300474626267668
                        ],
                        [
                            -157.81324697217053,
                            21.300467272639185
                        ],
                        [
                            -157.81321951191669,
                            21.300468129625017
                        ],
                        [
                            -157.8132215989616,
                            21.300526950461336
                        ],
                        [
                            -157.81329123070378,
                            21.30052478012675
                        ],
                        [
                            -157.81329249643304,
                            21.300560434079415
                        ],
                        [
                            -157.81329257653331,
                            21.300562703957887
                        ],
                        [
                            -157.81329263703245,
                            21.300564413596835
                        ],
                        [
                            -157.81329299247705,
                            21.30057441120125
                        ],
                        [
                            -157.81328024249319,
                            21.300574807312604
                        ],
                        [
                            -157.81327930410393,
                            21.30057438061915
                        ],
                        [
                            -157.81327621472076,
                            21.300574476273461
                        ],
                        [
                            -157.81327239655775,
                            21.30057505281172
                        ],
                        [
                            -157.81327963651367,
                            21.300779088237491
                        ],
                        [
                            -157.81328348686256,
                            21.300779426156083
                        ],
                        [
                            -157.81328657625727,
                            21.300779329598502
                        ],
                        [
                            -157.81328729365865,
                            21.300778945296887
                        ],
                        [
                            -157.81328729591939,
                            21.300779023907683
                        ]
                    ],
                    [
                        [
                            -157.81347996612593,
                            21.300697168614509
                        ],
                        [
                            -157.81348001630082,
                            21.300698603550352
                        ],
                        [
                            -157.81348002262706,
                            21.300698776142294
                        ],
                        [
                            -157.81348003821427,
                            21.30069923607731
                        ],
                        [
                            -157.81345764206202,
                            21.300699933674245
                        ],
                        [
                            -157.81339471549674,
                            21.300701893889105
                        ],
                        [
                            -157.8133929546394,
                            21.300652264628212
                        ],
                        [
                            -157.81339099339729,
                            21.300652325780145
                        ],
                        [
                            -157.81339113015881,
                            21.30065618331297
                        ],
                        [
                            -157.81339115678929,
                            21.300656948671392
                        ],
                        [
                            -157.81339136835567,
                            21.300662895367481
                        ],
                        [
                            -157.81339014185539,
                            21.300662933695261
                        ],
                        [
                            -157.8133899586573,
                            21.300662938727179
                        ],
                        [
                            -157.81338773610935,
                            21.30066300797381
                        ],
                        [
                            -157.81333965675961,
                            21.300664505532584
                        ],
                        [
                            -157.81333840807434,
                            21.300664545510315
                        ],
                        [
                            -157.81333807385855,
                            21.300655145195929
                        ],
                        [
                            -157.81333789091769,
                            21.300649955741832
                        ],
                        [
                            -157.81333522826509,
                            21.300574934885564
                        ],
                        [
                            -157.81338818851418,
                            21.300573284742221
                        ],
                        [
                            -157.81338812326024,
                            21.300571446788449
                        ],
                        [
                            -157.81338619673531,
                            21.300571506378414
                        ],
                        [
                            -157.81338443588734,
                            21.300521876213548
                        ],
                        [
                            -157.81347070442291,
                            21.300519187129257
                        ],
                        [
                            -157.8134724662566,
                            21.300568818204717
                        ],
                        [
                            -157.8134744274976,
                            21.30056875705176
                        ],
                        [
                            -157.81347425289965,
                            21.300563848610459
                        ],
                        [
                            -157.8134742287036,
                            21.3005631401827
                        ],
                        [
                            -157.81347404308366,
                            21.300557923607954
                        ],
                        [
                            -157.81347458883633,
                            21.300557906678005
                        ],
                        [
                            -157.81352561387993,
                            21.30055631602082
                        ],
                        [
                            -157.81352698694059,
                            21.300556273305016
                        ],
                        [
                            -157.81352723699919,
                            21.300563309760022
                        ],
                        [
                            -157.81353017535221,
                            21.300646147781219
                        ],
                        [
                            -157.81350363688176,
                            21.300646974272262
                        ],
                        [
                            -157.81349587965317,
                            21.300647216793543
                        ],
                        [
                            -157.81347723146303,
                            21.300647798083659
                        ],
                        [
                            -157.81347726702916,
                            21.30064877128461
                        ],
                        [
                            -157.81347729768197,
                            21.300649636044213
                        ],
                        [
                            -157.81347827734271,
                            21.300649605009266
                        ],
                        [
                            -157.81347832700334,
                            21.300650983931373
                        ],
                        [
                            -157.81347833236563,
                            21.300651156516512
                        ],
                        [
                            -157.8134789456181,
                            21.300668427318467
                        ],
                        [
                            -157.81347996612593,
                            21.300697168614509
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 232,
                "NUMBER": "1189",
                "PROPER_NAME": "HALE KAHAWAI",
                "DISPLAY_NAME": "HALE KAHAWAI - 1189",
                "ADDRESS": "1825 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE KAHAWAI",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1189_01.jpg",
                "HEIGHT (ft)": 45.200000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 278.1644622634729,
                "SHAPE_Area": 847.36025389366728
            }
        },
        {
            "type": "Feature",
            "id": 233,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81352624449895,
                            21.300323825113765
                        ],
                        [
                            -157.81352625099873,
                            21.300324096176361
                        ],
                        [
                            -157.81352628109232,
                            21.30032527079458
                        ],
                        [
                            -157.81352628614286,
                            21.300325482223272
                        ],
                        [
                            -157.8135263722566,
                            21.300328924743489
                        ],
                        [
                            -157.81352637668405,
                            21.300329093708498
                        ],
                        [
                            -157.81351882638435,
                            21.300329259095584
                        ],
                        [
                            -157.81351902292261,
                            21.300337078411896
                        ],
                        [
                            -157.8135194622148,
                            21.300354645203011
                        ],
                        [
                            -157.81355848932,
                            21.300353787508545
                        ],
                        [
                            -157.81358138031445,
                            21.30035328399989
                        ],
                        [
                            -157.81358068698859,
                            21.300325572162915
                        ],
                        [
                            -157.81358066199596,
                            21.30032460265004
                        ],
                        [
                            -157.81357976859246,
                            21.30028891157173
                        ],
                        [
                            -157.81363201233455,
                            21.300287762193925
                        ],
                        [
                            -157.81363230814006,
                            21.300299548089157
                        ],
                        [
                            -157.81363184813119,
                            21.300300412099904
                        ],
                        [
                            -157.81363191968217,
                            21.300303267314469
                        ],
                        [
                            -157.81363248994506,
                            21.300306801780057
                        ],
                        [
                            -157.81384726913993,
                            21.300302078794395
                        ],
                        [
                            -157.81384766110708,
                            21.300298522203196
                        ],
                        [
                            -157.81384758955193,
                            21.300295666988514
                        ],
                        [
                            -157.81384708732438,
                            21.300294825103254
                        ],
                        [
                            -157.81384720398901,
                            21.300294822312001
                        ],
                        [
                            -157.81385264568448,
                            21.300294702574703
                        ],
                        [
                            -157.81385282791092,
                            21.300294698438801
                        ],
                        [
                            -157.81385289250159,
                            21.30029469799068
                        ],
                        [
                            -157.81385295974499,
                            21.300297369786929
                        ],
                        [
                            -157.81385307432467,
                            21.300301950778493
                        ],
                        [
                            -157.81386444365339,
                            21.300301700274243
                        ],
                        [
                            -157.81388016324684,
                            21.300301354860242
                        ],
                        [
                            -157.81387870965142,
                            21.300243328047408
                        ],
                        [
                            -157.81383516549954,
                            21.300244285873539
                        ],
                        [
                            -157.81382552972869,
                            21.300244498005423
                        ],
                        [
                            -157.81381001839398,
                            21.300244839462167
                        ],
                        [
                            -157.81380969652216,
                            21.300231975639406
                        ],
                        [
                            -157.81380900313107,
                            21.300204266511034
                        ],
                        [
                            -157.81380899871053,
                            21.300204096642684
                        ],
                        [
                            -157.81380880312793,
                            21.300196276429322
                        ],
                        [
                            -157.81380879871463,
                            21.300196105657633
                        ],
                        [
                            -157.81380879281573,
                            21.300195879768712
                        ],
                        [
                            -157.81382137021643,
                            21.300195603453613
                        ],
                        [
                            -157.8138168987071,
                            21.300017070330057
                        ],
                        [
                            -157.81381633032055,
                            21.299994324399911
                        ],
                        [
                            -157.81381632494333,
                            21.299994153621423
                        ],
                        [
                            -157.81381619813203,
                            21.299989054901399
                        ],
                        [
                            -157.81381619274754,
                            21.299988885026242
                        ],
                        [
                            -157.81382393297497,
                            21.299988714640094
                        ],
                        [
                            -157.81382329709766,
                            21.299963327627033
                        ],
                        [
                            -157.81376137915188,
                            21.299964689830322
                        ],
                        [
                            -157.81376144568364,
                            21.299967330002982
                        ],
                        [
                            -157.81376299095703,
                            21.300029062262681
                        ],
                        [
                            -157.81373251405489,
                            21.300029731847768
                        ],
                        [
                            -157.81371074730535,
                            21.300030211685499
                        ],
                        [
                            -157.81371045246416,
                            21.300018424893231
                        ],
                        [
                            -157.81369884212455,
                            21.300018680012698
                        ],
                        [
                            -157.81369835811608,
                            21.300018691054984
                        ],
                        [
                            -157.81369013581389,
                            21.300018871587788
                        ],
                        [
                            -157.81368191158384,
                            21.300019052106602
                        ],
                        [
                            -157.81368142757537,
                            21.300019063148856
                        ],
                        [
                            -157.81363661755481,
                            21.300020049041468
                        ],
                        [
                            -157.8136145451835,
                            21.300020533939371
                        ],
                        [
                            -157.81359822494775,
                            21.300020893162998
                        ],
                        [
                            -157.81358951864439,
                            21.300021083829531
                        ],
                        [
                            -157.81354930859584,
                            21.300021969330277
                        ],
                        [
                            -157.81354807833944,
                            21.300021995888883
                        ],
                        [
                            -157.81348986754963,
                            21.300023275720665
                        ],
                        [
                            -157.81348968670792,
                            21.300016022939865
                        ],
                        [
                            -157.81346259688323,
                            21.300016617887497
                        ],
                        [
                            -157.81346405031755,
                            21.300074644697748
                        ],
                        [
                            -157.81353274148455,
                            21.300073134324009
                        ],
                        [
                            -157.81353362266117,
                            21.300108305867894
                        ],
                        [
                            -157.81353367794244,
                            21.300110545759676
                        ],
                        [
                            -157.81353372031833,
                            21.300112231782837
                        ],
                        [
                            -157.81353396697958,
                            21.300122093112524
                        ],
                        [
                            -157.81352138957851,
                            21.300122370309744
                        ],
                        [
                            -157.81352046857828,
                            21.300121939223345
                        ],
                        [
                            -157.81351742184947,
                            21.300122006274741
                        ],
                        [
                            -157.81351364934446,
                            21.300122540681617
                        ],
                        [
                            -157.81351869075777,
                            21.300323818832638
                        ],
                        [
                            -157.81352248494835,
                            21.30032418616122
                        ],
                        [
                            -157.81352553071741,
                            21.300324119103127
                        ],
                        [
                            -157.81352624319479,
                            21.300323747413092
                        ],
                        [
                            -157.81352624449895,
                            21.300323825113765
                        ]
                    ],
                    [
                        [
                            -157.81371709019191,
                            21.300244842981225
                        ],
                        [
                            -157.8137171260625,
                            21.300246258845139
                        ],
                        [
                            -157.81371712951901,
                            21.300246428706711
                        ],
                        [
                            -157.81371714130199,
                            21.300246882291198
                        ],
                        [
                            -157.81369504671881,
                            21.300247367945133
                        ],
                        [
                            -157.81363297150548,
                            21.300248732601251
                        ],
                        [
                            -157.81363174501485,
                            21.300199773805808
                        ],
                        [
                            -157.81362980995709,
                            21.300199816174203
                        ],
                        [
                            -157.8136299056894,
                            21.300203621924812
                        ],
                        [
                            -157.8136299237328,
                            21.300204376382073
                        ],
                        [
                            -157.81363007137111,
                            21.300210242226203
                        ],
                        [
                            -157.8136288623196,
                            21.300210268934823
                        ],
                        [
                            -157.81362868009325,
                            21.300210273070494
                        ],
                        [
                            -157.81362648760071,
                            21.300210321754488
                        ],
                        [
                            -157.81357905887842,
                            21.300211365052757
                        ],
                        [
                            -157.8135778276565,
                            21.300211391604709
                        ],
                        [
                            -157.81357759554302,
                            21.300202119387457
                        ],
                        [
                            -157.8135774669791,
                            21.300196999877379
                        ],
                        [
                            -157.81357561352749,
                            21.30012299200056
                        ],
                        [
                            -157.81362785816748,
                            21.300121843531421
                        ],
                        [
                            -157.81362781199326,
                            21.300120030103571
                        ],
                        [
                            -157.81362591260924,
                            21.300120071820054
                        ],
                        [
                            -157.81362468612699,
                            21.300071112120666
                        ],
                        [
                            -157.81370978816668,
                            21.300069240377294
                        ],
                        [
                            -157.8137110156411,
                            21.300118200084199
                        ],
                        [
                            -157.81371294973388,
                            21.30011815770802
                        ],
                        [
                            -157.81371282857847,
                            21.300113315590565
                        ],
                        [
                            -157.81371281105626,
                            21.300112616243716
                        ],
                        [
                            -157.81371268269785,
                            21.300107470536659
                        ],
                        [
                            -157.81371322070115,
                            21.300107458068197
                        ],
                        [
                            -157.81376355631363,
                            21.300106351206118
                        ],
                        [
                            -157.81376491095398,
                            21.300106321005806
                        ],
                        [
                            -157.81376508465672,
                            21.300113263873914
                        ],
                        [
                            -157.81376713081272,
                            21.300194981732002
                        ],
                        [
                            -157.81374095014323,
                            21.300195557836904
                        ],
                        [
                            -157.81373329765174,
                            21.300195725223702
                        ],
                        [
                            -157.81371490253241,
                            21.300196130358735
                        ],
                        [
                            -157.81371492759121,
                            21.300197091741616
                        ],
                        [
                            -157.81371494870768,
                            21.3001979437866
                        ],
                        [
                            -157.81371591575461,
                            21.300197922598532
                        ],
                        [
                            -157.81371595014687,
                            21.300199282441891
                        ],
                        [
                            -157.81371595360338,
                            21.300199452303442
                        ],
                        [
                            -157.81371637981769,
                            21.300216489616915
                        ],
                        [
                            -157.81371709019191,
                            21.300244842981225
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 233,
                "NUMBER": "1180",
                "PROPER_NAME": "HALE KUAHINE",
                "DISPLAY_NAME": "HALE KUAHINE - 1180",
                "ADDRESS": "1811 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE KUAHINE COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1180_01.jpg",
                "HEIGHT (ft)": 41.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 274.32939183158237,
                "SHAPE_Area": 824.15524129387063
            }
        },
        {
            "type": "Feature",
            "id": 234,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81271400147642,
                            21.293663594620213
                        ],
                        [
                            -157.81271156869965,
                            21.29366416827753
                        ],
                        [
                            -157.81271252430406,
                            21.293667727146353
                        ],
                        [
                            -157.8127153723577,
                            21.293667056141913
                        ],
                        [
                            -157.81271513369757,
                            21.293666166426419
                        ],
                        [
                            -157.81271543019136,
                            21.293666096246547
                        ],
                        [
                            -157.81271578656225,
                            21.293666012034794
                        ],
                        [
                            -157.8127407710133,
                            21.293660125611606
                        ],
                        [
                            -157.8127410096736,
                            21.293661015327075
                        ],
                        [
                            -157.8127448080493,
                            21.293660119757281
                        ],
                        [
                            -157.81274456938897,
                            21.293659230041818
                        ],
                        [
                            -157.81275973680107,
                            21.293655655708264
                        ],
                        [
                            -157.81277174130818,
                            21.293652827849616
                        ],
                        [
                            -157.81285294028868,
                            21.293633694896727
                        ],
                        [
                            -157.81285409052703,
                            21.293633422958116
                        ],
                        [
                            -157.81288795038367,
                            21.293625445426219
                        ],
                        [
                            -157.81288818904483,
                            21.293626335141518
                        ],
                        [
                            -157.81289198741891,
                            21.293625439568316
                        ],
                        [
                            -157.81289103181763,
                            21.293621879796966
                        ],
                        [
                            -157.81288984585032,
                            21.293622159614358
                        ],
                        [
                            -157.81288680125397,
                            21.293610813248065
                        ],
                        [
                            -157.81295861486052,
                            21.293593891498222
                        ],
                        [
                            -157.81295971873027,
                            21.29359363187934
                        ],
                        [
                            -157.81303136814904,
                            21.29357674778565
                        ],
                        [
                            -157.81303196623887,
                            21.293578973438724
                        ],
                        [
                            -157.81303576461104,
                            21.293578077862172
                        ],
                        [
                            -157.81303516650661,
                            21.293575854015792
                        ],
                        [
                            -157.81304756890765,
                            21.29357293137663
                        ],
                        [
                            -157.81304669926718,
                            21.293567308869761
                        ],
                        [
                            -157.81304169694425,
                            21.293534944887174
                        ],
                        [
                            -157.81304218136651,
                            21.293534879645449
                        ],
                        [
                            -157.81304049806226,
                            21.293523986445017
                        ],
                        [
                            -157.81306322258192,
                            21.293518632394065
                        ],
                        [
                            -157.81306752713982,
                            21.293517361865685
                        ],
                        [
                            -157.81306728340979,
                            21.293515542526681
                        ],
                        [
                            -157.81306712795509,
                            21.293514374250833
                        ],
                        [
                            -157.81306704161477,
                            21.293513722297927
                        ],
                        [
                            -157.81306667145412,
                            21.293510961638603
                        ],
                        [
                            -157.81306561035325,
                            21.293503012456252
                        ],
                        [
                            -157.81306542667889,
                            21.293501637105148
                        ],
                        [
                            -157.81306374720231,
                            21.293502033594759
                        ],
                        [
                            -157.81305276445482,
                            21.293504625668
                        ],
                        [
                            -157.81302629846493,
                            21.293510872081807
                        ],
                        [
                            -157.81301824393518,
                            21.293512772930118
                        ],
                        [
                            -157.81301358672602,
                            21.293495414878834
                        ],
                        [
                            -157.81301340233787,
                            21.293494728809101
                        ],
                        [
                            -157.81300281791101,
                            21.293455272697859
                        ],
                        [
                            -157.81300091921204,
                            21.293455720037567
                        ],
                        [
                            -157.81300282849054,
                            21.293462839565723
                        ],
                        [
                            -157.81281905054948,
                            21.293506143868989
                        ],
                        [
                            -157.81281890664749,
                            21.293506178086286
                        ],
                        [
                            -157.81281766756572,
                            21.293506470176048
                        ],
                        [
                            -157.81282101071992,
                            21.293518928915134
                        ],
                        [
                            -157.81278309271974,
                            21.293527863410525
                        ],
                        [
                            -157.81271181320352,
                            21.293544658765128
                        ],
                        [
                            -157.81270990393838,
                            21.293537539234332
                        ],
                        [
                            -157.81270800426645,
                            21.293537987467197
                        ],
                        [
                            -157.81271967806109,
                            21.29358150117379
                        ],
                        [
                            -157.81272016565754,
                            21.29358332132983
                        ],
                        [
                            -157.81272161262669,
                            21.293588711221915
                        ],
                        [
                            -157.8126959753229,
                            21.293594752034402
                        ],
                        [
                            -157.8126954380989,
                            21.293592749946921
                        ],
                        [
                            -157.81269410340275,
                            21.29359306484945
                        ],
                        [
                            -157.81269352587393,
                            21.293593200801212
                        ],
                        [
                            -157.81269258907545,
                            21.293593421847628
                        ],
                        [
                            -157.81269354467176,
                            21.293596981619899
                        ],
                        [
                            -157.81269591757766,
                            21.293596421091337
                        ],
                        [
                            -157.81270112412182,
                            21.293615829202412
                        ],
                        [
                            -157.81270164358347,
                            21.293617762506965
                        ],
                        [
                            -157.81270689600285,
                            21.293637339875325
                        ],
                        [
                            -157.81270695491605,
                            21.293637325836642
                        ],
                        [
                            -157.81271400147642,
                            21.293663594620213
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 234,
                "NUMBER": "1123E",
                "PROPER_NAME": "HALE NOELANI TOWER E",
                "DISPLAY_NAME": "HALE NOELANI TOWER E - 1123E",
                "ADDRESS": "2585 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE NOELANI TOWERS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1123E_01.jpg",
                "HEIGHT (ft)": 42,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 113.92975270930168,
                "SHAPE_Area": 462.83378541473172
            }
        },
        {
            "type": "Feature",
            "id": 235,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81308462459131,
                            21.293719194922026
                        ],
                        [
                            -157.81309051500332,
                            21.293763290262007
                        ],
                        [
                            -157.81309245725382,
                            21.293763061848878
                        ],
                        [
                            -157.81309148428096,
                            21.293755781796687
                        ],
                        [
                            -157.81320509070437,
                            21.293742453810573
                        ],
                        [
                            -157.81320338847243,
                            21.293729713949126
                        ],
                        [
                            -157.81335292013506,
                            21.293712170986012
                        ],
                        [
                            -157.81335462238707,
                            21.293724909943229
                        ],
                        [
                            -157.81339249182415,
                            21.29372046753549
                        ],
                        [
                            -157.8133933065352,
                            21.293726570257242
                        ],
                        [
                            -157.81339339836313,
                            21.293727259287678
                        ],
                        [
                            -157.81339349111869,
                            21.293727952841614
                        ],
                        [
                            -157.81339543336117,
                            21.293727725328278
                        ],
                        [
                            -157.81339540609761,
                            21.293727519163188
                        ],
                        [
                            -157.81339443310989,
                            21.29372023911203
                        ],
                        [
                            -157.81367486220086,
                            21.293687338575456
                        ],
                        [
                            -157.81368344165247,
                            21.293686332137803
                        ],
                        [
                            -157.81369544053666,
                            21.293684924302074
                        ],
                        [
                            -157.81369595701594,
                            21.293688792644385
                        ],
                        [
                            -157.81369641161137,
                            21.293692204338615
                        ],
                        [
                            -157.81369835386033,
                            21.293691975918385
                        ],
                        [
                            -157.8136973808505,
                            21.293684696771606
                        ],
                        [
                            -157.81373511712403,
                            21.293680269608451
                        ],
                        [
                            -157.81372405618401,
                            21.29359746010477
                        ],
                        [
                            -157.81372418933816,
                            21.293597443878753
                        ],
                        [
                            -157.81372394559989,
                            21.29359562454033
                        ],
                        [
                            -157.81371696973633,
                            21.29359644263241
                        ],
                        [
                            -157.81371466102186,
                            21.293579152641588
                        ],
                        [
                            -157.81371969368053,
                            21.293578562060009
                        ],
                        [
                            -157.8137164119629,
                            21.29355399201906
                        ],
                        [
                            -157.81371835420279,
                            21.293553764501851
                        ],
                        [
                            -157.8137181114358,
                            21.293551944266888
                        ],
                        [
                            -157.8136943211351,
                            21.293554735205479
                        ],
                        [
                            -157.81364213144028,
                            21.29356085824055
                        ],
                        [
                            -157.81363878967846,
                            21.293535844210894
                        ],
                        [
                            -157.81363823681289,
                            21.293531705498353
                        ],
                        [
                            -157.81361437124443,
                            21.29353450673592
                        ],
                        [
                            -157.81360109685232,
                            21.293536062766204
                        ],
                        [
                            -157.81360110043966,
                            21.293536096216915
                        ],
                        [
                            -157.8135989169817,
                            21.293536352747878
                        ],
                        [
                            -157.81360034275269,
                            21.293547030929179
                        ],
                        [
                            -157.81360311889568,
                            21.293567813107671
                        ],
                        [
                            -157.81360414371761,
                            21.293575481981133
                        ],
                        [
                            -157.81360292896591,
                            21.293575625188854
                        ],
                        [
                            -157.8136030808158,
                            21.293576762723706
                        ],
                        [
                            -157.81355564010448,
                            21.293582328386069
                        ],
                        [
                            -157.81355371619242,
                            21.293582554223768
                        ],
                        [
                            -157.81349335903056,
                            21.29358963505392
                        ],
                        [
                            -157.81349320718149,
                            21.293588497519007
                        ],
                        [
                            -157.81348932365705,
                            21.293588953458247
                        ],
                        [
                            -157.81348947550606,
                            21.293590090993142
                        ],
                        [
                            -157.81347067250292,
                            21.293592297328903
                        ],
                        [
                            -157.81346898171415,
                            21.293579570197206
                        ],
                        [
                            -157.81337610470322,
                            21.293590412926857
                        ],
                        [
                            -157.81337577552617,
                            21.293587949772178
                        ],
                        [
                            -157.8133738342494,
                            21.293588177292182
                        ],
                        [
                            -157.81337416889798,
                            21.293590679331189
                        ],
                        [
                            -157.81334944460903,
                            21.293593580173592
                        ],
                        [
                            -157.81334567107606,
                            21.293594023334062
                        ],
                        [
                            -157.81330231456275,
                            21.293599110011634
                        ],
                        [
                            -157.81330198088651,
                            21.293596607076001
                        ],
                        [
                            -157.81329809736147,
                            21.29359706301079
                        ],
                        [
                            -157.81329843104487,
                            21.293599565043092
                        ],
                        [
                            -157.8132086189085,
                            21.293610102259464
                        ],
                        [
                            -157.81320677411426,
                            21.293610318713693
                        ],
                        [
                            -157.81315084077036,
                            21.293616880445668
                        ],
                        [
                            -157.81315050612554,
                            21.293614378406403
                        ],
                        [
                            -157.81314662260701,
                            21.293614833434301
                        ],
                        [
                            -157.8131471390717,
                            21.293618701777643
                        ],
                        [
                            -157.81314835285292,
                            21.293618559469788
                        ],
                        [
                            -157.81314972044171,
                            21.293628796389072
                        ],
                        [
                            -157.81310719561171,
                            21.293633785893334
                        ],
                        [
                            -157.81310517232387,
                            21.293634022769201
                        ],
                        [
                            -157.81307713858385,
                            21.293637312181357
                        ],
                        [
                            -157.81307683489212,
                            21.293635037111105
                        ],
                        [
                            -157.81307295040179,
                            21.293635493033804
                        ],
                        [
                            -157.81307325506458,
                            21.293637767207535
                        ],
                        [
                            -157.81304106089271,
                            21.293641544015895
                        ],
                        [
                            -157.81300674211445,
                            21.293645570529083
                        ],
                        [
                            -157.81300175673303,
                            21.293646155098777
                        ],
                        [
                            -157.81300200624571,
                            21.293647974478606
                        ],
                        [
                            -157.81300371306691,
                            21.293647774218108
                        ],
                        [
                            -157.81300699466658,
                            21.293672344267257
                        ],
                        [
                            -157.81300528880899,
                            21.293672544534566
                        ],
                        [
                            -157.81300547064217,
                            21.293673909032048
                        ],
                        [
                            -157.81300553253843,
                            21.293674363873603
                        ],
                        [
                            -157.81301051020247,
                            21.293673780152787
                        ],
                        [
                            -157.81301488000807,
                            21.293673268030133
                        ],
                        [
                            -157.81307750945044,
                            21.293665919732202
                        ],
                        [
                            -157.81308462459131,
                            21.293719194922026
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 235,
                "NUMBER": "1123D",
                "PROPER_NAME": "HALE NOELANI TOWER D",
                "DISPLAY_NAME": "HALE NOELANI TOWER D - 1123D",
                "ADDRESS": "2585 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE NOELANI TOWERS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1123D_01.jpg",
                "HEIGHT (ft)": 42.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 200.31152949142131,
                "SHAPE_Area": 959.32852909874089
            }
        },
        {
            "type": "Feature",
            "id": 236,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81353859783465,
                            21.293541581913633
                        ],
                        [
                            -157.81353617123784,
                            21.293541866541869
                        ],
                        [
                            -157.81353641400261,
                            21.293543686776985
                        ],
                        [
                            -157.81354029752578,
                            21.293543230836608
                        ],
                        [
                            -157.81354023300449,
                            21.293542742551235
                        ],
                        [
                            -157.81359715143137,
                            21.293536063866593
                        ],
                        [
                            -157.81359721235827,
                            21.293536519604565
                        ],
                        [
                            -157.81360109685232,
                            21.293536062766204
                        ],
                        [
                            -157.81361437124443,
                            21.29353450673592
                        ],
                        [
                            -157.81361806855585,
                            21.293534072066034
                        ],
                        [
                            -157.81363830724186,
                            21.293531697864239
                        ],
                        [
                            -157.81362956147257,
                            21.293466220851997
                        ],
                        [
                            -157.81362973321836,
                            21.293466200381104
                        ],
                        [
                            -157.81362904851989,
                            21.29346107243072
                        ],
                        [
                            -157.81362703349419,
                            21.293445985166862
                        ],
                        [
                            -157.81362195580743,
                            21.293407981704718
                        ],
                        [
                            -157.81362172307911,
                            21.293406232004802
                        ],
                        [
                            -157.81361271450328,
                            21.293338790975998
                        ],
                        [
                            -157.81361077225887,
                            21.293339019395457
                        ],
                        [
                            -157.8136117442919,
                            21.293346299439271
                        ],
                        [
                            -157.8135660529197,
                            21.293351660623522
                        ],
                        [
                            -157.81356433742022,
                            21.293351861732113
                        ],
                        [
                            -157.8133864752873,
                            21.293372728409242
                        ],
                        [
                            -157.81338571695997,
                            21.293367047064489
                        ],
                        [
                            -157.81338477303495,
                            21.293359989451901
                        ],
                        [
                            -157.81337966188048,
                            21.293321720152086
                        ],
                        [
                            -157.81335847380785,
                            21.293324205975114
                        ],
                        [
                            -157.8133398512654,
                            21.293326390984991
                        ],
                        [
                            -157.81334399135358,
                            21.293357380247571
                        ],
                        [
                            -157.81334496335171,
                            21.293364663002329
                        ],
                        [
                            -157.81326189086053,
                            21.293374405805885
                        ],
                        [
                            -157.81325987818641,
                            21.293374641855223
                        ],
                        [
                            -157.81308182591147,
                            21.293395532161785
                        ],
                        [
                            -157.81308085391174,
                            21.293388251212818
                        ],
                        [
                            -157.81307891166625,
                            21.293388479626049
                        ],
                        [
                            -157.81308256697952,
                            21.293415849204884
                        ],
                        [
                            -157.81308291706617,
                            21.293418468793849
                        ],
                        [
                            -157.81308640514956,
                            21.29344457606113
                        ],
                        [
                            -157.81306018826331,
                            21.293447651532102
                        ],
                        [
                            -157.8130599272784,
                            21.293445700176513
                        ],
                        [
                            -157.81305798503934,
                            21.293445927686133
                        ],
                        [
                            -157.81305975087051,
                            21.293459148600689
                        ],
                        [
                            -157.81306001726884,
                            21.293461146067354
                        ],
                        [
                            -157.81306542667889,
                            21.293501637105148
                        ],
                        [
                            -157.81306561035325,
                            21.293503012456252
                        ],
                        [
                            -157.81306704161477,
                            21.293513722297927
                        ],
                        [
                            -157.81306712795509,
                            21.293514374250833
                        ],
                        [
                            -157.81306728340979,
                            21.293515542526681
                        ],
                        [
                            -157.81306731164403,
                            21.293515747795272
                        ],
                        [
                            -157.81306752713982,
                            21.293517361865685
                        ],
                        [
                            -157.81306946937985,
                            21.293517134355987
                        ],
                        [
                            -157.81306916472451,
                            21.293514859278915
                        ],
                        [
                            -157.81307994692617,
                            21.293513593773579
                        ],
                        [
                            -157.813081625764,
                            21.293513396928461
                        ],
                        [
                            -157.81309441098102,
                            21.293511898017172
                        ],
                        [
                            -157.81309471468009,
                            21.293514172184093
                        ],
                        [
                            -157.81309859915999,
                            21.293513717164064
                        ],
                        [
                            -157.81309829450419,
                            21.293511442087002
                        ],
                        [
                            -157.81313227941124,
                            21.293507454755563
                        ],
                        [
                            -157.81313258406757,
                            21.293509729832593
                        ],
                        [
                            -157.81313646662673,
                            21.293509273894731
                        ],
                        [
                            -157.81313616293423,
                            21.29350699882453
                        ],
                        [
                            -157.81317293045845,
                            21.293502686009894
                        ],
                        [
                            -157.81317491515995,
                            21.293502452474627
                        ],
                        [
                            -157.81324588468374,
                            21.293494125822331
                        ],
                        [
                            -157.81324618837064,
                            21.29349640179576
                        ],
                        [
                            -157.81325007285699,
                            21.293495945868855
                        ],
                        [
                            -157.81324976819889,
                            21.29349367079196
                        ],
                        [
                            -157.81332334087728,
                            21.29348503904594
                        ],
                        [
                            -157.81332419283734,
                            21.293484939355494
                        ],
                        [
                            -157.81332556967368,
                            21.293484778321222
                        ],
                        [
                            -157.81336070467631,
                            21.293480655412097
                        ],
                        [
                            -157.81336234598672,
                            21.293492940438135
                        ],
                        [
                            -157.8133611312428,
                            21.293493082740813
                        ],
                        [
                            -157.81336167866516,
                            21.293497178052867
                        ],
                        [
                            -157.81336556219469,
                            21.293496721213135
                        ],
                        [
                            -157.813365197558,
                            21.293493992211808
                        ],
                        [
                            -157.81347491928577,
                            21.2934811190589
                        ],
                        [
                            -157.81347528391723,
                            21.293483848963408
                        ],
                        [
                            -157.81347916743169,
                            21.293483393927698
                        ],
                        [
                            -157.8134788028074,
                            21.293480663119855
                        ],
                        [
                            -157.81354326535759,
                            21.293473100814708
                        ],
                        [
                            -157.81354474930106,
                            21.293472926079342
                        ],
                        [
                            -157.813588524512,
                            21.293467790795255
                        ],
                        [
                            -157.81358888914559,
                            21.293470520699636
                        ],
                        [
                            -157.81359010388917,
                            21.293470378395313
                        ],
                        [
                            -157.81359502778417,
                            21.293507245212741
                        ],
                        [
                            -157.81359333052424,
                            21.293507455484015
                        ],
                        [
                            -157.81359338871169,
                            21.293507892231489
                        ],
                        [
                            -157.81353646933172,
                            21.293514570908609
                        ],
                        [
                            -157.81353640839777,
                            21.293514116073958
                        ],
                        [
                            -157.81353252487534,
                            21.293514572014296
                        ],
                        [
                            -157.81353276860392,
                            21.293516392256233
                        ],
                        [
                            -157.81353519520755,
                            21.293516106724695
                        ],
                        [
                            -157.81353859783465,
                            21.293541581913633
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 236,
                "NUMBER": "1123C",
                "PROPER_NAME": "HALE NOELANI TOWER C",
                "DISPLAY_NAME": "HALE NOELANI TOWER C - 1123C",
                "ADDRESS": "2585 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE NOELANI TOWERS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1123C_01.jpg",
                "HEIGHT (ft)": 44.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 190.92209183254167,
                "SHAPE_Area": 821.13792600325235
            }
        },
        {
            "type": "Feature",
            "id": 238,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81408511516574,
                            21.292897442289679
                        ],
                        [
                            -157.81409979735906,
                            21.292903753824252
                        ],
                        [
                            -157.8141006136926,
                            21.292902086496802
                        ],
                        [
                            -157.81409694411531,
                            21.292900507716737
                        ],
                        [
                            -157.81410643344367,
                            21.292881118255494
                        ],
                        [
                            -157.81410776774834,
                            21.292881692274531
                        ],
                        [
                            -157.81410899177359,
                            21.2928791903765
                        ],
                        [
                            -157.81410765746173,
                            21.292878617260822
                        ],
                        [
                            -157.81410847183105,
                            21.292876954436419
                        ],
                        [
                            -157.81410988890752,
                            21.292874059116944
                        ],
                        [
                            -157.81411786902248,
                            21.292857754940584
                        ],
                        [
                            -157.81413172719425,
                            21.292829436431969
                        ],
                        [
                            -157.81413271501043,
                            21.292827420700373
                        ],
                        [
                            -157.8141578617396,
                            21.292776039568466
                        ],
                        [
                            -157.81417165534759,
                            21.292781969026404
                        ],
                        [
                            -157.81417287937091,
                            21.292779467127801
                        ],
                        [
                            -157.814171544103,
                            21.292778893102518
                        ],
                        [
                            -157.81418103730493,
                            21.292759499146452
                        ],
                        [
                            -157.81418259256111,
                            21.292756321135101
                        ],
                        [
                            -157.81418853427814,
                            21.292744180774736
                        ],
                        [
                            -157.81421517153169,
                            21.292689755770098
                        ],
                        [
                            -157.81421683555945,
                            21.29268635629057
                        ],
                        [
                            -157.81422174924941,
                            21.292676317199739
                        ],
                        [
                            -157.81422308355994,
                            21.292676890314468
                        ],
                        [
                            -157.81422430853809,
                            21.292674389325519
                        ],
                        [
                            -157.81422297327092,
                            21.292673815300674
                        ],
                        [
                            -157.8142454788341,
                            21.292627833178624
                        ],
                        [
                            -157.81425984063731,
                            21.292598490146442
                        ],
                        [
                            -157.81427037459719,
                            21.292576966093833
                        ],
                        [
                            -157.81427134186387,
                            21.292574988158869
                        ],
                        [
                            -157.81427317738621,
                            21.292571238467843
                        ],
                        [
                            -157.81427451265995,
                            21.292571811588925
                        ],
                        [
                            -157.81427573667241,
                            21.292569310592683
                        ],
                        [
                            -157.81427440236979,
                            21.292568736575063
                        ],
                        [
                            -157.81429032039802,
                            21.29253621282383
                        ],
                        [
                            -157.81429165567152,
                            21.292536785944751
                        ],
                        [
                            -157.81429287969058,
                            21.292534284045022
                        ],
                        [
                            -157.81429154442435,
                            21.292533710020763
                        ],
                        [
                            -157.8142953085495,
                            21.292526022485205
                        ],
                        [
                            -157.8142981446735,
                            21.292520224629055
                        ],
                        [
                            -157.81430746340857,
                            21.292501186274198
                        ],
                        [
                            -157.81430879771796,
                            21.292501759388198
                        ],
                        [
                            -157.81431002269306,
                            21.292499258398436
                        ],
                        [
                            -157.81430868839095,
                            21.292498684381112
                        ],
                        [
                            -157.81432024935424,
                            21.292475063562549
                        ],
                        [
                            -157.81432244455101,
                            21.292470576527645
                        ],
                        [
                            -157.81432460641065,
                            21.292466159722309
                        ],
                        [
                            -157.81432594071984,
                            21.292466732836164
                        ],
                        [
                            -157.81432716569435,
                            21.292464231846246
                        ],
                        [
                            -157.81432583139241,
                            21.292463657829067
                        ],
                        [
                            -157.81434576442808,
                            21.292422929755755
                        ],
                        [
                            -157.81434777045777,
                            21.292418832556024
                        ],
                        [
                            -157.81434910380275,
                            21.292419405662894
                        ],
                        [
                            -157.81435032974031,
                            21.292416904679524
                        ],
                        [
                            -157.81434765920937,
                            21.292415756631968
                        ],
                        [
                            -157.81434704671528,
                            21.292417008030373
                        ],
                        [
                            -157.81434026760073,
                            21.292414093824558
                        ],
                        [
                            -157.81433539724665,
                            21.292411999790382
                        ],
                        [
                            -157.8143235777444,
                            21.292406918984124
                        ],
                        [
                            -157.81432418927474,
                            21.292405667579036
                        ],
                        [
                            -157.81432152066478,
                            21.292404520447995
                        ],
                        [
                            -157.81432090817776,
                            21.292405770942949
                        ],
                        [
                            -157.81430393205792,
                            21.29239847303003
                        ],
                        [
                            -157.81428097029743,
                            21.292388602557576
                        ],
                        [
                            -157.81427819505973,
                            21.292387409505281
                        ],
                        [
                            -157.81427880755425,
                            21.292386158107142
                        ],
                        [
                            -157.81427613798112,
                            21.292385010968619
                        ],
                        [
                            -157.81427552548661,
                            21.292386262366747
                        ],
                        [
                            -157.81426812101924,
                            21.292383078156487
                        ],
                        [
                            -157.81423031188561,
                            21.292366825434272
                        ],
                        [
                            -157.81421501589853,
                            21.29236025031588
                        ],
                        [
                            -157.81421440341083,
                            21.292361500810433
                        ],
                        [
                            -157.81422152257446,
                            21.292364561958955
                        ],
                        [
                            -157.81420329765939,
                            21.292401797798565
                        ],
                        [
                            -157.81420322218727,
                            21.29240195355343
                        ],
                        [
                            -157.81420092510001,
                            21.292406644938552
                        ],
                        [
                            -157.81420084865675,
                            21.292406801589962
                        ],
                        [
                            -157.8142001959759,
                            21.292408135816597
                        ],
                        [
                            -157.81419958445176,
                            21.292409386317864
                        ],
                        [
                            -157.81419246527929,
                            21.292406326071681
                        ],
                        [
                            -157.81419185278395,
                            21.292407577469451
                        ],
                        [
                            -157.81419897195644,
                            21.292410637715658
                        ],
                        [
                            -157.81419855251875,
                            21.292411494788503
                        ],
                        [
                            -157.81416762490898,
                            21.29247468497767
                        ],
                        [
                            -157.81416547676349,
                            21.2924790738723
                        ],
                        [
                            -157.81416540032021,
                            21.292479230523693
                        ],
                        [
                            -157.81416499167315,
                            21.292480064184296
                        ],
                        [
                            -157.81415787249816,
                            21.292477003936551
                        ],
                        [
                            -157.81415726096608,
                            21.29247825534096
                        ],
                        [
                            -157.81417717083676,
                            21.292486813386859
                        ],
                        [
                            -157.81417668083284,
                            21.292487815408361
                        ],
                        [
                            -157.81413601694828,
                            21.292570898312629
                        ],
                        [
                            -157.81413576214422,
                            21.292571419580529
                        ],
                        [
                            -157.81413568570807,
                            21.292571575328548
                        ],
                        [
                            -157.81413339054356,
                            21.292576266726027
                        ],
                        [
                            -157.81413331410013,
                            21.292576423377394
                        ],
                        [
                            -157.81413251738709,
                            21.292578048384041
                        ],
                        [
                            -157.81413244190031,
                            21.292578205945542
                        ],
                        [
                            -157.81413014481507,
                            21.292582896426026
                        ],
                        [
                            -157.81413006837889,
                            21.292583052174059
                        ],
                        [
                            -157.81412927261516,
                            21.292584678994167
                        ],
                        [
                            -157.81412919617901,
                            21.2925848347422
                        ],
                        [
                            -157.81412690005016,
                            21.292589526132755
                        ],
                        [
                            -157.81412682360676,
                            21.292589682784122
                        ],
                        [
                            -157.81412635418417,
                            21.292590642491078
                        ],
                        [
                            -157.81411033771795,
                            21.292583756941077
                        ],
                        [
                            -157.81410972523562,
                            21.292585006531795
                        ],
                        [
                            -157.81412574170193,
                            21.292591892081862
                        ],
                        [
                            -157.81412540653361,
                            21.292592578103982
                        ],
                        [
                            -157.81411836035991,
                            21.292606975480854
                        ],
                        [
                            -157.81411622690823,
                            21.292611334666276
                        ],
                        [
                            -157.81411615047202,
                            21.292611490414302
                        ],
                        [
                            -157.81411535470798,
                            21.292613117234325
                        ],
                        [
                            -157.81411527826452,
                            21.292613273885685
                        ],
                        [
                            -157.81411298118536,
                            21.292617963462526
                        ],
                        [
                            -157.81411290473469,
                            21.292618121017224
                        ],
                        [
                            -157.8141121099417,
                            21.292619746940662
                        ],
                        [
                            -157.8141120325416,
                            21.292619902681892
                        ],
                        [
                            -157.8141097373755,
                            21.292624594078937
                        ],
                        [
                            -157.81410966093929,
                            21.292624749826956
                        ],
                        [
                            -157.81410792537281,
                            21.292628295150589
                        ],
                        [
                            -157.8141078489366,
                            21.292628450898611
                        ],
                        [
                            -157.81410555377022,
                            21.292633142295578
                        ],
                        [
                            -157.81410547732676,
                            21.292633298946935
                        ],
                        [
                            -157.81410468060582,
                            21.29263492485676
                        ],
                        [
                            -157.81410460416237,
                            21.292635081508113
                        ],
                        [
                            -157.81410230803914,
                            21.292639771994899
                        ],
                        [
                            -157.81410223159565,
                            21.292639928646256
                        ],
                        [
                            -157.81410143583855,
                            21.292641554562834
                        ],
                        [
                            -157.81410135939507,
                            21.292641711214191
                        ],
                        [
                            -157.81409906326439,
                            21.292646402604266
                        ],
                        [
                            -157.81409898682816,
                            21.292646558352263
                        ],
                        [
                            -157.81409819106372,
                            21.29264818517218
                        ],
                        [
                            -157.81409811462748,
                            21.292648340920199
                        ],
                        [
                            -157.81409581849661,
                            21.292653032310206
                        ],
                        [
                            -157.81409574205313,
                            21.292653188961548
                        ],
                        [
                            -157.8140949463031,
                            21.292654813974774
                        ],
                        [
                            -157.81409486888847,
                            21.292654971522669
                        ],
                        [
                            -157.81409257372852,
                            21.292659662016067
                        ],
                        [
                            -157.814092497285,
                            21.292659818667421
                        ],
                        [
                            -157.81409076172488,
                            21.292663363087485
                        ],
                        [
                            -157.81409068528865,
                            21.292663518835475
                        ],
                        [
                            -157.81408839012113,
                            21.292668210232154
                        ],
                        [
                            -157.81408831368489,
                            21.292668365980148
                        ],
                        [
                            -157.81408751695631,
                            21.292669992793208
                        ],
                        [
                            -157.81408744147666,
                            21.292670149451347
                        ],
                        [
                            -157.81408514438121,
                            21.292674840834369
                        ],
                        [
                            -157.81408506794494,
                            21.292674996582377
                        ],
                        [
                            -157.81408427315131,
                            21.292676622505656
                        ],
                        [
                            -157.8140841957439,
                            21.292676779150213
                        ],
                        [
                            -157.81408189961934,
                            21.292681469636634
                        ],
                        [
                            -157.81408182413972,
                            21.292681626294765
                        ],
                        [
                            -157.81408102741099,
                            21.292683253107789
                        ],
                        [
                            -157.8140809509747,
                            21.292683408855773
                        ],
                        [
                            -157.81407865580658,
                            21.292688100252285
                        ],
                        [
                            -157.8140785784064,
                            21.292688255993475
                        ],
                        [
                            -157.8140777826415,
                            21.292689882813271
                        ],
                        [
                            -157.81407770619796,
                            21.292690039464606
                        ],
                        [
                            -157.81407541007297,
                            21.292694729950917
                        ],
                        [
                            -157.81407533362946,
                            21.292694886602252
                        ],
                        [
                            -157.81407492498124,
                            21.292695720262579
                        ],
                        [
                            -157.81405534939728,
                            21.292687304584515
                        ],
                        [
                            -157.81405473689952,
                            21.292688555981655
                        ],
                        [
                            -157.81406185512543,
                            21.292691615323911
                        ],
                        [
                            -157.8140614366572,
                            21.29269247149977
                        ],
                        [
                            -157.81402884781281,
                            21.292759057540625
                        ],
                        [
                            -157.81402868709858,
                            21.292759385242352
                        ],
                        [
                            -157.81402860969834,
                            21.292759540983521
                        ],
                        [
                            -157.81402697798077,
                            21.29276287745127
                        ],
                        [
                            -157.81402690057325,
                            21.292763034095792
                        ],
                        [
                            -157.81402460540207,
                            21.292767725491366
                        ],
                        [
                            -157.81402452896569,
                            21.292767881239335
                        ],
                        [
                            -157.81402373224307,
                            21.292769507148684
                        ],
                        [
                            -157.81402365579947,
                            21.292769663799991
                        ],
                        [
                            -157.81402136063528,
                            21.29277435429217
                        ],
                        [
                            -157.81402128322054,
                            21.292774511840022
                        ],
                        [
                            -157.81402048843287,
                            21.29277613685959
                        ],
                        [
                            -157.81402041102535,
                            21.29277629350409
                        ],
                        [
                            -157.81401811488985,
                            21.292780984892776
                        ],
                        [
                            -157.81401803845344,
                            21.292781140640727
                        ],
                        [
                            -157.81401724268736,
                            21.292782767460157
                        ],
                        [
                            -157.81401716625095,
                            21.292782923208126
                        ],
                        [
                            -157.81401487107911,
                            21.292787614603526
                        ],
                        [
                            -157.81401479367156,
                            21.29278777124804
                        ],
                        [
                            -157.81401399791264,
                            21.292789397164118
                        ],
                        [
                            -157.81401392050512,
                            21.292789553808628
                        ],
                        [
                            -157.8140116253403,
                            21.292794244300634
                        ],
                        [
                            -157.81401154889662,
                            21.292794400951934
                        ],
                        [
                            -157.8140097319901,
                            21.29279811192502
                        ],
                        [
                            -157.81400965651034,
                            21.292798268583113
                        ],
                        [
                            -157.81400736037412,
                            21.292802959971592
                        ],
                        [
                            -157.81400728297379,
                            21.292803115712761
                        ],
                        [
                            -157.81400648817856,
                            21.292804741635564
                        ],
                        [
                            -157.81400641077101,
                            21.292804898280071
                        ],
                        [
                            -157.81400411464182,
                            21.292809588765156
                        ],
                        [
                            -157.81400403819092,
                            21.292809746319787
                        ],
                        [
                            -157.81400324243174,
                            21.292811372235796
                        ],
                        [
                            -157.8140031659953,
                            21.292811527983755
                        ],
                        [
                            -157.81400087082253,
                            21.29281621937891
                        ],
                        [
                            -157.81400079342222,
                            21.292816375120076
                        ],
                        [
                            -157.81399999765571,
                            21.292818001939406
                        ],
                        [
                            -157.81399992024814,
                            21.292818158583891
                        ],
                        [
                            -157.81399762507519,
                            21.292822849979004
                        ],
                        [
                            -157.81399754863875,
                            21.292823005726941
                        ],
                        [
                            -157.81399675287938,
                            21.292824631642912
                        ],
                        [
                            -157.81399667643572,
                            21.292824788294208
                        ],
                        [
                            -157.8139943803059,
                            21.292829478779115
                        ],
                        [
                            -157.81399430289107,
                            21.292829636326953
                        ],
                        [
                            -157.81399389521312,
                            21.292830469090468
                        ],
                        [
                            -157.8139867769822,
                            21.292827409745136
                        ],
                        [
                            -157.81398616545434,
                            21.292828660245387
                        ],
                        [
                            -157.81402233871782,
                            21.292844211309667
                        ],
                        [
                            -157.81402501694282,
                            21.292845362126915
                        ],
                        [
                            -157.81404790765828,
                            21.292855203226903
                        ],
                        [
                            -157.81403811063629,
                            21.292875217469589
                        ],
                        [
                            -157.81403565240069,
                            21.292874160348251
                        ],
                        [
                            -157.81403476478746,
                            21.292873778284335
                        ],
                        [
                            -157.81403394844611,
                            21.292875446514802
                        ],
                        [
                            -157.81408429864044,
                            21.292897090538712
                        ],
                        [
                            -157.81408511516574,
                            21.292897442289679
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 238,
                "NUMBER": "1120B",
                "PROPER_NAME": "HALE WAINANI G TOWER",
                "DISPLAY_NAME": "HALE WAINANI G TOWER - 1120B",
                "ADDRESS": "2591 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE WAINANI TOWERS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1120B_01.jpg",
                "HEIGHT (ft)": 41.700000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 167.7357824107772,
                "SHAPE_Area": 785.15090643555004
            }
        },
        {
            "type": "Feature",
            "id": 239,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    
                        [
                            [
                                -157.81645932863688,
                                21.300843785419925
                            ],
                            [
                                -157.81646025717967,
                                21.300844600484481
                            ],
                            [
                                -157.81647557160295,
                                21.30085802235287
                            ],
                            [
                                -157.81647576949464,
                                21.300863525389236
                            ],
                            [
                                -157.81647661175745,
                                21.300886911043939
                            ],
                            [
                                -157.81647680290163,
                                21.300892414032834
                            ],
                            [
                                -157.8165473178521,
                                21.300954165210953
                            ],
                            [
                                -157.8165573495489,
                                21.301232796943012
                            ],
                            [
                                -157.81655832728595,
                                21.301232765876726
                            ],
                            [
                                -157.81662576984812,
                                21.301230632980545
                            ],
                            [
                                -157.8169507580397,
                                21.301220357333278
                            ],
                            [
                                -157.81693659334053,
                                21.300826918125793
                            ],
                            [
                                -157.81654416363403,
                                21.300839326685306
                            ],
                            [
                                -157.81654432363609,
                                21.300843783329707
                            ],
                            [
                                -157.81648999733991,
                                21.300796195526551
                            ],
                            [
                                -157.81646565960392,
                                21.300774876000638
                            ],
                            [
                                -157.8164524559302,
                                21.300763309182134
                            ],
                            [
                                -157.81645254890489,
                                21.300765903468506
                            ],
                            [
                                -157.81645278478868,
                                21.300772440250189
                            ],
                            [
                                -157.81645372311169,
                                21.300798515972467
                            ],
                            [
                                -157.81645378058022,
                                21.30080012712088
                            ],
                            [
                                -157.81645502890291,
                                21.300834799875002
                            ],
                            [
                                -157.81645512991096,
                                21.300837594770414
                            ],
                            [
                                -157.81645522384963,
                                21.300840189063546
                            ],
                            [
                                -157.81645547560672,
                                21.300840410357942
                            ],
                            [
                                -157.81645932863688,
                                21.300843785419925
                            ]
                        ]
                    
                ]
            },
            "properties": {
                "FID": 239,
                "NUMBER": "1199C",
                "PROPER_NAME": "HAMILTON LIBRARY ADDITION",
                "DISPLAY_NAME": "HAMILTON LIBRARY ADDITION (HL) - 1199C",
                "ADDRESS": "2550 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HAMILTON LIBRARY ADDITION",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "Hamilton Addition",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1199C_01.jpg",
                "HEIGHT (ft)": 84.700000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 194.77211270798057,
                "SHAPE_Area": 1884.0861269811844
            }
        },
        {
            "type": "Feature",
            "id": 240,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81591722359713,
                            21.300748326562928
                        ],
                        [
                            -157.81593450804945,
                            21.301228502279596
                        ],
                        [
                            -157.81593940926541,
                            21.301228347054437
                        ],
                        [
                            -157.81595292207365,
                            21.301227919975318
                        ],
                        [
                            -157.81646859569935,
                            21.301211616106752
                        ],
                        [
                            -157.81643383923918,
                            21.30024620702812
                        ],
                        [
                            -157.81643349777974,
                            21.300236723548853
                        ],
                        [
                            -157.81643334173953,
                            21.300232374435467
                        ],
                        [
                            -157.81593591188255,
                            21.300248101151006
                        ],
                        [
                            -157.81589925764433,
                            21.300249259759489
                        ],
                        [
                            -157.81590455240931,
                            21.30039634087494
                        ],
                        [
                            -157.81582369296689,
                            21.300398896727678
                        ],
                        [
                            -157.81583617232138,
                            21.300745564615337
                        ],
                        [
                            -157.81591703099002,
                            21.300743008758754
                        ],
                        [
                            -157.81591722359713,
                            21.300748326562928
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 240,
                "NUMBER": "1199",
                "PROPER_NAME": "HAMILTON LIBRARY",
                "DISPLAY_NAME": "HAMILTON LIBRARY (HL) - 1199",
                "ADDRESS": "2550 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HAMILTON LIBRARY",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1199_01.jpg",
                "HEIGHT (ft)": 69.299999999999997,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 344.58184284797801,
                "SHAPE_Area": 6334.9991371675524
            }
        },
        {
            "type": "Feature",
            "id": 241,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81645005856836,
                            21.300696733261653
                        ],
                        [
                            -157.81654471382785,
                            21.300693695061902
                        ],
                        [
                            -157.8165325145672,
                            21.300359873527842
                        ],
                        [
                            -157.8164380407992,
                            21.300362905778606
                        ],
                        [
                            -157.81645005856836,
                            21.300696733261653
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 241,
                "NUMBER": "1199D",
                "PROPER_NAME": "HAMILTON LIBRARY MECHANICAL BUILDING",
                "DISPLAY_NAME": "HAMILTON LIBRARY MECHANICAL BUILDING - 1199D",
                "ADDRESS": "2550 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HAMILTON LIBRARY",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1199D_01.jpg",
                "HEIGHT (ft)": 19.199999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 93.581121712530532,
                "SHAPE_Area": 362.93547025465705
            }
        },
        {
            "type": "Feature",
            "id": 242,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81547344294708,
                            21.297130654684967
                        ],
                        [
                            -157.81671076284186,
                            21.297088288852706
                        ],
                        [
                            -157.81669762361688,
                            21.296751285165069
                        ],
                        [
                            -157.81546030655014,
                            21.296793651033504
                        ],
                        [
                            -157.81547344294708,
                            21.297130654684967
                        ]
                    ],
                    [
                        [
                            -157.81586568373876,
                            21.297028443598393
                        ],
                        [
                            -157.8157833540009,
                            21.297031261081425
                        ],
                        [
                            -157.81578174266141,
                            21.296989938615884
                        ],
                        [
                            -157.81573764847482,
                            21.296991447784745
                        ],
                        [
                            -157.81573761739585,
                            21.296990634514923
                        ],
                        [
                            -157.81573643531473,
                            21.296960346366713
                        ],
                        [
                            -157.81573628429206,
                            21.296956456209504
                        ],
                        [
                            -157.81573467698166,
                            21.296915234048367
                        ],
                        [
                            -157.81573464591719,
                            21.296914418971863
                        ],
                        [
                            -157.81577873912403,
                            21.296912908892605
                        ],
                        [
                            -157.81577712874929,
                            21.29687158643334
                        ],
                        [
                            -157.81585945937636,
                            21.296868767149274
                        ],
                        [
                            -157.81586095588349,
                            21.296907339791229
                        ],
                        [
                            -157.81586105626496,
                            21.296910091320566
                        ],
                        [
                            -157.81587243609692,
                            21.296909700718437
                        ],
                        [
                            -157.81587503372344,
                            21.296909612394195
                        ],
                        [
                            -157.81590502798224,
                            21.296908584870266
                        ],
                        [
                            -157.81590506228099,
                            21.296909477661075
                        ],
                        [
                            -157.81590799631564,
                            21.296984722700167
                        ],
                        [
                            -157.81590803062167,
                            21.296985614587626
                        ],
                        [
                            -157.81587509255985,
                            21.296986742454376
                        ],
                        [
                            -157.81587095987319,
                            21.296986884119178
                        ],
                        [
                            -157.81586407238342,
                            21.296987120229222
                        ],
                        [
                            -157.81586568373876,
                            21.297028443598393
                        ]
                    ],
                    [
                        [
                            -157.81626305182508,
                            21.29689668160486
                        ],
                        [
                            -157.81626303731042,
                            21.296896327373801
                        ],
                        [
                            -157.8162670350039,
                            21.296896190170148
                        ],
                        [
                            -157.81626878604266,
                            21.296896130214392
                        ],
                        [
                            -157.81630713147774,
                            21.296894817162343
                        ],
                        [
                            -157.81630551999825,
                            21.296853493791058
                        ],
                        [
                            -157.81638771561364,
                            21.296850680525218
                        ],
                        [
                            -157.81638932615951,
                            21.296892002986656
                        ],
                        [
                            -157.81639513467573,
                            21.296891803533178
                        ],
                        [
                            -157.816400323181,
                            21.296891626821022
                        ],
                        [
                            -157.81643342031876,
                            21.296890493645332
                        ],
                        [
                            -157.81643344816075,
                            21.296891230104222
                        ],
                        [
                            -157.81643639347891,
                            21.29696678508709
                        ],
                        [
                            -157.8164364232415,
                            21.296967522462872
                        ],
                        [
                            -157.8163923290592,
                            21.296969031803915
                        ],
                        [
                            -157.81639253460713,
                            21.29697430091824
                        ],
                        [
                            -157.81639263300184,
                            21.296976820262358
                        ],
                        [
                            -157.81639394056259,
                            21.297010355174983
                        ],
                        [
                            -157.81631174484369,
                            21.29701317024638
                        ],
                        [
                            -157.81631013529116,
                            21.296971846889157
                        ],
                        [
                            -157.81626604110082,
                            21.29697335710032
                        ],
                        [
                            -157.8162660275573,
                            21.296973001972688
                        ],
                        [
                            -157.81626511342202,
                            21.296949566116783
                        ],
                        [
                            -157.81626505493483,
                            21.296948082338606
                        ],
                        [
                            -157.81626305182508,
                            21.29689668160486
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 242,
                "NUMBER": "1163",
                "PROPER_NAME": "HOLMES HALL",
                "DISPLAY_NAME": "HOLMES HALL (HOLM) - 1163",
                "ADDRESS": "2540 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HOLMES HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1163_01.jpg",
                "HEIGHT (ft)": 83.799999999999997,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": "https://www.hawaii.edu/sustainability/pv-system/holmes-hall/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2019/05/Holmes-Hall-2.jpg",
                "PORTABLE?": null,
                "SHAPE_Length": 473.05489811320632,
                "SHAPE_Area": 4336.7471569184499
            }
        },
        {
            "type": "Feature",
            "id": 243,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81654939810127,
                            21.298798035354388
                        ],
                        [
                            -157.81654902784663,
                            21.298798046301574
                        ],
                        [
                            -157.81647691947111,
                            21.29880021867033
                        ],
                        [
                            -157.81646645586983,
                            21.298800534445927
                        ],
                        [
                            -157.81646419672742,
                            21.298800602573632
                        ],
                        [
                            -157.81645879330162,
                            21.298800765126188
                        ],
                        [
                            -157.81645874027143,
                            21.298800766560028
                        ],
                        [
                            -157.81644857076043,
                            21.298801072658637
                        ],
                        [
                            -157.81644851772302,
                            21.298801074995811
                        ],
                        [
                            -157.81643834628414,
                            21.298801381080253
                        ],
                        [
                            -157.81643829421066,
                            21.298801383424195
                        ],
                        [
                            -157.81643456369619,
                            21.29880149450377
                        ],
                        [
                            -157.81643227658554,
                            21.298801564241149
                        ],
                        [
                            -157.8164279501791,
                            21.298801694617946
                        ],
                        [
                            -157.81642764644957,
                            21.298801704225944
                        ],
                        [
                            -157.81642607768521,
                            21.298801751010124
                        ],
                        [
                            -157.81642562451157,
                            21.298801764084068
                        ],
                        [
                            -157.81641151523539,
                            21.298802189725397
                        ],
                        [
                            -157.81639697110728,
                            21.298802627664866
                        ],
                        [
                            -157.81638242793588,
                            21.298803066513202
                        ],
                        [
                            -157.81636788381499,
                            21.298803503546822
                        ],
                        [
                            -157.81635652349831,
                            21.298803846434236
                        ],
                        [
                            -157.81635332135787,
                            21.298803943160365
                        ],
                        [
                            -157.81633877915752,
                            21.298804381108361
                        ],
                        [
                            -157.81632423502933,
                            21.298804819041518
                        ],
                        [
                            -157.81631387076251,
                            21.298805129182519
                        ],
                        [
                            -157.81631377721865,
                            21.298805133944928
                        ],
                        [
                            -157.81631105568482,
                            21.298815273424612
                        ],
                        [
                            -157.81630842935661,
                            21.298825080222922
                        ],
                        [
                            -157.81630831461365,
                            21.298825083932822
                        ],
                        [
                            -157.81630783323743,
                            21.298826933400125
                        ],
                        [
                            -157.81630727432577,
                            21.298829196074738
                        ],
                        [
                            -157.81630387596698,
                            21.298842960615151
                        ],
                        [
                            -157.8163028657051,
                            21.298847054900403
                        ],
                        [
                            -157.81630284570318,
                            21.298847145098723
                        ],
                        [
                            -157.81630277681239,
                            21.298847441829516
                        ],
                        [
                            -157.81630153031622,
                            21.298852988007837
                        ],
                        [
                            -157.81630071566568,
                            21.298856610292507
                        ],
                        [
                            -157.81630070367177,
                            21.298856663508172
                        ],
                        [
                            -157.81629943417323,
                            21.298862313414531
                        ],
                        [
                            -157.81629640960261,
                            21.298876949645003
                        ],
                        [
                            -157.81629627896805,
                            21.298877613621265
                        ],
                        [
                            -157.81629617139353,
                            21.298878166642751
                        ],
                        [
                            -157.81629571704264,
                            21.298880493290035
                        ],
                        [
                            -157.81629571192641,
                            21.298880530293047
                        ],
                        [
                            -157.81629570488957,
                            21.298880566379147
                        ],
                        [
                            -157.81629569688158,
                            21.298880603361816
                        ],
                        [
                            -157.81629568984474,
                            21.298880639447933
                        ],
                        [
                            -157.81629568376459,
                            21.298880676444163
                        ],
                        [
                            -157.81629567575658,
                            21.298880713426822
                        ],
                        [
                            -157.81629566871976,
                            21.298880749512936
                        ],
                        [
                            -157.81629566167567,
                            21.298880786502391
                        ],
                        [
                            -157.81629565463882,
                            21.298880822588487
                        ],
                        [
                            -157.81629564759476,
                            21.298880859577938
                        ],
                        [
                            -157.81629564055066,
                            21.29888089656739
                        ],
                        [
                            -157.81629563351382,
                            21.2988809326535
                        ],
                        [
                            -157.81629562646978,
                            21.298880969642937
                        ],
                        [
                            -157.81629561943291,
                            21.298881005729054
                        ],
                        [
                            -157.81629561142492,
                            21.298881042711727
                        ],
                        [
                            -157.8162956043881,
                            21.298881078797823
                        ],
                        [
                            -157.81629470355674,
                            21.298885712273179
                        ],
                        [
                            -157.81629459683043,
                            21.298886279754861
                        ],
                        [
                            -157.81629321181845,
                            21.298893835001728
                        ],
                        [
                            -157.81629311089011,
                            21.298894400717408
                        ],
                        [
                            -157.81629179776704,
                            21.298902007059727
                        ],
                        [
                            -157.81629170357166,
                            21.298902574629544
                        ],
                        [
                            -157.81629156364855,
                            21.298903435479506
                        ],
                        [
                            -157.81629046217839,
                            21.298910251940782
                        ],
                        [
                            -157.81629037377377,
                            21.29891081864794
                        ],
                        [
                            -157.81628922653914,
                            21.298918414412949
                        ],
                        [
                            -157.8162891429252,
                            21.298918984767369
                        ],
                        [
                            -157.81628827091768,
                            21.298925194861038
                        ],
                        [
                            -157.81628816040416,
                            21.298925994487334
                        ],
                        [
                            -157.81628809284237,
                            21.298926486359722
                        ],
                        [
                            -157.81628801415656,
                            21.298927043197942
                        ],
                        [
                            -157.81628595470778,
                            21.298943100925182
                        ],
                        [
                            -157.8162859495626,
                            21.29894314154156
                        ],
                        [
                            -157.81628588940833,
                            21.298943671408416
                        ],
                        [
                            -157.81628580269452,
                            21.298944388090224
                        ],
                        [
                            -157.81628540907133,
                            21.298947798329273
                        ],
                        [
                            -157.81628501947193,
                            21.298951307969546
                        ],
                        [
                            -157.81628495706425,
                            21.298951878473101
                        ],
                        [
                            -157.81628473621035,
                            21.298953937552426
                        ],
                        [
                            -157.8162844093838,
                            21.298957071823949
                        ],
                        [
                            -157.81628416435012,
                            21.298959502026509
                        ],
                        [
                            -157.81628410675481,
                            21.298960073467317
                        ],
                        [
                            -157.81628379151144,
                            21.298963326164404
                        ],
                        [
                            -157.81628349735692,
                            21.298966473313182
                        ],
                        [
                            -157.81628337571885,
                            21.298967819412209
                        ],
                        [
                            -157.8162833239071,
                            21.298968390893677
                        ],
                        [
                            -157.81628290849582,
                            21.298973197620512
                        ],
                        [
                            -157.81628269597678,
                            21.298975780724692
                        ],
                        [
                            -157.8162826881441,
                            21.298975916178119
                        ],
                        [
                            -157.81628263920965,
                            21.298976489486598
                        ],
                        [
                            -157.8162814881637,
                            21.298992866176064
                        ],
                        [
                            -157.81628141256797,
                            21.298994120453134
                        ],
                        [
                            -157.81628064739951,
                            21.299009257695353
                        ],
                        [
                            -157.81628063415187,
                            21.299009828544701
                        ],
                        [
                            -157.8162805118703,
                            21.299017393576339
                        ],
                        [
                            -157.81628050245666,
                            21.299017967162815
                        ],
                        [
                            -157.81628038444657,
                            21.299025721033029
                        ],
                        [
                            -157.81628037599685,
                            21.299026294626287
                        ],
                        [
                            -157.81628027085051,
                            21.299034007031032
                        ],
                        [
                            -157.81628026336475,
                            21.299034580631066
                        ],
                        [
                            -157.8162801685032,
                            21.29904233285729
                        ],
                        [
                            -157.81628016198854,
                            21.299042905560768
                        ],
                        [
                            -157.81628007990949,
                            21.299050506107388
                        ],
                        [
                            -157.81628007435154,
                            21.299051079720961
                        ],
                        [
                            -157.81628000371654,
                            21.299058695705689
                        ],
                        [
                            -157.81628001692206,
                            21.299058731934181
                        ],
                        [
                            -157.8162799991442,
                            21.299059266616048
                        ],
                        [
                            -157.81628038389786,
                            21.299074777819364
                        ],
                        [
                            -157.81628096763274,
                            21.299091803600557
                        ],
                        [
                            -157.81628098714401,
                            21.299092376487092
                        ],
                        [
                            -157.81628124119601,
                            21.299099773424977
                        ],
                        [
                            -157.81628126070009,
                            21.299100347214846
                        ],
                        [
                            -157.81628152403303,
                            21.299108029689275
                        ],
                        [
                            -157.81628154450101,
                            21.299108603485926
                        ],
                        [
                            -157.81628180788459,
                            21.299116279636955
                        ],
                        [
                            -157.81628182738862,
                            21.299116853426824
                        ],
                        [
                            -157.81628209066369,
                            21.299124543127945
                        ],
                        [
                            -157.81628211113892,
                            21.299125116021255
                        ],
                        [
                            -157.81628237350071,
                            21.299132799392229
                        ],
                        [
                            -157.81628239300477,
                            21.299133373182094
                        ],
                        [
                            -157.81628264706404,
                            21.299140769216606
                        ],
                        [
                            -157.8162826665681,
                            21.299141343006479
                        ],
                        [
                            -157.81628274551932,
                            21.299143641786078
                        ],
                        [
                            -157.81628295487928,
                            21.29914975830588
                        ],
                        [
                            -157.81628320036833,
                            21.299156900427512
                        ],
                        [
                            -157.81629143569967,
                            21.299156652103278
                        ],
                        [
                            -157.81650471443737,
                            21.299150226664047
                        ],
                        [
                            -157.81651748059514,
                            21.299149842160794
                        ],
                        [
                            -157.8165662648646,
                            21.299148373021115
                        ],
                        [
                            -157.81655787562289,
                            21.298903822330633
                        ],
                        [
                            -157.81655779432521,
                            21.298901454876781
                        ],
                        [
                            -157.81655549815827,
                            21.298834512878241
                        ],
                        [
                            -157.81655513014314,
                            21.298823769884923
                        ],
                        [
                            -157.81655506814815,
                            21.298822001514445
                        ],
                        [
                            -157.81655498773486,
                            21.298819644004087
                        ],
                        [
                            -157.81655424132188,
                            21.298797889637502
                        ],
                        [
                            -157.81654939810127,
                            21.298798035354388
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 243,
                "NUMBER": "1140",
                "PROPER_NAME": "INFORMATION TECHNOLOGY CENTER",
                "DISPLAY_NAME": "INFORMATION TECHNOLOGY CENTER - 1140",
                "ADDRESS": "2520 CORREA ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "INFORMATION TECHNOLOGY CENTER",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "IT Center , ITS , Information Technology Services",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1140_01.jpg",
                "HEIGHT (ft)": 104.90000000000001,
                "LEED STATUS": "Gold",
                "LEED LINK": "https://www.usgbc.org/projects/university-hawaii-it-center",
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 132.41780501512909,
                "SHAPE_Area": 1096.7979071073175
            }
        },
        {
            "type": "Feature",
            "id": 244,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81618844677067,
                            21.299710076135437
                        ],
                        [
                            -157.81616494641122,
                            21.29971012582844
                        ],
                        [
                            -157.81615460463166,
                            21.299710147933855
                        ],
                        [
                            -157.81615462674739,
                            21.299719782743328
                        ],
                        [
                            -157.81615463825307,
                            21.299724484065599
                        ],
                        [
                            -157.81615465412293,
                            21.299730927154396
                        ],
                        [
                            -157.81615467976997,
                            21.299741805956643
                        ],
                        [
                            -157.81615472917099,
                            21.299762355715433
                        ],
                        [
                            -157.81617656857435,
                            21.299762308794389
                        ],
                        [
                            -157.81620031283055,
                            21.299762259008979
                        ],
                        [
                            -157.81621041168222,
                            21.299762237902236
                        ],
                        [
                            -157.81621038910714,
                            21.299752660003012
                        ],
                        [
                            -157.81621033565111,
                            21.299730810237225
                        ],
                        [
                            -157.81621028519535,
                            21.299710030106215
                        ],
                        [
                            -157.81618844677067,
                            21.299710076135437
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 244,
                "NUMBER": "1158A",
                "PROPER_NAME": "KELLER KIOSK",
                "DISPLAY_NAME": "KELLER KIOSK - 1158A",
                "ADDRESS": "2565 MCCARTHY MALL",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KELLER HALL AND KIOSK",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1158A_01.jpg",
                "HEIGHT (ft)": 19,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 23.111301134984892,
                "SHAPE_Area": 33.383441706785774
            }
        },
        {
            "type": "Feature",
            "id": 245,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.81765655162047,
                                21.297899603733335
                            ],
                            [
                                -157.81790629265456,
                                21.297907043980178
                            ],
                            [
                                -157.81790905979227,
                                21.297825493571121
                            ],
                            [
                                -157.81788527466452,
                                21.297824785378307
                            ],
                            [
                                -157.81788557996705,
                                21.297815779815352
                            ],
                            [
                                -157.81788434252252,
                                21.297815743118598
                            ],
                            [
                                -157.81788348365939,
                                21.29784105099316
                            ],
                            [
                                -157.8178649017606,
                                21.297840498591697
                            ],
                            [
                                -157.81787258188498,
                                21.297614114978714
                            ],
                            [
                                -157.81789240117664,
                                21.29761470678466
                            ],
                            [
                                -157.81789432238432,
                                21.297558052393505
                            ],
                            [
                                -157.81779447806298,
                                21.297555076345802
                            ],
                            [
                                -157.81779496529859,
                                21.297540679722534
                            ],
                            [
                                -157.81779372689249,
                                21.297540643018454
                            ],
                            [
                                -157.81779323867841,
                                21.297555041441615
                            ],
                            [
                                -157.81777595566737,
                                21.297554561392918
                            ],
                            [
                                -157.81778126688778,
                                21.297398029369738
                            ],
                            [
                                -157.81778199105747,
                                21.297376667462366
                            ],
                            [
                                -157.81778210187701,
                                21.297373417841467
                            ],
                            [
                                -157.81780532892628,
                                21.297374109478479
                            ],
                            [
                                -157.81780674474734,
                                21.297332316830371
                            ],
                            [
                                -157.81768800745655,
                                21.297328779809277
                            ],
                            [
                                -157.81768422699776,
                                21.297440229840845
                            ],
                            [
                                -157.81770801303958,
                                21.297440936259271
                            ],
                            [
                                -157.81770357118754,
                                21.297570960774241
                            ],
                            [
                                -157.81760709993236,
                                21.297568087808809
                            ],
                            [
                                -157.81760722605173,
                                21.297564372146226
                            ],
                            [
                                -157.81760598668163,
                                21.297564335433982
                            ],
                            [
                                -157.81760393730872,
                                21.29762470636901
                            ],
                            [
                                -157.81779068690832,
                                21.297630267821024
                            ],
                            [
                                -157.81779050537628,
                                21.297635609197688
                            ],
                            [
                                -157.81781031890816,
                                21.297636198262765
                            ],
                            [
                                -157.81780315936879,
                                21.297847257697914
                            ],
                            [
                                -157.81765971424267,
                                21.297842984269934
                            ],
                            [
                                -157.81766030467639,
                                21.29782557014537
                            ],
                            [
                                -157.81766290678061,
                                21.297825647146048
                            ],
                            [
                                -157.81766294586765,
                                21.297824496501129
                            ],
                            [
                                -157.8176591044562,
                                21.297824374658443
                            ],
                            [
                                -157.81765655162047,
                                21.297899603733335
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.8174823844912,
                                21.297606292253288
                            ],
                            [
                                -157.81754501001552,
                                21.297608421601474
                            ],
                            [
                                -157.81754927096384,
                                21.297498377920778
                            ],
                            [
                                -157.81748664547868,
                                21.29749624947965
                            ],
                            [
                                -157.8174823844912,
                                21.297606292253288
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 245,
                "NUMBER": "1046B",
                "PROPER_NAME": "KRAUSS HALL PRI BUILDING 1",
                "DISPLAY_NAME": "KRAUSS HALL PRI BUILDING 1 - 1046B",
                "ADDRESS": "2500 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KRAUSS HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1046B_01.jpg",
                "HEIGHT (ft)": 24.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 286.77019351522819,
                "SHAPE_Area": 854.9094141566236
            }
        },
        {
            "type": "Feature",
            "id": 246,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.81772536962245,
                                21.298515787551136
                            ],
                            [
                                -157.81784476865121,
                                21.298512276461739
                            ],
                            [
                                -157.81784364827476,
                                21.298478799781044
                            ],
                            [
                                -157.81789967802774,
                                21.298477151678224
                            ],
                            [
                                -157.8178997698582,
                                21.298479892306645
                            ],
                            [
                                -157.81790123832829,
                                21.298479850224464
                            ],
                            [
                                -157.81790114554113,
                                21.298477108685926
                            ],
                            [
                                -157.8179071515508,
                                21.298476932251198
                            ],
                            [
                                -157.81790691342658,
                                21.298469823605508
                            ],
                            [
                                -157.81790991016581,
                                21.29846973534406
                            ],
                            [
                                -157.81790986429019,
                                21.298468360061484
                            ],
                            [
                                -157.81790686658709,
                                21.298468448316175
                            ],
                            [
                                -157.81790414859339,
                                21.298387277655582
                            ],
                            [
                                -157.81790714629486,
                                21.29838718940087
                            ],
                            [
                                -157.81790710041926,
                                21.298385814118276
                            ],
                            [
                                -157.81790410272507,
                                21.298385901469654
                            ],
                            [
                                -157.81790322730618,
                                21.298359762039933
                            ],
                            [
                                -157.81790622500708,
                                21.298359673785207
                            ],
                            [
                                -157.81790617816759,
                                21.298358298495838
                            ],
                            [
                                -157.81790318239456,
                                21.298358386764107
                            ],
                            [
                                -157.81790046439448,
                                21.298277217005957
                            ],
                            [
                                -157.81790346017308,
                                21.298277127834329
                            ],
                            [
                                -157.81790341526144,
                                21.298275752558489
                            ],
                            [
                                -157.81790041756946,
                                21.298275839909902
                            ],
                            [
                                -157.81790018341971,
                                21.298268836988679
                            ],
                            [
                                -157.81789417838243,
                                21.298269013430328
                            ],
                            [
                                -157.81789408420207,
                                21.298266205031066
                            ],
                            [
                                -157.81789261573411,
                                21.298266247113286
                            ],
                            [
                                -157.8178927099072,
                                21.298269056415887
                            ],
                            [
                                -157.81783545666573,
                                21.298270740191537
                            ],
                            [
                                -157.81783536249372,
                                21.298267930888962
                            ],
                            [
                                -157.81783389497522,
                                21.29826797478411
                            ],
                            [
                                -157.8178339891472,
                                21.298270784086711
                            ],
                            [
                                -157.81777673590548,
                                21.298272467842299
                            ],
                            [
                                -157.81777664173458,
                                21.298269658539738
                            ],
                            [
                                -157.8177751742233,
                                21.298269701531041
                            ],
                            [
                                -157.81777526743747,
                                21.298272509923493
                            ],
                            [
                                -157.81771801418822,
                                21.298274194562392
                            ],
                            [
                                -157.81771792001845,
                                21.298271385259852
                            ],
                            [
                                -157.81771645249992,
                                21.298271429153978
                            ],
                            [
                                -157.8177165466841,
                                21.298274236649849
                            ],
                            [
                                -157.81765929344184,
                                21.298275920365363
                            ],
                            [
                                -157.81765919926596,
                                21.298273111966182
                            ],
                            [
                                -157.81765773175465,
                                21.298273154956458
                            ],
                            [
                                -157.81765782495935,
                                21.298275964252205
                            ],
                            [
                                -157.81760057171678,
                                21.298277647947682
                            ],
                            [
                                -157.81760047754923,
                                21.298274838645163
                            ],
                            [
                                -157.8175990100379,
                                21.298274881634942
                            ],
                            [
                                -157.81759910420544,
                                21.298277690937443
                            ],
                            [
                                -157.81754185096256,
                                21.298279374612875
                            ],
                            [
                                -157.81754175679617,
                                21.298276565310378
                            ],
                            [
                                -157.81754028927759,
                                21.298276609202979
                            ],
                            [
                                -157.81754038248008,
                                21.298279418498687
                            ],
                            [
                                -157.8174831302081,
                                21.298281101257516
                            ],
                            [
                                -157.81748303507163,
                                21.298278292851595
                            ],
                            [
                                -157.81748156756029,
                                21.298278335840351
                            ],
                            [
                                -157.81748166173281,
                                21.298281144239471
                            ],
                            [
                                -157.81742440945331,
                                21.298282827881589
                            ],
                            [
                                -157.81742431528193,
                                21.298280019482469
                            ],
                            [
                                -157.81742284680664,
                                21.298280062463935
                            ],
                            [
                                -157.81742294097799,
                                21.298282870863037
                            ],
                            [
                                -157.81736568773434,
                                21.298284554478339
                            ],
                            [
                                -157.81736559356403,
                                21.29828174607924
                            ],
                            [
                                -157.81736412508877,
                                21.298281789060187
                            ],
                            [
                                -157.81736422021572,
                                21.298284598369388
                            ],
                            [
                                -157.81735100777928,
                                21.298284987031042
                            ],
                            [
                                -157.81734748161952,
                                21.29817968294202
                            ],
                            [
                                -157.81737537398388,
                                21.298178862629499
                            ],
                            [
                                -157.81737546903156,
                                21.29818168187548
                            ],
                            [
                                -157.8173769365419,
                                21.298181638887609
                            ],
                            [
                                -157.81737684149419,
                                21.298178819641642
                            ],
                            [
                                -157.81740400106361,
                                21.29817802127674
                            ],
                            [
                                -157.81740409514796,
                                21.298180840515943
                            ],
                            [
                                -157.81740556265828,
                                21.298180797527838
                            ],
                            [
                                -157.81740546858117,
                                21.298177977385279
                            ],
                            [
                                -157.81740995692257,
                                21.298177846313681
                            ],
                            [
                                -157.81740982557551,
                                21.298173901188171
                            ],
                            [
                                -157.8174125542597,
                                21.298173820989081
                            ],
                            [
                                -157.81741250838868,
                                21.298172445706534
                            ],
                            [
                                -157.81740977874782,
                                21.298172524995515
                            ],
                            [
                                -157.817408926826,
                                21.298147074114691
                            ],
                            [
                                -157.81741165551691,
                                21.298146993012249
                            ],
                            [
                                -157.81741161061709,
                                21.298145616833136
                            ],
                            [
                                -157.81740888096948,
                                21.298145697025461
                            ],
                            [
                                -157.81740800563028,
                                21.298119558499916
                            ],
                            [
                                -157.81741073527738,
                                21.29811947830758
                            ],
                            [
                                -157.81741068941361,
                                21.298118102121688
                            ],
                            [
                                -157.81740795976651,
                                21.29811818231402
                            ],
                            [
                                -157.81740708443462,
                                21.29809204288506
                            ],
                            [
                                -157.81740981408123,
                                21.298091962692713
                            ],
                            [
                                -157.81740976725357,
                                21.298090586500042
                            ],
                            [
                                -157.81740703759974,
                                21.29809066759573
                            ],
                            [
                                -157.81740618665651,
                                21.298065214914786
                            ],
                            [
                                -157.81740891533869,
                                21.29806513471566
                            ],
                            [
                                -157.8174088694677,
                                21.298063759433099
                            ],
                            [
                                -157.8174061398216,
                                21.298063839625453
                            ],
                            [
                                -157.81740599735031,
                                21.298059598109671
                            ],
                            [
                                -157.81740150901251,
                                21.29805972918135
                            ],
                            [
                                -157.81740142507405,
                                21.298057208132228
                            ],
                            [
                                -157.81739995660826,
                                21.298057250210242
                            ],
                            [
                                -157.81740004149614,
                                21.298059773072811
                            ],
                            [
                                -157.81737288291239,
                                21.298060571444871
                            ],
                            [
                                -157.81737279898169,
                                21.298058049492418
                            ],
                            [
                                -157.81737133050862,
                                21.298058092473532
                            ],
                            [
                                -157.81737141443935,
                                21.298060614425971
                            ],
                            [
                                -157.81734352306128,
                                21.298061434745659
                            ],
                            [
                                -157.81734343817436,
                                21.2980589118831
                            ],
                            [
                                -157.81734197065799,
                                21.298058955774078
                            ],
                            [
                                -157.81734205458821,
                                21.298061477726499
                            ],
                            [
                                -157.81731416224616,
                                21.29806229803453
                            ],
                            [
                                -157.81731407735973,
                                21.298059775171986
                            ],
                            [
                                -157.81731260984338,
                                21.298059819062697
                            ],
                            [
                                -157.81731269472976,
                                21.298062341925228
                            ],
                            [
                                -157.81728480143096,
                                21.298063161318264
                            ],
                            [
                                -157.81728471653781,
                                21.298060639359068
                            ],
                            [
                                -157.81728324902866,
                                21.29806068234619
                            ],
                            [
                                -157.81728333391459,
                                21.298063205208706
                            ],
                            [
                                -157.8172554406157,
                                21.298064024596858
                            ],
                            [
                                -157.81725535668696,
                                21.298061502644444
                            ],
                            [
                                -157.81725388821391,
                                21.298061545624538
                            ],
                            [
                                -157.8172539730993,
                                21.298064068487044
                            ],
                            [
                                -157.81722608075702,
                                21.298064888780431
                            ],
                            [
                                -157.81722599587212,
                                21.298062365917911
                            ],
                            [
                                -157.81722452835575,
                                21.298062409807855
                            ],
                            [
                                -157.81722461229117,
                                21.298064930856906
                            ],
                            [
                                -157.81719671994162,
                                21.298065752048746
                            ],
                            [
                                -157.8171966350572,
                                21.298063229186241
                            ],
                            [
                                -157.81719516754805,
                                21.298063272172588
                            ],
                            [
                                -157.81719525243969,
                                21.298065794131741
                            ],
                            [
                                -157.81716809384824,
                                21.298066593373981
                            ],
                            [
                                -157.81716800895711,
                                21.298064071414835
                            ],
                            [
                                -157.81716654144796,
                                21.298064114400916
                            ],
                            [
                                -157.81716662537517,
                                21.298066636353305
                            ],
                            [
                                -157.81716252946021,
                                21.298066756625747
                            ],
                            [
                                -157.81716267191726,
                                21.29807099904475
                            ],
                            [
                                -157.81715954887704,
                                21.298071090922466
                            ],
                            [
                                -157.81715959570963,
                                21.298072466211764
                            ],
                            [
                                -157.81716271874265,
                                21.298072375237382
                            ],
                            [
                                -157.81716357062226,
                                21.298097826117669
                            ],
                            [
                                -157.81716044758147,
                                21.298097917995392
                            ],
                            [
                                -157.81716049344291,
                                21.298099294181249
                            ],
                            [
                                -157.81716361648373,
                                21.298099202303526
                            ],
                            [
                                -157.81716449177247,
                                21.298125341731751
                            ],
                            [
                                -157.81716136873109,
                                21.298125433609446
                            ],
                            [
                                -157.81716141459975,
                                21.298126808891958
                            ],
                            [
                                -157.81716453764116,
                                21.298126717014242
                            ],
                            [
                                -157.81716541292275,
                                21.298152857345737
                            ],
                            [
                                -157.81716228988802,
                                21.29815294832008
                            ],
                            [
                                -157.81716233671338,
                                21.298154324512705
                            ],
                            [
                                -157.81716545782751,
                                21.298154232621467
                            ],
                            [
                                -157.81716631066399,
                                21.298179684411654
                            ],
                            [
                                -157.81716318858543,
                                21.29817977629612
                            ],
                            [
                                -157.81716323444687,
                                21.298181152481966
                            ],
                            [
                                -157.81716635749663,
                                21.298181059700937
                            ],
                            [
                                -157.81716650054176,
                                21.298185349100322
                            ],
                            [
                                -157.81717059646004,
                                21.298185228827933
                            ],
                            [
                                -157.81717067883534,
                                21.298187703793079
                            ],
                            [
                                -157.81717214634571,
                                21.298187660807002
                            ],
                            [
                                -157.81717206397039,
                                21.29818518584187
                            ],
                            [
                                -157.81719922258364,
                                21.298184386600013
                            ],
                            [
                                -157.8171993049522,
                                21.298186862468512
                            ],
                            [
                                -157.81720077343371,
                                21.298186818585616
                            ],
                            [
                                -157.81720069008676,
                                21.298184344517026
                            ],
                            [
                                -157.81722858342266,
                                21.298183523332373
                            ],
                            [
                                -157.81722866579895,
                                21.298185998297537
                            ],
                            [
                                -157.81723013330932,
                                21.298185955310949
                            ],
                            [
                                -157.81723005093303,
                                21.298183480345781
                            ],
                            [
                                -157.8172579432977,
                                21.298182660052809
                            ],
                            [
                                -157.81725802663843,
                                21.29818513502476
                            ],
                            [
                                -157.81725949414152,
                                21.298185092941257
                            ],
                            [
                                -157.817259411772,
                                21.29818261707274
                            ],
                            [
                                -157.81728730412937,
                                21.298181797678222
                            ],
                            [
                                -157.81728738651387,
                                21.298184271740066
                            ],
                            [
                                -157.81728885498092,
                                21.298184229663079
                            ],
                            [
                                -157.81728877164693,
                                21.298181753787784
                            ],
                            [
                                -157.81731666497541,
                                21.298180933491818
                            ],
                            [
                                -157.81732017940823,
                                21.298285893306456
                            ],
                            [
                                -157.81730696697173,
                                21.298286281964639
                            ],
                            [
                                -157.81730687280981,
                                21.29828347266222
                            ],
                            [
                                -157.81730540529844,
                                21.29828351564943
                            ],
                            [
                                -157.81730549849644,
                                21.29828632494506
                            ],
                            [
                                -157.81729938160808,
                                21.29828650509635
                            ],
                            [
                                -157.81729961572933,
                                21.298293508017082
                            ],
                            [
                                -157.81729674048387,
                                21.298293592604622
                            ],
                            [
                                -157.81729678731045,
                                21.298294968797244
                            ],
                            [
                                -157.81729966255594,
                                21.2982948842097
                            ],
                            [
                                -157.81730238021808,
                                21.298376054865393
                            ],
                            [
                                -157.817299504971,
                                21.29837613945293
                            ],
                            [
                                -157.81729955180484,
                                21.298377514742185
                            ],
                            [
                                -157.8173024251241,
                                21.29837743014112
                            ],
                            [
                                -157.81730330140041,
                                21.298403569575751
                            ],
                            [
                                -157.8173004261528,
                                21.298403654163273
                            ],
                            [
                                -157.81730047297941,
                                21.298405030355884
                            ],
                            [
                                -157.81730334726311,
                                21.298404945761582
                            ],
                            [
                                -157.8173060649261,
                                21.298486116416374
                            ],
                            [
                                -157.81730319064081,
                                21.298486201010643
                            ],
                            [
                                -157.8173032355468,
                                21.298487576286352
                            ],
                            [
                                -157.81730611079607,
                                21.298487491698854
                            ],
                            [
                                -157.81730634889135,
                                21.298494600344039
                            ],
                            [
                                -157.81731246579554,
                                21.298494419289568
                            ],
                            [
                                -157.81731255760786,
                                21.298497160821135
                            ],
                            [
                                -157.81731402608528,
                                21.298497117840732
                            ],
                            [
                                -157.81731393330176,
                                21.298494377205746
                            ],
                            [
                                -157.81737118662653,
                                21.298492693611902
                            ],
                            [
                                -157.81737127941111,
                                21.298495434246924
                            ],
                            [
                                -157.81737274692458,
                                21.298495391259241
                            ],
                            [
                                -157.81737265511114,
                                21.29849264972767
                            ],
                            [
                                -157.81742990843563,
                                21.298490966113778
                            ],
                            [
                                -157.81743000025014,
                                21.298493707645388
                            ],
                            [
                                -157.81743146872753,
                                21.298493664663976
                            ],
                            [
                                -157.81743137594907,
                                21.298490923125598
                            ],
                            [
                                -157.8174886292733,
                                21.298489239491666
                            ],
                            [
                                -157.81748872108889,
                                21.298491981023293
                            ],
                            [
                                -157.81749018957348,
                                21.29849193713801
                            ],
                            [
                                -157.81749009775785,
                                21.298489195606404
                            ],
                            [
                                -157.81754735107458,
                                21.298487512855768
                            ],
                            [
                                -157.81754744192733,
                                21.298490254380635
                            ],
                            [
                                -157.81754891137587,
                                21.298490210501615
                            ],
                            [
                                -157.81754881858799,
                                21.298487469866554
                            ],
                            [
                                -157.81760607094773,
                                21.298485786185765
                            ],
                            [
                                -157.81760616373663,
                                21.298488526820861
                            ],
                            [
                                -157.81760763124285,
                                21.298488484734474
                            ],
                            [
                                -157.81760754038899,
                                21.298485743209582
                            ],
                            [
                                -157.81766479274842,
                                21.298484059508745
                            ],
                            [
                                -157.81766488457453,
                                21.298486800137095
                            ],
                            [
                                -157.81766635305189,
                                21.298486757153626
                            ],
                            [
                                -157.81766626123297,
                                21.298484015621941
                            ],
                            [
                                -157.81772351359217,
                                21.298482331901063
                            ],
                            [
                                -157.81772360637603,
                                21.298485073439537
                            ],
                            [
                                -157.81772434012913,
                                21.298485052395826
                            ],
                            [
                                -157.81772536962245,
                                21.298515787551136
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81748969165747,
                                21.298242222073821
                            ],
                            [
                                -157.81749062743668,
                                21.298267555199597
                            ],
                            [
                                -157.81757714820594,
                                21.29826474467129
                            ],
                            [
                                -157.81757621145519,
                                21.298239410635187
                            ],
                            [
                                -157.81748969165747,
                                21.298242222073821
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 246,
                "NUMBER": "1192",
                "PROPER_NAME": "KUYKENDALL HALL",
                "DISPLAY_NAME": "KUYKENDALL HALL (KUY) - 1192",
                "ADDRESS": "1733 DONAGHO ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KUYKENDALL HALL COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1192_01.jpg",
                "HEIGHT (ft)": 94.700000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 327.12577659984299,
                "SHAPE_Area": 1879.5902599586861
            }
        },
        {
            "type": "Feature",
            "id": 247,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81603622833671,
                            21.293764308191754
                        ],
                        [
                            -157.81603787274159,
                            21.29376600367808
                        ],
                        [
                            -157.81604477921209,
                            21.29377312851452
                        ],
                        [
                            -157.81604839844064,
                            21.293770046307692
                        ],
                        [
                            -157.81604149293398,
                            21.293762921478159
                        ],
                        [
                            -157.81605097144094,
                            21.293754850405254
                        ],
                        [
                            -157.81609252078354,
                            21.293756715447966
                        ],
                        [
                            -157.81612294859139,
                            21.293753589622366
                        ],
                        [
                            -157.81612977094508,
                            21.293760626234981
                        ],
                        [
                            -157.81612216950128,
                            21.29376709976901
                        ],
                        [
                            -157.81612545830598,
                            21.293770491643407
                        ],
                        [
                            -157.81613305974255,
                            21.293764019012567
                        ],
                        [
                            -157.81613486983778,
                            21.293762477911542
                        ],
                        [
                            -157.81614837713389,
                            21.29375097698901
                        ],
                        [
                            -157.81616463682235,
                            21.29374930534113
                        ],
                        [
                            -157.81616910741243,
                            21.293748846241684
                        ],
                        [
                            -157.81618415924081,
                            21.293747299798842
                        ],
                        [
                            -157.81619819985954,
                            21.293743710904032
                        ],
                        [
                            -157.81620649642531,
                            21.293752270157331
                        ],
                        [
                            -157.81621504731069,
                            21.2937610904719
                        ],
                        [
                            -157.81621866749947,
                            21.293758008267982
                        ],
                        [
                            -157.81625144236537,
                            21.293730099949986
                        ],
                        [
                            -157.81625413630809,
                            21.293729412443621
                        ],
                        [
                            -157.81627309925958,
                            21.29372456450314
                        ],
                        [
                            -157.81629536645579,
                            21.293715160509706
                        ],
                        [
                            -157.81631519626674,
                            21.293706786403014
                        ],
                        [
                            -157.81631765395605,
                            21.293705748525472
                        ],
                        [
                            -157.81635714818188,
                            21.29368906960558
                        ],
                        [
                            -157.8163579696386,
                            21.29368856586963
                        ],
                        [
                            -157.81636906233987,
                            21.293681747387328
                        ],
                        [
                            -157.81638290686996,
                            21.293696027971258
                        ],
                        [
                            -157.81639255422857,
                            21.29368781352294
                        ],
                        [
                            -157.81640305179616,
                            21.29367887511269
                        ],
                        [
                            -157.81640884408881,
                            21.293673943579432
                        ],
                        [
                            -157.81641029119803,
                            21.293672710689293
                        ],
                        [
                            -157.8164104173714,
                            21.293672603169608
                        ],
                        [
                            -157.81641391138069,
                            21.293669628480878
                        ],
                        [
                            -157.81641535848982,
                            21.293668395590693
                        ],
                        [
                            -157.81641897963618,
                            21.29366531338891
                        ],
                        [
                            -157.81642042674522,
                            21.293664080498697
                        ],
                        [
                            -157.81642404596357,
                            21.29366099828324
                        ],
                        [
                            -157.81642549403645,
                            21.293659765399756
                        ],
                        [
                            -157.81642911421847,
                            21.293656683190957
                        ],
                        [
                            -157.81643056132734,
                            21.293655450300626
                        ],
                        [
                            -157.81643418150915,
                            21.293652368091728
                        ],
                        [
                            -157.81643562958183,
                            21.293651135208133
                        ],
                        [
                            -157.81643924879958,
                            21.29364805299231
                        ],
                        [
                            -157.8164465692717,
                            21.293655602607327
                        ],
                        [
                            -157.81647148006388,
                            21.293681298546868
                        ],
                        [
                            -157.81647542662876,
                            21.293685369872325
                        ],
                        [
                            -157.81648134648364,
                            21.293691475957022
                        ],
                        [
                            -157.81648569070171,
                            21.293687777305021
                        ],
                        [
                            -157.81654650298483,
                            21.293635996116382
                        ],
                        [
                            -157.81655084719966,
                            21.293632297462519
                        ],
                        [
                            -157.81654492638734,
                            21.293626190470071
                        ],
                        [
                            -157.81654098077141,
                            21.293622120959647
                        ],
                        [
                            -157.81653266219641,
                            21.293613539886135
                        ],
                        [
                            -157.81650874951018,
                            21.293588874514729
                        ],
                        [
                            -157.81651236968878,
                            21.293585792303954
                        ],
                        [
                            -157.81651381776015,
                            21.293584559419632
                        ],
                        [
                            -157.81651743697464,
                            21.293581477201954
                        ],
                        [
                            -157.81651888504595,
                            21.293580244317564
                        ],
                        [
                            -157.8165225052241,
                            21.293577162106562
                        ],
                        [
                            -157.8165239532953,
                            21.293575929222133
                        ],
                        [
                            -157.81652757250936,
                            21.293572847004214
                        ],
                        [
                            -157.81652902058775,
                            21.293571613216407
                        ],
                        [
                            -157.81653066664427,
                            21.293570212789842
                        ],
                        [
                            -157.8165326407655,
                            21.29356853100515
                        ],
                        [
                            -157.81653408882929,
                            21.293567299023966
                        ],
                        [
                            -157.81653758186977,
                            21.293564324325605
                        ],
                        [
                            -157.81653770804294,
                            21.293564216805812
                        ],
                        [
                            -157.81653915611389,
                            21.293562983921248
                        ],
                        [
                            -157.81654494743364,
                            21.293558052376039
                        ],
                        [
                            -157.81655294579772,
                            21.293551241937291
                        ],
                        [
                            -157.81655751615759,
                            21.293547349740667
                        ],
                        [
                            -157.81655890114888,
                            21.293546169712471
                        ],
                        [
                            -157.816560538472,
                            21.29354477645132
                        ],
                        [
                            -157.81656509232965,
                            21.293540898592706
                        ],
                        [
                            -157.81655124778769,
                            21.293526618926705
                        ],
                        [
                            -157.81655954976554,
                            21.293516921578725
                        ],
                        [
                            -157.81656016472016,
                            21.293516204093059
                        ],
                        [
                            -157.81656651566655,
                            21.293505785672856
                        ],
                        [
                            -157.81658367158334,
                            21.293477646419699
                        ],
                        [
                            -157.81658390892446,
                            21.293477258726927
                        ],
                        [
                            -157.81658442270452,
                            21.293476415861932
                        ],
                        [
                            -157.81660589885809,
                            21.293441189163829
                        ],
                        [
                            -157.81661384980245,
                            21.293421515008003
                        ],
                        [
                            -157.81663134601735,
                            21.293406617332352
                        ],
                        [
                            -157.81664662451985,
                            21.293393606604987
                        ],
                        [
                            -157.81665022139111,
                            21.293390545005025
                        ],
                        [
                            -157.81665024469072,
                            21.293390524390823
                        ],
                        [
                            -157.81665022174542,
                            21.293390500741364
                        ],
                        [
                            -157.8166488717994,
                            21.293389109063405
                        ],
                        [
                            -157.81664169379846,
                            21.293381704097772
                        ],
                        [
                            -157.8166333962549,
                            21.293373145761919
                        ],
                        [
                            -157.81663530606841,
                            21.293368418193598
                        ],
                        [
                            -157.81663570926605,
                            21.29336742097459
                        ],
                        [
                            -157.81663854938995,
                            21.293360391783111
                        ],
                        [
                            -157.81664587655612,
                            21.293327362028428
                        ],
                        [
                            -157.81665938378029,
                            21.293315860157254
                        ],
                        [
                            -157.81666119290071,
                            21.293314319043205
                        ],
                        [
                            -157.81666879525451,
                            21.293307846392437
                        ],
                        [
                            -157.8166655064465,
                            21.293304454528375
                        ],
                        [
                            -157.81665790409278,
                            21.293310927179
                        ],
                        [
                            -157.81665108270357,
                            21.293303889690684
                        ],
                        [
                            -157.8166527717602,
                            21.293296273333365
                        ],
                        [
                            -157.81665535279959,
                            21.293284640447656
                        ],
                        [
                            -157.81665731189474,
                            21.293275802797567
                        ],
                        [
                            -157.81665892430203,
                            21.293244282182275
                        ],
                        [
                            -157.81665897811462,
                            21.293243219269659
                        ],
                        [
                            -157.81665930274454,
                            21.293236863487728
                        ],
                        [
                            -157.81666878214821,
                            21.293228792383168
                        ],
                        [
                            -157.81667568863404,
                            21.293235916291067
                        ],
                        [
                            -157.81667930783641,
                            21.293232834069233
                        ],
                        [
                            -157.81667240231445,
                            21.293225710168251
                        ],
                        [
                            -157.816670756951,
                            21.293224013777845
                        ],
                        [
                            -157.81666050048463,
                            21.293213433434868
                        ],
                        [
                            -157.816660758783,
                            21.29320837987607
                        ],
                        [
                            -157.81666081476919,
                            21.293207286263446
                        ],
                        [
                            -157.81666172439185,
                            21.293189503990796
                        ],
                        [
                            -157.81665251813436,
                            21.293110818981166
                        ],
                        [
                            -157.81664475086944,
                            21.293072501262166
                        ],
                        [
                            -157.81663526803177,
                            21.293025723875306
                        ],
                        [
                            -157.81664095657641,
                            21.293024717739279
                        ],
                        [
                            -157.81662962384846,
                            21.292968438130757
                        ],
                        [
                            -157.8166238619423,
                            21.29296945730162
                        ],
                        [
                            -157.81661821822107,
                            21.292941620292009
                        ],
                        [
                            -157.81660893093317,
                            21.292943274153842
                        ],
                        [
                            -157.81659563662609,
                            21.292945641528767
                        ],
                        [
                            -157.81655936012436,
                            21.292952100492741
                        ],
                        [
                            -157.81655167236295,
                            21.292953469284576
                        ],
                        [
                            -157.81652864672736,
                            21.292957568695549
                        ],
                        [
                            -157.81649017123118,
                            21.292964419613224
                        ],
                        [
                            -157.81648008176711,
                            21.292966215983935
                        ],
                        [
                            -157.8164743159397,
                            21.29296724325259
                        ],
                        [
                            -157.81645557726637,
                            21.292970578714328
                        ],
                        [
                            -157.81643356712917,
                            21.29297449825021
                        ],
                        [
                            -157.81642987190619,
                            21.292975156135082
                        ],
                        [
                            -157.81642650778721,
                            21.292975754917382
                        ],
                        [
                            -157.81640176387882,
                            21.292980161126
                        ],
                        [
                            -157.81639599805769,
                            21.292981187488582
                        ],
                        [
                            -157.81639681966101,
                            21.292985240455995
                        ],
                        [
                            -157.81641188116322,
                            21.293059538224238
                        ],
                        [
                            -157.81641288545711,
                            21.29306449134987
                        ],
                        [
                            -157.81641000302321,
                            21.293065004986357
                        ],
                        [
                            -157.81642544008687,
                            21.293141157344941
                        ],
                        [
                            -157.81642593435578,
                            21.29314359455482
                        ],
                        [
                            -157.81643207744091,
                            21.293196106680146
                        ],
                        [
                            -157.81643001435285,
                            21.293236476448048
                        ],
                        [
                            -157.81642946008151,
                            21.293247314142455
                        ],
                        [
                            -157.81642938150895,
                            21.293248700294694
                        ],
                        [
                            -157.81642610042175,
                            21.293263490121419
                        ],
                        [
                            -157.81642920814554,
                            21.293264094659797
                        ],
                        [
                            -157.81642219187688,
                            21.293295730850915
                        ],
                        [
                            -157.81642162188032,
                            21.293298297892935
                        ],
                        [
                            -157.81641998043688,
                            21.29330357751056
                        ],
                        [
                            -157.81640915436287,
                            21.293330556132034
                        ],
                        [
                            -157.81640263233325,
                            21.293346811957292
                        ],
                        [
                            -157.81640075458665,
                            21.293350543308264
                        ],
                        [
                            -157.81639887780383,
                            21.293354274665983
                        ],
                        [
                            -157.81637432754377,
                            21.293394325508011
                        ],
                        [
                            -157.81637102531528,
                            21.293398871637756
                        ],
                        [
                            -157.81633926527473,
                            21.293435968279191
                        ],
                        [
                            -157.81633524441031,
                            21.293439974547503
                        ],
                        [
                            -157.81631646411665,
                            21.29345596529787
                        ],
                        [
                            -157.81629768381171,
                            21.293471956949272
                        ],
                        [
                            -157.81629304343059,
                            21.293475323776331
                        ],
                        [
                            -157.81628773877699,
                            21.293478584752211
                        ],
                        [
                            -157.81625060720262,
                            21.293501406165081
                        ],
                        [
                            -157.81624546169479,
                            21.293504053049716
                        ],
                        [
                            -157.81620057531953,
                            21.293523126854623
                        ],
                        [
                            -157.81619643269744,
                            21.293524521464214
                        ],
                        [
                            -157.81619229007526,
                            21.293525916073698
                        ],
                        [
                            -157.81614471173128,
                            21.293537966040439
                        ],
                        [
                            -157.81613894587963,
                            21.293538993296387
                        ],
                        [
                            -157.81608435438054,
                            21.2935446015296
                        ],
                        [
                            -157.81608434219189,
                            21.293544197628282
                        ],
                        [
                            -157.81608425149469,
                            21.293541439842347
                        ],
                        [
                            -157.81602940459845,
                            21.293538977176798
                        ],
                        [
                            -157.81602839115109,
                            21.29353877943305
                        ],
                        [
                            -157.81598104293209,
                            21.293529555220612
                        ],
                        [
                            -157.81597421729933,
                            21.293528226200916
                        ],
                        [
                            -157.81589226769702,
                            21.293505850024147
                        ],
                        [
                            -157.81589144647907,
                            21.2935084902781
                        ],
                        [
                            -157.81588628237162,
                            21.293507079893772
                        ],
                        [
                            -157.81586969931681,
                            21.293502551981945
                        ],
                        [
                            -157.81585755706763,
                            21.29349923694339
                        ],
                        [
                            -157.81585167831193,
                            21.293497631818635
                        ],
                        [
                            -157.81584798293571,
                            21.293496622030094
                        ],
                        [
                            -157.81580880629991,
                            21.293485925815382
                        ],
                        [
                            -157.81580457998004,
                            21.293484772265149
                        ],
                        [
                            -157.81580293850521,
                            21.293490052778868
                        ],
                        [
                            -157.81579589274637,
                            21.293512716255361
                        ],
                        [
                            -157.81579493595035,
                            21.293515795506131
                        ],
                        [
                            -157.81579438482538,
                            21.293517569501411
                        ],
                        [
                            -157.81579388417549,
                            21.293519179434714
                        ],
                        [
                            -157.8157822820514,
                            21.29355650088856
                        ],
                        [
                            -157.81577776726405,
                            21.293571022746868
                        ],
                        [
                            -157.81576681319984,
                            21.293606261022969
                        ],
                        [
                            -157.81576025623087,
                            21.293627349712853
                        ],
                        [
                            -157.81576014636667,
                            21.293627707585937
                        ],
                        [
                            -157.81575806759079,
                            21.29363439069801
                        ],
                        [
                            -157.81574773982294,
                            21.293667615204154
                        ],
                        [
                            -157.81574271249221,
                            21.293683786659646
                        ],
                        [
                            -157.81574259871442,
                            21.293684151732307
                        ],
                        [
                            -157.81574199416326,
                            21.293686096995643
                        ],
                        [
                            -157.81574131045318,
                            21.293688297361555
                        ],
                        [
                            -157.81574857329841,
                            21.293690280811415
                        ],
                        [
                            -157.81577042629286,
                            21.293696246970292
                        ],
                        [
                            -157.81577366480309,
                            21.293697131588779
                        ],
                        [
                            -157.81591774261398,
                            21.293736470599189
                        ],
                        [
                            -157.81600043752513,
                            21.293752581576967
                        ],
                        [
                            -157.81601263473689,
                            21.29375312900407
                        ],
                        [
                            -157.81601418324374,
                            21.293753197713116
                        ],
                        [
                            -157.8160259709185,
                            21.293753727804358
                        ],
                        [
                            -157.81603622833671,
                            21.293764308191754
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 247,
                "NUMBER": "1115",
                "PROPER_NAME": "LES MURAKAMI STADIUM",
                "DISPLAY_NAME": "LES MURAKAMI STADIUM - 1115",
                "ADDRESS": "LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "LES MURAKAMI STADIUM AND BATTING CAGES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1115_01.jpg",
                "HEIGHT (ft)": 65.599999999999994,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 356.74832707633823,
                "SHAPE_Area": 3343.9979077742928
            }
        },
        {
            "type": "Feature",
            "id": 248,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81260849022118,
                            21.304121211687995
                        ],
                        [
                            -157.81263836657246,
                            21.304079494445769
                        ],
                        [
                            -157.81265422153149,
                            21.304089465912917
                        ],
                        [
                            -157.81304776313934,
                            21.30353994676307
                        ],
                        [
                            -157.81304613443959,
                            21.303538927995447
                        ],
                        [
                            -157.81304486596375,
                            21.303540708660663
                        ],
                        [
                            -157.81289689155409,
                            21.303447637448436
                        ],
                        [
                            -157.81250461719034,
                            21.303995375569162
                        ],
                        [
                            -157.81252087881509,
                            21.304005602867125
                        ],
                        [
                            -157.81249100245506,
                            21.304047319184654
                        ],
                        [
                            -157.81260849022118,
                            21.304121211687995
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 248,
                "NUMBER": "1195",
                "PROPER_NAME": "MAINTENANCE WAREHOUSE (HALE UKANA)",
                "DISPLAY_NAME": "MAINTENANCE WAREHOUSE (HALE UKANA) - 1195",
                "ADDRESS": "2002 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PACIFIC BIOSCIENCE RESEARCH CENTER COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1195_01.jpg",
                "HEIGHT (ft)": 22.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 195.0235919110734,
                "SHAPE_Area": 1446.4858398957163
            }
        },
        {
            "type": "Feature",
            "id": 249,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81289689155409,
                            21.303447637448436
                        ],
                        [
                            -157.81304486888462,
                            21.303540705067718
                        ],
                        [
                            -157.81317563763227,
                            21.303358109455591
                        ],
                        [
                            -157.81302764967771,
                            21.303265055429307
                        ],
                        [
                            -157.81289689155409,
                            21.303447637448436
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 249,
                "NUMBER": "1195C",
                "PROPER_NAME": "BIOPHYSICS LAB (PBRC) - WAREHOUSE",
                "DISPLAY_NAME": "BIOPHYSICS LAB (PBRC) - WAREHOUSE - 1195C",
                "ADDRESS": "1933 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PACIFIC BIOSCIENCE RESEARCH CENTER COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1195C_01.jpg",
                "HEIGHT (ft)": 24.900000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 85.658989262619997,
                "SHAPE_Area": 450.02196457156305
            }
        },
        {
            "type": "Feature",
            "id": 255,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81826448916661,
                            21.295253647484152
                        ],
                        [
                            -157.81827384276605,
                            21.2951594235332
                        ],
                        [
                            -157.81830016636849,
                            21.295161718666364
                        ],
                        [
                            -157.81831381606727,
                            21.295162909405946
                        ],
                        [
                            -157.8183157657499,
                            21.295163079380536
                        ],
                        [
                            -157.81855949921288,
                            21.295184331609725
                        ],
                        [
                            -157.81859021731279,
                            21.295187010769332
                        ],
                        [
                            -157.81859741881874,
                            21.295187637679842
                        ],
                        [
                            -157.81860337189806,
                            21.295188157357831
                        ],
                        [
                            -157.8186034621063,
                            21.295187242855885
                        ],
                        [
                            -157.81860436990002,
                            21.295178106910541
                        ],
                        [
                            -157.81860796294885,
                            21.29517841940805
                        ],
                        [
                            -157.81868755028455,
                            21.295185359556388
                        ],
                        [
                            -157.81868821398535,
                            21.29518541751456
                        ],
                        [
                            -157.81869211431641,
                            21.295185757461873
                        ],
                        [
                            -157.81869225586254,
                            21.295184329290667
                        ],
                        [
                            -157.81869247705339,
                            21.295182102177382
                        ],
                        [
                            -157.81869333877742,
                            21.295173423023876
                        ],
                        [
                            -157.81869338387764,
                            21.295172966224523
                        ],
                        [
                            -157.81869415444444,
                            21.295165199759563
                        ],
                        [
                            -157.8186949250111,
                            21.29515743329457
                        ],
                        [
                            -157.81869497107522,
                            21.295156976502
                        ],
                        [
                            -157.81869499315059,
                            21.295156747195609
                        ],
                        [
                            -157.81869501090119,
                            21.295156576579288
                        ],
                        [
                            -157.81869534005017,
                            21.295153264347643
                        ],
                        [
                            -157.81869535684407,
                            21.295153092821216
                        ],
                        [
                            -157.81869537363076,
                            21.295152922198127
                        ],
                        [
                            -157.81869642824597,
                            21.295142300300796
                        ],
                        [
                            -157.81869644599655,
                            21.295142129684471
                        ],
                        [
                            -157.81869669453687,
                            21.295139616388152
                        ],
                        [
                            -157.81869674060098,
                            21.295139159595582
                        ],
                        [
                            -157.81869751116008,
                            21.295131394033895
                        ],
                        [
                            -157.81869828173353,
                            21.295123626665497
                        ],
                        [
                            -157.81869832683373,
                            21.295123169866159
                        ],
                        [
                            -157.81870027772308,
                            21.29510352576899
                        ],
                        [
                            -157.81870064045231,
                            21.295099871387787
                        ],
                        [
                            -157.81870090572863,
                            21.295097193791747
                        ],
                        [
                            -157.81870108599938,
                            21.295095382854498
                        ],
                        [
                            -157.81870240997637,
                            21.295082054481128
                        ],
                        [
                            -157.81870245411264,
                            21.295081597675026
                        ],
                        [
                            -157.81870322564208,
                            21.295073831216637
                        ],
                        [
                            -157.81870399620755,
                            21.295066064751492
                        ],
                        [
                            -157.81870404227161,
                            21.295065607958914
                        ],
                        [
                            -157.81870483588341,
                            21.295057611290769
                        ],
                        [
                            -157.81870489984959,
                            21.295056964911716
                        ],
                        [
                            -157.81870837083457,
                            21.29502200726019
                        ],
                        [
                            -157.81870844111828,
                            21.29502129407453
                        ],
                        [
                            -157.81870977429458,
                            21.295021410934599
                        ],
                        [
                            -157.81871282790337,
                            21.295021676281038
                        ],
                        [
                            -157.81871291906748,
                            21.295020762689102
                        ],
                        [
                            -157.81872859260955,
                            21.295022130208793
                        ],
                        [
                            -157.81878638852677,
                            21.295027169309677
                        ],
                        [
                            -157.81879237627936,
                            21.295027691934258
                        ],
                        [
                            -157.81879228512295,
                            21.295028604622935
                        ],
                        [
                            -157.81879618545025,
                            21.295028944567644
                        ],
                        [
                            -157.81879627564996,
                            21.295028030968876
                        ],
                        [
                            -157.81886024716374,
                            21.295033609344689
                        ],
                        [
                            -157.81886304164325,
                            21.295033852995431
                        ],
                        [
                            -157.8188801206218,
                            21.295035342383997
                        ],
                        [
                            -157.8188800304226,
                            21.295036255982833
                        ],
                        [
                            -157.81888392978652,
                            21.295036595918759
                        ],
                        [
                            -157.81888402094958,
                            21.295035682326681
                        ],
                        [
                            -157.8189098561584,
                            21.29503793509101
                        ],
                        [
                            -157.81891034358071,
                            21.295037977357087
                        ],
                        [
                            -157.81891862972401,
                            21.295038700396869
                        ],
                        [
                            -157.81892691683848,
                            21.295039422539663
                        ],
                        [
                            -157.81892740521749,
                            21.295039465715799
                        ],
                        [
                            -157.81896786401182,
                            21.295042992781621
                        ],
                        [
                            -157.81896777381314,
                            21.295043906380528
                        ],
                        [
                            -157.81897167317757,
                            21.295044246314454
                        ],
                        [
                            -157.81897176434012,
                            21.295043332722294
                        ],
                        [
                            -157.81898173237579,
                            21.295044202165542
                        ],
                        [
                            -157.81901661088088,
                            21.295047242886309
                        ],
                        [
                            -157.81902477505278,
                            21.294965012077743
                        ],
                        [
                            -157.81904164884548,
                            21.294966483748976
                        ],
                        [
                            -157.81906377156392,
                            21.294968412322483
                        ],
                        [
                            -157.81906368136592,
                            21.294969325921482
                        ],
                        [
                            -157.81906758072873,
                            21.294969665853106
                        ],
                        [
                            -157.81906767189059,
                            21.294968752260854
                        ],
                        [
                            -157.81910105054376,
                            21.294971663192786
                        ],
                        [
                            -157.81910298096173,
                            21.294971831216255
                        ],
                        [
                            -157.81915151686397,
                            21.294976061733188
                        ],
                        [
                            -157.8191514256954,
                            21.294976976228831
                        ],
                        [
                            -157.81915532505872,
                            21.294977316158445
                        ],
                        [
                            -157.81915541622004,
                            21.294976402566117
                        ],
                        [
                            -157.81923926119717,
                            21.294983712898471
                        ],
                        [
                            -157.81923917002911,
                            21.294984627394186
                        ],
                        [
                            -157.81924307036405,
                            21.294984966425208
                        ],
                        [
                            -157.81924316055375,
                            21.294984053729404
                        ],
                        [
                            -157.81928766609127,
                            21.294987933423478
                        ],
                        [
                            -157.81929873227031,
                            21.294988898180033
                        ],
                        [
                            -157.81928621370017,
                            21.295114987013054
                        ],
                        [
                            -157.81931448796649,
                            21.295117451958038
                        ],
                        [
                            -157.81930151744513,
                            21.295248108779514
                        ],
                        [
                            -157.8196329948388,
                            21.295277010555807
                        ],
                        [
                            -157.819665481632,
                            21.294949758135157
                        ],
                        [
                            -157.8196665560115,
                            21.294938945751746
                        ],
                        [
                            -157.81966691775244,
                            21.294935291360503
                        ],
                        [
                            -157.81966204355101,
                            21.294934866011612
                        ],
                        [
                            -157.81966190633898,
                            21.29493623549401
                        ],
                        [
                            -157.81965264341625,
                            21.294935428852902
                        ],
                        [
                            -157.81965215503007,
                            21.294935386582218
                        ],
                        [
                            -157.81964386888706,
                            21.294934663578655
                        ],
                        [
                            -157.81963558273691,
                            21.294933941478018
                        ],
                        [
                            -157.81963509532184,
                            21.294933898310713
                        ],
                        [
                            -157.8195853813294,
                            21.294929563911872
                        ],
                        [
                            -157.81958551757825,
                            21.294928194422827
                        ],
                        [
                            -157.81958064241351,
                            21.294927769064856
                        ],
                        [
                            -157.81958050036684,
                            21.294929140320018
                        ],
                        [
                            -157.81954959926037,
                            21.294926446508232
                        ],
                        [
                            -157.81951675522819,
                            21.29492358187424
                        ],
                        [
                            -157.81951441926878,
                            21.294923378489216
                        ],
                        [
                            -157.81951250233809,
                            21.294923211468479
                        ],
                        [
                            -157.81950421137731,
                            21.294922488424291
                        ],
                        [
                            -157.81950372395511,
                            21.294922446159948
                        ],
                        [
                            -157.81950348024762,
                            21.294922424576104
                        ],
                        [
                            -157.81950361650439,
                            21.294921054183796
                        ],
                        [
                            -157.81949874133306,
                            21.294920629726818
                        ],
                        [
                            -157.81949860604013,
                            21.294922000125858
                        ],
                        [
                            -157.81949811862515,
                            21.294921956958156
                        ],
                        [
                            -157.81949763119576,
                            21.294921915597129
                        ],
                        [
                            -157.81949378385431,
                            21.294921579653909
                        ],
                        [
                            -157.81949271268505,
                            21.294921486319069
                        ],
                        [
                            -157.81948934024237,
                            21.294921191648886
                        ],
                        [
                            -157.81942158593029,
                            21.294915284344807
                        ],
                        [
                            -157.81942172218783,
                            21.294913913952602
                        ],
                        [
                            -157.81941684702429,
                            21.29491348858993
                        ],
                        [
                            -157.8194167107595,
                            21.294914859885449
                        ],
                        [
                            -157.81939139958163,
                            21.294912653334507
                        ],
                        [
                            -157.81938803291564,
                            21.294912359606219
                        ],
                        [
                            -157.81936698618762,
                            21.294910524444987
                        ],
                        [
                            -157.81936649877275,
                            21.294910481276904
                        ],
                        [
                            -157.81935821166212,
                            21.294909759155978
                        ],
                        [
                            -157.81934992455888,
                            21.294909036131308
                        ],
                        [
                            -157.81934943618009,
                            21.294908992956419
                        ],
                        [
                            -157.81934017903785,
                            21.294908187242168
                        ],
                        [
                            -157.81934031433943,
                            21.294906815939981
                        ],
                        [
                            -157.81933544014038,
                            21.294906390581719
                        ],
                        [
                            -157.81933530387488,
                            21.294907761877155
                        ],
                        [
                            -157.81931824705921,
                            21.294906274497425
                        ],
                        [
                            -157.81930995610082,
                            21.294905551443762
                        ],
                        [
                            -157.81930946867877,
                            21.29490550917885
                        ],
                        [
                            -157.81928338881238,
                            21.294903234885716
                        ],
                        [
                            -157.81923537407212,
                            21.294899048716193
                        ],
                        [
                            -157.81922367406693,
                            21.294898028016053
                        ],
                        [
                            -157.81920082889431,
                            21.294896036578649
                        ],
                        [
                            -157.81915913328788,
                            21.294892400616895
                        ],
                        [
                            -157.81914978175121,
                            21.294891586099503
                        ],
                        [
                            -157.81907705213192,
                            21.294885244454118
                        ],
                        [
                            -157.8190702407779,
                            21.294884650113868
                        ],
                        [
                            -157.81905647260811,
                            21.294883449571277
                        ],
                        [
                            -157.81903307452481,
                            21.294881409062409
                        ],
                        [
                            -157.81894386799584,
                            21.294873631898323
                        ],
                        [
                            -157.81894338058129,
                            21.294873588729025
                        ],
                        [
                            -157.81894289317393,
                            21.294873544656387
                        ],
                        [
                            -157.81892729477795,
                            21.29487218400822
                        ],
                        [
                            -157.81892680734899,
                            21.294872142645556
                        ],
                        [
                            -157.81892631895607,
                            21.294872101276127
                        ],
                        [
                            -157.81883711341243,
                            21.294864323159384
                        ],
                        [
                            -157.81881371436566,
                            21.294862283516881
                        ],
                        [
                            -157.8187446452466,
                            21.294856261018733
                        ],
                        [
                            -157.81864611228769,
                            21.29484766933389
                        ],
                        [
                            -157.81864212623654,
                            21.294847321557111
                        ],
                        [
                            -157.81863725107866,
                            21.294846896172039
                        ],
                        [
                            -157.81863738734333,
                            21.294845525780811
                        ],
                        [
                            -157.8186325131494,
                            21.294845100402391
                        ],
                        [
                            -157.81863237688466,
                            21.294846470793615
                        ],
                        [
                            -157.81862959107707,
                            21.294846228103431
                        ],
                        [
                            -157.81855879385012,
                            21.29484005518173
                        ],
                        [
                            -157.81855535686714,
                            21.294839755523029
                        ],
                        [
                            -157.81855549313252,
                            21.294838385131886
                        ],
                        [
                            -157.81855208023256,
                            21.29483808744893
                        ],
                        [
                            -157.8185525792299,
                            21.294833062676933
                        ],
                        [
                            -157.81851163213705,
                            21.294829491433667
                        ],
                        [
                            -157.81849310826649,
                            21.29482787623235
                        ],
                        [
                            -157.81848965394104,
                            21.294827575547188
                        ],
                        [
                            -157.81845365618514,
                            21.294824435620267
                        ],
                        [
                            -157.81843729391471,
                            21.294823009037678
                        ],
                        [
                            -157.81843665863983,
                            21.294829405103481
                        ],
                        [
                            -157.81840539154345,
                            21.294826678702044
                        ],
                        [
                            -157.81840533855802,
                            21.294826674716514
                        ],
                        [
                            -157.81839156751741,
                            21.294825473196379
                        ],
                        [
                            -157.81839170474819,
                            21.294824102812203
                        ],
                        [
                            -157.81838780442047,
                            21.294823763761748
                        ],
                        [
                            -157.81838766816077,
                            21.294825133249333
                        ],
                        [
                            -157.81838181912585,
                            21.294824623328608
                        ],
                        [
                            -157.81832259861491,
                            21.29481946026371
                        ],
                        [
                            -157.81831064914243,
                            21.294818416971186
                        ],
                        [
                            -157.81831078443898,
                            21.294817047476915
                        ],
                        [
                            -157.8183059102474,
                            21.294816622089119
                        ],
                        [
                            -157.8182471964285,
                            21.294811503207757
                        ],
                        [
                            -157.81824858661253,
                            21.294797494147105
                        ],
                        [
                            -157.81818821484063,
                            21.294729306916445
                        ],
                        [
                            -157.81819441904986,
                            21.294666816851652
                        ],
                        [
                            -157.81820240131123,
                            21.294586413282758
                        ],
                        [
                            -157.81824968573497,
                            21.294590536797671
                        ],
                        [
                            -157.8182498671114,
                            21.294588708704328
                        ],
                        [
                            -157.81823914389554,
                            21.294587774293198
                        ],
                        [
                            -157.81824721633595,
                            21.294506456218389
                        ],
                        [
                            -157.81825794050269,
                            21.294507391538847
                        ],
                        [
                            -157.81825812187165,
                            21.294505564348825
                        ],
                        [
                            -157.81824739770502,
                            21.294504629028385
                        ],
                        [
                            -157.81825537992427,
                            21.294424225453717
                        ],
                        [
                            -157.81826638922456,
                            21.294425184456649
                        ],
                        [
                            -157.81826657058602,
                            21.294423358169929
                        ],
                        [
                            -157.8182555613003,
                            21.294422397360336
                        ],
                        [
                            -157.81826363563846,
                            21.29434108019921
                        ],
                        [
                            -157.81827435979343,
                            21.294342015518072
                        ],
                        [
                            -157.81827454019796,
                            21.294340188321211
                        ],
                        [
                            -157.8182628412109,
                            21.294339167563336
                        ],
                        [
                            -157.81826574409286,
                            21.294309929818596
                        ],
                        [
                            -157.81826610683703,
                            21.29430627453506
                        ],
                        [
                            -157.81826608182428,
                            21.294303977036087
                        ],
                        [
                            -157.81822553071027,
                            21.29424944189816
                        ],
                        [
                            -157.81825040083362,
                            21.293998937238221
                        ],
                        [
                            -157.81834301869026,
                            21.294007013327441
                        ],
                        [
                            -157.81837767055328,
                            21.293657985711654
                        ],
                        [
                            -157.81825677895085,
                            21.293647444546725
                        ],
                        [
                            -157.81826955200069,
                            21.29351878834127
                        ],
                        [
                            -157.81828438920147,
                            21.293369341525555
                        ],
                        [
                            -157.81827376047653,
                            21.29336841501047
                        ],
                        [
                            -157.81825514142511,
                            21.293366791894663
                        ],
                        [
                            -157.81824299211593,
                            21.293489169395208
                        ],
                        [
                            -157.81821909008315,
                            21.29348809909953
                        ],
                        [
                            -157.81821540921092,
                            21.293560280403508
                        ],
                        [
                            -157.81820498550235,
                            21.293569158019576
                        ],
                        [
                            -157.81820157475107,
                            21.293636004887635
                        ],
                        [
                            -157.8182115229458,
                            21.293636449639635
                        ],
                        [
                            -157.81821922689051,
                            21.293644394848485
                        ],
                        [
                            -157.81821171255996,
                            21.293655658871941
                        ],
                        [
                            -157.81814922962363,
                            21.293704149645617
                        ],
                        [
                            -157.81814803070199,
                            21.293702795175072
                        ],
                        [
                            -157.81792800362606,
                            21.293873895421569
                        ],
                        [
                            -157.8179286274418,
                            21.29387460083376
                        ],
                        [
                            -157.81790412574068,
                            21.294121400499854
                        ],
                        [
                            -157.81792663401174,
                            21.29414682280024
                        ],
                        [
                            -157.81790930342035,
                            21.294160299836808
                        ],
                        [
                            -157.81802705041144,
                            21.294293292802244
                        ],
                        [
                            -157.81804438101619,
                            21.294279814850629
                        ],
                        [
                            -157.81808260818653,
                            21.29432299163787
                        ],
                        [
                            -157.81808256308483,
                            21.294323448437005
                        ],
                        [
                            -157.81807370576715,
                            21.294322675274099
                        ],
                        [
                            -157.81807352439628,
                            21.294324502463887
                        ],
                        [
                            -157.81808238171405,
                            21.294325275626807
                        ],
                        [
                            -157.8180767844743,
                            21.294381653090365
                        ],
                        [
                            -157.81807655600883,
                            21.294383945195797
                        ],
                        [
                            -157.81807430824185,
                            21.294406592781538
                        ],
                        [
                            -157.81806516577998,
                            21.294405795934399
                        ],
                        [
                            -157.81806498441608,
                            21.294407622220788
                        ],
                        [
                            -157.81807412687084,
                            21.294408419971301
                        ],
                        [
                            -157.81807401362721,
                            21.294409562869095
                        ],
                        [
                            -157.81804936337869,
                            21.294407413157888
                        ],
                        [
                            -157.81804622887503,
                            21.294407140004751
                        ],
                        [
                            -157.81803233264381,
                            21.294405928543792
                        ],
                        [
                            -157.81802846481128,
                            21.294405867054664
                        ],
                        [
                            -157.81802463114335,
                            21.294406355067046
                        ],
                        [
                            -157.81802092040493,
                            21.29440738236357
                        ],
                        [
                            -157.81801741859195,
                            21.294408923349796
                        ],
                        [
                            -157.81801420598933,
                            21.294410943357253
                        ],
                        [
                            -157.81801135622854,
                            21.2944133959267
                        ],
                        [
                            -157.81800893530934,
                            21.294416224607964
                        ],
                        [
                            -157.8180069996649,
                            21.294419363849833
                        ],
                        [
                            -157.81798976945277,
                            21.294452955597507
                        ],
                        [
                            -157.81798341339552,
                            21.294465346139202
                        ],
                        [
                            -157.81798200601395,
                            21.294468723972027
                        ],
                        [
                            -157.81798116126109,
                            21.294472262042483
                        ],
                        [
                            -157.81798089809377,
                            21.294475880081887
                        ],
                        [
                            -157.81798122105374,
                            21.294479492300027
                        ],
                        [
                            -157.81798212499331,
                            21.294483019162321
                        ],
                        [
                            -157.81798358649411,
                            21.294486375585588
                        ],
                        [
                            -157.81798557338311,
                            21.294489486362426
                        ],
                        [
                            -157.81798804093521,
                            21.294492278907452
                        ],
                        [
                            -157.81802439437243,
                            21.294527600213559
                        ],
                        [
                            -157.81805449029818,
                            21.294556839307198
                        ],
                        [
                            -157.81806067802597,
                            21.294562850557849
                        ],
                        [
                            -157.81805975554732,
                            21.294572131842536
                        ],
                        [
                            -157.8180490323345,
                            21.294571197419419
                        ],
                        [
                            -157.81804885097006,
                            21.294573023705738
                        ],
                        [
                            -157.81805957416859,
                            21.294573959935569
                        ],
                        [
                            -157.8180524095724,
                            21.294646125794156
                        ],
                        [
                            -157.81801277164601,
                            21.294642668418259
                        ],
                        [
                            -157.81800763240435,
                            21.294694443605241
                        ],
                        [
                            -157.81804726939495,
                            21.294697899169524
                        ],
                        [
                            -157.81804349528133,
                            21.294735909038931
                        ],
                        [
                            -157.81803277205685,
                            21.294734974614229
                        ],
                        [
                            -157.81803259069193,
                            21.294736800900498
                        ],
                        [
                            -157.81804331390211,
                            21.294737737131879
                        ],
                        [
                            -157.81804010897864,
                            21.294770022596058
                        ],
                        [
                            -157.81801278654552,
                            21.294791269101818
                        ],
                        [
                            -157.81800590917078,
                            21.294783501331374
                        ],
                        [
                            -157.81800440182121,
                            21.294784673284944
                        ],
                        [
                            -157.81801128015982,
                            21.294792441062238
                        ],
                        [
                            -157.81794496929894,
                            21.29484400528878
                        ],
                        [
                            -157.81793809192558,
                            21.294836237515661
                        ],
                        [
                            -157.81793658458216,
                            21.294837408565225
                        ],
                        [
                            -157.81794346194829,
                            21.294845177241758
                        ],
                        [
                            -157.81780858001079,
                            21.294950064897048
                        ],
                        [
                            -157.81779763967205,
                            21.294937705554698
                        ],
                        [
                            -157.81777503323372,
                            21.294955284853298
                        ],
                        [
                            -157.8178090990223,
                            21.294993770977779
                        ],
                        [
                            -157.81782772211855,
                            21.294995395082346
                        ],
                        [
                            -157.81783789530763,
                            21.294987484171433
                        ],
                        [
                            -157.81790573285789,
                            21.295064105616355
                        ],
                        [
                            -157.81817788471508,
                            21.294852474075913
                        ],
                        [
                            -157.81817749573889,
                            21.294856395675037
                        ],
                        [
                            -157.81817096776524,
                            21.29486147206644
                        ],
                        [
                            -157.8181678383755,
                            21.294892993795212
                        ],
                        [
                            -157.81815204885038,
                            21.29505203511598
                        ],
                        [
                            -157.81810912793381,
                            21.295048293626895
                        ],
                        [
                            -157.81810400348425,
                            21.295099908115517
                        ],
                        [
                            -157.81809226064999,
                            21.295218182513143
                        ],
                        [
                            -157.81809030328779,
                            21.29523790243913
                        ],
                        [
                            -157.81826448916661,
                            21.295253647484152
                        ]
                    ],
                    [
                        [
                            -157.81819331255792,
                            21.294078710577423
                        ],
                        [
                            -157.81811528774989,
                            21.293990582599037
                        ],
                        [
                            -157.81816577302388,
                            21.293951323375971
                        ],
                        [
                            -157.81820190800374,
                            21.293992136629385
                        ],
                        [
                            -157.81819331255792,
                            21.294078710577423
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 255,
                "NUMBER": "1110",
                "PROPER_NAME": "PHYSICAL EDUCATION/ATHLETIC COMPLEX",
                "DISPLAY_NAME": "PHYSICAL EDUCATION/ATHLETIC COMPLEX (PE/A) - 1110",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PHYSICAL EDUCATION/ATHLETIC COMPLEX (HPER)",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1110_01.jpg",
                "HEIGHT (ft)": 57.700000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 1012.8586509302445,
                "SHAPE_Area": 8828.6707031396636
            }
        },
        {
            "type": "Feature",
            "id": 258,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8215091291101,
                            21.298073796436292
                        ],
                        [
                            -157.82150903192112,
                            21.298076555616515
                        ],
                        [
                            -157.82150631734353,
                            21.298153333008358
                        ],
                        [
                            -157.8215062211255,
                            21.298156091291965
                        ],
                        [
                            -157.8215106359992,
                            21.298156227903558
                        ],
                        [
                            -157.82151946574663,
                            21.298156501126392
                        ],
                        [
                            -157.82151964403576,
                            21.298156506891782
                        ],
                        [
                            -157.82152762762016,
                            21.298156754314459
                        ],
                        [
                            -157.82152798419847,
                            21.298156765845242
                        ],
                        [
                            -157.82153596778292,
                            21.298157013267506
                        ],
                        [
                            -157.82153632436118,
                            21.298157024798275
                        ],
                        [
                            -157.82154430794569,
                            21.298157272220145
                        ],
                        [
                            -157.82154466452397,
                            21.298157283750889
                        ],
                        [
                            -157.82155264618069,
                            21.298157531158886
                        ],
                        [
                            -157.82155282543374,
                            21.298157536930994
                        ],
                        [
                            -157.82155331596806,
                            21.298157553013265
                        ],
                        [
                            -157.82155773084193,
                            21.298157689623629
                        ],
                        [
                            -157.82155822138347,
                            21.298157704802549
                        ],
                        [
                            -157.82155840063655,
                            21.298157710574664
                        ],
                        [
                            -157.82156646518322,
                            21.298157959465787
                        ],
                        [
                            -157.82156682272543,
                            21.298157971003242
                        ],
                        [
                            -157.82157488725775,
                            21.298158221700632
                        ],
                        [
                            -157.82157524383607,
                            21.298158233231316
                        ],
                        [
                            -157.82158330741174,
                            21.298158483018238
                        ],
                        [
                            -157.82158348667201,
                            21.298158487886973
                        ],
                        [
                            -157.82158364279098,
                            21.29815849349708
                        ],
                        [
                            -157.8215915251858,
                            21.298158737498017
                        ],
                        [
                            -157.82159188272803,
                            21.298158749035419
                        ],
                        [
                            -157.82159974198879,
                            21.29815899287399
                        ],
                        [
                            -157.82159992124184,
                            21.298158998646041
                        ],
                        [
                            -157.82160041177622,
                            21.298159014728196
                        ],
                        [
                            -157.82160482761412,
                            21.298159151344063
                        ],
                        [
                            -157.82160531815569,
                            21.298159166522847
                        ],
                        [
                            -157.82160549645207,
                            21.298159171384825
                        ],
                        [
                            -157.82161356098459,
                            21.298159422080367
                        ],
                        [
                            -157.82161391853404,
                            21.298159432714385
                        ],
                        [
                            -157.82162198210273,
                            21.298159683402798
                        ],
                        [
                            -157.82162233868104,
                            21.298159694933382
                        ],
                        [
                            -157.82163040322089,
                            21.298159944724784
                        ],
                        [
                            -157.82163058247397,
                            21.298159950496821
                        ],
                        [
                            -157.82163073860016,
                            21.298159955203534
                        ],
                        [
                            -157.82163862099523,
                            21.298160199202272
                        ],
                        [
                            -157.82163897853749,
                            21.298160210739567
                        ],
                        [
                            -157.82164683876243,
                            21.2981604545827
                        ],
                        [
                            -157.82164701705162,
                            21.298160460347972
                        ],
                        [
                            -157.82164750758596,
                            21.298160476429974
                        ],
                        [
                            -157.82165192341685,
                            21.29816061394796
                        ],
                        [
                            -157.82165241397283,
                            21.298160627319927
                        ],
                        [
                            -157.82165259226198,
                            21.298160633085178
                        ],
                        [
                            -157.8216606558309,
                            21.298160883771747
                        ],
                        [
                            -157.82166101337313,
                            21.298160895308996
                        ],
                        [
                            -157.82166907791321,
                            21.298161145098554
                        ],
                        [
                            -157.82166943449874,
                            21.298161155725698
                        ],
                        [
                            -157.82167749903169,
                            21.298161406418195
                        ],
                        [
                            -157.82167767828477,
                            21.298161412190183
                        ],
                        [
                            -157.82167783441099,
                            21.298161416896843
                        ],
                        [
                            -157.82168571679912,
                            21.298161661796723
                        ],
                        [
                            -157.82168607434136,
                            21.298161673333926
                        ],
                        [
                            -157.82169393360988,
                            21.298161916264771
                        ],
                        [
                            -157.82169411189903,
                            21.298161922029994
                        ],
                        [
                            -157.82169460243344,
                            21.298161938111857
                        ],
                        [
                            -157.82169901826444,
                            21.298162075628618
                        ],
                        [
                            -157.82169950881325,
                            21.298162089903787
                        ],
                        [
                            -157.8216996871096,
                            21.298162094765647
                        ],
                        [
                            -157.82170775164275,
                            21.29816234545671
                        ],
                        [
                            -157.82170810918498,
                            21.298162356993867
                        ],
                        [
                            -157.82171617468208,
                            21.29816260769126
                        ],
                        [
                            -157.82171653030369,
                            21.298162618311558
                        ],
                        [
                            -157.82172459580801,
                            21.298162868105223
                        ],
                        [
                            -157.82172477409719,
                            21.298162873870403
                        ],
                        [
                            -157.82172493022341,
                            21.298162878577042
                        ],
                        [
                            -157.82173281164791,
                            21.298163123467969
                        ],
                        [
                            -157.82173316919017,
                            21.298163135005069
                        ],
                        [
                            -157.82174102941568,
                            21.29816337884381
                        ],
                        [
                            -157.82174120770483,
                            21.298163384608973
                        ],
                        [
                            -157.82174169823924,
                            21.298163400690694
                        ],
                        [
                            -157.82174611408482,
                            21.298163536399542
                        ],
                        [
                            -157.82174660462644,
                            21.298163551577911
                        ],
                        [
                            -157.8217467829156,
                            21.298163557343084
                        ],
                        [
                            -157.82175484745619,
                            21.298163807128542
                        ],
                        [
                            -157.82175520499848,
                            21.298163818665596
                        ],
                        [
                            -157.8217632695391,
                            21.298164068450667
                        ],
                        [
                            -157.82176362515355,
                            21.298164079974192
                        ],
                        [
                            -157.82177169065093,
                            21.298164330668943
                        ],
                        [
                            -157.82177186894731,
                            21.298164335530732
                        ],
                        [
                            -157.82177202603026,
                            21.298164341147412
                        ],
                        [
                            -157.82177990746223,
                            21.298164585132806
                        ],
                        [
                            -157.82178026500452,
                            21.298164596669807
                        ],
                        [
                            -157.82178812523026,
                            21.298164840506352
                        ],
                        [
                            -157.82178830351947,
                            21.298164846271465
                        ],
                        [
                            -157.82178879502501,
                            21.298164861456478
                        ],
                        [
                            -157.8217932098996,
                            21.298164998060667
                        ],
                        [
                            -157.82179370044125,
                            21.298165013238901
                        ],
                        [
                            -157.82179387969433,
                            21.298165019010767
                        ],
                        [
                            -157.82180194230017,
                            21.298165269683839
                        ],
                        [
                            -157.82180229984965,
                            21.298165280317438
                        ],
                        [
                            -157.82181036535448,
                            21.298165530107003
                        ],
                        [
                            -157.82181072096893,
                            21.298165541630446
                        ],
                        [
                            -157.82181878646662,
                            21.298165792322933
                        ],
                        [
                            -157.82181896475581,
                            21.298165798088029
                        ],
                        [
                            -157.82181912184595,
                            21.298165802801314
                        ],
                        [
                            -157.82182700327098,
                            21.298166047687843
                        ],
                        [
                            -157.82182736082768,
                            21.298166057418062
                        ],
                        [
                            -157.82183522008262,
                            21.29816630214901
                        ],
                        [
                            -157.82183539934289,
                            21.298166307017496
                        ],
                        [
                            -157.82183588987735,
                            21.298166323098943
                        ],
                        [
                            -157.82184079528656,
                            21.298166475783358
                        ],
                        [
                            -157.82184484683552,
                            21.298166600808859
                        ],
                        [
                            -157.82184850516995,
                            21.298166714951069
                        ],
                        [
                            -157.82185992833135,
                            21.298167068645
                        ],
                        [
                            -157.82185987972923,
                            21.298168449590367
                        ],
                        [
                            -157.82186674730519,
                            21.298168662986185
                        ],
                        [
                            -157.82187189847093,
                            21.298168822810414
                        ],
                        [
                            -157.8218720452048,
                            21.298164684497767
                        ],
                        [
                            -157.82187239508121,
                            21.298154773128733
                        ],
                        [
                            -157.82187571710352,
                            21.298060780430294
                        ],
                        [
                            -157.82172180676358,
                            21.298056003567002
                        ],
                        [
                            -157.82172761485788,
                            21.297891644145498
                        ],
                        [
                            -157.82206537938868,
                            21.297902126388333
                        ],
                        [
                            -157.82206533078872,
                            21.297903507333896
                        ],
                        [
                            -157.82207077396262,
                            21.297903675519194
                        ],
                        [
                            -157.82207734951021,
                            21.297903880538303
                        ],
                        [
                            -157.82207749527376,
                            21.297899742218323
                        ],
                        [
                            -157.82208020955068,
                            21.297822963897691
                        ],
                        [
                            -157.82208030575026,
                            21.297820206516505
                        ],
                        [
                            -157.82208116700463,
                            21.297795839039519
                        ],
                        [
                            -157.82175591582666,
                            21.297785744368312
                        ],
                        [
                            -157.82175512557276,
                            21.297785718961247
                        ],
                        [
                            -157.82170440334974,
                            21.297784145179566
                        ],
                        [
                            -157.82170146011492,
                            21.297784053205572
                        ],
                        [
                            -157.82161855211768,
                            21.297781479850293
                        ],
                        [
                            -157.82161462683129,
                            21.297781358414003
                        ],
                        [
                            -157.82161448106234,
                            21.297785495829704
                        ],
                        [
                            -157.82161420970726,
                            21.297793173660637
                        ],
                        [
                            -157.82161519078073,
                            21.29779320492138
                        ],
                        [
                            -157.82161518583763,
                            21.297793341298881
                        ],
                        [
                            -157.82161517968575,
                            21.297793508383229
                        ],
                        [
                            -157.82161491567695,
                            21.297800990229661
                        ],
                        [
                            -157.82161490338035,
                            21.297801323495008
                        ],
                        [
                            -157.82161463937149,
                            21.297808805341429
                        ],
                        [
                            -157.8216146270677,
                            21.297809139510132
                        ],
                        [
                            -157.82161436305881,
                            21.297816621356528
                        ],
                        [
                            -157.82161435171895,
                            21.297816955531978
                        ],
                        [
                            -157.82161408771,
                            21.29782443737837
                        ],
                        [
                            -157.8216140815581,
                            21.297824604462715
                        ],
                        [
                            -157.82161406535434,
                            21.297825065078921
                        ],
                        [
                            -157.82161390242473,
                            21.297829662200691
                        ],
                        [
                            -157.82161388622814,
                            21.297830121913542
                        ],
                        [
                            -157.82161388007626,
                            21.29783028899789
                        ],
                        [
                            -157.82161363608458,
                            21.297837194620666
                        ],
                        [
                            -157.82161362473749,
                            21.297837529699454
                        ],
                        [
                            -157.8216133796162,
                            21.297844456092339
                        ],
                        [
                            -157.82161337362274,
                            21.297844603303183
                        ],
                        [
                            -157.82161336747086,
                            21.297844770387513
                        ],
                        [
                            -157.82161310189286,
                            21.297852328107798
                        ],
                        [
                            -157.82161308958186,
                            21.297852663179821
                        ],
                        [
                            -157.82161287808401,
                            21.297858636730123
                        ],
                        [
                            -157.8216128220688,
                            21.297860221789932
                        ],
                        [
                            -157.8216128097722,
                            21.297860555055269
                        ],
                        [
                            -157.8216127944099,
                            21.297861031035008
                        ],
                        [
                            -157.8216127710615,
                            21.297861662342168
                        ],
                        [
                            -157.8216125432302,
                            21.297868112768786
                        ],
                        [
                            -157.82161253804222,
                            21.29786827985987
                        ],
                        [
                            -157.82161252183843,
                            21.297868740476066
                        ],
                        [
                            -157.82161235890865,
                            21.29787333759781
                        ],
                        [
                            -157.82161233679062,
                            21.297873935488088
                        ],
                        [
                            -157.82161233160267,
                            21.297874102579186
                        ],
                        [
                            -157.82161206283024,
                            21.297881698219502
                        ],
                        [
                            -157.82161205148316,
                            21.297882033298279
                        ],
                        [
                            -157.82161178254509,
                            21.297889649715422
                        ],
                        [
                            -157.82161177751553,
                            21.297889796933017
                        ],
                        [
                            -157.82161155474964,
                            21.297896095625301
                        ],
                        [
                            -157.82161154859773,
                            21.297896262709649
                        ],
                        [
                            -157.82161129221544,
                            21.297903513341147
                        ],
                        [
                            -157.82161128086832,
                            21.297903848419935
                        ],
                        [
                            -157.82161102335644,
                            21.297911119821517
                        ],
                        [
                            -157.82161101832688,
                            21.297911267039112
                        ],
                        [
                            -157.82161097832093,
                            21.297912415872933
                        ],
                        [
                            -157.82161081538379,
                            21.29791701389799
                        ],
                        [
                            -157.82160971014432,
                            21.297948276151175
                        ],
                        [
                            -157.82160970398522,
                            21.297948444138857
                        ],
                        [
                            -157.82160944856651,
                            21.297955694777052
                        ],
                        [
                            -157.82160944240741,
                            21.297955862764741
                        ],
                        [
                            -157.82160941762692,
                            21.297956552782306
                        ],
                        [
                            -157.8216092546896,
                            21.297961150807332
                        ],
                        [
                            -157.82160923850017,
                            21.297961609616848
                        ],
                        [
                            -157.821609233305,
                            21.297961777611285
                        ],
                        [
                            -157.82160898073587,
                            21.297968912635302
                        ],
                        [
                            -157.82160896842487,
                            21.297969247707336
                        ],
                        [
                            -157.82160871568283,
                            21.297976404411546
                        ],
                        [
                            -157.82160871066046,
                            21.297976550725778
                        ],
                        [
                            -157.82160870546528,
                            21.297976718720214
                        ],
                        [
                            -157.82160843796581,
                            21.297984275523493
                        ],
                        [
                            -157.82160842564761,
                            21.297984611498865
                        ],
                        [
                            -157.82160815910481,
                            21.297992169212229
                        ],
                        [
                            -157.82160814776489,
                            21.297992503387668
                        ],
                        [
                            -157.82160788025814,
                            21.298000061094275
                        ],
                        [
                            -157.82160787409902,
                            21.298000229081957
                        ],
                        [
                            -157.82160785790958,
                            21.298000687891466
                        ],
                        [
                            -157.8216076949721,
                            21.29800528591646
                        ],
                        [
                            -157.82160767974659,
                            21.298005744732706
                        ],
                        [
                            -157.82160767358749,
                            21.298005912720392
                        ],
                        [
                            -157.82160740608785,
                            21.298013469523639
                        ],
                        [
                            -157.82160739377682,
                            21.298013804595669
                        ],
                        [
                            -157.82160712722663,
                            21.298021363212335
                        ],
                        [
                            -157.82160711589393,
                            21.298021696484437
                        ],
                        [
                            -157.82160684837979,
                            21.298029255094345
                        ],
                        [
                            -157.82160684222785,
                            21.29802942217869
                        ],
                        [
                            -157.82160683606872,
                            21.298029590166372
                        ],
                        [
                            -157.82160659080947,
                            21.298036533722527
                        ],
                        [
                            -157.82160657849843,
                            21.298036868794554
                        ],
                        [
                            -157.82160633322474,
                            21.298043814157388
                        ],
                        [
                            -157.82160632189203,
                            21.298044147429479
                        ],
                        [
                            -157.82160607661831,
                            21.298051092792303
                        ],
                        [
                            -157.82160607046637,
                            21.298051259876644
                        ],
                        [
                            -157.82160602948917,
                            21.298052409607035
                        ],
                        [
                            -157.82150999046939,
                            21.29804942806404
                        ],
                        [
                            -157.8215091291101,
                            21.298073796436292
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 258,
                "NUMBER": "1151",
                "PROPER_NAME": "UNIVERSITY HIGH SCHOOL 3 - CLASSROOM BUILDING",
                "DISPLAY_NAME": "UNIVERSITY HIGH SCHOOL 3 - CLASSROOM BUILDING - 1151",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY HIGH SCHOOL 3 COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1151_01.jpg",
                "HEIGHT (ft)": 36,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 233.01357357286827,
                "SHAPE_Area": 1238.6139367494031
            }
        },
        {
            "type": "Feature",
            "id": 259,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81536006486408,
                            21.298071636229416
                        ],
                        [
                            -157.81536324580387,
                            21.298071536662192
                        ],
                        [
                            -157.81536304987245,
                            21.298066034541723
                        ],
                        [
                            -157.81538164470277,
                            21.298065455363755
                        ],
                        [
                            -157.815381838707,
                            21.298070957470646
                        ],
                        [
                            -157.81538501964675,
                            21.29807085790301
                        ],
                        [
                            -157.81538482467849,
                            21.298065355789312
                        ],
                        [
                            -157.81539656878601,
                            21.298064989468429
                        ],
                        [
                            -157.81539676278356,
                            21.298070492478683
                        ],
                        [
                            -157.81539994372332,
                            21.298070392910752
                        ],
                        [
                            -157.81539974875449,
                            21.298064890797061
                        ],
                        [
                            -157.81541834262802,
                            21.298064310704877
                        ],
                        [
                            -157.81541853759032,
                            21.298069813721931
                        ],
                        [
                            -157.81542171852283,
                            21.298069715056926
                        ],
                        [
                            -157.81542152259649,
                            21.298064212033101
                        ],
                        [
                            -157.81543375651862,
                            21.298063831089401
                        ],
                        [
                            -157.81543341436608,
                            21.298054201254434
                        ],
                        [
                            -157.81543928545912,
                            21.298054017633913
                        ],
                        [
                            -157.81543918113391,
                            21.298051037519553
                        ],
                        [
                            -157.81543330812039,
                            21.298051220223165
                        ],
                        [
                            -157.81543255946312,
                            21.298030127122033
                        ],
                        [
                            -157.81543843248306,
                            21.298029943515065
                        ],
                        [
                            -157.81543832623004,
                            21.298026963387141
                        ],
                        [
                            -157.8154324541886,
                            21.298027145194204
                        ],
                        [
                            -157.81543206328453,
                            21.298016140959952
                        ],
                        [
                            -157.81543793630394,
                            21.298015957352977
                        ],
                        [
                            -157.81543783005088,
                            21.298012977225028
                        ],
                        [
                            -157.81543195800279,
                            21.298013159935454
                        ],
                        [
                            -157.815431567106,
                            21.298002154797828
                        ],
                        [
                            -157.81543744012481,
                            21.298001971190846
                        ],
                        [
                            -157.81543733387178,
                            21.297998991062897
                        ],
                        [
                            -157.81543146182426,
                            21.297999173773331
                        ],
                        [
                            -157.81542957555561,
                            21.297945980640005
                        ],
                        [
                            -157.81543544663711,
                            21.297945797922772
                        ],
                        [
                            -157.81543534135525,
                            21.297942816898253
                        ],
                        [
                            -157.81542946930998,
                            21.297942999608718
                        ],
                        [
                            -157.8154290793772,
                            21.297931994477803
                        ],
                        [
                            -157.81543495045815,
                            21.297931811760542
                        ],
                        [
                            -157.8154348451763,
                            21.297928830736023
                        ],
                        [
                            -157.81542897312431,
                            21.297929014349837
                        ],
                        [
                            -157.81542858223489,
                            21.297918008308784
                        ],
                        [
                            -157.81543445427917,
                            21.297917825598315
                        ],
                        [
                            -157.81543434899734,
                            21.297914844573786
                        ],
                        [
                            -157.81542847694593,
                            21.297915028187592
                        ],
                        [
                            -157.81542772829621,
                            21.297893934182834
                        ],
                        [
                            -157.81543360033959,
                            21.297893751472348
                        ],
                        [
                            -157.81543349409384,
                            21.297890770441033
                        ],
                        [
                            -157.81542762301453,
                            21.297890953158316
                        ],
                        [
                            -157.8154272808622,
                            21.297881323323182
                        ],
                        [
                            -157.8154150479119,
                            21.29788170517724
                        ],
                        [
                            -157.81541485295685,
                            21.297876201256742
                        ],
                        [
                            -157.81541167202127,
                            21.297876300825155
                        ],
                        [
                            -157.81541186698345,
                            21.297881803842298
                        ],
                        [
                            -157.81539327410408,
                            21.297882383038296
                        ],
                        [
                            -157.81539307913536,
                            21.297876880924495
                        ],
                        [
                            -157.81538989821428,
                            21.29787697868581
                        ],
                        [
                            -157.81539009316836,
                            21.297882482606273
                        ],
                        [
                            -157.81537835004656,
                            21.297882848030838
                        ],
                        [
                            -157.81537815411448,
                            21.297877345910265
                        ],
                        [
                            -157.81537497415729,
                            21.297877443678079
                        ],
                        [
                            -157.81537516911084,
                            21.297882947598552
                        ],
                        [
                            -157.81535657526746,
                            21.297883526783675
                        ],
                        [
                            -157.81535638030738,
                            21.297878023766565
                        ],
                        [
                            -157.81535319937902,
                            21.297878122430518
                        ],
                        [
                            -157.81535339530294,
                            21.297883625454425
                        ],
                        [
                            -157.81534116139588,
                            21.297884006392973
                        ],
                        [
                            -157.81534150354258,
                            21.297893636228025
                        ],
                        [
                            -157.81533563149205,
                            21.297893819838624
                        ],
                        [
                            -157.81533573774306,
                            21.297896799966573
                        ],
                        [
                            -157.81534160978646,
                            21.297896617259312
                        ],
                        [
                            -157.81534235746713,
                            21.297917710353737
                        ],
                        [
                            -157.81533648541566,
                            21.297917893964339
                        ],
                        [
                            -157.81533659165945,
                            21.297920874995619
                        ],
                        [
                            -157.81534246274711,
                            21.297920691378238
                        ],
                        [
                            -157.81534285459404,
                            21.297931697425973
                        ],
                        [
                            -157.81533698158535,
                            21.297931880126445
                        ],
                        [
                            -157.81533708782911,
                            21.297934861157724
                        ],
                        [
                            -157.81534295891734,
                            21.297934677540344
                        ],
                        [
                            -157.81534335076429,
                            21.297945683588065
                        ],
                        [
                            -157.81533747775504,
                            21.297945866288511
                        ],
                        [
                            -157.8153375839988,
                            21.297948847319788
                        ],
                        [
                            -157.81534345508763,
                            21.297948663702417
                        ],
                        [
                            -157.815345343253,
                            21.298001856848817
                        ],
                        [
                            -157.81533947120542,
                            21.298002039556032
                        ],
                        [
                            -157.81533957744921,
                            21.298005020587286
                        ],
                        [
                            -157.81534544854026,
                            21.298004836969948
                        ],
                        [
                            -157.81534583942337,
                            21.298015843010809
                        ],
                        [
                            -157.815339967368,
                            21.298016026621333
                        ],
                        [
                            -157.81534007361904,
                            21.29801900674925
                        ],
                        [
                            -157.81534594471063,
                            21.29801882313194
                        ],
                        [
                            -157.8153463355938,
                            21.298029829172769
                        ],
                        [
                            -157.81534046353786,
                            21.2980300127833
                        ],
                        [
                            -157.8153405697889,
                            21.29803299291121
                        ],
                        [
                            -157.81534644087381,
                            21.298032810197235
                        ],
                        [
                            -157.81534718951877,
                            21.298053903298172
                        ],
                        [
                            -157.81534131842577,
                            21.298054086915474
                        ],
                        [
                            -157.81534142371291,
                            21.298057067036588
                        ],
                        [
                            -157.81534729576271,
                            21.298056884329412
                        ],
                        [
                            -157.81534763790961,
                            21.298066514164287
                        ],
                        [
                            -157.815359869904,
                            21.298066133212416
                        ],
                        [
                            -157.81536006486408,
                            21.298071636229416
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 259,
                "NUMBER": "1098A",
                "PROPER_NAME": "MARINE SCIENCES MECHANICAL BUILDING",
                "DISPLAY_NAME": "MARINE SCIENCES MECHANICAL BUILDING - 1098A",
                "ADDRESS": "1000 POPE ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MARINE SCIENCES BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1098A_01.jpg",
                "HEIGHT (ft)": 12.6,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 87.562125367414325,
                "SHAPE_Area": 185.52374307375194
            }
        },
        {
            "type": "Feature",
            "id": 260,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.81410467527439,
                                21.297750737049643
                            ],
                            [
                                -157.81410999542052,
                                21.297882902501534
                            ],
                            [
                                -157.81422947771816,
                                21.297878677256836
                            ],
                            [
                                -157.81422415650101,
                                21.297746511796891
                            ],
                            [
                                -157.81410467527439,
                                21.297750737049643
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81402848985073,
                                21.298145890281685
                            ],
                            [
                                -157.81404020706029,
                                21.298145513025673
                            ],
                            [
                                -157.81404019926214,
                                21.298145283509747
                            ],
                            [
                                -157.81407632958542,
                                21.298144118884107
                            ],
                            [
                                -157.8140763373909,
                                21.298144347496681
                            ],
                            [
                                -157.81408610302341,
                                21.298144032370203
                            ],
                            [
                                -157.81408603576716,
                                21.298142202532318
                            ],
                            [
                                -157.81407627013476,
                                21.298142517658793
                            ],
                            [
                                -157.81407561514877,
                                21.298124672001816
                            ],
                            [
                                -157.81407659190106,
                                21.298124640942234
                            ],
                            [
                                -157.81407645739608,
                                21.298120980363077
                            ],
                            [
                                -157.81407548063657,
                                21.298121012326018
                            ],
                            [
                                -157.81407452252716,
                                21.298094931040037
                            ],
                            [
                                -157.81407549928647,
                                21.2980948990771
                            ],
                            [
                                -157.8140753647815,
                                21.298091238497936
                            ],
                            [
                                -157.81407438802219,
                                21.298091270460876
                            ],
                            [
                                -157.81407342991287,
                                21.298065189174817
                            ],
                            [
                                -157.81407440667201,
                                21.298065157211877
                            ],
                            [
                                -157.81407427216706,
                                21.29806149663272
                            ],
                            [
                                -157.81407329637187,
                                21.298061528602457
                            ],
                            [
                                -157.81407258974093,
                                21.298042310332576
                            ],
                            [
                                -157.81407747255744,
                                21.298042152317702
                            ],
                            [
                                -157.81407495201802,
                                21.297973518500644
                            ],
                            [
                                -157.81402612681808,
                                21.297975092340412
                            ],
                            [
                                -157.81403153696084,
                                21.298121742468737
                            ],
                            [
                                -157.81403932498216,
                                21.298121490197104
                            ],
                            [
                                -157.81404013981188,
                                21.298143682284437
                            ],
                            [
                                -157.81402842259521,
                                21.298144060443789
                            ],
                            [
                                -157.81402848985073,
                                21.298145890281685
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 260,
                "NUMBER": "1253",
                "PROPER_NAME": "HALE HĀLĀWAI",
                "DISPLAY_NAME": "HALE HĀLĀWAI - 1253",
                "ADDRESS": "1633 EAST WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE HALAWAI",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1253_01.jpg",
                "HEIGHT (ft)": 20.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 107.15045468977061,
                "SHAPE_Area": 269.98600132648164
            }
        },
        {
            "type": "Feature",
            "id": 262,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.81271323842304,
                                21.295648298343448
                            ],
                            [
                                -157.81271338509453,
                                21.295647559502044
                            ],
                            [
                                -157.81271422308691,
                                21.295643319482405
                            ],
                            [
                                -157.8127171398948,
                                21.295643934487913
                            ],
                            [
                                -157.8127172420734,
                                21.295644174606906
                            ],
                            [
                                -157.81271738683049,
                                21.295644394248288
                            ],
                            [
                                -157.81271756939009,
                                21.295644587958048
                            ],
                            [
                                -157.81271778401234,
                                21.295644750275329
                            ],
                            [
                                -157.81271802592852,
                                21.295644874842775
                            ],
                            [
                                -157.81271828551411,
                                21.295644959785736
                            ],
                            [
                                -157.81271855894258,
                                21.295645001463637
                            ],
                            [
                                -157.81271883464709,
                                21.295644999794902
                            ],
                            [
                                -157.81271910493095,
                                21.295644952918451
                            ],
                            [
                                -157.81271936494565,
                                21.295644864413621
                            ],
                            [
                                -157.81271960407378,
                                21.295644736012335
                            ],
                            [
                                -157.81271981458232,
                                21.29564457037019
                            ],
                            [
                                -157.81271999449277,
                                21.295644373796964
                            ],
                            [
                                -157.81272013508644,
                                21.295644151651501
                            ],
                            [
                                -157.81272023437754,
                                21.295643911146897
                            ],
                            [
                                -157.81272028654629,
                                21.295643656759033
                            ],
                            [
                                -157.8127202934408,
                                21.295643398438262
                            ],
                            [
                                -157.81272025211123,
                                21.295643143390866
                            ],
                            [
                                -157.8127201663697,
                                21.295642897064088
                            ],
                            [
                                -157.81272003613643,
                                21.295642669394645
                            ],
                            [
                                -157.81271986715123,
                                21.295642465843379
                            ],
                            [
                                -157.81271966226231,
                                21.295642291850697
                            ],
                            [
                                -157.81271942913733,
                                21.295642152891027
                            ],
                            [
                                -157.81271917545121,
                                21.295642053535456
                            ],
                            [
                                -157.81271890696559,
                                21.295641996534794
                            ],
                            [
                                -157.81271863043503,
                                21.29564198103331
                            ],
                            [
                                -157.81271495659908,
                                21.295630964480871
                            ],
                            [
                                -157.8127147099847,
                                21.295630224672003
                            ],
                            [
                                -157.81270296935691,
                                21.295595016260862
                            ],
                            [
                                -157.81270318959875,
                                21.295594838943334
                            ],
                            [
                                -157.81270337443746,
                                21.295594628854033
                            ],
                            [
                                -157.81270351707499,
                                21.295594392268757
                            ],
                            [
                                -157.81270361359771,
                                21.29559413638702
                            ],
                            [
                                -157.81270366201244,
                                21.295593869325238
                            ],
                            [
                                -157.81270366130457,
                                21.295593597399982
                            ],
                            [
                                -157.8127036085171,
                                21.295593328720919
                            ],
                            [
                                -157.81270350741852,
                                21.295593074155295
                            ],
                            [
                                -157.81270336084978,
                                21.295592840046897
                            ],
                            [
                                -157.81270317358684,
                                21.295592631849722
                            ],
                            [
                                -157.81270295037666,
                                21.295592458631177
                            ],
                            [
                                -157.81270269794476,
                                21.295592323148842
                            ],
                            [
                                -157.81270242491544,
                                21.29559223178731
                            ],
                            [
                                -157.81270213899265,
                                21.295592185504308
                            ],
                            [
                                -157.81270184882973,
                                21.29559218707103
                            ],
                            [
                                -157.81270156408021,
                                21.295592234748806
                            ],
                            [
                                -157.81270129052746,
                                21.295592328578444
                            ],
                            [
                                -157.81270103976732,
                                21.295592465028161
                            ],
                            [
                                -157.8127008185761,
                                21.295592640532195
                            ],
                            [
                                -157.81270063182407,
                                21.29559284880122
                            ],
                            [
                                -157.812700487266,
                                21.295593084469562
                            ],
                            [
                                -157.81264931759512,
                                21.295582171916823
                            ],
                            [
                                -157.81264923868812,
                                21.295581914797555
                            ],
                            [
                                -157.81264911339059,
                                21.295581672708661
                            ],
                            [
                                -157.81264894741335,
                                21.295581454724303
                            ],
                            [
                                -157.81264874264792,
                                21.295581265374782
                            ],
                            [
                                -157.81264850770415,
                                21.295581112851348
                            ],
                            [
                                -157.81264824834363,
                                21.295580999904807
                            ],
                            [
                                -157.8126479712846,
                                21.295580930196106
                            ],
                            [
                                -157.81264768615165,
                                21.295580905599934
                            ],
                            [
                                -157.81264740064867,
                                21.295580927074006
                            ],
                            [
                                -157.81264712442186,
                                21.295580993782995
                            ],
                            [
                                -157.81264686326921,
                                21.29558110396102
                            ],
                            [
                                -157.81264662588754,
                                21.295581254959277
                            ],
                            [
                                -157.81264641907495,
                                21.295581440501973
                            ],
                            [
                                -157.81264625057167,
                                21.295581657030155
                            ],
                            [
                                -157.81264612332745,
                                21.295581897337524
                            ],
                            [
                                -157.81264604124866,
                                21.295582155127914
                            ],
                            [
                                -157.81264600729955,
                                21.295582421388335
                            ],
                            [
                                -157.81264602345874,
                                21.295582689809017
                            ],
                            [
                                -157.8126460869143,
                                21.295582950432841
                            ],
                            [
                                -157.81264619867372,
                                21.295583197846579
                            ],
                            [
                                -157.81261035892786,
                                21.295619190809091
                            ],
                            [
                                -157.81261008859434,
                                21.295619123857957
                            ],
                            [
                                -157.81260980827355,
                                21.295619100199033
                            ],
                            [
                                -157.81260952855388,
                                21.295619121713852
                            ],
                            [
                                -157.81260925619713,
                                21.295619186643304
                            ],
                            [
                                -157.81260899988561,
                                21.295619294145247
                            ],
                            [
                                -157.812608766403,
                                21.29561943975061
                            ],
                            [
                                -157.81260856252555,
                                21.295619619893614
                            ],
                            [
                                -157.81260839407298,
                                21.295619830098385
                            ],
                            [
                                -157.81260826591551,
                                21.295620064075564
                            ],
                            [
                                -157.81260818003909,
                                21.295620314612012
                            ],
                            [
                                -157.81260814131394,
                                21.295620575418408
                            ],
                            [
                                -157.81260815076931,
                                21.295620838371448
                            ],
                            [
                                -157.81260820654265,
                                21.295621095327537
                            ],
                            [
                                -157.81260830770637,
                                21.295621341763159
                            ],
                            [
                                -157.81260845145582,
                                21.29562156681785
                            ],
                            [
                                -157.81260863396446,
                                21.295621766851095
                            ],
                            [
                                -157.81260884949964,
                                21.295621935498662
                            ],
                            [
                                -157.81260909232154,
                                21.295622067299789
                            ],
                            [
                                -157.81260935571186,
                                21.295622158593474
                            ],
                            [
                                -157.81260963100272,
                                21.295622208415178
                            ],
                            [
                                -157.8126099114759,
                                21.295622213103993
                            ],
                            [
                                -157.81261018941288,
                                21.295622173508807
                            ],
                            [
                                -157.81261045516746,
                                21.295622090465002
                            ],
                            [
                                -157.8126107029272,
                                21.295621967545095
                            ],
                            [
                                -157.81261092496638,
                                21.295621806501387
                            ],
                            [
                                -157.81261111642198,
                                21.295621612719895
                            ],
                            [
                                -157.81261414515129,
                                21.295622094815077
                            ],
                            [
                                -157.81261306887473,
                                21.29562659784624
                            ],
                            [
                                -157.81265866765312,
                                21.295636216303478
                            ],
                            [
                                -157.81265975922528,
                                21.295631969039103
                            ],
                            [
                                -157.8126685307289,
                                21.295633949715391
                            ],
                            [
                                -157.81266746203772,
                                21.295638108609047
                            ],
                            [
                                -157.81271323842304,
                                21.295648298343448
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81272193746909,
                                21.295649459131575
                            ],
                            [
                                -157.81276286749929,
                                21.295658158402659
                            ],
                            [
                                -157.81276741443443,
                                21.295659123676863
                            ],
                            [
                                -157.81276978554146,
                                21.295649669265845
                            ],
                            [
                                -157.81272427961935,
                                21.295639889786568
                            ],
                            [
                                -157.81272193746909,
                                21.295649459131575
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81277669915718,
                                21.29566105557112
                            ],
                            [
                                -157.81281645765924,
                                21.29566943579983
                            ],
                            [
                                -157.81282204011256,
                                21.295670612542573
                            ],
                            [
                                -157.81282426816639,
                                21.295661326055502
                            ],
                            [
                                -157.81277897505518,
                                21.295651573386685
                            ],
                            [
                                -157.81277669915718,
                                21.29566105557112
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81283094757549,
                                21.295672468598376
                            ],
                            [
                                -157.81287010249488,
                                21.295680747894682
                            ],
                            [
                                -157.81287644708169,
                                21.295682089007617
                            ],
                            [
                                -157.8128786437054,
                                21.295673114870819
                            ],
                            [
                                -157.8128331801137,
                                21.295663343849526
                            ],
                            [
                                -157.81283094757549,
                                21.295672468598376
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81282726078473,
                                21.295665344662343
                            ],
                            [
                                -157.81282699504467,
                                21.295665425899834
                            ],
                            [
                                -157.8128267472778,
                                21.295665549723385
                            ],
                            [
                                -157.81282652813769,
                                21.295665709884457
                            ],
                            [
                                -157.81282634053068,
                                21.295665904596721
                            ],
                            [
                                -157.81282619222594,
                                21.295666126687902
                            ],
                            [
                                -157.81282608520931,
                                21.295666368944861
                            ],
                            [
                                -157.81282602627888,
                                21.295666625091844
                            ],
                            [
                                -157.81282601454333,
                                21.295666886088664
                            ],
                            [
                                -157.81282605101003,
                                21.295667146522071
                            ],
                            [
                                -157.81282613576607,
                                21.295667395552012
                            ],
                            [
                                -157.81282626402825,
                                21.295667628627804
                            ],
                            [
                                -157.81282643394121,
                                21.295667836702474
                            ],
                            [
                                -157.81282663879406,
                                21.295668015211731
                            ],
                            [
                                -157.81282687383248,
                                21.295668155991535
                            ],
                            [
                                -157.81282713135258,
                                21.295668258084152
                            ],
                            [
                                -157.81282740368661,
                                21.295668316015181
                            ],
                            [
                                -157.81282768311618,
                                21.295668330633543
                            ],
                            [
                                -157.81282796002407,
                                21.295668299161264
                            ],
                            [
                                -157.81282822861954,
                                21.295668222460868
                            ],
                            [
                                -157.81282847730682,
                                21.295668104064131
                            ],
                            [
                                -157.81282870123735,
                                21.295667947550417
                            ],
                            [
                                -157.81282888389433,
                                21.295667769064238
                            ],
                            [
                                -157.81282903109008,
                                21.295667565033021
                            ],
                            [
                                -157.81282914181722,
                                21.295667340870011
                            ],
                            [
                                -157.81282921312598,
                                21.295667103781522
                            ],
                            [
                                -157.81282924112455,
                                21.295666858257057
                            ],
                            [
                                -157.81282922671872,
                                21.295666611530095
                            ],
                            [
                                -157.81282916985046,
                                21.295666370827345
                            ],
                            [
                                -157.81282907144021,
                                21.295666141575662
                            ],
                            [
                                -157.81282893528549,
                                21.295665931028942
                            ],
                            [
                                -157.8128287632851,
                                21.295665742814119
                            ],
                            [
                                -157.81282856212101,
                                21.295665585108861
                            ],
                            [
                                -157.81282833564163,
                                21.295665458843654
                            ],
                            [
                                -157.81282809055796,
                                21.295665368582814
                            ],
                            [
                                -157.81282781721646,
                                21.29566531606503
                            ],
                            [
                                -157.81282753774337,
                                21.295665306866688
                            ],
                            [
                                -157.81282726078473,
                                21.295665344662343
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81288178254999,
                                21.295676930342054
                            ],
                            [
                                -157.8128815430384,
                                21.295676986469712
                            ],
                            [
                                -157.81288131577458,
                                21.295677077915933
                            ],
                            [
                                -157.81288110752038,
                                21.295677202921649
                            ],
                            [
                                -157.81288092313153,
                                21.295677357004166
                            ],
                            [
                                -157.81288076841324,
                                21.295677537494228
                            ],
                            [
                                -157.81288064630073,
                                21.295677738992225
                            ],
                            [
                                -157.81288055769986,
                                21.295677968731674
                            ],
                            [
                                -157.81288051044515,
                                21.295678211410173
                            ],
                            [
                                -157.81288050847925,
                                21.29567845621489
                            ],
                            [
                                -157.81288055184572,
                                21.295678697725766
                            ],
                            [
                                -157.81288063866748,
                                21.295678929605867
                            ],
                            [
                                -157.81288076611091,
                                21.295679144608052
                            ],
                            [
                                -157.81288093037841,
                                21.295679335478443
                            ],
                            [
                                -157.81288112766521,
                                21.29567949586648
                            ],
                            [
                                -157.81288135123847,
                                21.295679623917895
                            ],
                            [
                                -157.81288159535831,
                                21.295679714171857
                            ],
                            [
                                -157.81288185137862,
                                21.295679762953842
                            ],
                            [
                                -157.81288211253766,
                                21.295679772022925
                            ],
                            [
                                -157.81288237115319,
                                21.29567973771136
                            ],
                            [
                                -157.81288262142732,
                                21.295679661785044
                            ],
                            [
                                -157.81288285272083,
                                21.295679548685893
                            ],
                            [
                                -157.81288306116366,
                                21.295679400193357
                            ],
                            [
                                -157.8128832390228,
                                21.295679218963116
                            ],
                            [
                                -157.81288338044962,
                                21.295679013084388
                            ],
                            [
                                -157.81288348347999,
                                21.295678787060279
                            ],
                            [
                                -157.81288354227246,
                                21.295678548076705
                            ],
                            [
                                -157.81288355773296,
                                21.295678303367168
                            ],
                            [
                                -157.81288352788286,
                                21.295678059241457
                            ],
                            [
                                -157.81288345458472,
                                21.295677823843185
                            ],
                            [
                                -157.81288333875162,
                                21.295677603502551
                            ],
                            [
                                -157.81288318515232,
                                21.295677404576892
                            ],
                            [
                                -157.8128829975843,
                                21.29567723432012
                            ],
                            [
                                -157.81288278180932,
                                21.295677095483036
                            ],
                            [
                                -157.81288254259604,
                                21.295676994423005
                            ],
                            [
                                -157.81288228957621,
                                21.295676932111348
                            ],
                            [
                                -157.81288202947542,
                                21.295676911305669
                            ],
                            [
                                -157.81288178254999,
                                21.295676930342054
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81277287995425,
                                21.295653735567875
                            ],
                            [
                                -157.81277265099473,
                                21.295653798093522
                            ],
                            [
                                -157.81277243717471,
                                21.295653895958154
                            ],
                            [
                                -157.81277223365291,
                                21.295654031837792
                            ],
                            [
                                -157.81277205688087,
                                21.295654197717973
                            ],
                            [
                                -157.81277191460615,
                                21.295654389136399
                            ],
                            [
                                -157.81277180782885,
                                21.295654601583152
                            ],
                            [
                                -157.8127717423977,
                                21.29565482696901
                            ],
                            [
                                -157.81277171739234,
                                21.29565505986713
                            ],
                            [
                                -157.81277173575523,
                                21.295655293974555
                            ],
                            [
                                -157.81277179658781,
                                21.29565552115443
                            ],
                            [
                                -157.81277189704909,
                                21.295655735062979
                            ],
                            [
                                -157.81277203525485,
                                21.295655930266594
                            ],
                            [
                                -157.81277220740026,
                                21.2956561004147
                            ],
                            [
                                -157.81277240678878,
                                21.295656239136335
                            ],
                            [
                                -157.81277263052877,
                                21.295656346411107
                            ],
                            [
                                -157.81277286903921,
                                21.295656414944297
                            ],
                            [
                                -157.81277311749335,
                                21.295656445605278
                            ],
                            [
                                -157.81277336724514,
                                21.295656434719497
                            ],
                            [
                                -157.81277361056158,
                                21.295656384942568
                            ],
                            [
                                -157.81277384165199,
                                21.29565629713704
                            ],
                            [
                                -157.81277405471849,
                                21.295656173068782
                            ],
                            [
                                -157.81277424008582,
                                21.29565601718652
                            ],
                            [
                                -157.81277439578989,
                                21.295655833993344
                            ],
                            [
                                -157.81277451696039,
                                21.295655629778604
                            ],
                            [
                                -157.81277459682826,
                                21.295655407204734
                            ],
                            [
                                -157.81277463627762,
                                21.295655176215281
                            ],
                            [
                                -157.81277463333711,
                                21.295654942216636
                            ],
                            [
                                -157.812774587956,
                                21.295654711532201
                            ],
                            [
                                -157.81277450199673,
                                21.295654492305601
                            ],
                            [
                                -157.81277437541581,
                                21.295654289956875
                            ],
                            [
                                -157.81277421587367,
                                21.295654110863776
                            ],
                            [
                                -157.81277402526902,
                                21.295653958653265
                            ],
                            [
                                -157.81277380932733,
                                21.295653840592827
                            ],
                            [
                                -157.81277358729753,
                                21.295653760431811
                            ],
                            [
                                -157.81277335341071,
                                21.295653716322747
                            ],
                            [
                                -157.81277311538534,
                                21.295653707416676
                            ],
                            [
                                -157.81277287995425,
                                21.295653735567875
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 262,
                "NUMBER": "1255",
                "PROPER_NAME": "KA PAPA LO`I O KĀNEWAI CULTURAL RESOURCE CENTER",
                "DISPLAY_NAME": "KA PAPA LO`I O KĀNEWAI CULTURAL RESOURCE CENTER (KPLOK) - 1255",
                "ADDRESS": "2645 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HAWAIIAN STUDIES AND RESOURCE CENTER",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1255_01.jpg",
                "HEIGHT (ft)": 16.399999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 70.736430791608043,
                "SHAPE_Area": 65.905883949284743
            }
        },
        {
            "type": "Feature",
            "id": 263,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81595903915442,
                            21.292061683384791
                        ],
                        [
                            -157.81601531664933,
                            21.292104387715746
                        ],
                        [
                            -157.81601654839929,
                            21.292102962698145
                        ],
                        [
                            -157.8160104643961,
                            21.292098346039388
                        ],
                        [
                            -157.81623459783748,
                            21.291838911053471
                        ],
                        [
                            -157.81624068184507,
                            21.291843526800761
                        ],
                        [
                            -157.81624191261952,
                            21.291842102677826
                        ],
                        [
                            -157.81618563611482,
                            21.29179939842972
                        ],
                        [
                            -157.81595903915442,
                            21.292061683384791
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 263,
                "NUMBER": "1115A",
                "PROPER_NAME": "HECO SUBSTATION L - LOWER CAMPUS ROAD",
                "DISPLAY_NAME": "HECO SUBSTATION L - LOWER CAMPUS ROAD - 1115A",
                "ADDRESS": "1311 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HECO SUBSTATION L - LOWER CAMPUS ROAD",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1115A_01.jpg",
                "HEIGHT (ft)": 18.400000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 91.364677543408732,
                "SHAPE_Area": 250.63484111066992
            }
        },
        {
            "type": "Feature",
            "id": 264,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81667206211557,
                            21.296281666753288
                        ],
                        [
                            -157.81668363288176,
                            21.296231527725158
                        ],
                        [
                            -157.81666290763059,
                            21.296227327596981
                        ],
                        [
                            -157.81667072566694,
                            21.296193449411366
                        ],
                        [
                            -157.81646879729757,
                            21.296152521630408
                        ],
                        [
                            -157.81644973317543,
                            21.296148656571162
                        ],
                        [
                            -157.81641262024118,
                            21.296141135042216
                        ],
                        [
                            -157.81640511472295,
                            21.296173657615768
                        ],
                        [
                            -157.81618653219354,
                            21.296129353854525
                        ],
                        [
                            -157.81617871405152,
                            21.296163232012898
                        ],
                        [
                            -157.81615798884192,
                            21.296159030016955
                        ],
                        [
                            -157.81614641789906,
                            21.296209169904689
                        ],
                        [
                            -157.81616714312244,
                            21.296213370998998
                        ],
                        [
                            -157.81616651702194,
                            21.296216080379747
                        ],
                        [
                            -157.81638510062751,
                            21.29626038508237
                        ],
                        [
                            -157.81638259813903,
                            21.296271226236136
                        ],
                        [
                            -157.81642212094096,
                            21.296279237192575
                        ],
                        [
                            -157.81643212798997,
                            21.296235872553925
                        ],
                        [
                            -157.81665071172242,
                            21.296280176916468
                        ],
                        [
                            -157.81665133589391,
                            21.296277466616644
                        ],
                        [
                            -157.81667206211557,
                            21.296281666753288
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 264,
                "NUMBER": "1130",
                "PROPER_NAME": "JOHNSON HALL A",
                "DISPLAY_NAME": "JOHNSON HALL A - 1130",
                "ADDRESS": "2555 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "JOHNSON HALL A",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1130_01.jpg",
                "HEIGHT (ft)": 40.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 139.45851895612989,
                "SHAPE_Area": 542.55865796317903
            }
        },
        {
            "type": "Feature",
            "id": 265,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81599422508648,
                            21.29614381951458
                        ],
                        [
                            -157.81600575860247,
                            21.296094025373986
                        ],
                        [
                            -157.8159851769145,
                            21.296089838821146
                        ],
                        [
                            -157.81599297008799,
                            21.296056194475508
                        ],
                        [
                            -157.81575699786387,
                            21.296008186797401
                        ],
                        [
                            -157.81572874595508,
                            21.296002439390893
                        ],
                        [
                            -157.81569188932693,
                            21.295994941190489
                        ],
                        [
                            -157.81568440666163,
                            21.296027239846492
                        ],
                        [
                            -157.8154225761742,
                            21.295973971796268
                        ],
                        [
                            -157.81541478288486,
                            21.296007615206619
                        ],
                        [
                            -157.81539420122934,
                            21.296003428582797
                        ],
                        [
                            -157.81538266656156,
                            21.296053221762609
                        ],
                        [
                            -157.81540324918018,
                            21.29605740929825
                        ],
                        [
                            -157.81540262514645,
                            21.296060099719028
                        ],
                        [
                            -157.81566445576152,
                            21.296113369613202
                        ],
                        [
                            -157.81566196154296,
                            21.296124134927847
                        ],
                        [
                            -157.81570121262502,
                            21.296132120650583
                        ],
                        [
                            -157.81571118855121,
                            21.296089055768618
                        ],
                        [
                            -157.81597301840424,
                            21.296142323376603
                        ],
                        [
                            -157.81597364243538,
                            21.296139632049915
                        ],
                        [
                            -157.81599422508648,
                            21.29614381951458
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 265,
                "NUMBER": "1156",
                "PROPER_NAME": "JOHNSON HALL B",
                "DISPLAY_NAME": "JOHNSON HALL B - 1156",
                "ADDRESS": "2550 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "JOHNSON HALL B",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1156_01.jpg",
                "HEIGHT (ft)": 38.899999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 157.52400504061936,
                "SHAPE_Area": 627.99042734779198
            }
        },
        {
            "type": "Feature",
            "id": 267,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81845707184712,
                            21.299244994636055
                        ],
                        [
                            -157.81846294968631,
                            21.299244817282833
                        ],
                        [
                            -157.81846276043089,
                            21.299239309788629
                        ],
                        [
                            -157.81846618916907,
                            21.299239206483055
                        ],
                        [
                            -157.81846623599921,
                            21.29924058357906
                        ],
                        [
                            -157.81876939576446,
                            21.299231459996424
                        ],
                        [
                            -157.81876934796037,
                            21.299230083796946
                        ],
                        [
                            -157.81877277670569,
                            21.299229979581753
                        ],
                        [
                            -157.81877296500156,
                            21.299235487972719
                        ],
                        [
                            -157.81877884284054,
                            21.299235310608431
                        ],
                        [
                            -157.81877841841535,
                            21.29922292124035
                        ],
                        [
                            -157.81881221114915,
                            21.299221903616154
                        ],
                        [
                            -157.81881216334466,
                            21.299220527416665
                        ],
                        [
                            -157.81884301908667,
                            21.299219598482534
                        ],
                        [
                            -157.81884306592752,
                            21.299220974675254
                        ],
                        [
                            -157.81884747333888,
                            21.299220842095092
                        ],
                        [
                            -157.81884742649797,
                            21.299219465902368
                        ],
                        [
                            -157.81890864622798,
                            21.299217623535466
                        ],
                        [
                            -157.81890869306946,
                            21.2992189997282
                        ],
                        [
                            -157.81891310048076,
                            21.299218867146326
                        ],
                        [
                            -157.81891305460317,
                            21.299217490960356
                        ],
                        [
                            -157.81897427433282,
                            21.299215648569483
                        ],
                        [
                            -157.81897432021097,
                            21.299217024755464
                        ],
                        [
                            -157.81897872858619,
                            21.299216892178634
                        ],
                        [
                            -157.81897868174403,
                            21.299215515985885
                        ],
                        [
                            -157.8190399014733,
                            21.299213673571053
                        ],
                        [
                            -157.819039948316,
                            21.299215049763813
                        ],
                        [
                            -157.8190796179162,
                            21.299213855608638
                        ],
                        [
                            -157.81907375752289,
                            21.29904282068965
                        ],
                        [
                            -157.81903849441815,
                            21.299043881350084
                        ],
                        [
                            -157.81903744312947,
                            21.299013185789988
                        ],
                        [
                            -157.81881199097137,
                            21.298829205374258
                        ],
                        [
                            -157.81877183165119,
                            21.298830415004272
                        ],
                        [
                            -157.81877176903384,
                            21.298828600556284
                        ],
                        [
                            -157.81876883109359,
                            21.298828688342137
                        ],
                        [
                            -157.81876889274696,
                            21.298830502783357
                        ],
                        [
                            -157.81876497516467,
                            21.298830620732172
                        ],
                        [
                            -157.81876328836924,
                            21.298781387651538
                        ],
                        [
                            -157.8187574105483,
                            21.298781565016132
                        ],
                        [
                            -157.81875750520697,
                            21.298784315601754
                        ],
                        [
                            -157.81875407647922,
                            21.298784418913787
                        ],
                        [
                            -157.81875402962467,
                            21.298783044527703
                        ],
                        [
                            -157.81845087080302,
                            21.298792165415776
                        ],
                        [
                            -157.81845091764032,
                            21.2987935416085
                        ],
                        [
                            -157.81844748986919,
                            21.298793645824372
                        ],
                        [
                            -157.81844739522353,
                            21.298790894335486
                        ],
                        [
                            -157.81844151836637,
                            21.298791071695778
                        ],
                        [
                            -157.8184423389018,
                            21.298815044409295
                        ],
                        [
                            -157.81844297392945,
                            21.29883050859106
                        ],
                        [
                            -157.81844066724335,
                            21.298830615257337
                        ],
                        [
                            -157.81844911184569,
                            21.299077072521513
                        ],
                        [
                            -157.81845308246469,
                            21.299076953145907
                        ],
                        [
                            -157.81845424987546,
                            21.299105407304541
                        ],
                        [
                            -157.8183751537272,
                            21.299107787081688
                        ],
                        [
                            -157.81837951052893,
                            21.299234923818943
                        ],
                        [
                            -157.81845664745614,
                            21.299232604365105
                        ],
                        [
                            -157.81845707184712,
                            21.299244994636055
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 267,
                "NUMBER": "1250",
                "PROPER_NAME": "WARRIOR RECREATION CENTER",
                "DISPLAY_NAME": "WARRIOR RECREATION CENTER - 1250",
                "ADDRESS": "2505 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CAMPUS CENTER AND WARRIOR RECREATION CENTER",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": "WRC , gym",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1250_01.jpg",
                "HEIGHT (ft)": 44.399999999999999,
                "LEED STATUS": "Gold",
                "LEED LINK": "https://www.usgbc.org/projects/university-hawaii-warrior-rec-center",
                "PV LINK": "https://www.hawaii.edu/sustainability/pv_system/warrior-recreation-center/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2019/08/WRC-01.jpg",
                "PORTABLE?": null,
                "SHAPE_Length": 237.97557578687241,
                "SHAPE_Area": 2803.0496048368891
            }
        },
        {
            "type": "Feature",
            "id": 268,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81843231924313,
                            21.298830851152559
                        ],
                        [
                            -157.81841458479423,
                            21.298831353593222
                        ],
                        [
                            -157.81833501070571,
                            21.298833607140601
                        ],
                        [
                            -157.81834296477504,
                            21.299080266931824
                        ],
                        [
                            -157.81835532403034,
                            21.299079894789227
                        ],
                        [
                            -157.81836373772865,
                            21.29907964219527
                        ],
                        [
                            -157.81844911184569,
                            21.299077072521513
                        ],
                        [
                            -157.81844759717043,
                            21.299032850855699
                        ],
                        [
                            -157.81844692414634,
                            21.299013216356581
                        ],
                        [
                            -157.81844066724335,
                            21.298830615257337
                        ],
                        [
                            -157.81843231924313,
                            21.298830851152559
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 268,
                "NUMBER": "1031C",
                "PROPER_NAME": "WARRIOR RECREATION CENTER ANNEX",
                "DISPLAY_NAME": "WARRIOR RECREATION CENTER ANNEX - 1031C",
                "ADDRESS": "2465 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CAMPUS CENTER AND WARRIOR RECREATION CENTER",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1031C_01.jpg",
                "HEIGHT (ft)": 17.800000000000001,
                "LEED STATUS": "Gold",
                "LEED LINK": "https://www.usgbc.org/projects/university-hawaii-warrior-rec-center",
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 76.596329591275506,
                "SHAPE_Area": 300.14287645702075
            }
        },
        {
            "type": "Feature",
            "id": 269,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81149366072444,
                            21.294460614371921
                        ],
                        [
                            -157.81155474069507,
                            21.294447489382602
                        ],
                        [
                            -157.81154872386074,
                            21.294422892776652
                        ],
                        [
                            -157.81157916195809,
                            21.29441635304314
                        ],
                        [
                            -157.81157970789121,
                            21.294418589172849
                        ],
                        [
                            -157.81158541757222,
                            21.294417362030238
                        ],
                        [
                            -157.81158487066784,
                            21.294415126797077
                        ],
                        [
                            -157.81162495429493,
                            21.294406513219876
                        ],
                        [
                            -157.81162550119262,
                            21.294408749356275
                        ],
                        [
                            -157.81163122825205,
                            21.294407518721222
                        ],
                        [
                            -157.81163068039038,
                            21.294405282578019
                        ],
                        [
                            -157.81167076400544,
                            21.294396669892976
                        ],
                        [
                            -157.81167131186768,
                            21.294398906036083
                        ],
                        [
                            -157.81167703796254,
                            21.294397675392613
                        ],
                        [
                            -157.81167649106408,
                            21.294395439256345
                        ],
                        [
                            -157.81176238533777,
                            21.294376983214526
                        ],
                        [
                            -157.81176293127359,
                            21.294379219343778
                        ],
                        [
                            -157.8117686583237,
                            21.29437798960727
                        ],
                        [
                            -157.81176811142387,
                            21.294375753471222
                        ],
                        [
                            -157.81185400471315,
                            21.294357297374724
                        ],
                        [
                            -157.8118545525781,
                            21.294359533517348
                        ],
                        [
                            -157.81186027867744,
                            21.294358301964174
                        ],
                        [
                            -157.81185973081244,
                            21.294356065821567
                        ],
                        [
                            -157.81189964251865,
                            21.29434749071315
                        ],
                        [
                            -157.81189981536744,
                            21.294347453087475
                        ],
                        [
                            -157.81190036226189,
                            21.294349690126516
                        ],
                        [
                            -157.81190608932445,
                            21.294348458578554
                        ],
                        [
                            -157.81190554145149,
                            21.294346223339378
                        ],
                        [
                            -157.81194562600896,
                            21.294337609690782
                        ],
                        [
                            -157.81194617194745,
                            21.294339845819586
                        ],
                        [
                            -157.81195189803094,
                            21.294338616069879
                        ],
                        [
                            -157.81195135209234,
                            21.294336379941104
                        ],
                        [
                            -157.81198177277864,
                            21.294329843623927
                        ],
                        [
                            -157.81198779064678,
                            21.294354440224669
                        ],
                        [
                            -157.81204887053869,
                            21.294341315051753
                        ],
                        [
                            -157.81204339956452,
                            21.294318954588054
                        ],
                        [
                            -157.81204578559394,
                            21.29431844204154
                        ],
                        [
                            -157.81204458259674,
                            21.294313522725808
                        ],
                        [
                            -157.81204219656746,
                            21.294314035272304
                        ],
                        [
                            -157.8120235148688,
                            21.294237674511553
                        ],
                        [
                            -157.81202589993302,
                            21.294237161958446
                        ],
                        [
                            -157.81202458774771,
                            21.29423179559755
                        ],
                        [
                            -157.81202220172693,
                            21.294232307240485
                        ],
                        [
                            -157.81200737081025,
                            21.294171685406383
                        ],
                        [
                            -157.81200414908614,
                            21.294158517447048
                        ],
                        [
                            -157.81200653607686,
                            21.294158004907757
                        ],
                        [
                            -157.81200522196505,
                            21.294152638533102
                        ],
                        [
                            -157.81200283690217,
                            21.294153151085983
                        ],
                        [
                            -157.81198478427868,
                            21.294079361290677
                        ],
                        [
                            -157.81198717030426,
                            21.294078848744814
                        ],
                        [
                            -157.81198585715762,
                            21.294073482376824
                        ],
                        [
                            -157.81198347113209,
                            21.294073994922677
                        ],
                        [
                            -157.81196479045173,
                            21.293997634162913
                        ],
                        [
                            -157.81196717551944,
                            21.293997120707115
                        ],
                        [
                            -157.81196597252699,
                            21.293992201390896
                        ],
                        [
                            -157.81195785946173,
                            21.293993944583825
                        ],
                        [
                            -157.81195840732721,
                            21.293996180726236
                        ],
                        [
                            -157.81187263302931,
                            21.294014611527246
                        ],
                        [
                            -157.811872086129,
                            21.294012375391439
                        ],
                        [
                            -157.81186636005052,
                            21.294013606042355
                        ],
                        [
                            -157.81186690598688,
                            21.29401584217139
                        ],
                        [
                            -157.81186072221155,
                            21.294017170771024
                        ],
                        [
                            -157.81178101289231,
                            21.294034299187885
                        ],
                        [
                            -157.81178046600058,
                            21.294032062148514
                        ],
                        [
                            -157.81177473896412,
                            21.294033291886098
                        ],
                        [
                            -157.81177528681965,
                            21.294035528932309
                        ],
                        [
                            -157.81168939274065,
                            21.294053985894124
                        ],
                        [
                            -157.81168884585028,
                            21.294051748854518
                        ],
                        [
                            -157.81168311976907,
                            21.29405297949905
                        ],
                        [
                            -157.81168366666662,
                            21.294055215635336
                        ],
                        [
                            -157.8115977735383,
                            21.294073671652765
                        ],
                        [
                            -157.81159722567807,
                            21.294071435509441
                        ],
                        [
                            -157.81159149960277,
                            21.294072665247466
                        ],
                        [
                            -157.81159204744833,
                            21.294074903197458
                        ],
                        [
                            -157.81150615333556,
                            21.294093359160208
                        ],
                        [
                            -157.81150560549125,
                            21.294091121209981
                        ],
                        [
                            -157.81149987844344,
                            21.294092351841325
                        ],
                        [
                            -157.81150042628767,
                            21.294094589791563
                        ],
                        [
                            -157.81141465961298,
                            21.294113018601372
                        ],
                        [
                            -157.81141411273387,
                            21.294110780657739
                        ],
                        [
                            -157.81140599290245,
                            21.294112524679136
                        ],
                        [
                            -157.81140719679715,
                            21.294117449425315
                        ],
                        [
                            -157.81140958572388,
                            21.294116936004844
                        ],
                        [
                            -157.81142826422717,
                            21.294193293185526
                        ],
                        [
                            -157.81142587626312,
                            21.294193806612999
                        ],
                        [
                            -157.81142719035395,
                            21.294199172991188
                        ],
                        [
                            -157.8114295783181,
                            21.29419865956368
                        ],
                        [
                            -157.81144762874484,
                            21.294272449391645
                        ],
                        [
                            -157.81144524174346,
                            21.294272962826142
                        ],
                        [
                            -157.81144655390776,
                            21.294278329190579
                        ],
                        [
                            -157.81144894187315,
                            21.294277815762875
                        ],
                        [
                            -157.81146699424502,
                            21.294351605602582
                        ],
                        [
                            -157.81146460724239,
                            21.29435211903731
                        ],
                        [
                            -157.81146591940796,
                            21.294357485401612
                        ],
                        [
                            -157.81146830641069,
                            21.29435697196687
                        ],
                        [
                            -157.8114869868526,
                            21.294433334575384
                        ],
                        [
                            -157.8114846008271,
                            21.294433846210449
                        ],
                        [
                            -157.81148580476281,
                            21.294438766439438
                        ],
                        [
                            -157.81148818983903,
                            21.294438252990865
                        ],
                        [
                            -157.81149366072444,
                            21.294460614371921
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 269,
                "NUMBER": "1134",
                "PROPER_NAME": "DOLE STREET PARKING STRUCTURE",
                "DISPLAY_NAME": "DOLE STREET PARKING STRUCTURE - 1134",
                "ADDRESS": "2421 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "DOLE STREET PARKING STRUCTURE",
                "SUBSTATION-FED?": "N",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "Zone 22 Parking Structure",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1134_01.jpg",
                "HEIGHT (ft)": 38.200000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 214.63974135676091,
                "SHAPE_Area": 2199.4408430950994
            }
        },
        {
            "type": "Feature",
            "id": 270,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.81364230941315,
                                21.304625131273273
                            ],
                            [
                                -157.81368714726838,
                                21.304671042353363
                            ],
                            [
                                -157.81370057015391,
                                21.30465952121892
                            ],
                            [
                                -157.8136560795102,
                                21.304613829403774
                            ],
                            [
                                -157.81364230941315,
                                21.304625131273273
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81360370270656,
                                21.304680705651123
                            ],
                            [
                                -157.81362557735559,
                                21.304703372340743
                            ],
                            [
                                -157.81364188941029,
                                21.30468920839261
                            ],
                            [
                                -157.81361972643381,
                                21.304666792620914
                            ],
                            [
                                -157.81360370270656,
                                21.304680705651123
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81357983580375,
                                21.304701456232049
                            ],
                            [
                                -157.81360176411664,
                                21.304723802600083
                            ],
                            [
                                -157.81361804508248,
                                21.304709669150462
                            ],
                            [
                                -157.81359602940341,
                                21.304687398053147
                            ],
                            [
                                -157.81357983580375,
                                21.304701456232049
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81362629653177,
                                21.304661106944661
                            ],
                            [
                                -157.81364815674542,
                                21.304683530518041
                            ],
                            [
                                -157.81366396729416,
                                21.304669993596914
                            ],
                            [
                                -157.8136421070727,
                                21.304647570928864
                            ],
                            [
                                -157.81362629653177,
                                21.304661106944661
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 270,
                "NUMBER": "1132B",
                "PROPER_NAME": "TRANSPORTATION SERVICES - SERVICE STATION (GAS PUMPS)",
                "DISPLAY_NAME": "TRANSPORTATION SERVICES - SERVICE STATION (GAS PUMPS) - 1132B",
                "ADDRESS": "2027 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "TRANSPORTATION SERVICES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1132B_01.jpg",
                "HEIGHT (ft)": 9.5999999999999996,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 51.343072758528045,
                "SHAPE_Area": 35.923860986066529
            }
        },
        {
            "type": "Feature",
            "id": 271,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8180374435033,
                            21.292880202019269
                        ],
                        [
                            -157.81804414344364,
                            21.292889053513541
                        ],
                        [
                            -157.81804789685262,
                            21.292886542242826
                        ],
                        [
                            -157.81804807903777,
                            21.292886421564241
                        ],
                        [
                            -157.81805081874262,
                            21.2928845888495
                        ],
                        [
                            -157.81804982358665,
                            21.292883308983871
                        ],
                        [
                            -157.81805465113524,
                            21.292880155716915
                        ],
                        [
                            -157.81805557049825,
                            21.292881390784178
                        ],
                        [
                            -157.81806209983841,
                            21.292876976588111
                        ],
                        [
                            -157.81805536118711,
                            21.29286802364291
                        ],
                        [
                            -157.81804891962898,
                            21.292872550475593
                        ],
                        [
                            -157.81804966152205,
                            21.292873557545608
                        ],
                        [
                            -157.81804485634515,
                            21.29287668567455
                        ],
                        [
                            -157.81804401846807,
                            21.292875627340649
                        ],
                        [
                            -157.8180374435033,
                            21.292880202019269
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 271,
                "NUMBER": "1252G",
                "PROPER_NAME": "PARKING KIOSK - VARSITY CIRCLE",
                "DISPLAY_NAME": "PARKING KIOSK - VARSITY CIRCLE - 1252G",
                "ADDRESS": "2600 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PARKING KIOSK - VARSITY CIRCLE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1252G_01.jpg",
                "HEIGHT (ft)": 8.1999999999999993,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 7.625804241552431,
                "SHAPE_Area": 2.5802303145204721
            }
        },
        {
            "type": "Feature",
            "id": 272,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81996092821205,
                            21.294897220596479
                        ],
                        [
                            -157.81996892730444,
                            21.294895502415283
                        ],
                        [
                            -157.81997302630512,
                            21.294894622340401
                        ],
                        [
                            -157.81997924964514,
                            21.294893285588095
                        ],
                        [
                            -157.81997794437663,
                            21.294887619400537
                        ],
                        [
                            -157.81997962726277,
                            21.294887278876022
                        ],
                        [
                            -157.81997871154502,
                            21.294883530609177
                        ],
                        [
                            -157.81997699373505,
                            21.294883898893982
                        ],
                        [
                            -157.81997276792515,
                            21.294866731030485
                        ],
                        [
                            -157.81997422214377,
                            21.294866416908018
                        ],
                        [
                            -157.81997326280083,
                            21.294862578899576
                        ],
                        [
                            -157.8199712232344,
                            21.294863042494875
                        ],
                        [
                            -157.81996984012883,
                            21.294857708209577
                        ],
                        [
                            -157.81995166481843,
                            21.294861935133593
                        ],
                        [
                            -157.81995311105746,
                            21.29486733038884
                        ],
                        [
                            -157.81995112131796,
                            21.294867831372247
                        ],
                        [
                            -157.8199521566471,
                            21.294871448582654
                        ],
                        [
                            -157.81995456217274,
                            21.294870907151427
                        ],
                        [
                            -157.81995670848954,
                            21.294879290313027
                        ],
                        [
                            -157.81995571190825,
                            21.294879513691029
                        ],
                        [
                            -157.81995791138172,
                            21.294888362471834
                        ],
                        [
                            -157.81995666957371,
                            21.294888633817141
                        ],
                        [
                            -157.81995757989691,
                            21.294892333263114
                        ],
                        [
                            -157.81995961735572,
                            21.294891892238006
                        ],
                        [
                            -157.81996092821205,
                            21.294897220596479
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 272,
                "NUMBER": "1252F",
                "PROPER_NAME": "PARKING KIOSK - DOLE ST 3",
                "DISPLAY_NAME": "PARKING KIOSK - DOLE ST 3 - 1252F",
                "ADDRESS": "2600 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MUSIC COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1252F_01.jpg",
                "HEIGHT (ft)": 11.800000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 13.630356322165092,
                "SHAPE_Area": 8.3045622442578573
            }
        },
        {
            "type": "Feature",
            "id": 273,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82001325705284,
                            21.294885054704181
                        ],
                        [
                            -157.82002402813345,
                            21.294882654018032
                        ],
                        [
                            -157.82002494648032,
                            21.294882449965794
                        ],
                        [
                            -157.82003327827698,
                            21.2948805931848
                        ],
                        [
                            -157.82003093345199,
                            21.294871355830917
                        ],
                        [
                            -157.82002898708083,
                            21.294871858022685
                        ],
                        [
                            -157.82002466214036,
                            21.29485515290509
                        ],
                        [
                            -157.82002663536343,
                            21.294854668066026
                        ],
                        [
                            -157.82002545072626,
                            21.294850433696393
                        ],
                        [
                            -157.82002357364067,
                            21.294850950828081
                        ],
                        [
                            -157.82002209141768,
                            21.294845595070296
                        ],
                        [
                            -157.82000415354639,
                            21.294850146175364
                        ],
                        [
                            -157.8200054101226,
                            21.294855149835527
                        ],
                        [
                            -157.82000335602578,
                            21.294855622363272
                        ],
                        [
                            -157.82000433452717,
                            21.294859354809102
                        ],
                        [
                            -157.82000687052474,
                            21.294858770928986
                        ],
                        [
                            -157.82000904548244,
                            21.294867068468655
                        ],
                        [
                            -157.82000790671799,
                            21.294867352280818
                        ],
                        [
                            -157.82001026443498,
                            21.294876423501329
                        ],
                        [
                            -157.82000883807561,
                            21.294876749563496
                        ],
                        [
                            -157.8200097211992,
                            21.294880233811419
                        ],
                        [
                            -157.82001191132852,
                            21.294879746879595
                        ],
                        [
                            -157.82001325705284,
                            21.294885054704181
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 273,
                "NUMBER": "1252E",
                "PROPER_NAME": "PARKING KIOSK - DOLE ST 2",
                "DISPLAY_NAME": "PARKING KIOSK - DOLE ST 2 - 1252E",
                "ADDRESS": "2600 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MUSIC COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1252E_01.jpg",
                "HEIGHT (ft)": 11.700000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 13.710489983052721,
                "SHAPE_Area": 8.2814940739613565
            }
        },
        {
            "type": "Feature",
            "id": 274,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82006528883497,
                            21.294873149599734
                        ],
                        [
                            -157.82006997427607,
                            21.294872103795864
                        ],
                        [
                            -157.8200720968313,
                            21.294871629037022
                        ],
                        [
                            -157.82008348212437,
                            21.29486908539986
                        ],
                        [
                            -157.82008214060872,
                            21.294863612284622
                        ],
                        [
                            -157.82008410369534,
                            21.294863189707847
                        ],
                        [
                            -157.82008318865547,
                            21.294859597732927
                        ],
                        [
                            -157.82008075762928,
                            21.294860194094142
                        ],
                        [
                            -157.82007835762468,
                            21.294851589631357
                        ],
                        [
                            -157.82007955816485,
                            21.294851295411064
                        ],
                        [
                            -157.82007718279365,
                            21.294842503215531
                        ],
                        [
                            -157.82007878742539,
                            21.294842063671762
                        ],
                        [
                            -157.82007780391299,
                            21.294838475733773
                        ],
                        [
                            -157.82007571776288,
                            21.294838978753045
                        ],
                        [
                            -157.8200742761565,
                            21.294833727170367
                        ],
                        [
                            -157.82005634961635,
                            21.294837945912519
                        ],
                        [
                            -157.82006528883497,
                            21.294873149599734
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 274,
                "NUMBER": "1252D",
                "PROPER_NAME": "PARKING KIOSK - DOLE ST 1",
                "DISPLAY_NAME": "PARKING KIOSK - DOLE ST 1 - 1252D",
                "ADDRESS": "2600 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MUSIC COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1252D_01.jpg",
                "HEIGHT (ft)": 11.700000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 12.888093792263083,
                "SHAPE_Area": 7.9575233404810799
            }
        },
        {
            "type": "Feature",
            "id": 275,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82036450917693,
                            21.297948718750469
                        ],
                        [
                            -157.82036571458497,
                            21.297949146372854
                        ],
                        [
                            -157.82036571894548,
                            21.297947029757939
                        ],
                        [
                            -157.82036581730529,
                            21.297943522579512
                        ],
                        [
                            -157.82036587561635,
                            21.297941409956319
                        ],
                        [
                            -157.82036610982237,
                            21.297933080524679
                        ],
                        [
                            -157.82036681190539,
                            21.29793195439996
                        ],
                        [
                            -157.82036538413689,
                            21.297932211796297
                        ],
                        [
                            -157.82034288400428,
                            21.297931736997612
                        ],
                        [
                            -157.82034199653503,
                            21.297931089369367
                        ],
                        [
                            -157.82034267818156,
                            21.297932403160996
                        ],
                        [
                            -157.82034206172051,
                            21.297946957891796
                        ],
                        [
                            -157.82034159687714,
                            21.297948433484876
                        ],
                        [
                            -157.8203429299555,
                            21.297947962224711
                        ],
                        [
                            -157.82036450917693,
                            21.297948718750469
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 275,
                "NUMBER": "1252C",
                "PROPER_NAME": "PARKING KIOSK - BACHMAN LOT 12",
                "DISPLAY_NAME": "PARKING KIOSK - BACHMAN LOT 12 - 1252C",
                "ADDRESS": "2600 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BACHMAN HALL AND ANNEXES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1252C_01.jpg",
                "HEIGHT (ft)": 7.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 8.9918158234727557,
                "SHAPE_Area": 4.4438841772959154
            }
        },
        {
            "type": "Feature",
            "id": 276,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81895964117149,
                            21.297312759166775
                        ],
                        [
                            -157.81896137132875,
                            21.297314468779355
                        ],
                        [
                            -157.81896332780587,
                            21.297314515934051
                        ],
                        [
                            -157.81896332082098,
                            21.297314786902295
                        ],
                        [
                            -157.81896614946652,
                            21.297314861858641
                        ],
                        [
                            -157.81896914484736,
                            21.297314940695138
                        ],
                        [
                            -157.81897213445194,
                            21.297315018587636
                        ],
                        [
                            -157.81897502762192,
                            21.297315101223752
                        ],
                        [
                            -157.81897799317201,
                            21.297315173527021
                        ],
                        [
                            -157.81898111383998,
                            21.29731525595264
                        ],
                        [
                            -157.81898389912385,
                            21.297315328797612
                        ],
                        [
                            -157.81898679330826,
                            21.297315405116901
                        ],
                        [
                            -157.81898986386719,
                            21.297315485383955
                        ],
                        [
                            -157.81899280912461,
                            21.29731556386831
                        ],
                        [
                            -157.81899575149748,
                            21.297315641428977
                        ],
                        [
                            -157.81899868129622,
                            21.297315724321699
                        ],
                        [
                            -157.81900134904043,
                            21.297315789114478
                        ],
                        [
                            -157.81900457476056,
                            21.297315874083608
                        ],
                        [
                            -157.81900757206932,
                            21.297315952932948
                        ],
                        [
                            -157.81901039783037,
                            21.2973160269649
                        ],
                        [
                            -157.81901331803329,
                            21.297316104369695
                        ],
                        [
                            -157.81901623245994,
                            21.297316180830521
                        ],
                        [
                            -157.81901701503494,
                            21.297316201679493
                        ],
                        [
                            -157.81901922398529,
                            21.297316259639054
                        ],
                        [
                            -157.81902406782339,
                            21.297316271946777
                        ],
                        [
                            -157.81902916902635,
                            21.297316286060262
                        ],
                        [
                            -157.81903106788528,
                            21.297316305708158
                        ],
                        [
                            -157.81903106236322,
                            21.297316755558072
                        ],
                        [
                            -157.81903979088153,
                            21.297317022778291
                        ],
                        [
                            -157.81904032479574,
                            21.297317038268776
                        ],
                        [
                            -157.81904701791146,
                            21.297317243326745
                        ],
                        [
                            -157.81904910921386,
                            21.297317306784148
                        ],
                        [
                            -157.81905438949957,
                            21.297317468502797
                        ],
                        [
                            -157.81906177457529,
                            21.297317694676533
                        ],
                        [
                            -157.81906923964141,
                            21.297317923218014
                        ],
                        [
                            -157.81907505288476,
                            21.297318099516303
                        ],
                        [
                            -157.81907676833313,
                            21.297318151302211
                        ],
                        [
                            -157.81908588048202,
                            21.297318422115222
                        ],
                        [
                            -157.81908607917845,
                            21.297315632031498
                        ],
                        [
                            -157.81908625951806,
                            21.297313088444668
                        ],
                        [
                            -157.81908619108745,
                            21.297313087061131
                        ],
                        [
                            -157.81908727955584,
                            21.297276267064515
                        ],
                        [
                            -157.81908746157129,
                            21.297270135220721
                        ],
                        [
                            -157.81908748534474,
                            21.297269331369613
                        ],
                        [
                            -157.81908773886093,
                            21.297260765388984
                        ],
                        [
                            -157.81908785061336,
                            21.297253172269052
                        ],
                        [
                            -157.81908844298721,
                            21.297212809305645
                        ],
                        [
                            -157.81908520062842,
                            21.297182108303108
                        ],
                        [
                            -157.8190834010073,
                            21.297165082114663
                        ],
                        [
                            -157.81907388777213,
                            21.297132243954948
                        ],
                        [
                            -157.81907335196954,
                            21.297131017004109
                        ],
                        [
                            -157.81907174743182,
                            21.297127338881904
                        ],
                        [
                            -157.81906014646322,
                            21.297100748378526
                        ],
                        [
                            -157.81904612004789,
                            21.297077309047634
                        ],
                        [
                            -157.81904238631853,
                            21.297071071132869
                        ],
                        [
                            -157.8190342837876,
                            21.297060744530928
                        ],
                        [
                            -157.81902834167141,
                            21.297053172169242
                        ],
                        [
                            -157.81902087560491,
                            21.297043659470948
                        ],
                        [
                            -157.81901884885215,
                            21.297041429231481
                        ],
                        [
                            -157.81901789518983,
                            21.297040380929971
                        ],
                        [
                            -157.81901712404681,
                            21.29703953265517
                        ],
                        [
                            -157.81901413296072,
                            21.29703638322416
                        ],
                        [
                            -157.81901206816815,
                            21.297034208727919
                        ],
                        [
                            -157.81900174037224,
                            21.297023333509262
                        ],
                        [
                            -157.81899953122428,
                            21.297021129091423
                        ],
                        [
                            -157.81899789301349,
                            21.297019494202559
                        ],
                        [
                            -157.8189978454426,
                            21.297019536328119
                        ],
                        [
                            -157.81898882721185,
                            21.297012338968532
                        ],
                        [
                            -157.81898178026159,
                            21.297006713790552
                        ],
                        [
                            -157.81896977543067,
                            21.296997133105375
                        ],
                        [
                            -157.81896889307825,
                            21.296996570424909
                        ],
                        [
                            -157.81893929694331,
                            21.296977687843306
                        ],
                        [
                            -157.81890676385854,
                            21.296961428871722
                        ],
                        [
                            -157.81889579294605,
                            21.296957933451107
                        ],
                        [
                            -157.81886908199095,
                            21.296949423964492
                        ],
                        [
                            -157.81883010760373,
                            21.296941863695192
                        ],
                        [
                            -157.81881535532079,
                            21.296940748365014
                        ],
                        [
                            -157.81879043741611,
                            21.296938865174599
                        ],
                        [
                            -157.81875828786264,
                            21.296940840198094
                        ],
                        [
                            -157.81872658904854,
                            21.296946242230323
                        ],
                        [
                            -157.8187194703855,
                            21.296948265548934
                        ],
                        [
                            -157.81870330655178,
                            21.296952857862436
                        ],
                        [
                            -157.81869575602369,
                            21.29695500281678
                        ],
                        [
                            -157.81865540672544,
                            21.296971725036812
                        ],
                        [
                            -157.81864243872428,
                            21.296978934314478
                        ],
                        [
                            -157.81861746226443,
                            21.296992820277641
                        ],
                        [
                            -157.81861015312063,
                            21.296997448536953
                        ],
                        [
                            -157.81860855545838,
                            21.296998459960843
                        ],
                        [
                            -157.81860595404365,
                            21.29700010755327
                        ],
                        [
                            -157.81859963120743,
                            21.297004111265149
                        ],
                        [
                            -157.81859951168593,
                            21.297003989371809
                        ],
                        [
                            -157.81859528404928,
                            21.297007688893608
                        ],
                        [
                            -157.81859513783448,
                            21.29700777097921
                        ],
                        [
                            -157.81859211634975,
                            21.297010597257952
                        ],
                        [
                            -157.81859161811619,
                            21.297011062620474
                        ],
                        [
                            -157.81857869308254,
                            21.297023146891402
                        ],
                        [
                            -157.81857844155232,
                            21.297023380007396
                        ],
                        [
                            -157.81857566895815,
                            21.297025941532606
                        ],
                        [
                            -157.81857553007916,
                            21.297026070646019
                        ],
                        [
                            -157.81857459779309,
                            21.297026931356978
                        ],
                        [
                            -157.81857465131009,
                            21.297026989549661
                        ],
                        [
                            -157.81857455192255,
                            21.297027122553835
                        ],
                        [
                            -157.81857427172415,
                            21.297027444904277
                        ],
                        [
                            -157.81854817036194,
                            21.297057484621718
                        ],
                        [
                            -157.81854500741514,
                            21.297061124765012
                        ],
                        [
                            -157.81853783677431,
                            21.297073750808561
                        ],
                        [
                            -157.81851573235971,
                            21.297112670000914
                        ],
                        [
                            -157.81850763179446,
                            21.297133579028802
                        ],
                        [
                            -157.81850182657308,
                            21.297148560761542
                        ],
                        [
                            -157.81849400330071,
                            21.297186032694952
                        ],
                        [
                            -157.81849244157638,
                            21.297216436188869
                        ],
                        [
                            -157.81849014240041,
                            21.297261192998594
                        ],
                        [
                            -157.81848977372556,
                            21.297268363333178
                        ],
                        [
                            -157.81848875775654,
                            21.297288135038475
                        ],
                        [
                            -157.81848851350631,
                            21.297292884255864
                        ],
                        [
                            -157.81848775099331,
                            21.297292886130027
                        ],
                        [
                            -157.81848771485784,
                            21.297298251114132
                        ],
                        [
                            -157.8184990938484,
                            21.297298693255613
                        ],
                        [
                            -157.81851166204788,
                            21.29729917626663
                        ],
                        [
                            -157.81854349115619,
                            21.297300397950867
                        ],
                        [
                            -157.81855728983285,
                            21.297300944703064
                        ],
                        [
                            -157.81855988882069,
                            21.297301048769356
                        ],
                        [
                            -157.81859731751845,
                            21.297302282649152
                        ],
                        [
                            -157.81860087266494,
                            21.297302398846931
                        ],
                        [
                            -157.81861127883346,
                            21.297302742909665
                        ],
                        [
                            -157.81861128211506,
                            21.297302694149597
                        ],
                        [
                            -157.81861320934217,
                            21.297302782659028
                        ],
                        [
                            -157.81861499169972,
                            21.297301216946362
                        ],
                        [
                            -157.8186148298297,
                            21.297293246999907
                        ],
                        [
                            -157.81861143954143,
                            21.297293128346084
                        ],
                        [
                            -157.81861130359391,
                            21.2972874631315
                        ],
                        [
                            -157.8186110889032,
                            21.297278503601341
                        ],
                        [
                            -157.8186106270476,
                            21.297259220192931
                        ],
                        [
                            -157.81861233367056,
                            21.297239510247778
                        ],
                        [
                            -157.81861296142603,
                            21.297232246875215
                        ],
                        [
                            -157.81861404893556,
                            21.297219683825794
                        ],
                        [
                            -157.81861414697275,
                            21.297219237335508
                        ],
                        [
                            -157.81861785284173,
                            21.297219792735348
                        ],
                        [
                            -157.8186192424229,
                            21.29721164848387
                        ],
                        [
                            -157.81861575126115,
                            21.297211125306461
                        ],
                        [
                            -157.81862100788805,
                            21.297184696467358
                        ],
                        [
                            -157.81862180434047,
                            21.297180689195926
                        ],
                        [
                            -157.81863207192211,
                            21.297154227775355
                        ],
                        [
                            -157.81863226876916,
                            21.297153720548046
                        ],
                        [
                            -157.81863301974192,
                            21.297151785335831
                        ],
                        [
                            -157.81863389584313,
                            21.297150355997385
                        ],
                        [
                            -157.81864936774116,
                            21.297125117257867
                        ],
                        [
                            -157.8186652425311,
                            21.297107241269654
                        ],
                        [
                            -157.81866710761926,
                            21.297108832584545
                        ],
                        [
                            -157.81868003378119,
                            21.297097572207331
                        ],
                        [
                            -157.81867821014819,
                            21.297095739074802
                        ],
                        [
                            -157.81869289036104,
                            21.297085006844249
                        ],
                        [
                            -157.81870453788761,
                            21.297078864233406
                        ],
                        [
                            -157.8187072948827,
                            21.297077410153705
                        ],
                        [
                            -157.81871779043698,
                            21.297071874665615
                        ],
                        [
                            -157.8187445045599,
                            21.29706237781242
                        ],
                        [
                            -157.8187665030633,
                            21.297058055003607
                        ],
                        [
                            -157.81878891809964,
                            21.297056494070912
                        ],
                        [
                            -157.81879242347475,
                            21.297056685799927
                        ],
                        [
                            -157.81879222900534,
                            21.297059911347265
                        ],
                        [
                            -157.81880139169786,
                            21.297060489682689
                        ],
                        [
                            -157.81880162822162,
                            21.297057188545654
                        ],
                        [
                            -157.81881135616328,
                            21.297057721161053
                        ],
                        [
                            -157.81881670614922,
                            21.297058689200608
                        ],
                        [
                            -157.81882001547214,
                            21.297059288789214
                        ],
                        [
                            -157.81882545401538,
                            21.297060272807634
                        ],
                        [
                            -157.81883342508056,
                            21.297061716357359
                        ],
                        [
                            -157.81885932295484,
                            21.297069802777568
                        ],
                        [
                            -157.81888355155195,
                            21.2970815904159
                        ],
                        [
                            -157.81888501064259,
                            21.297082599805726
                        ],
                        [
                            -157.81889093615115,
                            21.297086700324478
                        ],
                        [
                            -157.81890551073079,
                            21.297096786879877
                        ],
                        [
                            -157.81891026833415,
                            21.297101317346659
                        ],
                        [
                            -157.81891301594516,
                            21.297103932973631
                        ],
                        [
                            -157.81891100617216,
                            21.297105851223019
                        ],
                        [
                            -157.81892257966973,
                            21.297118141768433
                        ],
                        [
                            -157.81892526337145,
                            21.29711584701726
                        ],
                        [
                            -157.81893255960739,
                            21.297125863523352
                        ],
                        [
                            -157.81893320706641,
                            21.297126748872987
                        ],
                        [
                            -157.81893461157125,
                            21.297128678434657
                        ],
                        [
                            -157.81894624152801,
                            21.297144640755381
                        ],
                        [
                            -157.81895300927235,
                            21.297157220988957
                        ],
                        [
                            -157.81895733963478,
                            21.297169016236161
                        ],
                        [
                            -157.8189579009865,
                            21.297170544195769
                        ],
                        [
                            -157.81896379969217,
                            21.297197665634201
                        ],
                        [
                            -157.81896402077211,
                            21.297200399039646
                        ],
                        [
                            -157.81896490525071,
                            21.297211312787915
                        ],
                        [
                            -157.81896537997181,
                            21.297217168285371
                        ],
                        [
                            -157.81896547129779,
                            21.297218285517378
                        ],
                        [
                            -157.81896587237614,
                            21.297223223556287
                        ],
                        [
                            -157.81896285640852,
                            21.297223187938098
                        ],
                        [
                            -157.81896274110341,
                            21.29723158685746
                        ],
                        [
                            -157.81896570332304,
                            21.297231593189984
                        ],
                        [
                            -157.81896520109888,
                            21.29724112405319
                        ],
                        [
                            -157.81896513624605,
                            21.297242363953782
                        ],
                        [
                            -157.81896495337648,
                            21.297245827174578
                        ],
                        [
                            -157.81896458059802,
                            21.297252910756814
                        ],
                        [
                            -157.81896454136086,
                            21.29725468474118
                        ],
                        [
                            -157.81896446793635,
                            21.297257962631463
                        ],
                        [
                            -157.81896442774973,
                            21.297259734802385
                        ],
                        [
                            -157.81896375869863,
                            21.297289542006649
                        ],
                        [
                            -157.81896368229243,
                            21.297292951771073
                        ],
                        [
                            -157.8189634187421,
                            21.297304703037032
                        ],
                        [
                            -157.81895984971032,
                            21.297304635532591
                        ],
                        [
                            -157.81895964117149,
                            21.297312759166775
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 276,
                "NUMBER": "1212",
                "PROPER_NAME": "ANDREWS OUTDOOR THEATRE",
                "DISPLAY_NAME": "ANDREWS OUTDOOR THEATRE - 1212",
                "ADDRESS": "DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ANDREWS OUTDOOR THEATRE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "Andrews Amphitheatre",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1212_01.jpg",
                "HEIGHT (ft)": null,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 223.52848980925293,
                "SHAPE_Area": 1240.6663733198566
            }
        },
        {
            "type": "Feature",
            "id": 277,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81398864815799,
                            21.300073249375764
                        ],
                        [
                            -157.81401198140236,
                            21.300072527593112
                        ],
                        [
                            -157.81401183757274,
                            21.300068467650888
                        ],
                        [
                            -157.81401832004317,
                            21.300068267613963
                        ],
                        [
                            -157.81402092152263,
                            21.300068186574897
                        ],
                        [
                            -157.81402939993626,
                            21.300067924719109
                        ],
                        [
                            -157.81402900042116,
                            21.300056565395327
                        ],
                        [
                            -157.81403343202584,
                            21.300056424079102
                        ],
                        [
                            -157.81403266155652,
                            21.300034590954393
                        ],
                        [
                            -157.81402823095269,
                            21.300034727760739
                        ],
                        [
                            -157.81402784556991,
                            21.30002376964141
                        ],
                        [
                            -157.81401006298631,
                            21.300024367031391
                        ],
                        [
                            -157.81400990431376,
                            21.300020234713394
                        ],
                        [
                            -157.81398658215184,
                            21.300021018004678
                        ],
                        [
                            -157.81398677072008,
                            21.30002514872659
                        ],
                        [
                            -157.81396908167378,
                            21.30002574225448
                        ],
                        [
                            -157.81396955408113,
                            21.300036786809088
                        ],
                        [
                            -157.81396512517313,
                            21.300036952534171
                        ],
                        [
                            -157.81396606098608,
                            21.300058841930838
                        ],
                        [
                            -157.8139704908659,
                            21.300058675309209
                        ],
                        [
                            -157.81397096317184,
                            21.300069732510511
                        ],
                        [
                            -157.81398850432896,
                            21.300069189433561
                        ],
                        [
                            -157.81398864815799,
                            21.300073249375764
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 277,
                "NUMBER": "1256",
                "PROPER_NAME": "THAI PAVILION",
                "DISPLAY_NAME": "THAI PAVILION - 1256",
                "ADDRESS": "1811 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE KUAHINE COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1256_01.jpg",
                "HEIGHT (ft)": 18.199999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 25.586601313590648,
                "SHAPE_Area": 34.119244436622367
            }
        },
        {
            "type": "Feature",
            "id": 278,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81436764787807,
                            21.30129520663677
                        ],
                        [
                            -157.81441179959538,
                            21.301293896126747
                        ],
                        [
                            -157.81444203154484,
                            21.301263710971977
                        ],
                        [
                            -157.81444063214931,
                            21.301222334009523
                        ],
                        [
                            -157.81440842303303,
                            21.301194003545021
                        ],
                        [
                            -157.81436427037445,
                            21.301195314952107
                        ],
                        [
                            -157.81433403939576,
                            21.301225499196523
                        ],
                        [
                            -157.81433543779744,
                            21.301266876151672
                        ],
                        [
                            -157.81436764787807,
                            21.30129520663677
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 278,
                "NUMBER": "1076A",
                "PROPER_NAME": "KOREAN STUDIES PAVILION",
                "DISPLAY_NAME": "KOREAN STUDIES PAVILION - 1076A",
                "ADDRESS": "1881 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CENTER FOR KOREAN STUDIES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1076A_01.jpg",
                "HEIGHT (ft)": 37.399999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 36.660708531555336,
                "SHAPE_Area": 101.39753921783014
            }
        },
        {
            "type": "Feature",
            "id": 279,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81555148920452,
                            21.30250506425946
                        ],
                        [
                            -157.81555345045001,
                            21.302505005793467
                        ],
                        [
                            -157.81555316487407,
                            21.302496735962364
                        ],
                        [
                            -157.81561199089901,
                            21.302494952983476
                        ],
                        [
                            -157.81561227648544,
                            21.302503221911284
                        ],
                        [
                            -157.81561423773815,
                            21.302503162541242
                        ],
                        [
                            -157.8156134375098,
                            21.302479962382268
                        ],
                        [
                            -157.8156163784208,
                            21.302479873772032
                        ],
                        [
                            -157.81561631410347,
                            21.302478035825008
                        ],
                        [
                            -157.81561239255544,
                            21.302478155475285
                        ],
                        [
                            -157.81561220345213,
                            21.302472642564648
                        ],
                        [
                            -157.81561612499277,
                            21.302472523817709
                        ],
                        [
                            -157.81561606163936,
                            21.302470685877466
                        ],
                        [
                            -157.81561311976458,
                            21.30247077448092
                        ],
                        [
                            -157.81561231952907,
                            21.302447575225209
                        ],
                        [
                            -157.81561035731315,
                            21.302447634588496
                        ],
                        [
                            -157.8156106428996,
                            21.302455903516339
                        ],
                        [
                            -157.81555181688296,
                            21.302457687398835
                        ],
                        [
                            -157.81555153130711,
                            21.302449417567711
                        ],
                        [
                            -157.81554957004789,
                            21.302449477840391
                        ],
                        [
                            -157.81555037124474,
                            21.302472676199386
                        ],
                        [
                            -157.81554743031941,
                            21.302472766615146
                        ],
                        [
                            -157.81554749367919,
                            21.302474603652037
                        ],
                        [
                            -157.81555141521986,
                            21.302474484906607
                        ],
                        [
                            -157.81555160529206,
                            21.302479996920653
                        ],
                        [
                            -157.81554768374403,
                            21.302480116569416
                        ],
                        [
                            -157.81554774710381,
                            21.302481953606303
                        ],
                        [
                            -157.81555068801484,
                            21.302481864997223
                        ],
                        [
                            -157.81555148920452,
                            21.30250506425946
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 279,
                "NUMBER": "1198D",
                "PROPER_NAME": "POPE LAB TRANSFORMER VAULT",
                "DISPLAY_NAME": "POPE LAB TRANSFORMER VAULT - 1198D",
                "ADDRESS": "3190 MAILE WAY",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "POPE LABORATORY COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "ST. JOHN TRANSFORMER VAULT 1",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1198D_01.jpg",
                "HEIGHT (ft)": 10.700000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 31.851185657359427,
                "SHAPE_Area": 29.037246866238366
            }
        },
        {
            "type": "Feature",
            "id": 280,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81555676853236,
                            21.302619866218347
                        ],
                        [
                            -157.81554489542893,
                            21.302620164777114
                        ],
                        [
                            -157.81552356901906,
                            21.302620862940763
                        ],
                        [
                            -157.81552399502803,
                            21.302632298333705
                        ],
                        [
                            -157.81552450040883,
                            21.302648624332722
                        ],
                        [
                            -157.81554582877328,
                            21.302648043623531
                        ],
                        [
                            -157.81555552584518,
                            21.302647780337526
                        ],
                        [
                            -157.81557193190636,
                            21.302647333910677
                        ],
                        [
                            -157.81557106867905,
                            21.302619486273013
                        ],
                        [
                            -157.81555676853236,
                            21.302619866218347
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 280,
                "NUMBER": "1135",
                "PROPER_NAME": "MID PAC POTTING HOUSE",
                "DISPLAY_NAME": "MID PAC POTTING HOUSE - 1135",
                "ADDRESS": "EDMONDSON ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "POPE LABORATORY COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1135_01.jpg",
                "HEIGHT (ft)": 10,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 16.010961207319792,
                "SHAPE_Area": 15.182720938179228
            }
        },
        {
            "type": "Feature",
            "id": 281,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81693556255539,
                            21.293475699710349
                        ],
                        [
                            -157.81693445421286,
                            21.293476639577449
                        ],
                        [
                            -157.81694011192621,
                            21.29348249988864
                        ],
                        [
                            -157.81694616995443,
                            21.293477363326936
                        ],
                        [
                            -157.8169449347894,
                            21.293476082671614
                        ],
                        [
                            -157.81695815920136,
                            21.293464867873631
                        ],
                        [
                            -157.81696195590138,
                            21.29346164867448
                        ],
                        [
                            -157.81702320489316,
                            21.293409709567648
                        ],
                        [
                            -157.8170242737298,
                            21.293410815602446
                        ],
                        [
                            -157.81703033079555,
                            21.293405678127304
                        ],
                        [
                            -157.81702467211738,
                            21.293399817812293
                        ],
                        [
                            -157.81702247386411,
                            21.29340168322307
                        ],
                        [
                            -157.81699026657196,
                            21.293368324111782
                        ],
                        [
                            -157.81699228041444,
                            21.293366616402164
                        ],
                        [
                            -157.81698662270313,
                            21.293360756092778
                        ],
                        [
                            -157.81698460789684,
                            21.293362463795539
                        ],
                        [
                            -157.81696310800962,
                            21.293340195878624
                        ],
                        [
                            -157.81696061472888,
                            21.293337611822157
                        ],
                        [
                            -157.81695139584613,
                            21.293328064136794
                        ],
                        [
                            -157.81695310202568,
                            21.293326618055431
                        ],
                        [
                            -157.81694744431746,
                            21.293320757744826
                        ],
                        [
                            -157.81694573813073,
                            21.293322204729488
                        ],
                        [
                            -157.81691169435521,
                            21.293286944610191
                        ],
                        [
                            -157.8169132695208,
                            21.293285608725462
                        ],
                        [
                            -157.81690761180849,
                            21.293279749316991
                        ],
                        [
                            -157.81690603665015,
                            21.293281084298332
                        ],
                        [
                            -157.81687355980645,
                            21.293247446834201
                        ],
                        [
                            -157.81687476325899,
                            21.293246426330739
                        ],
                        [
                            -157.81686910555689,
                            21.29324056601773
                        ],
                        [
                            -157.81686304752904,
                            21.293245703480466
                        ],
                        [
                            -157.81686470142543,
                            21.293247417996881
                        ],
                        [
                            -157.81678650412729,
                            21.293313730110096
                        ],
                        [
                            -157.81678491044272,
                            21.29331208015693
                        ],
                        [
                            -157.8167788524018,
                            21.29331721851965
                        ],
                        [
                            -157.81678451107399,
                            21.293323077939029
                        ],
                        [
                            -157.81678654335479,
                            21.293321355003904
                        ],
                        [
                            -157.81681918939861,
                            21.293355168931523
                        ],
                        [
                            -157.81681746573744,
                            21.293356631149617
                        ],
                        [
                            -157.81682312440546,
                            21.293362491471168
                        ],
                        [
                            -157.81682484806666,
                            21.293361029253013
                        ],
                        [
                            -157.81682905072867,
                            21.29336538061483
                        ],
                        [
                            -157.81683170174759,
                            21.293368128392235
                        ],
                        [
                            -157.81684402864445,
                            21.293380894126326
                        ],
                        [
                            -157.81685868629975,
                            21.293396075647891
                        ],
                        [
                            -157.81685708493401,
                            21.293397433029241
                        ],
                        [
                            -157.81686274167015,
                            21.293403294239369
                        ],
                        [
                            -157.816864344007,
                            21.293401935961398
                        ],
                        [
                            -157.81689777880186,
                            21.293436566663726
                        ],
                        [
                            -157.81689636280353,
                            21.293437767254922
                        ],
                        [
                            -157.81690202051385,
                            21.293443627567278
                        ],
                        [
                            -157.81690343748332,
                            21.293442426079455
                        ],
                        [
                            -157.81693556255539,
                            21.293475699710349
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 281,
                "NUMBER": "1116",
                "PROPER_NAME": "CHING FIELD - EQUIPMENT STORAGE FACILITY",
                "DISPLAY_NAME": "CHING FIELD - EQUIPMENT STORAGE FACILITY - 1116",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CLARENCE TC CHING ATHLETICS COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "The Barn",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1116_01.jpg",
                "HEIGHT (ft)": 22.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 79.430606588612179,
                "SHAPE_Area": 299.27433074587532
            }
        },
        {
            "type": "Feature",
            "id": 283,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81383336580214,
                            21.293527588035417
                        ],
                        [
                            -157.81391498966431,
                            21.293593407838706
                        ],
                        [
                            -157.81392240931541,
                            21.293599391778898
                        ],
                        [
                            -157.81392368612526,
                            21.293598001424492
                        ],
                        [
                            -157.81391775002024,
                            21.293593214089011
                        ],
                        [
                            -157.81392541186452,
                            21.293584869259352
                        ],
                        [
                            -157.81392504025325,
                            21.293584570328939
                        ],
                        [
                            -157.81394100187282,
                            21.29356718413278
                        ],
                        [
                            -157.81394227964608,
                            21.293565793784978
                        ],
                        [
                            -157.81396590310118,
                            21.293540062755195
                        ],
                        [
                            -157.81396717991731,
                            21.29353867149706
                        ],
                        [
                            -157.81399080432035,
                            21.293512941373415
                        ],
                        [
                            -157.81399208112879,
                            21.293511551018405
                        ],
                        [
                            -157.81401570360251,
                            21.293485819973871
                        ],
                        [
                            -157.81401698137438,
                            21.293484429625423
                        ],
                        [
                            -157.81404060480327,
                            21.293458698583695
                        ],
                        [
                            -157.81404188161801,
                            21.293457307324921
                        ],
                        [
                            -157.81404530848405,
                            21.293453575173011
                        ],
                        [
                            -157.81405129674812,
                            21.293447053330947
                        ],
                        [
                            -157.81406550599479,
                            21.293431577189324
                        ],
                        [
                            -157.81406678183794,
                            21.293430186826882
                        ],
                        [
                            -157.81407716940845,
                            21.293418872778794
                        ],
                        [
                            -157.81407807864176,
                            21.293417881841975
                        ],
                        [
                            -157.81409040524935,
                            21.293404455777193
                        ],
                        [
                            -157.81409168206315,
                            21.293403064517971
                        ],
                        [
                            -157.81410764459261,
                            21.293385680117282
                        ],
                        [
                            -157.81410801524714,
                            21.293385978137159
                        ],
                        [
                            -157.81411567706976,
                            21.293377633297631
                        ],
                        [
                            -157.81412606573855,
                            21.293386010448287
                        ],
                        [
                            -157.81412734255184,
                            21.293384619188789
                        ],
                        [
                            -157.81415096593821,
                            21.293358889032952
                        ],
                        [
                            -157.8141522437077,
                            21.293357498683367
                        ],
                        [
                            -157.81417586612869,
                            21.293331767613438
                        ],
                        [
                            -157.81417714293383,
                            21.293330377256829
                        ],
                        [
                            -157.81420076727386,
                            21.293304646196496
                        ],
                        [
                            -157.81420204408576,
                            21.293303254936351
                        ],
                        [
                            -157.81422566744592,
                            21.293277524768573
                        ],
                        [
                            -157.81422694425009,
                            21.293276134411553
                        ],
                        [
                            -157.81425056760881,
                            21.293250403336472
                        ],
                        [
                            -157.81425184441974,
                            21.293249012075879
                        ],
                        [
                            -157.81424108510544,
                            21.293240336010044
                        ],
                        [
                            -157.81426470941958,
                            21.293214604939276
                        ],
                        [
                            -157.81426598525897,
                            21.293213214575101
                        ],
                        [
                            -157.81428960859324,
                            21.293187484396903
                        ],
                        [
                            -157.81429088636719,
                            21.293186093142765
                        ],
                        [
                            -157.81430684790001,
                            21.293168706907075
                        ],
                        [
                            -157.81430721853994,
                            21.293169006733191
                        ],
                        [
                            -157.81431488034715,
                            21.293160660979996
                        ],
                        [
                            -157.81432081644914,
                            21.293165448301497
                        ],
                        [
                            -157.81432209421533,
                            21.293164057950438
                        ],
                        [
                            -157.81431467361139,
                            21.293158073117684
                        ],
                        [
                            -157.81430318065841,
                            21.293148806491377
                        ],
                        [
                            -157.81429820805312,
                            21.29314479564453
                        ],
                        [
                            -157.81423304979106,
                            21.29309225350784
                        ],
                        [
                            -157.81421820857656,
                            21.293080286544775
                        ],
                        [
                            -157.8142169317741,
                            21.293081676901842
                        ],
                        [
                            -157.81423028848079,
                            21.293092447256381
                        ],
                        [
                            -157.81422262667274,
                            21.293100793005728
                        ],
                        [
                            -157.81422299828344,
                            21.293101091935473
                        ],
                        [
                            -157.81420703578499,
                            21.293118478156419
                        ],
                        [
                            -157.81420687630964,
                            21.29311865138731
                        ],
                        [
                            -157.81419611700721,
                            21.293109975319034
                        ],
                        [
                            -157.81417121589593,
                            21.293137096737372
                        ],
                        [
                            -157.81415216157345,
                            21.293121731346623
                        ],
                        [
                            -157.81414821375796,
                            21.293118547089829
                        ],
                        [
                            -157.81413831729495,
                            21.293129326182999
                        ],
                        [
                            -157.81416132136101,
                            21.293147875845488
                        ],
                        [
                            -157.8141204586841,
                            21.293192383476509
                        ],
                        [
                            -157.81413084638407,
                            21.293200759716331
                        ],
                        [
                            -157.8141097814935,
                            21.293223703772512
                        ],
                        [
                            -157.81410581395409,
                            21.293228025644307
                        ],
                        [
                            -157.81407978672158,
                            21.293256374047967
                        ],
                        [
                            -157.81404556553917,
                            21.293228780101426
                        ],
                        [
                            -157.81403681556125,
                            21.293238310649784
                        ],
                        [
                            -157.8140606471155,
                            21.293257528340998
                        ],
                        [
                            -157.81404671404968,
                            21.293272704696683
                        ],
                        [
                            -157.81404185575499,
                            21.293277996855743
                        ],
                        [
                            -157.81394072135456,
                            21.293388151927257
                        ],
                        [
                            -157.81391775627679,
                            21.293413163978403
                        ],
                        [
                            -157.813880231833,
                            21.293454035432934
                        ],
                        [
                            -157.81387004048116,
                            21.293445815944409
                        ],
                        [
                            -157.81386110950959,
                            21.293438614423387
                        ],
                        [
                            -157.81385834258361,
                            21.293436383427082
                        ],
                        [
                            -157.81384908496801,
                            21.293446466875594
                        ],
                        [
                            -157.81385737520148,
                            21.293453152563426
                        ],
                        [
                            -157.81386078285848,
                            21.293455900296902
                        ],
                        [
                            -157.8138709742249,
                            21.293464117979326
                        ],
                        [
                            -157.81384655335697,
                            21.293490718761639
                        ],
                        [
                            -157.8138573126642,
                            21.29349939485223
                        ],
                        [
                            -157.81385715221691,
                            21.293499568979268
                        ],
                        [
                            -157.81384119059564,
                            21.293516955167512
                        ],
                        [
                            -157.81384081995589,
                            21.293516655340383
                        ],
                        [
                            -157.81383315811078,
                            21.293525000166202
                        ],
                        [
                            -157.81381980139733,
                            21.293514229780207
                        ],
                        [
                            -157.8138185255512,
                            21.293515620140621
                        ],
                        [
                            -157.81383336580214,
                            21.293527588035417
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 283,
                "NUMBER": "1123A",
                "PROPER_NAME": "HALE NOELANI TOWER A",
                "DISPLAY_NAME": "HALE NOELANI TOWER A - 1123A",
                "ADDRESS": "2585 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE NOELANI TOWERS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1123A_01.jpg",
                "HEIGHT (ft)": 42.700000000000003,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 188.61245133799071,
                "SHAPE_Area": 844.67951224166268
            }
        },
        {
            "type": "Feature",
            "id": 284,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8138101272425,
                            21.293484679473782
                        ],
                        [
                            -157.81380964783548,
                            21.293485200965044
                        ],
                        [
                            -157.81381187459391,
                            21.293486996335186
                        ],
                        [
                            -157.81381837535275,
                            21.293479915301418
                        ],
                        [
                            -157.8138172624555,
                            21.293479017619781
                        ],
                        [
                            -157.81383943600648,
                            21.293454866356974
                        ],
                        [
                            -157.81384797206357,
                            21.293445570097514
                        ],
                        [
                            -157.81384908496801,
                            21.293446466875594
                        ],
                        [
                            -157.81385738473412,
                            21.293437426416702
                        ],
                        [
                            -157.81385834258361,
                            21.293436383427082
                        ],
                        [
                            -157.8138606550342,
                            21.293433865712956
                        ],
                        [
                            -157.81389426731118,
                            21.293397261412402
                        ],
                        [
                            -157.81388282515709,
                            21.293388032154862
                        ],
                        [
                            -157.81386978549037,
                            21.293377514246139
                        ],
                        [
                            -157.81383616742178,
                            21.293414119404396
                        ],
                        [
                            -157.81383385497114,
                            21.293416637118181
                        ],
                        [
                            -157.81382601583937,
                            21.29341031506074
                        ],
                        [
                            -157.81379118843245,
                            21.293382230767627
                        ],
                        [
                            -157.81380813316454,
                            21.293363775573887
                        ],
                        [
                            -157.81381719823924,
                            21.293353901260488
                        ],
                        [
                            -157.8138322107358,
                            21.29333754999411
                        ],
                        [
                            -157.81384222777442,
                            21.293345628230863
                        ],
                        [
                            -157.8138710012351,
                            21.293314288218983
                        ],
                        [
                            -157.8138806476278,
                            21.293322067529783
                        ],
                        [
                            -157.81388016918547,
                            21.293322589028087
                        ],
                        [
                            -157.81388128208198,
                            21.293323486709284
                        ],
                        [
                            -157.81388142309191,
                            21.293323332319826
                        ],
                        [
                            -157.8139019638808,
                            21.293300960060925
                        ],
                        [
                            -157.81395036206305,
                            21.293248244983946
                        ],
                        [
                            -157.8140691450815,
                            21.293118866335082
                        ],
                        [
                            -157.81407022837709,
                            21.293117686009186
                        ],
                        [
                            -157.81409305335052,
                            21.293092826522805
                        ],
                        [
                            -157.81411605644848,
                            21.293111375280887
                        ],
                        [
                            -157.81411395113346,
                            21.293113667707331
                        ],
                        [
                            -157.81411506402998,
                            21.293114565387
                        ],
                        [
                            -157.8141155434347,
                            21.293114043894743
                        ],
                        [
                            -157.81413557848791,
                            21.293130199437865
                        ],
                        [
                            -157.81413510004708,
                            21.293130720936972
                        ],
                        [
                            -157.81413621294385,
                            21.29313161861651
                        ],
                        [
                            -157.81413831729495,
                            21.293129326182999
                        ],
                        [
                            -157.81414821375796,
                            21.293118547089829
                        ],
                        [
                            -157.81417829016934,
                            21.293085787939468
                        ],
                        [
                            -157.81417940305883,
                            21.293086686522045
                        ],
                        [
                            -157.81418618287316,
                            21.293079301188921
                        ],
                        [
                            -157.81418395611581,
                            21.2930775058237
                        ],
                        [
                            -157.8141831946927,
                            21.293078336095693
                        ],
                        [
                            -157.81416315964071,
                            21.293062180558209
                        ],
                        [
                            -157.81416392202775,
                            21.293061350293115
                        ],
                        [
                            -157.81416169623483,
                            21.293059554934413
                        ],
                        [
                            -157.81415491545644,
                            21.293066940259759
                        ],
                        [
                            -157.81415602836015,
                            21.293067837035824
                        ],
                        [
                            -157.81412595194789,
                            21.293100596182231
                        ],
                        [
                            -157.81409936018918,
                            21.29307915297597
                        ],
                        [
                            -157.81409631744245,
                            21.293076698709829
                        ],
                        [
                            -157.81408217252863,
                            21.293065292225698
                        ],
                        [
                            -157.81410707364276,
                            21.293038170820491
                        ],
                        [
                            -157.81409631435213,
                            21.2930294947463
                        ],
                        [
                            -157.8140964738275,
                            21.293029321515515
                        ],
                        [
                            -157.81411243536434,
                            21.293011935298235
                        ],
                        [
                            -157.81411280697455,
                            21.293012234228204
                        ],
                        [
                            -157.81412046781256,
                            21.293003889380387
                        ],
                        [
                            -157.81413382450503,
                            21.293014659742031
                        ],
                        [
                            -157.81413510130764,
                            21.293013269385575
                        ],
                        [
                            -157.8140356789626,
                            21.29293309680498
                        ],
                        [
                            -157.81403529682967,
                            21.292932787863428
                        ],
                        [
                            -157.81403439846801,
                            21.292932063338917
                        ],
                        [
                            -157.81403121684633,
                            21.292929497879694
                        ],
                        [
                            -157.81402994004355,
                            21.29293088823534
                        ],
                        [
                            -157.81403587612698,
                            21.292935675566177
                        ],
                        [
                            -157.81402821528815,
                            21.292944020410133
                        ],
                        [
                            -157.81402858593421,
                            21.292944319333479
                        ],
                        [
                            -157.81402426540222,
                            21.292949026271071
                        ],
                        [
                            -157.81402161358167,
                            21.292951913793676
                        ],
                        [
                            -157.81401262439564,
                            21.292961705542837
                        ],
                        [
                            -157.81401134758516,
                            21.292963096801653
                        ],
                        [
                            -157.81400795089334,
                            21.292966793933871
                        ],
                        [
                            -157.81398772328581,
                            21.292988826030747
                        ],
                        [
                            -157.8139864464676,
                            21.292990218192706
                        ],
                        [
                            -157.81396676536792,
                            21.293011654286278
                        ],
                        [
                            -157.81396282311616,
                            21.293015948327941
                        ],
                        [
                            -157.81396154534806,
                            21.293017338676222
                        ],
                        [
                            -157.81398232358376,
                            21.293034093000287
                        ],
                        [
                            -157.81395869925308,
                            21.293059824031022
                        ],
                        [
                            -157.81395742244121,
                            21.293061215289352
                        ],
                        [
                            -157.81393379906564,
                            21.293086946322877
                        ],
                        [
                            -157.81393252226056,
                            21.293088336677673
                        ],
                        [
                            -157.81390889888354,
                            21.293114066803881
                        ],
                        [
                            -157.81390762207795,
                            21.293115457158443
                        ],
                        [
                            -157.81388399772106,
                            21.293141188177234
                        ],
                        [
                            -157.8138827209078,
                            21.293142579434917
                        ],
                        [
                            -157.81386675933743,
                            21.293159964724886
                        ],
                        [
                            -157.81386638772733,
                            21.293159665794406
                        ],
                        [
                            -157.81385872686707,
                            21.29316801062944
                        ],
                        [
                            -157.81384240213615,
                            21.293154847029378
                        ],
                        [
                            -157.81384112436575,
                            21.293156237376589
                        ],
                        [
                            -157.81384706045134,
                            21.293161024714099
                        ],
                        [
                            -157.81382343801164,
                            21.293186754833652
                        ],
                        [
                            -157.81382216120466,
                            21.293188145187486
                        ],
                        [
                            -157.81379853682122,
                            21.293213876192826
                        ],
                        [
                            -157.81379726000654,
                            21.293215267449781
                        ],
                        [
                            -157.81377363754211,
                            21.293240998464714
                        ],
                        [
                            -157.8137636195504,
                            21.293232920217491
                        ],
                        [
                            -157.81376234177856,
                            21.293234310564028
                        ],
                        [
                            -157.81373871931237,
                            21.293260040670251
                        ],
                        [
                            -157.81373744249669,
                            21.293261431926702
                        ],
                        [
                            -157.81371381808677,
                            21.293287162918677
                        ],
                        [
                            -157.81371254127785,
                            21.293288553271594
                        ],
                        [
                            -157.81371045928313,
                            21.293290821465405
                        ],
                        [
                            -157.81369657967164,
                            21.293305938543462
                        ],
                        [
                            -157.81369620902547,
                            21.29330563961938
                        ],
                        [
                            -157.81368854622022,
                            21.293313984432157
                        ],
                        [
                            -157.81368261013418,
                            21.293309197089116
                        ],
                        [
                            -157.81368133331756,
                            21.293310588345086
                        ],
                        [
                            -157.81378521878213,
                            21.293394360976638
                        ],
                        [
                            -157.81379062881209,
                            21.293408848824882
                        ],
                        [
                            -157.81380037098603,
                            21.293416704700018
                        ],
                        [
                            -157.81382068857658,
                            21.29343308811891
                        ],
                        [
                            -157.81380073315478,
                            21.293454823987851
                        ],
                        [
                            -157.81379500063599,
                            21.293461066668499
                        ],
                        [
                            -157.81379388773902,
                            21.293460168986716
                        ],
                        [
                            -157.81378738794382,
                            21.293467250026332
                        ],
                        [
                            -157.81378961374506,
                            21.293469044486638
                        ],
                        [
                            -157.81379009218821,
                            21.29346852298864
                        ],
                        [
                            -157.8138101272425,
                            21.293484679473782
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 284,
                "NUMBER": "1123B",
                "PROPER_NAME": "HALE NOELANI TOWER B",
                "DISPLAY_NAME": "HALE NOELANI TOWER B - 1123B",
                "ADDRESS": "2585 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE NOELANI TOWERS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1123B_01.jpg",
                "HEIGHT (ft)": 42.399999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 225.23937806328786,
                "SHAPE_Area": 833.24318172584367
            }
        },
        {
            "type": "Feature",
            "id": 285,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82109357282607,
                            21.303908466885325
                        ],
                        [
                            -157.82114161548154,
                            21.303921491607841
                        ],
                        [
                            -157.82114418341868,
                            21.303913177626445
                        ],
                        [
                            -157.82115401875748,
                            21.303903931671808
                        ],
                        [
                            -157.82115862720519,
                            21.30388900922858
                        ],
                        [
                            -157.82115558922058,
                            21.303876128177283
                        ],
                        [
                            -157.82116039660406,
                            21.303860557589704
                        ],
                        [
                            -157.821160856771,
                            21.303859065701964
                        ],
                        [
                            -157.82116278252258,
                            21.303852825019689
                        ],
                        [
                            -157.82116319912228,
                            21.303851477369232
                        ],
                        [
                            -157.82117230224839,
                            21.303822237859798
                        ],
                        [
                            -157.82117287362789,
                            21.30382239363249
                        ],
                        [
                            -157.82117349607768,
                            21.303820377108231
                        ],
                        [
                            -157.82117517439633,
                            21.303814942323573
                        ],
                        [
                            -157.82117194424052,
                            21.303814065989133
                        ],
                        [
                            -157.8211778569908,
                            21.303794913973469
                        ],
                        [
                            -157.82117869910303,
                            21.303792188922966
                        ],
                        [
                            -157.82118376080439,
                            21.303775794416964
                        ],
                        [
                            -157.82118511904969,
                            21.303776162578732
                        ],
                        [
                            -157.82118635106391,
                            21.30377217370593
                        ],
                        [
                            -157.82118493990913,
                            21.303771791622637
                        ],
                        [
                            -157.82119655657965,
                            21.303734166379872
                        ],
                        [
                            -157.82119791770927,
                            21.303734535465118
                        ],
                        [
                            -157.82119915072269,
                            21.303730542082228
                        ],
                        [
                            -157.82119486244369,
                            21.303729379187612
                        ],
                        [
                            -157.82119445967874,
                            21.303730684475756
                        ],
                        [
                            -157.82114731264818,
                            21.303717900926696
                        ],
                        [
                            -157.82114773221153,
                            21.3037165442631
                        ],
                        [
                            -157.82114349876358,
                            21.303715396205604
                        ],
                        [
                            -157.82114339881682,
                            21.303715719822634
                        ],
                        [
                            -157.82114329591334,
                            21.30371605154949
                        ],
                        [
                            -157.82114225884976,
                            21.303719408510897
                        ],
                        [
                            -157.82113744606625,
                            21.303735052235112
                        ],
                        [
                            -157.82113641195912,
                            21.303738401086658
                        ],
                        [
                            -157.82113620416652,
                            21.303739071753558
                        ],
                        [
                            -157.82113690157166,
                            21.303739260027967
                        ],
                        [
                            -157.8211347908117,
                            21.303746094748366
                        ],
                        [
                            -157.82113229108401,
                            21.303754196910937
                        ],
                        [
                            -157.82113215850507,
                            21.303754623285887
                        ],
                        [
                            -157.82113136288012,
                            21.30375720050576
                        ],
                        [
                            -157.82113068280447,
                            21.303757015062885
                        ],
                        [
                            -157.82113041562499,
                            21.303757879542715
                        ],
                        [
                            -157.82112178520055,
                            21.303755538918207
                        ],
                        [
                            -157.82111838899644,
                            21.30375203435915
                        ],
                        [
                            -157.82111725788999,
                            21.303750866480655
                        ],
                        [
                            -157.82111372113769,
                            21.303747216394292
                        ],
                        [
                            -157.82111071791286,
                            21.303744116597294
                        ],
                        [
                            -157.82109633226997,
                            21.303740215242232
                        ],
                        [
                            -157.82108051833563,
                            21.303744363027427
                        ],
                        [
                            -157.82107919524213,
                            21.303748651186925
                        ],
                        [
                            -157.82107539464442,
                            21.303747622697852
                        ],
                        [
                            -157.82106460522957,
                            21.303782568849925
                        ],
                        [
                            -157.82106378486293,
                            21.303785226297833
                        ],
                        [
                            -157.82103419033643,
                            21.303777178411504
                        ],
                        [
                            -157.8210377597612,
                            21.303765617435509
                        ],
                        [
                            -157.82103676512065,
                            21.303765348483054
                        ],
                        [
                            -157.82103339259683,
                            21.303764434109471
                        ],
                        [
                            -157.82102756810934,
                            21.303762855727761
                        ],
                        [
                            -157.82101792223543,
                            21.303760196313146
                        ],
                        [
                            -157.82101603684552,
                            21.303759686237655
                        ],
                        [
                            -157.82101157733635,
                            21.30375847787246
                        ],
                        [
                            -157.8210042019345,
                            21.303782370564637
                        ],
                        [
                            -157.82100371011245,
                            21.303783963409874
                        ],
                        [
                            -157.82100031387444,
                            21.303794961882687
                        ],
                        [
                            -157.82099950536954,
                            21.303797582374322
                        ],
                        [
                            -157.8209994687806,
                            21.303797697751961
                        ],
                        [
                            -157.82099632189534,
                            21.303807891243963
                        ],
                        [
                            -157.82099549657059,
                            21.303810565821159
                        ],
                        [
                            -157.82099469799337,
                            21.303813150246711
                        ],
                        [
                            -157.82099390035847,
                            21.303815737389002
                        ],
                        [
                            -157.82099310177401,
                            21.303818322717873
                        ],
                        [
                            -157.82099230318951,
                            21.303820908046724
                        ],
                        [
                            -157.82099150555453,
                            21.303823495189015
                        ],
                        [
                            -157.82099070696998,
                            21.303826080517872
                        ],
                        [
                            -157.82098939775048,
                            21.303830320894015
                        ],
                        [
                            -157.82098692576085,
                            21.30383832839231
                        ],
                        [
                            -157.82098608857274,
                            21.30384103992532
                        ],
                        [
                            -157.82098503567045,
                            21.303844448267824
                        ],
                        [
                            -157.82099432887259,
                            21.303846967897936
                        ],
                        [
                            -157.82102394668945,
                            21.303854997887036
                        ],
                        [
                            -157.82101412307128,
                            21.30388681784288
                        ],
                        [
                            -157.82105784567608,
                            21.303898672239598
                        ],
                        [
                            -157.82106555347403,
                            21.30390609700984
                        ],
                        [
                            -157.82107896759643,
                            21.303909733191368
                        ],
                        [
                            -157.82108961545231,
                            21.303907393031832
                        ],
                        [
                            -157.82109357282607,
                            21.303908466885325
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 285,
                "NUMBER": "1185",
                "PROPER_NAME": "COLLEGE HILL",
                "DISPLAY_NAME": "COLLEGE HILL - 1185",
                "ADDRESS": "2234 KAMEHAMEHA AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "COLLEGE HILL AND COTTAGE",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1185_01.jpg",
                "HEIGHT (ft)": 40,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 84.874311945540313,
                "SHAPE_Area": 298.57433291350264
            }
        },
        {
            "type": "Feature",
            "id": 286,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80834599497908,
                            21.307990859291969
                        ],
                        [
                            -157.8083739460757,
                            21.307972587523555
                        ],
                        [
                            -157.80837815283775,
                            21.307978240002591
                        ],
                        [
                            -157.80840429453963,
                            21.307961150594053
                        ],
                        [
                            -157.80840008488508,
                            21.307955498095147
                        ],
                        [
                            -157.8084280350046,
                            21.307937226310237
                        ],
                        [
                            -157.8084033455859,
                            21.307904062446788
                        ],
                        [
                            -157.80841621580754,
                            21.307895650021006
                        ],
                        [
                            -157.80837146722433,
                            21.307835540576821
                        ],
                        [
                            -157.80835859796247,
                            21.307843953909526
                        ],
                        [
                            -157.80830894073961,
                            21.307777249283109
                        ],
                        [
                            -157.80832180998351,
                            21.307768837760648
                        ],
                        [
                            -157.80827706147576,
                            21.30770872829406
                        ],
                        [
                            -157.80826419222763,
                            21.307717140716598
                        ],
                        [
                            -157.80823936364891,
                            21.307683788844255
                        ],
                        [
                            -157.80821141355733,
                            21.307702060599524
                        ],
                        [
                            -157.80820720488126,
                            21.307696408103155
                        ],
                        [
                            -157.80818106417794,
                            21.307713496586203
                        ],
                        [
                            -157.80818527285345,
                            21.307719149083201
                        ],
                        [
                            -157.80815732274874,
                            21.307737420828765
                        ],
                        [
                            -157.80818271208702,
                            21.307771526496552
                        ],
                        [
                            -157.8081790932894,
                            21.307773893932914
                        ],
                        [
                            -157.80822271927593,
                            21.307832494946268
                        ],
                        [
                            -157.80822633806713,
                            21.30783012841237
                        ],
                        [
                            -157.80827711874574,
                            21.307898339739594
                        ],
                        [
                            -157.80827349898959,
                            21.307900706267702
                        ],
                        [
                            -157.80831712601363,
                            21.307959307266064
                        ],
                        [
                            -157.80832074576333,
                            21.307956941640398
                        ],
                        [
                            -157.80834599497908,
                            21.307990859291969
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 286,
                "NUMBER": "9620A1",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING G",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING G - 9620A1",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING G",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620A1_01.jpg",
                "HEIGHT (ft)": 36,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 100.56179849725751,
                "SHAPE_Area": 393.65410858876055
            }
        },
        {
            "type": "Feature",
            "id": 287,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80820081862964,
                            21.308115199361758
                        ],
                        [
                            -157.80822876880333,
                            21.308096927612848
                        ],
                        [
                            -157.80823297749086,
                            21.308102580108994
                        ],
                        [
                            -157.80825911730318,
                            21.308085490711427
                        ],
                        [
                            -157.80825490957903,
                            21.308079838222742
                        ],
                        [
                            -157.80828285877558,
                            21.308061566457308
                        ],
                        [
                            -157.80825746936711,
                            21.308027460802375
                        ],
                        [
                            -157.80826108911941,
                            21.308025095178138
                        ],
                        [
                            -157.8082174630789,
                            21.307966492365988
                        ],
                        [
                            -157.80821384332742,
                            21.307968857989334
                        ],
                        [
                            -157.80816306361322,
                            21.307900647553957
                        ],
                        [
                            -157.80816668240701,
                            21.30789828102148
                        ],
                        [
                            -157.80812305644002,
                            21.307839678187484
                        ],
                        [
                            -157.80811943764704,
                            21.307842044719077
                        ],
                        [
                            -157.80809418754481,
                            21.307808127029702
                        ],
                        [
                            -157.80806623741222,
                            21.307826398758642
                        ],
                        [
                            -157.80806202873859,
                            21.307820746258809
                        ],
                        [
                            -157.80803588991762,
                            21.307837835634231
                        ],
                        [
                            -157.80804009666269,
                            21.307843488121023
                        ],
                        [
                            -157.80801214651697,
                            21.307861759840254
                        ],
                        [
                            -157.80803683583818,
                            21.307894923756844
                        ],
                        [
                            -157.80802396655326,
                            21.307903337062758
                        ],
                        [
                            -157.80806871500917,
                            21.307963446593273
                        ],
                        [
                            -157.80808158333318,
                            21.307955033277281
                        ],
                        [
                            -157.80813124243321,
                            21.308021737981111
                        ],
                        [
                            -157.80811837314914,
                            21.308030150390522
                        ],
                        [
                            -157.8081631207165,
                            21.308090259891792
                        ],
                        [
                            -157.8081759900036,
                            21.308081847479141
                        ],
                        [
                            -157.80820081862964,
                            21.308115199361758
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 287,
                "NUMBER": "9620A3",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING E",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING E - 9620A3",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING E",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620A3_01.jpg",
                "HEIGHT (ft)": 33,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 100.56133273514136,
                "SHAPE_Area": 393.65544219052123
            }
        },
        {
            "type": "Feature",
            "id": 288,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80789679037588,
                            21.30834702977582
                        ],
                        [
                            -157.80792473966591,
                            21.308328758074904
                        ],
                        [
                            -157.80792894834752,
                            21.308334410578276
                        ],
                        [
                            -157.80795508919164,
                            21.308317322142148
                        ],
                        [
                            -157.8079508814734,
                            21.308311669646233
                        ],
                        [
                            -157.80797883075033,
                            21.308293397935643
                        ],
                        [
                            -157.8079541423447,
                            21.308260234016402
                        ],
                        [
                            -157.80796701166548,
                            21.308251820717821
                        ],
                        [
                            -157.80792226316402,
                            21.308191712063454
                        ],
                        [
                            -157.80790939385355,
                            21.308200124455457
                        ],
                        [
                            -157.8078597357655,
                            21.308133419696219
                        ],
                        [
                            -157.80787260410858,
                            21.30812500730098
                        ],
                        [
                            -157.8078278566538,
                            21.308064897727704
                        ],
                        [
                            -157.80781498637853,
                            21.308073311009377
                        ],
                        [
                            -157.80779015881319,
                            21.308039959080887
                        ],
                        [
                            -157.80776220860756,
                            21.30805822985166
                        ],
                        [
                            -157.80775799993987,
                            21.308052577344608
                        ],
                        [
                            -157.80773185911579,
                            21.308069666655086
                        ],
                        [
                            -157.80773606779019,
                            21.308075318259412
                        ],
                        [
                            -157.80770811852082,
                            21.308093590833995
                        ],
                        [
                            -157.80773350780132,
                            21.308127697469523
                        ],
                        [
                            -157.80772988900253,
                            21.308130063088694
                        ],
                        [
                            -157.80777351393104,
                            21.308188665109238
                        ],
                        [
                            -157.80777713370193,
                            21.308186298592673
                        ],
                        [
                            -157.80782791427953,
                            21.30825451004872
                        ],
                        [
                            -157.8078242945077,
                            21.308256876566315
                        ],
                        [
                            -157.80786792046641,
                            21.30831547947518
                        ],
                        [
                            -157.8078715402464,
                            21.308313112053369
                        ],
                        [
                            -157.80789679037588,
                            21.30834702977582
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 288,
                "NUMBER": "9620A4",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING D",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING D - 9620A4",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING D",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620A4_01.jpg",
                "HEIGHT (ft)": 34,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 100.56149588310201,
                "SHAPE_Area": 393.6547813024502
            }
        },
        {
            "type": "Feature",
            "id": 289,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80673286499231,
                            21.30794228977004
                        ],
                        [
                            -157.80676825508115,
                            21.307919202687945
                        ],
                        [
                            -157.80677721380803,
                            21.307931262302692
                        ],
                        [
                            -157.80684135730885,
                            21.307889415241679
                        ],
                        [
                            -157.80683239954288,
                            21.307877355637007
                        ],
                        [
                            -157.8069035808802,
                            21.307830918669353
                        ],
                        [
                            -157.80691253962084,
                            21.307842977373948
                        ],
                        [
                            -157.8069766839958,
                            21.307801132070825
                        ],
                        [
                            -157.80696772332411,
                            21.307789073355789
                        ],
                        [
                            -157.80700331589176,
                            21.307765853955491
                        ],
                        [
                            -157.80698385631536,
                            21.307739662283929
                        ],
                        [
                            -157.80698988823528,
                            21.307735726542131
                        ],
                        [
                            -157.80697169134379,
                            21.30771123135013
                        ],
                        [
                            -157.80696565942441,
                            21.307715167091292
                        ],
                        [
                            -157.80694620083239,
                            21.307688974519348
                        ],
                        [
                            -157.8069098058204,
                            21.307712718505503
                        ],
                        [
                            -157.80690728624091,
                            21.307709326487188
                        ],
                        [
                            -157.80684475161286,
                            21.307750123508864
                        ],
                        [
                            -157.80684727022751,
                            21.307753515521213
                        ],
                        [
                            -157.80677448014416,
                            21.307801001632214
                        ],
                        [
                            -157.80677196055919,
                            21.307797610515333
                        ],
                        [
                            -157.80670942488649,
                            21.307838408379254
                        ],
                        [
                            -157.80671194543461,
                            21.307841799503876
                        ],
                        [
                            -157.80667575000803,
                            21.307865411150356
                        ],
                        [
                            -157.8066952085793,
                            21.307891602848571
                        ],
                        [
                            -157.80668917664545,
                            21.307895538579047
                        ],
                        [
                            -157.80670737447352,
                            21.307920033806813
                        ],
                        [
                            -157.80671340640066,
                            21.307916098979057
                        ],
                        [
                            -157.80673286499231,
                            21.30794228977004
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 289,
                "NUMBER": "9620A5",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING O",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING O - 9620A5",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING O",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620A5_01.jpg",
                "HEIGHT (ft)": 34,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 100.49290434652157,
                "SHAPE_Area": 393.11629263361829
            }
        },
        {
            "type": "Feature",
            "id": 290,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80741489112421,
                            21.307439014072365
                        ],
                        [
                            -157.80745028099659,
                            21.307415925931441
                        ],
                        [
                            -157.80745924071675,
                            21.307427985518572
                        ],
                        [
                            -157.80752338380478,
                            21.307386139079075
                        ],
                        [
                            -157.80751442408152,
                            21.307374079495165
                        ],
                        [
                            -157.80758560594006,
                            21.30732764131826
                        ],
                        [
                            -157.80759456373877,
                            21.307339700884913
                        ],
                        [
                            -157.80765870771549,
                            21.307297854396598
                        ],
                        [
                            -157.80764974895703,
                            21.307285793923011
                        ],
                        [
                            -157.80768533935714,
                            21.307262576159342
                        ],
                        [
                            -157.8076658806884,
                            21.307236383666076
                        ],
                        [
                            -157.80767191256291,
                            21.30723244880113
                        ],
                        [
                            -157.80765371465523,
                            21.307207952768902
                        ],
                        [
                            -157.80764768278129,
                            21.307211887633233
                        ],
                        [
                            -157.80762822507504,
                            21.307185696949599
                        ],
                        [
                            -157.80759182836519,
                            21.307209441082005
                        ],
                        [
                            -157.80758930974145,
                            21.307206049080229
                        ],
                        [
                            -157.80752677550873,
                            21.30724684637665
                        ],
                        [
                            -157.80752929509561,
                            21.307250238386164
                        ],
                        [
                            -157.80745650546515,
                            21.307297725720336
                        ],
                        [
                            -157.80745398490797,
                            21.307294334606294
                        ],
                        [
                            -157.80739144964522,
                            21.307335130938331
                        ],
                        [
                            -157.80739397115823,
                            21.307338522963416
                        ],
                        [
                            -157.80735777690984,
                            21.307362136582448
                        ],
                        [
                            -157.80737723458805,
                            21.307388327295673
                        ],
                        [
                            -157.80737120269967,
                            21.307392262149332
                        ],
                        [
                            -157.80738940154393,
                            21.307416758217304
                        ],
                        [
                            -157.8073954334329,
                            21.307412823363023
                        ],
                        [
                            -157.80741489112421,
                            21.307439014072365
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 290,
                "NUMBER": "9620A6",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING M",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING M - 9620A6",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING M",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620A6_01.jpg",
                "HEIGHT (ft)": 37,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 100.49311538104976,
                "SHAPE_Area": 393.11748671354019
            }
        },
        {
            "type": "Feature",
            "id": 291,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80778357194413,
                            21.307170123153842
                        ],
                        [
                            -157.80781902875722,
                            21.307146967650066
                        ],
                        [
                            -157.80782801433847,
                            21.307159049986403
                        ],
                        [
                            -157.80789227968248,
                            21.30711707869159
                        ],
                        [
                            -157.80788329312691,
                            21.30710499725501
                        ],
                        [
                            -157.80795460985831,
                            21.307058420744749
                        ],
                        [
                            -157.80796359543874,
                            21.30707050397756
                        ],
                        [
                            -157.80802785877916,
                            21.307028532613245
                        ],
                        [
                            -157.80801887415237,
                            21.307016450293844
                        ],
                        [
                            -157.80805453248524,
                            21.306993161560122
                        ],
                        [
                            -157.80803501632232,
                            21.306966921724129
                        ],
                        [
                            -157.80804105984603,
                            21.30696297428009
                        ],
                        [
                            -157.8080228073311,
                            21.306938431826328
                        ],
                        [
                            -157.80801676381526,
                            21.306942378366397
                        ],
                        [
                            -157.80799724863678,
                            21.30691613762999
                        ],
                        [
                            -157.80796078400414,
                            21.306939951830966
                        ],
                        [
                            -157.80795825675116,
                            21.306936553449585
                        ],
                        [
                            -157.80789560414246,
                            21.306977472011575
                        ],
                        [
                            -157.80789813139461,
                            21.306980870393829
                        ],
                        [
                            -157.80782520398299,
                            21.30702849875459
                        ],
                        [
                            -157.80782267576785,
                            21.307025100364445
                        ],
                        [
                            -157.80776002308542,
                            21.307066018871996
                        ],
                        [
                            -157.80776255129973,
                            21.307069417263008
                        ],
                        [
                            -157.80772628817815,
                            21.307093099136409
                        ],
                        [
                            -157.80774580332124,
                            21.30711934080589
                        ],
                        [
                            -157.80773976074755,
                            21.307123288245414
                        ],
                        [
                            -157.80775801227836,
                            21.307147829818085
                        ],
                        [
                            -157.80776405581659,
                            21.307143882384771
                        ],
                        [
                            -157.80778357194413,
                            21.307170123153842
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 291,
                "NUMBER": "9620A7",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING K",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING K - 9620A7",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING K",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620A7_01.jpg",
                "HEIGHT (ft)": 37,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 100.71869909089446,
                "SHAPE_Area": 394.88507031972324
            }
        },
        {
            "type": "Feature",
            "id": 292,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80835413492929,
                            21.30712105438829
                        ],
                        [
                            -157.80838213707639,
                            21.307102766710759
                        ],
                        [
                            -157.80838634855547,
                            21.307108429159843
                        ],
                        [
                            -157.80841253938368,
                            21.307091324732543
                        ],
                        [
                            -157.80840832597605,
                            21.307085662270417
                        ],
                        [
                            -157.8084363281173,
                            21.307067373679825
                        ],
                        [
                            -157.80841091524874,
                            21.307033203742943
                        ],
                        [
                            -157.80841454174325,
                            21.307030835451652
                        ],
                        [
                            -157.80837087630709,
                            21.30697212309304
                        ],
                        [
                            -157.80836725076284,
                            21.306974493196943
                        ],
                        [
                            -157.80831642413605,
                            21.306906153294282
                        ],
                        [
                            -157.80832005062871,
                            21.306903785004913
                        ],
                        [
                            -157.80827638525901,
                            21.306845073527779
                        ],
                        [
                            -157.80827275877445,
                            21.306847440912904
                        ],
                        [
                            -157.80824748713238,
                            21.3068134598584
                        ],
                        [
                            -157.80821948501924,
                            21.306831748419246
                        ],
                        [
                            -157.80821527163346,
                            21.30682608504948
                        ],
                        [
                            -157.80818908372464,
                            21.306843189468214
                        ],
                        [
                            -157.80819329518189,
                            21.306848852824931
                        ],
                        [
                            -157.8081652930629,
                            21.30686714047274
                        ],
                        [
                            -157.8081900039339,
                            21.306900366851703
                        ],
                        [
                            -157.80817711058188,
                            21.306908788134095
                        ],
                        [
                            -157.80822189841311,
                            21.30696900901669
                        ],
                        [
                            -157.80823479272487,
                            21.306960588641235
                        ],
                        [
                            -157.80828449493063,
                            21.307027417366204
                        ],
                        [
                            -157.80827160157943,
                            21.307035837752096
                        ],
                        [
                            -157.80831638947171,
                            21.307096060418939
                        ],
                        [
                            -157.80832928378996,
                            21.307087640036631
                        ],
                        [
                            -157.80835413492929,
                            21.30712105438829
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 292,
                "NUMBER": "9620A8",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING J",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING J - 9620A8",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING J",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620A8_01.jpg",
                "HEIGHT (ft)": 38,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 100.71837271945552,
                "SHAPE_Area": 394.88028870802151
            }
        },
        {
            "type": "Feature",
            "id": 293,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80803887175563,
                            21.307450572871375
                        ],
                        [
                            -157.80807533650704,
                            21.307426758660185
                        ],
                        [
                            -157.80807786280661,
                            21.307430157033309
                        ],
                        [
                            -157.8081405165311,
                            21.307389238419034
                        ],
                        [
                            -157.80813798733146,
                            21.307385840929669
                        ],
                        [
                            -157.8082109158033,
                            21.307338211542312
                        ],
                        [
                            -157.80821344306867,
                            21.307341609920336
                        ],
                        [
                            -157.80827609671212,
                            21.307300692154957
                        ],
                        [
                            -157.80827356848195,
                            21.307297293771015
                        ],
                        [
                            -157.80830983158123,
                            21.307273610875086
                        ],
                        [
                            -157.80829031535154,
                            21.307247369259041
                        ],
                        [
                            -157.80829635887352,
                            21.307243422709512
                        ],
                        [
                            -157.80827810627522,
                            21.307218881183957
                        ],
                        [
                            -157.80827206274657,
                            21.307222828636203
                        ],
                        [
                            -157.80825254749402,
                            21.307196587023082
                        ],
                        [
                            -157.80821709072441,
                            21.307219743524065
                        ],
                        [
                            -157.80820810414284,
                            21.307207661200113
                        ],
                        [
                            -157.80814383980533,
                            21.307249632624337
                        ],
                        [
                            -157.80815282541985,
                            21.307261714944708
                        ],
                        [
                            -157.80808150962343,
                            21.307308289736408
                        ],
                        [
                            -157.8080725249763,
                            21.307296207419263
                        ],
                        [
                            -157.80800825960645,
                            21.307338177877483
                        ],
                        [
                            -157.80801724520722,
                            21.307350261108038
                        ],
                        [
                            -157.80798158775093,
                            21.30737354893207
                        ],
                        [
                            -157.80800110297534,
                            21.307399790574937
                        ],
                        [
                            -157.80799506040341,
                            21.307403737119948
                        ],
                        [
                            -157.80801331200297,
                            21.307428279571042
                        ],
                        [
                            -157.80801935554675,
                            21.307424332128903
                        ],
                        [
                            -157.80803887175563,
                            21.307450572871375
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 293,
                "NUMBER": "9620A9",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING I",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING I - 9620A9",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING I",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620A9_01.jpg",
                "HEIGHT (ft)": 34,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 100.71893377938258,
                "SHAPE_Area": 394.88352562486057
            }
        },
        {
            "type": "Feature",
            "id": 294,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80782391133633,
                            21.307645285305973
                        ],
                        [
                            -157.80785191366181,
                            21.307626995918888
                        ],
                        [
                            -157.80785612704713,
                            21.30763266020098
                        ],
                        [
                            -157.80788231513657,
                            21.307615555844016
                        ],
                        [
                            -157.80787810367136,
                            21.307609892479537
                        ],
                        [
                            -157.80790610597637,
                            21.307591603986058
                        ],
                        [
                            -157.80788069315105,
                            21.307557433972665
                        ],
                        [
                            -157.80788431965945,
                            21.307555066597285
                        ],
                        [
                            -157.80784065429754,
                            21.307496354107212
                        ],
                        [
                            -157.80783702874663,
                            21.30749872239187
                        ],
                        [
                            -157.80778620220624,
                            21.307430382336197
                        ],
                        [
                            -157.80778982872013,
                            21.307428014059404
                        ],
                        [
                            -157.80774616342467,
                            21.307369302450795
                        ],
                        [
                            -157.80774253788289,
                            21.307371669830186
                        ],
                        [
                            -157.8077172653125,
                            21.307337689596103
                        ],
                        [
                            -157.8076892630356,
                            21.307355978059842
                        ],
                        [
                            -157.80768505062093,
                            21.307350314684214
                        ],
                        [
                            -157.80765886160225,
                            21.307367418101958
                        ],
                        [
                            -157.80766307305234,
                            21.307373081471358
                        ],
                        [
                            -157.80763507076227,
                            21.307391369925387
                        ],
                        [
                            -157.80765978159127,
                            21.307424596378745
                        ],
                        [
                            -157.8076468881784,
                            21.30743301580975
                        ],
                        [
                            -157.80769167689016,
                            21.307493237737358
                        ],
                        [
                            -157.80770456934212,
                            21.307484818296288
                        ],
                        [
                            -157.80775427242736,
                            21.307551647177721
                        ],
                        [
                            -157.80774137802945,
                            21.307560068415402
                        ],
                        [
                            -157.80778616680956,
                            21.307620291223916
                        ],
                        [
                            -157.80779905928256,
                            21.307611869969332
                        ],
                        [
                            -157.80782391133633,
                            21.307645285305973
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 294,
                "NUMBER": "9620A10",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING L",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING L - 9620A10",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING L",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620A10_01.jpg",
                "HEIGHT (ft)": 37,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 100.71832503654322,
                "SHAPE_Area": 394.88203778582869
            }
        },
        {
            "type": "Feature",
            "id": 295,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8078304067904,
                            21.30860566431901
                        ],
                        [
                            -157.80786680324309,
                            21.308581872269539
                        ],
                        [
                            -157.8078693276791,
                            21.30858526430902
                        ],
                        [
                            -157.80793186405953,
                            21.308544382006978
                        ],
                        [
                            -157.80792933865871,
                            21.308540989961561
                        ],
                        [
                            -157.80800213149726,
                            21.308493404904631
                        ],
                        [
                            -157.80800465594234,
                            21.308496796038856
                        ],
                        [
                            -157.80806719224199,
                            21.308455914585906
                        ],
                        [
                            -157.80806466586807,
                            21.308452523438909
                        ],
                        [
                            -157.80810086163828,
                            21.308428861808032
                        ],
                        [
                            -157.80808136225613,
                            21.308402669972246
                        ],
                        [
                            -157.80808739520654,
                            21.308398726068098
                        ],
                        [
                            -157.80806915950618,
                            21.308374228904491
                        ],
                        [
                            -157.80806312654906,
                            21.30837817371135
                        ],
                        [
                            -157.80804362814402,
                            21.308351981878491
                        ],
                        [
                            -157.80800823774663,
                            21.308375117109023
                        ],
                        [
                            -157.80799926057509,
                            21.308363057424724
                        ],
                        [
                            -157.80793511550945,
                            21.308404990740794
                        ],
                        [
                            -157.80794409267796,
                            21.308417050428332
                        ],
                        [
                            -157.80787290960805,
                            21.308463584485306
                        ],
                        [
                            -157.80786393147892,
                            21.308451524787344
                        ],
                        [
                            -157.80779978633788,
                            21.308493458047753
                        ],
                        [
                            -157.80780876446391,
                            21.308505517748955
                        ],
                        [
                            -157.80777317337095,
                            21.308528785205727
                        ],
                        [
                            -157.80779267174802,
                            21.308554977068255
                        ],
                        [
                            -157.80778663879829,
                            21.308558919154404
                        ],
                        [
                            -157.80780487543529,
                            21.308583416353823
                        ],
                        [
                            -157.80781090743622,
                            21.308579472453555
                        ],
                        [
                            -157.8078304067904,
                            21.30860566431901
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 295,
                "NUMBER": "9620A2",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING B",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING B - 9620A2",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING B",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620A2_01.jpg",
                "HEIGHT (ft)": 32,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 100.56268245974724,
                "SHAPE_Area": 393.65931712183948
            }
        },
        {
            "type": "Feature",
            "id": 296,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80706818498797,
                            21.30770337587937
                        ],
                        [
                            -157.8071035749762,
                            21.307680287817611
                        ],
                        [
                            -157.80711253468195,
                            21.307692347422272
                        ],
                        [
                            -157.80717667893663,
                            21.30765050203642
                        ],
                        [
                            -157.80716771827113,
                            21.307638441524823
                        ],
                        [
                            -157.8072389003554,
                            21.307592004410481
                        ],
                        [
                            -157.80724785911096,
                            21.307604063098147
                        ],
                        [
                            -157.80731200329762,
                            21.307562216753322
                        ],
                        [
                            -157.80730304455361,
                            21.307550156262209
                        ],
                        [
                            -157.80733863507021,
                            21.30752693857816
                        ],
                        [
                            -157.80732253619479,
                            21.307505269635783
                        ],
                        [
                            -157.8073301778289,
                            21.307500283812839
                        ],
                        [
                            -157.80730525944148,
                            21.307466743270396
                        ],
                        [
                            -157.80729761877234,
                            21.307471729099106
                        ],
                        [
                            -157.80728152087269,
                            21.307450060160065
                        ],
                        [
                            -157.80724512501493,
                            21.307473803314551
                        ],
                        [
                            -157.80724260542399,
                            21.307470412204328
                        ],
                        [
                            -157.80718007002261,
                            21.307511209354058
                        ],
                        [
                            -157.8071825905767,
                            21.307514600471983
                        ],
                        [
                            -157.80710979974398,
                            21.307562087636491
                        ],
                        [
                            -157.80710728112609,
                            21.307558695627868
                        ],
                        [
                            -157.80704474565135,
                            21.307599492723337
                        ],
                        [
                            -157.80704726522507,
                            21.307602885643028
                        ],
                        [
                            -157.80701107087279,
                            21.307626497374418
                        ],
                        [
                            -157.80702716971319,
                            21.30764816634478
                        ],
                        [
                            -157.80701952806896,
                            21.307653151249703
                        ],
                        [
                            -157.80704444545447,
                            21.307686691825342
                        ],
                        [
                            -157.80705208613574,
                            21.307681706912511
                        ],
                        [
                            -157.80706818498797,
                            21.30770337587937
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 296,
                "NUMBER": "9620H3",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING N",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING N - 9620H3",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING N",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620H3_01.jpg",
                "HEIGHT (ft)": 34,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 101.30695034787239,
                "SHAPE_Area": 396.81775964794923
            }
        },
        {
            "type": "Feature",
            "id": 297,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80686731766181,
                            21.308317830918508
                        ],
                        [
                            -157.80689044140263,
                            21.30830274484132
                        ],
                        [
                            -157.80689576096242,
                            21.308309905772862
                        ],
                        [
                            -157.80693155235161,
                            21.308286555910133
                        ],
                        [
                            -157.8069262337475,
                            21.308279395889837
                        ],
                        [
                            -157.80694935844048,
                            21.308264309810774
                        ],
                        [
                            -157.80692472040556,
                            21.308231146106849
                        ],
                        [
                            -157.80693758867559,
                            21.308222750046177
                        ],
                        [
                            -157.80689293316522,
                            21.308162640890718
                        ],
                        [
                            -157.80688006296302,
                            21.308171037837841
                        ],
                        [
                            -157.8068305085109,
                            21.308104333528274
                        ],
                        [
                            -157.80684337773116,
                            21.308095938384572
                        ],
                        [
                            -157.80679872228876,
                            21.30803583011016
                        ],
                        [
                            -157.8067858521149,
                            21.308044224340446
                        ],
                        [
                            -157.80676107587814,
                            21.308010873536748
                        ],
                        [
                            -157.80673795121569,
                            21.308025958688013
                        ],
                        [
                            -157.80673263070204,
                            21.308018798648586
                        ],
                        [
                            -157.80669683935082,
                            21.308042148471273
                        ],
                        [
                            -157.80670215986348,
                            21.308049308511773
                        ],
                        [
                            -157.80667903518187,
                            21.308064394557622
                        ],
                        [
                            -157.80670437312088,
                            21.308098500974847
                        ],
                        [
                            -157.80670075338003,
                            21.308100862047642
                        ],
                        [
                            -157.80674428823514,
                            21.308159462776565
                        ],
                        [
                            -157.80674790894079,
                            21.308157101709721
                        ],
                        [
                            -157.8067985839433,
                            21.308225312708757
                        ],
                        [
                            -157.80679496515734,
                            21.308227674693633
                        ],
                        [
                            -157.8068385000858,
                            21.308286275400818
                        ],
                        [
                            -157.8068421198366,
                            21.308283913421885
                        ],
                        [
                            -157.80686731766181,
                            21.308317830918508
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 297,
                "NUMBER": "9620H4",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING P",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING P - 9620H4",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING P",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620H4_01.jpg",
                "HEIGHT (ft)": 36,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 101.30662380728582,
                "SHAPE_Area": 396.81879392689143
            }
        },
        {
            "type": "Feature",
            "id": 298,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80772676755683,
                            21.308437994766663
                        ],
                        [
                            -157.80774989245478,
                            21.30842287695841
                        ],
                        [
                            -157.8077552236295,
                            21.308430037946803
                        ],
                        [
                            -157.80779101531633,
                            21.308406639116395
                        ],
                        [
                            -157.80778568509731,
                            21.308399479039238
                        ],
                        [
                            -157.80780880901213,
                            21.308384362118744
                        ],
                        [
                            -157.80778341966541,
                            21.30835025639605
                        ],
                        [
                            -157.80778703848355,
                            21.308347888969333
                        ],
                        [
                            -157.80774341157058,
                            21.308289287840598
                        ],
                        [
                            -157.80773979276785,
                            21.308291653459765
                        ],
                        [
                            -157.80768901222049,
                            21.308223441978729
                        ],
                        [
                            -157.80769263200079,
                            21.308221074560748
                        ],
                        [
                            -157.80764900612536,
                            21.308162473417006
                        ],
                        [
                            -157.80764538635319,
                            21.308164839930765
                        ],
                        [
                            -157.80762013631235,
                            21.308130922174012
                        ],
                        [
                            -157.80759701242067,
                            21.308146039069953
                        ],
                        [
                            -157.80759168222011,
                            21.308138878987318
                        ],
                        [
                            -157.80755588961438,
                            21.308162276867424
                        ],
                        [
                            -157.80756121981395,
                            21.308169436951136
                        ],
                        [
                            -157.80753809590311,
                            21.308184554741697
                        ],
                        [
                            -157.80756278420031,
                            21.308217718717319
                        ],
                        [
                            -157.80754991487581,
                            21.308226130177413
                        ],
                        [
                            -157.80759466322283,
                            21.308286239827329
                        ],
                        [
                            -157.80760753255041,
                            21.308277828363998
                        ],
                        [
                            -157.80765719056569,
                            21.308344533193516
                        ],
                        [
                            -157.80764432122743,
                            21.308352945563755
                        ],
                        [
                            -157.80768906965719,
                            21.308413054287954
                        ],
                        [
                            -157.80770193899119,
                            21.308404642817791
                        ],
                        [
                            -157.80772676755683,
                            21.308437994766663
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 298,
                "NUMBER": "9620H2",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING C",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING C - 9620H2",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING C",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620H2_01.jpg",
                "HEIGHT (ft)": 33,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 101.37530365669373,
                "SHAPE_Area": 397.36224995417973
            }
        },
        {
            "type": "Feature",
            "id": 299,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80858337915097,
                            21.307501900102761
                        ],
                        [
                            -157.80860654633278,
                            21.307486769817778
                        ],
                        [
                            -157.80861188126576,
                            21.307493944357493
                        ],
                        [
                            -157.80864774120897,
                            21.307470524129879
                        ],
                        [
                            -157.80864240626772,
                            21.307463350494576
                        ],
                        [
                            -157.80866557344496,
                            21.307448219297498
                        ],
                        [
                            -157.80864015948941,
                            21.307414050287715
                        ],
                        [
                            -157.80864378696143,
                            21.307411681095342
                        ],
                        [
                            -157.80860012035518,
                            21.307352969685819
                        ],
                        [
                            -157.80859649481198,
                            21.307355338890954
                        ],
                        [
                            -157.80854566891776,
                            21.30728699905632
                        ],
                        [
                            -157.80854929540936,
                            21.307284631665716
                        ],
                        [
                            -157.80850562984813,
                            21.307225919337807
                        ],
                        [
                            -157.80850200432133,
                            21.307228286734347
                        ],
                        [
                            -157.80847673160017,
                            21.307194305703419
                        ],
                        [
                            -157.80845356348223,
                            21.307209436869087
                        ],
                        [
                            -157.80844822855948,
                            21.307202263228273
                        ],
                        [
                            -157.80841236866155,
                            21.307225682512311
                        ],
                        [
                            -157.80841770453998,
                            21.307232857064367
                        ],
                        [
                            -157.80839453738872,
                            21.307247986421391
                        ],
                        [
                            -157.80841924837227,
                            21.307281212770626
                        ],
                        [
                            -157.80840635499797,
                            21.307289634069249
                        ],
                        [
                            -157.80845114399708,
                            21.307349854904771
                        ],
                        [
                            -157.80846403640319,
                            21.307341434499403
                        ],
                        [
                            -157.80851373883525,
                            21.307408263164525
                        ],
                        [
                            -157.80850084546177,
                            21.307416683566668
                        ],
                        [
                            -157.80854563452195,
                            21.307476906186416
                        ],
                        [
                            -157.80855852693452,
                            21.307468485774177
                        ],
                        [
                            -157.80858337915097,
                            21.307501900102761
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 299,
                "NUMBER": "9620H1",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING H",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING H - 9620H1",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING H",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620H1_01.jpg",
                "HEIGHT (ft)": 37,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 101.53369333185458,
                "SHAPE_Area": 398.59698331007758
            }
        },
        {
            "type": "Feature",
            "id": 302,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80578272906357,
                            21.308515904208168
                        ],
                        [
                            -157.80583237374057,
                            21.308483150205095
                        ],
                        [
                            -157.80582845944497,
                            21.308477940594656
                        ],
                        [
                            -157.80609182915015,
                            21.308304185205209
                        ],
                        [
                            -157.8060957444078,
                            21.308309395720013
                        ],
                        [
                            -157.80614538991247,
                            21.308276641624076
                        ],
                        [
                            -157.806109983846,
                            21.308229513629957
                        ],
                        [
                            -157.8061168341672,
                            21.30822499472124
                        ],
                        [
                            -157.80611050968926,
                            21.308216575444572
                        ],
                        [
                            -157.80610365743308,
                            21.30822109524269
                        ],
                        [
                            -157.80608611082374,
                            21.308197740131504
                        ],
                        [
                            -157.80572344912949,
                            21.308437001684354
                        ],
                        [
                            -157.80574099569859,
                            21.308460357734706
                        ],
                        [
                            -157.8057341443768,
                            21.308464878426761
                        ],
                        [
                            -157.80574046981368,
                            21.308473296820363
                        ],
                        [
                            -157.80574732113564,
                            21.308468776128045
                        ],
                        [
                            -157.80578272906357,
                            21.308515904208168
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 302,
                "NUMBER": "9620DH",
                "PROPER_NAME": "KAU`IOKAHALOA IKI - BUILDING DH",
                "DISPLAY_NAME": "KAU`IOKAHALOA IKI - BUILDING DH - 9620DH",
                "ADDRESS": "3030 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA IKI - BUILDING DH",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620DH_01.jpg",
                "HEIGHT (ft)": 39,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 118.26775393446115,
                "SHAPE_Area": 469.86597574230666
            }
        },
        {
            "type": "Feature",
            "id": 303,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8064144898307,
                            21.308294186880339
                        ],
                        [
                            -157.8064350727702,
                            21.308280607757599
                        ],
                        [
                            -157.80643103732382,
                            21.308275237401475
                        ],
                        [
                            -157.80648575747199,
                            21.308239136924769
                        ],
                        [
                            -157.80648519856393,
                            21.308238392182531
                        ],
                        [
                            -157.806456945722,
                            21.308200787014968
                        ],
                        [
                            -157.80644640837028,
                            21.308186762158638
                        ],
                        [
                            -157.80638840053584,
                            21.308109552795386
                        ],
                        [
                            -157.8063778632042,
                            21.308095527031909
                        ],
                        [
                            -157.80634961041591,
                            21.308057921848256
                        ],
                        [
                            -157.80634905150191,
                            21.308057178008927
                        ],
                        [
                            -157.80629433138517,
                            21.308093279346849
                        ],
                        [
                            -157.80629029692014,
                            21.308087908091206
                        ],
                        [
                            -157.8062697139888,
                            21.308101488100501
                        ],
                        [
                            -157.80627375038864,
                            21.308106858466946
                        ],
                        [
                            -157.80626985807689,
                            21.308109426278438
                        ],
                        [
                            -157.80627097591176,
                            21.308110913054257
                        ],
                        [
                            -157.80627158650344,
                            21.30811051086279
                        ],
                        [
                            -157.80640605773863,
                            21.308289492681816
                        ],
                        [
                            -157.80640544520398,
                            21.308289896666736
                        ],
                        [
                            -157.80640656303424,
                            21.308291384345079
                        ],
                        [
                            -157.80641045535606,
                            21.308288815627257
                        ],
                        [
                            -157.8064144898307,
                            21.308294186880339
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 303,
                "NUMBER": "9620D1",
                "PROPER_NAME": "KAU`IOKAHALOA IKI - BUILDING 1",
                "DISPLAY_NAME": "KAU`IOKAHALOA IKI - BUILDING 1 - 9620D1",
                "ADDRESS": "3030 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA IKI - BUILDING 1",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620D1_01.jpg",
                "HEIGHT (ft)": 37,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 72.424787326972492,
                "SHAPE_Area": 249.40731490967539
            }
        },
        {
            "type": "Feature",
            "id": 304,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8065853376211,
                            21.308531139511587
                        ],
                        [
                            -157.80660591962348,
                            21.308517559458949
                        ],
                        [
                            -157.80660188416468,
                            21.30851218910648
                        ],
                        [
                            -157.80665660437225,
                            21.308476087674009
                        ],
                        [
                            -157.80665604545518,
                            21.308475343835589
                        ],
                        [
                            -157.80662779252609,
                            21.308437738693598
                        ],
                        [
                            -157.80661725514184,
                            21.308423713846821
                        ],
                        [
                            -157.80655924712852,
                            21.308346504536072
                        ],
                        [
                            -157.80654870880039,
                            21.308332478775284
                        ],
                        [
                            -157.80652045688166,
                            21.308294874527359
                        ],
                        [
                            -157.80651989796593,
                            21.308294130688555
                        ],
                        [
                            -157.80646517779709,
                            21.308330232078912
                        ],
                        [
                            -157.80646114236293,
                            21.308324859916745
                        ],
                        [
                            -157.80644056037596,
                            21.3083384399526
                        ],
                        [
                            -157.80644459678831,
                            21.308343810315389
                        ],
                        [
                            -157.80644070447283,
                            21.308346378130611
                        ],
                        [
                            -157.80644182231114,
                            21.3083478649054
                        ],
                        [
                            -157.80644243289609,
                            21.308347463616684
                        ],
                        [
                            -157.80657690454601,
                            21.30852644531403
                        ],
                        [
                            -157.80657629298207,
                            21.308526848403034
                        ],
                        [
                            -157.80657741177976,
                            21.308528336087189
                        ],
                        [
                            -157.80658130313401,
                            21.308525768262136
                        ],
                        [
                            -157.8065853376211,
                            21.308531139511587
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 304,
                "NUMBER": "9620D2",
                "PROPER_NAME": "KAU`IOKAHALOA IKI - BUILDING 2",
                "DISPLAY_NAME": "KAU`IOKAHALOA IKI - BUILDING 2 - 9620D2",
                "ADDRESS": "3030 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA IKI - BUILDING 2",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620D2_01.jpg",
                "HEIGHT (ft)": 36,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 72.424438982818629,
                "SHAPE_Area": 249.40766952950912
            }
        },
        {
            "type": "Feature",
            "id": 305,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8068200828115,
                            21.308844794649779
                        ],
                        [
                            -157.80684074447038,
                            21.308831262110846
                        ],
                        [
                            -157.80683672265835,
                            21.308825871082419
                        ],
                        [
                            -157.80689165405363,
                            21.308789889418584
                        ],
                        [
                            -157.80689109708408,
                            21.308789142884539
                        ],
                        [
                            -157.80686293871105,
                            21.308751393907347
                        ],
                        [
                            -157.80685243547467,
                            21.308737313306231
                        ],
                        [
                            -157.80679462339535,
                            21.308659806438264
                        ],
                        [
                            -157.8067841201572,
                            21.308645727640027
                        ],
                        [
                            -157.80675596280912,
                            21.308607977750366
                        ],
                        [
                            -157.80675540584087,
                            21.308607231215923
                        ],
                        [
                            -157.80670047546366,
                            21.308643211037804
                        ],
                        [
                            -157.80669645269771,
                            21.308637819999547
                        ],
                        [
                            -157.80667579104727,
                            21.308651353425041
                        ],
                        [
                            -157.80667981381276,
                            21.308656744463764
                        ],
                        [
                            -157.80667590614183,
                            21.308659303141383
                        ],
                        [
                            -157.80667702007048,
                            21.308660797114122
                        ],
                        [
                            -157.80667763355541,
                            21.308660394941757
                        ],
                        [
                            -157.80681165479353,
                            21.308840067977101
                        ],
                        [
                            -157.80681104035148,
                            21.308840469239744
                        ],
                        [
                            -157.80681215429013,
                            21.308841962308335
                        ],
                        [
                            -157.8068160619639,
                            21.308839403627719
                        ],
                        [
                            -157.8068200828115,
                            21.308844794649779
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 305,
                "NUMBER": "9620D3",
                "PROPER_NAME": "KAU`IOKAHALOA IKI - BUILDING 3",
                "DISPLAY_NAME": "KAU`IOKAHALOA IKI - BUILDING 3 - 9620D3",
                "ADDRESS": "3030 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA IKI - BUILDING 3",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620D3_01.jpg",
                "HEIGHT (ft)": 37,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 72.531059522810736,
                "SHAPE_Area": 250.14179200806797
            }
        },
        {
            "type": "Feature",
            "id": 306,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80645837731373,
                            21.309074223042288
                        ],
                        [
                            -157.80645917109493,
                            21.309073699289424
                        ],
                        [
                            -157.80649930111838,
                            21.309047222976147
                        ],
                        [
                            -157.80651426856952,
                            21.309037349450385
                        ],
                        [
                            -157.80659666080996,
                            21.308982990883941
                        ],
                        [
                            -157.80661162824831,
                            21.308973117348835
                        ],
                        [
                            -157.80665175821807,
                            21.308946640996307
                        ],
                        [
                            -157.8066525519979,
                            21.30894611724246
                        ],
                        [
                            -157.80661402768399,
                            21.308894840555151
                        ],
                        [
                            -157.80661975860025,
                            21.308891058980052
                        ],
                        [
                            -157.80660526775296,
                            21.308871771864361
                        ],
                        [
                            -157.8065995368444,
                            21.308875552535639
                        ],
                        [
                            -157.80659679662412,
                            21.308871905095756
                        ],
                        [
                            -157.80659520906488,
                            21.308872952602936
                        ],
                        [
                            -157.80659564018106,
                            21.308873525698246
                        ],
                        [
                            -157.80640463970244,
                            21.308999537321693
                        ],
                        [
                            -157.80640420955064,
                            21.308998964232742
                        ],
                        [
                            -157.80640262199603,
                            21.309000010834627
                        ],
                        [
                            -157.80640536221355,
                            21.309003658277504
                        ],
                        [
                            -157.80639963032368,
                            21.309007439837945
                        ],
                        [
                            -157.80641412116285,
                            21.309026726067099
                        ],
                        [
                            -157.80641985208916,
                            21.30902294449935
                        ],
                        [
                            -157.80645837731373,
                            21.309074223042288
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 306,
                "NUMBER": "9620D4",
                "PROPER_NAME": "KAU`IOKAHALOA IKI - BUILDING 4",
                "DISPLAY_NAME": "KAU`IOKAHALOA IKI - BUILDING 4 - 9620D4",
                "ADDRESS": "3030 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA IKI - BUILDING 4",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620D4_01.jpg",
                "HEIGHT (ft)": 39,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 72.424508262882568,
                "SHAPE_Area": 249.40584507933417
            }
        },
        {
            "type": "Feature",
            "id": 307,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80624565561303,
                            21.308802495397153
                        ],
                        [
                            -157.80625138749832,
                            21.308798713841696
                        ],
                        [
                            -157.80625412674453,
                            21.308802361279934
                        ],
                        [
                            -157.80625571430525,
                            21.308801313776048
                        ],
                        [
                            -157.8062552831833,
                            21.308800741583248
                        ],
                        [
                            -157.80644628254291,
                            21.308674731016939
                        ],
                        [
                            -157.80644671270127,
                            21.308675303202431
                        ],
                        [
                            -157.8064483012233,
                            21.308674255703416
                        ],
                        [
                            -157.80644556004634,
                            21.308670608254495
                        ],
                        [
                            -157.8064512919143,
                            21.308666827595008
                        ],
                        [
                            -157.80643680207419,
                            21.308647540473185
                        ],
                        [
                            -157.80643107115606,
                            21.308651322945707
                        ],
                        [
                            -157.80639254507977,
                            21.308600044392779
                        ],
                        [
                            -157.80639175130102,
                            21.308600568145465
                        ],
                        [
                            -157.80635162139257,
                            21.308627043535903
                        ],
                        [
                            -157.80633665396709,
                            21.30863691795243
                        ],
                        [
                            -157.80625426280159,
                            21.308691276405096
                        ],
                        [
                            -157.80623929535605,
                            21.30870115171561
                        ],
                        [
                            -157.80619916540124,
                            21.308727626163474
                        ],
                        [
                            -157.80619837162109,
                            21.308728149915176
                        ],
                        [
                            -157.80623689574526,
                            21.308779426689885
                        ],
                        [
                            -157.80623116482437,
                            21.308783208251725
                        ],
                        [
                            -157.80624565561303,
                            21.308802495397153
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 307,
                "NUMBER": "9620D5",
                "PROPER_NAME": "KAU`IOKAHALOA IKI - BUILDING 5",
                "DISPLAY_NAME": "KAU`IOKAHALOA IKI - BUILDING 5 - 9620D5",
                "ADDRESS": "3030 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA IKI - BUILDING 5",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620D5_01.jpg",
                "HEIGHT (ft)": 39,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 72.424485190902217,
                "SHAPE_Area": 249.40613487371766
            }
        },
        {
            "type": "Feature",
            "id": 308,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80598621501036,
                            21.308788939090892
                        ],
                        [
                            -157.80598700975554,
                            21.308788415347088
                        ],
                        [
                            -157.80602713880606,
                            21.30876194004242
                        ],
                        [
                            -157.80604210529989,
                            21.308752065648299
                        ],
                        [
                            -157.80612449849372,
                            21.308697708222219
                        ],
                        [
                            -157.80613946595335,
                            21.308687832018926
                        ],
                        [
                            -157.8061795949356,
                            21.308661358481658
                        ],
                        [
                            -157.80618038871543,
                            21.308660834730041
                        ],
                        [
                            -157.80614186465493,
                            21.308609556137391
                        ],
                        [
                            -157.80614759556366,
                            21.308605775481638
                        ],
                        [
                            -157.80613310480621,
                            21.30858648832881
                        ],
                        [
                            -157.8061273729266,
                            21.30859026988059
                        ],
                        [
                            -157.80612463368726,
                            21.308586622440529
                        ],
                        [
                            -157.80612304612811,
                            21.308587669943275
                        ],
                        [
                            -157.80612347724892,
                            21.308588242136352
                        ],
                        [
                            -157.80593247774198,
                            21.308714253233006
                        ],
                        [
                            -157.8059320466289,
                            21.308713680136133
                        ],
                        [
                            -157.80593045907435,
                            21.308714726733584
                        ],
                        [
                            -157.80593320023888,
                            21.30871837419032
                        ],
                        [
                            -157.80592746834924,
                            21.308722155734749
                        ],
                        [
                            -157.80594195909123,
                            21.308741442904349
                        ],
                        [
                            -157.80594769001732,
                            21.308737661352616
                        ],
                        [
                            -157.80598621501036,
                            21.308788939090892
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 308,
                "NUMBER": "9620D6",
                "PROPER_NAME": "KAU`IOKAHALOA IKI - BUILDING 6",
                "DISPLAY_NAME": "KAU`IOKAHALOA IKI - BUILDING 6 - 9620D6",
                "ADDRESS": "3030 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA IKI - BUILDING 6",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620D6_01.jpg",
                "HEIGHT (ft)": 40,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 72.424508350028844,
                "SHAPE_Area": 249.40608671836139
            }
        },
        {
            "type": "Feature",
            "id": 309,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82050382721837,
                            21.300159156685297
                        ],
                        [
                            -157.82051116809455,
                            21.300158900080447
                        ],
                        [
                            -157.82051107650338,
                            21.300156606632246
                        ],
                        [
                            -157.8205379879056,
                            21.300155666010127
                        ],
                        [
                            -157.82053794210978,
                            21.300154519286014
                        ],
                        [
                            -157.82054032188805,
                            21.300154436592184
                        ],
                        [
                            -157.82057782081498,
                            21.30015312569979
                        ],
                        [
                            -157.82057791241445,
                            21.300155418244671
                        ],
                        [
                            -157.82058623008567,
                            21.300155126926402
                        ],
                        [
                            -157.82058613945003,
                            21.300152834388275
                        ],
                        [
                            -157.82062185835906,
                            21.300151585992335
                        ],
                        [
                            -157.82062194900249,
                            21.300153877627142
                        ],
                        [
                            -157.82063026763041,
                            21.300153587216784
                        ],
                        [
                            -157.82063017603014,
                            21.300151294671878
                        ],
                        [
                            -157.82066589591005,
                            21.300150045369989
                        ],
                        [
                            -157.82066598751089,
                            21.300152337914877
                        ],
                        [
                            -157.82067430516761,
                            21.30015204839891
                        ],
                        [
                            -157.82067421357385,
                            21.300149754950684
                        ],
                        [
                            -157.82070993345351,
                            21.300148505639388
                        ],
                        [
                            -157.82071002408392,
                            21.300150799080892
                        ],
                        [
                            -157.82071834271892,
                            21.300150507762805
                        ],
                        [
                            -157.82071825111726,
                            21.300148215217899
                        ],
                        [
                            -157.82075397003274,
                            21.30014696589048
                        ],
                        [
                            -157.82075406162775,
                            21.300149259338731
                        ],
                        [
                            -157.82076237929877,
                            21.300148968011719
                        ],
                        [
                            -157.82076228866759,
                            21.300146674570207
                        ],
                        [
                            -157.82079800853953,
                            21.300145426143501
                        ],
                        [
                            -157.82079809917849,
                            21.300147718681668
                        ],
                        [
                            -157.82080641780618,
                            21.300147428262559
                        ],
                        [
                            -157.82080632620315,
                            21.300145135717642
                        ],
                        [
                            -157.82084204511816,
                            21.300143886371441
                        ],
                        [
                            -157.82084213672172,
                            21.300146178916389
                        ],
                        [
                            -157.82085045534936,
                            21.300145888495095
                        ],
                        [
                            -157.82085036374565,
                            21.300143595950153
                        ],
                        [
                            -157.82087822976368,
                            21.300142621309668
                        ],
                        [
                            -157.82088437014693,
                            21.300142405963491
                        ],
                        [
                            -157.82088446174396,
                            21.300144699411764
                        ],
                        [
                            -157.82089424797408,
                            21.300144356937302
                        ],
                        [
                            -157.82089394684283,
                            21.300136790734083
                        ],
                        [
                            -157.82089150052462,
                            21.300136876580293
                        ],
                        [
                            -157.82088960596604,
                            21.300089310607376
                        ],
                        [
                            -157.82088923571646,
                            21.30008001663613
                        ],
                        [
                            -157.82089168299046,
                            21.300079931700026
                        ],
                        [
                            -157.820891390632,
                            21.300072595019554
                        ],
                        [
                            -157.82090704820695,
                            21.300072047056425
                        ],
                        [
                            -157.82090713981876,
                            21.300074338698039
                        ],
                        [
                            -157.82091594731446,
                            21.300074031823996
                        ],
                        [
                            -157.82091565496199,
                            21.300066694240183
                        ],
                        [
                            -157.82091369752422,
                            21.300066762734065
                        ],
                        [
                            -157.82091262064742,
                            21.300039709467139
                        ],
                        [
                            -157.82091457808485,
                            21.30003964097325
                        ],
                        [
                            -157.82091419981583,
                            21.300030143682783
                        ],
                        [
                            -157.82091224238573,
                            21.300030211273331
                        ],
                        [
                            -157.82091122413635,
                            21.300004630041141
                        ],
                        [
                            -157.82091318157327,
                            21.300004561547247
                        ],
                        [
                            -157.82091287070432,
                            21.29999676581436
                        ],
                        [
                            -157.82091091326745,
                            21.299996834308256
                        ],
                        [
                            -157.82090981871582,
                            21.299969338255682
                        ],
                        [
                            -157.82091177518117,
                            21.299969270658369
                        ],
                        [
                            -157.82091147417864,
                            21.29996168819488
                        ],
                        [
                            -157.82090951674942,
                            21.299961755785446
                        ],
                        [
                            -157.8209084301437,
                            21.299934472085344
                        ],
                        [
                            -157.82091038757974,
                            21.299934403591436
                        ],
                        [
                            -157.82091007670365,
                            21.299926608761837
                        ],
                        [
                            -157.82090812023165,
                            21.299926677262512
                        ],
                        [
                            -157.8209070336261,
                            21.29989939356231
                        ],
                        [
                            -157.82090899106166,
                            21.299899325068402
                        ],
                        [
                            -157.82090868019282,
                            21.299891529335433
                        ],
                        [
                            -157.82090672275737,
                            21.299891597829344
                        ],
                        [
                            -157.82090563711591,
                            21.299864314135817
                        ],
                        [
                            -157.8209075945438,
                            21.299864246545248
                        ],
                        [
                            -157.82090726516563,
                            21.299855991759877
                        ],
                        [
                            -157.82090530869459,
                            21.299856060260563
                        ],
                        [
                            -157.82090422208938,
                            21.299828776560172
                        ],
                        [
                            -157.820906179524,
                            21.299828708066251
                        ],
                        [
                            -157.82090588716463,
                            21.299821371385576
                        ],
                        [
                            -157.82090393069404,
                            21.299821439886269
                        ],
                        [
                            -157.8209029717124,
                            21.299797371345488
                        ],
                        [
                            -157.82090284721684,
                            21.299794247450194
                        ],
                        [
                            -157.82090480465104,
                            21.299794178956269
                        ],
                        [
                            -157.8209044906545,
                            21.299786291958803
                        ],
                        [
                            -157.82090253321323,
                            21.299786361356073
                        ],
                        [
                            -157.82090175748411,
                            21.299766872485222
                        ],
                        [
                            -157.82090144757228,
                            21.299759077662255
                        ],
                        [
                            -157.82090340500599,
                            21.299759009168312
                        ],
                        [
                            -157.82090309413016,
                            21.299751214338588
                        ],
                        [
                            -157.82090113669656,
                            21.299751282832521
                        ],
                        [
                            -157.82090005887181,
                            21.299724227751316
                        ],
                        [
                            -157.82090201630504,
                            21.299724159257366
                        ],
                        [
                            -157.82090174245519,
                            21.29971728162899
                        ],
                        [
                            -157.82089342481567,
                            21.299717572060704
                        ],
                        [
                            -157.82089349790354,
                            21.299719406456724
                        ],
                        [
                            -157.82087735053122,
                            21.299719970862895
                        ],
                        [
                            -157.82087703966391,
                            21.299712175129795
                        ],
                        [
                            -157.82087508319475,
                            21.2997122436302
                        ],
                        [
                            -157.8208727823218,
                            21.299654467392319
                        ],
                        [
                            -157.82087473975406,
                            21.29965439889866
                        ],
                        [
                            -157.82087444836012,
                            21.29964706222464
                        ],
                        [
                            -157.82087273585245,
                            21.299647121593701
                        ],
                        [
                            -157.82086725897759,
                            21.299509557281038
                        ],
                        [
                            -157.82086481170583,
                            21.299509643120594
                        ],
                        [
                            -157.82086508555409,
                            21.299516520749094
                        ],
                        [
                            -157.82084428954127,
                            21.29951724861758
                        ],
                        [
                            -157.82084305859166,
                            21.299486309687857
                        ],
                        [
                            -157.82053186101285,
                            21.299497191054627
                        ],
                        [
                            -157.82053309382502,
                            21.299528129997082
                        ],
                        [
                            -157.82051303161288,
                            21.299528831348695
                        ],
                        [
                            -157.82051275875219,
                            21.299521952823788
                        ],
                        [
                            -157.82051031148754,
                            21.299522037754819
                        ],
                        [
                            -157.82051587874327,
                            21.299661884665003
                        ],
                        [
                            -157.82050831023869,
                            21.299662160453639
                        ],
                        [
                            -157.82048407472411,
                            21.299663007809187
                        ],
                        [
                            -157.82048488101501,
                            21.299683250322285
                        ],
                        [
                            -157.82048679543371,
                            21.299731331368694
                        ],
                        [
                            -157.82046869159123,
                            21.299731964231356
                        ],
                        [
                            -157.82046863605271,
                            21.299730588880987
                        ],
                        [
                            -157.82046276472408,
                            21.299730793450994
                        ],
                        [
                            -157.82046334116535,
                            21.299745290592998
                        ],
                        [
                            -157.82046352512293,
                            21.299749900983201
                        ],
                        [
                            -157.82046447423934,
                            21.29977374722047
                        ],
                        [
                            -157.82046398536104,
                            21.299773764571885
                        ],
                        [
                            -157.82046432027241,
                            21.299782168455497
                        ],
                        [
                            -157.82046603182494,
                            21.299782108180583
                        ],
                        [
                            -157.82046641806082,
                            21.299791811500157
                        ],
                        [
                            -157.82046680846759,
                            21.299801596154161
                        ],
                        [
                            -157.82046509594372,
                            21.299801657325656
                        ],
                        [
                            -157.82046540583966,
                            21.299809451245
                        ],
                        [
                            -157.82046711834917,
                            21.299809391880167
                        ],
                        [
                            -157.82046860797811,
                            21.299846801804438
                        ],
                        [
                            -157.82046689450422,
                            21.299846861162493
                        ],
                        [
                            -157.82046720534976,
                            21.299854656895235
                        ],
                        [
                            -157.820468917867,
                            21.299854596627089
                        ],
                        [
                            -157.82046969288484,
                            21.29987404664671
                        ],
                        [
                            -157.8204679793962,
                            21.299874107811441
                        ],
                        [
                            -157.8204682902562,
                            21.299881901737486
                        ],
                        [
                            -157.82047000276654,
                            21.299881842372663
                        ],
                        [
                            -157.82047230347342,
                            21.299939619510745
                        ],
                        [
                            -157.82047059096237,
                            21.299939678875543
                        ],
                        [
                            -157.82047090180802,
                            21.29994747460821
                        ],
                        [
                            -157.82047261335524,
                            21.299947415236641
                        ],
                        [
                            -157.82047338903453,
                            21.299966903203138
                        ],
                        [
                            -157.82047167651595,
                            21.299966963471292
                        ],
                        [
                            -157.82047198736885,
                            21.299974758300582
                        ],
                        [
                            -157.8204736998803,
                            21.299974698935795
                        ],
                        [
                            -157.8204751878925,
                            21.300012070002285
                        ],
                        [
                            -157.82047347537343,
                            21.300012130270414
                        ],
                        [
                            -157.82047378526246,
                            21.300019925092933
                        ],
                        [
                            -157.82047549873835,
                            21.300019865734882
                        ],
                        [
                            -157.82047609686657,
                            21.300034906869833
                        ],
                        [
                            -157.82047627345398,
                            21.300039353694487
                        ],
                        [
                            -157.82047456093457,
                            21.300039413962626
                        ],
                        [
                            -157.82047490796947,
                            21.300048110629646
                        ],
                        [
                            -157.82047539684871,
                            21.300048093278235
                        ],
                        [
                            -157.82047678598644,
                            21.300082996490723
                        ],
                        [
                            -157.82047605315302,
                            21.300083022069536
                        ],
                        [
                            -157.82047631561451,
                            21.300089633117413
                        ],
                        [
                            -157.82048292172595,
                            21.300089402078932
                        ],
                        [
                            -157.82048283890001,
                            21.300087339056841
                        ],
                        [
                            -157.82050094375728,
                            21.300086705298117
                        ],
                        [
                            -157.82050144558031,
                            21.300099319249846
                        ],
                        [
                            -157.82050151872815,
                            21.300101145515661
                        ],
                        [
                            -157.82050352610716,
                            21.300151590482336
                        ],
                        [
                            -157.82050382721837,
                            21.300159156685297
                        ]
                    ],
                    [
                        [
                            -157.82075144534983,
                            21.300003558361436
                        ],
                        [
                            -157.8205753271636,
                            21.300009716585624
                        ],
                        [
                            -157.82056762487258,
                            21.299804729259158
                        ],
                        [
                            -157.82074328574527,
                            21.299798588606681
                        ],
                        [
                            -157.82075144534983,
                            21.300003558361436
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 309,
                "NUMBER": "1016",
                "PROPER_NAME": "ARCHITECTURE BUILDING",
                "DISPLAY_NAME": "ARCHITECTURE BUILDING (ARCH) - 1016",
                "ADDRESS": "2410 CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ARCHITECTURE BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1016_01.jpg",
                "HEIGHT (ft)": 43.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 335.80027641103209,
                "SHAPE_Area": 2643.4972658388151
            }
        },
        {
            "type": "Feature",
            "id": 310,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81615235311997,
                            21.294545023795941
                        ],
                        [
                            -157.81614841637878,
                            21.294541048291229
                        ],
                        [
                            -157.81614495191255,
                            21.294544062026709
                        ],
                        [
                            -157.81614335218777,
                            21.294545452837344
                        ],
                        [
                            -157.81613335872657,
                            21.294554145437253
                        ],
                        [
                            -157.81612209641048,
                            21.294542772940048
                        ],
                        [
                            -157.81612110193947,
                            21.29454176950577
                        ],
                        [
                            -157.81613109636436,
                            21.294533076913332
                        ],
                        [
                            -157.81601197963022,
                            21.294412796400717
                        ],
                        [
                            -157.81600291758568,
                            21.294403645452554
                        ],
                        [
                            -157.8159971047489,
                            21.294397776792241
                        ],
                        [
                            -157.81598711226115,
                            21.294406468487139
                        ],
                        [
                            -157.81597900546464,
                            21.294398283657848
                        ],
                        [
                            -157.81596607744746,
                            21.294385229064975
                        ],
                        [
                            -157.81596508394247,
                            21.29438422563662
                        ],
                        [
                            -157.81597507740824,
                            21.294375532143103
                        ],
                        [
                            -157.81595962498054,
                            21.294359929395636
                        ],
                        [
                            -157.81591428036879,
                            21.294314140969806
                        ],
                        [
                            -157.81588052853579,
                            21.294312961298047
                        ],
                        [
                            -157.81588031618026,
                            21.294318292517953
                        ],
                        [
                            -157.81582776300345,
                            21.294316455700116
                        ],
                        [
                            -157.81582797536089,
                            21.294311124480366
                        ],
                        [
                            -157.81579422352294,
                            21.294309945694707
                        ],
                        [
                            -157.81573246400774,
                            21.294363664017709
                        ],
                        [
                            -157.81574372627955,
                            21.294375036539211
                        ],
                        [
                            -157.81574265462314,
                            21.294375967622003
                        ],
                        [
                            -157.81571624352199,
                            21.294398939309318
                        ],
                        [
                            -157.81570498125066,
                            21.294387566786042
                        ],
                        [
                            -157.81556061016568,
                            21.294513140322639
                        ],
                        [
                            -157.81557154159046,
                            21.294524178079623
                        ],
                        [
                            -157.81556047837526,
                            21.29453380083585
                        ],
                        [
                            -157.81559757750256,
                            21.294571264409207
                        ],
                        [
                            -157.81560917159382,
                            21.294582970818794
                        ],
                        [
                            -157.81582831559362,
                            21.294392361548077
                        ],
                        [
                            -157.81587373372346,
                            21.294393949426656
                        ],
                        [
                            -157.81604854414073,
                            21.294570469383775
                        ],
                        [
                            -157.81605880147328,
                            21.294580826633062
                        ],
                        [
                            -157.81608705861987,
                            21.294609360229369
                        ],
                        [
                            -157.81610295859372,
                            21.29462541509919
                        ],
                        [
                            -157.81611885856378,
                            21.294641470870957
                        ],
                        [
                            -157.81612393661769,
                            21.294646530341872
                        ],
                        [
                            -157.8161337656642,
                            21.294656323569079
                        ],
                        [
                            -157.81614043022205,
                            21.294650448719104
                        ],
                        [
                            -157.8161910720973,
                            21.294605808822126
                        ],
                        [
                            -157.81619526659551,
                            21.29460997765754
                        ],
                        [
                            -157.81619793873301,
                            21.294612617186605
                        ],
                        [
                            -157.81619943090033,
                            21.294614064975356
                        ],
                        [
                            -157.81620698650642,
                            21.294607302032698
                        ],
                        [
                            -157.81620845543284,
                            21.294605994316896
                        ],
                        [
                            -157.81621128827356,
                            21.294603491973916
                        ],
                        [
                            -157.81620649694867,
                            21.294598738964716
                        ],
                        [
                            -157.81615235311997,
                            21.294545023795941
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 310,
                "NUMBER": "1109",
                "PROPER_NAME": "RAINBOW WĀHINE SOFTBALL STADIUM",
                "DISPLAY_NAME": "RAINBOW WĀHINE SOFTBALL STADIUM - 1109",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "SOFTBALL AND TENNIS COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1109_01.jpg",
                "HEIGHT (ft)": 30.400000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 198.10827271950959,
                "SHAPE_Area": 740.62900638143947
            }
        },
        {
            "type": "Feature",
            "id": 311,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81664679800977,
                            21.291441317918025
                        ],
                        [
                            -157.81663999944257,
                            21.29144914408247
                        ],
                        [
                            -157.81656605091783,
                            21.291534263890608
                        ],
                        [
                            -157.81655564542478,
                            21.291546532865734
                        ],
                        [
                            -157.81654595599582,
                            21.291556530329135
                        ],
                        [
                            -157.81654227880651,
                            21.291559275177736
                        ],
                        [
                            -157.81652983470326,
                            21.291570567707986
                        ],
                        [
                            -157.8165247266522,
                            21.291575288149996
                        ],
                        [
                            -157.81651984239781,
                            21.29158022878579
                        ],
                        [
                            -157.81651370461199,
                            21.291586306108304
                        ],
                        [
                            -157.81651217137573,
                            21.291587824769863
                        ],
                        [
                            -157.81650595189848,
                            21.291593871705828
                        ],
                        [
                            -157.81649716308533,
                            21.291603107615568
                        ],
                        [
                            -157.81648476525066,
                            21.291615723935042
                        ],
                        [
                            -157.81647784024412,
                            21.291622605159741
                        ],
                        [
                            -157.8164734617572,
                            21.291626980213639
                        ],
                        [
                            -157.81646402408697,
                            21.291636713844898
                        ],
                        [
                            -157.81645813647245,
                            21.291642967278474
                        ],
                        [
                            -157.81644506890743,
                            21.291656159766351
                        ],
                        [
                            -157.81643688675004,
                            21.291664267989098
                        ],
                        [
                            -157.81642071103917,
                            21.291680404454169
                        ],
                        [
                            -157.81641165085807,
                            21.291689581537323
                        ],
                        [
                            -157.81641080440926,
                            21.291690439227605
                        ],
                        [
                            -157.81634709156705,
                            21.291754973959652
                        ],
                        [
                            -157.816340834084,
                            21.291761311513472
                        ],
                        [
                            -157.81637657224047,
                            21.291799789782747
                        ],
                        [
                            -157.81648010163607,
                            21.291911259856001
                        ],
                        [
                            -157.81650614865751,
                            21.291893960561644
                        ],
                        [
                            -157.81660596713041,
                            21.291827660513221
                        ],
                        [
                            -157.81687073185688,
                            21.29165180107924
                        ],
                        [
                            -157.81691113766445,
                            21.291624962549506
                        ],
                        [
                            -157.81716416614233,
                            21.291456897708663
                        ],
                        [
                            -157.81690605642058,
                            21.29114289005172
                        ],
                        [
                            -157.81664679800977,
                            21.291441317918025
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 311,
                "NUMBER": "1116H",
                "PROPER_NAME": "PRACTICE FIELD H",
                "DISPLAY_NAME": "PRACTICE FIELD H - 1116H",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "PRACTICE FIELD H",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1116H_01.jpg",
                "HEIGHT (ft)": null,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 243.06766962630832,
                "SHAPE_Area": 2825.4967681452486
            }
        },
        {
            "type": "Feature",
            "id": 312,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81698714016966,
                            21.294711171697223
                        ],
                        [
                            -157.81699456058283,
                            21.294718769872784
                        ],
                        [
                            -157.81699883822466,
                            21.29472315247369
                        ],
                        [
                            -157.81703859142809,
                            21.294764122389793
                        ],
                        [
                            -157.81708033149238,
                            21.294807605039175
                        ],
                        [
                            -157.81709433715019,
                            21.294821888508768
                        ],
                        [
                            -157.81711742236976,
                            21.29484543501275
                        ],
                        [
                            -157.81715715242299,
                            21.294886294526492
                        ],
                        [
                            -157.81719842812933,
                            21.29492866813526
                        ],
                        [
                            -157.81721869626369,
                            21.29494950001569
                        ],
                        [
                            -157.81723728739439,
                            21.294968611797838
                        ],
                        [
                            -157.81727678077507,
                            21.295009301591605
                        ],
                        [
                            -157.81730390915027,
                            21.295037150423411
                        ],
                        [
                            -157.81736904310361,
                            21.295043814373976
                        ],
                        [
                            -157.8173985625981,
                            21.295018822599818
                        ],
                        [
                            -157.81743105204083,
                            21.29499141795165
                        ],
                        [
                            -157.81743113400105,
                            21.29499141491393
                        ],
                        [
                            -157.81743565096454,
                            21.294991188279447
                        ],
                        [
                            -157.81748134520504,
                            21.294988894898214
                        ],
                        [
                            -157.81753988107693,
                            21.294978905394455
                        ],
                        [
                            -157.81756534063229,
                            21.294972681016127
                        ],
                        [
                            -157.81758979370468,
                            21.294963578587513
                        ],
                        [
                            -157.8176256823088,
                            21.294947222759635
                        ],
                        [
                            -157.81763986456335,
                            21.294940760153491
                        ],
                        [
                            -157.81766570771015,
                            21.294926707862508
                        ],
                        [
                            -157.81768956917577,
                            21.294909857397013
                        ],
                        [
                            -157.81773377033608,
                            21.294872113435886
                        ],
                        [
                            -157.81775273457819,
                            21.29485289420068
                        ],
                        [
                            -157.81775418347843,
                            21.294851075914483
                        ],
                        [
                            -157.81776944947751,
                            21.294831921943683
                        ],
                        [
                            -157.81779904801661,
                            21.294785942169664
                        ],
                        [
                            -157.8178125830562,
                            21.29475987864754
                        ],
                        [
                            -157.81782364204034,
                            21.294732808520735
                        ],
                        [
                            -157.81783272976264,
                            21.294702842731198
                        ],
                        [
                            -157.81783449604626,
                            21.294697015617789
                        ],
                        [
                            -157.81784186188406,
                            21.294660452917952
                        ],
                        [
                            -157.81784568031702,
                            21.294623416317975
                        ],
                        [
                            -157.81784285801751,
                            21.294581688745659
                        ],
                        [
                            -157.81784285501854,
                            21.294578447358081
                        ],
                        [
                            -157.81786185160701,
                            21.294561565407317
                        ],
                        [
                            -157.8179047572481,
                            21.294523437388076
                        ],
                        [
                            -157.81787927995742,
                            21.294498257119074
                        ],
                        [
                            -157.81786976101009,
                            21.2944888483017
                        ],
                        [
                            -157.81782935566306,
                            21.294445269518413
                        ],
                        [
                            -157.81778890626586,
                            21.294404911908664
                        ],
                        [
                            -157.81774964793718,
                            21.294364844513627
                        ],
                        [
                            -157.81771019711957,
                            21.294323657360128
                        ],
                        [
                            -157.81768942368402,
                            21.29430176592485
                        ],
                        [
                            -157.8176709195584,
                            21.294282263635129
                        ],
                        [
                            -157.81763246514095,
                            21.294242929994603
                        ],
                        [
                            -157.81759275225744,
                            21.294202217061692
                        ],
                        [
                            -157.81755405801218,
                            21.294162382144666
                        ],
                        [
                            -157.81751301368809,
                            21.294120136724096
                        ],
                        [
                            -157.81747514060868,
                            21.294081044725928
                        ],
                        [
                            -157.81743536142892,
                            21.294039833524437
                        ],
                        [
                            -157.81739483816355,
                            21.293997771512625
                        ],
                        [
                            -157.81735610610164,
                            21.293958339199975
                        ],
                        [
                            -157.81731716026508,
                            21.29391827932719
                        ],
                        [
                            -157.81727625679758,
                            21.293876397102444
                        ],
                        [
                            -157.81723212232419,
                            21.293830765678095
                        ],
                        [
                            -157.81722169436085,
                            21.293819441574502
                        ],
                        [
                            -157.8171812320945,
                            21.293778083685037
                        ],
                        [
                            -157.81714028185644,
                            21.293736153221246
                        ],
                        [
                            -157.8171022802884,
                            21.293696639262183
                        ],
                        [
                            -157.81706485426992,
                            21.293657841211864
                        ],
                        [
                            -157.81702571633301,
                            21.293617353526002
                        ],
                        [
                            -157.81702313217838,
                            21.293614681202772
                        ],
                        [
                            -157.81699323172364,
                            21.293584071963664
                        ],
                        [
                            -157.81699174881129,
                            21.293582551975689
                        ],
                        [
                            -157.81692473904485,
                            21.293513931924643
                        ],
                        [
                            -157.81690676682638,
                            21.293529410779502
                        ],
                        [
                            -157.81686346889509,
                            21.293566698349164
                        ],
                        [
                            -157.81682417724332,
                            21.293565543172058
                        ],
                        [
                            -157.81680013854765,
                            21.293541561724787
                        ],
                        [
                            -157.81679633243476,
                            21.293537766024713
                        ],
                        [
                            -157.81679045445304,
                            21.293531606041622
                        ],
                        [
                            -157.81674439618317,
                            21.29348332759071
                        ],
                        [
                            -157.81669018702908,
                            21.293531496543565
                        ],
                        [
                            -157.81668675023269,
                            21.293534550235623
                        ],
                        [
                            -157.81664331555183,
                            21.293569646965953
                        ],
                        [
                            -157.8165990175363,
                            21.293607707059742
                        ],
                        [
                            -157.81655994416488,
                            21.293640938211229
                        ],
                        [
                            -157.81655520302959,
                            21.293644970136047
                        ],
                        [
                            -157.81655514770472,
                            21.293645017626787
                        ],
                        [
                            -157.81649524818906,
                            21.293696087040576
                        ],
                        [
                            -157.81649442993958,
                            21.29369679225589
                        ],
                        [
                            -157.81648880797286,
                            21.29370164007101
                        ],
                        [
                            -157.81648740150641,
                            21.293702853372999
                        ],
                        [
                            -157.81645467915013,
                            21.293731071971262
                        ],
                        [
                            -157.81643639475365,
                            21.293745319966224
                        ],
                        [
                            -157.81645025600764,
                            21.293758717146549
                        ],
                        [
                            -157.81643728272854,
                            21.293783346308224
                        ],
                        [
                            -157.8164268795982,
                            21.293809024309308
                        ],
                        [
                            -157.81641855830046,
                            21.293836062096617
                        ],
                        [
                            -157.81641222860682,
                            21.293863569196308
                        ],
                        [
                            -157.81640832564699,
                            21.293891617325951
                        ],
                        [
                            -157.81640733779764,
                            21.293919888312804
                        ],
                        [
                            -157.81640759539931,
                            21.293923110711692
                        ],
                        [
                            -157.81641090335714,
                            21.293964326777004
                        ],
                        [
                            -157.81642005679134,
                            21.294008057428538
                        ],
                        [
                            -157.81638386178352,
                            21.29397071150612
                        ],
                        [
                            -157.81633793682872,
                            21.293923240611424
                        ],
                        [
                            -157.81630517409101,
                            21.293952279171538
                        ],
                        [
                            -157.81627470071703,
                            21.293978066260728
                        ],
                        [
                            -157.8163157341744,
                            21.294020655180571
                        ],
                        [
                            -157.81635621335525,
                            21.294062525611555
                        ],
                        [
                            -157.81636753644977,
                            21.294074130691733
                        ],
                        [
                            -157.81639506162014,
                            21.294102341999213
                        ],
                        [
                            -157.81639583032589,
                            21.294103129740797
                        ],
                        [
                            -157.81639347124542,
                            21.294105094287936
                        ],
                        [
                            -157.81636942529835,
                            21.294125120497835
                        ],
                        [
                            -157.8163674310922,
                            21.294126781360941
                        ],
                        [
                            -157.81640850031727,
                            21.294167680267844
                        ],
                        [
                            -157.81641456241368,
                            21.294174081860739
                        ],
                        [
                            -157.81642393371956,
                            21.294183977549093
                        ],
                        [
                            -157.81643229658914,
                            21.294192808275714
                        ],
                        [
                            -157.81643326296262,
                            21.294193829578425
                        ],
                        [
                            -157.81641232807144,
                            21.294211637260734
                        ],
                        [
                            -157.81641314746633,
                            21.294212475045164
                        ],
                        [
                            -157.81641335685919,
                            21.294212688814341
                        ],
                        [
                            -157.81641427857338,
                            21.294213629401369
                        ],
                        [
                            -157.81647673400266,
                            21.294277400751998
                        ],
                        [
                            -157.81647896943949,
                            21.29427968307699
                        ],
                        [
                            -157.81648003074744,
                            21.294280766477545
                        ],
                        [
                            -157.81648113727243,
                            21.294279813953619
                        ],
                        [
                            -157.816485030536,
                            21.294276457226971
                        ],
                        [
                            -157.81650574885333,
                            21.294297865102354
                        ],
                        [
                            -157.81652508952399,
                            21.294317849482827
                        ],
                        [
                            -157.81656427286447,
                            21.294358931130684
                        ],
                        [
                            -157.81658323175517,
                            21.294378924564814
                        ],
                        [
                            -157.81658240480542,
                            21.294379632429365
                        ],
                        [
                            -157.81659617972494,
                            21.294393708342316
                        ],
                        [
                            -157.81660395782154,
                            21.294401655950693
                        ],
                        [
                            -157.81664411350442,
                            21.294443019048188
                        ],
                        [
                            -157.81668411971484,
                            21.294484151624761
                        ],
                        [
                            -157.81668457194195,
                            21.294484616436584
                        ],
                        [
                            -157.81672334325384,
                            21.294524677935659
                        ],
                        [
                            -157.81673994124876,
                            21.294541688925129
                        ],
                        [
                            -157.8167425122225,
                            21.294544323217792
                        ],
                        [
                            -157.81676468336619,
                            21.294567045772723
                        ],
                        [
                            -157.81677602748576,
                            21.294578802744958
                        ],
                        [
                            -157.8168004222351,
                            21.294604083971169
                        ],
                        [
                            -157.81680346716018,
                            21.294607239237447
                        ],
                        [
                            -157.81680082485732,
                            21.294609542377447
                        ],
                        [
                            -157.81680079504787,
                            21.294610978559014
                        ],
                        [
                            -157.81683571476518,
                            21.294647752622648
                        ],
                        [
                            -157.81686651765082,
                            21.294678602214699
                        ],
                        [
                            -157.81686797011579,
                            21.294679230343402
                        ],
                        [
                            -157.81686957379702,
                            21.294678789920457
                        ],
                        [
                            -157.81688911680405,
                            21.294662060984894
                        ],
                        [
                            -157.81692740558563,
                            21.294701602309022
                        ],
                        [
                            -157.81695428398717,
                            21.294729474731302
                        ],
                        [
                            -157.81697927772638,
                            21.294708098208613
                        ],
                        [
                            -157.81698192647934,
                            21.294705832150125
                        ],
                        [
                            -157.81698714016966,
                            21.294711171697223
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 312,
                "NUMBER": "1254A",
                "PROPER_NAME": "CLARENCE T.C. CHING FIELD",
                "DISPLAY_NAME": "CLARENCE T.C. CHING FIELD - 1254A",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CLARENCE TC CHING ATHLETICS COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1254A_01.jpg",
                "HEIGHT (ft)": null,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 539.71045461321785,
                "SHAPE_Area": 14960.653779422933
            }
        },
        {
            "type": "Feature",
            "id": 315,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81559800315085,
                            21.295045849961323
                        ],
                        [
                            -157.81553646479165,
                            21.295671535026194
                        ],
                        [
                            -157.81553577872242,
                            21.295673306263321
                        ],
                        [
                            -157.81556279368584,
                            21.295703731939895
                        ],
                        [
                            -157.81585382012796,
                            21.295728472835734
                        ],
                        [
                            -157.81584821371266,
                            21.295788888270518
                        ],
                        [
                            -157.81662267330742,
                            21.29585507460332
                        ],
                        [
                            -157.81662278431068,
                            21.295853972343998
                        ],
                        [
                            -157.81665602160095,
                            21.29582831756607
                        ],
                        [
                            -157.81671731158394,
                            21.295196715673995
                        ],
                        [
                            -157.81669063535603,
                            21.295165619530806
                        ],
                        [
                            -157.81639855724717,
                            21.295140990164882
                        ],
                        [
                            -157.81640409632851,
                            21.29508690518453
                        ],
                        [
                            -157.81563043251668,
                            21.295020449874791
                        ],
                        [
                            -157.81559800315085,
                            21.295045849961323
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 315,
                "NUMBER": "1116E",
                "PROPER_NAME": "UH TENNIS COMPLEX",
                "DISPLAY_NAME": "UH TENNIS COMPLEX - 1116E",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "SOFTBALL AND TENNIS COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1116E_01.jpg",
                "HEIGHT (ft)": null,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 392.48363839421614,
                "SHAPE_Area": 9241.051911620294
            }
        },
        {
            "type": "Feature",
            "id": 316,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8152044040215,
                            21.298556362764892
                        ],
                        [
                            -157.81520293647884,
                            21.298556409346958
                        ],
                        [
                            -157.8152030358909,
                            21.298559159965514
                        ],
                        [
                            -157.81520597097631,
                            21.298559066801374
                        ],
                        [
                            -157.81520594660523,
                            21.29855837915013
                        ],
                        [
                            -157.81522880245805,
                            21.298557655634799
                        ],
                        [
                            -157.81528789558229,
                            21.298555786958161
                        ],
                        [
                            -157.81529106400873,
                            21.298555686401247
                        ],
                        [
                            -157.81529108838021,
                            21.298556374052492
                        ],
                        [
                            -157.81529402442226,
                            21.298556281796948
                        ],
                        [
                            -157.8152939903228,
                            21.298555364616185
                        ],
                        [
                            -157.81529521391406,
                            21.298555326253322
                        ],
                        [
                            -157.81529597854168,
                            21.29855530182402
                        ],
                        [
                            -157.8153250391394,
                            21.29855438257513
                        ],
                        [
                            -157.81532627623272,
                            21.298554343403701
                        ],
                        [
                            -157.81532631033232,
                            21.298555260584454
                        ],
                        [
                            -157.81532924445378,
                            21.298555167411383
                        ],
                        [
                            -157.81532921227475,
                            21.298554251147539
                        ],
                        [
                            -157.81532964039289,
                            21.298554236996761
                        ],
                        [
                            -157.81533086302016,
                            21.298554198626853
                        ],
                        [
                            -157.81536068535362,
                            21.298553254921966
                        ],
                        [
                            -157.8153614981845,
                            21.298553229928263
                        ],
                        [
                            -157.81536150920329,
                            21.298553538965177
                        ],
                        [
                            -157.81536153036376,
                            21.298554146192128
                        ],
                        [
                            -157.81536446640578,
                            21.298554053935344
                        ],
                        [
                            -157.81536436699795,
                            21.298551302413408
                        ],
                        [
                            -157.81536143190544,
                            21.298551396483642
                        ],
                        [
                            -157.8153614650486,
                            21.298552312754296
                        ],
                        [
                            -157.81536048636551,
                            21.298552343807664
                        ],
                        [
                            -157.81535926373823,
                            21.298552382177764
                        ],
                        [
                            -157.81535779619557,
                            21.298552428761184
                        ],
                        [
                            -157.81535657356829,
                            21.298552467131284
                        ],
                        [
                            -157.81535504528415,
                            21.298552515093895
                        ],
                        [
                            -157.8153538216857,
                            21.298552554360526
                        ],
                        [
                            -157.81535235414304,
                            21.298552600943886
                        ],
                        [
                            -157.81535113055187,
                            21.298552639307157
                        ],
                        [
                            -157.81534978546324,
                            21.29855268223552
                        ],
                        [
                            -157.81534856283596,
                            21.298552720605564
                        ],
                        [
                            -157.8153470952933,
                            21.298552767188891
                        ],
                        [
                            -157.81534587265878,
                            21.298552806462251
                        ],
                        [
                            -157.81534434437467,
                            21.298552854424759
                        ],
                        [
                            -157.81534312078347,
                            21.298552892787963
                        ],
                        [
                            -157.81534165324081,
                            21.298552939371238
                        ],
                        [
                            -157.81534042964958,
                            21.298552977734435
                        ],
                        [
                            -157.81533896210692,
                            21.298553024317695
                        ],
                        [
                            -157.81533774044354,
                            21.298553062694427
                        ],
                        [
                            -157.81533627192971,
                            21.298553110174208
                        ],
                        [
                            -157.81533504930243,
                            21.298553148544155
                        ],
                        [
                            -157.81533352101832,
                            21.298553196506564
                        ],
                        [
                            -157.81533229741987,
                            21.298553235773042
                        ],
                        [
                            -157.81533082987721,
                            21.298553282356227
                        ],
                        [
                            -157.81532960628599,
                            21.298553320719332
                        ],
                        [
                            -157.81532917913901,
                            21.298553333973558
                        ],
                        [
                            -157.81532914600331,
                            21.298552416799573
                        ],
                        [
                            -157.81532621091799,
                            21.298552509965877
                        ],
                        [
                            -157.81532624405369,
                            21.298553427139844
                        ],
                        [
                            -157.81532483822366,
                            21.298553471447224
                        ],
                        [
                            -157.81532361463243,
                            21.298553509810297
                        ],
                        [
                            -157.81532214708977,
                            21.29855355639339
                        ],
                        [
                            -157.81532092349133,
                            21.298553595659783
                        ],
                        [
                            -157.81531939520718,
                            21.298553643622068
                        ],
                        [
                            -157.81531817257991,
                            21.298553681991887
                        ],
                        [
                            -157.81531670407333,
                            21.298553728568166
                        ],
                        [
                            -157.81531548144602,
                            21.298553766937946
                        ],
                        [
                            -157.81531413732134,
                            21.298553809872825
                        ],
                        [
                            -157.81531291373011,
                            21.298553848235802
                        ],
                        [
                            -157.81531144618745,
                            21.29855389481882
                        ],
                        [
                            -157.81531022259625,
                            21.298553933181797
                        ],
                        [
                            -157.81530869430489,
                            21.29855398204732
                        ],
                        [
                            -157.81530747167761,
                            21.298554020417061
                        ],
                        [
                            -157.815306003171,
                            21.298554066993226
                        ],
                        [
                            -157.81530478053648,
                            21.298554106266288
                        ],
                        [
                            -157.81530331396496,
                            21.298554151952679
                        ],
                        [
                            -157.81530209037376,
                            21.298554190315595
                        ],
                        [
                            -157.81530062283107,
                            21.2985542368985
                        ],
                        [
                            -157.81529939923263,
                            21.298554276164737
                        ],
                        [
                            -157.81529787094848,
                            21.29855432412683
                        ],
                        [
                            -157.81529664832121,
                            21.298554362496485
                        ],
                        [
                            -157.8152951807713,
                            21.2985544099827
                        ],
                        [
                            -157.815293958144,
                            21.298554448352327
                        ],
                        [
                            -157.81529392500849,
                            21.298553531178364
                        ],
                        [
                            -157.81529245650191,
                            21.298553577754429
                        ],
                        [
                            -157.8152913677707,
                            21.29852332098395
                        ],
                        [
                            -157.81529283531307,
                            21.298523274401095
                        ],
                        [
                            -157.81529273589936,
                            21.298520523782521
                        ],
                        [
                            -157.81529126836423,
                            21.298520569462021
                        ],
                        [
                            -157.81529076541625,
                            21.298506587770049
                        ],
                        [
                            -157.81532720902672,
                            21.298505435021521
                        ],
                        [
                            -157.81532716243669,
                            21.298504151879918
                        ],
                        [
                            -157.81532597503056,
                            21.298471171597537
                        ],
                        [
                            -157.81532558228051,
                            21.2984602784678
                        ],
                        [
                            -157.81532619359379,
                            21.298460259282852
                        ],
                        [
                            -157.81532650021433,
                            21.298460249697165
                        ],
                        [
                            -157.81533469318035,
                            21.298459990279394
                        ],
                        [
                            -157.81533499980088,
                            21.298459980693671
                        ],
                        [
                            -157.81534270390037,
                            21.298459737708864
                        ],
                        [
                            -157.81534250603494,
                            21.29845423647841
                        ],
                        [
                            -157.8153439735766,
                            21.298454189895097
                        ],
                        [
                            -157.81534427923322,
                            21.298454180302574
                        ],
                        [
                            -157.81535247316282,
                            21.298453920890704
                        ],
                        [
                            -157.81535277881943,
                            21.298453911298182
                        ],
                        [
                            -157.81535791521168,
                            21.298453748707832
                        ],
                        [
                            -157.81535796395525,
                            21.298455124010363
                        ],
                        [
                            -157.81535943246087,
                            21.298455077433676
                        ],
                        [
                            -157.81535957040529,
                            21.298458914198161
                        ],
                        [
                            -157.81536042911262,
                            21.298482752571399
                        ],
                        [
                            -157.81536052217018,
                            21.298485334211367
                        ],
                        [
                            -157.81535905366428,
                            21.298485380788048
                        ],
                        [
                            -157.81535915404316,
                            21.298488131413436
                        ],
                        [
                            -157.81536062061403,
                            21.298488085726543
                        ],
                        [
                            -157.81536082327176,
                            21.298493710755118
                        ],
                        [
                            -157.81536162220235,
                            21.298515866595526
                        ],
                        [
                            -157.81536171032349,
                            21.298518342504114
                        ],
                        [
                            -157.81536024375231,
                            21.298518388191013
                        ],
                        [
                            -157.81536034220338,
                            21.298521138802844
                        ],
                        [
                            -157.81536180974575,
                            21.298521092219385
                        ],
                        [
                            -157.81536221424213,
                            21.298532324202949
                        ],
                        [
                            -157.8153776253549,
                            21.298531836444511
                        ],
                        [
                            -157.81539865785922,
                            21.298531171439208
                        ],
                        [
                            -157.81541382309268,
                            21.298530691884032
                        ],
                        [
                            -157.81545026670955,
                            21.298529539109079
                        ],
                        [
                            -157.8154501682568,
                            21.298526788497234
                        ],
                        [
                            -157.81545015802081,
                            21.298526502050581
                        ],
                        [
                            -157.81544988120677,
                            21.298518823094774
                        ],
                        [
                            -157.81544987097075,
                            21.298518536648125
                        ],
                        [
                            -157.81544986219924,
                            21.29851830802874
                        ],
                        [
                            -157.81545133071273,
                            21.298518260547947
                        ],
                        [
                            -157.81545123033214,
                            21.298515509922542
                        ],
                        [
                            -157.81544976375375,
                            21.29851555651355
                        ],
                        [
                            -157.8154497471819,
                            21.298515098378228
                        ],
                        [
                            -157.81544973695313,
                            21.298514811028237
                        ],
                        [
                            -157.81544953259584,
                            21.298509157079209
                        ],
                        [
                            -157.81544879227664,
                            21.298488587100515
                        ],
                        [
                            -157.8154487086272,
                            21.298486274736948
                        ],
                        [
                            -157.81544869839843,
                            21.298485987386961
                        ],
                        [
                            -157.81544867402621,
                            21.298485299735702
                        ],
                        [
                            -157.81545014059708,
                            21.298485254048007
                        ],
                        [
                            -157.81545004215155,
                            21.29848250253281
                        ],
                        [
                            -157.81544857460233,
                            21.298482550020392
                        ],
                        [
                            -157.81544855023739,
                            21.298481861465792
                        ],
                        [
                            -157.81544854000137,
                            21.298481575019142
                        ],
                        [
                            -157.81544839312383,
                            21.298477529508705
                        ],
                        [
                            -157.81544759375191,
                            21.298455306814141
                        ],
                        [
                            -157.81544750292579,
                            21.298452807398341
                        ],
                        [
                            -157.81544749268977,
                            21.298452520951688
                        ],
                        [
                            -157.81544748488218,
                            21.298452292339089
                        ],
                        [
                            -157.81544895242385,
                            21.298452245754852
                        ],
                        [
                            -157.81544885397111,
                            21.298449495142979
                        ],
                        [
                            -157.81544738546555,
                            21.298449541720448
                        ],
                        [
                            -157.81544736890092,
                            21.298449082681771
                        ],
                        [
                            -157.8154473586649,
                            21.298448796235139
                        ],
                        [
                            -157.81544724598916,
                            21.298445655258714
                        ],
                        [
                            -157.81544640070058,
                            21.298422185562803
                        ],
                        [
                            -157.81544632253892,
                            21.298420030427696
                        ],
                        [
                            -157.81544631231012,
                            21.298419743077705
                        ],
                        [
                            -157.81544629573827,
                            21.298419284942383
                        ],
                        [
                            -157.81544776424354,
                            21.298419238364907
                        ],
                        [
                            -157.81544766482688,
                            21.298416487746259
                        ],
                        [
                            -157.81544619728558,
                            21.298416534330499
                        ],
                        [
                            -157.81544617194945,
                            21.298415846672452
                        ],
                        [
                            -157.81544616171342,
                            21.298415560225799
                        ],
                        [
                            -157.81544605306817,
                            21.298412517747241
                        ],
                        [
                            -157.81544525412463,
                            21.298390361906399
                        ],
                        [
                            -157.81544513436631,
                            21.298387022134328
                        ],
                        [
                            -157.81544512413029,
                            21.298386735687675
                        ],
                        [
                            -157.81544510756567,
                            21.298386276649008
                        ],
                        [
                            -157.81544657509946,
                            21.298386230968088
                        ],
                        [
                            -157.81544647568279,
                            21.298383480349415
                        ],
                        [
                            -157.81544500910576,
                            21.298383526940462
                        ],
                        [
                            -157.81544499157721,
                            21.29838306789501
                        ],
                        [
                            -157.81544498134119,
                            21.298382781448357
                        ],
                        [
                            -157.815444810287,
                            21.298378023896447
                        ],
                        [
                            -157.81544405080135,
                            21.298356958724899
                        ],
                        [
                            -157.81544396179453,
                            21.298354472872738
                        ],
                        [
                            -157.81544395155851,
                            21.298354186426081
                        ],
                        [
                            -157.81544391841484,
                            21.298353270155406
                        ],
                        [
                            -157.81544538595551,
                            21.298353223571151
                        ],
                        [
                            -157.8154452875028,
                            21.298350472959253
                        ],
                        [
                            -157.81544235242146,
                            21.298350566127759
                        ],
                        [
                            -157.81544238460125,
                            21.298351482391649
                        ],
                        [
                            -157.8154348309221,
                            21.298351721019657
                        ],
                        [
                            -157.8154115980926,
                            21.298352456365123
                        ],
                        [
                            -157.81541009872811,
                            21.29835250453187
                        ],
                        [
                            -157.81541007436331,
                            21.298351815977266
                        ],
                        [
                            -157.81540713928197,
                            21.298351909145151
                        ],
                        [
                            -157.81540716461791,
                            21.298352596803205
                        ],
                        [
                            -157.81540614544431,
                            21.298352628475278
                        ],
                        [
                            -157.81537647068157,
                            21.298353566904879
                        ],
                        [
                            -157.81537487778797,
                            21.298353618026542
                        ],
                        [
                            -157.81537485341613,
                            21.298352930375259
                        ],
                        [
                            -157.81537191737084,
                            21.298353023535764
                        ],
                        [
                            -157.81537194271385,
                            21.298353710290474
                        ],
                        [
                            -157.81536630879089,
                            21.298353888350476
                        ],
                        [
                            -157.81534312803453,
                            21.298354621342821
                        ],
                        [
                            -157.81534143003759,
                            21.298354676241267
                        ],
                        [
                            -157.81534112534507,
                            21.298354685840565
                        ],
                        [
                            -157.81533965684773,
                            21.298354731513797
                        ],
                        [
                            -157.81533963150486,
                            21.298354044759087
                        ],
                        [
                            -157.81533669739466,
                            21.29835413702919
                        ],
                        [
                            -157.81533672175911,
                            21.298354825583804
                        ],
                        [
                            -157.81533180039662,
                            21.298354980653379
                        ],
                        [
                            -157.81530670470354,
                            21.298355774239067
                        ],
                        [
                            -157.81530443590006,
                            21.298355845896992
                        ],
                        [
                            -157.81530441152853,
                            21.298355158245734
                        ],
                        [
                            -157.81530147549049,
                            21.298355250501647
                        ],
                        [
                            -157.81530150081869,
                            21.298355939063047
                        ],
                        [
                            -157.81529905267561,
                            21.298356015782201
                        ],
                        [
                            -157.81528795838568,
                            21.298356366795137
                        ],
                        [
                            -157.81528682542623,
                            21.298356403085826
                        ],
                        [
                            -157.81528680009083,
                            21.298355715427778
                        ],
                        [
                            -157.8152853335213,
                            21.298355761114109
                        ],
                        [
                            -157.81528531528275,
                            21.298355270445001
                        ],
                        [
                            -157.81528431005441,
                            21.298327344104248
                        ],
                        [
                            -157.81528426974248,
                            21.298326239878037
                        ],
                        [
                            -157.81528425950677,
                            21.298325953431384
                        ],
                        [
                            -157.81528423506293,
                            21.298325274813514
                        ],
                        [
                            -157.81528570259607,
                            21.298325229133969
                        ],
                        [
                            -157.81528560318242,
                            21.298322478515317
                        ],
                        [
                            -157.81528413660598,
                            21.298322525104989
                        ],
                        [
                            -157.81528406067952,
                            21.298320452194108
                        ],
                        [
                            -157.81528405044381,
                            21.298320165747455
                        ],
                        [
                            -157.81528398194726,
                            21.298318248271922
                        ],
                        [
                            -157.8152831454266,
                            21.298295010808836
                        ],
                        [
                            -157.81528308063463,
                            21.298293232481441
                        ],
                        [
                            -157.81528307039892,
                            21.298292946034785
                        ],
                        [
                            -157.81528304691173,
                            21.298292268327017
                        ],
                        [
                            -157.81528451348788,
                            21.298292221737363
                        ],
                        [
                            -157.81528441503815,
                            21.298289471125489
                        ],
                        [
                            -157.81528294653418,
                            21.298289517701594
                        ],
                        [
                            -157.8152828812272,
                            21.298287683360392
                        ],
                        [
                            -157.81528287099152,
                            21.298287396913736
                        ],
                        [
                            -157.81528280001592,
                            21.298285427927528
                        ],
                        [
                            -157.81528200131376,
                            21.298263244986586
                        ],
                        [
                            -157.81528190117518,
                            21.29826046455095
                        ],
                        [
                            -157.81528189094672,
                            21.298260177200959
                        ],
                        [
                            -157.81528185684735,
                            21.298259260020185
                        ],
                        [
                            -157.81528332534376,
                            21.298259214347411
                        ],
                        [
                            -157.81528327564416,
                            21.298257838134742
                        ],
                        [
                            -157.81528467857243,
                            21.298257794710576
                        ],
                        [
                            -157.8152969713818,
                            21.298257405158118
                        ],
                        [
                            -157.81529795101963,
                            21.298257375015151
                        ],
                        [
                            -157.8152980007338,
                            21.298258749421151
                        ],
                        [
                            -157.8153009348421,
                            21.298258657151617
                        ],
                        [
                            -157.81530088609904,
                            21.298257281849086
                        ],
                        [
                            -157.81530094781152,
                            21.298257279573313
                        ],
                        [
                            -157.81530548541542,
                            21.298257136257369
                        ],
                        [
                            -157.8153290778798,
                            21.298256389906665
                        ],
                        [
                            -157.81533213252129,
                            21.298256293064714
                        ],
                        [
                            -157.81533243817751,
                            21.298256283472192
                        ],
                        [
                            -157.81533317194371,
                            21.298256260632208
                        ],
                        [
                            -157.81533322165103,
                            21.298257635941532
                        ],
                        [
                            -157.81533615672322,
                            21.29825754367819
                        ],
                        [
                            -157.81533610702314,
                            21.298256167465507
                        ],
                        [
                            -157.8153381993701,
                            21.298256101792102
                        ],
                        [
                            -157.81536255838108,
                            21.298255331924025
                        ],
                        [
                            -157.8153680409217,
                            21.298255158218776
                        ],
                        [
                            -157.81536834657791,
                            21.298255148626186
                        ],
                        [
                            -157.8153683928677,
                            21.298255146241857
                        ],
                        [
                            -157.8153686404346,
                            21.298262023685115
                        ],
                        [
                            -157.81536869014946,
                            21.29826339809112
                        ],
                        [
                            -157.81537162522179,
                            21.29826330582716
                        ],
                        [
                            -157.81537157551415,
                            21.298261930517818
                        ],
                        [
                            -157.81537842434713,
                            21.298261714032833
                        ],
                        [
                            -157.8153784496902,
                            21.298262400787554
                        ],
                        [
                            -157.81538138379858,
                            21.29826230851663
                        ],
                        [
                            -157.81538135942668,
                            21.298261620865361
                        ],
                        [
                            -157.81538160337038,
                            21.298261613548544
                        ],
                        [
                            -157.81538190902663,
                            21.298261603955932
                        ],
                        [
                            -157.81538459727068,
                            21.298261518084871
                        ],
                        [
                            -157.8154013582535,
                            21.298260988331403
                        ],
                        [
                            -157.8154035557111,
                            21.298260917976702
                        ],
                        [
                            -157.81540386136732,
                            21.298260908384066
                        ],
                        [
                            -157.81540391203194,
                            21.298262284603521
                        ],
                        [
                            -157.81540684614757,
                            21.298262191428826
                        ],
                        [
                            -157.81540679740351,
                            21.298260816126259
                        ],
                        [
                            -157.8154080200284,
                            21.298260777755676
                        ],
                        [
                            -157.81540832568464,
                            21.298260768163036
                        ],
                        [
                            -157.81541370794173,
                            21.298260598267376
                        ],
                        [
                            -157.81542356514097,
                            21.298260285514747
                        ],
                        [
                            -157.81542679141072,
                            21.29826018355536
                        ],
                        [
                            -157.81542709803085,
                            21.298260173969471
                        ],
                        [
                            -157.81542734197458,
                            21.298260166652589
                        ],
                        [
                            -157.81542739264663,
                            21.298261541968728
                        ],
                        [
                            -157.81543032676228,
                            21.298261448793596
                        ],
                        [
                            -157.815430278018,
                            21.298260073491047
                        ],
                        [
                            -157.81543033875934,
                            21.298260072111784
                        ],
                        [
                            -157.81543853267823,
                            21.298259812695214
                        ],
                        [
                            -157.81543883833444,
                            21.298259803102514
                        ],
                        [
                            -157.81543908324932,
                            21.298259794889063
                        ],
                        [
                            -157.81543913199368,
                            21.298261170191633
                        ],
                        [
                            -157.81544206707323,
                            21.298261077023088
                        ],
                        [
                            -157.81544196862055,
                            21.29825832641118
                        ],
                        [
                            -157.81544123484707,
                            21.298258350154985
                        ],
                        [
                            -157.81544094554255,
                            21.298250305238131
                        ],
                        [
                            -157.81543973431081,
                            21.298216686090282
                        ],
                        [
                            -157.81543956615673,
                            21.298212047806178
                        ],
                        [
                            -157.81543893941267,
                            21.298194626940187
                        ],
                        [
                            -157.81543845607408,
                            21.298181203680649
                        ],
                        [
                            -157.81543738618157,
                            21.298151479138038
                        ],
                        [
                            -157.81543727265057,
                            21.298148324604643
                        ],
                        [
                            -157.81543800545236,
                            21.298148301757376
                        ],
                        [
                            -157.81543790699246,
                            21.29814555204878
                        ],
                        [
                            -157.81543497192249,
                            21.298145644314008
                        ],
                        [
                            -157.8154350206668,
                            21.298147019616593
                        ],
                        [
                            -157.81542621544222,
                            21.298147298218659
                        ],
                        [
                            -157.81542616669796,
                            21.298145922916095
                        ],
                        [
                            -157.81542323162796,
                            21.298146015181118
                        ],
                        [
                            -157.81542328133608,
                            21.298147390490485
                        ],
                        [
                            -157.81540273485294,
                            21.298148039950828
                        ],
                        [
                            -157.81540268610166,
                            21.298146665551588
                        ],
                        [
                            -157.81539975103166,
                            21.298146757816212
                        ],
                        [
                            -157.81539980073234,
                            21.298148134028917
                        ],
                        [
                            -157.81537925424911,
                            21.298148783486383
                        ],
                        [
                            -157.81537920550531,
                            21.298147408183802
                        ],
                        [
                            -157.81537627043528,
                            21.298147500448003
                        ],
                        [
                            -157.81537632013575,
                            21.298148876660704
                        ],
                        [
                            -157.81536751491109,
                            21.298149155259708
                        ],
                        [
                            -157.8153674642468,
                            21.298147779040224
                        ],
                        [
                            -157.81536736578823,
                            21.298145029331625
                        ],
                        [
                            -157.81536589729293,
                            21.298145075005184
                        ],
                        [
                            -157.81536561764088,
                            21.298137269554534
                        ],
                        [
                            -157.81536501041322,
                            21.298120421575089
                        ],
                        [
                            -157.81536647795156,
                            21.298120374991402
                        ],
                        [
                            -157.81536637854359,
                            21.298117623469331
                        ],
                        [
                            -157.81536344345966,
                            21.298117717540027
                        ],
                        [
                            -157.81536349317452,
                            21.298119091946038
                        ],
                        [
                            -157.81534940693999,
                            21.298119537537524
                        ],
                        [
                            -157.81529715798973,
                            21.298121190631452
                        ],
                        [
                            -157.81529598646813,
                            21.298121227554223
                        ],
                        [
                            -157.8152959611327,
                            21.298120539896164
                        ],
                        [
                            -157.81529302701992,
                            21.298120633069058
                        ],
                        [
                            -157.81529312546985,
                            21.298123383680981
                        ],
                        [
                            -157.81529606054661,
                            21.298123290514859
                        ],
                        [
                            -157.81529603617508,
                            21.298122602863579
                        ],
                        [
                            -157.81529736197419,
                            21.298122560703099
                        ],
                        [
                            -157.8153283933419,
                            21.298121579438344
                        ],
                        [
                            -157.81532978952865,
                            21.29812153506289
                        ],
                        [
                            -157.81532980293954,
                            21.298121906450554
                        ],
                        [
                            -157.81533093504436,
                            21.298153367746423
                        ],
                        [
                            -157.81533102338227,
                            21.298155816554921
                        ],
                        [
                            -157.81532955584359,
                            21.298155863138284
                        ],
                        [
                            -157.81532960651475,
                            21.298157238454422
                        ],
                        [
                            -157.81532463694853,
                            21.298157394991517
                        ],
                        [
                            -157.81529971677276,
                            21.29815818348926
                        ],
                        [
                            -157.81529731972785,
                            21.298158259664842
                        ],
                        [
                            -157.81529727002089,
                            21.298156884355492
                        ],
                        [
                            -157.81529433495069,
                            21.298156976618255
                        ],
                        [
                            -157.81529438465762,
                            21.298158351927611
                        ],
                        [
                            -157.81529242826062,
                            21.298158414040579
                        ],
                        [
                            -157.81529212260463,
                            21.298158423633026
                        ],
                        [
                            -157.81528779423184,
                            21.298158561194487
                        ],
                        [
                            -157.81526356732991,
                            21.298159327465385
                        ],
                        [
                            -157.81526209883452,
                            21.298159373138031
                        ],
                        [
                            -157.81526204912785,
                            21.298157997828689
                        ],
                        [
                            -157.81525911405043,
                            21.298158090994185
                        ],
                        [
                            -157.81525916375702,
                            21.298159466303527
                        ],
                        [
                            -157.81525622867957,
                            21.29815955946896
                        ],
                        [
                            -157.81525592302356,
                            21.298159569061333
                        ],
                        [
                            -157.81525241616919,
                            21.298159679882996
                        ],
                        [
                            -157.81522832329517,
                            21.298160441671982
                        ],
                        [
                            -157.81522687793375,
                            21.298160487507175
                        ],
                        [
                            -157.81522682822745,
                            21.298159112197833
                        ],
                        [
                            -157.81522389315001,
                            21.298159205362698
                        ],
                        [
                            -157.81522394285631,
                            21.29816058067204
                        ],
                        [
                            -157.81522002814165,
                            21.298160703979395
                        ],
                        [
                            -157.81519350833395,
                            21.298161542630801
                        ],
                        [
                            -157.8151916570329,
                            21.298161601868905
                        ],
                        [
                            -157.81519160732691,
                            21.29816022655957
                        ],
                        [
                            -157.81518867225671,
                            21.298160318820496
                        ],
                        [
                            -157.81518872099872,
                            21.298161694123046
                        ],
                        [
                            -157.81518627574343,
                            21.298161771764399
                        ],
                        [
                            -157.81518597008741,
                            21.298161781356651
                        ],
                        [
                            -157.81518301572436,
                            21.298161875288432
                        ],
                        [
                            -157.8151564351752,
                            21.298162715313126
                        ],
                        [
                            -157.81515638643347,
                            21.298161340010584
                        ],
                        [
                            -157.81515345136324,
                            21.298161432270881
                        ],
                        [
                            -157.81515350106162,
                            21.298162808483546
                        ],
                        [
                            -157.81514907530411,
                            21.298162948969374
                        ],
                        [
                            -157.81512287947385,
                            21.298163777243026
                        ],
                        [
                            -157.81512121523798,
                            21.298163829666844
                        ],
                        [
                            -157.81512116553989,
                            21.298162453454182
                        ],
                        [
                            -157.81511823045517,
                            21.298162547520555
                        ],
                        [
                            -157.815118329873,
                            21.298165297235855
                        ],
                        [
                            -157.81511906266761,
                            21.298165275293332
                        ],
                        [
                            -157.8151192354365,
                            21.298170058152241
                        ],
                        [
                            -157.81512243736819,
                            21.298258971547298
                        ],
                        [
                            -157.81512252950841,
                            21.298261546857095
                        ],
                        [
                            -157.81512179671336,
                            21.298261568799621
                        ],
                        [
                            -157.8151218951528,
                            21.298264320314775
                        ],
                        [
                            -157.81512262989023,
                            21.298264296579166
                        ],
                        [
                            -157.81512266206079,
                            21.298265213746351
                        ],
                        [
                            -157.81512270300232,
                            21.298266359532942
                        ],
                        [
                            -157.81512275366433,
                            21.298267735752376
                        ],
                        [
                            -157.81512278982171,
                            21.298268756837476
                        ],
                        [
                            -157.81512366351086,
                            21.298293006358737
                        ],
                        [
                            -157.81512370445242,
                            21.298294152145324
                        ],
                        [
                            -157.81512371955165,
                            21.298294553356715
                        ],
                        [
                            -157.81512298481408,
                            21.298294577092339
                        ],
                        [
                            -157.81512308422469,
                            21.298297327710952
                        ],
                        [
                            -157.81512381799115,
                            21.298297304871877
                        ],
                        [
                            -157.81512381946277,
                            21.298297361795804
                        ],
                        [
                            -157.81512386040433,
                            21.298298507582373
                        ],
                        [
                            -157.81512391106634,
                            21.2982998838018
                        ],
                        [
                            -157.81512486185454,
                            21.298326300194667
                        ],
                        [
                            -157.81512490765269,
                            21.298327561649348
                        ],
                        [
                            -157.8151241729222,
                            21.298327584481633
                        ],
                        [
                            -157.81512427329676,
                            21.298330335107003
                        ],
                        [
                            -157.81512500610668,
                            21.298330311357809
                        ],
                        [
                            -157.81512502120592,
                            21.298330712569218
                        ],
                        [
                            -157.81512506214025,
                            21.298331859259118
                        ],
                        [
                            -157.81512606359055,
                            21.298359651871316
                        ],
                        [
                            -157.81512609585525,
                            21.298360557295108
                        ],
                        [
                            -157.81512536208129,
                            21.298360581037514
                        ],
                        [
                            -157.81512546149193,
                            21.298363331656095
                        ],
                        [
                            -157.81512839656619,
                            21.298363239396476
                        ],
                        [
                            -157.81512829716272,
                            21.298360487874543
                        ],
                        [
                            -157.81512756338873,
                            21.298360511616959
                        ],
                        [
                            -157.81512753016733,
                            21.298359605283061
                        ],
                        [
                            -157.81512748922577,
                            21.29835845949648
                        ],
                        [
                            -157.81512652968067,
                            21.298331812677642
                        ],
                        [
                            -157.81512648777519,
                            21.298330666884276
                        ],
                        [
                            -157.81512647460377,
                            21.298330265686456
                        ],
                        [
                            -157.8151272074137,
                            21.298330241937254
                        ],
                        [
                            -157.81512710896689,
                            21.298327491325434
                        ],
                        [
                            -157.81512637519307,
                            21.298327515067857
                        ],
                        [
                            -157.81512632938765,
                            21.298326254516525
                        ],
                        [
                            -157.81512530758224,
                            21.298297874557509
                        ],
                        [
                            -157.81512528796677,
                            21.298297315221092
                        ],
                        [
                            -157.81512528553122,
                            21.298297258290383
                        ],
                        [
                            -157.8151260193049,
                            21.29829723454796
                        ],
                        [
                            -157.81512592085087,
                            21.298294484839492
                        ],
                        [
                            -157.81512518612055,
                            21.298294507671788
                        ],
                        [
                            -157.81512517198522,
                            21.298294106467168
                        ],
                        [
                            -157.81512513972777,
                            21.298293200140044
                        ],
                        [
                            -157.81512412960055,
                            21.298265167164853
                        ],
                        [
                            -157.81512409645882,
                            21.298264250894213
                        ],
                        [
                            -157.81512483119624,
                            21.298264227158576
                        ],
                        [
                            -157.81512478833406,
                            21.298263080455076
                        ],
                        [
                            -157.81515707513614,
                            21.298262060182232
                        ],
                        [
                            -157.81515711607796,
                            21.298263205968826
                        ],
                        [
                            -157.81515729163419,
                            21.298263191847141
                        ],
                        [
                            -157.81516005115745,
                            21.298263112805209
                        ],
                        [
                            -157.81516001021561,
                            21.298261967018632
                        ],
                        [
                            -157.81519229606087,
                            21.298260945828883
                        ],
                        [
                            -157.81519233700294,
                            21.298262091615467
                        ],
                        [
                            -157.81519380453545,
                            21.29826204593671
                        ],
                        [
                            -157.81519465072648,
                            21.298285518349211
                        ],
                        [
                            -157.81519489421149,
                            21.298292302714486
                        ],
                        [
                            -157.81519342667869,
                            21.298292348393254
                        ],
                        [
                            -157.81519352608339,
                            21.298295099915222
                        ],
                        [
                            -157.81519499362346,
                            21.298295053333113
                        ],
                        [
                            -157.81519608329964,
                            21.298325310110812
                        ],
                        [
                            -157.81519461575925,
                            21.29832535669291
                        ],
                        [
                            -157.81519466546521,
                            21.298326732002206
                        ],
                        [
                            -157.81519011050148,
                            21.298326876096269
                        ],
                        [
                            -157.8151594445248,
                            21.298327846355331
                        ],
                        [
                            -157.81516015100232,
                            21.298347462116116
                        ],
                        [
                            -157.81516066020853,
                            21.298361623626853
                        ],
                        [
                            -157.81516067454669,
                            21.298361999537981
                        ],
                        [
                            -157.81516068147681,
                            21.298362217303723
                        ],
                        [
                            -157.81516227243537,
                            21.298362167073879
                        ],
                        [
                            -157.81516228501226,
                            21.298362522194637
                        ],
                        [
                            -157.81516233144879,
                            21.298363824306335
                        ],
                        [
                            -157.81516334230071,
                            21.298391888001639
                        ],
                        [
                            -157.81516336201045,
                            21.298392435594661
                        ],
                        [
                            -157.81516103824859,
                            21.298392508670506
                        ],
                        [
                            -157.81516113765991,
                            21.298395259289084
                        ],
                        [
                            -157.81516346045788,
                            21.298395186206452
                        ],
                        [
                            -157.81516351333855,
                            21.298396646456755
                        ],
                        [
                            -157.8151645439076,
                            21.298425256841629
                        ],
                        [
                            -157.81516455012724,
                            21.298425442983731
                        ],
                        [
                            -157.81516296109581,
                            21.298425493227139
                        ],
                        [
                            -157.81516305954324,
                            21.298428243838934
                        ],
                        [
                            -157.81516599558995,
                            21.298428150682156
                        ],
                        [
                            -157.81516595368419,
                            21.298427004888811
                        ],
                        [
                            -157.81516799783034,
                            21.298426939781667
                        ],
                        [
                            -157.81519745951587,
                            21.298426008019934
                        ],
                        [
                            -157.81519970710696,
                            21.298425937117532
                        ],
                        [
                            -157.81519973784251,
                            21.298426792844101
                        ],
                        [
                            -157.81520076056779,
                            21.298455180036438
                        ],
                        [
                            -157.81520083771849,
                            21.298457340584722
                        ],
                        [
                            -157.81519937114797,
                            21.29845738627025
                        ],
                        [
                            -157.81519946959605,
                            21.298460136882049
                        ],
                        [
                            -157.8152009381017,
                            21.298460090306758
                        ],
                        [
                            -157.81520111467168,
                            21.298465000570271
                        ],
                        [
                            -157.81520192753285,
                            21.298487580198476
                        ],
                        [
                            -157.8152020277785,
                            21.298490347083941
                        ],
                        [
                            -157.81520055926532,
                            21.298490394562553
                        ],
                        [
                            -157.81520065868457,
                            21.298493144277792
                        ],
                        [
                            -157.81520212621939,
                            21.298493098599057
                        ],
                        [
                            -157.81520237289411,
                            21.298499966098515
                        ],
                        [
                            -157.81520316138432,
                            21.2985218580754
                        ],
                        [
                            -157.81520321589633,
                            21.29852335537614
                        ],
                        [
                            -157.8152017483612,
                            21.298523401054872
                        ],
                        [
                            -157.81520184776599,
                            21.298526152576763
                        ],
                        [
                            -157.81520331435169,
                            21.298526105084587
                        ],
                        [
                            -157.8152044040215,
                            21.298556362764892
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 316,
                "NUMBER": "1190",
                "PROPER_NAME": "UNIVERSITY HEALTH SERVICES",
                "DISPLAY_NAME": "UNIVERSITY HEALTH SERVICES - 1190",
                "ADDRESS": "1710 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY HEALTH SERVICES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1190_01.jpg",
                "HEIGHT (ft)": 14,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 281.98927898978548,
                "SHAPE_Area": 1019.8946460635909
            }
        },
        {
            "type": "Feature",
            "id": 317,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82035615673215,
                            21.301469317553334
                        ],
                        [
                            -157.82034577394566,
                            21.301479773787761
                        ],
                        [
                            -157.82034632318553,
                            21.301494053922642
                        ],
                        [
                            -157.82034683152801,
                            21.301507298484939
                        ],
                        [
                            -157.82040557489088,
                            21.301505317195971
                        ],
                        [
                            -157.82040506655039,
                            21.301492071730252
                        ],
                        [
                            -157.82040451826876,
                            21.301477791602075
                        ],
                        [
                            -157.82039336056548,
                            21.301468062463826
                        ],
                        [
                            -157.82039300771856,
                            21.301458886960223
                        ],
                        [
                            -157.82041985352899,
                            21.301457981138967
                        ],
                        [
                            -157.82049678849395,
                            21.301455386554704
                        ],
                        [
                            -157.82049636545699,
                            21.301444375772306
                        ],
                        [
                            -157.8205090936145,
                            21.301443946441065
                        ],
                        [
                            -157.8205086058787,
                            21.301431258511766
                        ],
                        [
                            -157.82050252490231,
                            21.301425956347277
                        ],
                        [
                            -157.82048730524215,
                            21.301412684553441
                        ],
                        [
                            -157.82048647688663,
                            21.301391100353893
                        ],
                        [
                            -157.8204842627826,
                            21.301333463857059
                        ],
                        [
                            -157.82050408275779,
                            21.30131350233485
                        ],
                        [
                            -157.82050388545005,
                            21.301308390469885
                        ],
                        [
                            -157.82050359502225,
                            21.301300814405383
                        ],
                        [
                            -157.82050065693846,
                            21.301300913962645
                        ],
                        [
                            -157.82049086686985,
                            21.301301244640143
                        ],
                        [
                            -157.8204885019056,
                            21.301239681852103
                        ],
                        [
                            -157.82048836880983,
                            21.301239689953103
                        ],
                        [
                            -157.82045747899335,
                            21.301240728244132
                        ],
                        [
                            -157.82044258902332,
                            21.301241227337535
                        ],
                        [
                            -157.82044238173879,
                            21.30123579560226
                        ],
                        [
                            -157.82041464119501,
                            21.301236724968785
                        ],
                        [
                            -157.8204157579398,
                            21.301266018017294
                        ],
                        [
                            -157.82038597028316,
                            21.301267016141061
                        ],
                        [
                            -157.82038586902544,
                            21.301264363979218
                        ],
                        [
                            -157.82038573240618,
                            21.301260828053252
                        ],
                        [
                            -157.82039608019073,
                            21.301250406802257
                        ],
                        [
                            -157.82039502670438,
                            21.301222971568716
                        ],
                        [
                            -157.82033647532842,
                            21.301224947880602
                        ],
                        [
                            -157.82033752881105,
                            21.301252382210677
                        ],
                        [
                            -157.8203416606558,
                            21.301255984086339
                        ],
                        [
                            -157.82032574926697,
                            21.301272009813843
                        ],
                        [
                            -157.82024315808272,
                            21.301274795937246
                        ],
                        [
                            -157.82024054189472,
                            21.30127249021028
                        ],
                        [
                            -157.82022894568513,
                            21.301262267446479
                        ],
                        [
                            -157.82022893877644,
                            21.301262046067315
                        ],
                        [
                            -157.82023088938146,
                            21.301261990181608
                        ],
                        [
                            -157.82023073070806,
                            21.301257111662338
                        ],
                        [
                            -157.82023070430898,
                            21.301256312879822
                        ],
                        [
                            -157.82023047197438,
                            21.301249189821426
                        ],
                        [
                            -157.82021585931065,
                            21.301249608630268
                        ],
                        [
                            -157.82021550152501,
                            21.301238638054418
                        ],
                        [
                            -157.82012184647306,
                            21.301241320352283
                        ],
                        [
                            -157.82012220425173,
                            21.301252290928009
                        ],
                        [
                            -157.82010759062393,
                            21.301252709720671
                        ],
                        [
                            -157.8201077092221,
                            21.301256328632185
                        ],
                        [
                            -157.82006656002227,
                            21.301257316597866
                        ],
                        [
                            -157.82001091433571,
                            21.301207711491308
                        ],
                        [
                            -157.82000597606859,
                            21.301063642954137
                        ],
                        [
                            -157.82002710672697,
                            21.301062924771831
                        ],
                        [
                            -157.82002726263727,
                            21.301067182642281
                        ],
                        [
                            -157.82003968494811,
                            21.301066781916013
                        ],
                        [
                            -157.82004007825469,
                            21.301077527796703
                        ],
                        [
                            -157.82013180933725,
                            21.301074570970691
                        ],
                        [
                            -157.82013141601678,
                            21.301063825993257
                        ],
                        [
                            -157.82014383736353,
                            21.301063425252515
                        ],
                        [
                            -157.82014367259902,
                            21.30105894779598
                        ],
                        [
                            -157.82017998298576,
                            21.301057778631254
                        ],
                        [
                            -157.82018014775861,
                            21.301062255184458
                        ],
                        [
                            -157.82019256909805,
                            21.301061855343445
                        ],
                        [
                            -157.82019296338694,
                            21.301072600327704
                        ],
                        [
                            -157.82028469446055,
                            21.301069644321402
                        ],
                        [
                            -157.82028452504028,
                            21.301065024999851
                        ],
                        [
                            -157.8202843001722,
                            21.301058898433691
                        ],
                        [
                            -157.82029672247543,
                            21.301058498591715
                        ],
                        [
                            -157.82029630036851,
                            21.301047010825119
                        ],
                        [
                            -157.82029277078064,
                            21.301043922683014
                        ],
                        [
                            -157.82030989353018,
                            21.301026733751506
                        ],
                        [
                            -157.82031522665613,
                            21.301021379701819
                        ],
                        [
                            -157.82032674660928,
                            21.301020986179246
                        ],
                        [
                            -157.820384883483,
                            21.301018997927997
                        ],
                        [
                            -157.82043049501934,
                            21.301003023191335
                        ],
                        [
                            -157.82047848596773,
                            21.300983147113698
                        ],
                        [
                            -157.82047861765855,
                            21.300987663184323
                        ],
                        [
                            -157.82053732034288,
                            21.300986163063218
                        ],
                        [
                            -157.82053679923141,
                            21.300968235232268
                        ],
                        [
                            -157.82053652092915,
                            21.300958656434894
                        ],
                        [
                            -157.82053335828402,
                            21.300955851824146
                        ],
                        [
                            -157.82055118349155,
                            21.300938211577488
                        ],
                        [
                            -157.82055523500972,
                            21.300938108078832
                        ],
                        [
                            -157.82063083506395,
                            21.300936177092435
                        ],
                        [
                            -157.8206540652638,
                            21.300959016815479
                        ],
                        [
                            -157.82067247764354,
                            21.300977119718567
                        ],
                        [
                            -157.82066659481328,
                            21.300977309758853
                        ],
                        [
                            -157.82066666209292,
                            21.30097914682408
                        ],
                        [
                            -157.82066679663774,
                            21.300982822761235
                        ],
                        [
                            -157.82066688910461,
                            21.300985369164856
                        ],
                        [
                            -157.8206693366829,
                            21.301052172201171
                        ],
                        [
                            -157.82066962403616,
                            21.30106001384128
                        ],
                        [
                            -157.82066975761708,
                            21.301063689771649
                        ],
                        [
                            -157.82066982488951,
                            21.301065527740217
                        ],
                        [
                            -157.82068240243831,
                            21.301065122633979
                        ],
                        [
                            -157.82068273719054,
                            21.301074272716292
                        ],
                        [
                            -157.82068283954536,
                            21.301077029679284
                        ],
                        [
                            -157.82068957861648,
                            21.301076813117088
                        ],
                        [
                            -157.82069378270035,
                            21.301076678162364
                        ],
                        [
                            -157.82071374298161,
                            21.301056642614228
                        ],
                        [
                            -157.82071685361998,
                            21.301056542455495
                        ],
                        [
                            -157.82072234303683,
                            21.301056365917628
                        ],
                        [
                            -157.82075169449752,
                            21.301055421589368
                        ],
                        [
                            -157.82076345533022,
                            21.301055043275827
                        ],
                        [
                            -157.82076668746086,
                            21.301054939450591
                        ],
                        [
                            -157.82076669136515,
                            21.301055054208604
                        ],
                        [
                            -157.82078794361956,
                            21.301073649473999
                        ],
                        [
                            -157.82079881253676,
                            21.301073299236801
                        ],
                        [
                            -157.82079837638429,
                            21.301061392198125
                        ],
                        [
                            -157.82081103009844,
                            21.30106098580918
                        ],
                        [
                            -157.82080915873769,
                            21.301009912136443
                        ],
                        [
                            -157.82080901625818,
                            21.301006022040013
                        ],
                        [
                            -157.82080900992335,
                            21.301005849447943
                        ],
                        [
                            -157.82080887441106,
                            21.301002173503996
                        ],
                        [
                            -157.82080886903296,
                            21.301002001822038
                        ],
                        [
                            -157.8208080061672,
                            21.300978454310957
                        ],
                        [
                            -157.82080799983237,
                            21.300978281718887
                        ],
                        [
                            -157.82080786529124,
                            21.300974604878345
                        ],
                        [
                            -157.82080779801706,
                            21.300972766909751
                        ],
                        [
                            -157.82079607286374,
                            21.300973144573295
                        ],
                        [
                            -157.82079573810438,
                            21.300963994490768
                        ],
                        [
                            -157.82080501119188,
                            21.300963696307598
                        ],
                        [
                            -157.82081632750504,
                            21.300963332039572
                        ],
                        [
                            -157.82082782574682,
                            21.300973391467032
                        ],
                        [
                            -157.82085620137624,
                            21.300972479127818
                        ],
                        [
                            -157.82085603602977,
                            21.300967951077123
                        ],
                        [
                            -157.82085525549539,
                            21.300946649069342
                        ],
                        [
                            -157.82085415685862,
                            21.300916646080953
                        ],
                        [
                            -157.82082578026879,
                            21.300917559316904
                        ],
                        [
                            -157.82081504605074,
                            21.300928333825045
                        ],
                        [
                            -157.82080372974022,
                            21.300928698093109
                        ],
                        [
                            -157.8207944556838,
                            21.300928997172893
                        ],
                        [
                            -157.82079411996776,
                            21.300919846180246
                        ],
                        [
                            -157.82080584608076,
                            21.300919468523382
                        ],
                        [
                            -157.82080279786229,
                            21.300836235822384
                        ],
                        [
                            -157.82080268222478,
                            21.300833089404737
                        ],
                        [
                            -157.82080261495065,
                            21.300831251436119
                        ],
                        [
                            -157.8207895938809,
                            21.30083166970525
                        ],
                        [
                            -157.8207891586928,
                            21.300819762673047
                        ],
                        [
                            -157.82077871599137,
                            21.300820098732618
                        ],
                        [
                            -157.82075881794867,
                            21.300840071489393
                        ],
                        [
                            -157.82075882185293,
                            21.300840186247409
                        ],
                        [
                            -157.82075558875587,
                            21.300840290969298
                        ],
                        [
                            -157.8207406411338,
                            21.300840771618912
                        ],
                        [
                            -157.82072722858234,
                            21.300841202497445
                        ],
                        [
                            -157.82070898807743,
                            21.300841790156721
                        ],
                        [
                            -157.82070587841474,
                            21.300841889418916
                        ],
                        [
                            -157.82068443759772,
                            21.300823131115958
                        ],
                        [
                            -157.82067815558841,
                            21.300823332813678
                        ],
                        [
                            -157.82067355230495,
                            21.300823482135112
                        ],
                        [
                            -157.82067365370293,
                            21.300826238188055
                        ],
                        [
                            -157.82067398844765,
                            21.300835389173947
                        ],
                        [
                            -157.82066141189685,
                            21.30083579248053
                        ],
                        [
                            -157.82066147916922,
                            21.300837630449141
                        ],
                        [
                            -157.82066161275,
                            21.300841306379589
                        ],
                        [
                            -157.82066248826928,
                            21.300865198171458
                        ],
                        [
                            -157.82066262280685,
                            21.300868875011993
                        ],
                        [
                            -157.82066342379127,
                            21.300890751719692
                        ],
                        [
                            -157.82065038632953,
                            21.300891169862943
                        ],
                        [
                            -157.82064570108767,
                            21.300891321319305
                        ],
                        [
                            -157.82064031774618,
                            21.30089149408137
                        ],
                        [
                            -157.82064021797601,
                            21.300888654927903
                        ],
                        [
                            -157.8206200603955,
                            21.300870963480943
                        ],
                        [
                            -157.82061999364268,
                            21.300869060471847
                        ],
                        [
                            -157.82061975258054,
                            21.30086218307413
                        ],
                        [
                            -157.8206192917464,
                            21.300849021955713
                        ],
                        [
                            -157.82061910110883,
                            21.300843556911389
                        ],
                        [
                            -157.82061839921261,
                            21.300823518395202
                        ],
                        [
                            -157.82061833342374,
                            21.300821615392852
                        ],
                        [
                            -157.82063721162581,
                            21.30080272409203
                        ],
                        [
                            -157.8206371120431,
                            21.300799861451672
                        ],
                        [
                            -157.82063683392187,
                            21.300791950314963
                        ],
                        [
                            -157.82062419965393,
                            21.300792338760164
                        ],
                        [
                            -157.82062378515946,
                            21.300780497820558
                        ],
                        [
                            -157.82053047981037,
                            21.300783365293647
                        ],
                        [
                            -157.82053095326964,
                            21.300796876112852
                        ],
                        [
                            -157.82052026191772,
                            21.300797204993287
                        ],
                        [
                            -157.82052020294549,
                            21.300795535113583
                        ],
                        [
                            -157.82051988425832,
                            21.300786426699656
                        ],
                        [
                            -157.82051950752685,
                            21.300775652929442
                        ],
                        [
                            -157.82052923086101,
                            21.300765923805596
                        ],
                        [
                            -157.82052828177902,
                            21.300738810909461
                        ],
                        [
                            -157.82046922964548,
                            21.30074062567213
                        ],
                        [
                            -157.82047017775267,
                            21.30076773856133
                        ],
                        [
                            -157.82048056334457,
                            21.300776852492614
                        ],
                        [
                            -157.8204809400948,
                            21.300787623552747
                        ],
                        [
                            -157.82048125878677,
                            21.300796731063297
                        ],
                        [
                            -157.82048131775136,
                            21.300798401846354
                        ],
                        [
                            -157.82047062640655,
                            21.300798729820308
                        ],
                        [
                            -157.82047015295277,
                            21.300785219001192
                        ],
                        [
                            -157.82037684856616,
                            21.300788086395549
                        ],
                        [
                            -157.82037726207685,
                            21.300799927328089
                        ],
                        [
                            -157.82036632871186,
                            21.300800262632777
                        ],
                        [
                            -157.82036637730704,
                            21.30080166232586
                        ],
                        [
                            -157.82036667710435,
                            21.300810237606679
                        ],
                        [
                            -157.82036676115248,
                            21.300812630374836
                        ],
                        [
                            -157.82038516206924,
                            21.30082878099957
                        ],
                        [
                            -157.820385229783,
                            21.300830684015388
                        ],
                        [
                            -157.82038592972683,
                            21.300850721614196
                        ],
                        [
                            -157.82038612227643,
                            21.300856187575246
                        ],
                        [
                            -157.82038665280845,
                            21.300871362840251
                        ],
                        [
                            -157.82038682317707,
                            21.3008762260841
                        ],
                        [
                            -157.82038688896293,
                            21.300878129086392
                        ],
                        [
                            -157.82037172184741,
                            21.300893306333599
                        ],
                        [
                            -157.8203601007867,
                            21.300883180067835
                        ],
                        [
                            -157.82035850013023,
                            21.300881784852503
                        ],
                        [
                            -157.82036602679446,
                            21.30087419854102
                        ],
                        [
                            -157.82036558067722,
                            21.300862698861781
                        ],
                        [
                            -157.82035314566454,
                            21.300863123011958
                        ],
                        [
                            -157.82035272833019,
                            21.300852365218365
                        ],
                        [
                            -157.82035081524484,
                            21.300852431306016
                        ],
                        [
                            -157.82034698908842,
                            21.300852561674567
                        ],
                        [
                            -157.82030896666032,
                            21.300853857094342
                        ],
                        [
                            -157.82030664570701,
                            21.300853935679875
                        ],
                        [
                            -157.82026090057681,
                            21.300855494040466
                        ],
                        [
                            -157.82026115729508,
                            21.30086209872378
                        ],
                        [
                            -157.82026131790448,
                            21.300866251833988
                        ],
                        [
                            -157.8202488828988,
                            21.300866675073113
                        ],
                        [
                            -157.8202490220101,
                            21.30087026070316
                        ],
                        [
                            -157.8202461523889,
                            21.300870358929494
                        ],
                        [
                            -157.82021554313445,
                            21.300871401856192
                        ],
                        [
                            -157.82021267352764,
                            21.30087149827526
                        ],
                        [
                            -157.82021253538116,
                            21.300867912651974
                        ],
                        [
                            -157.8202001003682,
                            21.300868336790817
                        ],
                        [
                            -157.82019968206666,
                            21.300857580797267
                        ],
                        [
                            -157.82010785431842,
                            21.300860708632207
                        ],
                        [
                            -157.82010827164208,
                            21.300871465522249
                        ],
                        [
                            -157.82009583662892,
                            21.30087188965334
                        ],
                        [
                            -157.82009628273235,
                            21.300883388428989
                        ],
                        [
                            -157.82010245177011,
                            21.300888764399129
                        ],
                        [
                            -157.82008858015317,
                            21.300902743772891
                        ],
                        [
                            -157.82006352690863,
                            21.300903598876896
                        ],
                        [
                            -157.82006225596479,
                            21.300870928775147
                        ],
                        [
                            -157.82003317117824,
                            21.300871921830574
                        ],
                        [
                            -157.82002289523345,
                            21.3008822803261
                        ],
                        [
                            -157.82001236268746,
                            21.300882640099417
                        ],
                        [
                            -157.81997181002362,
                            21.300884025203928
                        ],
                        [
                            -157.81997174240124,
                            21.300882473607818
                        ],
                        [
                            -157.81997130513233,
                            21.300872404961751
                        ],
                        [
                            -157.81998728909946,
                            21.300871797042547
                        ],
                        [
                            -157.81998349155003,
                            21.300784193905802
                        ],
                        [
                            -157.81996750759239,
                            21.300784801825088
                        ],
                        [
                            -157.81996699403834,
                            21.300772938509905
                        ],
                        [
                            -157.81996028551734,
                            21.300773194103684
                        ],
                        [
                            -157.81995636666659,
                            21.300773343688011
                        ],
                        [
                            -157.81995556824603,
                            21.300773373321441
                        ],
                        [
                            -157.81995560083126,
                            21.300774121557499
                        ],
                        [
                            -157.81993760552865,
                            21.30079241369808
                        ],
                        [
                            -157.81993557088714,
                            21.300792491576086
                        ],
                        [
                            -157.81991414836543,
                            21.300793307074695
                        ],
                        [
                            -157.81990830673973,
                            21.300793528996355
                        ],
                        [
                            -157.81989878926129,
                            21.30079389136413
                        ],
                        [
                            -157.81988688421794,
                            21.300794344491468
                        ],
                        [
                            -157.8198848495764,
                            21.300794422368853
                        ],
                        [
                            -157.8198776730178,
                            21.300788221756957
                        ],
                        [
                            -157.81986450035672,
                            21.300776840608368
                        ],
                        [
                            -157.81986230757218,
                            21.300776924603586
                        ],
                        [
                            -157.81985872333706,
                            21.300777060271216
                        ],
                        [
                            -157.8198492762487,
                            21.300777420419696
                        ],
                        [
                            -157.8198497897933,
                            21.300789283734773
                        ],
                        [
                            -157.81983937842872,
                            21.300789679579598
                        ],
                        [
                            -157.81984317589252,
                            21.300877282715582
                        ],
                        [
                            -157.81985516965361,
                            21.300876826600216
                        ],
                        [
                            -157.81985560427526,
                            21.300886863609033
                        ],
                        [
                            -157.81984605303859,
                            21.300887227543626
                        ],
                        [
                            -157.81983647576834,
                            21.300887592198475
                        ],
                        [
                            -157.8198259933483,
                            21.300878536270137
                        ],
                        [
                            -157.81979586718879,
                            21.300879682784643
                        ],
                        [
                            -157.81979827108651,
                            21.300935127181113
                        ],
                        [
                            -157.81982839726453,
                            21.300933979763364
                        ],
                        [
                            -157.81983806066802,
                            21.300924157212318
                        ],
                        [
                            -157.81984763022908,
                            21.300923792503397
                        ],
                        [
                            -157.81985718917963,
                            21.300923428622905
                        ],
                        [
                            -157.8198576247581,
                            21.300933466541792
                        ],
                        [
                            -157.81984563099243,
                            21.300933922657102
                        ],
                        [
                            -157.81984942845187,
                            21.301021526695166
                        ],
                        [
                            -157.81985947534167,
                            21.301021143651973
                        ],
                        [
                            -157.81985998889411,
                            21.301033006063442
                        ],
                        [
                            -157.81986454321046,
                            21.301032832933014
                        ],
                        [
                            -157.81986469782652,
                            21.301044012574035
                        ],
                        [
                            -157.81988234082161,
                            21.301055841536201
                        ],
                        [
                            -157.81987758366608,
                            21.301060652155915
                        ],
                        [
                            -157.81986550704841,
                            21.301073172474187
                        ],
                        [
                            -157.8198656033781,
                            21.301080303612618
                        ],
                        [
                            -157.81986585490637,
                            21.301095040582464
                        ],
                        [
                            -157.81987153921071,
                            21.301100155695188
                        ],
                        [
                            -157.81988438558332,
                            21.301110632068454
                        ],
                        [
                            -157.81990797388997,
                            21.301109860672039
                        ],
                        [
                            -157.81990905669582,
                            21.301109830323046
                        ],
                        [
                            -157.81990984804131,
                            21.301131813561888
                        ],
                        [
                            -157.81990808267298,
                            21.301131850868352
                        ],
                        [
                            -157.8198846407733,
                            21.301132636842237
                        ],
                        [
                            -157.81987213635011,
                            21.301143440428358
                        ],
                        [
                            -157.81986849609922,
                            21.301146726729783
                        ],
                        [
                            -157.81987485077789,
                            21.301152999270315
                        ],
                        [
                            -157.81987677421131,
                            21.301154897232205
                        ],
                        [
                            -157.81989221140847,
                            21.301170130961872
                        ],
                        [
                            -157.81990710301099,
                            21.301184758302504
                        ],
                        [
                            -157.81991831035464,
                            21.301195748952761
                        ],
                        [
                            -157.81992606590515,
                            21.301203446928572
                        ],
                        [
                            -157.81993167704218,
                            21.301208912945352
                        ],
                        [
                            -157.8199404792405,
                            21.301217487322155
                        ],
                        [
                            -157.81995330761907,
                            21.301230460536349
                        ],
                        [
                            -157.81996942788817,
                            21.301246832804814
                        ],
                        [
                            -157.81997059457507,
                            21.301248008166866
                        ],
                        [
                            -157.81998203673587,
                            21.301238042698433
                        ],
                        [
                            -157.8200325522547,
                            21.301289433077397
                        ],
                        [
                            -157.82004070824948,
                            21.301297687634715
                        ],
                        [
                            -157.82004376783979,
                            21.301321246933952
                        ],
                        [
                            -157.82006018343628,
                            21.30133709549175
                        ],
                        [
                            -157.82008137251614,
                            21.301357921776074
                        ],
                        [
                            -157.82008685087681,
                            21.301363115839823
                        ],
                        [
                            -157.8200894012198,
                            21.301363043383006
                        ],
                        [
                            -157.82011116740051,
                            21.301362419987001
                        ],
                        [
                            -157.82012578103195,
                            21.301362002097886
                        ],
                        [
                            -157.82012613881798,
                            21.301372971770135
                        ],
                        [
                            -157.82021979491029,
                            21.301370290383886
                        ],
                        [
                            -157.82021943713173,
                            21.301359318904815
                        ],
                        [
                            -157.82025581790745,
                            21.301358277598247
                        ],
                        [
                            -157.82025636626864,
                            21.301372545983003
                        ],
                        [
                            -157.8202582051851,
                            21.301420414194546
                        ],
                        [
                            -157.82023838517031,
                            21.301440374781993
                        ],
                        [
                            -157.82023887191173,
                            21.301453063607571
                        ],
                        [
                            -157.82025160007697,
                            21.301452633392525
                        ],
                        [
                            -157.82025202309563,
                            21.301463644174682
                        ],
                        [
                            -157.82032506441448,
                            21.301461179561745
                        ],
                        [
                            -157.82035580388037,
                            21.301460142953104
                        ],
                        [
                            -157.82035615673215,
                            21.301469317553334
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 317,
                "NUMBER": "1017",
                "PROPER_NAME": "BUSINESS ADMINISTRATION BUILDING - SHIDLER",
                "DISPLAY_NAME": "BUSINESS ADMINISTRATION BUILDING - SHIDLER (BUSAD) - 1017",
                "ADDRESS": "2404 MAILE WAY",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BUSINESS ADMINISTRATION BUILDING - SHIDLER",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1017_01.jpg",
                "HEIGHT (ft)": 67.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 642.86495910436724,
                "SHAPE_Area": 3434.1023351827903
            }
        },
        {
            "type": "Feature",
            "id": 318,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82362292383436,
                            21.297738427358208
                        ],
                        [
                            -157.82351654179169,
                            21.297796088029873
                        ],
                        [
                            -157.82360188251806,
                            21.297934368731781
                        ],
                        [
                            -157.82370826366875,
                            21.297876708003415
                        ],
                        [
                            -157.82362292383436,
                            21.297738427358208
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 318,
                "NUMBER": "1170",
                "PROPER_NAME": "UNIVERSITY LAB SCHOOL - LOCKER BUILDING",
                "DISPLAY_NAME": "UNIVERSITY LAB SCHOOL - LOCKER BUILDING - 1170",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY LAB SCHOOL LOCKERS AND BATTING CAGE",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1170_01.jpg",
                "HEIGHT (ft)": 19.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 60.864080431562535,
                "SHAPE_Area": 225.44082126441666
            }
        },
        {
            "type": "Feature",
            "id": 319,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81546172302581,
                            21.295720196822728
                        ],
                        [
                            -157.81545589362685,
                            21.295719038303336
                        ],
                        [
                            -157.81545544802799,
                            21.295718949345254
                        ],
                        [
                            -157.81544595179514,
                            21.29571706218168
                        ],
                        [
                            -157.81542780241963,
                            21.295713454589965
                        ],
                        [
                            -157.8154177634911,
                            21.295759443285313
                        ],
                        [
                            -157.81545269951098,
                            21.295766381475268
                        ],
                        [
                            -157.81545538756347,
                            21.295766915325562
                        ],
                        [
                            -157.81547277762189,
                            21.295770368511356
                        ],
                        [
                            -157.81548338428098,
                            21.295724503055091
                        ],
                        [
                            -157.81548210907269,
                            21.295724249261955
                        ],
                        [
                            -157.81546172302581,
                            21.295720196822728
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 319,
                "NUMBER": "1261",
                "PROPER_NAME": "QUARRY STAIRS",
                "DISPLAY_NAME": "QUARRY STAIRS - 1261",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "QUARRY STAIRS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1261_01.jpg",
                "HEIGHT (ft)": 64.299999999999997,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 22.11977617619856,
                "SHAPE_Area": 30.468246008424682
            }
        },
        {
            "type": "Feature",
            "id": 320,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8141983960447,
                            21.297542998957567
                        ],
                        [
                            -157.81420074137532,
                            21.297563066216604
                        ],
                        [
                            -157.81416749373784,
                            21.297566478944823
                        ],
                        [
                            -157.81416855996071,
                            21.29757560165935
                        ],
                        [
                            -157.81403634022448,
                            21.297589174826228
                        ],
                        [
                            -157.81404444333202,
                            21.297658499328335
                        ],
                        [
                            -157.81430724570581,
                            21.297631521123051
                        ],
                        [
                            -157.81429914151846,
                            21.297562195717578
                        ],
                        [
                            -157.81429572994375,
                            21.29753300574518
                        ],
                        [
                            -157.8141983960447,
                            21.297542998957567
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 320,
                "NUMBER": "1259",
                "PROPER_NAME": "SUBSTATION M",
                "DISPLAY_NAME": "SUBSTATION M - 1259",
                "ADDRESS": "1701 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "SUBSTATION M",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1259_01.jpg",
                "HEIGHT (ft)": 18.699999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 76.793860530940051,
                "SHAPE_Area": 248.27434515158185
            }
        },
        {
            "type": "Feature",
            "id": 321,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81950926262957,
                            21.296592273498685
                        ],
                        [
                            -157.81951887953554,
                            21.296592583962482
                        ],
                        [
                            -157.81951870227485,
                            21.296597398697113
                        ],
                        [
                            -157.81952310642953,
                            21.296597543414322
                        ],
                        [
                            -157.81952322820192,
                            21.296594245084151
                        ],
                        [
                            -157.8195233599219,
                            21.296590666772516
                        ],
                        [
                            -157.81953070245018,
                            21.296590905273337
                        ],
                        [
                            -157.81953085587031,
                            21.296586782369058
                        ],
                        [
                            -157.81952747901911,
                            21.296586672862453
                        ],
                        [
                            -157.81952583781421,
                            21.296586619795416
                        ],
                        [
                            -157.81952633887528,
                            21.296573004689037
                        ],
                        [
                            -157.81952707460513,
                            21.296553059360367
                        ],
                        [
                            -157.81952753911534,
                            21.296553074362436
                        ],
                        [
                            -157.81952847969535,
                            21.296553105350991
                        ],
                        [
                            -157.81953199242085,
                            21.296553220327482
                        ],
                        [
                            -157.81953213188064,
                            21.296549638456522
                        ],
                        [
                            -157.81952861142952,
                            21.296549525232653
                        ],
                        [
                            -157.81952720536825,
                            21.296549480138612
                        ],
                        [
                            -157.81952775400813,
                            21.296534494018189
                        ],
                        [
                            -157.81952779688496,
                            21.296533349722388
                        ],
                        [
                            -157.81952794248278,
                            21.296529361368485
                        ],
                        [
                            -157.81952850068043,
                            21.296514144046945
                        ],
                        [
                            -157.81952860047087,
                            21.296511425539631
                        ],
                        [
                            -157.81952867547892,
                            21.296509396145922
                        ],
                        [
                            -157.81952906351262,
                            21.296498829191616
                        ],
                        [
                            -157.81952916829124,
                            21.296495968886887
                        ],
                        [
                            -157.81952974857109,
                            21.296480159095584
                        ],
                        [
                            -157.81953115269667,
                            21.296480205079394
                        ],
                        [
                            -157.81953466734828,
                            21.296480320069264
                        ],
                        [
                            -157.81953480584392,
                            21.296476738191508
                        ],
                        [
                            -157.81953128347396,
                            21.296476624050896
                        ],
                        [
                            -157.81952987934119,
                            21.296476578970431
                        ],
                        [
                            -157.81953036835245,
                            21.296463265511964
                        ],
                        [
                            -157.81953104004447,
                            21.296444941320885
                        ],
                        [
                            -157.8195328103898,
                            21.296444998003732
                        ],
                        [
                            -157.81953617856982,
                            21.2964451065459
                        ],
                        [
                            -157.81953622994686,
                            21.296443742785659
                        ],
                        [
                            -157.81953628343922,
                            21.296442355552099
                        ],
                        [
                            -157.81953633378021,
                            21.296441000818508
                        ],
                        [
                            -157.81953119140655,
                            21.296440834663127
                        ],
                        [
                            -157.81952871080543,
                            21.296440754930895
                        ],
                        [
                            -157.8195288386882,
                            21.296437294936492
                        ],
                        [
                            -157.81952895951065,
                            21.296433994792807
                        ],
                        [
                            -157.81952779535527,
                            21.296433955912438
                        ],
                        [
                            -157.8195263150958,
                            21.296433907587854
                        ],
                        [
                            -157.81952498517714,
                            21.296433863931291
                        ],
                        [
                            -157.8195248139991,
                            21.296438520615229
                        ],
                        [
                            -157.81952371536775,
                            21.29643848490457
                        ],
                        [
                            -157.81948653049318,
                            21.296437283664577
                        ],
                        [
                            -157.81947639705106,
                            21.296436956025445
                        ],
                        [
                            -157.8194653847055,
                            21.296436599636202
                        ],
                        [
                            -157.81946544261967,
                            21.296435020914799
                        ],
                        [
                            -157.81946556347242,
                            21.296431717157855
                        ],
                        [
                            -157.81946115253214,
                            21.296431577812076
                        ],
                        [
                            -157.81946097283003,
                            21.296436456670303
                        ],
                        [
                            -157.81939786696694,
                            21.296434417733625
                        ],
                        [
                            -157.81939804546192,
                            21.296429569582376
                        ],
                        [
                            -157.81939364228364,
                            21.296429423965549
                        ],
                        [
                            -157.81939352536716,
                            21.296432596758279
                        ],
                        [
                            -157.81939346375967,
                            21.296434275730128
                        ],
                        [
                            -157.81938626675367,
                            21.296434042761359
                        ],
                        [
                            -157.8193449918881,
                            21.296432708910604
                        ],
                        [
                            -157.81934061469929,
                            21.29643256799163
                        ],
                        [
                            -157.8193373901205,
                            21.296432463163097
                        ],
                        [
                            -157.81933694102608,
                            21.296432449172073
                        ],
                        [
                            -157.81933403061629,
                            21.296432354677844
                        ],
                        [
                            -157.81933420187966,
                            21.296427688057612
                        ],
                        [
                            -157.81933037877926,
                            21.296427570899866
                        ],
                        [
                            -157.81933025890186,
                            21.296430872856661
                        ],
                        [
                            -157.81933013426692,
                            21.296434287703956
                        ],
                        [
                            -157.81932719204818,
                            21.296434192986464
                        ],
                        [
                            -157.81932249105847,
                            21.296434040761682
                        ],
                        [
                            -157.81932233762572,
                            21.296438164568922
                        ],
                        [
                            -157.81932572122054,
                            21.296438274126814
                        ],
                        [
                            -157.81932704054333,
                            21.296438316807237
                        ],
                        [
                            -157.81932703669921,
                            21.296438436027891
                        ],
                        [
                            -157.81932703065311,
                            21.296438589561962
                        ],
                        [
                            -157.81932630670127,
                            21.296458263954285
                        ],
                        [
                            -157.81932185627639,
                            21.296458119810882
                        ],
                        [
                            -157.81932171954901,
                            21.296461841726284
                        ],
                        [
                            -157.81932510025985,
                            21.296461950360587
                        ],
                        [
                            -157.81932616998122,
                            21.296461984966342
                        ],
                        [
                            -157.81932525892984,
                            21.296486739620782
                        ],
                        [
                            -157.81932476757527,
                            21.29650010274797
                        ],
                        [
                            -157.81932441813848,
                            21.296509576868797
                        ],
                        [
                            -157.81932401515368,
                            21.296520565600783
                        ],
                        [
                            -157.81932389983442,
                            21.29652365890616
                        ],
                        [
                            -157.81915983819076,
                            21.296518358663906
                        ],
                        [
                            -157.81915593516331,
                            21.296518231004047
                        ],
                        [
                            -157.8191550536078,
                            21.296541703047964
                        ],
                        [
                            -157.81916365763576,
                            21.296541982034039
                        ],
                        [
                            -157.81932303662691,
                            21.296547130177323
                        ],
                        [
                            -157.81932277417744,
                            21.296554282289947
                        ],
                        [
                            -157.81931800089805,
                            21.296554128654375
                        ],
                        [
                            -157.81931785516889,
                            21.29655825341899
                        ],
                        [
                            -157.81932138043214,
                            21.296558367584442
                        ],
                        [
                            -157.81932262169383,
                            21.29655840791056
                        ],
                        [
                            -157.81932228565182,
                            21.296567532512967
                        ],
                        [
                            -157.8193222291905,
                            21.296569049813836
                        ],
                        [
                            -157.81932181654582,
                            21.296580282393535
                        ],
                        [
                            -157.81931729770142,
                            21.296580135059742
                        ],
                        [
                            -157.81931716022189,
                            21.296583709717058
                        ],
                        [
                            -157.81932168387152,
                            21.296583858891353
                        ],
                        [
                            -157.81932449695833,
                            21.296583949089626
                        ],
                        [
                            -157.81932441070362,
                            21.296586300011448
                        ],
                        [
                            -157.81932424444955,
                            21.296590822124116
                        ],
                        [
                            -157.81932820715502,
                            21.296590961039502
                        ],
                        [
                            -157.81932837349552,
                            21.296586428086723
                        ],
                        [
                            -157.81938781345517,
                            21.296588348287852
                        ],
                        [
                            -157.81938763759428,
                            21.296593107925119
                        ],
                        [
                            -157.81939203792894,
                            21.296593248102003
                        ],
                        [
                            -157.81939221376808,
                            21.296588491174742
                        ],
                        [
                            -157.8193962324597,
                            21.296588620543925
                        ],
                        [
                            -157.81939743131693,
                            21.296588659668668
                        ],
                        [
                            -157.81940902479502,
                            21.296589034593399
                        ],
                        [
                            -157.81945562422692,
                            21.296590540383111
                        ],
                        [
                            -157.81945545650791,
                            21.296595125723176
                        ],
                        [
                            -157.81945926700996,
                            21.296595251823799
                        ],
                        [
                            -157.81945943571441,
                            21.296590663780467
                        ],
                        [
                            -157.81950926262957,
                            21.296592273498685
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 321,
                "NUMBER": "1260",
                "PROPER_NAME": "LAW SCHOOL CLINICAL BUILDING",
                "DISPLAY_NAME": "LAW SCHOOL CLINICAL BUILDING - 1260",
                "ADDRESS": "2485 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "LAW SCHOOL CLINICAL BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": "CLOC",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1260_01.jpg",
                "HEIGHT (ft)": 28.400000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": "https://www.hawaii.edu/sustainability/pv_system/richardson-school-of-law-cloc/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2020/03/DJI_0011-scaled.jpg",
                "PORTABLE?": null,
                "SHAPE_Length": 127.69871682212522,
                "SHAPE_Area": 409.97465262540771
            }
        },
        {
            "type": "Feature",
            "id": 659,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81478346824287,
                            21.305040761080303
                        ],
                        [
                            -157.81478409326419,
                            21.305042882123708
                        ],
                        [
                            -157.81478686739953,
                            21.305052294201563
                        ],
                        [
                            -157.81478699596252,
                            21.30505273144411
                        ],
                        [
                            -157.81478704194311,
                            21.305052888054323
                        ],
                        [
                            -157.81478880722375,
                            21.305058876408065
                        ],
                        [
                            -157.81490391749011,
                            21.305029081308771
                        ],
                        [
                            -157.8149076955961,
                            21.305028104254546
                        ],
                        [
                            -157.81491113077814,
                            21.305027214220388
                        ],
                        [
                            -157.8149123141533,
                            21.305026908176032
                        ],
                        [
                            -157.81491101155245,
                            21.305022487752186
                        ],
                        [
                            -157.81490988817788,
                            21.30501867837835
                        ],
                        [
                            -157.81490521641066,
                            21.305002830743049
                        ],
                        [
                            -157.81490916067972,
                            21.305001809689671
                        ],
                        [
                            -157.81491528430593,
                            21.305000223107175
                        ],
                        [
                            -157.81491646864475,
                            21.304999917069562
                        ],
                        [
                            -157.81491614109746,
                            21.304998808110838
                        ],
                        [
                            -157.81491117089763,
                            21.304981947481274
                        ],
                        [
                            -157.8149196419497,
                            21.304979754094031
                        ],
                        [
                            -157.81492082532444,
                            21.304979448049611
                        ],
                        [
                            -157.81492049874106,
                            21.30497833909768
                        ],
                        [
                            -157.81491873066537,
                            21.304972338077945
                        ],
                        [
                            -157.81491494012027,
                            21.304959481447312
                        ],
                        [
                            -157.81491332126481,
                            21.304953986473059
                        ],
                        [
                            -157.81491260894816,
                            21.304951571213742
                        ],
                        [
                            -157.8149117183259,
                            21.304948550331215
                        ],
                        [
                            -157.81490927924011,
                            21.304940272561538
                        ],
                        [
                            -157.81490885973881,
                            21.304938849479115
                        ],
                        [
                            -157.81490780205976,
                            21.304935262801692
                        ],
                        [
                            -157.81490763406794,
                            21.304934693386699
                        ],
                        [
                            -157.81490745106566,
                            21.304934072372784
                        ],
                        [
                            -157.81490739100232,
                            21.30493386868719
                        ],
                        [
                            -157.81494597293448,
                            21.304923882449526
                        ],
                        [
                            -157.81494715631595,
                            21.304923575501537
                        ],
                        [
                            -157.81494641772522,
                            21.304921070621763
                        ],
                        [
                            -157.81493509874355,
                            21.304882666422191
                        ],
                        [
                            -157.81493259673832,
                            21.304874180430122
                        ],
                        [
                            -157.81492787246131,
                            21.304858149037447
                        ],
                        [
                            -157.81492080987854,
                            21.304859977439282
                        ],
                        [
                            -157.81484887413541,
                            21.304878598212142
                        ],
                        [
                            -157.81484501681427,
                            21.304879596388549
                        ],
                        [
                            -157.81484534340413,
                            21.304880704437267
                        ],
                        [
                            -157.81484726917543,
                            21.304887235954467
                        ],
                        [
                            -157.81484762108221,
                            21.304888432713621
                        ],
                        [
                            -157.81485560563385,
                            21.304915523777581
                        ],
                        [
                            -157.8148624039616,
                            21.304938589114371
                        ],
                        [
                            -157.81486397309442,
                            21.304943912998265
                        ],
                        [
                            -157.8148189941538,
                            21.304955555237971
                        ],
                        [
                            -157.81481873327331,
                            21.304954668079024
                        ],
                        [
                            -157.81481637861611,
                            21.304946681794203
                        ],
                        [
                            -157.81481552835209,
                            21.304943797607269
                        ],
                        [
                            -157.81476369645549,
                            21.30495721279199
                        ],
                        [
                            -157.81475610931182,
                            21.304959177516739
                        ],
                        [
                            -157.81475957510901,
                            21.304970935148436
                        ],
                        [
                            -157.81474821178713,
                            21.304973876937304
                        ],
                        [
                            -157.81475446767612,
                            21.304995100059816
                        ],
                        [
                            -157.81475547464558,
                            21.304998518350445
                        ],
                        [
                            -157.81475573648243,
                            21.304999406419615
                        ],
                        [
                            -157.8147560715156,
                            21.305000543436382
                        ],
                        [
                            -157.81475809489862,
                            21.305007404475671
                        ],
                        [
                            -157.81475842617019,
                            21.305008529721885
                        ],
                        [
                            -157.8147585529718,
                            21.305008946174102
                        ],
                        [
                            -157.81475913379515,
                            21.305010928687711
                        ],
                        [
                            -157.81475925295751,
                            21.305011336052218
                        ],
                        [
                            -157.81475994462266,
                            21.305013681605647
                        ],
                        [
                            -157.81475995682084,
                            21.30501372324747
                        ],
                        [
                            -157.81476033971907,
                            21.305015022308066
                        ],
                        [
                            -157.81476066163367,
                            21.305016112256197
                        ],
                        [
                            -157.81476131010146,
                            21.305018314769857
                        ],
                        [
                            -157.814761682686,
                            21.305019577622229
                        ],
                        [
                            -157.81476201299364,
                            21.305020702861647
                        ],
                        [
                            -157.81476789350396,
                            21.305040651367595
                        ],
                        [
                            -157.81478233360832,
                            21.305036913684081
                        ],
                        [
                            -157.81478346824287,
                            21.305040761080303
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 659,
                "NUMBER": "1003A",
                "PROPER_NAME": "COTTAGE 1 - HVAC",
                "DISPLAY_NAME": "COTTAGE 1 - HVAC - 1003A",
                "ADDRESS": "2010 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "COTTAGE 1 - HVAC",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1003A_01.jpg",
                "HEIGHT (ft)": 16.699999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 80.605267186620182,
                "SHAPE_Area": 236.97758366450492
            }
        },
        {
            "type": "Feature",
            "id": 677,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81367989224648,
                            21.304841042405908
                        ],
                        [
                            -157.81380496427246,
                            21.304966561155908
                        ],
                        [
                            -157.81393478512197,
                            21.304853349421037
                        ],
                        [
                            -157.81386743692755,
                            21.304785759185133
                        ],
                        [
                            -157.81386002552441,
                            21.304778320830021
                        ],
                        [
                            -157.81381099455237,
                            21.304729113577892
                        ],
                        [
                            -157.81367989224648,
                            21.304841042405908
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 677,
                "NUMBER": "1132D",
                "PROPER_NAME": "TRANSPORTATION SERVICES - COVERED EXTENSION WORK AREA",
                "DISPLAY_NAME": "TRANSPORTATION SERVICES - COVERED EXTENSION WORK AREA - 1132D",
                "ADDRESS": "2027 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "TRANSPORTATION SERVICES",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1132D_01.jpg",
                "HEIGHT (ft)": 21.900000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 74.620248772800863,
                "SHAPE_Area": 347.93133977548177
            }
        },
        {
            "type": "Feature",
            "id": 1315,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81450422656488,
                            21.292675749309993
                        ],
                        [
                            -157.81450294593489,
                            21.292677136932408
                        ],
                        [
                            -157.81450319686388,
                            21.29267733925224
                        ],
                        [
                            -157.81450442752046,
                            21.292678337131612
                        ],
                        [
                            -157.81450478634355,
                            21.292677946683892
                        ],
                        [
                            -157.81450876147306,
                            21.292673636598892
                        ],
                        [
                            -157.81451545443034,
                            21.292666379823846
                        ],
                        [
                            -157.81451858650055,
                            21.292662983452637
                        ],
                        [
                            -157.81453643569671,
                            21.292643628446399
                        ],
                        [
                            -157.81453791728225,
                            21.292644828645305
                        ],
                        [
                            -157.81453807383605,
                            21.292644659007035
                        ],
                        [
                            -157.814539196955,
                            21.292643440112457
                        ],
                        [
                            -157.81453917215481,
                            21.292643407415742
                        ],
                        [
                            -157.81453771549982,
                            21.292642223653448
                        ],
                        [
                            -157.81454403784753,
                            21.292635384343654
                        ],
                        [
                            -157.81455989362533,
                            21.292618192466882
                        ],
                        [
                            -157.81456204164124,
                            21.292615862392488
                        ],
                        [
                            -157.81456352323397,
                            21.292617061687832
                        ],
                        [
                            -157.81456446644106,
                            21.292616040271927
                        ],
                        [
                            -157.81456480386285,
                            21.292615674064887
                        ],
                        [
                            -157.81456332227739,
                            21.29261447386622
                        ],
                        [
                            -157.81456764843551,
                            21.292609783214207
                        ],
                        [
                            -157.81457401370542,
                            21.292602880064695
                        ],
                        [
                            -157.81458764758335,
                            21.292588095430819
                        ],
                        [
                            -157.81458912916878,
                            21.292589295629277
                        ],
                        [
                            -157.81459040980442,
                            21.292587907102774
                        ],
                        [
                            -157.81458892821175,
                            21.292586707807668
                        ],
                        [
                            -157.81461453414366,
                            21.292558940841349
                        ],
                        [
                            -157.81463231030722,
                            21.292573339585459
                        ],
                        [
                            -157.81463359094235,
                            21.292571951058601
                        ],
                        [
                            -157.81463210935669,
                            21.292570750860527
                        ],
                        [
                            -157.8146577152707,
                            21.292542984790412
                        ],
                        [
                            -157.8146591968563,
                            21.292544184988262
                        ],
                        [
                            -157.81466047652702,
                            21.292542796454381
                        ],
                        [
                            -157.81465899590529,
                            21.29254159626333
                        ],
                        [
                            -157.81466514140453,
                            21.292534931864331
                        ],
                        [
                            -157.81467148818638,
                            21.292528049358559
                        ],
                        [
                            -157.81467855063363,
                            21.292520392266031
                        ],
                        [
                            -157.81467912921204,
                            21.292519763966876
                        ],
                        [
                            -157.81468417299365,
                            21.292514294221878
                        ],
                        [
                            -157.81468460180912,
                            21.292513830188565
                        ],
                        [
                            -157.81468608339466,
                            21.292515030386181
                        ],
                        [
                            -157.81468736306488,
                            21.292513641852068
                        ],
                        [
                            -157.81468640343397,
                            21.2925128645029
                        ],
                        [
                            -157.81465032915867,
                            21.292483644175782
                        ],
                        [
                            -157.81465160978559,
                            21.292482256552063
                        ],
                        [
                            -157.81465012723675,
                            21.292481056347381
                        ],
                        [
                            -157.81464884853037,
                            21.292482444887998
                        ],
                        [
                            -157.81463499134151,
                            21.292471221154248
                        ],
                        [
                            -157.8146207673496,
                            21.292459700331225
                        ],
                        [
                            -157.81462070126918,
                            21.292459646565877
                        ],
                        [
                            -157.8146383053851,
                            21.292440557224587
                        ],
                        [
                            -157.81463682476456,
                            21.292439357033384
                        ],
                        [
                            -157.81463554413068,
                            21.292440745560341
                        ],
                        [
                            -157.81461924956619,
                            21.292427547015226
                        ],
                        [
                            -157.8146205302001,
                            21.292426158488379
                        ],
                        [
                            -157.81462048325966,
                            21.292426122022228
                        ],
                        [
                            -157.81461905721847,
                            21.292424967384719
                        ],
                        [
                            -157.81461760753683,
                            21.292426520944961
                        ],
                        [
                            -157.81460871898912,
                            21.292419320665939
                        ],
                        [
                            -157.81461025730363,
                            21.292417652999337
                        ],
                        [
                            -157.81461811029916,
                            21.292409138738346
                        ],
                        [
                            -157.81461816184105,
                            21.292409082187703
                        ],
                        [
                            -157.81461668024986,
                            21.292407882892888
                        ],
                        [
                            -157.81461665496445,
                            21.292407910719934
                        ],
                        [
                            -157.81461539962331,
                            21.292409270516366
                        ],
                        [
                            -157.81461535174074,
                            21.292409231333398
                        ],
                        [
                            -157.81458789874833,
                            21.292387007031202
                        ],
                        [
                            -157.8145872465397,
                            21.292386479375338
                        ],
                        [
                            -157.81458853397137,
                            21.292385084572885
                        ],
                        [
                            -157.8145877141412,
                            21.292384423841646
                        ],
                        [
                            -157.81458704849618,
                            21.292383888864027
                        ],
                        [
                            -157.81458576591288,
                            21.292385280087057
                        ],
                        [
                            -157.81456753390233,
                            21.292370512255562
                        ],
                        [
                            -157.81454945704445,
                            21.292355870182703
                        ],
                        [
                            -157.81454873205925,
                            21.292355282390432
                        ],
                        [
                            -157.81454745141809,
                            21.292356671820077
                        ],
                        [
                            -157.81454818024434,
                            21.292357261446188
                        ],
                        [
                            -157.81454893301546,
                            21.292357870212104
                        ],
                        [
                            -157.81452338173105,
                            21.292385677304008
                        ],
                        [
                            -157.81452270462836,
                            21.292385128694612
                        ],
                        [
                            -157.81452190014812,
                            21.292384477105067
                        ],
                        [
                            -157.81452062047759,
                            21.292385865637922
                        ],
                        [
                            -157.81452142878439,
                            21.292386520867975
                        ],
                        [
                            -157.81452210109666,
                            21.292387065830084
                        ],
                        [
                            -157.81452177340097,
                            21.292387421264877
                        ],
                        [
                            -157.81449649518683,
                            21.292414831880137
                        ],
                        [
                            -157.81449576157738,
                            21.292414237703174
                        ],
                        [
                            -157.81449501360387,
                            21.292413631680958
                        ],
                        [
                            -157.81449373392559,
                            21.29241502111692
                        ],
                        [
                            -157.81449447806528,
                            21.292415624401972
                        ],
                        [
                            -157.81449521454468,
                            21.292416221309317
                        ],
                        [
                            -157.81449494227533,
                            21.292416516607254
                        ],
                        [
                            -157.81446960862471,
                            21.292443987354734
                        ],
                        [
                            -157.81446892195561,
                            21.292443429643839
                        ],
                        [
                            -157.81446812800559,
                            21.292442787162109
                        ],
                        [
                            -157.8144667995528,
                            21.29244412837464
                        ],
                        [
                            -157.81446765282155,
                            21.292444826380962
                        ],
                        [
                            -157.81446832991705,
                            21.292445375893919
                        ],
                        [
                            -157.81446801778807,
                            21.292445713370423
                        ],
                        [
                            -157.81444266742943,
                            21.29247310269055
                        ],
                        [
                            -157.81444196734566,
                            21.292472534947777
                        ],
                        [
                            -157.81444118584639,
                            21.292471902490899
                        ],
                        [
                            -157.81443990521043,
                            21.292473291016268
                        ],
                        [
                            -157.81444068378912,
                            21.292473927066155
                        ],
                        [
                            -157.81447565382049,
                            21.292502247110061
                        ],
                        [
                            -157.81447694003288,
                            21.292503288743571
                        ],
                        [
                            -157.81447565940422,
                            21.292504676365873
                        ],
                        [
                            -157.81447640642142,
                            21.292505281478057
                        ],
                        [
                            -157.81447714098789,
                            21.292505876565244
                        ],
                        [
                            -157.81447842162379,
                            21.292504488039594
                        ],
                        [
                            -157.81447931038267,
                            21.292505207977179
                        ],
                        [
                            -157.81449767935104,
                            21.292520086996468
                        ],
                        [
                            -157.81449639871516,
                            21.292521475522264
                        ],
                        [
                            -157.81449719746342,
                            21.292522120747854
                        ],
                        [
                            -157.81449788808266,
                            21.292522666742379
                        ],
                        [
                            -157.81449916094229,
                            21.292521286292324
                        ],
                        [
                            -157.81450003246019,
                            21.292521992557532
                        ],
                        [
                            -157.81450305607029,
                            21.292524428613756
                        ],
                        [
                            -157.81448377163744,
                            21.292545339987981
                        ],
                        [
                            -157.81448257169868,
                            21.29254664235652
                        ],
                        [
                            -157.8144746082985,
                            21.292540192076185
                        ],
                        [
                            -157.81447423862363,
                            21.29253989225726
                        ],
                        [
                            -157.81443326890471,
                            21.292584318822122
                        ],
                        [
                            -157.81445252664412,
                            21.292599916880942
                        ],
                        [
                            -157.81445255971303,
                            21.292599880074853
                        ],
                        [
                            -157.81445636758383,
                            21.292595752201269
                        ],
                        [
                            -157.81445658306635,
                            21.29259592716982
                        ],
                        [
                            -157.81446377454935,
                            21.292601752288853
                        ],
                        [
                            -157.81444072889335,
                            21.292626742173102
                        ],
                        [
                            -157.81444221048511,
                            21.292627941469473
                        ],
                        [
                            -157.81444238259877,
                            21.292627754776483
                        ],
                        [
                            -157.81444349015135,
                            21.292626553840723
                        ],
                        [
                            -157.81444358208998,
                            21.292626628566236
                        ],
                        [
                            -157.81447311804246,
                            21.292650551481564
                        ],
                        [
                            -157.81447183740516,
                            21.292651940007101
                        ],
                        [
                            -157.81447331899744,
                            21.292653139303216
                        ],
                        [
                            -157.81447459866359,
                            21.292651751674228
                        ],
                        [
                            -157.81450422656488,
                            21.292675749309993
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 1315,
                "NUMBER": "1120D",
                "PROPER_NAME": "HALE WAINANI I TOWER",
                "DISPLAY_NAME": "HALE WAINANI I TOWER - 1120D",
                "ADDRESS": "2591 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE WAINANI TOWERS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1120D_01.jpg",
                "HEIGHT (ft)": 114.40000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 115.68768376802088,
                "SHAPE_Area": 471.00888439925706
            }
        },
        {
            "type": "Feature",
            "id": 1318,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81432775434359,
                            21.293074645929064
                        ],
                        [
                            -157.81432647945545,
                            21.29307603810728
                        ],
                        [
                            -157.81432796494235,
                            21.293077232915209
                        ],
                        [
                            -157.81435984191467,
                            21.293042433910436
                        ],
                        [
                            -157.81436132643762,
                            21.293043628711285
                        ],
                        [
                            -157.81436260228904,
                            21.293042236539574
                        ],
                        [
                            -157.81436111679497,
                            21.293041042635274
                        ],
                        [
                            -157.81438534348746,
                            21.293014593978977
                        ],
                        [
                            -157.814386828967,
                            21.293015789689743
                        ],
                        [
                            -157.81438810385404,
                            21.293014397511012
                        ],
                        [
                            -157.81438661836728,
                            21.293013202703609
                        ],
                        [
                            -157.81441084504331,
                            21.292986754946458
                        ],
                        [
                            -157.81441152026389,
                            21.292987298122771
                        ],
                        [
                            -157.81441233147947,
                            21.29298795156712
                        ],
                        [
                            -157.81441360540938,
                            21.292986558478059
                        ],
                        [
                            -157.81441211992265,
                            21.292985363670862
                        ],
                        [
                            -157.81443762147561,
                            21.292957523730383
                        ],
                        [
                            -157.81445505364584,
                            21.292971548777661
                        ],
                        [
                            -157.81445544440402,
                            21.292971864102764
                        ],
                        [
                            -157.81445672790707,
                            21.292970479211284
                        ],
                        [
                            -157.81445523573811,
                            21.292969276226884
                        ],
                        [
                            -157.81445576282059,
                            21.292968699059195
                        ],
                        [
                            -157.81448035219989,
                            21.292941855450518
                        ],
                        [
                            -157.81448073630924,
                            21.292941437175877
                        ],
                        [
                            -157.81448222083225,
                            21.292942631975667
                        ],
                        [
                            -157.81448349667443,
                            21.292941240706273
                        ],
                        [
                            -157.81448201119474,
                            21.29294004499635
                        ],
                        [
                            -157.8144821308027,
                            21.292939914847135
                        ],
                        [
                            -157.81448255770678,
                            21.292939448994201
                        ],
                        [
                            -157.81450612017613,
                            21.292913725580028
                        ],
                        [
                            -157.81450739311168,
                            21.29291233609673
                        ],
                        [
                            -157.81450751272683,
                            21.292912205044168
                        ],
                        [
                            -157.81450895319367,
                            21.292913364301242
                        ],
                        [
                            -157.81450899916305,
                            21.292913401663974
                        ],
                        [
                            -157.81450933466522,
                            21.292913034540177
                        ],
                        [
                            -157.81451027309143,
                            21.292912008574092
                        ],
                        [
                            -157.81450840449955,
                            21.292910505723782
                        ],
                        [
                            -157.81452486383819,
                            21.292892700183877
                        ],
                        [
                            -157.81452498735953,
                            21.292892562835075
                        ],
                        [
                            -157.81452389074659,
                            21.29289167792021
                        ],
                        [
                            -157.81450621472223,
                            21.292877409957491
                        ],
                        [
                            -157.81448960465585,
                            21.292895379754448
                        ],
                        [
                            -157.8144731417471,
                            21.292882133935873
                        ],
                        [
                            -157.81447441471161,
                            21.292880740839472
                        ],
                        [
                            -157.81447348377878,
                            21.292879990792901
                        ],
                        [
                            -157.81447293211704,
                            21.292879546053189
                        ],
                        [
                            -157.81447165626085,
                            21.29288093912923
                        ],
                        [
                            -157.81447138616983,
                            21.292880722220136
                        ],
                        [
                            -157.81444514647538,
                            21.292859609477762
                        ],
                        [
                            -157.81444417816871,
                            21.292858832066123
                        ],
                        [
                            -157.814443807522,
                            21.292858533143662
                        ],
                        [
                            -157.81444343591139,
                            21.292858234214403
                        ],
                        [
                            -157.81444440932719,
                            21.292857172359504
                        ],
                        [
                            -157.81445992764571,
                            21.292840235583487
                        ],
                        [
                            -157.81446001516295,
                            21.292840140440486
                        ],
                        [
                            -157.81445852774223,
                            21.29283894652351
                        ],
                        [
                            -157.81445842563639,
                            21.292839057824775
                        ],
                        [
                            -157.81445821070602,
                            21.292839294806065
                        ],
                        [
                            -157.8144418587039,
                            21.292826163592984
                        ],
                        [
                            -157.81444190636876,
                            21.292826109725279
                        ],
                        [
                            -157.81444217670401,
                            21.292825815317247
                        ],
                        [
                            -157.81444205892151,
                            21.29282571782494
                        ],
                        [
                            -157.81444069505963,
                            21.292824622344181
                        ],
                        [
                            -157.81444041594801,
                            21.292824929337872
                        ],
                        [
                            -157.81443149240422,
                            21.292817764034936
                        ],
                        [
                            -157.81444071708844,
                            21.292807690255859
                        ],
                        [
                            -157.81444059734201,
                            21.292807597266684
                        ],
                        [
                            -157.81443923160322,
                            21.292806495448975
                        ],
                        [
                            -157.81443795671854,
                            21.292807887628218
                        ],
                        [
                            -157.81443758510807,
                            21.292807588698956
                        ],
                        [
                            -157.81443744720721,
                            21.292807475707331
                        ],
                        [
                            -157.81440973735903,
                            21.292785181811887
                        ],
                        [
                            -157.81441017689474,
                            21.29278470340061
                        ],
                        [
                            -157.81441039278172,
                            21.292784467329501
                        ],
                        [
                            -157.81441101223652,
                            21.292783790536181
                        ],
                        [
                            -157.81440952771564,
                            21.292782595735837
                        ],
                        [
                            -157.81440825186701,
                            21.29278398790807
                        ],
                        [
                            -157.81437112058251,
                            21.292754112346028
                        ],
                        [
                            -157.81437007324541,
                            21.292755256791761
                        ],
                        [
                            -157.81436984569044,
                            21.292755505428094
                        ],
                        [
                            -157.81437139438515,
                            21.292756751270637
                        ],
                        [
                            -157.81437074770977,
                            21.292757456780581
                        ],
                        [
                            -157.81437060087413,
                            21.292757616549814
                        ],
                        [
                            -157.81434694818071,
                            21.292783412484621
                        ],
                        [
                            -157.81434655824472,
                            21.292783836138273
                        ],
                        [
                            -157.81434587752895,
                            21.29278457935072
                        ],
                        [
                            -157.81434434416937,
                            21.292783344456652
                        ],
                        [
                            -157.81434306928404,
                            21.292784736635152
                        ],
                        [
                            -157.81434314974305,
                            21.292784800439197
                        ],
                        [
                            -157.81434460168697,
                            21.292785970619118
                        ],
                        [
                            -157.81434409796253,
                            21.292786519945924
                        ],
                        [
                            -157.81434382470655,
                            21.292786817946777
                        ],
                        [
                            -157.81432001447834,
                            21.292812784411868
                        ],
                        [
                            -157.81431941448901,
                            21.292813437853805
                        ],
                        [
                            -157.81431911302678,
                            21.292813767274591
                        ],
                        [
                            -157.81431908579901,
                            21.292813796894681
                        ],
                        [
                            -157.81431757261572,
                            21.292812570272989
                        ],
                        [
                            -157.81431644846458,
                            21.292813797289206
                        ],
                        [
                            -157.81431629287422,
                            21.292813966934016
                        ],
                        [
                            -157.81431780995655,
                            21.292815188162834
                        ],
                        [
                            -157.81431691238944,
                            21.292816167439351
                        ],
                        [
                            -157.8143167597197,
                            21.292816333491178
                        ],
                        [
                            -157.81430947612728,
                            21.292824277190739
                        ],
                        [
                            -157.81430433581016,
                            21.292829881751885
                        ],
                        [
                            -157.81429366422387,
                            21.292841520843762
                        ],
                        [
                            -157.81429315271552,
                            21.292842079149477
                        ],
                        [
                            -157.81429229404392,
                            21.292843016240464
                        ],
                        [
                            -157.81429079036172,
                            21.292841806849879
                        ],
                        [
                            -157.81428951547539,
                            21.29284319902791
                        ],
                        [
                            -157.81429101820092,
                            21.292844407508387
                        ],
                        [
                            -157.81429060395018,
                            21.292844858092334
                        ],
                        [
                            -157.81429047655865,
                            21.292844997220481
                        ],
                        [
                            -157.81426734312186,
                            21.292870226761117
                        ],
                        [
                            -157.81426621899161,
                            21.292871451066919
                        ],
                        [
                            -157.81426550036485,
                            21.292872233761134
                        ],
                        [
                            -157.81426401392386,
                            21.292871038042602
                        ],
                        [
                            -157.81426343433495,
                            21.292871671753414
                        ],
                        [
                            -157.81426273903699,
                            21.292872430220406
                        ],
                        [
                            -157.81429987129789,
                            21.292902304909784
                        ],
                        [
                            -157.8142985954544,
                            21.292903696177728
                        ],
                        [
                            -157.81430008093218,
                            21.292904891889194
                        ],
                        [
                            -157.81430075192296,
                            21.292904159449133
                        ],
                        [
                            -157.81430094641649,
                            21.292903946715651
                        ],
                        [
                            -157.814301355819,
                            21.292903499711088
                        ],
                        [
                            -157.81432066421249,
                            21.292919034905029
                        ],
                        [
                            -157.81431938933295,
                            21.292920426179922
                        ],
                        [
                            -157.81432087481102,
                            21.292921621891214
                        ],
                        [
                            -157.8143221496978,
                            21.292920229712973
                        ],
                        [
                            -157.81432449812888,
                            21.292922118079201
                        ],
                        [
                            -157.81430411716414,
                            21.29294440840912
                        ],
                        [
                            -157.8142972921876,
                            21.292938916505534
                        ],
                        [
                            -157.81425648813985,
                            21.292983458012969
                        ],
                        [
                            -157.81427579845166,
                            21.292998995032427
                        ],
                        [
                            -157.81427962025984,
                            21.292994813961798
                        ],
                        [
                            -157.81428705053673,
                            21.293000793443628
                        ],
                        [
                            -157.8142640977687,
                            21.293025848093901
                        ],
                        [
                            -157.81426558325455,
                            21.293027042902359
                        ],
                        [
                            -157.81426685909946,
                            21.293025651634746
                        ],
                        [
                            -157.81429656493714,
                            21.293049551387153
                        ],
                        [
                            -157.81429528908507,
                            21.293050943558342
                        ],
                        [
                            -157.8142967745714,
                            21.29305213836653
                        ],
                        [
                            -157.81429804945964,
                            21.293050746188555
                        ],
                        [
                            -157.81432775434359,
                            21.293074645929064
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 1318,
                "NUMBER": "1120A",
                "PROPER_NAME": "HALE WAINANI F TOWER",
                "DISPLAY_NAME": "HALE WAINANI F TOWER - 1120A",
                "ADDRESS": "2591 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE WAINANI TOWERS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1120A_01.jpg",
                "HEIGHT (ft)": 124,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 119.8631000938687,
                "SHAPE_Area": 478.21575723291824
            }
        },
        {
            "type": "Feature",
            "id": 1327,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81435577907993,
                            21.292382017993546
                        ],
                        [
                            -157.81435702929232,
                            21.292382740477588
                        ],
                        [
                            -157.81435780115999,
                            21.292381568796618
                        ],
                        [
                            -157.81435857109986,
                            21.292380397102061
                        ],
                        [
                            -157.81435732184408,
                            21.292379675528156
                        ],
                        [
                            -157.81435721150504,
                            21.292379611513681
                        ],
                        [
                            -157.81439834534297,
                            21.29231675695894
                        ],
                        [
                            -157.81439894606567,
                            21.292317093637532
                        ],
                        [
                            -157.81439969969136,
                            21.292315912793946
                        ],
                        [
                            -157.81439973972471,
                            21.292315848935186
                        ],
                        [
                            -157.81440954388404,
                            21.292321500035321
                        ],
                        [
                            -157.81440953120151,
                            21.292321518917198
                        ],
                        [
                            -157.81440874239087,
                            21.292322760040168
                        ],
                        [
                            -157.81441006668416,
                            21.292323500209974
                        ],
                        [
                            -157.81441139194132,
                            21.292324240386574
                        ],
                        [
                            -157.81441218172304,
                            21.292322998367041
                        ],
                        [
                            -157.81441297054087,
                            21.292321756340719
                        ],
                        [
                            -157.81441166735155,
                            21.292321028967027
                        ],
                        [
                            -157.81445305968572,
                            21.292258028964898
                        ],
                        [
                            -157.81445309903091,
                            21.292258050923383
                        ],
                        [
                            -157.81445442333111,
                            21.292258790189486
                        ],
                        [
                            -157.81445521310488,
                            21.292257549073053
                        ],
                        [
                            -157.814456001922,
                            21.292256307046479
                        ],
                        [
                            -157.8144546776218,
                            21.292255567780387
                        ],
                        [
                            -157.81449626114184,
                            21.292192281834058
                        ],
                        [
                            -157.81449748637229,
                            21.292192994203809
                        ],
                        [
                            -157.81449826015105,
                            21.292191824342336
                        ],
                        [
                            -157.81449903488644,
                            21.292190655390968
                        ],
                        [
                            -157.81449780582949,
                            21.292189939380723
                        ],
                        [
                            -157.81455426802398,
                            21.292103999087125
                        ],
                        [
                            -157.81456588465596,
                            21.292110696420178
                        ],
                        [
                            -157.81459412089671,
                            21.292067682484777
                        ],
                        [
                            -157.81459414680555,
                            21.292067697121464
                        ],
                        [
                            -157.81459538531249,
                            21.292068436685696
                        ],
                        [
                            -157.81459617347556,
                            21.292067275958896
                        ],
                        [
                            -157.81459696356634,
                            21.292066115245653
                        ],
                        [
                            -157.81459572409554,
                            21.292065375674643
                        ],
                        [
                            -157.81459566079101,
                            21.292065336383072
                        ],
                        [
                            -157.81462409510729,
                            21.292022021200772
                        ],
                        [
                            -157.81463716466433,
                            21.292002111265738
                        ],
                        [
                            -157.81463841469409,
                            21.292002856331123
                        ],
                        [
                            -157.81463927311015,
                            21.29200158949871
                        ],
                        [
                            -157.81464013248285,
                            21.292000323576399
                        ],
                        [
                            -157.81463884311523,
                            21.291999555649276
                        ],
                        [
                            -157.81465068798977,
                            21.291981509817514
                        ],
                        [
                            -157.81465449430945,
                            21.291983704756721
                        ],
                        [
                            -157.81465565166926,
                            21.291981941357719
                        ],
                        [
                            -157.81459682880933,
                            21.291948024010704
                        ],
                        [
                            -157.81459371716613,
                            21.291946229647056
                        ],
                        [
                            -157.81459256761835,
                            21.291947980453166
                        ],
                        [
                            -157.8145956753626,
                            21.291949780209713
                        ],
                        [
                            -157.81458381098946,
                            21.291967853001896
                        ],
                        [
                            -157.81452558881637,
                            21.291934279535546
                        ],
                        [
                            -157.81452473299444,
                            21.291935583424657
                        ],
                        [
                            -157.81453137845787,
                            21.291939415429276
                        ],
                        [
                            -157.81446719089487,
                            21.292037196252586
                        ],
                        [
                            -157.81444896815319,
                            21.292026688863917
                        ],
                        [
                            -157.81444811233729,
                            21.292027991849217
                        ],
                        [
                            -157.81445480577915,
                            21.292031851296517
                        ],
                        [
                            -157.81439092811334,
                            21.292129080490373
                        ],
                        [
                            -157.81437577383144,
                            21.292120342765362
                        ],
                        [
                            -157.81437491801429,
                            21.292121645750235
                        ],
                        [
                            -157.81439007229628,
                            21.29213038347531
                        ],
                        [
                            -157.81432644468677,
                            21.29222731176565
                        ],
                        [
                            -157.8143080540151,
                            21.292216708322627
                        ],
                        [
                            -157.81430719916065,
                            21.29221801131386
                        ],
                        [
                            -157.8143138599799,
                            21.292221852469289
                        ],
                        [
                            -157.81424994050792,
                            21.292319224041805
                        ],
                        [
                            -157.81424328735378,
                            21.292315388358098
                        ],
                        [
                            -157.81424243249094,
                            21.292316692252271
                        ],
                        [
                            -157.81428258071631,
                            21.292339841667783
                        ],
                        [
                            -157.81427230689781,
                            21.292355493711437
                        ],
                        [
                            -157.81430909978039,
                            21.292376707912634
                        ],
                        [
                            -157.81431937456782,
                            21.292361054970097
                        ],
                        [
                            -157.81435372356998,
                            21.292380866147415
                        ],
                        [
                            -157.81435565983412,
                            21.292381982824814
                        ],
                        [
                            -157.81435567641566,
                            21.29238195855007
                        ],
                        [
                            -157.81435577907993,
                            21.292382017993546
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 1327,
                "NUMBER": "1120C",
                "PROPER_NAME": "HALE WAINANI H TOWER",
                "DISPLAY_NAME": "HALE WAINANI H TOWER - 1120C",
                "ADDRESS": "2591 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE WAINANI TOWERS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1120C_01.jpg",
                "HEIGHT (ft)": 40.399999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 157.85011825913301,
                "SHAPE_Area": 703.78514846735106
            }
        },
        {
            "type": "Feature",
            "id": 1365,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81296465987859,
                            21.294654194808693
                        ],
                        [
                            -157.81296482339241,
                            21.294654239324529
                        ],
                        [
                            -157.81296499387832,
                            21.294654255884478
                        ],
                        [
                            -157.81296516362519,
                            21.29465424443411
                        ],
                        [
                            -157.81296532973408,
                            21.294654205856407
                        ],
                        [
                            -157.81296548545049,
                            21.294654141007118
                        ],
                        [
                            -157.81296562690434,
                            21.294654051665702
                        ],
                        [
                            -157.81296575021105,
                            21.294653941418364
                        ],
                        [
                            -157.81296585054386,
                            21.294653811134438
                        ],
                        [
                            -157.81296592496031,
                            21.294653667116879
                        ],
                        [
                            -157.81296597246029,
                            21.29465351387562
                        ],
                        [
                            -157.81296599012305,
                            21.294653355003593
                        ],
                        [
                            -157.81296597887629,
                            21.294653195024303
                        ],
                        [
                            -157.81296593770526,
                            21.29465304025431
                        ],
                        [
                            -157.81296586850877,
                            21.294652894320567
                        ],
                        [
                            -157.81296577317838,
                            21.29465276175338
                        ],
                        [
                            -157.81296565456944,
                            21.29465264708983
                        ],
                        [
                            -157.81296551555917,
                            21.294652552156954
                        ],
                        [
                            -157.81296536285853,
                            21.294652481519062
                        ],
                        [
                            -157.81297210792704,
                            21.29463935585818
                        ],
                        [
                            -157.81297242705489,
                            21.294639468322277
                        ],
                        [
                            -157.81297276203298,
                            21.294639527598171
                        ],
                        [
                            -157.81297310323691,
                            21.294639531811185
                        ],
                        [
                            -157.81297344102771,
                            21.294639480893373
                        ],
                        [
                            -157.81297376286747,
                            21.294639375659678
                        ],
                        [
                            -157.81297406102334,
                            21.294639218765745
                        ],
                        [
                            -157.81297432388507,
                            21.294639015550029
                        ],
                        [
                            -157.81297454656789,
                            21.294638774108613
                        ],
                        [
                            -157.81297472132439,
                            21.29463849890378
                        ],
                        [
                            -157.8129748422914,
                            21.294638199831482
                        ],
                        [
                            -157.81297490554084,
                            21.294637885897906
                        ],
                        [
                            -157.81297491004355,
                            21.294637565226321
                        ],
                        [
                            -157.81297485570519,
                            21.294637249560104
                        ],
                        [
                            -157.81297474245324,
                            21.294636947932645
                        ],
                        [
                            -157.81297457600584,
                            21.294636668514794
                        ],
                        [
                            -157.81297435917483,
                            21.294636421263657
                        ],
                        [
                            -157.8129741005917,
                            21.294636211660439
                        ],
                        [
                            -157.8129738069313,
                            21.294636048786124
                        ],
                        [
                            -157.81297375506236,
                            21.294636025835594
                        ],
                        [
                            -157.81298022242225,
                            21.294622431163365
                        ],
                        [
                            -157.81298041667495,
                            21.294622008843493
                        ],
                        [
                            -157.81298050006382,
                            21.294621827850236
                        ],
                        [
                            -157.81298655215107,
                            21.294608209471168
                        ],
                        [
                            -157.81298673485875,
                            21.294607784359698
                        ],
                        [
                            -157.81298686649384,
                            21.294607477232113
                        ],
                        [
                            -157.81298757035739,
                            21.294605773885877
                        ],
                        [
                            -157.81299279630053,
                            21.294593120824388
                        ],
                        [
                            -157.81299285139559,
                            21.294592982090908
                        ],
                        [
                            -157.81299296747775,
                            21.294592691114637
                        ],
                        [
                            -157.81299827940995,
                            21.294578812759486
                        ],
                        [
                            -157.81299843904941,
                            21.29457837935481
                        ],
                        [
                            -157.81299844986259,
                            21.294578353232762
                        ],
                        [
                            -157.8130026410266,
                            21.294566477919211
                        ],
                        [
                            -157.81300277516237,
                            21.294566099441461
                        ],
                        [
                            -157.81300365797415,
                            21.294563598760575
                        ],
                        [
                            -157.81300399193017,
                            21.294563665256295
                        ],
                        [
                            -157.81300433309042,
                            21.294563674889279
                        ],
                        [
                            -157.81300467082298,
                            21.294563631198091
                        ],
                        [
                            -157.81300499550349,
                            21.294563532308096
                        ],
                        [
                            -157.81300529650008,
                            21.294563381757865
                        ],
                        [
                            -157.81300556510146,
                            21.294563184002914
                        ],
                        [
                            -157.8130057944951,
                            21.294562947125712
                        ],
                        [
                            -157.81300597500578,
                            21.294562675574969
                        ],
                        [
                            -157.81300610270543,
                            21.294562378356897
                        ],
                        [
                            -157.81300617268752,
                            21.294562066277557
                        ],
                        [
                            -157.81300618489399,
                            21.294561746563684
                        ],
                        [
                            -157.81300613731739,
                            21.294561429138376
                        ],
                        [
                            -157.81300603179832,
                            21.294561124855306
                        ],
                        [
                            -157.81300587115604,
                            21.294560842768256
                        ],
                        [
                            -157.81300566015196,
                            21.294560590137923
                        ],
                        [
                            -157.81300540738133,
                            21.294560376962178
                        ],
                        [
                            -157.81300511762734,
                            21.294560207791747
                        ],
                        [
                            -157.81300483325782,
                            21.294560088345705
                        ],
                        [
                            -157.81300511014712,
                            21.294559218527247
                        ],
                        [
                            -157.81300717010791,
                            21.294552734971781
                        ],
                        [
                            -157.81300932897457,
                            21.294545938637516
                        ],
                        [
                            -157.81300944579652,
                            21.294545555520703
                        ],
                        [
                            -157.81300946361804,
                            21.294545496926045
                        ],
                        [
                            -157.8130096242366,
                            21.294544941570653
                        ],
                        [
                            -157.81301368327175,
                            21.294530913450608
                        ],
                        [
                            -157.81301386695918,
                            21.294530246237571
                        ],
                        [
                            -157.81301782884884,
                            21.294514150476591
                        ],
                        [
                            -157.81302135130721,
                            21.294499839424937
                        ],
                        [
                            -157.8130215041935,
                            21.29449916657433
                        ],
                        [
                            -157.81302267853363,
                            21.294493372383361
                        ],
                        [
                            -157.8130244807636,
                            21.294484531873035
                        ],
                        [
                            -157.81302481981453,
                            21.294484564075834
                        ],
                        [
                            -157.81302516027904,
                            21.294484540278436
                        ],
                        [
                            -157.8130254915398,
                            21.294484462212754
                        ],
                        [
                            -157.81302580202282,
                            21.294484330700566
                        ],
                        [
                            -157.81302608493738,
                            21.29448415111429
                        ],
                        [
                            -157.8130263286877,
                            21.294483926985759
                        ],
                        [
                            -157.81302652837456,
                            21.294483668217662
                        ],
                        [
                            -157.81302667721445,
                            21.294483379279157
                        ],
                        [
                            -157.81302677032986,
                            21.294483067362954
                        ],
                        [
                            -157.81302680465507,
                            21.294482754128765
                        ],
                        [
                            -157.81302677926246,
                            21.294482435053126
                        ],
                        [
                            -157.81302669499979,
                            21.294482124596229
                        ],
                        [
                            -157.81302655467911,
                            21.294481832715221
                        ],
                        [
                            -157.81302636304724,
                            21.294481568477455
                        ],
                        [
                            -157.81302612486564,
                            21.294481339143619
                        ],
                        [
                            -157.81302584778743,
                            21.294481151994802
                        ],
                        [
                            -157.81302554043694,
                            21.29448101341556
                        ],
                        [
                            -157.81302521146009,
                            21.294480927080421
                        ],
                        [
                            -157.8130251575619,
                            21.294480916763053
                        ],
                        [
                            -157.81302690549597,
                            21.294470674712294
                        ],
                        [
                            -157.81302757781776,
                            21.294466656658894
                        ],
                        [
                            -157.81302767687683,
                            21.294466204759196
                        ],
                        [
                            -157.81302778046674,
                            21.294465548725338
                        ],
                        [
                            -157.81302942850382,
                            21.294454062002401
                        ],
                        [
                            -157.81302961431837,
                            21.294452769658633
                        ],
                        [
                            -157.81302975827063,
                            21.294451768814536
                        ],
                        [
                            -157.81302999415175,
                            21.294450123598416
                        ],
                        [
                            -157.81303009074125,
                            21.294449378983018
                        ],
                        [
                            -157.81303012238581,
                            21.294448919380798
                        ],
                        [
                            -157.81303175995762,
                            21.294435014209657
                        ],
                        [
                            -157.81303179757339,
                            21.294434651312233
                        ],
                        [
                            -157.81303180700272,
                            21.2944345574262
                        ],
                        [
                            -157.81303312301486,
                            21.294420002256985
                        ],
                        [
                            -157.81303315946437,
                            21.294419544495415
                        ],
                        [
                            -157.81303318968082,
                            21.294419142700075
                        ],
                        [
                            -157.81303417041624,
                            21.294403604988624
                        ],
                        [
                            -157.81303446643997,
                            21.294403593525285
                        ],
                        [
                            -157.8130347995413,
                            21.294403526313232
                        ],
                        [
                            -157.81303511571323,
                            21.294403406585193
                        ],
                        [
                            -157.81303540530229,
                            21.294403236079859
                        ],
                        [
                            -157.81303565861162,
                            21.294403021955986
                        ],
                        [
                            -157.8130358678865,
                            21.294402769579239
                        ],
                        [
                            -157.81303602727832,
                            21.294402487038845
                        ],
                        [
                            -157.81303613286624,
                            21.294402182437693
                        ],
                        [
                            -157.81303617975104,
                            21.294401865678509
                        ],
                        [
                            -157.8130361678601,
                            21.294401545794692
                        ],
                        [
                            -157.8130360971065,
                            21.294401233626299
                        ],
                        [
                            -157.81303596838882,
                            21.294400937310158
                        ],
                        [
                            -157.81303578741785,
                            21.294400665920449
                        ],
                        [
                            -157.81303555798394,
                            21.294400427614431
                        ],
                        [
                            -157.81303528868955,
                            21.294400231486623
                        ],
                        [
                            -157.81303498721684,
                            21.294400081204788
                        ],
                        [
                            -157.81303466219003,
                            21.294399983153454
                        ],
                        [
                            -157.81303435116467,
                            21.29439994211441
                        ],
                        [
                            -157.81303450062688,
                            21.29439501337054
                        ],
                        [
                            -157.8130347922731,
                            21.294385462080555
                        ],
                        [
                            -157.81305058669352,
                            21.294385082917891
                        ],
                        [
                            -157.81305428614297,
                            21.294384744939112
                        ],
                        [
                            -157.8130585455051,
                            21.294384035157329
                        ],
                        [
                            -157.81306263712625,
                            21.294382655087638
                        ],
                        [
                            -157.81306645624193,
                            21.294380640066219
                        ],
                        [
                            -157.81306990506508,
                            21.294378041686965
                        ],
                        [
                            -157.81307289528985,
                            21.29437492648043
                        ],
                        [
                            -157.81307535035259,
                            21.294371374210343
                        ],
                        [
                            -157.81307720739235,
                            21.29436747583129
                        ],
                        [
                            -157.81307841886027,
                            21.29436333115985
                        ],
                        [
                            -157.8130789537372,
                            21.294359046318828
                        ],
                        [
                            -157.81307879832775,
                            21.294354731020022
                        ],
                        [
                            -157.81307773436737,
                            21.294350141471639
                        ],
                        [
                            -157.81307592226071,
                            21.294345792651622
                        ],
                        [
                            -157.81307341243541,
                            21.294341805579649
                        ],
                        [
                            -157.81307027473525,
                            21.294338291208611
                        ],
                        [
                            -157.81306659647669,
                            21.294335347336997
                        ],
                        [
                            -157.81306248001894,
                            21.294333055887357
                        ],
                        [
                            -157.8130580399154,
                            21.294331480626521
                        ],
                        [
                            -157.81305339972604,
                            21.294330665391108
                        ],
                        [
                            -157.81305286779553,
                            21.294330644475707
                        ],
                        [
                            -157.8130496839309,
                            21.294330518134355
                        ],
                        [
                            -157.81303389876356,
                            21.294330946145468
                        ],
                        [
                            -157.81303261494693,
                            21.294316518991799
                        ],
                        [
                            -157.81303292290704,
                            21.29431646153974
                        ],
                        [
                            -157.81303324193419,
                            21.294316346348772
                        ],
                        [
                            -157.81303353340738,
                            21.294316181277065
                        ],
                        [
                            -157.813033791507,
                            21.29431597080054
                        ],
                        [
                            -157.81303400556493,
                            21.294315722974439
                        ],
                        [
                            -157.81303417071828,
                            21.294315443184853
                        ],
                        [
                            -157.81303428111104,
                            21.294315140424352
                        ],
                        [
                            -157.81303433473579,
                            21.294314824616102
                        ],
                        [
                            -157.81303432766435,
                            21.294314504766248
                        ],
                        [
                            -157.81303426270864,
                            21.294314190831962
                        ],
                        [
                            -157.81303413978887,
                            21.29431389274993
                        ],
                        [
                            -157.81303396365198,
                            21.29431361958753
                        ],
                        [
                            -157.81303374099446,
                            21.294313377715731
                        ],
                        [
                            -157.81303347462813,
                            21.294313177091635
                        ],
                        [
                            -157.81303317608354,
                            21.294313022313489
                        ],
                        [
                            -157.81303285399937,
                            21.294312917959189
                        ],
                        [
                            -157.81303251605777,
                            21.294312867696444
                        ],
                        [
                            -157.81303222009223,
                            21.294312871933094
                        ],
                        [
                            -157.81303178242018,
                            21.294309275162277
                        ],
                        [
                            -157.81303076592005,
                            21.294300933320258
                        ],
                        [
                            -157.81303033726323,
                            21.294297414304527
                        ],
                        [
                            -157.81303028359935,
                            21.294297014627819
                        ],
                        [
                            -157.81303022073897,
                            21.294296559779504
                        ],
                        [
                            -157.81302805999181,
                            21.294282100243528
                        ],
                        [
                            -157.81302804531657,
                            21.294282007090903
                        ],
                        [
                            -157.81302798555024,
                            21.294281647120325
                        ],
                        [
                            -157.8130255418429,
                            21.294267853193979
                        ],
                        [
                            -157.81302548382376,
                            21.294267395669625
                        ],
                        [
                            -157.81302534419447,
                            21.294266657518932
                        ],
                        [
                            -157.81302273654038,
                            21.294253833580427
                        ],
                        [
                            -157.81302223573769,
                            21.294251376442269
                        ],
                        [
                            -157.81302209540485,
                            21.294250725915422
                        ],
                        [
                            -157.81302196981181,
                            21.294250280562
                        ],
                        [
                            -157.81301872470058,
                            21.294236172024902
                        ],
                        [
                            -157.81301877781615,
                            21.29423615975201
                        ],
                        [
                            -157.81301910061163,
                            21.294236055428311
                        ],
                        [
                            -157.81301939970155,
                            21.294235902154416
                        ],
                        [
                            -157.81301966447572,
                            21.294235700758858
                        ],
                        [
                            -157.81301988908561,
                            21.294235459330924
                        ],
                        [
                            -157.81302006479086,
                            21.294235185939474
                        ],
                        [
                            -157.81302014244687,
                            21.29423499858202
                        ],
                        [
                            -157.81302018767795,
                            21.294234887784047
                        ],
                        [
                            -157.81302025381876,
                            21.294234573870817
                        ],
                        [
                            -157.81302026024181,
                            21.294234254116141
                        ],
                        [
                            -157.81302020783127,
                            21.294233938463524
                        ],
                        [
                            -157.81302009651452,
                            21.294233635946345
                        ],
                        [
                            -157.81301993295912,
                            21.29423335654894
                        ],
                        [
                            -157.81301971807812,
                            21.294233106601453
                        ],
                        [
                            -157.81301946045954,
                            21.294232897005124
                        ],
                        [
                            -157.81301916874213,
                            21.294232732337836
                        ],
                        [
                            -157.81301885060074,
                            21.294232617170628
                        ],
                        [
                            -157.81301851564527,
                            21.294232555184852
                        ],
                        [
                            -157.81301817446408,
                            21.294232548261959
                        ],
                        [
                            -157.81301783763811,
                            21.29423259918671
                        ],
                        [
                            -157.8130140150067,
                            21.294218145095623
                        ],
                        [
                            -157.81301382272537,
                            21.294217481554984
                        ],
                        [
                            -157.81300458290565,
                            21.294187516905943
                        ],
                        [
                            -157.81300436069299,
                            21.294186859477939
                        ],
                        [
                            -157.81299930039833,
                            21.294172520423057
                        ],
                        [
                            -157.81299927869304,
                            21.294172462453062
                        ],
                        [
                            -157.81299914097494,
                            21.294172086575131
                        ],
                        [
                            -157.81299796074236,
                            21.294169010340568
                        ],
                        [
                            -157.81299641902058,
                            21.294164974867051
                        ],
                        [
                            -157.81299588656296,
                            21.294163578988552
                        ],
                        [
                            -157.81299382556628,
                            21.294158186575238
                        ],
                        [
                            -157.81299410515334,
                            21.294158061168922
                        ],
                        [
                            -157.81299438424799,
                            21.294157877038803
                        ],
                        [
                            -157.81299462512064,
                            21.294157651083207
                        ],
                        [
                            -157.81299482097327,
                            21.294157389577922
                        ],
                        [
                            -157.8129949650079,
                            21.29415709879876
                        ],
                        [
                            -157.81299505135414,
                            21.294156789544971
                        ],
                        [
                            -157.81299508090336,
                            21.294156470856766
                        ],
                        [
                            -157.81299505068412,
                            21.294156152650469
                        ],
                        [
                            -157.81299496255164,
                            21.294155843973051
                        ],
                        [
                            -157.81299481739006,
                            21.29415555476805
                        ],
                        [
                            -157.81299462092468,
                            21.294155292302946
                        ],
                        [
                            -157.81299437885184,
                            21.294155067458579
                        ],
                        [
                            -157.81299409981023,
                            21.294154884812844
                        ],
                        [
                            -157.81299378953972,
                            21.294154749826525
                        ],
                        [
                            -157.81299346053461,
                            21.29415466710471
                        ],
                        [
                            -157.81299312144816,
                            21.294154639418579
                        ],
                        [
                            -157.8129927809409,
                            21.294154668635976
                        ],
                        [
                            -157.81299245156515,
                            21.294154752135256
                        ],
                        [
                            -157.81298639360307,
                            21.294140291314001
                        ],
                        [
                            -157.8129863822322,
                            21.294140266842295
                        ],
                        [
                            -157.81298619767517,
                            21.294139841850996
                        ],
                        [
                            -157.8129800873252,
                            21.294126263271888
                        ],
                        [
                            -157.81297995465798,
                            21.294125978671943
                        ],
                        [
                            -157.81297989212916,
                            21.294125842722519
                        ],
                        [
                            -157.81297787636345,
                            21.294121660266892
                        ],
                        [
                            -157.81297313759262,
                            21.294111817842776
                        ],
                        [
                            -157.81297298865533,
                            21.294111518673837
                        ],
                        [
                            -157.81297278184914,
                            21.29411110346291
                        ],
                        [
                            -157.81296594809623,
                            21.294097820610659
                        ],
                        [
                            -157.81296585407819,
                            21.294097644690012
                        ],
                        [
                            -157.8129656366402,
                            21.29409723301767
                        ],
                        [
                            -157.81295838899518,
                            21.294083995125987
                        ],
                        [
                            -157.81295844028446,
                            21.294083970192766
                        ],
                        [
                            -157.81295872319103,
                            21.294083791509916
                        ],
                        [
                            -157.8129589688468,
                            21.294083570105037
                        ],
                        [
                            -157.81295917046097,
                            21.294083311350601
                        ],
                        [
                            -157.81295932024992,
                            21.294083024225607
                        ],
                        [
                            -157.81295941621335,
                            21.294082717749834
                        ],
                        [
                            -157.81295945250261,
                            21.294082400012556
                        ],
                        [
                            -157.8129594300018,
                            21.294082080957292
                        ],
                        [
                            -157.81295934863118,
                            21.294081770520755
                        ],
                        [
                            -157.81295921024596,
                            21.294081477749959
                        ],
                        [
                            -157.81295902054973,
                            21.294081212622377
                        ],
                        [
                            -157.81295878334726,
                            21.294080981488591
                        ],
                        [
                            -157.81295850820493,
                            21.294080793449954
                        ],
                        [
                            -157.81295820184096,
                            21.294080652167409
                        ],
                        [
                            -157.8129578748073,
                            21.294080564039103
                        ],
                        [
                            -157.81295753481518,
                            21.29408052911938
                        ],
                        [
                            -157.81295719533003,
                            21.29408055111681
                        ],
                        [
                            -157.81295686312075,
                            21.294080627368931
                        ],
                        [
                            -157.8129565516964,
                            21.294080756164227
                        ],
                        [
                            -157.81294905630105,
                            21.29406800074192
                        ],
                        [
                            -157.81294920440726,
                            21.294067923191488
                        ],
                        [
                            -157.81294933631594,
                            21.294067822038681
                        ],
                        [
                            -157.81294944814249,
                            21.294067700869689
                        ],
                        [
                            -157.81294953503118,
                            21.294067564167197
                        ],
                        [
                            -157.81294959600365,
                            21.294067413731103
                        ],
                        [
                            -157.8129496281102,
                            21.294067256767704
                        ],
                        [
                            -157.81294963132177,
                            21.294067096890366
                        ],
                        [
                            -157.81294960367438,
                            21.294066938602182
                        ],
                        [
                            -157.8129495480089,
                            21.294066788246923
                        ],
                        [
                            -157.81294946430356,
                            21.294066648534596
                        ],
                        [
                            -157.8129493573343,
                            21.294066524919202
                        ],
                        [
                            -157.81294922707937,
                            21.294066420110809
                        ],
                        [
                            -157.81294908121359,
                            21.294066338680448
                        ],
                        [
                            -157.81294892165755,
                            21.294066281545057
                        ],
                        [
                            -157.81294875417277,
                            21.294066251455444
                        ],
                        [
                            -157.81294858357873,
                            21.294066248445603
                        ],
                        [
                            -157.81294841564426,
                            21.294066274362994
                        ],
                        [
                            -157.81294825424666,
                            21.294066326524774
                        ],
                        [
                            -157.81287109508375,
                            21.29409876512436
                        ],
                        [
                            -157.81286818377842,
                            21.294099989462918
                        ],
                        [
                            -157.81285520381809,
                            21.294105446538545
                        ],
                        [
                            -157.81284418536526,
                            21.294110078198262
                        ],
                        [
                            -157.81284005537216,
                            21.294111815196974
                        ],
                        [
                            -157.81283968105541,
                            21.294111973360351
                        ],
                        [
                            -157.81283033587715,
                            21.294115901335825
                        ],
                        [
                            -157.81281135437266,
                            21.294123881706241
                        ],
                        [
                            -157.81279857462999,
                            21.294129253464043
                        ],
                        [
                            -157.8127981113378,
                            21.294129448038742
                        ],
                        [
                            -157.81278980880043,
                            21.294132938898002
                        ],
                        [
                            -157.81277751169162,
                            21.29413810808537
                        ],
                        [
                            -157.81277706278243,
                            21.294138672247861
                        ],
                        [
                            -157.81277607438639,
                            21.294139916471213
                        ],
                        [
                            -157.81277573258603,
                            21.294140346784083
                        ],
                        [
                            -157.81277512783137,
                            21.294139911601693
                        ],
                        [
                            -157.81277491026873,
                            21.294139755587526
                        ],
                        [
                            -157.81277430538987,
                            21.294139455912742
                        ],
                        [
                            -157.81277373667083,
                            21.294139694913238
                        ],
                        [
                            -157.81277406238956,
                            21.294140186847848
                        ],
                        [
                            -157.81277442772844,
                            21.294140786565272
                        ],
                        [
                            -157.81277527796396,
                            21.294142102477277
                        ],
                        [
                            -157.81277545123754,
                            21.294142372006164
                        ],
                        [
                            -157.81278028316345,
                            21.294149855438452
                        ],
                        [
                            -157.81278654015512,
                            21.294160175628303
                        ],
                        [
                            -157.81279183560554,
                            21.294169476336158
                        ],
                        [
                            -157.81279250192776,
                            21.294170647311962
                        ],
                        [
                            -157.81275898003707,
                            21.294181721425954
                        ],
                        [
                            -157.81272789962949,
                            21.294197882093883
                        ],
                        [
                            -157.81270013206566,
                            21.294218676240501
                        ],
                        [
                            -157.81267645582943,
                            21.294243520887765
                        ],
                        [
                            -157.81265753470245,
                            21.294271719498827
                        ],
                        [
                            -157.81264389915449,
                            21.294302481505813
                        ],
                        [
                            -157.81263593147125,
                            21.29433494447375
                        ],
                        [
                            -157.8126338550363,
                            21.294368198279496
                        ],
                        [
                            -157.81263772806798,
                            21.294401310627581
                        ],
                        [
                            -157.8126474419868,
                            21.294433353187795
                        ],
                        [
                            -157.81266272445916,
                            21.294463427621668
                        ],
                        [
                            -157.81268314703189,
                            21.294490690768146
                        ],
                        [
                            -157.81270813714403,
                            21.294514378282432
                        ],
                        [
                            -157.81273699417903,
                            21.294533826065113
                        ],
                        [
                            -157.81276890910672,
                            21.294548488880949
                        ],
                        [
                            -157.81280298716544,
                            21.294557955645132
                        ],
                        [
                            -157.81280280982082,
                            21.294558313039989
                        ],
                        [
                            -157.81280148415706,
                            21.29456098314359
                        ],
                        [
                            -157.81279764140967,
                            21.294568721577491
                        ],
                        [
                            -157.81279199213645,
                            21.294579351667156
                        ],
                        [
                            -157.81278760004133,
                            21.294587077192165
                        ],
                        [
                            -157.81279018007143,
                            21.294590015145285
                        ],
                        [
                            -157.81279042555769,
                            21.294590295120784
                        ],
                        [
                            -157.81279186219564,
                            21.294591931355196
                        ],
                        [
                            -157.81280249462191,
                            21.29459576264253
                        ],
                        [
                            -157.81280746481295,
                            21.294597553887783
                        ],
                        [
                            -157.81281217357224,
                            21.294599250239852
                        ],
                        [
                            -157.81286652564231,
                            21.294618835132457
                        ],
                        [
                            -157.81287845468756,
                            21.294623133578536
                        ],
                        [
                            -157.81296465987859,
                            21.294654194808693
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 1365,
                "NUMBER": "1122E",
                "PROPER_NAME": "HALE ALOHA - CAFETERIA",
                "DISPLAY_NAME": "HALE ALOHA - CAFETERIA - 1122E",
                "ADDRESS": "2573 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "HALE ALOHA - CAFETERIA",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1122E_01.jpg",
                "HEIGHT (ft)": 18.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 183.00472204003981,
                "SHAPE_Area": 1891.1253387675406
            }
        },
        {
            "type": "Feature",
            "id": 2094,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82038949604083,
                            21.2960932207457
                        ],
                        [
                            -157.82038940430047,
                            21.296096019712532
                        ],
                        [
                            -157.82039234077402,
                            21.296096108950575
                        ],
                        [
                            -157.82039243318985,
                            21.296093346124145
                        ],
                        [
                            -157.82039269880784,
                            21.296085790213692
                        ],
                        [
                            -157.82039279903242,
                            21.29608579362629
                        ],
                        [
                            -157.82041034847123,
                            21.296086328567071
                        ],
                        [
                            -157.8204363516997,
                            21.296087122401943
                        ],
                        [
                            -157.82043624125083,
                            21.296090333184175
                        ],
                        [
                            -157.82044358098872,
                            21.296090556267053
                        ],
                        [
                            -157.82044379685829,
                            21.29608367755128
                        ],
                        [
                            -157.82043941480003,
                            21.296083543854287
                        ],
                        [
                            -157.82044051559691,
                            21.296051898542274
                        ],
                        [
                            -157.82044491981685,
                            21.296052033297926
                        ],
                        [
                            -157.82044509406435,
                            21.296046988174893
                        ],
                        [
                            -157.82044068983737,
                            21.296046854322611
                        ],
                        [
                            -157.82044185346828,
                            21.296013374662927
                        ],
                        [
                            -157.82044625768708,
                            21.296013509418483
                        ],
                        [
                            -157.82044643289831,
                            21.296008464302179
                        ],
                        [
                            -157.82044202867968,
                            21.296008329546648
                        ],
                        [
                            -157.8204431913384,
                            21.295974850783356
                        ],
                        [
                            -157.82044382835718,
                            21.295974870605352
                        ],
                        [
                            -157.82044759651995,
                            21.295974985545584
                        ],
                        [
                            -157.82044777172385,
                            21.295969941332594
                        ],
                        [
                            -157.82044650154197,
                            21.295969901715665
                        ],
                        [
                            -157.82044336750636,
                            21.295969806577144
                        ],
                        [
                            -157.82044453112792,
                            21.295936327820424
                        ],
                        [
                            -157.82044550064325,
                            21.29593635629632
                        ],
                        [
                            -157.82044893535164,
                            21.295936461672465
                        ],
                        [
                            -157.82044910959146,
                            21.295931417452692
                        ],
                        [
                            -157.82044782013182,
                            21.295931377700686
                        ],
                        [
                            -157.82044470537511,
                            21.295931282697332
                        ],
                        [
                            -157.82044587009645,
                            21.295897786783698
                        ],
                        [
                            -157.82044669214855,
                            21.295897812419359
                        ],
                        [
                            -157.82044882969265,
                            21.295897877086063
                        ],
                        [
                            -157.82044896232054,
                            21.295894061186939
                        ],
                        [
                            -157.82044900489626,
                            21.295892832873026
                        ],
                        [
                            -157.82044604530736,
                            21.295892741667338
                        ],
                        [
                            -157.82044720783318,
                            21.295859279163626
                        ],
                        [
                            -157.82044815617814,
                            21.295859302974179
                        ],
                        [
                            -157.82045016851504,
                            21.295859354115876
                        ],
                        [
                            -157.8204502502052,
                            21.295856968831732
                        ],
                        [
                            -157.82045029877531,
                            21.295855593307028
                        ],
                        [
                            -157.82045034372567,
                            21.295854308999484
                        ],
                        [
                            -157.82044834881845,
                            21.295854248042613
                        ],
                        [
                            -157.82044738413759,
                            21.295854217793849
                        ],
                        [
                            -157.82044854774873,
                            21.295820739939902
                        ],
                        [
                            -157.82044941414,
                            21.295820765886269
                        ],
                        [
                            -157.82045149290647,
                            21.295820827430802
                        ],
                        [
                            -157.82045158590262,
                            21.295818112488
                        ],
                        [
                            -157.82045166715307,
                            21.295815782307617
                        ],
                        [
                            -157.82044829507961,
                            21.295815680080782
                        ],
                        [
                            -157.82044579518083,
                            21.295815603840783
                        ],
                        [
                            -157.82044579258991,
                            21.295815686934624
                        ],
                        [
                            -157.8204457075683,
                            21.295818127302336
                        ],
                        [
                            -157.82029454467741,
                            21.295813513925967
                        ],
                        [
                            -157.82029450902016,
                            21.295813512772661
                        ],
                        [
                            -157.82029459662087,
                            21.295810991117982
                        ],
                        [
                            -157.82029133056284,
                            21.295810891437842
                        ],
                        [
                            -157.82028872369264,
                            21.295810811735585
                        ],
                        [
                            -157.82028863370263,
                            21.29581339119056
                        ],
                        [
                            -157.82028862847011,
                            21.295813563701625
                        ],
                        [
                            -157.82028854944051,
                            21.295815856858358
                        ],
                        [
                            -157.82029001719968,
                            21.295815900571416
                        ],
                        [
                            -157.82029292956989,
                            21.295815989642055
                        ],
                        [
                            -157.82029188626353,
                            21.295845983956333
                        ],
                        [
                            -157.82029176590919,
                            21.295849469299991
                        ],
                        [
                            -157.8202873845554,
                            21.295849369029725
                        ],
                        [
                            -157.82028720960594,
                            21.295854380722094
                        ],
                        [
                            -157.82028867832219,
                            21.295854425345276
                        ],
                        [
                            -157.82029159069316,
                            21.295854514415975
                        ],
                        [
                            -157.82029042690885,
                            21.295888009430506
                        ],
                        [
                            -157.82028751453723,
                            21.295887920359764
                        ],
                        [
                            -157.82028602268696,
                            21.295887875574401
                        ],
                        [
                            -157.82028584765803,
                            21.295892897203487
                        ],
                        [
                            -157.82028908369983,
                            21.295893013837841
                        ],
                        [
                            -157.82029025169265,
                            21.295893054546479
                        ],
                        [
                            -157.82028967112444,
                            21.295909756893376
                        ],
                        [
                            -157.82028948467379,
                            21.295915122634515
                        ],
                        [
                            -157.82028948093142,
                            21.295915229208465
                        ],
                        [
                            -157.82028935344539,
                            21.295918883436279
                        ],
                        [
                            -157.82028933341633,
                            21.295919460562963
                        ],
                        [
                            -157.82028908804423,
                            21.295926532397345
                        ],
                        [
                            -157.82028468285728,
                            21.295926398534398
                        ],
                        [
                            -157.82028450860469,
                            21.295931443657064
                        ],
                        [
                            -157.82028891282786,
                            21.295931577513283
                        ],
                        [
                            -157.82028808302917,
                            21.295955472721857
                        ],
                        [
                            -157.82028807822195,
                            21.295955591935822
                        ],
                        [
                            -157.82028774916401,
                            21.29596505717064
                        ],
                        [
                            -157.820283344947,
                            21.295964922411024
                        ],
                        [
                            -157.82028316973032,
                            21.295969967526911
                        ],
                        [
                            -157.82028757298355,
                            21.295970102279803
                        ],
                        [
                            -157.8202868946797,
                            21.295989629749595
                        ],
                        [
                            -157.82028689078592,
                            21.295989755293682
                        ],
                        [
                            -157.8202868058047,
                            21.295992190241083
                        ],
                        [
                            -157.82028641125362,
                            21.296003581047142
                        ],
                        [
                            -157.8202820070355,
                            21.29600344628744
                        ],
                        [
                            -157.82028183085475,
                            21.296008491396542
                        ],
                        [
                            -157.82028623507304,
                            21.296008626156276
                        ],
                        [
                            -157.82028507237814,
                            21.29604210491669
                        ],
                        [
                            -157.82028066718775,
                            21.296041971053462
                        ],
                        [
                            -157.82028049294908,
                            21.296047014369371
                        ],
                        [
                            -157.82028489716851,
                            21.296047149129191
                        ],
                        [
                            -157.82028468452049,
                            21.296053260887838
                        ],
                        [
                            -157.82028468313848,
                            21.29605331327484
                        ],
                        [
                            -157.82028446945444,
                            21.29605943406013
                        ],
                        [
                            -157.82028409049951,
                            21.296070319979659
                        ],
                        [
                            -157.82028407917139,
                            21.296070652348259
                        ],
                        [
                            -157.82028373350863,
                            21.296080627882649
                        ],
                        [
                            -157.82027933024489,
                            21.296080494032857
                        ],
                        [
                            -157.82027920017444,
                            21.296084230451079
                        ],
                        [
                            -157.82027915406385,
                            21.296085539141924
                        ],
                        [
                            -157.82028649475757,
                            21.296085763141711
                        ],
                        [
                            -157.82028653861585,
                            21.296084495087701
                        ],
                        [
                            -157.82028660713746,
                            21.296082552373235
                        ],
                        [
                            -157.82031645948254,
                            21.296083463544644
                        ],
                        [
                            -157.82031649706767,
                            21.296083464711469
                        ],
                        [
                            -157.82033101654787,
                            21.296083907959112
                        ],
                        [
                            -157.8203339751837,
                            21.296083998256904
                        ],
                        [
                            -157.82033371364184,
                            21.296091526190587
                        ],
                        [
                            -157.8203336171386,
                            21.296094317896834
                        ],
                        [
                            -157.82033655265531,
                            21.296094406225766
                        ],
                        [
                            -157.82033664898546,
                            21.296091636199691
                        ],
                        [
                            -157.82033691164969,
                            21.296084088399258
                        ],
                        [
                            -157.82033711306997,
                            21.296084094327941
                        ],
                        [
                            -157.82035452854683,
                            21.296084625625447
                        ],
                        [
                            -157.82035416952482,
                            21.296094947065406
                        ],
                        [
                            -157.82037178642335,
                            21.29609548428985
                        ],
                        [
                            -157.82037193938118,
                            21.296091295432813
                        ],
                        [
                            -157.82037214543695,
                            21.296085163753141
                        ],
                        [
                            -157.82037231986789,
                            21.296085169492606
                        ],
                        [
                            -157.82038974883983,
                            21.296085700881068
                        ],
                        [
                            -157.82038949604083,
                            21.2960932207457
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2094,
                "NUMBER": "1166",
                "PROPER_NAME": "ORVIS AUDITORIUM",
                "DISPLAY_NAME": "ORVIS AUDITORIUM (ORVIS) - 1166",
                "ADDRESS": "2411 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "ORVIS AUDITORIUM",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1166_01.jpg",
                "HEIGHT (ft)": 29.400000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 114.99229237444149,
                "SHAPE_Area": 488.28884098879468
            }
        },
        {
            "type": "Feature",
            "id": 2106,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.82080940156567,
                                21.2962841787724
                            ],
                            [
                                -157.82081138968849,
                                21.296284245098029
                            ],
                            [
                                -157.82081355547666,
                                21.296227357451958
                            ],
                            [
                                -157.82080879073115,
                                21.296172964296829
                            ],
                            [
                                -157.82080902875842,
                                21.296172973191577
                            ],
                            [
                                -157.82081561856805,
                                21.296173192811153
                            ],
                            [
                                -157.82081568934044,
                                21.296171329610434
                            ],
                            [
                                -157.82081592236062,
                                21.296154323092242
                            ],
                            [
                                -157.82081603409205,
                                21.296146237618185
                            ],
                            [
                                -157.820816158431,
                                21.296142976342793
                            ],
                            [
                                -157.82081267753617,
                                21.296142859809688
                            ],
                            [
                                -157.82081267272216,
                                21.296142979927023
                            ],
                            [
                                -157.82080890367695,
                                21.296142854147913
                            ],
                            [
                                -157.82080894696244,
                                21.296142624086361
                            ],
                            [
                                -157.82080946746748,
                                21.296139848900946
                            ],
                            [
                                -157.82081846261724,
                                21.296091940028266
                            ],
                            [
                                -157.82082065267494,
                                21.296034425597004
                            ],
                            [
                                -157.82081866455545,
                                21.296034359271633
                            ],
                            [
                                -157.82081841081191,
                                21.296041033556801
                            ],
                            [
                                -157.82081738585919,
                                21.296040824919732
                            ],
                            [
                                -157.82077365070154,
                                21.296031921834043
                            ],
                            [
                                -157.82076787619675,
                                21.296031728703316
                            ],
                            [
                                -157.82072318147686,
                                21.296037742004923
                            ],
                            [
                                -157.82072326084963,
                                21.296035646692932
                            ],
                            [
                                -157.82072343243215,
                                21.296031176107512
                            ],
                            [
                                -157.82072286000192,
                                21.296031155835713
                            ],
                            [
                                -157.82072144335612,
                                21.29603110887091
                            ],
                            [
                                -157.82072003961096,
                                21.296067990831485
                            ],
                            [
                                -157.82072001275517,
                                21.296068698902207
                            ],
                            [
                                -157.82072599927011,
                                21.296068899843817
                            ],
                            [
                                -157.82072658520235,
                                21.296068919306805
                            ],
                            [
                                -157.82071873686115,
                                21.296101758605861
                            ],
                            [
                                -157.82071857315898,
                                21.296106449673953
                            ],
                            [
                                -157.82071855289374,
                                21.296107056610996
                            ],
                            [
                                -157.82072000919496,
                                21.296116149512081
                            ],
                            [
                                -157.82072375555879,
                                21.296139539270232
                            ],
                            [
                                -157.82072383085173,
                                21.296140009561327
                            ],
                            [
                                -157.82072073543316,
                                21.296139906567877
                            ],
                            [
                                -157.82072074024728,
                                21.296139786450553
                            ],
                            [
                                -157.8207172612733,
                                21.296139670832307
                            ],
                            [
                                -157.820717171301,
                                21.296142007275524
                            ],
                            [
                                -157.82071713693935,
                                21.296142931204201
                            ],
                            [
                                -157.82071703977584,
                                21.296149069068125
                            ],
                            [
                                -157.82071676021576,
                                21.296166712150622
                            ],
                            [
                                -157.82071674320267,
                                21.296167757255283
                            ],
                            [
                                -157.82071548261473,
                                21.296167723127898
                            ],
                            [
                                -157.82069314289953,
                                21.296167231442656
                            ],
                            [
                                -157.82055170016423,
                                21.296162503001028
                            ],
                            [
                                -157.82052810293945,
                                21.296161712493195
                            ],
                            [
                                -157.82051915494969,
                                21.296161414002828
                            ],
                            [
                                -157.82051963413954,
                                21.296148836732598
                            ],
                            [
                                -157.82044252248161,
                                21.296146257380411
                            ],
                            [
                                -157.82043735510462,
                                21.296146084754113
                            ],
                            [
                                -157.82043728528419,
                                21.296147948864551
                            ],
                            [
                                -157.82044324868207,
                                21.296148147847539
                            ],
                            [
                                -157.82044288721858,
                                21.296157688740607
                            ],
                            [
                                -157.8204428421906,
                                21.296158861930422
                            ],
                            [
                                -157.82043341716872,
                                21.29615854744489
                            ],
                            [
                                -157.82043016659736,
                                21.296158438841765
                            ],
                            [
                                -157.82042583222386,
                                21.296272286364612
                            ],
                            [
                                -157.82052376863379,
                                21.296275560925366
                            ],
                            [
                                -157.82054736685498,
                                21.29627634963472
                            ],
                            [
                                -157.8206888087276,
                                21.296281078981536
                            ],
                            [
                                -157.82070241044619,
                                21.296281533835188
                            ],
                            [
                                -157.82071234141327,
                                21.296281866305232
                            ],
                            [
                                -157.82076184014736,
                                21.296283521229196
                            ],
                            [
                                -157.82080609097611,
                                21.296279509435994
                            ],
                            [
                                -157.82080849780553,
                                21.296279290513286
                            ],
                            [
                                -157.82080959172669,
                                21.296279191577195
                            ],
                            [
                                -157.82080940156567,
                                21.2962841787724
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.82058194934632,
                                21.295900672744676
                            ],
                            [
                                -157.82058189674163,
                                21.295902070825985
                            ],
                            [
                                -157.82061569664478,
                                21.2959032011237
                            ],
                            [
                                -157.82061564307648,
                                21.295904599198263
                            ],
                            [
                                -157.8206493996195,
                                21.295905727378631
                            ],
                            [
                                -157.82064932884532,
                                21.295907590579237
                            ],
                            [
                                -157.82069431347367,
                                21.295909094640432
                            ],
                            [
                                -157.82069425609194,
                                21.295910608322437
                            ],
                            [
                                -157.82069660751526,
                                21.295910688035448
                            ],
                            [
                                -157.82070034571657,
                                21.295910812697336
                            ],
                            [
                                -157.82070045570183,
                                21.295907900933948
                            ],
                            [
                                -157.82069863719542,
                                21.295907840312616
                            ],
                            [
                                -157.8207032040973,
                                21.295787894699423
                            ],
                            [
                                -157.82066507334233,
                                21.295786620247608
                            ],
                            [
                                -157.82066503672118,
                                21.295786619087622
                            ],
                            [
                                -157.82066494709971,
                                21.295786615749471
                            ],
                            [
                                -157.82066136694584,
                                21.295786496711298
                            ],
                            [
                                -157.82065769717772,
                                21.295786373431557
                            ],
                            [
                                -157.8206540283735,
                                21.295786250158489
                            ],
                            [
                                -157.82065137626461,
                                21.295786162014348
                            ],
                            [
                                -157.82065128664314,
                                21.295786158676211
                            ],
                            [
                                -157.82062384429295,
                                21.295785241868664
                            ],
                            [
                                -157.82062354458367,
                                21.29578523163806
                            ],
                            [
                                -157.82062407636596,
                                21.295771256285171
                            ],
                            [
                                -157.82054318140663,
                                21.295768551103841
                            ],
                            [
                                -157.82053999365928,
                                21.295852269536194
                            ],
                            [
                                -157.82053886654111,
                                21.295881901006563
                            ],
                            [
                                -157.82053802998726,
                                21.295903869236898
                            ],
                            [
                                -157.82055279678585,
                                21.295904362981002
                            ],
                            [
                                -157.82055157057815,
                                21.295899657656399
                            ],
                            [
                                -157.82058194934632,
                                21.295900672744676
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.82077964749848,
                                21.295807519853845
                            ],
                            [
                                -157.82077851661629,
                                21.295808506564743
                            ],
                            [
                                -157.82073714765073,
                                21.295844604427764
                            ],
                            [
                                -157.82073655939547,
                                21.295845117949536
                            ],
                            [
                                -157.82073532367599,
                                21.295846196071508
                            ],
                            [
                                -157.82073526391295,
                                21.295847766650535
                            ],
                            [
                                -157.82073522126933,
                                21.295848882943606
                            ],
                            [
                                -157.82073321394259,
                                21.295901613389521
                            ],
                            [
                                -157.8207331638508,
                                21.295902938313823
                            ],
                            [
                                -157.82073310292921,
                                21.295904533276282
                            ],
                            [
                                -157.820734235163,
                                21.295905673158696
                            ],
                            [
                                -157.82073485197409,
                                21.295906292689914
                            ],
                            [
                                -157.82077375346549,
                                21.295945448117386
                            ],
                            [
                                -157.82077441137895,
                                21.295946111299237
                            ],
                            [
                                -157.82077557995353,
                                21.295947287571636
                            ],
                            [
                                -157.82077722788534,
                                21.295947342480147
                            ],
                            [
                                -157.82077764035026,
                                21.295947356210647
                            ],
                            [
                                -157.82083436962677,
                                21.295949253286238
                            ],
                            [
                                -157.82083612838611,
                                21.29594931168079
                            ],
                            [
                                -157.820837776318,
                                21.295949366588694
                            ],
                            [
                                -157.82083903241661,
                                21.295948271444317
                            ],
                            [
                                -157.82083948671632,
                                21.29594787442462
                            ],
                            [
                                -157.82083973619092,
                                21.29594765664827
                            ],
                            [
                                -157.82084017495288,
                                21.29594727397399
                            ],
                            [
                                -157.82088083336734,
                                21.295911795351905
                            ],
                            [
                                -157.8208821797497,
                                21.295910620437809
                            ],
                            [
                                -157.82088338246541,
                                21.295909570992066
                            ],
                            [
                                -157.82088344448618,
                                21.295907958872743
                            ],
                            [
                                -157.82088347504708,
                                21.295907148744675
                            ],
                            [
                                -157.82088547724715,
                                21.295854570932129
                            ],
                            [
                                -157.82088554442043,
                                21.295852796238417
                            ],
                            [
                                -157.82088560422514,
                                21.295851220239225
                            ],
                            [
                                -157.82088445764006,
                                21.295850066706404
                            ],
                            [
                                -157.82088386187587,
                                21.295849467197772
                            ],
                            [
                                -157.8208458583216,
                                21.295811216057025
                            ],
                            [
                                -157.82084434740071,
                                21.295809695001328
                            ],
                            [
                                -157.82084315874312,
                                21.295808498714088
                            ],
                            [
                                -157.82084153972991,
                                21.295808444008895
                            ],
                            [
                                -157.82083880571011,
                                21.29580835258367
                            ],
                            [
                                -157.82078483651813,
                                21.295806548927199
                            ],
                            [
                                -157.8207825477285,
                                21.295806472364479
                            ],
                            [
                                -157.8207809104012,
                                21.295806417530375
                            ],
                            [
                                -157.82077964749848,
                                21.295807519853845
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2106,
                "NUMBER": "1093",
                "PROPER_NAME": "MUSIC COMPLEX PHASE I",
                "DISPLAY_NAME": "MUSIC COMPLEX PHASE I (MB) - 1093",
                "ADDRESS": "2411 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MUSIC COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1093_01.jpg",
                "HEIGHT (ft)": 21,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 261.74326522079571,
                "SHAPE_Area": 1095.8290389892159
            }
        },
        {
            "type": "Feature",
            "id": 2130,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.82073939395974,
                                21.295728322969381
                            ],
                            [
                                -157.82073855892997,
                                21.295751070839827
                            ],
                            [
                                -157.82073866854,
                                21.295752193619993
                            ],
                            [
                                -157.82073894318657,
                                21.295753291358121
                            ],
                            [
                                -157.82073937530976,
                                21.295754345030005
                            ],
                            [
                                -157.82073995737852,
                                21.295755331998098
                            ],
                            [
                                -157.82074067795574,
                                21.295756235921228
                            ],
                            [
                                -157.82074152466197,
                                21.295757037741417
                            ],
                            [
                                -157.82074248024784,
                                21.295757724690358
                            ],
                            [
                                -157.82074352748555,
                                21.295758281289661
                            ],
                            [
                                -157.8207446452341,
                                21.295758699260706
                            ],
                            [
                                -157.82074581428751,
                                21.295758969434988
                            ],
                            [
                                -157.82074701251918,
                                21.295759086237151
                            ],
                            [
                                -157.8208165277963,
                                21.295761328557923
                            ],
                            [
                                -157.82084275034694,
                                21.295762173550916
                            ],
                            [
                                -157.82084610694696,
                                21.295762281985155
                            ],
                            [
                                -157.82090963855291,
                                21.295764331481152
                            ],
                            [
                                -157.82091088529859,
                                21.295764287818312
                            ],
                            [
                                -157.82091211215698,
                                21.295764078695505
                            ],
                            [
                                -157.82091329499437,
                                21.29576370846063
                            ],
                            [
                                -157.82091440966275,
                                21.295763183268246
                            ],
                            [
                                -157.82091543389146,
                                21.29576251560983
                            ],
                            [
                                -157.82091634637374,
                                21.295761717983602
                            ],
                            [
                                -157.82091712770179,
                                21.295760806514664
                            ],
                            [
                                -157.8209177622947,
                                21.295759800968469
                            ],
                            [
                                -157.82091823844146,
                                21.295758719330802
                            ],
                            [
                                -157.82091854534465,
                                21.295757585917613
                            ],
                            [
                                -157.82091867703343,
                                21.295756424175263
                            ],
                            [
                                -157.8209208577492,
                                21.295697053203767
                            ],
                            [
                                -157.82092080878604,
                                21.295695819731339
                            ],
                            [
                                -157.82092057362379,
                                21.295694605732553
                            ],
                            [
                                -157.82092015496684,
                                21.295693434714515
                            ],
                            [
                                -157.82091956513696,
                                21.295692332961902
                            ],
                            [
                                -157.82091881265802,
                                21.295691319505654
                            ],
                            [
                                -157.82091791372903,
                                21.295690417947419
                            ],
                            [
                                -157.82091688749836,
                                21.295689644682387
                            ],
                            [
                                -157.82091575407824,
                                21.29568901611248
                            ],
                            [
                                -157.82091453745829,
                                21.295688545956633
                            ],
                            [
                                -157.82091326071449,
                                21.295688241603649
                            ],
                            [
                                -157.82091195077129,
                                21.29568811137262
                            ],
                            [
                                -157.82091146505761,
                                21.295688096225955
                            ],
                            [
                                -157.82091186640031,
                                21.295677177034054
                            ],
                            [
                                -157.8209501063919,
                                21.29567840973473
                            ],
                            [
                                -157.82097958722437,
                                21.295679360642364
                            ],
                            [
                                -157.82098083299826,
                                21.295679317875571
                            ],
                            [
                                -157.82098206081972,
                                21.295679108758975
                            ],
                            [
                                -157.8209832446274,
                                21.295678737626972
                            ],
                            [
                                -157.82098435928771,
                                21.295678213337414
                            ],
                            [
                                -157.82098538255161,
                                21.295677545671772
                            ],
                            [
                                -157.82098629406909,
                                21.295676748038371
                            ],
                            [
                                -157.82098707636015,
                                21.295675836575793
                            ],
                            [
                                -157.8209877109594,
                                21.29567483012594
                            ],
                            [
                                -157.82098818709815,
                                21.295673749391387
                            ],
                            [
                                -157.82098849400057,
                                21.295672615978024
                            ],
                            [
                                -157.8209886256887,
                                21.295671454235578
                            ],
                            [
                                -157.82099291953037,
                                21.295554531243937
                            ],
                            [
                                -157.82099287293238,
                                21.295553363735642
                            ],
                            [
                                -157.82099264978891,
                                21.295552213961905
                            ],
                            [
                                -157.82099225473934,
                                21.295551104540014
                            ],
                            [
                                -157.82099169433653,
                                21.295550059907438
                            ],
                            [
                                -157.82099098191657,
                                21.295549100032218
                            ],
                            [
                                -157.82099012984452,
                                21.295548245778946
                            ],
                            [
                                -157.82098915823261,
                                21.295547513549575
                            ],
                            [
                                -157.82098808431587,
                                21.295546917919097
                            ],
                            [
                                -157.82098693111982,
                                21.295546472599653
                            ],
                            [
                                -157.82098572172777,
                                21.295546184076677
                            ],
                            [
                                -157.82098448113626,
                                21.29554606065582
                            ],
                            [
                                -157.82093116394921,
                                21.295544342922366
                            ],
                            [
                                -157.82093067631541,
                                21.295544326858938
                            ],
                            [
                                -157.82092113077749,
                                21.295544019688485
                            ],
                            [
                                -157.82092114789626,
                                21.295543565402482
                            ],
                            [
                                -157.82092131432205,
                                21.295539015281772
                            ],
                            [
                                -157.82092133048411,
                                21.295538560085653
                            ],
                            [
                                -157.82092667040862,
                                21.295538730291447
                            ],
                            [
                                -157.82092680940329,
                                21.295534960508853
                            ],
                            [
                                -157.82092683042242,
                                21.295534379775336
                            ],
                            [
                                -157.82092806555897,
                                21.295500742513241
                            ],
                            [
                                -157.82092520334572,
                                21.29550065019161
                            ],
                            [
                                -157.82087422318563,
                                21.29549900572572
                            ],
                            [
                                -157.82087272365644,
                                21.295498957278344
                            ],
                            [
                                -157.8208724573787,
                                21.295506236748658
                            ],
                            [
                                -157.82087197263672,
                                21.295506220705303
                            ],
                            [
                                -157.82086711747712,
                                21.295506063831176
                            ],
                            [
                                -157.82086663175684,
                                21.295506049587758
                            ],
                            [
                                -157.82086669089293,
                                21.295504436544768
                            ],
                            [
                                -157.82086684249663,
                                21.295500294653301
                            ],
                            [
                                -157.82086861181958,
                                21.295452137308654
                            ],
                            [
                                -157.82086856522972,
                                21.295450968897018
                            ],
                            [
                                -157.82086834208735,
                                21.295449819123156
                            ],
                            [
                                -157.82086794703898,
                                21.295448709701013
                            ],
                            [
                                -157.82086738663742,
                                21.295447665068071
                            ],
                            [
                                -157.82086667421154,
                                21.29544670609571
                            ],
                            [
                                -157.8208658221408,
                                21.295445851841862
                            ],
                            [
                                -157.82086485053739,
                                21.295445118708489
                            ],
                            [
                                -157.8208637775858,
                                21.295444523084019
                            ],
                            [
                                -157.82086262342708,
                                21.295444077757004
                            ],
                            [
                                -157.82086141402894,
                                21.295443790136535
                            ],
                            [
                                -157.82086017344565,
                                21.295443665811462
                            ],
                            [
                                -157.82082206651333,
                                21.295442436735065
                            ],
                            [
                                -157.82082432253372,
                                21.295381000235196
                            ],
                            [
                                -157.8208244640781,
                                21.295377152778908
                            ],
                            [
                                -157.82081926488206,
                                21.29537698445942
                            ],
                            [
                                -157.82066963101917,
                                21.295372158108119
                            ],
                            [
                                -157.82066499365573,
                                21.295372009078108
                            ],
                            [
                                -157.82066477955561,
                                21.295377821805605
                            ],
                            [
                                -157.82066219328672,
                                21.29544826370326
                            ],
                            [
                                -157.82066211192659,
                                21.295450487283009
                            ],
                            [
                                -157.82066162621376,
                                21.295450472135663
                            ],
                            [
                                -157.82065677105649,
                                21.295450315255561
                            ],
                            [
                                -157.82065628631477,
                                21.295450299211602
                            ],
                            [
                                -157.82065646986081,
                                21.295445295708866
                            ],
                            [
                                -157.82065642423655,
                                21.295444127304002
                            ],
                            [
                                -157.82065620110305,
                                21.295442976626596
                            ],
                            [
                                -157.82065580508521,
                                21.295441868100628
                            ],
                            [
                                -157.82065524564911,
                                21.295440823473808
                            ],
                            [
                                -157.82065453226079,
                                21.295439864493844
                            ],
                            [
                                -157.82065368212636,
                                21.295439009349145
                            ],
                            [
                                -157.82065270955303,
                                21.295438277111181
                            ],
                            [
                                -157.82065163563851,
                                21.295437681478646
                            ],
                            [
                                -157.82065048245167,
                                21.295437235253637
                            ],
                            [
                                -157.82064927305404,
                                21.29543694763165
                            ],
                            [
                                -157.82064803342777,
                                21.29543682421512
                            ],
                            [
                                -157.8206373275984,
                                21.295436479087009
                            ],
                            [
                                -157.82059885349798,
                                21.295435238353587
                            ],
                            [
                                -157.82057472996848,
                                21.295434460429949
                            ],
                            [
                                -157.82057348323281,
                                21.295434503187071
                            ],
                            [
                                -157.82057225541294,
                                21.295434712300764
                            ],
                            [
                                -157.82057107257032,
                                21.295435083436697
                            ],
                            [
                                -157.82056995791058,
                                21.29543560772353
                            ],
                            [
                                -157.82056893367553,
                                21.295436276283258
                            ],
                            [
                                -157.82056802216468,
                                21.295437073011051
                            ],
                            [
                                -157.82056724083637,
                                21.295437984478379
                            ],
                            [
                                -157.82056660527155,
                                21.295438990919831
                            ],
                            [
                                -157.82056612913061,
                                21.295440071653129
                            ],
                            [
                                -157.82056582318947,
                                21.295441205072361
                            ],
                            [
                                -157.82056569149833,
                                21.295442366814381
                            ],
                            [
                                -157.82056452673294,
                                21.295474060465516
                            ],
                            [
                                -157.82056398224526,
                                21.29548890298528
                            ],
                            [
                                -157.82056003296753,
                                21.295488775938306
                            ],
                            [
                                -157.82047431210992,
                                21.29548601161812
                            ],
                            [
                                -157.82047397827446,
                                21.295495110947325
                            ],
                            [
                                -157.82046649122594,
                                21.295494869670154
                            ],
                            [
                                -157.82046652548067,
                                21.295493959291651
                            ],
                            [
                                -157.82046647985069,
                                21.295492791790149
                            ],
                            [
                                -157.82046625672584,
                                21.295491640209221
                            ],
                            [
                                -157.82046586070936,
                                21.295490531682869
                            ],
                            [
                                -157.82046530127442,
                                21.29548948705548
                            ],
                            [
                                -157.82046458788719,
                                21.29548852807476
                            ],
                            [
                                -157.82046373678975,
                                21.295487672922405
                            ],
                            [
                                -157.8204627651738,
                                21.295486941593456
                            ],
                            [
                                -157.82046169125977,
                                21.295486345959734
                            ],
                            [
                                -157.8204605380804,
                                21.295485898830094
                            ],
                            [
                                -157.82045932868283,
                                21.295485611206757
                            ],
                            [
                                -157.8204580880853,
                                21.295485488685387
                            ],
                            [
                                -157.82041512598545,
                                21.295484103533841
                            ],
                            [
                                -157.82041387924937,
                                21.295484146289756
                            ],
                            [
                                -157.82041265239283,
                                21.295484355409009
                            ],
                            [
                                -157.82041146859271,
                                21.295484725633671
                            ],
                            [
                                -157.8204103539249,
                                21.295485250822757
                            ],
                            [
                                -157.82040933065994,
                                21.295485918484857
                            ],
                            [
                                -157.8204087356001,
                                21.295486439184948
                            ],
                            [
                                -157.82040841914076,
                                21.295486716115064
                            ],
                            [
                                -157.82040798421119,
                                21.295487222579737
                            ],
                            [
                                -157.82040763684731,
                                21.29548762757485
                            ],
                            [
                                -157.82040700128118,
                                21.295488634015634
                            ],
                            [
                                -157.82040652610286,
                                21.295489714755156
                            ],
                            [
                                -157.82040621823978,
                                21.295490847257195
                            ],
                            [
                                -157.82040608654012,
                                21.295492009902347
                            ],
                            [
                                -157.82040602633424,
                                21.29549363558495
                            ],
                            [
                                -157.82040598241451,
                                21.295494790714773
                            ],
                            [
                                -157.8204054967016,
                                21.295494775566684
                            ],
                            [
                                -157.82040322813759,
                                21.29549470185091
                            ],
                            [
                                -157.82040012500022,
                                21.295494601508171
                            ],
                            [
                                -157.8204001286488,
                                21.295494506677631
                            ],
                            [
                                -157.82040039228664,
                                21.295487319336427
                            ],
                            [
                                -157.82040052773971,
                                21.295483632641957
                            ],
                            [
                                -157.82027455379182,
                                21.295479568891231
                            ],
                            [
                                -157.82027430731907,
                                21.295486295622737
                            ],
                            [
                                -157.82027428176414,
                                21.295486961243071
                            ],
                            [
                                -157.82027415007192,
                                21.295490538653301
                            ],
                            [
                                -157.82027366533018,
                                21.295490522608244
                            ],
                            [
                                -157.8202688101654,
                                21.295490366620236
                            ],
                            [
                                -157.82026832542365,
                                21.295490350575164
                            ],
                            [
                                -157.82026876386129,
                                21.295478412620916
                            ],
                            [
                                -157.82026923565567,
                                21.295465556151388
                            ],
                            [
                                -157.82026919003451,
                                21.295464387746581
                            ],
                            [
                                -157.82026896690402,
                                21.295463237068802
                            ],
                            [
                                -157.82026857088908,
                                21.295462128542042
                            ],
                            [
                                -157.82026801145568,
                                21.295461083914059
                            ],
                            [
                                -157.82026729904101,
                                21.295460124035984
                            ],
                            [
                                -157.82026644697382,
                                21.295459269779272
                            ],
                            [
                                -157.82026547440958,
                                21.295458536635802
                            ],
                            [
                                -157.82026440048941,
                                21.295457941904196
                            ],
                            [
                                -157.82026324731092,
                                21.295457494773249
                            ],
                            [
                                -157.82026203791406,
                                21.29545720714852
                            ],
                            [
                                -157.82026079731699,
                                21.29545708462571
                            ],
                            [
                                -157.82025713329796,
                                21.295456966798213
                            ],
                            [
                                -157.8202367992231,
                                21.295456412326143
                            ],
                            [
                                -157.82016909492134,
                                21.29545422763562
                            ],
                            [
                                -157.82016264482522,
                                21.295454019812048
                            ],
                            [
                                -157.8201484484521,
                                21.29545356165276
                            ],
                            [
                                -157.82013000622661,
                                21.295452815359432
                            ],
                            [
                                -157.82012806435409,
                                21.295452752963968
                            ],
                            [
                                -157.82012515203454,
                                21.295452658470758
                            ],
                            [
                                -157.82012418061635,
                                21.295452627269629
                            ],
                            [
                                -157.82012297822726,
                                21.295452669430876
                            ],
                            [
                                -157.82012289429571,
                                21.29545267787644
                            ],
                            [
                                -157.82012224478962,
                                21.29545277359988
                            ],
                            [
                                -157.82012202176782,
                                21.295452817206083
                            ],
                            [
                                -157.82012177551869,
                                21.295452872393533
                            ],
                            [
                                -157.82012062553412,
                                21.295453232915893
                            ],
                            [
                                -157.82011954183301,
                                21.295453742962433
                            ],
                            [
                                -157.82011942853737,
                                21.295453807212404
                            ],
                            [
                                -157.82011927357772,
                                21.295453898272072
                            ],
                            [
                                -157.82011909047742,
                                21.295454012622628
                            ],
                            [
                                -157.8201185369677,
                                21.295454399911012
                            ],
                            [
                                -157.82011767982948,
                                21.295455147330884
                            ],
                            [
                                -157.82011766038562,
                                21.295455167972584
                            ],
                            [
                                -157.82011689949832,
                                21.295456054286049
                            ],
                            [
                                -157.82011683126817,
                                21.295456148663856
                            ],
                            [
                                -157.82011672205667,
                                21.295456305088369
                            ],
                            [
                                -157.82011628541025,
                                21.295457026547361
                            ],
                            [
                                -157.82011624037864,
                                21.295457112957251
                            ],
                            [
                                -157.82011581909975,
                                21.295458082956593
                            ],
                            [
                                -157.82011552112593,
                                21.29545918390863
                            ],
                            [
                                -157.82011539256808,
                                21.295460314956799
                            ],
                            [
                                -157.82011522724025,
                                21.295464845208862
                            ],
                            [
                                -157.82011442192103,
                                21.295486757644433
                            ],
                            [
                                -157.82011373483226,
                                21.295505451221995
                            ],
                            [
                                -157.82011373104652,
                                21.295505563215983
                            ],
                            [
                                -157.82011364733933,
                                21.295507838271988
                            ],
                            [
                                -157.82011356460322,
                                21.295510112431415
                            ],
                            [
                                -157.820113480896,
                                21.29551238748741
                            ],
                            [
                                -157.82011339718878,
                                21.295514662543418
                            ],
                            [
                                -157.82011331348875,
                                21.295516936696085
                            ],
                            [
                                -157.82011322978153,
                                21.295519211752094
                            ],
                            [
                                -157.82011282078784,
                                21.295530357637578
                            ],
                            [
                                -157.82011278750207,
                                21.29553126711933
                            ],
                            [
                                -157.8201104153606,
                                21.295595861942363
                            ],
                            [
                                -157.82011033901563,
                                21.295597939207237
                            ],
                            [
                                -157.82010948678413,
                                21.295621139549585
                            ],
                            [
                                -157.82010953240402,
                                21.295622307954378
                            ],
                            [
                                -157.82010975554064,
                                21.295623457728961
                            ],
                            [
                                -157.82011015155473,
                                21.295624566256038
                            ],
                            [
                                -157.82011071098751,
                                21.295625610884503
                            ],
                            [
                                -157.82011142436579,
                                21.295626570769954
                            ],
                            [
                                -157.82011227546187,
                                21.295627425924032
                            ],
                            [
                                -157.82011324803355,
                                21.295628158165037
                            ],
                            [
                                -157.82011432098315,
                                21.295628753794205
                            ],
                            [
                                -157.82011547417687,
                                21.295629199119528
                            ],
                            [
                                -157.82011668357478,
                                21.295629486745369
                            ],
                            [
                                -157.82011792416591,
                                21.295629610172625
                            ],
                            [
                                -157.82012156505525,
                                21.295629727841195
                            ],
                            [
                                -157.82012084692502,
                                21.295649291166733
                            ],
                            [
                                -157.82011720603521,
                                21.295649173498138
                            ],
                            [
                                -157.82011595929777,
                                21.295649216251782
                            ],
                            [
                                -157.82011473147563,
                                21.295649425362022
                            ],
                            [
                                -157.82011354863747,
                                21.295649795591238
                            ],
                            [
                                -157.82011243396738,
                                21.295650320778236
                            ],
                            [
                                -157.82011140973611,
                                21.295650988431639
                            ],
                            [
                                -157.8201104982071,
                                21.295651786963436
                            ],
                            [
                                -157.82010971688209,
                                21.29565269752511
                            ],
                            [
                                -157.82010908131323,
                                21.295653703964621
                            ],
                            [
                                -157.82010860613218,
                                21.295654784703153
                            ],
                            [
                                -157.82010829923036,
                                21.295655917211263
                            ],
                            [
                                -157.82010816752091,
                                21.295657080759383
                            ],
                            [
                                -157.82010768734145,
                                21.295670140431863
                            ],
                            [
                                -157.82010603942135,
                                21.295715012070872
                            ],
                            [
                                -157.82010547665612,
                                21.295730326932436
                            ],
                            [
                                -157.82010552323987,
                                21.295731495343968
                            ],
                            [
                                -157.82010574636936,
                                21.295732646021889
                            ],
                            [
                                -157.82010614141979,
                                21.295733754542198
                            ],
                            [
                                -157.82010670085293,
                                21.295734799170685
                            ],
                            [
                                -157.82010741423167,
                                21.295735759056178
                            ],
                            [
                                -157.82010826533553,
                                21.295736613306939
                            ],
                            [
                                -157.82010923790787,
                                21.295737345548005
                            ],
                            [
                                -157.82011031182213,
                                21.29573794118398
                            ],
                            [
                                -157.82011146404557,
                                21.295738387405947
                            ],
                            [
                                -157.82011267344436,
                                21.295738675031846
                            ],
                            [
                                -157.8201139140364,
                                21.295738798459183
                            ],
                            [
                                -157.82021560658214,
                                21.295742077834682
                            ],
                            [
                                -157.82021685332037,
                                21.295742035080337
                            ],
                            [
                                -157.82021808017927,
                                21.295741825962633
                            ],
                            [
                                -157.82021926398906,
                                21.295741454836122
                            ],
                            [
                                -157.82022037865232,
                                21.295740930551776
                            ],
                            [
                                -157.82022140289098,
                                21.295740261994382
                            ],
                            [
                                -157.82022231440556,
                                21.295739465268674
                            ],
                            [
                                -157.82022309573762,
                                21.29573855380313
                            ],
                            [
                                -157.8202237313061,
                                21.295737547363181
                            ],
                            [
                                -157.82022420648664,
                                21.295736466624309
                            ],
                            [
                                -157.820224513395,
                                21.295735333212626
                            ],
                            [
                                -157.82022464508921,
                                21.29573417147105
                            ],
                            [
                                -157.82022468690246,
                                21.29573303891139
                            ],
                            [
                                -157.82022817553386,
                                21.295733150993552
                            ],
                            [
                                -157.82023196869389,
                                21.295733273340716
                            ],
                            [
                                -157.82023162727802,
                                21.295742595753101
                            ],
                            [
                                -157.82023453865398,
                                21.295742688431275
                            ],
                            [
                                -157.82025125515867,
                                21.295743227486042
                            ],
                            [
                                -157.82028655679574,
                                21.295744366567632
                            ],
                            [
                                -157.82029419708078,
                                21.295744613444274
                            ],
                            [
                                -157.82029710941356,
                                21.295744707031485
                            ],
                            [
                                -157.82029745273869,
                                21.295735386438974
                            ],
                            [
                                -157.82029986008675,
                                21.295735463839215
                            ],
                            [
                                -157.82030358290365,
                                21.295735582981553
                            ],
                            [
                                -157.82030353267842,
                                21.295736924165716
                            ],
                            [
                                -157.82030357835751,
                                21.295738085343775
                            ],
                            [
                                -157.82030380059675,
                                21.29573922698134
                            ],
                            [
                                -157.82030419377855,
                                21.295740328261029
                            ],
                            [
                                -157.82030474941521,
                                21.295741365635166
                            ],
                            [
                                -157.82030545610564,
                                21.295742318245857
                            ],
                            [
                                -157.82030630243446,
                                21.295743167041856
                            ],
                            [
                                -157.82030726829663,
                                21.295743894717816
                            ],
                            [
                                -157.82030833453661,
                                21.295744485781828
                            ],
                            [
                                -157.82030947907836,
                                21.295744928335047
                            ],
                            [
                                -157.82031067981694,
                                21.295745214092058
                            ],
                            [
                                -157.82031191174136,
                                21.295745336553804
                            ],
                            [
                                -157.82037731677585,
                                21.295747446357279
                            ],
                            [
                                -157.82038359052717,
                                21.295747648420257
                            ],
                            [
                                -157.82044840963425,
                                21.295749738732052
                            ],
                            [
                                -157.82044965637257,
                                21.295749695975989
                            ],
                            [
                                -157.8204508841952,
                                21.295749486863325
                            ],
                            [
                                -157.82045206704066,
                                21.295749115728384
                            ],
                            [
                                -157.82045318170319,
                                21.295748591442475
                            ],
                            [
                                -157.82045420497704,
                                21.295747922876846
                            ],
                            [
                                -157.82045511745437,
                                21.29574712615657
                            ],
                            [
                                -157.8204558987851,
                                21.295746214689906
                            ],
                            [
                                -157.8204565343521,
                                21.295745208249002
                            ],
                            [
                                -157.82045701049489,
                                21.295744127516134
                            ],
                            [
                                -157.82045731740149,
                                21.295742994103961
                            ],
                            [
                                -157.82045743560644,
                                21.295741831364211
                            ],
                            [
                                -157.82045762026681,
                                21.295736447542161
                            ],
                            [
                                -157.82045832219004,
                                21.295717339409329
                            ],
                            [
                                -157.82045918039148,
                                21.29569398823881
                            ],
                            [
                                -157.82045986171104,
                                21.295675408445444
                            ],
                            [
                                -157.82045981614604,
                                21.295674232813898
                            ],
                            [
                                -157.82045959307149,
                                21.295673074909583
                            ],
                            [
                                -157.8204591971267,
                                21.295671957349811
                            ],
                            [
                                -157.82045863776329,
                                21.295670903688976
                            ],
                            [
                                -157.82045792348347,
                                21.295669935668062
                            ],
                            [
                                -157.82045707052214,
                                21.29566907237205
                            ],
                            [
                                -157.82045609609986,
                                21.295668330182686
                            ],
                            [
                                -157.82045501840827,
                                21.295667724585083
                            ],
                            [
                                -157.82045386144398,
                                21.295667268394915
                            ],
                            [
                                -157.82045264730473,
                                21.295666970800941
                            ],
                            [
                                -157.82045140005928,
                                21.295666835585401
                            ],
                            [
                                -157.82044854169197,
                                21.295666744185901
                            ],
                            [
                                -157.82044870812541,
                                21.295662194969761
                            ],
                            [
                                -157.82045787203498,
                                21.295662490458895
                            ],
                            [
                                -157.82046029961683,
                                21.295662568901989
                            ],
                            [
                                -157.82046069127759,
                                21.295651900787394
                            ],
                            [
                                -157.82046111003299,
                                21.295640494791861
                            ],
                            [
                                -157.82046394754036,
                                21.29556322412088
                            ],
                            [
                                -157.82046410516432,
                                21.295558933212842
                            ],
                            [
                                -157.82046424428606,
                                21.295555148977741
                            ],
                            [
                                -157.82046427274827,
                                21.295554360516501
                            ],
                            [
                                -157.82046431086059,
                                21.295553329110568
                            ],
                            [
                                -157.82046511360286,
                                21.295531491634883
                            ],
                            [
                                -157.82046519730469,
                                21.295529216578455
                            ],
                            [
                                -157.82045354511226,
                                21.2955288404148
                            ],
                            [
                                -157.82045373692634,
                                21.295523647258339
                            ],
                            [
                                -157.82045765343932,
                                21.295523773174839
                            ],
                            [
                                -157.82045887228023,
                                21.295523722995984
                            ],
                            [
                                -157.82046006747962,
                                21.295523494683334
                            ],
                            [
                                -157.82046121007721,
                                21.295523093454289
                            ],
                            [
                                -157.82046227106937,
                                21.295522529946286
                            ],
                            [
                                -157.82046322431549,
                                21.29552181843038
                            ],
                            [
                                -157.82046404750878,
                                21.295520975914709
                            ],
                            [
                                -157.82046472024882,
                                21.29552002213093
                            ],
                            [
                                -157.82046522594737,
                                21.295518982257715
                            ],
                            [
                                -157.82046555091523,
                                21.295517880590747
                            ],
                            [
                                -157.82046568818888,
                                21.29551674418294
                            ],
                            [
                                -157.82046644937867,
                                21.295496006746706
                            ],
                            [
                                -157.82047587829345,
                                21.295496311318725
                            ],
                            [
                                -157.82047618740896,
                                21.295487893876814
                            ],
                            [
                                -157.82054748058758,
                                21.295490193932487
                            ],
                            [
                                -157.82055421690785,
                                21.295490410974189
                            ],
                            [
                                -157.82055996639428,
                                21.295490595805585
                            ],
                            [
                                -157.82056391470095,
                                21.295490723749147
                            ],
                            [
                                -157.82056368072,
                                21.295497094632871
                            ],
                            [
                                -157.82056364378852,
                                21.295498098945373
                            ],
                            [
                                -157.82056121717315,
                                21.295498020510646
                            ],
                            [
                                -157.8205611544862,
                                21.295499715737126
                            ],
                            [
                                -157.8205610952603,
                                21.295501339619943
                            ],
                            [
                                -157.82056089226683,
                                21.295506847078581
                            ],
                            [
                                -157.82056034161124,
                                21.295521858489224
                            ],
                            [
                                -157.82056021472562,
                                21.295525317589355
                            ],
                            [
                                -157.82056160536271,
                                21.295525361662907
                            ],
                            [
                                -157.82056264134144,
                                21.295525396024114
                            ],
                            [
                                -157.82056278056874,
                                21.295521598238675
                            ],
                            [
                                -157.82056279183124,
                                21.295521274000077
                            ],
                            [
                                -157.82065173269828,
                                21.295524233385812
                            ],
                            [
                                -157.82065250654605,
                                21.295524259586035
                            ],
                            [
                                -157.82065356758628,
                                21.29552429412227
                            ],
                            [
                                -157.8206534197619,
                                21.295528324019237
                            ],
                            [
                                -157.82065584830568,
                                21.295528402466164
                            ],
                            [
                                -157.82065592104493,
                                21.29552641370783
                            ],
                            [
                                -157.82065662527876,
                                21.295507254095529
                            ],
                            [
                                -157.82065670047189,
                                21.295505199406779
                            ],
                            [
                                -157.82065684977891,
                                21.295501104475999
                            ],
                            [
                                -157.82065442412727,
                                21.295501026049372
                            ],
                            [
                                -157.82065457445592,
                                21.2954969238986
                            ],
                            [
                                -157.82065468280899,
                                21.295493975084657
                            ],
                            [
                                -157.82065710942445,
                                21.295494053518034
                            ],
                            [
                                -157.82065711798782,
                                21.295493825923383
                            ],
                            [
                                -157.82070129339655,
                                21.295495251133104
                            ],
                            [
                                -157.82070128579713,
                                21.295495478734516
                            ],
                            [
                                -157.82070371241988,
                                21.295495556263884
                            ],
                            [
                                -157.82070372098318,
                                21.295495328669226
                            ],
                            [
                                -157.82074325036524,
                                21.295496602971227
                            ],
                            [
                                -157.82077120078424,
                                21.29549750524901
                            ],
                            [
                                -157.82077008139655,
                                21.295527986869619
                            ],
                            [
                                -157.82076967341615,
                                21.29553913276574
                            ],
                            [
                                -157.82074636805496,
                                21.295538381376222
                            ],
                            [
                                -157.82074628435745,
                                21.295540656432987
                            ],
                            [
                                -157.82073939395974,
                                21.295728322969381
                            ]
                        ],
                        [
                            [
                                -157.8203203988152,
                                21.295607218714061
                            ],
                            [
                                -157.82032106298126,
                                21.295606735537728
                            ],
                            [
                                -157.82032163631908,
                                21.295606158675483
                            ],
                            [
                                -157.82032210520424,
                                21.295605504292872
                            ],
                            [
                                -157.82032245794014,
                                21.29560478856898
                            ],
                            [
                                -157.82032268474359,
                                21.29560402950305
                            ],
                            [
                                -157.8203227796798,
                                21.295603246024719
                            ],
                            [
                                -157.82032363747467,
                                21.2955795858927
                            ],
                            [
                                -157.82032358761847,
                                21.295578706543449
                            ],
                            [
                                -157.82032337566088,
                                21.295577846836061
                            ],
                            [
                                -157.82032300714735,
                                21.295577036621342
                            ],
                            [
                                -157.82032249443569,
                                21.295576297667253
                            ],
                            [
                                -157.82032185276807,
                                21.295575652665462
                            ],
                            [
                                -157.82032110029286,
                                21.295575122521125
                            ],
                            [
                                -157.82032026290565,
                                21.295574723676793
                            ],
                            [
                                -157.82031936269695,
                                21.295574466224615
                            ],
                            [
                                -157.82031842947558,
                                21.295574359407404
                            ],
                            [
                                -157.82029351954117,
                                21.295573556056247
                            ],
                            [
                                -157.82029433341341,
                                21.295551414217531
                            ],
                            [
                                -157.82029451824098,
                                21.295549996285118
                            ],
                            [
                                -157.82029496291844,
                                21.295548630763896
                            ],
                            [
                                -157.8202956536268,
                                21.295547358209614
                            ],
                            [
                                -157.82029657077805,
                                21.295546217330802
                            ],
                            [
                                -157.82029768421722,
                                21.295545242244998
                            ],
                            [
                                -157.82029896284715,
                                21.295544464352901
                            ],
                            [
                                -157.82030036408315,
                                21.295543905037476
                            ],
                            [
                                -157.82030185018164,
                                21.295543583005355
                            ],
                            [
                                -157.82030337190429,
                                21.295543507848777
                            ],
                            [
                                -157.82039730647639,
                                21.295546536698485
                            ],
                            [
                                -157.8203988194623,
                                21.295546710815835
                            ],
                            [
                                -157.82040027653065,
                                21.295547127553565
                            ],
                            [
                                -157.82040163535629,
                                21.295547775774352
                            ],
                            [
                                -157.82040285176546,
                                21.295548634390631
                            ],
                            [
                                -157.82040389222345,
                                21.295549677872405
                            ],
                            [
                                -157.82040472323868,
                                21.295550875269683
                            ],
                            [
                                -157.82040532003813,
                                21.295552190273149
                            ],
                            [
                                -157.8204056627041,
                                21.295553582090633
                            ],
                            [
                                -157.82040574290033,
                                21.295555008204314
                            ],
                            [
                                -157.82040324259987,
                                21.295623116330713
                            ],
                            [
                                -157.82040294834053,
                                21.295631121026428
                            ],
                            [
                                -157.82040287814544,
                                21.295633032110683
                            ],
                            [
                                -157.82040269331878,
                                21.295634450043242
                            ],
                            [
                                -157.82040224767809,
                                21.295635815558033
                            ],
                            [
                                -157.82040155696291,
                                21.295637089016108
                            ],
                            [
                                -157.8204006407758,
                                21.295638229902224
                            ],
                            [
                                -157.82039952637982,
                                21.295639204078626
                            ],
                            [
                                -157.82039824869901,
                                21.295639983784877
                            ],
                            [
                                -157.8203968465057,
                                21.295640542190995
                            ],
                            [
                                -157.82039536041361,
                                21.295640863320571
                            ],
                            [
                                -157.82039383868275,
                                21.295640939381297
                            ],
                            [
                                -157.82029990405812,
                                21.295637909623547
                            ],
                            [
                                -157.82029854121683,
                                21.295637764562787
                            ],
                            [
                                -157.82029721851043,
                                21.295637421940583
                            ],
                            [
                                -157.8202959705817,
                                21.295636889226913
                            ],
                            [
                                -157.82029482527574,
                                21.295636180167797
                            ],
                            [
                                -157.82029381330045,
                                21.295635312142917
                            ],
                            [
                                -157.82029295955152,
                                21.29563430610477
                            ],
                            [
                                -157.82029228311237,
                                21.295633186578677
                            ],
                            [
                                -157.82029180205924,
                                21.295631983503242
                            ],
                            [
                                -157.8202915277499,
                                21.295630723156432
                            ],
                            [
                                -157.82029146762886,
                                21.295629439015894
                            ],
                            [
                                -157.82029228307158,
                                21.295607221303502
                            ],
                            [
                                -157.82031720071569,
                                21.295608025612474
                            ],
                            [
                                -157.82031804143347,
                                21.295608007113355
                            ],
                            [
                                -157.82031886869476,
                                21.295607862948508
                            ],
                            [
                                -157.82031966125041,
                                21.295607598389349
                            ],
                            [
                                -157.8203203988152,
                                21.295607218714061
                            ]
                        ],
                        [
                            [
                                -157.82086055495478,
                                21.295566357183525
                            ],
                            [
                                -157.82086093443698,
                                21.295566396881071
                            ],
                            [
                                -157.82086130094174,
                                21.295566492497972
                            ],
                            [
                                -157.82086164775052,
                                21.295566640373607
                            ],
                            [
                                -157.82086196525313,
                                21.295566836827078
                            ],
                            [
                                -157.82086224673108,
                                21.295567078197742
                            ],
                            [
                                -157.82086248452359,
                                21.295567358108201
                            ],
                            [
                                -157.82086267194816,
                                21.295567668381111
                            ],
                            [
                                -157.82086280519962,
                                21.295568002666091
                            ],
                            [
                                -157.82086288240788,
                                21.295568353722878
                            ],
                            [
                                -157.82086289787588,
                                21.295568710670892
                            ],
                            [
                                -157.82086107394437,
                                21.295618396170582
                            ],
                            [
                                -157.82086075748867,
                                21.295627011405248
                            ],
                            [
                                -157.82085994967255,
                                21.295649008749628
                            ],
                            [
                                -157.82085990732077,
                                21.295649363485776
                            ],
                            [
                                -157.82085980528626,
                                21.29564970786652
                            ],
                            [
                                -157.82085964749666,
                                21.295650032885447
                            ],
                            [
                                -157.82085943787249,
                                21.295650330439486
                            ],
                            [
                                -157.82085918031976,
                                21.295650594232278
                            ],
                            [
                                -157.8208588816434,
                                21.295650817084358
                            ],
                            [
                                -157.82085855056903,
                                21.295650992733105
                            ],
                            [
                                -157.82085819387279,
                                21.295651117612433
                            ],
                            [
                                -157.82085781928751,
                                21.295651189066326
                            ],
                            [
                                -157.82085743935835,
                                21.295651205375911
                            ],
                            [
                                -157.82080549640352,
                                21.295649529750666
                            ],
                            [
                                -157.82080511692831,
                                21.295649489149643
                            ],
                            [
                                -157.82080475041622,
                                21.295649394435952
                            ],
                            [
                                -157.82080440361449,
                                21.295649245656858
                            ],
                            [
                                -157.8208040851479,
                                21.29564904919652
                            ],
                            [
                                -157.82080380463378,
                                21.295648807832514
                            ],
                            [
                                -157.82080356683409,
                                21.295648528825311
                            ],
                            [
                                -157.82080337941676,
                                21.295648217648999
                            ],
                            [
                                -157.82080324616535,
                                21.29564788336398
                            ],
                            [
                                -157.82080316894283,
                                21.295647534113847
                            ],
                            [
                                -157.82080315251105,
                                21.29564717715909
                            ],
                            [
                                -157.82080610075229,
                                21.295566878179422
                            ],
                            [
                                -157.82080614407531,
                                21.295566522546682
                            ],
                            [
                                -157.82080624513875,
                                21.295566179062572
                            ],
                            [
                                -157.82080640292835,
                                21.295565854043701
                            ],
                            [
                                -157.82080661351642,
                                21.29556555649647
                            ],
                            [
                                -157.82080687106907,
                                21.295565292703756
                            ],
                            [
                                -157.82080716878141,
                                21.295565069845008
                            ],
                            [
                                -157.82080750081954,
                                21.295564894203107
                            ],
                            [
                                -157.82080785751563,
                                21.295564769323878
                            ],
                            [
                                -157.82080823114401,
                                21.295564696959996
                            ],
                            [
                                -157.82080861106573,
                                21.295564681553852
                            ],
                            [
                                -157.82086055495478,
                                21.295566357183525
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.82094758219722,
                                21.295696124724781
                            ],
                            [
                                -157.82094635437556,
                                21.295696333841121
                            ],
                            [
                                -157.82094517153158,
                                21.295696704979601
                            ],
                            [
                                -157.82094405687101,
                                21.295697229268889
                            ],
                            [
                                -157.82094303263568,
                                21.295697897830845
                            ],
                            [
                                -157.82094212111065,
                                21.295698696367353
                            ],
                            [
                                -157.82094133979746,
                                21.295699606029757
                            ],
                            [
                                -157.82094070423392,
                                21.295700612472654
                            ],
                            [
                                -157.82094022809474,
                                21.295701693207068
                            ],
                            [
                                -157.82093992119187,
                                21.295702826620303
                            ],
                            [
                                -157.82093979045999,
                                21.295703989272795
                            ],
                            [
                                -157.82093885343167,
                                21.295729498098858
                            ],
                            [
                                -157.82093808010109,
                                21.295750557061584
                            ],
                            [
                                -157.82093784370306,
                                21.295756991166744
                            ],
                            [
                                -157.82093788932949,
                                21.295758159571594
                            ],
                            [
                                -157.82093811247279,
                                21.295759309345371
                            ],
                            [
                                -157.8209385084935,
                                21.29576041787077
                            ],
                            [
                                -157.82093906792554,
                                21.295761463400101
                            ],
                            [
                                -157.82093978131721,
                                21.295762422378981
                            ],
                            [
                                -157.82094063242624,
                                21.295763276625756
                            ],
                            [
                                -157.82094160403201,
                                21.295764009758802
                            ],
                            [
                                -157.82094267795011,
                                21.295764605389628
                            ],
                            [
                                -157.82094383114764,
                                21.295765050709434
                            ],
                            [
                                -157.82094504054859,
                                21.295765338329424
                            ],
                            [
                                -157.82094628017077,
                                21.295765462647264
                            ],
                            [
                                -157.82095386553868,
                                21.295765706399155
                            ],
                            [
                                -157.8209540476733,
                                21.295765713095381
                            ],
                            [
                                -157.82097116027231,
                                21.295766264790768
                            ],
                            [
                                -157.82097134241411,
                                21.295766270583634
                            ],
                            [
                                -157.82097807778456,
                                21.295766487602219
                            ],
                            [
                                -157.8209793245303,
                                21.295766443938888
                            ],
                            [
                                -157.8209805513886,
                                21.295766234815581
                            ],
                            [
                                -157.82098173519699,
                                21.295765863683609
                            ],
                            [
                                -157.82098284985796,
                                21.295765339394116
                            ],
                            [
                                -157.82098387408641,
                                21.29576467173527
                            ],
                            [
                                -157.82098478560442,
                                21.29576387410189
                            ],
                            [
                                -157.82098556693211,
                                21.295762962632619
                            ],
                            [
                                -157.82098620249567,
                                21.295761956189555
                            ],
                            [
                                -157.82098667767087,
                                21.295760875448259
                            ],
                            [
                                -157.8209869845663,
                                21.295759742938277
                            ],
                            [
                                -157.82098711626176,
                                21.295758580292489
                            ],
                            [
                                -157.8209871654521,
                                21.295757247231176
                            ],
                            [
                                -157.82098726890592,
                                21.295754428470893
                            ],
                            [
                                -157.820987276051,
                                21.295754257779947
                            ],
                            [
                                -157.82098731693057,
                                21.295753120696371
                            ],
                            [
                                -157.82098733405638,
                                21.295752665507003
                            ],
                            [
                                -157.82098761747699,
                                21.295744928137108
                            ],
                            [
                                -157.82098767641745,
                                21.295743339484268
                            ],
                            [
                                -157.82098777627345,
                                21.295740609231164
                            ],
                            [
                                -157.8209878770862,
                                21.295737879888133
                            ],
                            [
                                -157.8209879779061,
                                21.295735149641768
                            ],
                            [
                                -157.82098838586415,
                                21.295724004647969
                            ],
                            [
                                -157.82098906300112,
                                21.295705578397165
                            ],
                            [
                                -157.82098901736708,
                                21.295704410895642
                            ],
                            [
                                -157.82098879423788,
                                21.295703259315232
                            ],
                            [
                                -157.82098839821691,
                                21.295702150789939
                            ],
                            [
                                -157.82098783877748,
                                21.295701106164096
                            ],
                            [
                                -157.82098712538578,
                                21.295700147185411
                            ],
                            [
                                -157.82098627428402,
                                21.295699292035529
                            ],
                            [
                                -157.82098530170009,
                                21.295698560702672
                            ],
                            [
                                -157.8209842277823,
                                21.295697965072129
                            ],
                            [
                                -157.82098307555623,
                                21.295697518856024
                            ],
                            [
                                -157.82098186615573,
                                21.295697231236328
                            ],
                            [
                                -157.82098062556298,
                                21.295697107815364
                            ],
                            [
                                -157.82094882893514,
                                21.295696081964987
                            ],
                            [
                                -157.82094758219722,
                                21.295696124724781
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2130,
                "NUMBER": "1091",
                "PROPER_NAME": "MUSIC COMPLEX PHASE II",
                "DISPLAY_NAME": "MUSIC COMPLEX PHASE II (MB) - 1091",
                "ADDRESS": "2411 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MUSIC COMPLEX",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1091_01.jpg",
                "HEIGHT (ft)": 35.399999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 465.99262657474969,
                "SHAPE_Area": 1956.4653910556317
            }
        },
        {
            "type": "Feature",
            "id": 2147,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81974878460056,
                            21.296220738026967
                        ],
                        [
                            -157.81975022487381,
                            21.296205993941868
                        ],
                        [
                            -157.81978059196928,
                            21.296208598160355
                        ],
                        [
                            -157.81978561419905,
                            21.296157164470461
                        ],
                        [
                            -157.81975524517892,
                            21.296154561143169
                        ],
                        [
                            -157.81978514052184,
                            21.295848362157606
                        ],
                        [
                            -157.81930589963349,
                            21.295807268174819
                        ],
                        [
                            -157.8190314368527,
                            21.295783731705217
                        ],
                        [
                            -157.81832124611753,
                            21.295722829960358
                        ],
                        [
                            -157.81827993070604,
                            21.296124285033642
                        ],
                        [
                            -157.81917052634969,
                            21.296200656822805
                        ],
                        [
                            -157.81917338300744,
                            21.296171397960659
                        ],
                        [
                            -157.81974878460056,
                            21.296220738026967
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2147,
                "NUMBER": "1001A",
                "PROPER_NAME": "LOWER CAMPUS PARKING STRUCTURE - PHASE II",
                "DISPLAY_NAME": "LOWER CAMPUS PARKING STRUCTURE - PHASE II - 1001A",
                "ADDRESS": "2520 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "LOWER CAMPUS PARKING STRUCTURE - PHASE II",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": "Zone 20 Parking Structure",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1001A_01.jpg",
                "HEIGHT (ft)": 63,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": "https://www.hawaii.edu/sustainability/pv_system/manoa-parking-structure-phase-2/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2019/08/Parking-Structure-2A-Drone-2019.jpg",
                "PORTABLE?": null,
                "SHAPE_Length": 400.84093313255113,
                "SHAPE_Area": 6636.5338440662035
            }
        },
        {
            "type": "Feature",
            "id": 2150,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81806821840348,
                            21.296127155507897
                        ],
                        [
                            -157.81820365997706,
                            21.296139398050201
                        ],
                        [
                            -157.81821218197223,
                            21.296140167952561
                        ],
                        [
                            -157.81824635181388,
                            21.296143257166438
                        ],
                        [
                            -157.81825151480189,
                            21.296093092891947
                        ],
                        [
                            -157.81828284879626,
                            21.296095924595086
                        ],
                        [
                            -157.81836856532956,
                            21.295263054329855
                        ],
                        [
                            -157.81830306185987,
                            21.295257134367546
                        ],
                        [
                            -157.81690352295439,
                            21.29513062178048
                        ],
                        [
                            -157.81682433081829,
                            21.295123462239847
                        ],
                        [
                            -157.81673704939354,
                            21.295971450373486
                        ],
                        [
                            -157.81681624198265,
                            21.295978609072087
                        ],
                        [
                            -157.81681780150174,
                            21.295963454818729
                        ],
                        [
                            -157.81735454620988,
                            21.296011975676258
                        ],
                        [
                            -157.81735298674477,
                            21.296027129937038
                        ],
                        [
                            -157.81743217843766,
                            21.296034289245064
                        ],
                        [
                            -157.81743373789476,
                            21.296019134983183
                        ],
                        [
                            -157.81807338463142,
                            21.29607695512826
                        ],
                        [
                            -157.81806821840348,
                            21.296127155507897
                        ]
                    ],
                    [
                        [
                            -157.81745335167136,
                            21.295646410938641
                        ],
                        [
                            -157.81689080927632,
                            21.295595558137894
                        ],
                        [
                            -157.81690014528934,
                            21.295504849271492
                        ],
                        [
                            -157.81746268734568,
                            21.295555702025641
                        ],
                        [
                            -157.81745335167136,
                            21.295646410938641
                        ]
                    ],
                    [
                        [
                            -157.8180894977184,
                            21.29570398142182
                        ],
                        [
                            -157.81764375441037,
                            21.29566362205113
                        ],
                        [
                            -157.81765308996279,
                            21.295572914025708
                        ],
                        [
                            -157.81809883300244,
                            21.295613273359496
                        ],
                        [
                            -157.8180894977184,
                            21.29570398142182
                        ]
                    ],
                    [
                        [
                            -157.81817215925113,
                            21.295619900583606
                        ],
                        [
                            -157.8181682463098,
                            21.295657912187547
                        ],
                        [
                            -157.81816795363207,
                            21.295660760330637
                        ],
                        [
                            -157.81816749067272,
                            21.295665254159612
                        ],
                        [
                            -157.8181628230474,
                            21.295710608645226
                        ],
                        [
                            -157.81812616038187,
                            21.29570729503747
                        ],
                        [
                            -157.81813082801824,
                            21.295661940553391
                        ],
                        [
                            -157.81813549564382,
                            21.295616586972134
                        ],
                        [
                            -157.81817215925113,
                            21.295619900583606
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2150,
                "NUMBER": "1001",
                "PROPER_NAME": "LOWER CAMPUS PARKING STRUCTURE - PHASE I",
                "DISPLAY_NAME": "LOWER CAMPUS PARKING STRUCTURE - PHASE I - 1001",
                "ADDRESS": "2520 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "LOWER CAMPUS PARKING STRUCTURE - PHASE I",
                "SUBSTATION-FED?": "Y",
                "REXED?": "Y",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": "Zone 20 Parking Structure",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1001_01.jpg",
                "HEIGHT (ft)": 43.100000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": "https://www.hawaii.edu/sustainability/pv_system/lower-campus-parking-structure-phase-1/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2024/05/OPS-2048x1536.jpg",
                "PORTABLE?": null,
                "SHAPE_Length": 803.38411617181316,
                "SHAPE_Area": 13939.694200941552
            }
        },
        {
            "type": "Feature",
            "id": 2157,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81634956421217,
                            21.29450809612398
                        ],
                        [
                            -157.81638471281724,
                            21.294478217924521
                        ],
                        [
                            -157.81642648544425,
                            21.294442707581805
                        ],
                        [
                            -157.81649087192676,
                            21.294387973987831
                        ],
                        [
                            -157.81652724823181,
                            21.294357051034716
                        ],
                        [
                            -157.81653603270314,
                            21.294349583037572
                        ],
                        [
                            -157.81620173301897,
                            21.294004184156147
                        ],
                        [
                            -157.81616698208663,
                            21.293968279315848
                        ],
                        [
                            -157.81594947640522,
                            21.294153174011385
                        ],
                        [
                            -157.81628085503669,
                            21.294495562613353
                        ],
                        [
                            -157.81631189529554,
                            21.294469176953776
                        ],
                        [
                            -157.81634956421217,
                            21.29450809612398
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2157,
                "NUMBER": "1254B",
                "PROPER_NAME": "BEACH VOLLEYBALL COURT",
                "DISPLAY_NAME": "BEACH VOLLEYBALL COURT - 1254B",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "BEACH VOLLEYBALL COURT",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1254B_01.jpg",
                "HEIGHT (ft)": null,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 174.90261810540608,
                "SHAPE_Area": 1710.7950555275625
            }
        },
        {
            "type": "Feature",
            "id": 2214,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.81787144609297,
                                21.293913196846134
                            ],
                            [
                                -157.81786927301135,
                                21.29391504889389
                            ],
                            [
                                -157.81787058950496,
                                21.293916406902223
                            ],
                            [
                                -157.81791653262499,
                                21.293877278466397
                            ],
                            [
                                -157.81791521613124,
                                21.293875920458415
                            ],
                            [
                                -157.81791469591781,
                                21.293876363080287
                            ],
                            [
                                -157.81789230687443,
                                21.293853274172054
                            ],
                            [
                                -157.81786367261694,
                                21.293877661573333
                            ],
                            [
                                -157.81786318024379,
                                21.293877154023264
                            ],
                            [
                                -157.81786962957406,
                                21.293871661529788
                            ],
                            [
                                -157.81786887811734,
                                21.293870885659874
                            ],
                            [
                                -157.81804002736877,
                                21.29372512569455
                            ],
                            [
                                -157.81805747739836,
                                21.293743121816746
                            ],
                            [
                                -157.81808573888659,
                                21.293719054272991
                            ],
                            [
                                -157.81808705538066,
                                21.293720412279676
                            ],
                            [
                                -157.81809738204652,
                                21.293711618005737
                            ],
                            [
                                -157.81807861455769,
                                21.29369226387406
                            ],
                            [
                                -157.81814238171447,
                                21.293637956175122
                            ],
                            [
                                -157.81814353280592,
                                21.293639144085915
                            ],
                            [
                                -157.81814421705604,
                                21.293638559879216
                            ],
                            [
                                -157.81816263367409,
                                21.29365755199062
                            ],
                            [
                                -157.81813110724917,
                                21.29368440346034
                            ],
                            [
                                -157.81814803070199,
                                21.293702795175072
                            ],
                            [
                                -157.81814922962363,
                                21.293704149645617
                            ],
                            [
                                -157.81821171255996,
                                21.293655658871941
                            ],
                            [
                                -157.81821922689051,
                                21.293644394848485
                            ],
                            [
                                -157.8182115229458,
                                21.293636449639635
                            ],
                            [
                                -157.81820230998187,
                                21.293636037151334
                            ],
                            [
                                -157.81820157475107,
                                21.293636004887635
                            ],
                            [
                                -157.81820203861713,
                                21.293626934484418
                            ],
                            [
                                -157.81820498550235,
                                21.293569158019576
                            ],
                            [
                                -157.81820693921946,
                                21.293567494139054
                            ],
                            [
                                -157.81821540921092,
                                21.293560280403508
                            ],
                            [
                                -157.81821697876589,
                                21.293529497530962
                            ],
                            [
                                -157.81821795045875,
                                21.29351043918739
                            ],
                            [
                                -157.81821909008315,
                                21.29348809909953
                            ],
                            [
                                -157.81818608205901,
                                21.293486620676244
                            ],
                            [
                                -157.81818466995699,
                                21.293485164432848
                            ],
                            [
                                -157.81816855842163,
                                21.293468549069171
                            ],
                            [
                                -157.81816747903065,
                                21.293467435740066
                            ],
                            [
                                -157.81816892903001,
                                21.293466201047625
                            ],
                            [
                                -157.81816629508072,
                                21.29346348502882
                            ],
                            [
                                -157.81816484605247,
                                21.293464718824652
                            ],
                            [
                                -157.81816212510438,
                                21.293461912759248
                            ],
                            [
                                -157.81814725931639,
                                21.293446582631741
                            ],
                            [
                                -157.81814443224397,
                                21.293443667414028
                            ],
                            [
                                -157.81814588127935,
                                21.293442432715015
                            ],
                            [
                                -157.81814324636701,
                                21.293439716689118
                            ],
                            [
                                -157.81814179733885,
                                21.293440950484754
                            ],
                            [
                                -157.81814039958772,
                                21.29343950789265
                            ],
                            [
                                -157.81808471100581,
                                21.293382078578365
                            ],
                            [
                                -157.81808220326721,
                                21.293379491726061
                            ],
                            [
                                -157.81808365229523,
                                21.293378257930907
                            ],
                            [
                                -157.81808101835628,
                                21.293375541007549
                            ],
                            [
                                -157.8180795683644,
                                21.29337677479591
                            ],
                            [
                                -157.81807846507255,
                                21.29337563690687
                            ],
                            [
                                -157.81801997434425,
                                21.293315316017114
                            ],
                            [
                                -157.81806254650755,
                                21.293279059227821
                            ],
                            [
                                -157.81802336531891,
                                21.293238652767013
                            ],
                            [
                                -157.81795982832372,
                                21.293292764201954
                            ],
                            [
                                -157.81793400616374,
                                21.293266133388109
                            ],
                            [
                                -157.81792119020668,
                                21.293252917117425
                            ],
                            [
                                -157.81792558312847,
                                21.293166804209218
                            ],
                            [
                                -157.81792751452195,
                                21.293165159146206
                            ],
                            [
                                -157.81794849874939,
                                21.293147288369248
                            ],
                            [
                                -157.8179571938947,
                                21.293139882901297
                            ],
                            [
                                -157.81795587741397,
                                21.293138523990461
                            ],
                            [
                                -157.81795521008894,
                                21.293137835437332
                            ],
                            [
                                -157.81783271538907,
                                21.293011507745074
                            ],
                            [
                                -157.81782523712502,
                                21.293003795373114
                            ],
                            [
                                -157.81782227335125,
                                21.293000739164771
                            ],
                            [
                                -157.81781828827192,
                                21.293004134126374
                            ],
                            [
                                -157.81780916272822,
                                21.292994722650455
                            ],
                            [
                                -157.81770845578313,
                                21.292890863454524
                            ],
                            [
                                -157.81770189821043,
                                21.292884100684294
                            ],
                            [
                                -157.8176971871693,
                                21.292888112980609
                            ],
                            [
                                -157.81767620779988,
                                21.292905980147552
                            ],
                            [
                                -157.81762508802541,
                                21.292949517757286
                            ],
                            [
                                -157.81761917960748,
                                21.292943425342827
                            ],
                            [
                                -157.81758838704482,
                                21.292911668958528
                            ],
                            [
                                -157.81758574259999,
                                21.292908942016862
                            ],
                            [
                                -157.81756020065441,
                                21.292930696029618
                            ],
                            [
                                -157.81755965618746,
                                21.292931158354765
                            ],
                            [
                                -157.81756731034335,
                                21.292939052651622
                            ],
                            [
                                -157.81757328089122,
                                21.292945210548403
                            ],
                            [
                                -157.81759109982843,
                                21.292963585116713
                            ],
                            [
                                -157.81754570044168,
                                21.293002249338517
                            ],
                            [
                                -157.81754463283534,
                                21.293003158780841
                            ],
                            [
                                -157.81754595027485,
                                21.293004517701458
                            ],
                            [
                                -157.81755673743669,
                                21.293015641044949
                            ],
                            [
                                -157.81771567863183,
                                21.293179556649424
                            ],
                            [
                                -157.81771300574147,
                                21.293181832489129
                            ],
                            [
                                -157.81770726007281,
                                21.293186727358503
                            ],
                            [
                                -157.81770186575773,
                                21.293191321156073
                            ],
                            [
                                -157.81774894864014,
                                21.293239877568819
                            ],
                            [
                                -157.81776008958877,
                                21.293230388905613
                            ],
                            [
                                -157.81772848141779,
                                21.293197792082825
                            ],
                            [
                                -157.81773115333706,
                                21.293195517139431
                            ],
                            [
                                -157.81783922597396,
                                21.293306970467562
                            ],
                            [
                                -157.81784523861202,
                                21.293313172013828
                            ],
                            [
                                -157.81784655606424,
                                21.293314530028955
                            ],
                            [
                                -157.8178589907582,
                                21.293303939274125
                            ],
                            [
                                -157.81785923727563,
                                21.293303729611875
                            ],
                            [
                                -157.81786734655688,
                                21.293312092338784
                            ],
                            [
                                -157.81812085997018,
                                21.293573538728257
                            ],
                            [
                                -157.81812720629836,
                                21.293580084089914
                            ],
                            [
                                -157.81812741185905,
                                21.293580295119959
                            ],
                            [
                                -157.81812872930902,
                                21.293581654036405
                            ],
                            [
                                -157.8181163538178,
                                21.293592193733076
                            ],
                            [
                                -157.81811549985656,
                                21.293608942931037
                            ],
                            [
                                -157.81812464170542,
                                21.29361837167087
                            ],
                            [
                                -157.81812545052628,
                                21.293619206662839
                            ],
                            [
                                -157.8181247653267,
                                21.293619789056034
                            ],
                            [
                                -157.81812622619049,
                                21.293621295328819
                            ],
                            [
                                -157.81790190928041,
                                21.293812335787162
                            ],
                            [
                                -157.81772695130567,
                                21.29363190677633
                            ],
                            [
                                -157.81772830619892,
                                21.293630752725107
                            ],
                            [
                                -157.81775502514023,
                                21.293658311327849
                            ],
                            [
                                -157.81777051516337,
                                21.293645119496542
                            ],
                            [
                                -157.81774379525021,
                                21.293617561792779
                            ],
                            [
                                -157.81774236785213,
                                21.293616090080732
                            ],
                            [
                                -157.81773974060519,
                                21.293613380426315
                            ],
                            [
                                -157.81773920521948,
                                21.293612827404257
                            ],
                            [
                                -157.81773380347894,
                                21.293607258001565
                            ],
                            [
                                -157.8177169604914,
                                21.293621603894252
                            ],
                            [
                                -157.81731644481835,
                                21.293208562303185
                            ],
                            [
                                -157.81725915696757,
                                21.293257353035479
                            ],
                            [
                                -157.8172462875375,
                                21.293244081233226
                            ],
                            [
                                -157.81727744712359,
                                21.293217545346707
                            ],
                            [
                                -157.81726477081742,
                                21.293204472745401
                            ],
                            [
                                -157.81726095902982,
                                21.29320054241046
                            ],
                            [
                                -157.81725406972151,
                                21.293193436714013
                            ],
                            [
                                -157.81720995031682,
                                21.293231013115054
                            ],
                            [
                                -157.81722065045523,
                                21.293242048239065
                            ],
                            [
                                -157.81755060314023,
                                21.293582322200482
                            ],
                            [
                                -157.81754087610273,
                                21.293590624690705
                            ],
                            [
                                -157.81750817069619,
                                21.293556973992203
                            ],
                            [
                                -157.81747338354634,
                                21.293586669791313
                            ],
                            [
                                -157.81750608895084,
                                21.293620320496398
                            ],
                            [
                                -157.81752306309636,
                                21.2936377866512
                            ],
                            [
                                -157.81756755787205,
                                21.293599805378964
                            ],
                            [
                                -157.81787144609297,
                                21.293913196846134
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.8172613070825,
                                21.293151130277405
                            ],
                            [
                                -157.81726180040789,
                                21.293151638739186
                            ],
                            [
                                -157.81728688530131,
                                21.293130274539241
                            ],
                            [
                                -157.8173061837515,
                                21.293113839232873
                            ],
                            [
                                -157.81729828198587,
                                21.293105689331902
                            ],
                            [
                                -157.81745298780351,
                                21.292973931695609
                            ],
                            [
                                -157.81746089054971,
                                21.292982079789603
                            ],
                            [
                                -157.8175052728281,
                                21.292944280218521
                            ],
                            [
                                -157.81750477950249,
                                21.292943771757432
                            ],
                            [
                                -157.81747366476645,
                                21.292911684255586
                            ],
                            [
                                -157.81743036951221,
                                21.292948557348922
                            ],
                            [
                                -157.81742246774058,
                                21.292940408357055
                            ],
                            [
                                -157.81726667394653,
                                21.293073092427868
                            ],
                            [
                                -157.81722913839056,
                                21.293034383985322
                            ],
                            [
                                -157.81718475505323,
                                21.293072183471878
                            ],
                            [
                                -157.8172613070825,
                                21.293151130277405
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.81721642367734,
                                21.293247819211967
                            ],
                            [
                                -157.817215880172,
                                21.293248281542652
                            ],
                            [
                                -157.81719389908338,
                                21.293267001633811
                            ],
                            [
                                -157.81722287226012,
                                21.293296881609162
                            ],
                            [
                                -157.81724895878074,
                                21.293274666233085
                            ],
                            [
                                -157.81721998657372,
                                21.293244785365541
                            ],
                            [
                                -157.81721642367734,
                                21.293247819211967
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2214,
                "NUMBER": "1113",
                "PROPER_NAME": "DUKE KAHANAMOKU AQUATIC COMPLEX",
                "DISPLAY_NAME": "DUKE KAHANAMOKU AQUATIC COMPLEX (KP) - 1113",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "DUKE KAHANAMOKU AQUATIC COMPLEX (DKAC)",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1113_01.jpg",
                "HEIGHT (ft)": 29.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 744.83898578603112,
                "SHAPE_Area": 2912.8060898829272
            }
        },
        {
            "type": "Feature",
            "id": 2252,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.82148263926803,
                                21.298907256881176
                            ],
                            [
                                -157.82148192676487,
                                21.298926373975789
                            ],
                            [
                                -157.82148169644506,
                                21.298932530781549
                            ],
                            [
                                -157.82148992474242,
                                21.298932800699308
                            ],
                            [
                                -157.8215185223772,
                                21.298933737222473
                            ],
                            [
                                -157.82151808093755,
                                21.298945577591589
                            ],
                            [
                                -157.82151806022205,
                                21.298946120384702
                            ],
                            [
                                -157.8215189082959,
                                21.298946148908193
                            ],
                            [
                                -157.82180780089826,
                                21.298955614691639
                            ],
                            [
                                -157.82181318813764,
                                21.298955790625698
                            ],
                            [
                                -157.8220484358786,
                                21.298963499145035
                            ],
                            [
                                -157.82204912370293,
                                21.298945050382162
                            ],
                            [
                                -157.82205063527351,
                                21.298904523980756
                            ],
                            [
                                -157.82205143444239,
                                21.298883111066278
                            ],
                            [
                                -157.82205356860575,
                                21.298825909705592
                            ],
                            [
                                -157.82201710986587,
                                21.298824715890181
                            ],
                            [
                                -157.82201769102301,
                                21.298809128324802
                            ],
                            [
                                -157.82201825249498,
                                21.298794075429345
                            ],
                            [
                                -157.82201881633384,
                                21.298778967443557
                            ],
                            [
                                -157.82194859057915,
                                21.298776666387077
                            ],
                            [
                                -157.82194786007167,
                                21.298796235959433
                            ],
                            [
                                -157.82194779514535,
                                21.298797971823326
                            ],
                            [
                                -157.82194688216168,
                                21.298822414818524
                            ],
                            [
                                -157.82182747164907,
                                21.298818502855987
                            ],
                            [
                                -157.82182551432953,
                                21.298818437660064
                            ],
                            [
                                -157.82152416776626,
                                21.298808563101684
                            ],
                            [
                                -157.82152401453115,
                                21.298808558415097
                            ],
                            [
                                -157.82152307200792,
                                21.2988085274235
                            ],
                            [
                                -157.82152297764739,
                                21.298811052644936
                            ],
                            [
                                -157.8215229457069,
                                21.298811915159998
                            ],
                            [
                                -157.82152264639933,
                                21.298819954150439
                            ],
                            [
                                -157.8215226098541,
                                21.29882091058597
                            ],
                            [
                                -157.82151771701984,
                                21.298820749848982
                            ],
                            [
                                -157.82151722744723,
                                21.298820733773255
                            ],
                            [
                                -157.82151679955138,
                                21.298820719936199
                            ],
                            [
                                -157.82150841803224,
                                21.298820444430095
                            ],
                            [
                                -157.8215000374627,
                                21.298820170737006
                            ],
                            [
                                -157.82149960957403,
                                21.29882015599657
                            ],
                            [
                                -157.82149911999423,
                                21.298820140824127
                            ],
                            [
                                -157.8214930639414,
                                21.29881994212889
                            ],
                            [
                                -157.82149275747838,
                                21.2988199318523
                            ],
                            [
                                -157.8214922679058,
                                21.298819915776502
                            ],
                            [
                                -157.82148590634671,
                                21.298819707714507
                            ],
                            [
                                -157.82148263926803,
                                21.298907256881176
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.821785936174,
                                21.298787494055503
                            ],
                            [
                                -157.82180751688773,
                                21.298788201628451
                            ],
                            [
                                -157.8218155447255,
                                21.298788464706252
                            ],
                            [
                                -157.82181750205905,
                                21.298788528095596
                            ],
                            [
                                -157.8218360653465,
                                21.298789136848971
                            ],
                            [
                                -157.82184270542191,
                                21.298789354074593
                            ],
                            [
                                -157.82184272257476,
                                21.298788895271834
                            ],
                            [
                                -157.82184361155865,
                                21.298765046541309
                            ],
                            [
                                -157.82184362871149,
                                21.298764587738553
                            ],
                            [
                                -157.82184382454432,
                                21.298759369313839
                            ],
                            [
                                -157.82184701697702,
                                21.298673779966997
                            ],
                            [
                                -157.82179024874441,
                                21.298671919054815
                            ],
                            [
                                -157.821785936174,
                                21.298787494055503
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2252,
                "NUMBER": "1081",
                "PROPER_NAME": "EVERLY HALL",
                "DISPLAY_NAME": "EVERLY HALL - 1081",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "EVERLY AND WIST HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1081_01.jpg",
                "HEIGHT (ft)": 36,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 195.75761332786971,
                "SHAPE_Area": 999.19616853300079
            }
        },
        {
            "type": "Feature",
            "id": 2272,
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -157.82202249678068,
                                21.297332931655657
                            ],
                            [
                                -157.82214188225427,
                                21.297336812542849
                            ],
                            [
                                -157.82214266244759,
                                21.297315720194515
                            ],
                            [
                                -157.8222840669581,
                                21.297320316987204
                            ],
                            [
                                -157.82228618840358,
                                21.297262999885856
                            ],
                            [
                                -157.82229010303135,
                                21.297263126651742
                            ],
                            [
                                -157.8222964588644,
                                21.297091393002432
                            ],
                            [
                                -157.82228178144788,
                                21.29709091629309
                            ],
                            [
                                -157.82228031273945,
                                21.297090868976689
                            ],
                            [
                                -157.82222159924098,
                                21.297088959389036
                            ],
                            [
                                -157.82222150387352,
                                21.29709149183196
                            ],
                            [
                                -157.82203508725291,
                                21.297085431750467
                            ],
                            [
                                -157.82203564644189,
                                21.297070300240623
                            ],
                            [
                                -157.82203858288688,
                                21.297070395774288
                            ],
                            [
                                -157.8220390411071,
                                21.297058015288655
                            ],
                            [
                                -157.82203316821762,
                                21.297057824221344
                            ],
                            [
                                -157.82203622030909,
                                21.296974942234534
                            ],
                            [
                                -157.82193202812087,
                                21.296971555186211
                            ],
                            [
                                -157.82192737144035,
                                21.296971404247
                            ],
                            [
                                -157.82192541413789,
                                21.296971339956695
                            ],
                            [
                                -157.82192025632389,
                                21.296971172862044
                            ],
                            [
                                -157.82188015609617,
                                21.296969868626714
                            ],
                            [
                                -157.82187805926097,
                                21.297026498410087
                            ],
                            [
                                -157.82185261617633,
                                21.297025671673374
                            ],
                            [
                                -157.82185055944652,
                                21.297081259222438
                            ],
                            [
                                -157.82180505563281,
                                21.297079778923429
                            ],
                            [
                                -157.82180836039581,
                                21.296990489151398
                            ],
                            [
                                -157.82175564029799,
                                21.296988774935134
                            ],
                            [
                                -157.82175500008816,
                                21.297006085759765
                            ],
                            [
                                -157.82171769078292,
                                21.29700487148817
                            ],
                            [
                                -157.8217103245002,
                                21.297203878635052
                            ],
                            [
                                -157.82180035308053,
                                21.297206805319455
                            ],
                            [
                                -157.82180166397805,
                                21.297171382575268
                            ],
                            [
                                -157.82188043920763,
                                21.297173944062454
                            ],
                            [
                                -157.82187816040968,
                                21.297235503281978
                            ],
                            [
                                -157.82189430654697,
                                21.29723602734699
                            ],
                            [
                                -157.82199558848947,
                                21.29723931997815
                            ],
                            [
                                -157.82199455391029,
                                21.297267291678594
                            ],
                            [
                                -157.8220248888731,
                                21.297268277302422
                            ],
                            [
                                -157.82202249678068,
                                21.297332931655657
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.82224893487998,
                                21.297071725156407
                            ],
                            [
                                -157.82227698675766,
                                21.297072636939777
                            ],
                            [
                                -157.8222809823275,
                                21.297072766982261
                            ],
                            [
                                -157.82228129360661,
                                21.297072777290975
                            ],
                            [
                                -157.82228333026794,
                                21.297017752402805
                            ],
                            [
                                -157.82228301995283,
                                21.297017742100849
                            ],
                            [
                                -157.82228195118967,
                                21.297017707520418
                            ],
                            [
                                -157.82228065113068,
                                21.297017665901116
                            ],
                            [
                                -157.82225097058941,
                                21.297016700262457
                            ],
                            [
                                -157.82224893487998,
                                21.297071725156407
                            ]
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2272,
                "NUMBER": "1079",
                "PROPER_NAME": "2350 DOLE STREET (FORMER KHET TV - PBS BUILDING)",
                "DISPLAY_NAME": "2350 DOLE STREET (FORMER KHET TV - PBS BUILDING) - 1079",
                "ADDRESS": "2350 DOLE STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "2350 DOLE STREET (FORMER KHET TV - PBS BUILDING)",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1079_01.jpg",
                "HEIGHT (ft)": 29.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 247.68730921259137,
                "SHAPE_Area": 1526.8210403997421
            }
        },
        {
            "type": "Feature",
            "id": 2290,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82325878957565,
                            21.298181216901895
                        ],
                        [
                            -157.82330335762319,
                            21.298182469851081
                        ],
                        [
                            -157.82331197940377,
                            21.298182712617425
                        ],
                        [
                            -157.82332011954645,
                            21.297928379805459
                        ],
                        [
                            -157.82326692980953,
                            21.297926884096693
                        ],
                        [
                            -157.82325878957565,
                            21.298181216901895
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2290,
                "NUMBER": "1170A",
                "PROPER_NAME": "UNIVERSITY LAB SCHOOL - BATTING CAGE",
                "DISPLAY_NAME": "UNIVERSITY LAB SCHOOL - BATTING CAGE - 1170A",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "UNIVERSITY LAB SCHOOL LOCKERS AND BATTING CAGE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1170A_01.jpg",
                "HEIGHT (ft)": 14.4,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 67.373894173474099,
                "SHAPE_Area": 155.49055018331723
            }
        },
        {
            "type": "Feature",
            "id": 2308,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82354244879997,
                            21.29772108433405
                        ],
                        [
                            -157.82355864352493,
                            21.297737676310295
                        ],
                        [
                            -157.82358013148914,
                            21.297719256387541
                        ],
                        [
                            -157.82358449819972,
                            21.29771551163579
                        ],
                        [
                            -157.82356830346683,
                            21.297698920565303
                        ],
                        [
                            -157.82354244879997,
                            21.29772108433405
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2308,
                "NUMBER": "1068A",
                "PROPER_NAME": "CASTLE MEMORIAL SHED",
                "DISPLAY_NAME": "CASTLE MEMORIAL SHED - 1068A",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CASTLE MEMORIAL SHED",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1068A_01.jpg",
                "HEIGHT (ft)": 8.0999999999999996,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 12.24841815213723,
                "SHAPE_Area": 9.0483738381873025
            }
        },
        {
            "type": "Feature",
            "id": 2311,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82298219938767,
                            21.297738633533921
                        ],
                        [
                            -157.82304289188906,
                            21.297740703055478
                        ],
                        [
                            -157.82304339412696,
                            21.297730048351042
                        ],
                        [
                            -157.82326015460868,
                            21.297737436104395
                        ],
                        [
                            -157.82326503802059,
                            21.297633552177611
                        ],
                        [
                            -157.82291244003201,
                            21.297621534034533
                        ],
                        [
                            -157.82291832432179,
                            21.297496339789369
                        ],
                        [
                            -157.82288948632396,
                            21.297495356663926
                        ],
                        [
                            -157.82289559089276,
                            21.297365501553745
                        ],
                        [
                            -157.82292442790146,
                            21.297366484670242
                        ],
                        [
                            -157.82292783997715,
                            21.297293899318404
                        ],
                        [
                            -157.82303188465224,
                            21.297297445531758
                        ],
                        [
                            -157.82303113466529,
                            21.29731342851613
                        ],
                        [
                            -157.82308893684637,
                            21.297315398303393
                        ],
                        [
                            -157.82308968874776,
                            21.297299416235315
                        ],
                        [
                            -157.82315038204374,
                            21.297301484813328
                        ],
                        [
                            -157.82315369905581,
                            21.297230897090092
                        ],
                        [
                            -157.82314791874217,
                            21.297230700384951
                        ],
                        [
                            -157.82314961050892,
                            21.297194740052525
                        ],
                        [
                            -157.82288669221296,
                            21.297185778169979
                        ],
                        [
                            -157.82288782023585,
                            21.297161787455121
                        ],
                        [
                            -157.82273464305797,
                            21.297156565888827
                        ],
                        [
                            -157.82273930651638,
                            21.297057343754222
                        ],
                        [
                            -157.82261503096953,
                            21.29705310748303
                        ],
                        [
                            -157.82260882270765,
                            21.297185182390038
                        ],
                        [
                            -157.822591602252,
                            21.297184594867826
                        ],
                        [
                            -157.8225889087079,
                            21.297241864613174
                        ],
                        [
                            -157.82271884425668,
                            21.297246294078111
                        ],
                        [
                            -157.82271634068516,
                            21.297299566743803
                        ],
                        [
                            -157.82278425886847,
                            21.297301882931169
                        ],
                        [
                            -157.82278138030406,
                            21.297363147992844
                        ],
                        [
                            -157.82276114823918,
                            21.297362458116744
                        ],
                        [
                            -157.82275538915471,
                            21.297484988223367
                        ],
                        [
                            -157.82277561931559,
                            21.297485677184106
                        ],
                        [
                            -157.82276948425974,
                            21.297616198773689
                        ],
                        [
                            -157.8224848056978,
                            21.297606494110401
                        ],
                        [
                            -157.82248129938696,
                            21.297681077988333
                        ],
                        [
                            -157.82249575020634,
                            21.297681570261627
                        ],
                        [
                            -157.82249434959991,
                            21.297711332638958
                        ],
                        [
                            -157.82263307747891,
                            21.297716061292835
                        ],
                        [
                            -157.82263259816676,
                            21.297726254522118
                        ],
                        [
                            -157.82269329162267,
                            21.297728323272718
                        ],
                        [
                            -157.82269377092345,
                            21.297718130946425
                        ],
                        [
                            -157.82298270066602,
                            21.297727978823133
                        ],
                        [
                            -157.82298219938767,
                            21.297738633533921
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2311,
                "NUMBER": "1068",
                "PROPER_NAME": "CASTLE MEMORIAL HALL",
                "DISPLAY_NAME": "CASTLE MEMORIAL HALL - 1068",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "CASTLE MEMORIAL HALL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1068_01.jpg",
                "HEIGHT (ft)": 31.400000000000002,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 414.17158997378453,
                "SHAPE_Area": 2332.6330641584054
            }
        },
        {
            "type": "Feature",
            "id": 2659,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81478445991635,
                            21.300644421304252
                        ],
                        [
                            -157.81531303726564,
                            21.300630051084813
                        ],
                        [
                            -157.81530949438707,
                            21.300515593774438
                        ],
                        [
                            -157.81531542131233,
                            21.30051543223658
                        ],
                        [
                            -157.81531448552272,
                            21.300485217201462
                        ],
                        [
                            -157.81528871444556,
                            21.300485919289951
                        ],
                        [
                            -157.81528652889747,
                            21.300415352783865
                        ],
                        [
                            -157.81535441743637,
                            21.300404557305658
                        ],
                        [
                            -157.8153283771243,
                            21.300260743159551
                        ],
                        [
                            -157.81490445886863,
                            21.300328157707565
                        ],
                        [
                            -157.81487172730016,
                            21.300329047403583
                        ],
                        [
                            -157.81486789920316,
                            21.300200912573462
                        ],
                        [
                            -157.81486485424782,
                            21.300200998632903
                        ],
                        [
                            -157.8148649865347,
                            21.300205298795614
                        ],
                        [
                            -157.81476972367363,
                            21.300207812332783
                        ],
                        [
                            -157.81477154896049,
                            21.30026857813683
                        ],
                        [
                            -157.81477282632144,
                            21.300268568162124
                        ],
                        [
                            -157.81478445991635,
                            21.300644421304252
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2659,
                "NUMBER": "1263",
                "PROPER_NAME": "ISABELLA AIONA ABBOTT LIFE SCIENCES BUILDING",
                "DISPLAY_NAME": "ISABELLA AIONA ABBOTT LIFE SCIENCES BUILDING (LSB) - 1263",
                "ADDRESS": "1800 EAST-WEST ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "LIFE SCIENCES BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "Y",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1263_01.jpg",
                "HEIGHT (ft)": 68.299999999999997,
                "LEED STATUS": "Silver",
                "LEED LINK": "https://www.usgbc.org/projects/university-hawaii-life-sciences-bldg",
                "PV LINK": "https://www.hawaii.edu/sustainability/pv_system/life-sciences-building/",
                "PV PIC": "https://www.hawaii.edu/sustainability/wp-content/uploads/2021/01/Life-Sciences-Building-03.jpg",
                "PORTABLE?": null,
                "SHAPE_Length": 226.62988350476803,
                "SHAPE_Area": 2208.1861126783965
            }
        },
        {
            "type": "Feature",
            "id": 2700,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82264618982529,
                            21.298460891963746
                        ],
                        [
                            -157.82285745206627,
                            21.298477330836292
                        ],
                        [
                            -157.82286425738161,
                            21.298400514256151
                        ],
                        [
                            -157.82265299621994,
                            21.298384074500436
                        ],
                        [
                            -157.82264618982529,
                            21.298460891963746
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2700,
                "NUMBER": "1264A",
                "PROPER_NAME": "LAULIMA 5",
                "DISPLAY_NAME": "LAULIMA 5 (LIMA) - 1264A",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "LAULIMA 5",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "N1",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1264A_01.jpg",
                "HEIGHT (ft)": 17.5,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 61.048754384467387,
                "SHAPE_Area": 187.64808633704155
            }
        },
        {
            "type": "Feature",
            "id": 2703,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82238925462553,
                            21.298308438410217
                        ],
                        [
                            -157.82260051755341,
                            21.298324879407669
                        ],
                        [
                            -157.82260732395446,
                            21.298248062849158
                        ],
                        [
                            -157.82239606113478,
                            21.298231621865131
                        ],
                        [
                            -157.82238925462553,
                            21.298308438410217
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2703,
                "NUMBER": "1264D",
                "PROPER_NAME": "MAKAWALU 8",
                "DISPLAY_NAME": "MAKAWALU 8 (WALU) - 1264D",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAKAWALU 8",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "N4",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1264D_01.jpg",
                "HEIGHT (ft)": 17.600000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 61.048983940791494,
                "SHAPE_Area": 187.64844533616497
            }
        },
        {
            "type": "Feature",
            "id": 2704,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82265784526399,
                            21.298329342109959
                        ],
                        [
                            -157.82286910730534,
                            21.298345782766177
                        ],
                        [
                            -157.82287591452561,
                            21.298268967100633
                        ],
                        [
                            -157.82266465258525,
                            21.298252527361218
                        ],
                        [
                            -157.82265784526399,
                            21.298329342109959
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2704,
                "NUMBER": "1264C",
                "PROPER_NAME": "NĀHIKU 7",
                "DISPLAY_NAME": "NĀHIKU 7 (NAHIKU) - 1264C",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "NAHIKU 7",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "N3",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1264C_01.jpg",
                "HEIGHT (ft)": 21.199999999999999,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 61.048492893019173,
                "SHAPE_Area": 187.64443859823808
            }
        },
        {
            "type": "Feature",
            "id": 2706,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82237759798744,
                            21.298439988227965
                        ],
                        [
                            -157.82258886110773,
                            21.298456428345126
                        ],
                        [
                            -157.82259566656779,
                            21.298379610878722
                        ],
                        [
                            -157.82238440451238,
                            21.298363171685104
                        ],
                        [
                            -157.82237759798744,
                            21.298439988227965
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 2706,
                "NUMBER": "1264B",
                "PROPER_NAME": "KŪ`ONO`ONO 6",
                "DISPLAY_NAME": "KŪ`ONO`ONO 6 (ONO) - 1264B",
                "ADDRESS": "1776 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KUONOONO 6",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": "N2",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1264B_01.jpg",
                "HEIGHT (ft)": 16,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 61.048953816249792,
                "SHAPE_Area": 187.64893718059614
            }
        },
        {
            "type": "Feature",
            "id": 3061,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80872024474192,
                            21.308651968000088
                        ],
                        [
                            -157.80858103429168,
                            21.308467928808444
                        ],
                        [
                            -157.80842893008509,
                            21.308568959581134
                        ],
                        [
                            -157.80837259061576,
                            21.308606381728879
                        ],
                        [
                            -157.80819719740941,
                            21.308722880427716
                        ],
                        [
                            -157.80840249631981,
                            21.308994296605253
                        ],
                        [
                            -157.80837848936639,
                            21.309010242079786
                        ],
                        [
                            -157.8084664075088,
                            21.309126474878614
                        ],
                        [
                            -157.80849041350896,
                            21.309110529385357
                        ],
                        [
                            -157.80859626173367,
                            21.309250465712179
                        ],
                        [
                            -157.8087716572241,
                            21.309133966632558
                        ],
                        [
                            -157.80882799777908,
                            21.309096543461607
                        ],
                        [
                            -157.80872214942232,
                            21.308956608176338
                        ],
                        [
                            -157.80887425386311,
                            21.308855576249002
                        ],
                        [
                            -157.80878633456695,
                            21.308739344548744
                        ],
                        [
                            -157.80877914481189,
                            21.308744120436899
                        ],
                        [
                            -157.80876818388765,
                            21.308729629279721
                        ],
                        [
                            -157.80877537364233,
                            21.308724853392015
                        ],
                        [
                            -157.80873166254548,
                            21.308667064954637
                        ],
                        [
                            -157.80872447278512,
                            21.30867184174393
                        ],
                        [
                            -157.80871305401797,
                            21.308656744782088
                        ],
                        [
                            -157.80872024474192,
                            21.308651968000088
                        ]
                    ],
                    [
                        [
                            -157.8084492159077,
                            21.308784031718659
                        ],
                        [
                            -157.80856799429188,
                            21.308705136403596
                        ],
                        [
                            -157.80861825743415,
                            21.308771590499365
                        ],
                        [
                            -157.80859159290566,
                            21.308789301376159
                        ],
                        [
                            -157.80860848402267,
                            21.308811632579918
                        ],
                        [
                            -157.80863514951747,
                            21.308793921707434
                        ],
                        [
                            -157.80864726843484,
                            21.308809943280878
                        ],
                        [
                            -157.80852848905337,
                            21.308888836835504
                        ],
                        [
                            -157.8084492159077,
                            21.308784031718659
                        ]
                    ],
                    [
                        [
                            -157.80858131885213,
                            21.308875520158615
                        ],
                        [
                            -157.80865734900294,
                            21.308976034650769
                        ],
                        [
                            -157.80854206939287,
                            21.309052603282801
                        ],
                        [
                            -157.80847780239009,
                            21.308967641658477
                        ],
                        [
                            -157.80855139044309,
                            21.308918762928936
                        ],
                        [
                            -157.80853962827737,
                            21.308903212733419
                        ],
                        [
                            -157.80858131885213,
                            21.308875520158615
                        ]
                    ],
                    [
                        [
                            -157.80861806868879,
                            21.30874251725912
                        ],
                        [
                            -157.80867054866937,
                            21.308707659516092
                        ],
                        [
                            -157.80871425879593,
                            21.308765447058363
                        ],
                        [
                            -157.8086617788037,
                            21.308800304814298
                        ],
                        [
                            -157.80861806868879,
                            21.30874251725912
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3061,
                "NUMBER": "9621",
                "PROPER_NAME": "MĀNOA INNOVATION CENTER",
                "DISPLAY_NAME": "MĀNOA INNOVATION CENTER - 9621",
                "ADDRESS": "2800 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MANOA INNOVATION CENTER",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9621_01.jpg",
                "HEIGHT (ft)": 36,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 401.58818569126453,
                "SHAPE_Area": 2733.9938766808
            }
        },
        {
            "type": "Feature",
            "id": 3064,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80875834214794,
                            21.308973855371175
                        ],
                        [
                            -157.8088391446573,
                            21.309080683928382
                        ],
                        [
                            -157.80891454510802,
                            21.309030602815074
                        ],
                        [
                            -157.80883374256769,
                            21.308923774292197
                        ],
                        [
                            -157.80875834214794,
                            21.308973855371175
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3064,
                "NUMBER": "9621A",
                "PROPER_NAME": "MĀNOA INNOVATION CENTER MECHANICAL BUILDING",
                "DISPLAY_NAME": "MĀNOA INNOVATION CENTER MECHANICAL BUILDING - 9621A",
                "ADDRESS": "2800 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MANOA INNOVATION CENTER MECHANICAL BUILDING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9621A_01.jpg",
                "HEIGHT (ft)": 24,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 48.163810496950077,
                "SHAPE_Area": 138.96262159730364
            }
        },
        {
            "type": "Feature",
            "id": 3081,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80833568707715,
                            21.308276310835797
                        ],
                        [
                            -157.80837225103519,
                            21.308252408739442
                        ],
                        [
                            -157.80837473353645,
                            21.3082557417545
                        ],
                        [
                            -157.80843755650372,
                            21.308214672473753
                        ],
                        [
                            -157.80843507400894,
                            21.308211338556241
                        ],
                        [
                            -157.80850656498095,
                            21.308164602263208
                        ],
                        [
                            -157.80850904650543,
                            21.308167937076231
                        ],
                        [
                            -157.80857187036338,
                            21.308126867748232
                        ],
                        [
                            -157.80856938787409,
                            21.308123532929258
                        ],
                        [
                            -157.80864087874082,
                            21.308076799284688
                        ],
                        [
                            -157.80864335932492,
                            21.308080131378986
                        ],
                        [
                            -157.80870618216741,
                            21.30803905928007
                        ],
                        [
                            -157.80870370157518,
                            21.308035728089983
                        ],
                        [
                            -157.80874026445235,
                            21.308011825900543
                        ],
                        [
                            -157.80872043693523,
                            21.307985192765582
                        ],
                        [
                            -157.80872657063773,
                            21.307981183603122
                        ],
                        [
                            -157.80870802873801,
                            21.307956275102818
                        ],
                        [
                            -157.80870189600006,
                            21.307960284271481
                        ],
                        [
                            -157.80868206848194,
                            21.307933652939131
                        ],
                        [
                            -157.80864558023583,
                            21.307957506862092
                        ],
                        [
                            -157.80863642182297,
                            21.307945204722326
                        ],
                        [
                            -157.80857344977144,
                            21.307986372402176
                        ],
                        [
                            -157.80858260818854,
                            21.307998673641858
                        ],
                        [
                            -157.80851126656898,
                            21.308045312560818
                        ],
                        [
                            -157.80850210911933,
                            21.308033011324277
                        ],
                        [
                            -157.80843913700161,
                            21.308074178046581
                        ],
                        [
                            -157.80844829445547,
                            21.308086478383036
                        ],
                        [
                            -157.80837695274536,
                            21.308133118143896
                        ],
                        [
                            -157.80836779434554,
                            21.308120815990289
                        ],
                        [
                            -157.80830482311831,
                            21.308161982665215
                        ],
                        [
                            -157.80831398152236,
                            21.308174283918731
                        ],
                        [
                            -157.80827749219551,
                            21.308198137748775
                        ],
                        [
                            -157.80829731869986,
                            21.308224770022751
                        ],
                        [
                            -157.80829118594005,
                            21.308228779175245
                        ],
                        [
                            -157.80830972779881,
                            21.308253687719013
                        ],
                        [
                            -157.80831586056649,
                            21.308249677662541
                        ],
                        [
                            -157.80833568707715,
                            21.308276310835797
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3081,
                "NUMBER": "9620B1",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING F",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING F - 9620B1",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING F",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620B1_01.jpg",
                "HEIGHT (ft)": 38,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 139.21038360746184,
                "SHAPE_Area": 595.5341858587426
            }
        },
        {
            "type": "Feature",
            "id": 3083,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80719105427298,
                            21.308100436455412
                        ],
                        [
                            -157.80722759161327,
                            21.308076384462197
                        ],
                        [
                            -157.8072300885666,
                            21.308079714885366
                        ],
                        [
                            -157.80729286659539,
                            21.308038388257302
                        ],
                        [
                            -157.80729036868456,
                            21.308035056924847
                        ],
                        [
                            -157.80736180635657,
                            21.307988028053387
                        ],
                        [
                            -157.80736430426106,
                            21.307991360288188
                        ],
                        [
                            -157.80742708123753,
                            21.307950035405916
                        ],
                        [
                            -157.80742458333953,
                            21.307946702268662
                        ],
                        [
                            -157.8074960218697,
                            21.307899676052546
                        ],
                        [
                            -157.80749851883382,
                            21.307903005568626
                        ],
                        [
                            -157.80756129383045,
                            21.307861677908654
                        ],
                        [
                            -157.8075587978295,
                            21.307858348400284
                        ],
                        [
                            -157.80759533504488,
                            21.307834297224229
                        ],
                        [
                            -157.80757538324266,
                            21.307807683859853
                        ],
                        [
                            -157.80758151331463,
                            21.307803649419451
                        ],
                        [
                            -157.80756285484102,
                            21.307778758945812
                        ],
                        [
                            -157.80755672573363,
                            21.307782793392381
                        ],
                        [
                            -157.80753677490176,
                            21.307756180934078
                        ],
                        [
                            -157.80750031328154,
                            21.307780183850948
                        ],
                        [
                            -157.80749109801545,
                            21.307767892090425
                        ],
                        [
                            -157.80742817187374,
                            21.307809316219814
                        ],
                        [
                            -157.80743738809352,
                            21.307821608893768
                        ],
                        [
                            -157.8073660988253,
                            21.307868538578486
                        ],
                        [
                            -157.80735688356563,
                            21.307856246810996
                        ],
                        [
                            -157.80729395831398,
                            21.307897670893052
                        ],
                        [
                            -157.80730317260665,
                            21.307909962656971
                        ],
                        [
                            -157.8072318832474,
                            21.30795689318365
                        ],
                        [
                            -157.80722266703748,
                            21.30794460049902
                        ],
                        [
                            -157.80715974267591,
                            21.307986024533744
                        ],
                        [
                            -157.80716895887545,
                            21.307998318124973
                        ],
                        [
                            -157.80713249521719,
                            21.30802232003883
                        ],
                        [
                            -157.80715244600702,
                            21.30804893254253
                        ],
                        [
                            -157.80714631784159,
                            21.308052966979819
                        ],
                        [
                            -157.80716497531802,
                            21.308077856587044
                        ],
                        [
                            -157.80717110347678,
                            21.308073823052464
                        ],
                        [
                            -157.80719105427298,
                            21.308100436455412
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3083,
                "NUMBER": "9620B2",
                "PROPER_NAME": "KAU`IOKAHALOA NUI - BUILDING Q",
                "DISPLAY_NAME": "KAU`IOKAHALOA NUI - BUILDING Q - 9620B2",
                "ADDRESS": "3029 LOWREY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "KAUIOKAHALOA NUI - BUILDING Q",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/9620B2_01.jpg",
                "HEIGHT (ft)": 34,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 139.42740039710392,
                "SHAPE_Area": 597.39231349160445
            }
        },
        {
            "type": "Feature",
            "id": 3111,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8124219779049,
                            21.307371558944023
                        ],
                        [
                            -157.8125449343755,
                            21.307537549953398
                        ],
                        [
                            -157.81259338739812,
                            21.307506031239285
                        ],
                        [
                            -157.81247043088828,
                            21.307340041166722
                        ],
                        [
                            -157.8124219779049,
                            21.307371558944023
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3111,
                "NUMBER": "1011C",
                "PROPER_NAME": "WOODLAWN 3 - JOURNALS",
                "DISPLAY_NAME": "WOODLAWN 3 - JOURNALS - 1011C",
                "ADDRESS": "2840 KOLOWALU STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WOODLAWN 3 - JOURNALS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1011C_01.jpg",
                "HEIGHT (ft)": 29,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 56.972434683635683,
                "SHAPE_Area": 136.8567767788482
            }
        },
        {
            "type": "Feature",
            "id": 3113,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81253167430592,
                            21.30730064576791
                        ],
                        [
                            -157.81264893448304,
                            21.307458947510241
                        ],
                        [
                            -157.81269777024031,
                            21.307427181226451
                        ],
                        [
                            -157.81258051003246,
                            21.307268879516322
                        ],
                        [
                            -157.81253167430592,
                            21.30730064576791
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3113,
                "NUMBER": "1011B",
                "PROPER_NAME": "WOODLAWN 2 - MARKETING",
                "DISPLAY_NAME": "WOODLAWN 2 - MARKETING - 1011B",
                "ADDRESS": "2840 KOLOWALU STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WOODLAWN 2 - MARKETING",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1011B_01.jpg",
                "HEIGHT (ft)": 27,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 54.996703631633565,
                "SHAPE_Area": 131.54691269075818
            }
        },
        {
            "type": "Feature",
            "id": 3115,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81264243466336,
                            21.307228321704702
                        ],
                        [
                            -157.81275896326002,
                            21.307387097006671
                        ],
                        [
                            -157.81280688570425,
                            21.307356211371289
                        ],
                        [
                            -157.81269035707695,
                            21.307197436100687
                        ],
                        [
                            -157.81264243466336,
                            21.307228321704702
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3115,
                "NUMBER": "1011A",
                "PROPER_NAME": "WOODLAWN 1 - EDITORIAL",
                "DISPLAY_NAME": "WOODLAWN 1 - EDITORIAL - 1011A",
                "ADDRESS": "2840 KOLOWALU STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WOODLAWN 1 - EDITORIAL",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1011A_01.jpg",
                "HEIGHT (ft)": 26,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 54.729966553780713,
                "SHAPE_Area": 128.70208384655663
            }
        },
        {
            "type": "Feature",
            "id": 3118,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81250191698513,
                            21.307154634279971
                        ],
                        [
                            -157.81253365928092,
                            21.307197492833538
                        ],
                        [
                            -157.81269535674619,
                            21.30709232782036
                        ],
                        [
                            -157.81266361538681,
                            21.307049469302449
                        ],
                        [
                            -157.81250191698513,
                            21.307154634279971
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3118,
                "NUMBER": "1011D",
                "PROPER_NAME": "WOODLAWN 4 - ADMINISTRATION",
                "DISPLAY_NAME": "WOODLAWN 4 - ADMINISTRATION - 1011D",
                "ADDRESS": "2840 KOLOWALU STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WOODLAWN 4 - ADMINISTRATION",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1011D_01.jpg",
                "HEIGHT (ft)": 36,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 52.38519985119953,
                "SHAPE_Area": 117.91167138767386
            }
        },
        {
            "type": "Feature",
            "id": 3119,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81237420283341,
                            21.307070020304373
                        ],
                        [
                            -157.81241946347444,
                            21.307131131505869
                        ],
                        [
                            -157.81258115802632,
                            21.307025969291676
                        ],
                        [
                            -157.81253589735323,
                            21.306964857227989
                        ],
                        [
                            -157.81237420283341,
                            21.307070020304373
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3119,
                "NUMBER": "1011E",
                "PROPER_NAME": "WOODLAWN 5 - WAREHOUSE",
                "DISPLAY_NAME": "WOODLAWN 5 - WAREHOUSE - 1011E",
                "ADDRESS": "2840 KOLOWALU STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WOODLAWN 5 - WAREHOUSE",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1011E_01.jpg",
                "HEIGHT (ft)": 31,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 57.303423690551426,
                "SHAPE_Area": 168.12606944732903
            }
        },
        {
            "type": "Feature",
            "id": 3122,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81231986424726,
                            21.307003477977382
                        ],
                        [
                            -157.8123529482906,
                            21.307048147390596
                        ],
                        [
                            -157.81247361811748,
                            21.306969665425978
                        ],
                        [
                            -157.81244053309598,
                            21.306924995125076
                        ],
                        [
                            -157.81231986424726,
                            21.307003477977382
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3122,
                "NUMBER": "1011G",
                "PROPER_NAME": "WOODLAWN 7 - BUSINESS",
                "DISPLAY_NAME": "WOODLAWN 7 - BUSINESS - 1011G",
                "ADDRESS": "2840 KOLOWALU STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WOODLAWN 7 - BUSINESS",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1011G_01.jpg",
                "HEIGHT (ft)": 30,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 42.512339167528808,
                "SHAPE_Area": 91.713845417147283
            }
        },
        {
            "type": "Feature",
            "id": 3124,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81224720654498,
                            21.307136076591583
                        ],
                        [
                            -157.81236446433567,
                            21.307294381211353
                        ],
                        [
                            -157.81241330202138,
                            21.307262615023493
                        ],
                        [
                            -157.81229604419997,
                            21.307104310435921
                        ],
                        [
                            -157.81224720654498,
                            21.307136076591583
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3124,
                "NUMBER": "1011F",
                "PROPER_NAME": "WOODLAWN 6 - PRODUCTION",
                "DISPLAY_NAME": "WOODLAWN 6 - PRODUCTION - 1011F",
                "ADDRESS": "2840 KOLOWALU STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WOODLAWN 6 - PRODUCTION",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1011F_01.jpg",
                "HEIGHT (ft)": 33,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 54.997290249239285,
                "SHAPE_Area": 131.55119993288395
            }
        },
        {
            "type": "Feature",
            "id": 3125,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81210281546177,
                            21.306949114556616
                        ],
                        [
                            -157.81222006618498,
                            21.307107421928698
                        ],
                        [
                            -157.81226953857961,
                            21.307075244703139
                        ],
                        [
                            -157.81215228782528,
                            21.306916937363663
                        ],
                        [
                            -157.81210281546177,
                            21.306949114556616
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3125,
                "NUMBER": "1011H",
                "PROPER_NAME": "WOODLAWN H",
                "DISPLAY_NAME": "WOODLAWN H - 1011H",
                "ADDRESS": "2840 KOLOWALU STREET",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WOODLAWN H",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "N",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1011H_01.jpg",
                "HEIGHT (ft)": 30,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": "Y",
                "SHAPE_Length": 55.157051423676698,
                "SHAPE_Area": 133.25757780733966
            }
        },
        {
            "type": "Feature",
            "id": 3476,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81025080966666,
                            21.30590058920524
                        ],
                        [
                            -157.81035118353202,
                            21.305959019123431
                        ],
                        [
                            -157.81045426120309,
                            21.305803522348448
                        ],
                        [
                            -157.81035388740335,
                            21.305745091590392
                        ],
                        [
                            -157.81025080966666,
                            21.30590058920524
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3476,
                "NUMBER": "1010",
                "PROPER_NAME": "MAGOON SOIL LABORATORY - NREM",
                "DISPLAY_NAME": "MAGOON SOIL LABORATORY - NREM - 1010",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1010_01.jpg",
                "HEIGHT (ft)": 18,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 65.043414765016209,
                "SHAPE_Area": 248.39042400441605
            }
        },
        {
            "type": "Feature",
            "id": 3480,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80957603323102,
                            21.306239099952549
                        ],
                        [
                            -157.80970328137724,
                            21.306407584994602
                        ],
                        [
                            -157.80994172157202,
                            21.306249442569381
                        ],
                        [
                            -157.8098144732563,
                            21.306080959504925
                        ],
                        [
                            -157.80957603323102,
                            21.306239099952549
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3480,
                "NUMBER": "1033",
                "PROPER_NAME": "MAGOON GREENHOUSE 4 - TPSS",
                "DISPLAY_NAME": "MAGOON GREENHOUSE 4 - TPSS - 1033",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1033_01.jpg",
                "HEIGHT (ft)": 7,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 106.30415340858247,
                "SHAPE_Area": 692.39775604856572
            }
        },
        {
            "type": "Feature",
            "id": 3484,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80943737474161,
                            21.306611413044127
                        ],
                        [
                            -157.80948849664892,
                            21.30668036992321
                        ],
                        [
                            -157.80972090645784,
                            21.306529062661443
                        ],
                        [
                            -157.80966978545086,
                            21.306460105855976
                        ],
                        [
                            -157.80943737474161,
                            21.306611413044127
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3484,
                "NUMBER": "1005A",
                "PROPER_NAME": "MAGOON GREENHOUSE 5 - TPSS",
                "DISPLAY_NAME": "MAGOON GREENHOUSE 5 - TPSS - 1005A",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1005A_01.jpg",
                "HEIGHT (ft)": 13,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 77.301648382499494,
                "SHAPE_Area": 272.85552124070989
            }
        },
        {
            "type": "Feature",
            "id": 3486,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80935442427946,
                            21.306512952113732
                        ],
                        [
                            -157.80941519211711,
                            21.306595072783079
                        ],
                        [
                            -157.80965502769268,
                            21.306439224430537
                        ],
                        [
                            -157.80959425977659,
                            21.306357103843112
                        ],
                        [
                            -157.80935442427946,
                            21.306512952113732
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3486,
                "NUMBER": "1005B",
                "PROPER_NAME": "MAGOON GREENHOUSE 6 - TPSS",
                "DISPLAY_NAME": "MAGOON GREENHOUSE 6 - TPSS - 1005B",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1005B_01.jpg",
                "HEIGHT (ft)": 10,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 82.675848362440746,
                "SHAPE_Area": 334.91879709841669
            }
        },
        {
            "type": "Feature",
            "id": 3489,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.80919713182521,
                            21.306305816842013
                        ],
                        [
                            -157.8093366226434,
                            21.306492849522254
                        ],
                        [
                            -157.80957836371394,
                            21.306334524119197
                        ],
                        [
                            -157.80943887367454,
                            21.306147492538837
                        ],
                        [
                            -157.80919713182521,
                            21.306305816842013
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3489,
                "NUMBER": "1005C",
                "PROPER_NAME": "MAGOON GREENHOUSE 7 - TPSS",
                "DISPLAY_NAME": "MAGOON GREENHOUSE 7 - TPSS - 1005C",
                "ADDRESS": "2717 WOODLAWN DRIVE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "MAGOON RESEARCH FACILITY",
                "SUBSTATION-FED?": "N",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1005C_01.jpg",
                "HEIGHT (ft)": 25,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 111.7078123077699,
                "SHAPE_Area": 772.79888344216999
            }
        },
        {
            "type": "Feature",
            "id": 3795,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.82141589653202,
                            21.299942140905415
                        ],
                        [
                            -157.82141654338253,
                            21.299934885783895
                        ],
                        [
                            -157.82147848223883,
                            21.299939731720087
                        ],
                        [
                            -157.82148100846885,
                            21.299911369376311
                        ],
                        [
                            -157.82148027629896,
                            21.299911311852203
                        ],
                        [
                            -157.82148315084387,
                            21.299879041166918
                        ],
                        [
                            -157.82149564229036,
                            21.299738788622967
                        ],
                        [
                            -157.82149932783236,
                            21.299697413818532
                        ],
                        [
                            -157.821506647174,
                            21.299615228465768
                        ],
                        [
                            -157.82151909503804,
                            21.299616201862239
                        ],
                        [
                            -157.82151888116462,
                            21.299618603385294
                        ],
                        [
                            -157.82157062346414,
                            21.29962265064847
                        ],
                        [
                            -157.82157066277404,
                            21.299622193807757
                        ],
                        [
                            -157.82178739396812,
                            21.299639145755755
                        ],
                        [
                            -157.82181802978599,
                            21.299291544633252
                        ],
                        [
                            -157.8218281199556,
                            21.299292247646978
                        ],
                        [
                            -157.82183050021331,
                            21.299265256522347
                        ],
                        [
                            -157.82177683031082,
                            21.299261057629352
                        ],
                        [
                            -157.82177740094548,
                            21.299254653869525
                        ],
                        [
                            -157.82169832382135,
                            21.29924846848154
                        ],
                        [
                            -157.82167904177044,
                            21.299246960320769
                        ],
                        [
                            -157.82167849223217,
                            21.299253135669808
                        ],
                        [
                            -157.8215200952346,
                            21.299240745899954
                        ],
                        [
                            -157.82152175828986,
                            21.299278563568102
                        ],
                        [
                            -157.82152176136051,
                            21.299278662059255
                        ],
                        [
                            -157.82148926423432,
                            21.299279916955605
                        ],
                        [
                            -157.82148850475477,
                            21.299264666909121
                        ],
                        [
                            -157.82139015698743,
                            21.299268963080522
                        ],
                        [
                            -157.82139036218598,
                            21.299273089402117
                        ],
                        [
                            -157.82136100452104,
                            21.299274372584364
                        ],
                        [
                            -157.82136538358671,
                            21.299362412532766
                        ],
                        [
                            -157.82139474029808,
                            21.299361130247163
                        ],
                        [
                            -157.82140062478157,
                            21.299479434407218
                        ],
                        [
                            -157.82137126708994,
                            21.29948071578265
                        ],
                        [
                            -157.82137300846844,
                            21.299515718127896
                        ],
                        [
                            -157.82137453952126,
                            21.299546511907039
                        ],
                        [
                            -157.82137564616139,
                            21.299568755729243
                        ],
                        [
                            -157.82140500387058,
                            21.299567474353868
                        ],
                        [
                            -157.82140644280204,
                            21.299596402888131
                        ],
                        [
                            -157.82134446313918,
                            21.299599109899148
                        ],
                        [
                            -157.82133059719791,
                            21.299599715622985
                        ],
                        [
                            -157.82133010307675,
                            21.299605225558825
                        ],
                        [
                            -157.82132946285799,
                            21.299612374126454
                        ],
                        [
                            -157.82132493066837,
                            21.299662963910006
                        ],
                        [
                            -157.82130072674647,
                            21.299933144136581
                        ],
                        [
                            -157.82141589653202,
                            21.299942140905415
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 3795,
                "NUMBER": "1265",
                "PROPER_NAME": "WALTER DODS, JR. RISE CENTER",
                "DISPLAY_NAME": "WALTER DODS, JR. RISE CENTER - 1265",
                "ADDRESS": "1810 UNIVERSITY AVENUE",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "WALTER DODS, JR. RISE CENTER",
                "SUBSTATION-FED?": null,
                "REXED?": null,
                "PV?": null,
                "OPS-FUNDED?": null,
                "AKA": "YMCA",
                "PIC": null,
                "HEIGHT (ft)": null,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 274.1660552761544,
                "SHAPE_Area": 2453.5375497226751
            }
        },
        {
            "type": "Feature",
            "id": 4131,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81864255748491,
                            21.29472978437267
                        ],
                        [
                            -157.81864645475966,
                            21.294731711557226
                        ],
                        [
                            -157.81864785081501,
                            21.294732403415722
                        ],
                        [
                            -157.81868164394487,
                            21.294749181680388
                        ],
                        [
                            -157.81868256013075,
                            21.294747559296358
                        ],
                        [
                            -157.8186875516999,
                            21.294738723931665
                        ],
                        [
                            -157.81869373810576,
                            21.294727774886784
                        ],
                        [
                            -157.81869944297625,
                            21.294729919826032
                        ],
                        [
                            -157.81871333797105,
                            21.294697874688463
                        ],
                        [
                            -157.81871696680872,
                            21.294699256146046
                        ],
                        [
                            -157.81871862646341,
                            21.294695429284904
                        ],
                        [
                            -157.8187584024478,
                            21.294706465109083
                        ],
                        [
                            -157.81875885835302,
                            21.294706591169739
                        ],
                        [
                            -157.81875760731577,
                            21.294710550987251
                        ],
                        [
                            -157.8187618325889,
                            21.294711722525889
                        ],
                        [
                            -157.81876308265493,
                            21.294707763604915
                        ],
                        [
                            -157.81876353856015,
                            21.294707889665577
                        ],
                        [
                            -157.81878278550045,
                            21.294713230075509
                        ],
                        [
                            -157.81878329142003,
                            21.294713370037964
                        ],
                        [
                            -157.81880253739797,
                            21.294718710438957
                        ],
                        [
                            -157.81880331550843,
                            21.294718926389539
                        ],
                        [
                            -157.81880248495878,
                            21.294722981304115
                        ],
                        [
                            -157.81880633137672,
                            21.294723673192507
                        ],
                        [
                            -157.81880716193348,
                            21.294719617374565
                        ],
                        [
                            -157.81880797013011,
                            21.294719687186891
                        ],
                        [
                            -157.81882795837882,
                            21.294721404775252
                        ],
                        [
                            -157.81882848337037,
                            21.294721450015338
                        ],
                        [
                            -157.81884847161248,
                            21.294723168504607
                        ],
                        [
                            -157.81884894556083,
                            21.294723207966104
                        ],
                        [
                            -157.81884854254935,
                            21.294727320084586
                        ],
                        [
                            -157.8188529303263,
                            21.294727697777137
                        ],
                        [
                            -157.81885333238097,
                            21.294723584748539
                        ],
                        [
                            -157.81885380535098,
                            21.294723626009937
                        ],
                        [
                            -157.81887379360106,
                            21.294725343592884
                        ],
                        [
                            -157.81887431955653,
                            21.294725388839588
                        ],
                        [
                            -157.8188943078072,
                            21.294727106420122
                        ],
                        [
                            -157.81889511600394,
                            21.294727176232055
                        ],
                        [
                            -157.81889514566782,
                            21.294731305841061
                        ],
                        [
                            -157.81889568646426,
                            21.294731303312108
                        ],
                        [
                            -157.8188990623907,
                            21.294731281831513
                        ],
                        [
                            -157.81889903271951,
                            21.294727153125855
                        ],
                        [
                            -157.81889983922258,
                            21.294727072962935
                        ],
                        [
                            -157.81891980102037,
                            21.294725103615622
                        ],
                        [
                            -157.81892032582027,
                            21.294725052191218
                        ],
                        [
                            -157.81894028762483,
                            21.294723081938105
                        ],
                        [
                            -157.81894076033825,
                            21.294723034665122
                        ],
                        [
                            -157.8189412220311,
                            21.294727142010682
                        ],
                        [
                            -157.81894560278732,
                            21.294726709309703
                        ],
                        [
                            -157.81894514205825,
                            21.294722601970914
                        ],
                        [
                            -157.81894561380054,
                            21.294722555594497
                        ],
                        [
                            -157.8189655765685,
                            21.294720585345114
                        ],
                        [
                            -157.8189659904337,
                            21.294720543982891
                        ],
                        [
                            -157.81898606220091,
                            21.294718564558565
                        ],
                        [
                            -157.8189868706317,
                            21.294718484408751
                        ],
                        [
                            -157.81898775888044,
                            21.294722530606375
                        ],
                        [
                            -157.81899159553191,
                            21.294721790547069
                        ],
                        [
                            -157.819031339834,
                            21.294712421189256
                        ],
                        [
                            -157.81903393866648,
                            21.294720261887317
                        ],
                        [
                            -157.81904095229663,
                            21.294718219745747
                        ],
                        [
                            -157.81903835249989,
                            21.294710379040996
                        ],
                        [
                            -157.81905444708241,
                            21.294704769883126
                        ],
                        [
                            -157.81907196360345,
                            21.294698663897488
                        ],
                        [
                            -157.81907239956189,
                            21.294698511572879
                        ],
                        [
                            -157.8190767658788,
                            21.294696990180782
                        ],
                        [
                            -157.81907808147375,
                            21.294699911040688
                        ],
                        [
                            -157.8190790513801,
                            21.294702061592751
                        ],
                        [
                            -157.81908070137843,
                            21.294705717449045
                        ],
                        [
                            -157.8190807676894,
                            21.294705863360264
                        ],
                        [
                            -157.81908482718015,
                            21.294704257606679
                        ],
                        [
                            -157.81911639453344,
                            21.294689546924381
                        ],
                        [
                            -157.81912329123503,
                            21.294686334067343
                        ],
                        [
                            -157.819127145359,
                            21.294684371839171
                        ],
                        [
                            -157.81913375164356,
                            21.294680709765583
                        ],
                        [
                            -157.81915931890632,
                            21.294666538764364
                        ],
                        [
                            -157.81916431210846,
                            21.29466377057097
                        ],
                        [
                            -157.81916795892317,
                            21.294661453661497
                        ],
                        [
                            -157.81917042446253,
                            21.294659674113117
                        ],
                        [
                            -157.81918332808223,
                            21.294650358527257
                        ],
                        [
                            -157.81918684994636,
                            21.294647875420171
                        ],
                        [
                            -157.8191913816045,
                            21.294644600799167
                        ],
                        [
                            -157.81920064659377,
                            21.294637904815357
                        ],
                        [
                            -157.8192031973889,
                            21.294640778329292
                        ],
                        [
                            -157.81920470377855,
                            21.294639604551016
                        ],
                        [
                            -157.81920219787526,
                            21.294636782845323
                        ],
                        [
                            -157.81920558508489,
                            21.29463414160313
                        ],
                        [
                            -157.81920809002429,
                            21.294636963302015
                        ],
                        [
                            -157.81920959640664,
                            21.294635790427016
                        ],
                        [
                            -157.81920704369088,
                            21.294632915996306
                        ],
                        [
                            -157.81921712389726,
                            21.294624445146315
                        ],
                        [
                            -157.81922001102612,
                            21.294622019016366
                        ],
                        [
                            -157.81922325581951,
                            21.294619225908381
                        ],
                        [
                            -157.81923769351937,
                            21.294607079010895
                        ],
                        [
                            -157.81924078909879,
                            21.294604140313222
                        ],
                        [
                            -157.81924328596307,
                            21.294601455785426
                        ],
                        [
                            -157.81924717612438,
                            21.294597274174887
                        ],
                        [
                            -157.81926283207332,
                            21.294580442703495
                        ],
                        [
                            -157.8192691617364,
                            21.294573637592453
                        ],
                        [
                            -157.81926918020196,
                            21.294573618750771
                        ],
                        [
                            -157.81927097332766,
                            21.294571544495373
                        ],
                        [
                            -157.8192719346028,
                            21.294570431033357
                        ],
                        [
                            -157.81927195115495,
                            21.29457041037147
                        ],
                        [
                            -157.8192720192842,
                            21.294570328640784
                        ],
                        [
                            -157.819276548772,
                            21.294564669952564
                        ],
                        [
                            -157.81928220274156,
                            21.294557618895691
                        ],
                        [
                            -157.81929290230678,
                            21.294544256004787
                        ],
                        [
                            -157.8192946354134,
                            21.294542092795751
                        ],
                        [
                            -157.81929772376083,
                            21.294538248848159
                        ],
                        [
                            -157.81929786503352,
                            21.294538061030359
                        ],
                        [
                            -157.81929907700027,
                            21.294536335924008
                        ],
                        [
                            -157.81930015343437,
                            21.294534804096052
                        ],
                        [
                            -157.81929868199015,
                            21.294533895803593
                        ],
                        [
                            -157.81929821580238,
                            21.294533608868615
                        ],
                        [
                            -157.81929647289607,
                            21.29453253335134
                        ],
                        [
                            -157.8192915674517,
                            21.294529504199534
                        ],
                        [
                            -157.81929710070813,
                            21.294520669904372
                        ],
                        [
                            -157.81930450081887,
                            21.2945088575757
                        ],
                        [
                            -157.81930776297196,
                            21.294503648919463
                        ],
                        [
                            -157.8193088379858,
                            21.294501932789665
                        ],
                        [
                            -157.81930981828253,
                            21.294500368668579
                        ],
                        [
                            -157.81931218507242,
                            21.294496590123792
                        ],
                        [
                            -157.81931478037347,
                            21.294497873979658
                        ],
                        [
                            -157.81931569463029,
                            21.294496250674868
                        ],
                        [
                            -157.81931315597541,
                            21.294494995221484
                        ],
                        [
                            -157.81931497872009,
                            21.294491746764681
                        ],
                        [
                            -157.81931752217997,
                            21.294493004058516
                        ],
                        [
                            -157.81931843642957,
                            21.294491381657057
                        ],
                        [
                            -157.81931582960507,
                            21.294490092300062
                        ],
                        [
                            -157.81933033686462,
                            21.294461025363258
                        ],
                        [
                            -157.81933213253413,
                            21.29445742529709
                        ],
                        [
                            -157.81933307982828,
                            21.294455527592984
                        ],
                        [
                            -157.81933455486129,
                            21.294452124023802
                        ],
                        [
                            -157.81933475680998,
                            21.294451580695412
                        ],
                        [
                            -157.81933894328358,
                            21.294440591397507
                        ],
                        [
                            -157.8193388442549,
                            21.294440559084194
                        ],
                        [
                            -157.81933911616952,
                            21.294439824727597
                        ],
                        [
                            -157.81934137909087,
                            21.294433722834796
                        ],
                        [
                            -157.81934158006115,
                            21.29443318130631
                        ],
                        [
                            -157.81934476707013,
                            21.294424587115021
                        ],
                        [
                            -157.81934820331139,
                            21.294415322548716
                        ],
                        [
                            -157.81934840331778,
                            21.294414781013455
                        ],
                        [
                            -157.81934928546139,
                            21.29441198849489
                        ],
                        [
                            -157.81934979575166,
                            21.294410374100433
                        ],
                        [
                            -157.81934994190254,
                            21.294409816829752
                        ],
                        [
                            -157.81935236380866,
                            21.294400584897737
                        ],
                        [
                            -157.81935475885248,
                            21.29439145757064
                        ],
                        [
                            -157.81935490500331,
                            21.294390900299977
                        ],
                        [
                            -157.81935655140146,
                            21.294384626955061
                        ],
                        [
                            -157.81935676912414,
                            21.294383798265631
                        ],
                        [
                            -157.81935945051245,
                            21.294373578036666
                        ],
                        [
                            -157.81935972290856,
                            21.294372541950722
                        ],
                        [
                            -157.81935986905935,
                            21.294371984680048
                        ],
                        [
                            -157.81936060834209,
                            21.294368371783442
                        ],
                        [
                            -157.81936069289023,
                            21.294367803239961
                        ],
                        [
                            -157.81936231787381,
                            21.29435684837113
                        ],
                        [
                            -157.81936252065424,
                            21.294355476638714
                        ],
                        [
                            -157.81936322362253,
                            21.294350737861844
                        ],
                        [
                            -157.81936347015889,
                            21.294349077351125
                        ],
                        [
                            -157.819363554707,
                            21.294348508807644
                        ],
                        [
                            -157.8193652030933,
                            21.294337399622993
                        ],
                        [
                            -157.81936633196761,
                            21.294329783822025
                        ],
                        [
                            -157.81936641650847,
                            21.294329216181893
                        ],
                        [
                            -157.81936643861869,
                            21.294328982358628
                        ],
                        [
                            -157.81936684160692,
                            21.294324871141335
                        ],
                        [
                            -157.81936686467384,
                            21.294324638228172
                        ],
                        [
                            -157.81936688215492,
                            21.294324259829839
                        ],
                        [
                            -157.81936689238103,
                            21.294324065672434
                        ],
                        [
                            -157.8193673414271,
                            21.29431466993918
                        ],
                        [
                            -157.81936757983254,
                            21.294309682181307
                        ],
                        [
                            -157.81936776032595,
                            21.294305910885292
                        ],
                        [
                            -157.81936779509334,
                            21.294305178478819
                        ],
                        [
                            -157.81936782183661,
                            21.29430460591632
                        ],
                        [
                            -157.81936813076243,
                            21.294298150642234
                        ],
                        [
                            -157.81936868050462,
                            21.294286647099963
                        ],
                        [
                            -157.81936872454861,
                            21.294285718722648
                        ],
                        [
                            -157.81936875225577,
                            21.294285146166906
                        ],
                        [
                            -157.81936874729433,
                            21.294284439680123
                        ],
                        [
                            -157.81936873680434,
                            21.294282977016039
                        ],
                        [
                            -157.81936872573277,
                            21.294281466468156
                        ],
                        [
                            -157.81936868982294,
                            21.294280893466201
                        ],
                        [
                            -157.81936811074476,
                            21.29427156730976
                        ],
                        [
                            -157.81936791762737,
                            21.294268470033249
                        ],
                        [
                            -157.81936771685932,
                            21.294265244421531
                        ],
                        [
                            -157.81936751608401,
                            21.294262019713134
                        ],
                        [
                            -157.81936748544535,
                            21.294261510888941
                        ],
                        [
                            -157.8193674811381,
                            21.294261446717936
                        ],
                        [
                            -157.81936699338002,
                            21.294253600956957
                        ],
                        [
                            -157.81936679852964,
                            21.294250479276727
                        ],
                        [
                            -157.81936638425933,
                            21.294243812053416
                        ],
                        [
                            -157.81936630739216,
                            21.294242573868189
                        ],
                        [
                            -157.81936627148235,
                            21.29424200086623
                        ],
                        [
                            -157.81936624537622,
                            21.294241769414956
                        ],
                        [
                            -157.81936604739428,
                            21.294240005509874
                        ],
                        [
                            -157.81936578463618,
                            21.294237662076615
                        ],
                        [
                            -157.81936575853729,
                            21.294237429722003
                        ],
                        [
                            -157.81936566570727,
                            21.294236862644539
                        ],
                        [
                            -157.81936522188269,
                            21.294234137613532
                        ],
                        [
                            -157.81936461719678,
                            21.294230432178058
                        ],
                        [
                            -157.819364195438,
                            21.294227841003739
                        ],
                        [
                            -157.81936404845794,
                            21.294226932967959
                        ],
                        [
                            -157.81936356689565,
                            21.294223984534586
                        ],
                        [
                            -157.81936293095242,
                            21.294220089167695
                        ],
                        [
                            -157.81936261946475,
                            21.294218174503506
                        ],
                        [
                            -157.81936252760585,
                            21.294217606529468
                        ],
                        [
                            -157.81936198455037,
                            21.29421427101332
                        ],
                        [
                            -157.81936184576205,
                            21.294213423562191
                        ],
                        [
                            -157.81936182554475,
                            21.294213299655784
                        ],
                        [
                            -157.81936176671235,
                            21.294212941500177
                        ],
                        [
                            -157.81936148645323,
                            21.294211220380756
                        ],
                        [
                            -157.81936109039944,
                            21.294208790190371
                        ],
                        [
                            -157.81936079545392,
                            21.294206976822036
                        ],
                        [
                            -157.81936038372095,
                            21.294204457989323
                        ],
                        [
                            -157.81935985963321,
                            21.294201161452033
                        ],
                        [
                            -157.81935948040731,
                            21.29419891747829
                        ],
                        [
                            -157.81935940873691,
                            21.294198477024015
                        ],
                        [
                            -157.81935938854843,
                            21.294198349504232
                        ],
                        [
                            -157.81935917836273,
                            21.294197389531796
                        ],
                        [
                            -157.81935897555627,
                            21.294196471167123
                        ],
                        [
                            -157.81935859792961,
                            21.294194751171549
                        ],
                        [
                            -157.8193525008983,
                            21.294172791229741
                        ],
                        [
                            -157.81934797522155,
                            21.294156489408529
                        ],
                        [
                            -157.81934651605343,
                            21.294152113083502
                        ],
                        [
                            -157.81933919280428,
                            21.294133180838472
                        ],
                        [
                            -157.8193375514509,
                            21.294128925193284
                        ],
                        [
                            -157.81933213593513,
                            21.29411493161864
                        ],
                        [
                            -157.81933732196336,
                            21.294112880257533
                        ],
                        [
                            -157.81933755212009,
                            21.294112787919207
                        ],
                        [
                            -157.81934138144226,
                            21.294111273593412
                        ],
                        [
                            -157.81933966900945,
                            21.294107469145349
                        ],
                        [
                            -157.81932073973945,
                            21.294071290153788
                        ],
                        [
                            -157.81932009221674,
                            21.294070172633749
                        ],
                        [
                            -157.81931863456774,
                            21.294067658208611
                        ],
                        [
                            -157.8193138741147,
                            21.294060114925205
                        ],
                        [
                            -157.81929668945719,
                            21.294032885418694
                        ],
                        [
                            -157.81929421627615,
                            21.294029467705766
                        ],
                        [
                            -157.81929153302161,
                            21.294026162346562
                        ],
                        [
                            -157.81929016990159,
                            21.294024485124623
                        ],
                        [
                            -157.81928246758309,
                            21.294014998787976
                        ],
                        [
                            -157.81927979959988,
                            21.294011712506933
                        ],
                        [
                            -157.81927428321129,
                            21.294004919155071
                        ],
                        [
                            -157.81926924219516,
                            21.293998710921596
                        ],
                        [
                            -157.81927212785308,
                            21.293996467264783
                        ],
                        [
                            -157.81927087830113,
                            21.29399505372621
                        ],
                        [
                            -157.81926805759193,
                            21.293997251765635
                        ],
                        [
                            -157.81926524025371,
                            21.293994079167401
                        ],
                        [
                            -157.81926805321569,
                            21.293991885590639
                        ],
                        [
                            -157.81926680172162,
                            21.293990473845184
                        ],
                        [
                            -157.81926391310714,
                            21.293992725611698
                        ],
                        [
                            -157.81925908930396,
                            21.293987804427417
                        ],
                        [
                            -157.81925897169756,
                            21.2939876843548
                        ],
                        [
                            -157.8192521237203,
                            21.293980697369772
                        ],
                        [
                            -157.81924914241728,
                            21.293977657323037
                        ],
                        [
                            -157.81923602587958,
                            21.293964276427587
                        ],
                        [
                            -157.81923289019295,
                            21.293961376226669
                        ],
                        [
                            -157.81922424554449,
                            21.293954132721584
                        ],
                        [
                            -157.81920069875588,
                            21.293934400990246
                        ],
                        [
                            -157.81919727437059,
                            21.293931802302943
                        ],
                        [
                            -157.81918202441298,
                            21.293921345169384
                        ],
                        [
                            -157.81917774097187,
                            21.293918407103952
                        ],
                        [
                            -157.81916262332697,
                            21.293908039429269
                        ],
                        [
                            -157.81915895050275,
                            21.29390577054296
                        ],
                        [
                            -157.81915658518272,
                            21.293909124502488
                        ],
                        [
                            -157.81915653056987,
                            21.293909203617801
                        ],
                        [
                            -157.81915342316398,
                            21.293913624696767
                        ],
                        [
                            -157.81911829520604,
                            21.293894298636758
                        ],
                        [
                            -157.81911929653151,
                            21.293892515140048
                        ],
                        [
                            -157.81912035457802,
                            21.293890629958042
                        ],
                        [
                            -157.81911862051547,
                            21.293889775832092
                        ],
                        [
                            -157.81911659437029,
                            21.293893387830231
                        ],
                        [
                            -157.81911312720905,
                            21.293891679584991
                        ],
                        [
                            -157.81911515431818,
                            21.293888067593659
                        ],
                        [
                            -157.81911342121958,
                            21.293887213474417
                        ],
                        [
                            -157.81911136184024,
                            21.293890883056385
                        ],
                        [
                            -157.8190821399746,
                            21.293878074835416
                        ],
                        [
                            -157.81907448605716,
                            21.293874720145975
                        ],
                        [
                            -157.81907085435836,
                            21.29387333686979
                        ],
                        [
                            -157.8190702755752,
                            21.293873147613962
                        ],
                        [
                            -157.81905773258345,
                            21.293869062108406
                        ],
                        [
                            -157.81905356568009,
                            21.293867705792252
                        ],
                        [
                            -157.81905122168871,
                            21.293866941339143
                        ],
                        [
                            -157.81905064193452,
                            21.293866752979831
                        ],
                        [
                            -157.8190315880498,
                            21.293860546702863
                        ],
                        [
                            -157.81903100925953,
                            21.293860358350262
                        ],
                        [
                            -157.81903083324994,
                            21.29386030923564
                        ],
                        [
                            -157.81902630599325,
                            21.293859053377187
                        ],
                        [
                            -157.81902571329721,
                            21.293858916420302
                        ],
                        [
                            -157.81901449915927,
                            21.293856332637233
                        ],
                        [
                            -157.81901234196937,
                            21.293855835091229
                        ],
                        [
                            -157.8190061234412,
                            21.293854402045497
                        ],
                        [
                            -157.81900552881746,
                            21.293854265075023
                        ],
                        [
                            -157.81899883497886,
                            21.293852722093984
                        ],
                        [
                            -157.81898593992668,
                            21.293849750704684
                        ],
                        [
                            -157.81898534530296,
                            21.293849613734125
                        ],
                        [
                            -157.81898148927482,
                            21.2938489208798
                        ],
                        [
                            -157.81898088358648,
                            21.293848841648636
                        ],
                        [
                            -157.81896772979167,
                            21.293847127769936
                        ],
                        [
                            -157.81896090156786,
                            21.293846237899789
                        ],
                        [
                            -157.8189602958723,
                            21.293846159571888
                        ],
                        [
                            -157.81895834591307,
                            21.293845905588078
                        ],
                        [
                            -157.81894224648534,
                            21.293843806972884
                        ],
                        [
                            -157.81894031578236,
                            21.293843555834158
                        ],
                        [
                            -157.81893970913015,
                            21.293843476596077
                        ],
                        [
                            -157.81893482528557,
                            21.293843056580261
                        ],
                        [
                            -157.81893421434481,
                            21.293843031515554
                        ],
                        [
                            -157.81891406116307,
                            21.293842185462935
                        ],
                        [
                            -157.81891344926566,
                            21.293842159488047
                        ],
                        [
                            -157.81890656226557,
                            21.293841869958456
                        ],
                        [
                            -157.81890296410074,
                            21.293841719139682
                        ],
                        [
                            -157.81889329609149,
                            21.293841312529601
                        ],
                        [
                            -157.8188926851436,
                            21.293841288368082
                        ],
                        [
                            -157.81888951843783,
                            21.293841306800473
                        ],
                        [
                            -157.81888875976927,
                            21.293841312317706
                        ],
                        [
                            -157.81888814836665,
                            21.293841345066625
                        ],
                        [
                            -157.81887489122985,
                            21.293842069611873
                        ],
                        [
                            -157.818868009521,
                            21.293842445013787
                        ],
                        [
                            -157.81886739811119,
                            21.293842478665962
                        ],
                        [
                            -157.81884726022204,
                            21.293843579520722
                        ],
                        [
                            -157.8188470422817,
                            21.29384359063889
                        ],
                        [
                            -157.81884663627443,
                            21.293843613988251
                        ],
                        [
                            -157.81884177126705,
                            21.293844093879571
                        ],
                        [
                            -157.81884116521476,
                            21.293844180869336
                        ],
                        [
                            -157.81883479493646,
                            21.293845091956058
                        ],
                        [
                            -157.81882122345931,
                            21.293847034772792
                        ],
                        [
                            -157.81882061933479,
                            21.293847121776007
                        ],
                        [
                            -157.81881380513244,
                            21.29384809659777
                        ],
                        [
                            -157.81880728429925,
                            21.293849030115119
                        ],
                        [
                            -157.81880507336962,
                            21.293849347048251
                        ],
                        [
                            -157.81880067757868,
                            21.293849975677009
                        ],
                        [
                            -157.81880007056242,
                            21.29385006265986
                        ],
                        [
                            -157.81879814934527,
                            21.293850434022605
                        ],
                        [
                            -157.81879623199811,
                            21.293850803605689
                        ],
                        [
                            -157.81879405695685,
                            21.293851333990837
                        ],
                        [
                            -157.81879237448865,
                            21.293851744067958
                        ],
                        [
                            -157.81876938781227,
                            21.293857350008629
                        ],
                        [
                            -157.81875669395373,
                            21.293860445382229
                        ],
                        [
                            -157.81875540457563,
                            21.293860759747876
                        ],
                        [
                            -157.81875399393886,
                            21.293861169925442
                        ],
                        [
                            -157.81875386876558,
                            21.293860790526114
                        ],
                        [
                            -157.81875314595695,
                            21.293858600150418
                        ],
                        [
                            -157.81875127445446,
                            21.293859143505816
                        ],
                        [
                            -157.8187520001475,
                            21.293861334805158
                        ],
                        [
                            -157.81875212338579,
                            21.293861715094295
                        ],
                        [
                            -157.81875071950347,
                            21.293862124415824
                        ],
                        [
                            -157.81873921829339,
                            21.293866033079219
                        ],
                        [
                            -157.81873530657896,
                            21.293867363424731
                        ],
                        [
                            -157.81871756712255,
                            21.293873392833227
                        ],
                        [
                            -157.81871527055171,
                            21.293874173507188
                        ],
                        [
                            -157.81871233604448,
                            21.293875171034994
                        ],
                        [
                            -157.81871109400177,
                            21.293875593236042
                        ],
                        [
                            -157.8187090360606,
                            21.293870516189457
                        ],
                        [
                            -157.8187073217191,
                            21.293866711722195
                        ],
                        [
                            -157.81870326321931,
                            21.293868316571132
                        ],
                        [
                            -157.81869568845028,
                            21.293871826386376
                        ],
                        [
                            -157.81866452343289,
                            21.293886266995855
                        ],
                        [
                            -157.81866296804318,
                            21.293887059194574
                        ],
                        [
                            -157.81866065190249,
                            21.293888238125941
                        ],
                        [
                            -157.81864721185235,
                            21.293895688019841
                        ],
                        [
                            -157.81862618278808,
                            21.293907344139186
                        ],
                        [
                            -157.81862351530725,
                            21.293908822336796
                        ],
                        [
                            -157.81861986753992,
                            21.293911139228371
                        ],
                        [
                            -157.81860449841386,
                            21.293922235217053
                        ],
                        [
                            -157.81860327114731,
                            21.293923100182663
                        ],
                        [
                            -157.81860097656573,
                            21.293924717409158
                        ],
                        [
                            -157.81859227683049,
                            21.293931006285522
                        ],
                        [
                            -157.8185902611487,
                            21.293932462858955
                        ],
                        [
                            -157.81858562962805,
                            21.293935810841543
                        ],
                        [
                            -157.8185822414608,
                            21.293938452064939
                        ],
                        [
                            -157.81856781554706,
                            21.293950573695319
                        ],
                        [
                            -157.818567571015,
                            21.293950776145405
                        ],
                        [
                            -157.81855070177431,
                            21.293965034309451
                        ],
                        [
                            -157.81855033687506,
                            21.293965341611411
                        ],
                        [
                            -157.81855015441459,
                            21.293965496617414
                        ],
                        [
                            -157.81855013307182,
                            21.293965513632045
                        ],
                        [
                            -157.81854703845011,
                            21.293968453227322
                        ],
                        [
                            -157.81854701900625,
                            21.293968473868844
                        ],
                        [
                            -157.81854021097485,
                            21.293975792334983
                        ],
                        [
                            -157.81853928631543,
                            21.293976786802201
                        ],
                        [
                            -157.81852642183577,
                            21.293990615956844
                        ],
                        [
                            -157.81852079223236,
                            21.293996667105269
                        ],
                        [
                            -157.8185195768568,
                            21.293997973911921
                        ],
                        [
                            -157.81851941545028,
                            21.293998148036863
                        ],
                        [
                            -157.81851866678539,
                            21.29399895222037
                        ],
                        [
                            -157.81851827177087,
                            21.293999409273795
                        ],
                        [
                            -157.81851587831198,
                            21.294002181242259
                        ],
                        [
                            -157.81851371484396,
                            21.294004881650327
                        ],
                        [
                            -157.81851319394247,
                            21.294005531145835
                        ],
                        [
                            -157.81850269985458,
                            21.294018629832035
                        ],
                        [
                            -157.81849238296905,
                            21.294031507527091
                        ],
                        [
                            -157.81849234789357,
                            21.294031554257231
                        ],
                        [
                            -157.81849010273581,
                            21.29403434443066
                        ],
                        [
                            -157.81848767401678,
                            21.294037789177541
                        ],
                        [
                            -157.81849135355867,
                            21.294040060835499
                        ],
                        [
                            -157.81849625994084,
                            21.294043089112712
                        ],
                        [
                            -157.81847490210299,
                            21.294077184042138
                        ],
                        [
                            -157.81847390173243,
                            21.294078967541324
                        ],
                        [
                            -157.81847261973971,
                            21.294081252252521
                        ],
                        [
                            -157.81847013734227,
                            21.294086226966797
                        ],
                        [
                            -157.81845474728308,
                            21.294117065502309
                        ],
                        [
                            -157.81845327225562,
                            21.294120466353107
                        ],
                        [
                            -157.81845383445773,
                            21.294120679886209
                        ],
                        [
                            -157.81845735659715,
                            21.294122021754038
                        ],
                        [
                            -157.81845712521294,
                            21.294122750069828
                        ],
                        [
                            -157.81845142775751,
                            21.294140787835534
                        ],
                        [
                            -157.81845127841223,
                            21.294141261970911
                        ],
                        [
                            -157.81844557999136,
                            21.294159299729547
                        ],
                        [
                            -157.81844544548707,
                            21.294159726089383
                        ],
                        [
                            -157.81844122023963,
                            21.294158553640219
                        ],
                        [
                            -157.81843996919221,
                            21.294162514358785
                        ],
                        [
                            -157.81844419541807,
                            21.294163685008051
                        ],
                        [
                            -157.81844405994266,
                            21.294164112264443
                        ],
                        [
                            -157.81844364063207,
                            21.294165438209333
                        ],
                        [
                            -157.81843836248382,
                            21.294182150029471
                        ],
                        [
                            -157.81843821217453,
                            21.294182624158065
                        ],
                        [
                            -157.81843251471415,
                            21.294200661922787
                        ],
                        [
                            -157.81843228429355,
                            21.294201390245306
                        ],
                        [
                            -157.81842795756572,
                            21.294200612768723
                        ],
                        [
                            -157.81842721832646,
                            21.294204217530218
                        ],
                        [
                            -157.81843154793884,
                            21.294204995930457
                        ],
                        [
                            -157.81843147345228,
                            21.294205752449315
                        ],
                        [
                            -157.81843037139214,
                            21.294217002772751
                        ],
                        [
                            -157.8184296397213,
                            21.294224484941854
                        ],
                        [
                            -157.81842959144745,
                            21.294224976951121
                        ],
                        [
                            -157.81842775770863,
                            21.29424371034693
                        ],
                        [
                            -157.81842771464409,
                            21.294244153609629
                        ],
                        [
                            -157.81842332687589,
                            21.294243776810021
                        ],
                        [
                            -157.81842292482577,
                            21.294247888030672
                        ],
                        [
                            -157.81842731162297,
                            21.294248265726861
                        ],
                        [
                            -157.81842726855845,
                            21.294248708989564
                        ],
                        [
                            -157.81842543482608,
                            21.294267441481921
                        ],
                        [
                            -157.8184253875161,
                            21.294267933497959
                        ],
                        [
                            -157.81842355378313,
                            21.294286665990217
                        ],
                        [
                            -157.81842347928929,
                            21.294287423412381
                        ],
                        [
                            -157.81841907286301,
                            21.294287451200848
                        ],
                        [
                            -157.81841909943455,
                            21.294291121865253
                        ],
                        [
                            -157.81842350586095,
                            21.294291094076801
                        ],
                        [
                            -157.81842359043114,
                            21.294291849905381
                        ],
                        [
                            -157.81842569268662,
                            21.294310558533841
                        ],
                        [
                            -157.81842574756379,
                            21.294311049460418
                        ],
                        [
                            -157.81842784981967,
                            21.294329758088832
                        ],
                        [
                            -157.81842789930334,
                            21.294330200194427
                        ],
                        [
                            -157.81842351759423,
                            21.294330632875656
                        ],
                        [
                            -157.81842397927198,
                            21.29433474022208
                        ],
                        [
                            -157.81842836098122,
                            21.294334307540844
                        ],
                        [
                            -157.8184294417772,
                            21.29434392991875
                        ],
                        [
                            -157.81843051272853,
                            21.294353457371464
                        ],
                        [
                            -157.81843056759848,
                            21.294353949201358
                        ],
                        [
                            -157.8184326698553,
                            21.294372657829697
                        ],
                        [
                            -157.81843271848339,
                            21.294373086378407
                        ],
                        [
                            -157.8184327544256,
                            21.294373413658271
                        ],
                        [
                            -157.81842843699661,
                            21.294374246089639
                        ],
                        [
                            -157.81842883134186,
                            21.294376043895856
                        ],
                        [
                            -157.81840269889071,
                            21.294381086568617
                        ],
                        [
                            -157.81840225428601,
                            21.294379064368552
                        ],
                        [
                            -157.81839793877734,
                            21.294379897715999
                        ],
                        [
                            -157.81839838338195,
                            21.29438191991607
                        ],
                        [
                            -157.81837330326303,
                            21.294386758577929
                        ],
                        [
                            -157.81837668891802,
                            21.294402523934224
                        ],
                        [
                            -157.81837713781479,
                            21.294404612112015
                        ],
                        [
                            -157.81837717405648,
                            21.294404781300557
                        ],
                        [
                            -157.81837786732399,
                            21.294408013983499
                        ],
                        [
                            -157.81837883943496,
                            21.294412540473104
                        ],
                        [
                            -157.81837887567664,
                            21.294412709661643
                        ],
                        [
                            -157.81837923070026,
                            21.294414361745954
                        ],
                        [
                            -157.81837956524748,
                            21.294415922444024
                        ],
                        [
                            -157.81837248579052,
                            21.294426442421049
                        ],
                        [
                            -157.81837600588574,
                            21.294428523250318
                        ],
                        [
                            -157.81837616130738,
                            21.294428615583879
                        ],
                        [
                            -157.81838123374925,
                            21.294431612508387
                        ],
                        [
                            -157.81838138917092,
                            21.294431704841941
                        ],
                        [
                            -157.81838334541811,
                            21.29443286136447
                        ],
                        [
                            -157.81837642886592,
                            21.294443140376426
                        ],
                        [
                            -157.81837974172791,
                            21.294445098696428
                        ],
                        [
                            -157.81837989715677,
                            21.294445190126645
                        ],
                        [
                            -157.81838496958486,
                            21.294448188857764
                        ],
                        [
                            -157.81838512502094,
                            21.294448279384639
                        ],
                        [
                            -157.81838689897319,
                            21.294449328930664
                        ],
                        [
                            -157.81838494985595,
                            21.294452225070405
                        ],
                        [
                            -157.81838487473354,
                            21.294452337466918
                        ],
                        [
                            -157.81838419869698,
                            21.294453340905541
                        ],
                        [
                            -157.81838015412359,
                            21.294459351681638
                        ],
                        [
                            -157.81837958831389,
                            21.294460192380249
                        ],
                        [
                            -157.81838043780826,
                            21.294460642812115
                        ],
                        [
                            -157.81838322336978,
                            21.294462121343329
                        ],
                        [
                            -157.81838338270481,
                            21.294462206477235
                        ],
                        [
                            -157.8183862479375,
                            21.294463727123674
                        ],
                        [
                            -157.81838860155884,
                            21.294464975871449
                        ],
                        [
                            -157.81838876185773,
                            21.294465061012101
                        ],
                        [
                            -157.81839063361119,
                            21.294466055234423
                        ],
                        [
                            -157.81838994001512,
                            21.294467084748142
                        ],
                        [
                            -157.81838940154105,
                            21.294467882275921
                        ],
                        [
                            -157.81838830311287,
                            21.294469511509526
                        ],
                        [
                            -157.81838381186245,
                            21.294476171398337
                        ],
                        [
                            -157.8183872611398,
                            21.294478067438494
                        ],
                        [
                            -157.81838741853264,
                            21.294478154365542
                        ],
                        [
                            -157.8183925914922,
                            21.294480997515528
                        ],
                        [
                            -157.8183927498489,
                            21.294481084449338
                        ],
                        [
                            -157.81839513381698,
                            21.294482395744041
                        ],
                        [
                            -157.81839125528259,
                            21.29449308002437
                        ],
                        [
                            -157.8183950597718,
                            21.294494192607761
                        ],
                        [
                            -157.81839523480355,
                            21.29449424352298
                        ],
                        [
                            -157.81840095884431,
                            21.294495917939734
                        ],
                        [
                            -157.81840113483997,
                            21.294495968861717
                        ],
                        [
                            -157.81840311402297,
                            21.294496547374798
                        ],
                        [
                            -157.81839889156973,
                            21.294508531930877
                        ],
                        [
                            -157.81840261189012,
                            21.294509682769075
                        ],
                        [
                            -157.81840278593631,
                            21.294509736387539
                        ],
                        [
                            -157.8184084803606,
                            21.294511498225084
                        ],
                        [
                            -157.81840865439958,
                            21.294511552746904
                        ],
                        [
                            -157.81841039580399,
                            21.294512091648304
                        ],
                        [
                            -157.81840605024297,
                            21.294523679655089
                        ],
                        [
                            -157.81840951423271,
                            21.29452482056319
                        ],
                        [
                            -157.81840968728616,
                            21.294524877788255
                        ],
                        [
                            -157.81841534523835,
                            21.294526740549362
                        ],
                        [
                            -157.81841551925569,
                            21.294526797781188
                        ],
                        [
                            -157.8184187101925,
                            21.294527850046791
                        ],
                        [
                            -157.81841609715516,
                            21.294538434804288
                        ],
                        [
                            -157.81841991259509,
                            21.29453926289586
                        ],
                        [
                            -157.81842009157634,
                            21.294539302094702
                        ],
                        [
                            -157.81842593455718,
                            21.294540568109465
                        ],
                        [
                            -157.81842611353844,
                            21.294540607308303
                        ],
                        [
                            -157.81842824113667,
                            21.294541069422117
                        ],
                        [
                            -157.81842463652694,
                            21.294554989765974
                        ],
                        [
                            -157.81842653976159,
                            21.294555422299723
                        ],
                        [
                            -157.8184265646243,
                            21.294555326714796
                        ],
                        [
                            -157.81843430360232,
                            21.294557086642804
                        ],
                        [
                            -157.81844406014162,
                            21.294572111672853
                        ],
                        [
                            -157.81844611506287,
                            21.29457467185367
                        ],
                        [
                            -157.81847611897504,
                            21.294612058816686
                        ],
                        [
                            -157.81850236635344,
                            21.294638836180315
                        ],
                        [
                            -157.81851220040573,
                            21.294648867805147
                        ],
                        [
                            -157.81855195926201,
                            21.294682186600578
                        ],
                        [
                            -157.81856374359057,
                            21.294690263422599
                        ],
                        [
                            -157.81856711821897,
                            21.294692575398621
                        ],
                        [
                            -157.81859323128049,
                            21.294710471472161
                        ],
                        [
                            -157.81859691084031,
                            21.294712743128503
                        ],
                        [
                            -157.8185998408444,
                            21.294708571959092
                        ],
                        [
                            -157.81860186577526,
                            21.294709578095027
                        ],
                        [
                            -157.81864255748491,
                            21.29472978437267
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 4131,
                "NUMBER": "1118",
                "PROPER_NAME": "STAN SHERIFF CENTER",
                "DISPLAY_NAME": "STAN SHERIFF CENTER (SHRF) - 1118",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "CREATED_USER": "USER",
                "CREATED_DATE": 1724927240000,
                "LAST_EDITED_USER": "USER",
                "LAST_EDITED_DATE": 1724927240000,
                "COMPLEX_NAME": "STAN SHERIFF CENTER",
                "SUBSTATION-FED?": "Y",
                "REXED?": "N",
                "PV?": "N",
                "OPS-FUNDED?": "Y",
                "AKA": null,
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1118_01.jpg",
                "HEIGHT (ft)": 106.60000000000001,
                "LEED STATUS": "n/a",
                "LEED LINK": null,
                "PV LINK": null,
                "PV PIC": null,
                "PORTABLE?": null,
                "SHAPE_Length": 363.54553381205369,
                "SHAPE_Area": 8031.6134579986528
            }
        },
        {
            "type" : "Feature",
            "id" : 4132,
            "geometry" : {
                "type" : "Polygon",
                "coordinates" : [
                    [
                        [
                            -157.8141353626294,
                            21.294033099872113
                        ],
                        [
                            -157.81389965647648,
                            21.294231397612318
                        ],
                        [
                            -157.81391914810783,
                            21.294251746976691
                        ],
                        [
                            -157.81486066131538,
                            21.295234674550677
                        ],
                        [
                            -157.81491871064458,
                            21.295295277469556
                        ],
                        [
                            -157.81519874114409,
                            21.295059688738132
                        ],
                        [
                            -157.81524295610055,
                            21.295022490235596
                        ],
                        [
                            -157.81526822550092,
                            21.295001230979555
                        ],
                        [
                            -157.81521017614187,
                            21.294940628178868
                        ],
                        [
                            -157.81516354361662,
                            21.294891945387054
                        ],
                        [
                            -157.81433450115981,
                            21.294026437420229
                        ],
                        [
                            -157.81424963716742,
                            21.293937417837633
                        ],
                        [
                            -157.81420765586955,
                            21.293972568336823
                        ],
                        [
                            -157.81420750283957,
                            21.293972408305489
                        ],
                        [
                            -157.8141353626294,
                            21.294033099872113
                        ]
                    ]
                ]
            },
            "properties" : {
                "FID" : 4132,
                "PROP_NUM" : "1116F",
                "PROP_NAME" : "COOKE PRACTICE FIELD F",
                "COMPLEX_NAME" : "COOKE PRACTICE FIELD F",
                "SQ_FT" : 0,
                "PV" : "No",
                "OPSFUNDED" : "Yes",
                "STATUS" : "AC"
            }
        },
        {
            "type": "Feature",
            "id": 4133,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81470493777016,
                            21.293433726152276
                        ],
                        [
                            -157.81435372295408,
                            21.29372906301894
                        ],
                        [
                            -157.81432921483,
                            21.29374967269327
                        ],
                        [
                            -157.81446378427975,
                            21.293890228151511
                        ],
                        [
                            -157.81489282710334,
                            21.294338355034753
                        ],
                        [
                            -157.81502636104921,
                            21.294477828701083
                        ],
                        [
                            -157.81504576527323,
                            21.294498095650383
                        ],
                        [
                            -157.81509741046955,
                            21.294454666196238
                        ],
                        [
                            -157.81516563074149,
                            21.294397299930601
                        ],
                        [
                            -157.81555766908886,
                            21.294067631189485
                        ],
                        [
                            -157.81550762481783,
                            21.294015360941945
                        ],
                        [
                            -157.81505862256481,
                            21.293546389108819
                        ],
                        [
                            -157.81491936858518,
                            21.29340094097093
                        ],
                        [
                            -157.81484111810443,
                            21.293319210369329
                        ],
                        [
                            -157.81470493777016,
                            21.293433726152276
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 4133,
                "NUMBER": "1116G",
                "ESRI TYPE": "",
                "PROPER NAME": "",
                "DISPLAY NAME": "",
                "ADDRESS": "1337 LOWER CAMPUS ROAD",
                "ABBREV 1": "",
                "ABBREV 2": "",
                "YEAR BUILT": "",
                "GSF": 0,
                "PROPERTY TYPE": "",
                "TMK": "",
                "FLOORPLAN LINK": "",
                "HISTORICAL REGISTER": "",
                "ABOUT": "",
                "CREATED_USER": "",
                "CREATED_DATE": -2209161600000,
                "LAST_EDITED_USER": "",
                "LAST_EDITED_DATE": -2209161600000,
                "KEYWORDS": "",
                "PUBLICLY VISIBLE?": "",
                "NAME": "COOKE PRACTICE FIELD G",
                "COMPLEX_NAME" : "COOKE PRACTICE FIELD G",
                "LABEL ORDER": 0,
                "SUBSTATION-FED?": "",
                "REXED?": "",
                "PV?": "",
                "OPS-FUNDED?": "",
                "SCHOOLS AND COLLEGES": "",
                "AKA": "",
                "BIM?": "",
                "STATUS": "DE",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1116G_01.jpg",
                "HEIGHT (ft)": 0,
                "PRINTED LABEL NAME": "",
                "PRINTED LABEL HIERARCHY": 0,
                "PRINTED GRID": "",
                "LEED STATUS": "",
                "LEED LINK": "",
                "PRINTED ABBREV": "",
                "PV LINK": "",
                "PV PIC": "",
                "PORTABLE?": "",
                "NAME SORTED": "",
                "PRINTED PUBLIC?": "",
                "ESRI BASEMAP NAME": "",
                "NAME_SORT_PUB": "",
                "UH BASEMAP NAME": "",
                "SHAPE.AREA": 85522.7185307123,
                "SHAPE.LEN": 1198.8075870395301
            }
        },
        {
            "type": "Feature",
            "id": 4134,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.8140065856617,
                            21.296545778718993
                        ],
                        [
                            -157.81405059776421,
                            21.296554749835799
                        ],
                        [
                            -157.81406069072233,
                            21.296511261258637
                        ],
                        [
                            -157.81409800561775,
                            21.29651886748907
                        ],
                        [
                            -157.81411101229187,
                            21.296462826156102
                        ],
                        [
                            -157.8140736974099,
                            21.296455219928607
                        ],
                        [
                            -157.81409560033313,
                            21.296360843127946
                        ],
                        [
                            -157.81424772905851,
                            21.296391851878191
                        ],
                        [
                            -157.81426239940293,
                            21.296328640237256
                        ],
                        [
                            -157.81410931399819,
                            21.296297436260755
                        ],
                        [
                            -157.81412268498448,
                            21.296239825605447
                        ],
                        [
                            -157.81405929728106,
                            21.29622690518659
                        ],
                        [
                            -157.81404764427495,
                            21.29627711800314
                        ],
                        [
                            -157.81391560823178,
                            21.296250204616907
                        ],
                        [
                            -157.81392726128047,
                            21.296199991809647
                        ],
                        [
                            -157.81386411352048,
                            21.296187119451091
                        ],
                        [
                            -157.81385037906279,
                            21.296246299405791
                        ],
                        [
                            -157.81372982396908,
                            21.2962217260588
                        ],
                        [
                            -157.81371525708866,
                            21.29628449250087
                        ],
                        [
                            -157.81383581223093,
                            21.29630906585848
                        ],
                        [
                            -157.81379106999756,
                            21.296501849231554
                        ],
                        [
                            -157.81383723450318,
                            21.29651125901983
                        ],
                        [
                            -157.81384732751977,
                            21.296467771358849
                        ],
                        [
                            -157.81401667863207,
                            21.296502290144524
                        ],
                        [
                            -157.8140065856617,
                            21.296545778718993
                        ]
                    ],
                    [
                        [
                            -157.81401007276526,
                            21.29644058861151
                        ],
                        [
                            -157.81387830828655,
                            21.296413730589563
                        ],
                        [
                            -157.81389963865405,
                            21.296321822468251
                        ],
                        [
                            -157.81403140305505,
                            21.29634868047324
                        ],
                        [
                            -157.81401007276526,
                            21.29644058861151
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 4134,
                "NUMBER": "1203",
                "ESRI TYPE": "",
                "PROPER NAME": "",
                "DISPLAY NAME": "",
                "ADDRESS": "2570 DOLE STREET",
                "ABBREV 1": "",
                "ABBREV 2": "",
                "YEAR BUILT": "",
                "GSF": 0,
                "PROPERTY TYPE": "",
                "TMK": "",
                "FLOORPLAN LINK": "",
                "HISTORICAL REGISTER": "",
                "ABOUT": "",
                "CREATED_USER": "",
                "CREATED_DATE": -2209161600000,
                "LAST_EDITED_USER": "",
                "LAST_EDITED_DATE": -2209161600000,
                "KEYWORDS": "",
                "PUBLICLY VISIBLE?": "",
                "NAME": "2570 DOLE STREET (FORMER NOAA)",
                "COMPLEX_NAME" : "2570 DOLE STREET COMPLEX",
                "LABEL ORDER": 0,
                "SUBSTATION-FED?": "",
                "REXED?": "",
                "PV?": "",
                "OPS-FUNDED?": "",
                "SCHOOLS AND COLLEGES": "",
                "AKA": "",
                "BIM?": "",
                "STATUS": "DE",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1203_01.jpg",
                "HEIGHT (ft)": 0,
                "PRINTED LABEL NAME": "",
                "PRINTED LABEL HIERARCHY": 0,
                "PRINTED GRID": "",
                "LEED STATUS": "",
                "LEED LINK": "",
                "PRINTED ABBREV": "",
                "PV LINK": "",
                "PV PIC": "",
                "PORTABLE?": "",
                "NAME SORTED": "",
                "PRINTED PUBLIC?": "",
                "ESRI BASEMAP NAME": "",
                "NAME_SORT_PUB": "",
                "UH BASEMAP NAME": "",
                "SHAPE.AREA": 9686.9515422769309,
                "SHAPE.LEN": 860.64373640583005
            }
        },
        {
            "type": "Feature",
            "id": 4135,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81391722783346,
                            21.297038361332646
                        ],
                        [
                            -157.81392851310582,
                            21.29712801685676
                        ],
                        [
                            -157.81422747056862,
                            21.297094966564465
                        ],
                        [
                            -157.81421618511723,
                            21.297005311058719
                        ],
                        [
                            -157.81391722783346,
                            21.297038361332646
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 4135,
                "NUMBER": "1203B",
                "ESRI TYPE": "",
                "PROPER NAME": "",
                "DISPLAY NAME": "",
                "ADDRESS": "2570 DOLE STREET",
                "ABBREV 1": "",
                "ABBREV 2": "",
                "YEAR BUILT": "",
                "GSF": 0,
                "PROPERTY TYPE": "",
                "TMK": "",
                "FLOORPLAN LINK": "",
                "HISTORICAL REGISTER": "",
                "ABOUT": "",
                "CREATED_USER": "",
                "CREATED_DATE": -2209161600000,
                "LAST_EDITED_USER": "",
                "LAST_EDITED_DATE": -2209161600000,
                "KEYWORDS": "",
                "PUBLICLY VISIBLE?": "",
                "NAME": "2570 DOLE STREET ANNEX 2",
                "COMPLEX_NAME" : "2570 DOLE STREET COMPLEX",
                "LABEL ORDER": 0,
                "SUBSTATION-FED?": "",
                "REXED?": "",
                "PV?": "",
                "OPS-FUNDED?": "",
                "SCHOOLS AND COLLEGES": "",
                "AKA": "",
                "BIM?": "",
                "STATUS": "DE",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1203B_01.jpg",
                "HEIGHT (ft)": 0,
                "PRINTED LABEL NAME": "",
                "PRINTED LABEL HIERARCHY": 0,
                "PRINTED GRID": "",
                "LEED STATUS": "",
                "LEED LINK": "",
                "PRINTED ABBREV": "",
                "PV LINK": "",
                "PV PIC": "",
                "PORTABLE?": "",
                "NAME SORTED": "",
                "PRINTED PUBLIC?": "",
                "ESRI BASEMAP NAME": "",
                "NAME_SORT_PUB": "",
                "UH BASEMAP NAME": "",
                "SHAPE.AREA": 3360.6647796708903,
                "SHAPE.LEN": 270.54566877569903
            }
        },
        {
            "type": "Feature",
            "id": 4136,
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.81388957257977,
                            21.29701603492272
                        ],
                        [
                            -157.81421853973387,
                            21.296980608147695
                        ],
                        [
                            -157.81420479702783,
                            21.296868508682785
                        ],
                        [
                            -157.81399533425389,
                            21.296891060884608
                        ],
                        [
                            -157.81397471469944,
                            21.296722900814654
                        ],
                        [
                            -157.81381783004545,
                            21.296739792883976
                        ],
                        [
                            -157.81384970869638,
                            21.296999842030452
                        ],
                        [
                            -157.81388709424516,
                            21.296995816366636
                        ],
                        [
                            -157.81388957257977,
                            21.29701603492272
                        ]
                    ]
                ]
            },
            "properties": {
                "FID": 4136,
                "NUMBER": "1203A",
                "ESRI TYPE": "",
                "PROPER NAME": "",
                "DISPLAY NAME": "",
                "ADDRESS": "2570 DOLE STREET",
                "ABBREV 1": "",
                "ABBREV 2": "",
                "YEAR BUILT": "",
                "GSF": 0,
                "PROPERTY TYPE": "",
                "TMK": "",
                "FLOORPLAN LINK": "",
                "HISTORICAL REGISTER": "",
                "ABOUT": "",
                "CREATED_USER": "",
                "CREATED_DATE": -2209161600000,
                "LAST_EDITED_USER": "",
                "LAST_EDITED_DATE": -2209161600000,
                "KEYWORDS": "",
                "PUBLICLY VISIBLE?": "",
                "NAME": "2570 DOLE STREET ANNEX 1",
                "COMPLEX_NAME" : "2570 DOLE STREET COMPLEX",
                "LABEL ORDER": 0,
                "SUBSTATION-FED?": "",
                "REXED?": "",
                "PV?": "",
                "OPS-FUNDED?": "",
                "SCHOOLS AND COLLEGES": "",
                "AKA": "",
                "BIM?": "",
                "STATUS": "DE",
                "PIC": "https://map.hawaii.edu/images/MA/building_images/1203A_01.jpg",
                "HEIGHT (ft)": 0,
                "PRINTED LABEL NAME": "",
                "PRINTED LABEL HIERARCHY": 0,
                "PRINTED GRID": "",
                "LEED STATUS": "",
                "LEED LINK": "",
                "PRINTED ABBREV": "",
                "PV LINK": "",
                "PV PIC": "",
                "PORTABLE?": "",
                "NAME SORTED": "",
                "PRINTED PUBLIC?": "",
                "ESRI BASEMAP NAME": "",
                "NAME_SORT_PUB": "",
                "UH BASEMAP NAME": "",
                "SHAPE.AREA": 8356.639358108001,
                "SHAPE.LEN": 456.02695059593901
            }
        }
    ]
}